<template>
  <svg>
    <symbol id="AD" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 0h10v15H5V0z"
          fill="#FFD018"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h5v15H0V0z"
          fill="#2E42A5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15 0h5v15h-5V0z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.187 12.14c.138-.04.257-.28.257-.28s.09.071.233.143c.143.072.292-.142.292-.142s.203 0 .292-.24c.09-.24-.178-.342-.178-.342s.312-.328.839-.328c.526 0 .936 0 1.28-.146s.678-.396.803-.917c.124-.521-.271-.85-.271-.85s.088.029.27-.121c.183-.15-.111-.631-.27-.631-.159 0-.177.089-.177.089s-.098-.085-.232-.374c-.135-.29.134-.543.134-.543s.147.084.275-.055c.128-.139-.067-.352-.067-.352s.618-.21.529-1c-.09-.79-.904-.745-.904-.745s.025-.131-.09-.206c-.115-.075-.2.075-.2.075-.09-.209.174-.494.385-.722.066-.07.126-.136.17-.192.182-.235.068-.527-.6-.845-.668-.318-1.033.11-1.086.261-.053.152.154.245.154.245a.734.734 0 01-.719.103c-.223-.103-.124-.414-.078-.5l.02-.033c.063-.106.194-.327.058-.542-.153-.242-.417-.242-.629-.105-.18.118-.438.18-.508.196a1.726 1.726 0 01-.51-.196c-.21-.137-.475-.137-.628.105-.136.215-.004.436.058.542l.02.034c.046.085.145.396-.078.499a.734.734 0 01-.719-.103s.208-.093.154-.245c-.053-.151-.418-.579-1.086-.26-.668.317-.782.609-.6.844.044.056.104.121.17.192.21.228.475.513.385.722 0 0-.085-.15-.2-.075s-.09.206-.09.206-.814-.045-.904.745c-.089.79.529 1 .529 1s-.195.213-.067.352c.128.14.275.055.275.055s.269.254.135.543c-.135.289-.233.374-.233.374s-.018-.09-.177-.09-.453.482-.27.632c.182.15.27.122.27.122s-.395.328-.27.849c.124.52.458.771.802.917.344.146.754.146 1.28.146.527 0 .839.328.839.328s-.267.102-.178.342c.09.24.292.24.292.24s.149.214.292.142c.143-.072.233-.142.233-.142s.119.24.257.279v.005l.018-.001.019.001v-.005z"
          fill="#BF9937"
        />
        <path
          d="M7.569 9.999l.066-.16c.754.324 1.613.486 2.577.486.963 0 1.799-.161 2.508-.484l.07.157c-.733.333-1.592.5-2.578.5-.985 0-1.867-.166-2.643-.5z"
          fill="#805440"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.799 4.52h4.713v4.394s-.001.388-.411.557c-.41.17-.892.11-.892.11s-.462-.1-.705 0c-.15.06-.258.09-.32.104v.012l-.029-.005a.502.502 0 01-.03.005v-.012a2.137 2.137 0 01-.318-.105c-.244-.099-.705 0-.705 0s-.482.061-.892-.109a.638.638 0 01-.411-.557V4.52z"
          fill="#BF9937"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="7"
          y="4"
          width="6"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.799 4.52h4.713v4.394s-.001.388-.411.557c-.41.17-.892.11-.892.11s-.462-.1-.705 0c-.15.06-.258.09-.32.104v.012l-.029-.005a.502.502 0 01-.03.005v-.012a2.137 2.137 0 01-.318-.105c-.244-.099-.705 0-.705 0s-.482.061-.892-.109a.638.638 0 01-.411-.557V4.52z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#D00F3A" d="M7.733 4.465h2.285v2.438H7.733z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.272 4.465h2.37v2.438h-2.37V4.465zm0 2.709h2.285V9.7h-2.285V7.174z"
            fill="#FEDF00"
          />
          <path fill="#FEDF00" d="M7.733 7.174h2.285v2.528H7.733z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.965 8.312s.106-.108.106-.363c0-.254.09-.422-.106-.422h-.649c-.187 0-.09.113-.279 0-.188-.113-.34-.077-.34 0s.19.043.19.2c0 .156.072.02.072.302 0 .283.04.235.059.235.02 0 .02-.05.02-.125 0-.074-.01-.373.042-.281.052.091.078.048.104.153.025.104.095.206.047.253-.047.048-.143.088-.072.088.072 0 .176-.12.124-.323-.052-.202.065-.018.065-.018s.276.06.294-.023c.018-.084.043.08.118.08s-.072.17-.134.196c-.062.027 0 .048 0 .048s.058.047.096 0c.038-.048.175-.203.175-.283 0-.08.088-.032.088.04 0 .07-.082.324-.051.283l.03-.04zm0 .993s.106-.108.106-.362c0-.255.09-.423-.106-.423h-.649c-.187 0-.09.113-.279 0-.188-.113-.34-.077-.34 0s.19.043.19.2c0 .156.072.02.072.302 0 .283.04.235.059.235.02 0 .02-.05.02-.125 0-.074-.01-.373.042-.281.052.092.078.048.104.153.025.104.095.206.047.253-.047.048-.143.088-.072.088.072 0 .176-.12.124-.323-.052-.202.065-.018.065-.018s.276.061.294-.023c.018-.084.043.08.118.08s-.072.17-.134.196c-.062.027 0 .048 0 .048s.058.047.096 0c.038-.048.175-.203.175-.283 0-.08.088-.031.088.04 0 .07-.082.324-.051.283l.03-.04z"
            fill="#D00F3A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.881 6.436c0 .103-.052.182-.172.303l-.048.048a1.15 1.15 0 00-.042.044c-.102.116-.28.016-.327-.096a2.914 2.914 0 00-.101-.183l-.003-.005-.035-.06-.031-.053a3.675 3.675 0 01-.04-.072c-.005-.007-.029.001-.07.054-.016.02.016.09.12.2l-.059.065c-.144-.14-.213-.23-.213-.294 0-.105.084-.161.242-.161.099 0 .151.07.23.245l.02.045a.8.8 0 00.095.172c.036.046.058.044.095-.003s.071-.119.122-.249a2.89 2.89 0 01.014-.035c.011-.027.016-.04.013-.042-.003-.002-.01.002-.026.01l-.02.011-.039.02-.358-.861.678-.824V6.43l-.043-.04a.495.495 0 00-.002.045zm.049-.002l-.004.003V6.43l.004.003zm.003-.003v.006l-.003-.003.003-.003zm0-1.716l.679.824-.359.862-.04-.021c-.027-.014-.041-.024-.045-.02-.004.003.007.024.027.076.051.13.085.202.122.249.037.047.059.049.095.003a.8.8 0 00.095-.172l.02-.045c.079-.175.132-.245.23-.245.158 0 .242.056.242.161 0 .063-.07.154-.213.294l-.058-.065c.103-.11.135-.18.12-.2-.042-.053-.066-.061-.07-.054a3.699 3.699 0 01-.04.072l-.032.053-.034.06-.004.005a2.55 2.55 0 00-.101.183c-.046.112-.225.212-.327.096a1.15 1.15 0 00-.042-.044l-.048-.048c-.12-.121-.172-.2-.172-.303 0-.018 0-.033-.002-.044l-.043.039V4.715zm0 0L8.93 4.71l.003-.004v.008zM8.93 4.71l-.004.004v-.008l.004.004zm-.042 1.654l.001-.002-.001.002z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.924 6.281V4.889l.588.666-.302.726c-.111-.039-.15.043-.093.19.034.087.061.15.088.198-.1-.101-.142-.165-.142-.233a.262.262 0 00-.019-.118c-.006-.012-.059-.023-.093-.03l-.027-.007zm-.275 0l-.302-.726.574-.66v1.391a.237.237 0 01-.026.006c-.03.006-.074.014-.08.026a.262.262 0 00-.018.118c0 .068-.042.132-.142.233.026-.048.053-.111.087-.198.058-.147.019-.229-.093-.19z"
            fill="#FEDF00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.24 7.174h-.253V9.7h.254V7.174zm.509 0h-.254V9.7h.254V7.174zm.254 0h.254V9.7h-.254V7.174zm.761 0H9.51V9.7h.254V7.174zm1.101-2.709h-.254v2.528h.254V4.465zm.507 0h-.254v2.528h.254V4.465zm.254 0h.254v2.528h-.254V4.465zm.762 0h-.254v2.528h.254V4.465z"
            fill="#D00F3A"
          />
        </g>
      </g>
    </symbol>
    <symbol id="AE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v5h20V0H0z"
          fill="#5EAA22"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10v5h20v-5H0z"
          fill="#272727"
        />
        <path fill="#E31D1C" d="M0 0h6v15H0z" />
      </g>
    </symbol>
    <symbol id="AF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 0h6v15h-6V0z"
          fill="#67BD38"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 0h8v15H6V0z"
          fill="#D51700"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h6v15H0V0z"
          fill="#272727"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.705 4.986l.216.135c-.36.607-.602 1.163-.728 1.668a.59.59 0 01.12.15c.098.17.18.334.247.494l-.287.122a3.813 3.813 0 00-.16-.333c-.029.246-.027.48.006.698a.586.586 0 01.148.036c.184.066.352.14.506.219l-.142.278a3.968 3.968 0 00-.431-.19l.003.01c.134.404.338.775.614 1.115a.595.595 0 01.13-.013c.196 0 .38.011.55.033l-.037.31a3.82 3.82 0 00-.37-.028c.247.248.538.476.873.686l-.132.222a5.033 5.033 0 01-1.058-.869 4.134 4.134 0 00-.143.06l-.022.01c.254.266.554.51.9.734l-.134.22a5.095 5.095 0 01-1.029-.86.678.678 0 01-.384-.005l.083-.3c.02.006.04.01.06.013a3.883 3.883 0 01-.597-1.151 2.486 2.486 0 01-.061-.224.666.666 0 01-.282-.125l.182-.254a.424.424 0 00.047.03 3.56 3.56 0 01.134-1.24.667.667 0 01-.151-.295l.265-.069c.143-.405.346-.834.607-1.286l.218.133a7.228 7.228 0 00-.634 1.382c.039.035.086.073.144.116.138-.504.382-1.048.729-1.632zm-.806 1.963a4.984 4.984 0 00-.16-.12 3.138 3.138 0 00-.086 1.102c.047 0 .1-.002.16-.006l.05-.003A3.035 3.035 0 016.9 6.95zm-.072 1.287l.098-.005c.012.042.024.085.038.126.134.405.334.78.6 1.122l-.052.023c-.044.02-.084.036-.12.05a3.637 3.637 0 01-.68-1.31l.116-.006zm5.26-3.25l-.216.135c.36.607.602 1.163.727 1.668a.59.59 0 00-.12.15 4.33 4.33 0 00-.246.494l.287.122a3.79 3.79 0 01.16-.333c.029.246.027.48-.006.698a.586.586 0 00-.148.036 4.18 4.18 0 00-.506.219l.141.278c.131-.067.275-.13.432-.19l-.003.01a3.494 3.494 0 01-.614 1.115.595.595 0 00-.13-.013c-.196 0-.38.011-.55.033l.037.31a3.82 3.82 0 01.37-.028 4.92 4.92 0 01-.873.686l.132.222c.414-.26.767-.55 1.058-.869l.143.06.022.01a4.97 4.97 0 01-.9.734l.134.22c.4-.258.744-.544 1.028-.86.136.035.25.035.385-.005l-.084-.3a.42.42 0 01-.06.013c.265-.352.464-.736.598-1.151a2.51 2.51 0 00.06-.224.667.667 0 00.282-.125l-.18-.254a.423.423 0 01-.049.03 3.56 3.56 0 00-.133-1.24.668.668 0 00.15-.295l-.265-.069a7.762 7.762 0 00-.606-1.286l-.218.133c.285.493.496.954.634 1.382a1.893 1.893 0 01-.144.116c-.139-.504-.382-1.048-.73-1.632zm.806 1.963a4.821 4.821 0 01.16-.12c.096.398.124.765.085 1.102-.046 0-.099-.002-.16-.006l-.05-.003c.042-.304.03-.628-.035-.973zm.072 1.287a6.322 6.322 0 00-.098-.005 3.745 3.745 0 01-.637 1.249l.05.022c.045.02.085.036.122.05a3.638 3.638 0 00.679-1.31 3.261 3.261 0 01-.116-.006z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.808 10.165l-.698.69s.602.369 1.736.369 1.794-.369 1.794-.369l-.53-.69s-.723.28-1.235.28c-.511 0-1.067-.28-1.067-.28z"
          fill="#F7FCFF"
        />
        <path
          d="M8.823 10.606s.59.139 1.043.139c.453 0 1.044-.14 1.044-.14"
          stroke="#C00001"
          stroke-width=".5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.457 5.911c0 .274-.25.495-.557.495-.308 0-.557-.221-.557-.495 0-.273.25-.494.557-.494.308 0 .557.221.557.494zm-.557.495h-.6l-.165.127h-.033v-.99h-.304v.99h-.266v.169h.266v1.786c-.036.285-.12.446-.236.502l-.62.298h3.735l-.268-.268c-.236-.236-.349-.417-.349-.522V6.702h.107v-.17h-.107v-.99h-.304v.99h-.098l-.196-.126H9.9zm-.798.296h1.654v1.796c0 .145.069.302.202.478H8.977a1.44 1.44 0 00.125-.469V6.702zm.849.798h-.66v1.302h1.319L9.95 7.5zm.68-3.652l.001.001-.001-.001zm.963.338v.006-.006zm.187.023l.001-.003v.003zm-.757.384h.004-.004z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.02 6.668l-.124.09.128.188c-.11.04-.286.14-.286.374 0 .34-.12.62-.12.62l.357.23s.038-.398.135-.624a.365.365 0 01.189-.198l.555.816.125-.09-.958-1.406zm3.8 0l.124.09-.128.188c.11.04.286.14.286.374 0 .34.12.62.12.62l-.357.23s-.038-.398-.135-.624a.365.365 0 00-.189-.198l-.555.816-.125-.09.958-1.406z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="AG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#1B1B1B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 8.75l-1.39 2.375.034-2.623-2.54 1.657 1.453-2.35-3.188.61 2.584-1.613L3.75 6.25l3.203-.556L4.37 4.08l3.188.61-1.454-2.35 2.541 1.657-.035-2.623L10 3.75l1.39-2.375-.034 2.623 2.54-1.657-1.453 2.35 3.188-.61-2.584 1.613 3.203.556-3.203.556L15.63 8.42l-3.188-.61 1.454 2.35-2.541-1.657.035 2.623L10 8.75z"
          fill="#F9D313"
        />
        <path fill="#F1F9FF" d="M3.75 8.75h12.5V15H3.75z" />
        <path fill="#4A80E8" d="M1.25 6.25h17.5v2.5H1.25z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 3.75L10 15 20 3.75V15H0V3.75z"
          fill="#E31D1C"
        />
      </g>
    </symbol>
    <symbol id="AI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M16.219 13.477c-.628 0-1.052-.148-1.35-.394-.298-.249-.5-.624-.632-1.14-.132-.52-.186-1.158-.207-1.907a55.84 55.84 0 01-.009-1.711l.002-.555h4.453c.079 1.475.1 2.891-.184 3.953-.149.555-.375.99-.7 1.286-.32.291-.758.468-1.373.468z"
            fill="#fff"
            stroke="#E6E617"
            stroke-width=".5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.246 12.696c.373.834 1.027 1.25 1.96 1.25.928 0 1.583-.41 1.967-1.233l-3.927-.017z"
            fill="#82E5FF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.653 9.75c0 .83.675 1.5 1.506 1.5s1.507-.67 1.507-1.5-.676-1.5-1.507-1.5c-.83 0-1.506.67-1.506 1.5zm2.388 0a.878.878 0 01-.882.875.878.878 0 01-.88-.875c0-.483.394-.875.88-.875.487 0 .882.392.882.875z"
            fill="#E18600"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.905 8.041s-.548.249-.429.716c.119.467.253.534.253.534s.194-1.012.976-1.012l-.8-.238zm-.997 2.521s.457.392.83.086c.373-.305.377-.455.377-.455s-1 .252-1.33-.456l.123.825zm2.742-.052s.017-.602-.455-.7c-.472-.098-.591-.007-.591-.007s.824.618.482 1.32l.564-.614z"
            fill="#E18600"
          />
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="AL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#F50100" />
        <path
          d="M10.313 12.03l-.005 1.47s-.684-1.195-.63-1.195c.055 0 .258-.395.341-.591.084-.196-.181-.335-.226-.196-.044.14-.225.337-.474.495-.248.158-.303-.238-.303-.331 0-.072.097-.068.25-.063.046.002.097.004.152.004.238 0 .26-.527.206-.662-.03-.076-.1 0-.208.117a1.856 1.856 0 01-.327.3c-.3.204-.466-.01-.466-.203 0-.108.062-.105.158-.102a.561.561 0 00.274-.042c.235-.11.404-.568.363-.609-.033-.032-.224.08-.438.206l-.16.094c-.27.154-.382-.21-.382-.3 0-.088.253-.1.382-.1s.591-.282.859-.64c.267-.356.19-.78 0-.917-.133-.096-.224.041-.322.19a1.229 1.229 0 01-.14.184c-.08.081-.185.297-.283.498-.102.21-.195.402-.243.402-.093 0-.376-.301-.376-.301l-1.009.302s.417.226.554.226c.138 0 .191.248.191.301 0 .054-.228.132-.39.079-.16-.054-.062-.224-.062-.224l-.53-.304s-.411.148-.411.304c0 .157-.186.224-.406.224-.22 0-.191-.09 0-.38a.49.49 0 01.095-.117h.046c.018.033.006.117.006.117s.59-.22.259-.148c-.102.022-.19.03-.265.032-.008-.014-.022-.018-.046 0a1.408 1.408 0 01-.201-.022.58.58 0 00-.085-.01c-.088 0-.436-.204-.436-.204s.127-.13.436-.13.19.13.19.13h.737s-.33-.231-.438-.231c-.055 0-.13-.046-.205-.091-.073-.044-.145-.088-.196-.088-.103 0-.088-.233.103-.233.19 0 .406.165.406.233s.411.28.411.28l1.081-.28s-.158-.365 0-.365c.16 0 .662-.326.866-.733.204-.408.182-.598.073-.598s-.202.182-.202.26c0 .078-.262.478-.324.565-.06.087-.278-.087-.125-.299.136-.188.13-.47.126-.607V7.68c0-.11-.28.11-.28.501s-.616.539-.788.539c-.173 0 0-.315.327-.387.258-.056.214-.391.184-.625a1.416 1.416 0 01-.015-.16c0-.191-.393.275-.546.519-.153.243-.788.828-.974.904-.186.076-.541-.166-.627-.34-.062-.126.13-.15.396-.182a5.88 5.88 0 00.309-.044c.4-.073.946-.857 1.05-1.008.103-.152-.154-.265-.294 0-.14.262-.825.51-1.05.59l-.004.002c-.22.08-.407-.28-.407-.44 0-.098.11-.078.284-.047.116.02.26.046.42.046.402 0 .897-.7.897-.874 0-.175-.22-.099-.377 0-.039.025-.084.06-.134.098-.15.115-.342.262-.536.262-.26 0-.468-.185-.468-.185s-.086-.274.13-.274h.597c.319 0 .838-.676.838-.802 0-.069-.247.04-.502.155-.213.095-.433.193-.522.193-.197 0-.627-.183-.627-.348 0-.07 0-.102.016-.116.022-.02.075-.005.2-.005.097 0 .19.025.291.051.126.033.266.07.445.07.22 0 .405-.17.525-.28.057-.053.1-.092.124-.092.075 0-.075-.256-.22-.256-.06 0-.15.044-.255.095-.15.073-.33.16-.5.16-.289 0-.626-.46-.626-.584 0-.123.161-.079.407 0 .245.079.423.135.975 0 .551-.135.22-.335.079-.335H6.252c-.407 0-.407-.587-.407-.698v-.001c0-.083.086-.036.294.08l.2.109c.275.147.647.12.912.1.075-.005.142-.01.195-.01.24 0-.14-.28-.14-.28s-.357 0-.968-.26c-.61-.259-.493-.969-.493-.969s.182-.253.304 0c.12.254.891.892 1.157.892.166 0 .161-.053.158-.097-.003-.027-.005-.051.032-.058.096-.018.87.243.87.243.315.023.363.488.363.764 0 .275.232.52.59.52.268 0 .16-.402.07-.737a2.829 2.829 0 01-.07-.297c-.045-.318-1.034-.502-1.034-.502-.35-.055-.293-.255-.293-.255.131-.005.323-.084.323-.084.211-.048-.869-.153-.869-.153-.24-.022-.14-.312-.14-.312 0-.131.103-.062.251.038.141.096.323.218.494.218.349 0-.102-.256-.228-.256h-.025c0-.004.307-.025.568-.177.162-.095.31-.038.5.036.166.064.363.14.63.14.325 0 .32.201.312.452-.005.191-.012.412.128.595.228.3.334.358.377.367.042-.009.148-.067.376-.367.14-.183.133-.404.128-.595-.008-.25-.013-.451.312-.451.267 0 .465-.077.63-.141.19-.074.338-.131.5-.036.261.152.568.173.568.176h-.025c-.126 0-.577.257-.228.257.17 0 .353-.122.494-.218.148-.1.251-.17.251-.038 0 0 .1.29-.14.312 0 0-1.08.105-.87.153 0 0 .193.079.325.084 0 0 .056.2-.294.255 0 0-.989.184-1.034.502-.012.08-.04.184-.07.297-.09.335-.198.737.07.737.358 0 .59-.245.59-.52 0-.276.048-.74.363-.764 0 0 .774-.26.87-.243.037.007.035.03.033.058-.004.044-.009.097.157.097.266 0 1.036-.638 1.157-.892.122-.253.304 0 .304 0s.117.71-.493.97-.968.26-.968.26-.38.28-.14.28c.053 0 .12.004.195.01.265.02.637.046.913-.101.076-.04.142-.078.199-.11.208-.115.294-.162.294-.08v.002c0 .11 0 .698-.407.698H13.32c-.14 0-.472.2.08.335.551.135.729.079.974 0 .246-.079.407-.123.407 0s-.337.585-.627.585c-.17 0-.35-.088-.5-.16-.105-.052-.195-.096-.255-.096-.144 0-.294.256-.22.256.025 0 .068.039.125.092.12.11.305.28.525.28.18 0 .32-.037.445-.07.102-.026.194-.05.291-.05.125 0 .178-.016.2.004.016.014.016.046.016.116 0 .165-.43.348-.627.348-.089 0-.309-.098-.522-.193-.255-.114-.502-.224-.502-.155 0 .126.519.802.838.802h.597c.216 0 .13.274.13.274s-.209.185-.468.185c-.194 0-.386-.147-.536-.262a1.904 1.904 0 00-.134-.098c-.158-.099-.377-.175-.377 0s.495.874.896.874c.16 0 .305-.026.421-.046.174-.031.284-.05.284.046 0 .161-.187.52-.407.441l-.004-.001c-.225-.082-.91-.329-1.05-.591-.14-.265-.397-.152-.293 0 .103.151.649.935 1.05 1.008.106.019.211.032.307.044.266.032.46.056.397.183-.086.173-.44.415-.627.34-.186-.077-.821-.662-.974-.905-.153-.244-.546-.71-.546-.519 0 .041-.007.097-.015.16-.03.234-.074.569.184.625.327.072.5.387.327.387-.172 0-.789-.148-.789-.539 0-.39-.278-.61-.278-.5l-.001.045c-.004.138-.01.419.126.607.153.212-.064.386-.125.299-.062-.087-.324-.487-.324-.565 0-.078-.093-.26-.202-.26-.11 0-.131.19.073.598.204.407.707.733.866.733.159 0 0 .365 0 .365l1.08.28s.412-.212.412-.28c0-.068.215-.233.406-.233.191 0 .206.233.103.233-.05 0-.123.044-.196.088-.074.045-.15.09-.205.09-.108 0-.438.232-.438.232h.736s-.118-.13.191-.13.436.13.436.13-.348.204-.436.204a.58.58 0 00-.085.01c-.051.009-.117.02-.201.021-.024-.017-.038-.013-.046 0a1.344 1.344 0 01-.265-.03c-.33-.072.26.147.26.147s-.014-.085.005-.116h.046a.489.489 0 01.095.116c.191.29.22.38 0 .38s-.406-.067-.406-.224c0-.156-.411-.304-.411-.304l-.53.304s.099.17-.063.224c-.161.053-.389-.025-.389-.079 0-.053.053-.3.19-.3.138 0 .555-.227.555-.227l-1.01-.302s-.282.302-.375.302c-.048 0-.141-.193-.243-.403-.098-.2-.203-.417-.284-.498-.05-.051-.095-.119-.139-.184-.098-.149-.189-.286-.322-.19-.191.137-.267.561 0 .918.268.357.73.638.86.638.128 0 .38.013.38.101 0 .09-.112.454-.38.3l-.161-.094c-.214-.125-.405-.238-.438-.206-.04.041.128.5.363.61a.56.56 0 00.274.041c.096-.003.158-.006.158.102 0 .193-.166.407-.466.204a1.897 1.897 0 01-.327-.301c-.108-.117-.178-.193-.208-.117-.055.134-.032.662.206.662.055 0 .106-.002.151-.004.154-.005.25-.009.25.063 0 .093-.054.489-.302.331-.248-.158-.43-.355-.474-.495-.045-.14-.31 0-.226.196.083.196.286.591.34.591.055 0-.63 1.195-.63 1.195l-.004-1.47z"
          fill="#1A1A1A"
        />
      </g>
    </symbol>
    <symbol id="AM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#E31D1C" />
          <path d="M0 10v5h20v-5H0z" fill="#FECA00" />
        </g>
      </g>
    </symbol>
    <symbol id="AO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#1D1D1D"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v7.5h20V0H0z" fill="#F50100" />
          <g filter="url(#AO_-_Angola__filter0_d)">
            <path
              d="M9.719 8.37c.484-.599.636-1.373.636-1.856 0-2.573-3.211-3.997-3.211-3.997 2.208 0 4.666 1.79 4.666 3.997 0 .935-.32 1.802-.858 2.492.984.49 1.817.874 1.817.874.309.202.395.742.192 1.052a.67.67 0 01-.926.192s-.79-.467-1.271-.783a20.846 20.846 0 00-.748-.462 3.932 3.932 0 01-2.203.675s-2.936-.36-2.852-1.865c0 0 .71.543 2.802.543.332 0 .625-.046.881-.128-.905-.494-1.673-.886-1.673-.886-.31-.202-1.113-1.23-.91-1.538.202-.31 1.427.04 1.736.242 0 0 .43.59 1.036.951.268.16.57.328.886.497zM8.238 6.127l-.631.42.201-.72-.463-.46.627-.025.266-.712.265.712h.626l-.462.485.232.678-.661-.378z"
              fill="#FCFF01"
            />
            <path
              d="M9.719 8.37c.484-.599.636-1.373.636-1.856 0-2.573-3.211-3.997-3.211-3.997 2.208 0 4.666 1.79 4.666 3.997 0 .935-.32 1.802-.858 2.492.984.49 1.817.874 1.817.874.309.202.395.742.192 1.052a.67.67 0 01-.926.192s-.79-.467-1.271-.783a20.846 20.846 0 00-.748-.462 3.932 3.932 0 01-2.203.675s-2.936-.36-2.852-1.865c0 0 .71.543 2.802.543.332 0 .625-.046.881-.128-.905-.494-1.673-.886-1.673-.886-.31-.202-1.113-1.23-.91-1.538.202-.31 1.427.04 1.736.242 0 0 .43.59 1.036.951.268.16.57.328.886.497zM8.238 6.127l-.631.42.201-.72-.463-.46.627-.025.266-.712.265.712h.626l-.462.485.232.678-.661-.378z"
              fill="#FFEA42"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="AO_-_Angola__filter0_d"
          x="4.959"
          y="2.517"
          width="8.111"
          height="8.717"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="AQ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#5196ED"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g
          filter="url(#AQ_-_Antarctica__filter0_d)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          mask="url(#b)"
        >
          <path
            d="M5.448 4.934s1.29.707 1.47.903c.18.196.467.915.915.508.448-.406.897-.09.897-.738 0-.647.67-2.15 1.64-1.773.972.376 1.77.14 1.995.291.224.151.762.899 1.18.899.419 0 .628.436.658 1.069.03.633-.135.693.254.768.388.076.538.362.344.738-.195.377-.18.211-.15.603.03.391-.388 2.7-1.674 2.927-1.285.225-2.504.105-2.175-.332.33-.437.784-.94.112-1.045-.673-.105-1.097-.195-1.77-.014-.672.18-1.374.467-1.793-.075-.418-.543-.328-.934-.672-1.19-.344-.256-.763-.211-.419-.708.344-.497.628-.311.344-.703-.284-.392-1.356-.562-1.356-.954 0-.391-.681-1.25.2-1.174z"
            fill="#fff"
          />
          <path
            d="M5.448 4.934s1.29.707 1.47.903c.18.196.467.915.915.508.448-.406.897-.09.897-.738 0-.647.67-2.15 1.64-1.773.972.376 1.77.14 1.995.291.224.151.762.899 1.18.899.419 0 .628.436.658 1.069.03.633-.135.693.254.768.388.076.538.362.344.738-.195.377-.18.211-.15.603.03.391-.388 2.7-1.674 2.927-1.285.225-2.504.105-2.175-.332.33-.437.784-.94.112-1.045-.673-.105-1.097-.195-1.77-.014-.672.18-1.374.467-1.793-.075-.418-.543-.328-.934-.672-1.19-.344-.256-.763-.211-.419-.708.344-.497.628-.311.344-.703-.284-.392-1.356-.562-1.356-.954 0-.391-.681-1.25.2-1.174z"
            fill="#F5F8FB"
          />
        </g>
      </g>
      <defs>
        <filter
          id="AQ_-_Antarctica__filter0_d"
          x="3.997"
          y="2.774"
          width="11.889"
          height="9.466"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation=".5" />
          <feColorMatrix
            values="0 0 0 0 0.0941176 0 0 0 0 0.32549 0 0 0 0 0.639216 0 0 0 0.43 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="AR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0zm0 10v5h20v-5H0z" fill="#58A5FF" />
          <path
            d="M10.345 9.054s-.638 1.325-1.2 1.596c.243-.607.332-1.846.332-1.846s-1.458.577-1.97.472c.616-.43 1.47-1.226 1.47-1.226s-1.887-.617-1.84-.879c.851.153 2.022-.014 2.022-.014S7.836 5.57 7.97 5.452c.202.196 1.788 1.025 1.788 1.025s.115-1.412.456-1.888c.041.336.52 1.857.52 1.857s.963-.963 1.498-.963c-.235.29-.791 1.57-.791 1.57s1.385-.022 1.912.237c-.638.09-1.756.652-1.756.652s1.456 1.104 1.324 1.334c-.782-.382-1.686-.51-1.686-.51s.25 1.537.048 1.884c-.197-.511-.938-1.596-.938-1.596z"
            fill="#FFD018"
            stroke="#F19900"
            stroke-opacity=".98"
            stroke-width=".5"
          />
          <path
            d="M10.262 8.339a.625.625 0 100-1.25.625.625 0 000 1.25z"
            fill="#FFD018"
            stroke="#F19900"
            stroke-opacity=".98"
            stroke-width=".5"
          />
        </g>
      </g>
    </symbol>
    <symbol id="AS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          d="M0-.625h-.625v7.692L-1.78 7.5l1.155.433v7.692H20l.22-1.21L1.78 7.5 20.22.585 20-.625H0z"
          fill="#3547A0"
          stroke="#E31D1C"
          stroke-width="1.25"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.556 3.767s-5.04 1.309-5.04 1.51c0 .201-.453.84-.36 1.006.093.166.334.387.532.277.198-.11.668-.554.51-.277-.157.277.85.598.425 1.21 0 0 .51-.294.263 1.377l1.213.346s1.356-.355.737-1.372h.718s-.297-1.318.143-1.561c.44-.244-.449-.429-.449-.429 1.878-1.069 1.308-2.087 1.308-2.087z"
          fill="#C44800"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.722 9.357l-3.042-.515-.399-.533-1.727.348 1.516.859.51-.275 3.142.502v-.386z"
          fill="#FFC221"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.189 9.824v-.301l-3.41-.208s-.207-.19-.714-.19-.565.398-.565.398.29.58.855.58c.564 0 1.441.135 1.679.414.237.279 1.222-.143 1.222-.143s-.421-.724-.96-.497c-.54.226-1.518-.11-1.518-.232 0-.122 3.411.18 3.411.18zm-5.761-2.44s-.33.709-.21.977c.528.551 1.488-.328 1.488-.328l-1.278-.65z"
          fill="#FFC221"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.642 7.722c.351-.18.53-.515.53-.95 0-.336-.08-.602-.256-.771v-.229l-.31-.003c-2.774-.025-4.336.25-4.789.936-.458.695-.418 1.288.205 1.576l.276-.007c1.347-.702 2.717-.877 4.126-.527l.218-.025zm-4.564-.845c.366-.554 1.874-.82 4.525-.795v.079c.171.082.257.285.257.61s-.12.55-.36.673c-1.484-.369-2.933-.184-4.347.553-.415-.192-.44-.565-.075-1.12z"
          fill="#979797"
        />
        <path
          d="M16.603 6.082c-2.651-.024-4.16.24-4.525.795-.365.555-.34.928.075 1.12 1.414-.737 2.863-.922 4.346-.553.24-.123.36-.348.36-.673 0-.325-.085-.528-.256-.61v-.08z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="AT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g
          mask="url(#b)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#C51918"
        >
          <path d="M0 0v5h20V0H0zm0 10v5h20v-5H0z" />
        </g>
      </g>
    </symbol>
    <symbol id="AU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#2E42A5"
        />
        <path fill="#2E42A5" d="M0 0h11v9H0z" />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="11"
          height="9"
        >
          <path fill="#fff" d="M0 0h11v9H0z" />
        </mask>
        <g mask="url(#b)">
          <path
            d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
            fill="#F7FCFF"
          />
          <path
            d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
            fill="#F50100"
          />
          <path
            d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
            fill="#F7FCFF"
          />
          <path
            d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
            fill="#F50100"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="13"
            height="11"
            fill="#000"
          >
            <path fill="#fff" d="M-1-1h13v11H-1z" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
            fill="#F50100"
          />
          <path
            d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
            fill="#F7FCFF"
            mask="url(#c)"
          />
        </g>
      </g>
      <path
        d="M5.92 12.278l-.82.758.081-1.113-1.104-.17.922-.63-.557-.968 1.068.327.41-1.039.41 1.039 1.068-.327-.557.968.922.63-1.104.17.081 1.113-.82-.758zm7.32-3.981l-.547.505.054-.743-.735-.112.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.645.613.421-.735.112.054.743-.547-.505zm1.28-5.334l-.547.506.054-.743-.735-.112.614-.42-.371-.646.712.218.273-.693.273.693.712-.218-.37.645.613.42-.735.113.054.743-.547-.506zm3.2 2.667l-.547.505.054-.742-.735-.113.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.646.613.42-.735.113.054.742-.547-.505zm-2.56 7.667l-.547.505.054-.742-.735-.113.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.646.613.42-.735.113.054.742-.547-.505zM17.4 9.14l-.555.291.106-.618-.45-.438.621-.09.278-.563.278.562.62.09-.449.439.107.618-.556-.292z"
        fill="#F7FCFF"
      />
    </symbol>
    <symbol id="AW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#5BA3DA"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <g filter="url(#AW_-_Aruba__filter0_d)">
            <path
              d="M3.546 4.975L.808 4.397l2.772-.549.8-2.868.633 2.845 2.474.575-2.445.575-.706 2.34-.791-2.34z"
              fill="#EF2929"
            />
            <path
              d="M3.546 4.975L.808 4.397l2.772-.549.8-2.868.633 2.845 2.474.575-2.445.575-.706 2.34-.791-2.34z"
              fill="red"
            />
          </g>
          <path d="M20 9H0v1h20V9zm0 2H0v1h20v-1z" fill="#FAD615" />
        </g>
      </g>
      <defs>
        <filter
          id="AW_-_Aruba__filter0_d"
          x="-.192"
          y="-.02"
          width="8.681"
          height="8.335"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation=".5" />
          <feColorMatrix
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="AX" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#0061C1"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M6-.5h-.5v6h-6v4h6v6h4v-6h11v-4h-11v-6H6z"
            fill="#D21034"
            stroke="#FFCE00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="AZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#AF0100"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#3CA5D9" />
          <path d="M0 10v5h20v-5H0z" fill="#73BE4A" />
          <path
            d="M10.726 9.317c-.842-.194-1.5-.856-1.492-1.828.008-.909.595-1.678 1.52-1.887.927-.209 1.741.232 1.741.232-.255-.567-1.143-.965-1.872-.963-1.357.003-2.804 1.039-2.818 2.62-.015 1.64 1.546 2.571 2.919 2.568 1.1-.003 1.624-.712 1.732-1.013 0 0-.888.465-1.73.27zm.535-.93l.735-.51.735.51-.26-.856.714-.54-.895-.019-.294-.845-.294.845-.895.018.713.541-.259.857z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="BA" width="21" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="15">
        <path fill="#fff" d="M0 0h21.25v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20.25v15H0V0z" fill="#2E42A5" />
        <path d="M6.25 0H19v15L6.25 0z" fill="#FECA00" />
        <path
          d="M4.443 1.746l-.735.386.14-.818-.594-.58.821-.119.368-.744.367.744.821.12-.594.58.14.817-.734-.386zm2.179 2.675l-.735.386.14-.818-.594-.58.821-.118.368-.745.367.745.822.119-.595.58.14.817-.734-.386zm2.043 2.603l-.735.386.14-.818-.594-.58.821-.119.368-.744.367.744.821.12-.594.58.14.817-.734-.386zm2.001 2.494l-.735.387.14-.819-.594-.579.822-.12.367-.744.367.745.822.119-.595.58.14.818-.734-.387zm2.156 2.567l-.735.387.14-.818-.594-.58.821-.12.367-.744.368.745.821.12-.594.579.14.818-.734-.387zm2.382 2.485l-.735.386.14-.819-.594-.579.822-.12.367-.744.368.745.821.12-.594.579.14.818-.735-.387z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="BB" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0z" fill="#2E42A5" />
        <path d="M6 0h8v15H6V0z" fill="#FECA00" />
        <path d="M0 0h6v15H0V0z" fill="#2E42A5" />
        <path
          d="M11.521 9.546c.396-.818.852-2.311.852-2.311l.346-1.028-1.372.497.325.188s-.566 1.131-.85 1.684c-.286.552-.314.187-.314.187l.049-3.855.315-.086-.785-1.507-1.001 1.528.44.012S9.49 8.923 9.43 8.763c-.034-.09-.125.19-.17.081-.278-.681-.658-2.002-.658-2.002l.222-.208-1.492-.307.445.918s.393 1.635.825 2.434c.097.252.566.36.566.36s.23-.233.286 0c.057.233 0 1.172 0 1.172h1.055s-.074-.886 0-1.172c.074-.286.304 0 .304 0s.612-.24.71-.493z"
          fill="#000"
        />
      </g>
    </symbol>
    <symbol id="BD" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path fill="#38A17E" d="M0 0h20v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.5 11.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
          fill="#F72E45"
        />
      </g>
    </symbol>
    <symbol id="BE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M6 0h8v15H6V0z" fill="#FECA00" />
        <path d="M14 0h6v15h-6V0z" fill="#E31D1C" />
        <path d="M0 0h6v15H0V0z" fill="#1D1D1D" />
      </g>
    </symbol>
    <symbol id="BF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#5EAA22"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v7.5h20V0H0z" fill="#C51918" />
          <path
            d="M10.022 9.857l-2.94 2.224.941-3.623-2.757-2.206h3.286l1.47-3.216 1.47 3.216h3.285l-2.786 2.209.97 3.62-2.939-2.224z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="BG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#5EAA22"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#F7FCFF" />
          <path d="M0 10v5h20v-5H0z" fill="#E22C18" />
        </g>
      </g>
    </symbol>
    <symbol id="BH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path fill="#E31D1C" d="M0 0h20v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h4.25L7.5 1.25 4.25 2.5 7.5 3.75 4.25 5 7.5 6.25 4.25 7.5 7.5 8.75 4.25 10l3.25 1.25-3.25 1.25 3.25 1.25L4.25 15H0V0z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="BI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <rect width="20" height="15" rx="1.25" fill="#5EAA22" />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="-5"
          y="-2"
          width="30"
          height="19"
          fill="#000"
        >
          <path fill="#fff" d="M-5-2h30v19H-5z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 7.5L20 0H0l10 7.5zm0 0L0 15h20L10 7.5z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 7.5L20 0H0l10 7.5zm0 0L0 15h20L10 7.5z"
          fill="#DD2C2B"
        />
        <path
          d="M20 0l.938 1.25 3.75-2.813H20V0zM0 0v-1.563h-4.688l3.75 2.813L0 0zm0 15l-.938-1.25-3.75 2.813H0V15zm20 0v1.563h4.688l-3.75-2.813L20 15zm-.938-16.25l-10 7.5 1.876 2.5 10-7.5-1.875-2.5zM0 1.563h20v-3.125H0v3.125zM10.938 6.25l-10-7.5-1.875 2.5 10 7.5 1.874-2.5zm-1.876 0l-10 7.5 1.875 2.5 10-7.5-1.874-2.5zM0 16.563h20v-3.125H0v3.124zm20.938-2.813l-10-7.5-1.876 2.5 10 7.5 1.875-2.5z"
          fill="#fff"
          mask="url(#b)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 11.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
          fill="#fff"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.104 6.518l-.734.386.14-.818-.594-.58h.821l.367-.863.368.864h.821l-.594.58.14.817-.735-.386zm-1.753 2.5l-.734.386.14-.818-.595-.58h.822l.367-.863.368.864h.821l-.594.58.14.817-.735-.386zm3.5 0l-.734.386.14-.818-.595-.58h.822l.367-.863.368.864h.821l-.594.58.14.817-.735-.386z"
          fill="#DD2C2B"
        />
      </g>
    </symbol>
    <symbol id="BJ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#DD2C2B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v7.5h20V0H0z"
          fill="#FECA00"
        />
        <path fill="#5EAA22" d="M0 0h9v15H0z" />
      </g>
    </symbol>
    <symbol id="BL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0z" fill="#F50100" />
        <path d="M0 0h8v15H0V0z" fill="#2E42A5" />
        <path d="M6 0h8v15H6V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="BM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#AF0100"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.755 7.5c0 3.68.348 4.957 2.445 4.957s2.67-1.854 2.494-4.957h-4.94z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.313 9.625c.586 0 1.062-.56 1.062-1.25s-.476-1.25-1.063-1.25c-.586 0-1.062.56-1.062 1.25s.476 1.25 1.063 1.25z"
            fill="#AF0100"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.246 11.446c.373.834 1.027 1.25 1.96 1.25.928 0 1.583-.41 1.967-1.233l-3.927-.017z"
            fill="#5EAA22"
          />
          <path
            d="M14.762 9.394l-.349-.87c.64-.257 1.258-.387 1.85-.387.594 0 1.211.13 1.852.387l-.35.87c-.533-.214-1.033-.32-1.501-.32-.468 0-.968.106-1.502.32z"
            fill="#82B2CB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.625 10a.625.625 0 100-1.25.625.625 0 000 1.25z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 11a.625.625 0 100-1.25.625.625 0 000 1.25z"
            fill="#8A4E22"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 10.5a.625.625 0 100-1.25.625.625 0 000 1.25zm2.125 0a.625.625 0 100-1.25.625.625 0 000 1.25zm-.437 1.375c.241 0 .437-.28.437-.625s-.196-.625-.438-.625c-.241 0-.437.28-.437.625s.196.625.438.625zm-1.5 0c.241 0 .437-.28.437-.625s-.196-.625-.438-.625c-.241 0-.437.28-.437.625s.196.625.438.625z"
            fill="#AF0100"
          />
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#fff"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#fff"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="BN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#FFD221"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M-1.917 6.635l1.255-2.862 21.767 9.545-1.255 2.862-21.767-9.545z"
            fill="#313131"
          />
          <path
            d="M-1.886 3.48L-.63.62l22.849 10.014-1.255 2.863L-1.886 3.48z"
            fill="#FAF9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.582 7.748c-.887-1.088-.739-1.824-.739-1.824s.908.034.898.619c0 .247.325.48.605.683.213.152.399.286.399.393 0 .249.187 2.756.187 2.756s-.13.229-.757.229c-.626 0-.593-.361-.593-.361.38-.466 0-2.495 0-2.495zm10.836 0c.887-1.088.739-1.824.739-1.824s-.907.034-.897.619c0 .247-.326.48-.606.683-.212.152-.399.286-.399.393 0 .249-.187 2.756-.187 2.756s.13.229.757.229.594-.361.594-.361c-.38-.466 0-2.495 0-2.495zm-5.381-5.951l.705.502-.462.124.462.399-.575-.146v.403h.575l.192.945-.223-.158-.222.158-.222-.158-.223.158-.229-.158-.229.158-.229-.158-.229.158.289-.945h.531V1.797h.09zm3.141 3.173s-.215.19-.675 0a3.25 3.25 0 01-.498-.29c-.35-.23-.73-.48-1.08-.411-.524.104-.757.354-.757.354v-.576h-.226v.576s-.233-.25-.757-.354c-.35-.07-.729.18-1.08.41a3.249 3.249 0 01-.498.29c-.46.19-.675 0-.675 0s0 .161.342.409c.149.107.319.1.463.056-.107.081-.159.176.012.252.354.158.936-.257 1-.304-.072.053-.775.581-.453.581.34 0 .889-.444.889-.444s-.667.64-.308.74c.228.063.5-.27.629-.467.004.042.042.067.084.095.054.036.113.076.113.158 0 .106.027.124.05.14.018.012.033.023.033.073v.146l-.083.122s0 .191.083.342c.063.115.031.211-.025.377a4.24 4.24 0 00-.058.183c-.083.288.083.78.083.78h-.083s.083.06.083.303c0 .198-.055.31-.159.522-.023.048-.05.102-.078.163-.155.328.154.745.154.745s-.518-.228-.414 0c.08.175.518.345.717.414v.033l.05-.016.048.016v-.033c.2-.07.638-.24.718-.414.103-.228-.415 0-.415 0s.31-.417.155-.745c-.03-.061-.055-.115-.08-.163-.103-.212-.158-.324-.158-.522 0-.242.083-.303.083-.303h-.083s.166-.492.083-.78a4.15 4.15 0 00-.058-.183c-.056-.166-.088-.262-.025-.377.083-.151.083-.342.083-.342l-.083-.122v-.146c0-.05.016-.061.034-.073.023-.016.049-.034.049-.14 0-.082.06-.122.113-.158.042-.028.08-.053.085-.095.128.197.4.53.628.466.359-.1-.308-.739-.308-.739s.55.444.889.444c.322 0-.381-.528-.452-.581.064.047.645.462 1 .304.17-.076.118-.171.011-.252.145.043.314.051.463-.056.342-.248.342-.408.342-.408zm-1.14.291s.146.117.335.173a1.614 1.614 0 00-.335-.173zm-1.476.425c-.057-.075-.03-.007.043.106.002-.027-.01-.06-.043-.106zm-1.013 0c.056-.075.03-.007-.043.106-.003-.027.009-.06.043-.106zm-1.477-.425s-.146.117-.335.173c.128-.096.335-.173.335-.173z"
            fill="#CF1225"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.018 5.986s-.746 1.015-.663 2.1c.083 1.084.968 3.606 3.592 3.606h.068c2.78 0 3.57-2.782 3.57-3.782 0-1.009-.63-1.924-.63-1.924s.074 1.354 0 1.924c-.221 1.719-1.304 2.513-2.959 2.513-1.665 0-2.696-.824-2.978-2.513-.09-.546 0-1.924 0-1.924z"
            fill="#CF1225"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.666 12.345s.135-.388.302-.388c.166 0-.319-.337 0-.432.318-.095.808.38.808-.095s-.414-.734-.11-.734c.305 0 .623-.09.623-.09s1.295 1.35 2.593 1.35c1.297 0 2.857-1.26 2.857-1.26s.575-.146.575.082c0 .228-.126.572-.126.572s.402-.079.607 0c.205.08 0 .46 0 .46v.147s.534-.118.534.092-.258.09-.78.15c-.521.06-.719.469-1.047.469-.327 0-.398-.323-.398-.323s-1.016.55-2.222.55c-1.207 0-1.936-.55-1.936-.55s.114.565-.272.444c-.385-.121-.78-.89-1.243-.74-.463.15-.765.296-.765.296z"
            fill="#CF1225"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.539 10.103c.022-.021.045-.045.075-.078a1.02 1.02 0 01.126-.128.385.385 0 01.006.078c0 .235.008.412.031.536.016.088.04.145.08.172.058.04.117.005.171-.077.126-.188.361-.211.361-.14 0 .02-.007.04-.053.151a2.07 2.07 0 00-.02.05.423.423 0 00-.04.2c.011.08.07.124.164.124.106 0 .175-.068.252-.203a7.54 7.54 0 00.036-.065l.004-.007a.58.58 0 01.033-.055c.028-.04.034-.036.096.11l.079.19.05.12c.04.095.069.152.099.191.069.09.15.09.249.006a.762.762 0 01.066-.05c.013-.01.044-.03.074-.049l.065-.042c.057-.04.085-.07.084-.117 0-.058-.05-.095-.147-.131a.342.342 0 01-.045-.02l-.017-.006.012-.005.004-.003a.77.77 0 01.295-.052l.01.001c.003.002.003.008.003.022v.002a.747.747 0 01-.036.167l-.009.036c-.03.12-.04.191-.018.254.031.091.12.123.256.096.185-.037.275-.11.299-.223a.42.42 0 00.007-.094c0-.073 0-.073.063-.073.088 0 .123.031.16.118l.013.032c.043.104.083.15.174.15.06 0 .102-.026.095-.085a.141.141 0 00-.017-.046l-.007-.014-.013-.026c-.056-.114-.034-.202.16-.325.054-.036.14-.095.213-.147l.126-.087a.892.892 0 01.005.069l.003.082.002.04c.008.21.051.401.115.479.107.132.211.01.282-.28a2.78 2.78 0 01.258-.697c.046-.078.09-.127.122-.142.022-.01.037-.002.06.038.085.155.215.298.326.34.164.063.26-.07.26-.365 0-.248.041-.446.108-.599a.74.74 0 01.1-.165l-.071-.076a.658.658 0 00-.123.198 1.6 1.6 0 00-.116.642c0 .233-.046.296-.122.267-.084-.032-.199-.159-.273-.293-.047-.085-.116-.117-.19-.083-.057.026-.113.088-.169.183-.1.169-.2.44-.27.726-.03.125-.062.204-.104.238-.044-.055-.084-.227-.09-.415l-.002-.04-.004-.083a.825.825 0 00-.006-.086c-.01-.068-.045-.107-.106-.091a2.2 2.2 0 00-.244.158c-.058.04-.112.079-.145.1-.238.152-.276.299-.196.461l.006.013c-.019-.009-.032-.031-.053-.08l-.013-.033c-.052-.122-.119-.181-.255-.181-.13 0-.164.054-.165.178a.33.33 0 01-.004.072c-.014.067-.07.112-.218.142-.093.018-.13.005-.14-.028-.012-.035-.005-.094.02-.193l.01-.034a.783.783 0 00.038-.193c.002-.079-.037-.133-.115-.133a.86.86 0 00-.34.064c-.125.062-.1.168.057.227a.5.5 0 01.063.027l.015.006a.04.04 0 00-.009.006l-.03.024-.057.037-.08.052a.893.893 0 00-.076.057c-.057.05-.073.05-.103.01a.848.848 0 01-.086-.168 17.817 17.817 0 01-.128-.31c-.088-.208-.183-.255-.272-.13a.676.676 0 00-.04.065l-.005.008-.035.063c-.06.104-.106.15-.163.15-.046 0-.059-.009-.062-.032a.351.351 0 01.034-.147l.019-.048c.057-.14.06-.15.06-.191 0-.214-.377-.176-.547.08a.195.195 0 01-.036.043.325.325 0 01-.03-.099 3.137 3.137 0 01-.03-.516c0-.145-.043-.222-.137-.18-.042.019-.044.02-.171.158-.028.031-.05.053-.07.072a.347.347 0 01-.07.053c-.029.015-.04.006-.055-.062a1.603 1.603 0 01-.022-.335v-.14c0-.117-.031-.183-.107-.183a.19.19 0 00-.086.026.874.874 0 00-.04.022l-.042.024c-.07.04-.117.058-.161.058-.008 0-.013.002-.015.002H6.87h.001l.013-.02c.029-.057.107-.15.233-.273l-.07-.076c-.134.13-.218.23-.254.3-.05.097-.011.173.094.173a.418.418 0 00.211-.072c.098-.056.103-.059.118-.059 0 0 .005.012.005.078v.14c0 .174.005.278.024.36.029.124.1.184.202.13a.436.436 0 00.092-.068zm.212-.212h.001-.001zm1.664.967a.024.024 0 01-.003-.002c.001.004.002.007.004.008l-.001-.006zm1.813-.309zm-2.583 1.795c-.045.123-.117.163-.198.102a.466.466 0 01-.082-.088l-.007-.01a7.41 7.41 0 00-.078-.102.533.533 0 00-.195-.169l-.006-.002c-.08-.034-.097-.041-.114-.05l-.018-.008a.422.422 0 01-.203-.186 2.283 2.283 0 01-.149-.352l.096-.037c.066.18.104.271.14.335a.32.32 0 00.16.145l.016.008.111.048.006.002c.084.036.155.1.235.2l.081.105.005.007a.397.397 0 00.07.077c.008-.005.02-.024.035-.062.031-.085.003-.15-.073-.22l-.02-.016c-.03-.024-.08-.063-.088-.076-.03-.044-.004-.088.04-.1a.422.422 0 01.098-.007c.166 0 .211.097.242.346v.004c.025.196.05.25.133.25.094 0 .152-.038.252-.145l.022-.024c.128-.136.217-.182.367-.14.12.033.172.092.184.184l.003.035c.006.077.02.09.17.09.113 0 .218.005.356.018l.016.001c.032.003.101.01.122.01a.866.866 0 00.101.006.26.26 0 00.041-.002c.004-.03.022-.052.094-.133l.02-.024a.225.225 0 00.048-.07s-.03-.012-.111-.012c-.075 0-.112-.009-.119-.061-.005-.044.02-.066.076-.095.065-.035.182-.08.323-.124.136-.043.279-.082.388-.105a.941.941 0 01.142-.022c.066-.004.106.005.106.065 0 .026.07.111.14.15.084.047.144.03.185-.08.06-.16.184-.332.306-.43.066-.054.126-.082.178-.078.07.007.106.067.106.158h-.102c0-.043-.006-.052-.013-.053-.02-.002-.059.017-.105.055a.998.998 0 00-.275.386c-.064.172-.193.21-.328.135a.44.44 0 01-.187-.203.912.912 0 00-.133.02 4.12 4.12 0 00-.604.182c.074.01.116.038.127.09.011.05-.014.095-.07.161a1.018 1.018 0 00-.09.106c0 .07-.053.09-.143.09-.028 0-.062-.002-.11-.006l-.123-.011-.015-.002a3.798 3.798 0 00-.348-.018c-.202 0-.26-.053-.27-.186a.494.494 0 00-.004-.029c-.006-.05-.028-.074-.108-.096-.105-.03-.163 0-.267.111l-.022.024c-.118.126-.196.176-.326.176-.147 0-.195-.078-.226-.282a.36.36 0 01-.01.034zm.009-.093v-.004a.902.902 0 00-.033-.152.22.22 0 01.043.215 1.92 1.92 0 01-.01-.06zm1.874-.076h.003-.002zm-.002.343l-.002.001h.002z"
            fill="#F6E017"
          />
        </g>
      </g>
    </symbol>
    <symbol id="BO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#FECA00"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#DB501C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#5EAA22"
          />
          <path
            d="M7.28 7.038s-.233 2.38 1.883 2.38h1.577s2.226-.145 1.968-2.38"
            stroke="#DB501C"
            stroke-width=".938"
          />
          <path
            d="M11.406 7.375a1.406 1.406 0 11-2.812 0 1.406 1.406 0 012.812 0z"
            fill="#FECA00"
            stroke="#68B9E8"
            stroke-width=".938"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 7.5a.625.625 0 100-1.25.625.625 0 000 1.25z"
            fill="#DB501C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.063 8.5c.586 0 1.062-.224 1.062-.5s-.476-.5-1.063-.5C9.476 7.5 9 7.724 9 8s.476.5 1.063.5z"
            fill="#5EAA22"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.063 6.25c.828 0 1.5-.224 1.5-.5s-.672-.5-1.5-.5c-.829 0-1.5.224-1.5.5s.671.5 1.5.5z"
            fill="#674F28"
          />
        </g>
      </g>
    </symbol>
    <symbol id="BQ-BO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#fff"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 6.833V0h10L0 6.833z"
          fill="#FEDA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 15h20.006V0L0 15z"
          fill="#00268D"
        />
        <mask id="b" fill="#fff">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.846 3.125l.33.707a2.75 2.75 0 012.419 2.661l.597.299-.652.326A2.752 2.752 0 016.2 9.29l-.354.71-.355-.71a2.752 2.752 0 01-2.34-2.172L2.5 6.792l.597-.299a2.75 2.75 0 012.397-2.658l.352-.71z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.846 3.125l.33.707a2.75 2.75 0 012.419 2.661l.597.299-.652.326A2.752 2.752 0 016.2 9.29l-.354.71-.355-.71a2.752 2.752 0 01-2.34-2.172L2.5 6.792l.597-.299a2.75 2.75 0 012.397-2.658l.352-.71z"
          fill="#fff"
        />
        <path
          d="M6.175 3.832l-.453.211.117.252.277.033.06-.496zm-.33-.707l.454-.211-.44-.943-.461.932.448.222zm2.75 3.368l-.5.013.008.3.268.135.224-.448zm.597.299l.223.447.895-.447-.895-.448-.223.448zm-.652.326l-.224-.448-.217.11-.049.237.49.1zM6.2 9.29l-.063-.496-.264.034-.12.238.448.224zm-.354.71l-.447.224.447.894.447-.894L5.846 10zm-.355-.71l.447-.224-.12-.238-.263-.034-.064.496zM3.15 7.118l.49-.1-.048-.239-.218-.109-.223.448zm-.65-.326l-.224-.448-.894.448.894.447.224-.447zm.597-.299l.223.448.27-.135.007-.3-.5-.013zm2.397-2.658l.063.496.266-.034.12-.24-.449-.222zm1.134-.214L6.3 2.914l-.906.422.329.707.906-.422zm2.467 2.86a3.25 3.25 0 00-2.86-3.145l-.12.992a2.25 2.25 0 011.98 2.178l1-.025zm.32-.137l-.596-.298-.448.895.597.298.447-.895zm-.652 1.22l.652-.325-.447-.895-.652.326.447.895zM6.265 9.787A3.252 3.252 0 009.03 7.218l-.98-.2a2.252 2.252 0 01-1.913 1.776l.128.992zm-.511-.72l-.355.71.894.448.355-.71-.894-.448zm.54.71l-.356-.71-.894.447.355.71.894-.447zM2.661 7.218a3.252 3.252 0 002.765 2.568l.128-.992a2.252 2.252 0 01-1.913-1.777l-.98.201zm-.386.02l.652.327.447-.895-.651-.326-.448.895zm.597-1.192l-.597.298.448.895.596-.298-.447-.895zM5.431 3.34a3.25 3.25 0 00-2.834 3.14l1 .025a2.25 2.25 0 011.96-2.175l-.126-.992zm-.033-.436l-.352.71.896.444.352-.71-.896-.444z"
          fill="#000"
          mask="url(#b)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.86 5.188l-.406.68h-.8l.4.715-.4.686h.8l.406.7.412-.7h.793l-.39-.686.39-.715h-.793l-.412-.68z"
          fill="#F00A17"
        />
      </g>
    </symbol>
    <symbol id="BQ-SA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#fff" />
        <path
          d="M0 7.29V0h10L0 7.29zm20 0V0H10l10 7.29z"
          fill="#F00000"
        />
        <path
          d="M0 7.29V15h10L0 7.29zm20 0v7.92L10 15l10-7.71z"
          fill="#00268D"
        />
        <path
          d="M9.821 8.91l-2.198 1.567.807-2.588-2.18-1.585h2.715l.856-2.554.907 2.554h2.642L11.21 7.89l.82 2.588L9.822 8.91z"
          fill="#FEDA00"
        />
      </g>
    </symbol>
    <symbol id="BQ-SE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#00268D"
        />
        <path
          d="M.625.625h18.75v13.75H.625V.625z"
          fill="#00268D"
          stroke="#E31D1C"
          stroke-width="1.25"
        />
        <path fill="#E31D1C" d="M9.375 0h1.25v15h-1.25z" />
        <path fill="#E31D1C" d="M0 8.125v-1.25h20v1.25z" />
        <path
          d="M10.28 3.816l-.28-.14-.28.14-6.25 3.125-1.118.559 1.118.559 6.25 3.125.28.14.28-.14 6.25-3.125 1.117-.559-1.117-.559-6.25-3.125z"
          fill="#fff"
          stroke="#E31D1C"
          stroke-width="1.25"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="2"
          width="20"
          height="11"
        >
          <path
            d="M10.28 3.816l-.28-.14-.28.14-6.25 3.125-1.118.559 1.118.559 6.25 3.125.28.14.28-.14 6.25-3.125 1.117-.559-1.117-.559-6.25-3.125z"
            fill="#fff"
            stroke="#fff"
            stroke-width="1.25"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M7.256 10h8.369l-.885-.957s-1.77-1.893-1.883-1.98c-.114-.086-.302-.124-.516.152-.215.276-.337-.151-.516-.151-.178 0-.253 0-.512.353l-1.19 1.626H8.755s-.231-.209-.363-.134c-.131.074-.872-.825-1.136-.892-.264-.067-.438.243-.438.49 0 .248-.124-.226-.377-.087-.253.14-.171.489-.171.489S7.087 10 7.256 10z"
            fill="#059334"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.753 7.034l-.617.466.226-.77-.612-.47h.763l.24-.76.255.76h.742l-.607.47.23.77-.62-.466z"
            fill="#FEDA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="BR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#093"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <g
            filter="url(#BR_-_Brazil__filter0_d)"
            fill-rule="evenodd"
            clip-rule="evenodd"
          >
            <path
              d="M9.954 2.315L17.58 7.63l-7.73 4.977-7.47-5.08 7.574-5.212z"
              fill="#FFD221"
            />
            <path
              d="M9.954 2.315L17.58 7.63l-7.73 4.977-7.47-5.08 7.574-5.212z"
              fill="url(#BR_-_Brazil__paint0_linear)"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 10.75a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25z"
            fill="#2E42A5"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="6"
            y="4"
            width="8"
            height="7"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 10.75a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)" fill="#F7FCFF">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.988 9.106l-.14.074.027-.156-.113-.11.156-.023.07-.141.07.141.155.023-.113.11.027.156-.14-.074zm1.25 0l-.14.074.027-.156-.113-.11.156-.023.07-.141.07.141.155.023-.113.11.027.156-.14-.074zm0 .75l-.14.074.027-.156-.113-.11.156-.023.07-.141.07.141.155.023-.113.11.027.156-.14-.074zm-.625-2.625l-.14.074.027-.156-.113-.11.156-.023.07-.141.07.141.155.023-.113.11.027.156-.14-.074zm0 1.25l-.14.074.027-.156-.113-.11.156-.023.07-.141.07.141.155.023-.113.11.027.156-.14-.074zm-.876-.625l-.14.074.028-.156-.113-.11.156-.023.07-.141.07.141.155.023-.113.11.027.156-.14-.074zm-.875.5l-.14.074.028-.156-.113-.11.156-.023.07-.141.07.141.155.023-.113.11.027.156-.14-.074zm2.876-2.125l-.14.074.027-.156-.113-.11.156-.023.07-.141.07.141.155.023-.112.11.026.156-.14-.074z"
            />
            <path
              d="M6.203 6.873l.094-1.246c2.999.226 5.365 1.212 7.07 2.966l-.896.871c-1.478-1.52-3.557-2.386-6.268-2.59z"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="BR_-_Brazil__paint0_linear"
          x1="20"
          y1="15"
          x2="20"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFC600" />
          <stop offset="1" stop-color="#FFDE42" />
        </linearGradient>
        <filter
          id="BR_-_Brazil__filter0_d"
          x="2.381"
          y="2.315"
          width="15.2"
          height="10.292"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feColorMatrix
            values="0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="BS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#FECA00" />
        <path d="M0 0v5h20V0H0zm0 10v5h20v-5H0z" fill="#3CB1CF" />
        <path d="M0 0l10 7.5L0 15V0z" fill="#272727" />
      </g>
    </symbol>
    <symbol id="BT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#FF6230"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15L20 0H0z"
          fill="#FECA00"
        />
        <g filter="url(#BT_-_Bhutan__filter0_d)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.739 10.206s-.94.856-.195.9c.745.046.606.5 1.215.003.61-.496.018.08.83-.034.813-.113 1.22-1.104 1.649-1.036.428.067.18-.09.541.338.361.43.996-.481.657.15-.338.633-.474 1.264.023 1.242.497-.023.7-.316.925-.632.226-.316 1.987.768 1.174-.316-.812-1.083-1.128.119-1.195-.445-.068-.565-.23-.858.155-.587.383.27 1.286.203.586-.474-.7-.678-.602-.858-.806-.678-.203.181-.7-.677 0-.79.7-.112 1.506.271 1.777.474.27.204 1.106-.045 1.287.361.18.407.79.475.947.723.159.248.046 1.467 1.332 1.4 1.287-.068 1.693-.723 1.152-1.242-.542-.52-.497-1.467-1.061-1.016-.565.452-1.377.384-1.377-.158s.248-.632.203-1.06c-.045-.43-.09-.25.745-.227.835.023.541 0 1.15-.293.61-.293 1.017.993 1.265.045s-.09-1.918-.767-1.535c-.678.384-.655 1.332-1.513.587-.857-.745-1.264-.361-.993-.767.27-.407-.068-.7.542-.43.61.272.429.362.948.43.519.067 3.273.406 2.663-.158-.61-.565-1.194-.473-1.284-.834-.09-.36.28-.27.823-.474.541-.203.316-1.241-.204-1.038-.519.203-.474 1.106-1.535.542-1.218.53-1.03.263-1.649-.634-.542-.43-.835-.452-1.76.045-.731.301-1.342.858-.959 1.603.384.745 1.298 2.147.802 2.238-.497.09-2.28-1.242-3.318-.542-1.039.7-1.606 1.38-1.944 2.193-.339.813-1.434 1.286-1.705 1.286-.27 0-.652.478-1.126.84z"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <filter
          id="BT_-_Bhutan__filter0_d"
          x="-.743"
          y="-.782"
          width="20.429"
          height="15.551"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            values="0 0 0 0 0.866667 0 0 0 0 0.184314 0 0 0 0 0 0 0 0 0.38 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="BV" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M6.25-.625h-.625v6.25h-6.25v3.75h6.25v6.25h3.75v-6.25h11.25v-3.75H9.375v-6.25H6.25z"
            fill="#2E42A5"
            stroke="#F7FCFF"
            stroke-width="1.25"
          />
        </g>
      </g>
    </symbol>
    <symbol id="BW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#42ADDF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#58A5FF"
          />
          <path
            d="M0 5.5h-.5v4h21v-4H0z"
            fill="#272727"
            stroke="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="BY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#73BE4A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v10h20V0H0z"
          fill="#AF0100"
        />
        <path fill="#F7FCFF" d="M0 0h3.75v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M.625 0a.625.625 0 110 1.25.625.625 0 010-1.25zm2.5 0a.625.625 0 110 1.25.625.625 0 010-1.25zM1.25 3.125a.625.625 0 10-1.25 0 .625.625 0 001.25 0zM3.125 2.5a.625.625 0 110 1.25.625.625 0 010-1.25zm0 8.75a.625.625 0 110 1.25.625.625 0 010-1.25zm-1.875.625a.625.625 0 10-1.25 0 .625.625 0 001.25 0zM.625 13.75a.625.625 0 110 1.25.625.625 0 010-1.25zm3.125.625a.625.625 0 10-1.25 0 .625.625 0 001.25 0zM1.875 12.5a.625.625 0 110 1.25.625.625 0 010-1.25zM2.5 1.875a.625.625 0 10-1.25 0 .625.625 0 001.25 0zm.069 5.65L3.75 8.75V10l.027.058-1.845-1.847L.274 10H0V8.75l1.24-1.232L0 6.278V5h.136l1.779 1.846 1.787-1.778L3.75 5v1.25L2.569 7.524zM1.875 3.75a.625.625 0 110 1.25.625.625 0 010-1.25zm.625 6.875a.625.625 0 10-1.25 0 .625.625 0 001.25 0z"
          fill="#D0181A"
        />
        <path
          opacity=".4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h1.25v1.25H0V0zm1.25 2.5H0v1.25h1.25V2.5zM0 5h1.25v1.25H0V5zm1.25 3.75H0V10h1.25V8.75zM0 11.25h1.25v1.25H0v-1.25zm1.25 2.5H0V15h1.25v-1.25zm2.5 0H2.5V15h1.25v-1.25zM3.75 0H2.5v1.25h1.25V0z"
          fill="#8F181A"
        />
      </g>
    </symbol>
    <symbol id="BZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#0168B4"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0-1v3h20v-3H0zm0 14v3h20v-3H0z"
            fill="#E93C43"
          />
          <path
            d="M10 11.25a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.625 7.5a4.375 4.375 0 108.75 0 4.375 4.375 0 00-8.75 0zm8.125 0a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.25 7.5a3.75 3.75 0 107.5 0 3.75 3.75 0 00-7.5 0zm6.625 0a2.875 2.875 0 11-5.75 0 2.875 2.875 0 015.75 0z"
            fill="#5B8C39"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.125 8.75l1.837-.235 1.913.235v.625L9.962 9.14l-1.837.235V8.75z"
            fill="#5B8C39"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.75 6.25h2.5S11.427 10 10 10 8.75 6.25 8.75 6.25z"
            fill="#769DF1"
          />
          <path fill="#FECA00" d="M10 6.25h1.25V7.5H10z" />
          <path
            opacity=".6"
            fill="#F6F7F8"
            d="M8.75 6.25H10V7.5H8.75z"
          />
          <rect
            opacity=".66"
            x="8.75"
            y="5"
            width="2.5"
            height="1.25"
            rx=".625"
            fill="#5B8C39"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.625 8c.345 0 .625-.56.625-1.25S8.97 5.5 8.625 5.5 8 6.06 8 6.75 8.28 8 8.625 8z"
            fill="#E9AD35"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.375 8C11.72 8 12 7.44 12 6.75s-.28-1.25-.625-1.25-.625.56-.625 1.25.28 1.25.625 1.25z"
            fill="#5C2216"
          />
        </g>
      </g>
    </symbol>
    <symbol id="CA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M5 0h10v15H5V0z" fill="#F7FCFF" />
        <path
          d="M8.956 5.252L9.983 3.75 10 12.5h-.428l.263-2.165s-2.883.529-2.644.262c.238-.267.375-.757.375-.757L5 8.092s.405-.005.734-.205c.33-.2-.33-1.385-.33-1.385l1.296.192.49-.544.978 1.045h.44l-.44-2.393.788.45zM10 12.5V3.75l1.044 1.502.788-.45-.44 2.393h.44l.977-1.045.49.544 1.296-.192s-.658 1.185-.33 1.385c.33.2.735.205.735.205L12.434 9.84s.137.49.376.757c.238.267-2.645-.262-2.645-.262l.263 2.165H10zM15 0h5v15h-5V0zM0 0h5v15H0V0z"
          fill="#E31D1C"
        />
      </g>
    </symbol>
    <symbol id="CC" width="20" height="15" fill="none">
      <g mask="url(#CC_-_Cocos_(Keeling)_Islands__a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#5EAA22"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15 4.375l-.625.458.084-.77-.709-.313.709-.313-.084-.77.625.458.625-.458-.084.77.709.313-.709.313.084.77L15 4.375zm-.648 4.175l-.625.457.083-.77-.708-.313.708-.312-.083-.77.625.457.625-.457-.084.77.709.312-.709.313.084.77-.625-.458zm1.898 3.325l-.625.457.084-.77L15 11.25l.709-.313-.084-.77.625.458.625-.457-.084.77.709.312-.709.313.084.77-.625-.458zm.625-5.937l-.313.228.042-.385-.354-.156.354-.156-.041-.385.312.229.313-.23-.042.386.354.156-.354.156.041.385-.312-.229zM4.375 8.75a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25z"
          fill="#FECA00"
        />
        <path
          d="M4.056 7.492l-.224-.158c.496-.65.365-1.558.224-2.155l.912-.215c.21.89-.255 1.668-.912 2.528z"
          fill="#915E2B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.436 9.34c-.411.707-1.065 1.027-1.94 1.027a2.371 2.371 0 010-4.742c1 0 1.796.35 2.162 1.302-.29-.287-.738-.484-1.408-.46-1.036 0-1.71.807-1.71 1.498 0 .69.675 1.628 1.71 1.628.52-.007.906-.103 1.186-.252z"
          fill="#FECA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.375 5.462c1.036 0 1.696-.28 1.696-.625s-.66-.625-1.696-.625-1.572.28-1.572.625.536.625 1.572.625z"
          fill="#5EAA22"
        />
      </g>
    </symbol>
    <symbol id="CD" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3195F9"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M-1.139 15.9l.434.65.65-.434L22.608.988l.65-.433-.434-.65-1.388-2.08-.433-.65-.65.434L-2.31 12.737l-.65.433.434.65 1.387 2.08z"
            fill="#E31D1C"
            stroke="#FECA00"
            stroke-width="1.563"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.082 5.379L.903 6.89 1.6 4.302 0 2.649l2.165-.09L3.082 0l.916 2.56H6.16L4.564 4.301l.8 2.435L3.081 5.38z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="CF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v3.75H0V0z" fill="#3D58DB" />
        <path d="M0 3.75h20V7.5H0V3.75z" fill="#F7FCFF" />
        <path d="M0 7.5h20v3.75H0V7.5z" fill="#73BE4A" />
        <path d="M0 11.25h20V15H0v-3.75z" fill="#FFD018" />
        <path
          d="M2.83 3.385L1.317 4.436l.484-1.8-1.113-1.15 1.507-.062.637-1.78.637 1.78h1.504l-1.11 1.212.556 1.694-1.587-.945z"
          fill="#FECA00"
        />
        <path d="M8 0h4v15H8V0z" fill="#E11C1B" />
      </g>
    </symbol>
    <symbol id="CG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M20 0v15H0L20 0z" fill="#FA1111" />
        <path d="M0 15V0h20L0 15z" fill="#07A907" />
        <path
          d="M18.432-3.625L-.625 14.735l3.782 1.883L21.65-.133l-3.218-3.493z"
          fill="#FBCD17"
        />
      </g>
    </symbol>
    <symbol id="CH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.25 3.75h-2.5v2.5h-2.5v2.5h2.5v2.5h2.5v-2.5h2.5v-2.5h-2.5v-2.5z"
            fill="#F1F9FF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="CI" width="20" height="15" fill="none">
      <g
        mask="url(#CI_-_Côte_d'Ivoire_(Ivory_Coast)__a)"
        fill-rule="evenodd"
        clip-rule="evenodd"
      >
        <path d="M13.75 0H20v15h-6.25V0z" fill="#67BD38" />
        <path d="M0 0h6.25v15H0V0z" fill="#E47E00" />
        <path d="M6.25 0h7.5v15h-7.5V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="CK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.907 9.284l.662-.461.641.461-.2-.82.516-.521h-.655l-.303-.67-.258.67h-.768l.588.52-.223.821zm1.758.787l.662-.462.391.282-.125.326h-.768l.588.52-.11.401-.075-.169-.258.67h-.768l.588.52-.224.822.663-.462.64.462-.199-.821.515-.52h-.655l-.11-.242.432-.3.64.461-.199-.821.515-.52h-.655l-.302-.67-.006.015-.076-.313.515-.52h-.655l-.303-.67-.258.67H16.3l.588.52-.223.82zm-1.029 3.227l-.662.462.223-.822-.535-.473.131.54-.64-.461-.663.461.224-.82-.589-.521h.769l.052-.135-.585-.421-.663.461.224-.82-.588-.521h.768l.258-.67.036.078.097-.357-.588-.52h.768l.258-.67.302.67h.655l-.515.52.2.82-.641-.46-.408.283.138.306h.655l-.514.52.171.707.178-.461.302.67h.655l-.515.52.057.234h.726l.258-.67.302.67h.655l-.514.52.199.822-.641-.462z"
            fill="#fff"
          />
        </g>
      </g>
    </symbol>
    <symbol id="CL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h9v9H0V0z" fill="#3D58DB" />
        <path d="M8.75-1.25H20v10H8.75v-10z" fill="#F7FCFF" />
        <path d="M0 8h20v7H0V8z" fill="#E31D1C" />
        <path
          d="M4.384 5.615l-2.377 1.42L3.18 4.618l-2.078-1.57 2.399-.025.905-2.142.582 2.142 2.27.01L5.532 4.57l.896 2.465-2.044-1.42z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="CM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M6 0h8v15H6V0z" fill="#E11C1B" />
        <path
          d="M10.047 9.056L7.87 10.568l.696-2.589-1.6-1.653 2.166-.09.916-2.558.916 2.559h2.162L11.53 7.979l.799 2.436-2.282-1.359z"
          fill="#FECA00"
        />
        <path d="M14 0h6v15h-6V0z" fill="#FBCD17" />
        <path d="M0 0h6v15H0V0z" fill="#0B9E7A" />
      </g>
    </symbol>
    <symbol id="CN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#E31D1C" />
        <path
          d="M4.446 6.097L2.013 8.004l.93-2.884-1.624-1.5 2.198-.08.93-2.322.929 2.321h2.193L5.95 5.12l.738 2.884-2.242-1.907zm4.939-2.24l-1.02.617.232-1.203-.85-.9 1.151-.049.487-1.123.487 1.123h1.15l-.849.949.256 1.203-1.044-.617z"
          fill="#FECA00"
        />
        <path
          d="M10.635 6.357l-1.02.617.232-1.203-.85-.9 1.151-.049.487-1.123.487 1.123h1.15l-.849.949.256 1.203-1.044-.617z"
          fill="#FECA00"
        />
        <path
          d="M9.385 8.857l-1.02.617.232-1.203-.85-.9 1.151-.049.487-1.123.487 1.123h1.15l-.849.949.256 1.203-1.044-.617z"
          fill="#FECA00"
        />
        <path
          d="M6.885 10.107l-1.02.617.232-1.203-.85-.9 1.151-.049.487-1.123.487 1.123h1.15l-.849.949.256 1.203-1.044-.617z"
          fill="#FECA00"
        />
      </g>
    </symbol>
    <symbol id="CO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v7h20V0H0z" fill="#FECA00" />
          <path d="M0 11v4h20v-4H0z" fill="#E31D1C" />
        </g>
      </g>
    </symbol>
    <symbol id="CR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M0 5h-1v5h22V5H0z"
            fill="#E31D1C"
            stroke="#F7FCFF"
            stroke-width="2"
          />
        </g>
      </g>
    </symbol>
    <symbol id="CU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3D58DB"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M0 5h-1.25v5h22.5V5H0z"
            fill="#3D58DB"
            stroke="#F7FCFF"
            stroke-width="2.5"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l11.25-7.5L0 0z"
          fill="#E31D1C"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15l11.25-7.5L0 0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.18 8.886l-2.295 1.21 1.117-2.433-1.424-1.3 1.758-.065.844-2.2.644 2.2h1.754l-1.17 1.365.931 2.434-2.16-1.211z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="CV" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#4141DB"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M0 8.125h-.625v2.5h21.25v-2.5H0z"
            fill="#F90000"
            stroke="#F7FCFF"
            stroke-width="1.25"
          />
          <g filter="url(#CV_-_Cabo_Verde__filter0_d)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.119 6.32l.53-.37.597.43-.009.032.027-.019.027.02-.008-.033.617-.43.596.43-.009.032.027-.019.027.02-.008-.033.617-.43.514.37h-.291l.588.521-.224.821.663-.461.514.37h-.291l.588.52-.199.73h-.39l.589.52-.199.73h-.39l.589.52-.199.73h-.311l-.302-.67-.258.67h-.768l.588.52-.199.73h-.311l-.302-.67-.258.67h-.69l-.302-.67-.258.67h-.69l-.302-.67-.258.67h-.373l-.177-.73.515-.52h-.655l-.302-.67-.258.67h-.373l-.177-.73.515-.52h-.338l-.177-.73.515-.52h-.338l-.177-.73.515-.52H3.87l.53-.37.642.461-.2-.821.515-.52H5.12zm-.107 0l.199-.729-.588-.52h.768l.258-.67.302.67h.69L6.9 4.4l.302.67h.689l.258-.67.302.67h.655l-.515.52.177.73h.373l.258-.67.302.67h.655l-.515.52.177.73h.373l.258-.67.302.67h.655l-.515.52.177.73h.338l-.515.52.177.73h.338l-.515.52.2.821-.641-.461-.531.37h.237l-.515.52.2.821L9.4 12.2l-.531.37h.237l-.515.52.2.821-.641-.461-.617.43.008.031-.027-.019-.027.02.01-.033-.597-.43-.617.43.008.032-.027-.019-.027.02.01-.033-.597-.43-.663.462.224-.821-.588-.52h.29L4.4 12.2l-.663.461.224-.821-.588-.52h.29l-.513-.37-.663.461.224-.821-.588-.52h.39l.198-.73-.588-.52h.39l.198-.73-.588-.52h.768l.258-.67.302.67h.311l.199-.73-.588-.52h.768l.258-.67.302.67h.311zM3.35 8.595l.315.227H3.45l-.102-.227zm-.73.227l.372-.26-.1.26H2.62zm0 1.25h.272l.1-.26-.372.26zm.73-.227l.102.227h.213l-.315-.227zm2.742 3.247l.173-.174.197.174-.195.718-.175-.718zm1.425.718l.195-.718-.197-.174-.173.174.175.718zm2.875-3.738h-.272l.372-.26-.1.26zm.56 0l-.102-.227.315.227h-.213zm.213-1.25l-.315-.227.102.227h.213zm-.673-.26l-.372.26h.272l.1-.26zm-2.78-2.97l-.195.718-.175-.718.173-.174.197.174zm-1.447-.174l-.173.174.175.718.195-.718-.197-.174z"
              fill="#FFDE00"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="CV_-_Cabo_Verde__filter0_d"
          x="-.877"
          y="1.401"
          width="15.483"
          height="15.512"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="CW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M2.659 3.843L1.416 4.5l.6-1.167-.766-.855.952-.035.457-1.192.349 1.192 1.114.035-.802.855.509 1.167-1.17-.656zm4.436 3.08l-1.534.642.602-1.61-1.334-1.08h1.598l.668-1.742.51 1.742h1.6l-1.137 1.08.565 1.61-1.538-.642z"
            fill="#F7FCFF"
          />
          <path d="M0 8.75v2.5h20v-2.5H0z" fill="#F9E813" />
        </g>
      </g>
    </symbol>
    <symbol id="CX" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#5EAA22" />
        <path d="M0 0l20 15H0V0z" fill="#4141DB" />
        <path
          d="M3.75 5.625l-.625.458.084-.77L2.5 5l.709-.313-.084-.77.625.458.625-.458-.084.77L5 5l-.709.313.084.77-.625-.458zM2.5 9.375l-.625.458.084-.77-.709-.313.709-.313-.084-.77.625.458.625-.458-.084.77.709.313-.709.313.084.77-.625-.458zm2.5 3.75l-.625.457.084-.77-.709-.312.709-.313-.084-.77.625.458.625-.457-.084.77.709.312-.709.313.084.77L5 13.124zm.625-5.937l-.313.228.042-.385L5 6.875l.354-.156-.042-.385.313.229.313-.23-.042.386.354.156-.354.156.042.385-.313-.229z"
          fill="#fff"
        />
        <path
          d="M13.476 7.64c-.234-.244 1.869-.816 2.086-1.555.29-.643.096-1.164-.995-1.621-1.091-.458-2.194-1.343-.926-1.343 1.268 0 1.268.181 1.609.715.34.533 1.077.647 1.093 0 0-1.104.104-1.252-.787-2.212-.89-.96 2.234.394 1.976 2.04-.259 1.644-.57 1.113-.372 1.39.197.275 1.385-.582 1.237.56-.416.657-1.24 1.634-4.921 2.026z"
          fill="#FECA00"
        />
        <path
          d="M10 10.625a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25z"
          fill="#FECA00"
        />
        <path
          d="M8.096 6.351c.354-.079.839.87 1.714.514.874-.356 1.057-1.035 1.473-.786.415.248.47.847.193 1.148-.277.301-.747.372-.747.753 0 .38-.092 1.737-.271 1.344-.539-.437-.21-1.133-.874-1.344-.663-.211-1.066-.204-1.555-.115-.49.089.329-.245.502-.562.353-.34-.597-.839-.435-.952z"
          fill="#548650"
        />
      </g>
    </symbol>
    <symbol id="CY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M15.355 2.974s-3.302 1.824-3.717 1.94c-.416.115-.139.184-.854.138-.716-.046-2.124.258-2.447.05-.324-.208-.44-.577-.462.046-.023.623.485 1.154-.162 1.2-.646.047-.715-.554-1.154-.184-.438.37-.808 1.2-1.085.992-.277-.207-.67-.761-.554-.23.115.53.462 1.868 1.57 1.89 1.108.024 1.339-.368 1.385-.045.046.323.53.369.646-.047.116-.415 1.062.464 1.57.025.508-.438.923-.808 1.085-1.062.162-.254.716-.207 1.247-.207.53 0 1.315.23.9-.277-.415-.508-1.131-.74-.716-1.247.416-.508 3.942-2.197 4.104-2.381.162-.185-.872-.877-1.356-.6z"
            fill="#F57A01"
          />
          <path
            d="M15.355 2.974s-3.302 1.824-3.717 1.94c-.416.115-.139.184-.854.138-.716-.046-2.124.258-2.447.05-.324-.208-.44-.577-.462.046-.023.623.485 1.154-.162 1.2-.646.047-.715-.554-1.154-.184-.438.37-.808 1.2-1.085.992-.277-.207-.67-.761-.554-.23.115.53.462 1.868 1.57 1.89 1.108.024 1.339-.368 1.385-.045.046.323.53.369.646-.047.116-.415 1.062.464 1.57.025.508-.438.923-.808 1.085-1.062.162-.254.716-.207 1.247-.207.53 0 1.315.23.9-.277-.415-.508-1.131-.74-.716-1.247.416-.508 3.942-2.197 4.104-2.381.162-.185-.872-.877-1.356-.6z"
            fill="url(#CY_-_Cyprus__paint0_linear)"
          />
          <path
            d="M6.82 10.065c1.639 0 3.047 1.824 3.047 1.824l.066.069.066-.07s1.642-1.823 3.281-1.823c1.64 0-1.18 2.655-3.004 2.655 0 0-.188-.017-.343-.095a1.1 1.1 0 01-.343.095c-1.823 0-4.41-2.655-2.77-2.655z"
            fill="#006B49"
          />
          <path
            d="M6.82 10.065c1.639 0 3.047 1.824 3.047 1.824l.066.069.066-.07s1.642-1.823 3.281-1.823c1.64 0-1.18 2.655-3.004 2.655 0 0-.188-.017-.343-.095a1.1 1.1 0 01-.343.095c-1.823 0-4.41-2.655-2.77-2.655z"
            fill="url(#CY_-_Cyprus__paint1_linear)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="CY_-_Cyprus__paint0_linear"
          x1="18.75"
          y1="11.25"
          x2="18.75"
          y2="1.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EA5113" />
          <stop offset="1" stop-color="#FC9B58" />
        </linearGradient>
        <linearGradient
          id="CY_-_Cyprus__paint1_linear"
          x1="13.774"
          y1="12.72"
          x2="13.774"
          y2="10.065"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#008057" />
          <stop offset="1" stop-color="#00B77C" />
        </linearGradient>
      </defs>
    </symbol>
    <symbol id="CZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0-1.25V7.5h20v-8.75H0z"
            fill="#F7FCFF"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l11.25-7.5L0 0z"
          fill="#3D58DB"
        />
      </g>
    </symbol>
    <symbol id="DE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 10h20v5H0v-5z" fill="#FFD018" />
        <path d="M0 5h20v5H0V5z" fill="#E31D1C" />
        <path d="M0 0h20v5H0V0z" fill="#272727" />
      </g>
    </symbol>
    <symbol id="DJ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#73BE4A"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0-1.25V7.5h20v-8.75H0z"
            fill="#69F"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l11.25-7.5L0 0z"
          fill="#fff"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15l11.25-7.5L0 0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.376 8.794l-1.17.706.268-1.377L2.5 7.092l1.318-.056.558-1.286.558 1.286H6.25l-.971 1.087L5.57 9.5l-1.195-.706z"
            fill="#E31D1C"
          />
        </g>
      </g>
    </symbol>
    <symbol id="DK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#C51918"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 0h3v6h11v3H9v6H6V9H0V6h6V0z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="DM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#279E19"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M10 0h1.25v8.75H20V10h-8.75v5H10v-5H0V8.75h10V0z"
            fill="#F7FCFF"
          />
          <path
            d="M8.75 0H10v7.5h10v1.25H10V15H8.75V8.75H0V7.5h8.75V0z"
            fill="#272727"
          />
          <path
            d="M7.5 0h1.25v6.25H20V7.5H8.75V15H7.5V7.5H0V6.25h7.5V0z"
            fill="#FECA00"
          />
          <path
            d="M10 12.5a5 5 0 100-10 5 5 0 000 10z"
            fill="#C51918"
          />
          <path
            d="M9.204 5.258s.237-.77.789-.372c.865.426 1.15.915 1.484 1.47.334.554-.819.148-1.034-.164-.215-.312-1.408-.413-1.24-.674.17-.26 0-.26 0-.26z"
            fill="#804BFF"
          />
          <path
            d="M9.008 9.203s-.587.804 0 .804 2.969-.173 2.683-.402c-.285-.229-2.4 0-2.4 0l-.283-.402z"
            fill="#A95601"
          />
          <path
            d="M9.886 9.178c-.06-.069-1.13-2.497-.633-3.002.497-.504.789-.208.789.55 0 .756.03 2.64-.156 2.452z"
            fill="#804BFF"
          />
          <path
            d="M9.823 8.784s-.061.59.242 1.28c.304.688.917.675.917.111 0-.564.447-.035.619.342.172.376-.273-3.343-.905-4.174-.63-.832-1.24-.886-1.056-.348.183.537.183 2.789.183 2.789z"
            fill="#279E19"
          />
          <path
            d="M9.455 4.75s-.268.171-.268.643.633-.146.633-.146l-.365-.497zm.056-.18l.552-.289.55.29-.105-.614.446-.434-.616-.09-.275-.558-.276.558-.616.09.446.434-.106.614zm0 7.376l.552-.29.55.29-.105-.614.446-.434-.616-.09-.275-.558-.276.558-.616.09.446.434-.106.614zm4.052-3.79l-.552.29.106-.614-.446-.434.616-.09.275-.558.276.558.616.09-.446.434.106.614-.552-.29zm-7.571-.324l-.106.614.552-.29.55.29-.105-.614.446-.434-.616-.09-.275-.558-.276.558-.616.09.446.434zm1.8-2.393l-.174.597-.368-.502-.623.02.364-.506-.21-.586.593.19.492-.381.003.622.515.35-.592.196zm5.131 5.473l.175-.597.59-.195-.514-.35-.003-.623-.492.38-.593-.189.21.586-.363.505.622-.018.368.502zm.088-5.546l-.174.598-.368-.502-.623.018.364-.505-.21-.586.593.19.492-.381.003.622.514.35-.59.196zm-5.248 5.723l.175-.598.591-.195-.514-.35-.003-.623-.493.38-.593-.189.21.586-.363.506.622-.02.368.503z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="DO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#C51918"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.75 0h2.5v6.25H20v2.5h-8.75V15h-2.5V8.75H0v-2.5h8.75V0z"
            fill="#F7FCFF"
          />
          <path
            fill="#4257BF"
            d="M0 0h8.75v6.25H0zm11.25 8.75H20V15h-8.75z"
          />
          <path
            d="M8.523 6.944l.622.06c-.106 1.112.032 1.581.257 1.581v.625c-.778 0-1.018-.814-.879-2.266zm2.994 0l-.622.06c.106 1.112-.032 1.581-.257 1.581v.625c.777 0 1.018-.814.879-2.266z"
            fill="#309404"
          />
          <path
            fill="#003994"
            d="M9.205 6.683h.591v.923h-.591zm.909 1.096h.59v.468a.455.455 0 01-.454.455h-.136v-.923z"
          />
          <path
            fill="#DE2110"
            d="M10.068 6.625h.591v.923h-.591zm-.863 1.154h.59v.923H9.66a.455.455 0 01-.454-.455V7.78z"
          />
          <path
            d="M8.959 6.63l-.418-.464c.441-.397.902-.604 1.375-.604.474 0 .934.207 1.376.604l-.418.465c-.335-.301-.652-.444-.958-.444-.305 0-.623.143-.957.444z"
            fill="#00319C"
          />
          <path
            d="M9.004 9.746l-.418-.464c.442-.398.902-.604 1.376-.604.474 0 .934.206 1.375.604l-.418.464c-.334-.3-.652-.443-.957-.443-.306 0-.623.142-.958.443z"
            fill="#DE2110"
          />
        </g>
      </g>
    </symbol>
    <symbol id="DZ" width="20" height="15" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0h10v15H10V0z"
        fill="#F7FCFF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0h10v15H0V0z"
        fill="#36A400"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.637 3.908c.9 0 1.739.247 2.441.673a5.322 5.322 0 10-.302 7.222 4.724 4.724 0 01-2.139.505c-2.482 0-4.494-1.88-4.494-4.2 0-2.32 2.012-4.2 4.494-4.2zm1.76 1.608l-1.292 1.465-1.857-.511 1.03 1.61-1.03 1.713 1.948-.7 1.064 1.66V8.826L15 8.08l-1.74-.623.137-1.94z"
        fill="red"
      />
    </symbol>
    <symbol id="EC" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v7.5h20V0H0z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 11.25V15h20v-3.75H0z"
            fill="#E31D1C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.758 3.62c-.075-.17 2.82-1.029 3.036-1.029.217 0 .491.515.491.515l1.76.142s-.208-.657 0-.657 3.395 1.107 3.395 1.107-3.984.48-3.984.589c0 .108.261.701.261.701l-.736.242s.043-.716-.077-.716-.477.856-.477.856l-.35-1.083S5.833 3.79 5.758 3.62z"
            fill="#7B2900"
          />
          <path
            d="M5.77 6.261l.788.189c-.824 3.447-.062 5.1 2.284 5.254l-.053.809C5.85 12.32 4.843 10.138 5.77 6.26z"
            fill="#FECA00"
          />
          <path
            d="M6.25 5.796l.8.126c-.564 3.608-.112 5.24 1.156 5.194l.028.81c-2.025.071-2.619-2.072-1.984-6.13z"
            fill="#07138E"
          />
          <path
            d="M7.06 5.466l.8.125c-.564 3.608-.112 5.24 1.156 5.195l.028.81c-2.024.07-2.619-2.073-1.984-6.13z"
            fill="#E10001"
          />
          <path
            d="M8.564 12.046l.806-.079c.067.683.016 1.272-.157 1.766l-.764-.267c.13-.373.17-.847.115-1.42z"
            fill="#07138E"
          />
          <path
            d="M13.437 6.355s1.292 5.808-2.687 5.708"
            stroke="#FECA00"
            stroke-width=".81"
          />
          <path
            d="M13.351 5.796l-.8.126c.565 3.608.113 5.24-1.155 5.194l-.028.81c2.024.071 2.618-2.072 1.983-6.13z"
            fill="#07138E"
          />
          <path
            d="M12.541 5.466l-.8.125c.565 3.608.112 5.24-1.155 5.195l-.029.81c2.025.07 2.62-2.073 1.984-6.13z"
            fill="#E10001"
          />
          <path
            d="M10.88 12.05l-.805-.087c-.068.623-.016 1.164.161 1.618l.755-.294c-.126-.323-.165-.734-.11-1.237z"
            fill="#07138E"
          />
          <path fill="#908F89" d="M8.667 10.938h2.431v1.158H8.667z" />
          <path
            d="M9.882 11.25c.685 0 1.277-.386 1.686-.954.409-.567.652-1.336.652-2.171 0-.835-.243-1.604-.652-2.171-.409-.568-1-.954-1.686-.954-.685 0-1.277.386-1.686.954-.409.567-.652 1.336-.652 2.171 0 .835.243 1.604.652 2.171.409.568 1 .954 1.686.954z"
            stroke="#FEE901"
            stroke-width=".625"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="7"
            y="4"
            width="6"
            height="8"
          >
            <path
              d="M9.882 11.25c.685 0 1.277-.386 1.686-.954.409-.567.652-1.336.652-2.171 0-.835-.243-1.604-.652-2.171-.409-.568-1-.954-1.686-.954-.685 0-1.277.386-1.686.954-.409.567-.652 1.336-.652 2.171 0 .835.243 1.604.652 2.171.409.568 1 .954 1.686.954z"
              fill="#fff"
              stroke="#fff"
              stroke-width=".625"
            />
          </mask>
          <g mask="url(#c)" fill-rule="evenodd" clip-rule="evenodd">
            <path
              d="M11.349 9.628s-.985-.536-1.268-.727c-.282-.19-.119-.617-.606-.503-.486.114-.877.312-.877.856s-.383.867-.513.495c-.13-.371-.743-2.109 0-2.109s2.479.39 2.99.39c.51 0 .808.265.808.745 0 .644-.534.853-.534.853z"
              fill="#8DDD61"
            />
            <path
              d="M9.882 6.801a.41.41 0 00.405-.413.41.41 0 00-.405-.414.41.41 0 00-.405.414.41.41 0 00.405.413z"
              fill="#FEE901"
            />
            <path
              d="M8.543 6.838s.472-.114 1.123.325c.65.438 2.23.688 2.23.344v.67s-3.503-.217-3.69 0c-.188.219-.207-1.217 0-1.34.205-.121.337 0 .337 0z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="EE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#40A8FF" />
          <path d="M0 5v5h20V5H0z" fill="#272727" />
        </g>
      </g>
    </symbol>
    <symbol id="EG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#BF2714"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#272727"
          />
          <path
            d="M7.663 6.388l.624.028-.157 3.419-.624-.029.157-3.418zm.652.212l.624.035-.157 2.772-.624-.035.157-2.772z"
            fill="#C09302"
          />
          <path
            d="M8.968 6.807l.623.052-.157 1.91-.623-.052.157-1.91zm3.369-.419l-.624.028.157 3.419.624-.029-.157-3.418zm-.652.212l-.624.035.157 2.772.624-.035-.157-2.772z"
            fill="#C09302"
          />
          <path
            d="M11.032 6.807l-.623.052.157 1.91.623-.052-.157-1.91zM9.983 9.58l-.609-.14.258-1.126.61.14-.259 1.125z"
            fill="#C09302"
          />
          <path
            d="M10.45 9.58l.609-.14-.258-1.126-.61.14.259 1.125z"
            fill="#C09302"
          />
          <path
            d="M10.295 9.569H9.67V8.464h.625v1.105zM9.147 6.82l.625.016-.037 1.488-.625-.015.037-1.488zm1.087 0l.624.016-.036 1.488-.625-.015.037-1.488z"
            fill="#C09302"
          />
          <path
            d="M8.336 9.952l.163-.604c.663.179 1.172.267 1.52.267.346 0 .855-.088 1.519-.267l.162.604c-.711.191-1.27.288-1.682.288-.412 0-.97-.097-1.682-.288zm-.66-3.562c-.041-.414.2-.693.61-.658.135.012.286.052.487.12l.116.04c.277.1.353.125.368.128-.061-.014.12-.34.16-.396.006.035-.015.03-.065.02l-.564-.113.402-.411a.732.732 0 01.54-.216c.022 0 .043 0 .11-.005l.107-.005c.39-.013.67.098.67.499 0 .143.017.374.047.549.01.059.03.114-.027.138.002-.02.138-.075.35-.164l.026-.01c.618-.258.69-.282.889-.16.132.08.258.225.4.44l-.523.343a1.09 1.09 0 00-.198-.248c.078.055-.187.143-.327.201l-.025.011c-.48.2-.544.225-.681.225-.374 0-.508-.383-.545-.932-.115.38-.46.86-.743.86-.124 0-.065.019-.58-.164l-.107-.038a1.682 1.682 0 00-.34-.089.284.284 0 01.025-.024l-.582.058z"
            fill="#C09302"
          />
        </g>
      </g>
    </symbol>
    <symbol id="EH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#F7FCFF" />
        <path d="M0 0v5h20V0H0z" fill="#272727" />
        <path d="M0 10v5h20v-5H0z" fill="#5EAA22" />
        <path
          d="M0 0l10 7.5L0 15V0zm13.555 9.673s-1.422-.859-1.422-2.279 1.422-2.167 1.422-2.167c-.636-.404-2.843.173-2.843 2.213 0 2.041 2.186 2.418 2.843 2.233zm1.15-2.603l-.827-.775.286.99-.801.38.983.32.428 1.07.186-.991.972.214-.735-.717.248-.766-.74.275z"
          fill="#E31D1C"
        />
      </g>
    </symbol>
    <symbol id="ER" width="21" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="15">
        <path fill="#fff" d="M0 0h21.25v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0v7.5h20.25V0H0z" fill="#43B764" />
        <path d="M0 7.5V15h20.25V7.5H0z" fill="#B4D7F4" />
        <path d="M0 0l20.875 7.5L0 15V0z" fill="#BE0027" />
        <path
          d="M5.063 11.572a.78.78 0 01.304-.192 16.31 16.31 0 00-.022-1.246c-.033-.049-.09-.09-.19-.09-.25 0-.8-.214-.8-.521 0 0 .41.185.525.092.048-.04-.079-.161-.232-.309-.207-.199-.462-.444-.4-.596 0 0 .402.356.487.356.04 0 .013-.115-.014-.231-.032-.138-.064-.277.014-.223.145.098.545.778.545 1.003 0 .122.032.315.062.465v-.005a7.477 7.477 0 00-.073-.69c-.18-1.125-.186-2.278.064-2.891-.125-.078-.216-.176-.216-.29 0 0 .41.167.524.084.048-.035-.078-.145-.232-.278-.207-.179-.461-.4-.4-.536 0 0 .402.32.488.32.039 0 .012-.104-.015-.208-.032-.124-.064-.249.015-.2.144.088.544.7.544.902v.005c.156-.193.337-.372.432-.417.102-.048.06.076.019.2-.035.105-.07.208-.02.208.112 0 .634-.32.634-.32.08.137-.25.357-.52.536-.199.133-.364.243-.3.278.148.084.68-.083.68-.083 0 .277-.714.469-1.038.469-.121 0-.194.032-.238.072a5.568 5.568 0 00-.03.641c.162-.209.364-.414.467-.463.102-.048.06.077.019.2-.035.105-.07.209-.019.209.112 0 .634-.32.634-.32.08.136-.251.357-.52.536-.2.132-.365.242-.301.278.148.083.68-.084.68-.084 0 .246-.564.425-.917.462.02.202.046.407.078.61a10.47 10.47 0 01.096 1.094c.016-.1.027-.198.027-.271 0-.225.4-.905.545-1.003.079-.054.046.085.014.223-.026.115-.053.23-.014.23.086 0 .487-.355.487-.355.062.152-.193.397-.4.596-.153.147-.28.27-.231.309.114.092.524-.093.524-.093 0 .308-.55.521-.8.521a.234.234 0 00-.146.044c.007.264.007.527.003.777a.783.783 0 01.324.207c.16-.01.319-.035.474-.073.3-.165.965-.697 1.133-.906.127-.158.176-.47.222-.765.026-.168.052-.331.09-.457.107-.344.296.42.296.538 0 .119.155-.44.155-.833 0-.197-.039-.323-.078-.45a1.345 1.345 0 01-.077-.445c0-.23.134-.189.258-.07a1.631 1.631 0 01-.103-.548c0-.254-.032-.33-.046-.35.013.006.046.01.116-.029.12-.065.176.015.223.082.041.059.075.107.139.04.07-.073-.08-.156-.305-.28-.215-.118-.498-.274-.717-.494-.448-.45.14-.604.24-.447.1.157.697.333.35-.189-.211-.317-.471-.313-.708-.31-.153.003-.296.005-.41-.079-.195-.146.078-.296.227-.378.07-.039.114-.062.064-.062a1.01 1.01 0 01-.24-.05 1.796 1.796 0 00-.49-.084c-.318 0-.945-.284-.728-.284.077 0 .191-.027.317-.058.138-.033.29-.069.42-.076a7.252 7.252 0 00-1.307-.445l.083-.332c.486.12.923.266 1.31.44a6.928 6.928 0 01-.199-.319c-.208-.362.44.2.697.573l.001.001a3.85 3.85 0 011.033.849V4.56c.243.083.38.867.453 1.457.053.118.099.24.137.367.094-.251.272-.519.433-.287.19.275-.147 1.838-.27 2.378a5.462 5.462 0 01-.02.169c.296-.188.45-.623.528-.846.068-.192.08-.226.08.191 0 .54-.42 1.074-.764 1.421-.05.171-.108.337-.175.5.237-.076.44-.207.597-.309.276-.178.411-.266.342.201-.076.51-.815.697-1.28.766a4.725 4.725 0 01-.104.16l-.02.024a5.164 5.164 0 01-.218.208l.136-.06c.182-.082.347-.157.556-.157.126 0-.047.066-.29.159-.29.11-.678.258-.792.382a1.482 1.482 0 00-.104.126c-.074.1-.097.13-.33.136a3.26 3.26 0 01-1.127.361.836.836 0 01.035.098H4.808s.013-.048.044-.117a3.276 3.276 0 01-.992-.341h-.026c-.356 0-.373-.022-.46-.137a1.48 1.48 0 00-.103-.127c-.114-.123-.503-.271-.791-.381-.244-.093-.417-.16-.29-.16.208 0 .373.076.555.158.057.026.116.053.179.078.059.024.138.053.225.084a5.036 5.036 0 01-.334-.31l-.02-.024a4.638 4.638 0 01-.091-.14c-.43-.047-1.351-.214-1.436-.786-.07-.467.066-.38.342-.201.166.107.383.248.637.32l.123.033a4.612 4.612 0 01-.133-.349c-.35-.314-.97-.961-.97-1.616.001-.417.013-.383.08-.19.082.228.241.68.553.86 0 0-.545-2.228-.314-2.562.232-.334.5.37.5.57 0 .034.004-.004.011-.09.037-.406.172-1.9.512-2.017v.808c0 .037.016.052.046.048.226-.298.512-.565.856-.798.051-.064.096-.123.131-.174.257-.372.905-.935.698-.573-.062.109-.138.224-.206.33l-.057.088a7.345 7.345 0 011.518-.539l.083.332a7.204 7.204 0 00-1.334.458c.1.015.205.04.303.063.126.03.24.058.317.058.217 0-.41.284-.728.284-.187 0-.353.046-.49.084a1.01 1.01 0 01-.24.05c-.05 0-.007.023.064.062.149.082.422.232.226.378-.114.084-.257.082-.41.08-.168-.003-.35-.006-.516.109-.112.16-.206.33-.28.511.075.1.371-.016.44-.122.1-.157.687-.003.239.447-.22.22-.502.376-.717.494a4.55 4.55 0 00-.185.106 7.126 7.126 0 00-.019.183.427.427 0 00.038-.049c.046-.067.102-.147.223-.082.07.038.103.035.116.03-.014.018-.046.095-.046.35 0 .199-.047.391-.104.547.125-.119.26-.16.26.07 0 .195-.04.32-.078.446a1.368 1.368 0 00-.078.449c0 .392.155.952.155.833s.189-.882.295-.538c.04.126.065.289.09.457.047.295.096.607.223.765.146.182.665.606.996.823.204.072.412.12.625.144zM2.73 7.22s-.003 0-.006.005c.004-.002.006-.004.006-.005zm5.803.005c-.003-.005-.006-.006-.006-.005 0 0 .001.003.006.005zm.112 2.746a4.22 4.22 0 00.041-.089c-.035.034-.06.07-.04.089zM5.76 6.843a2.02 2.02 0 01-.056.282c.015-.104.034-.198.056-.282z"
          fill="#F3E294"
        />
      </g>
    </symbol>
    <symbol id="ES" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#FFB400"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v3.75h20V0H0zm0 11.25V15h20v-3.75H0z"
            fill="#C51918"
          />
          <path fill="#F1F9FF" d="M3.13 6.42h.7v3.64h-.7z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.11 5.79H2.85v.35h.21v.28h.84v-.28h.21v-.35zm-.21 4.48h.21v.35H2.85v-.35h.21v-.28h.84v.28z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.48 5.86c.152 0 .168-.057.258-.143.07-.067.232-.15.232-.242 0-.213-.22-.385-.49-.385s-.49.172-.49.385c0 .104.112.173.197.242.089.073.154.143.293.143z"
            fill="#AD1619"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.85 10.62h1.26v.56s-.157-.07-.315-.07c-.157 0-.315.07-.315.07s-.157-.07-.315-.07a.898.898 0 00-.315.07v-.56z"
            fill="#005BBF"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="2"
            y="10"
            width="3"
            height="2"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.85 10.62h1.26v.56s-.157-.07-.315-.07c-.157 0-.315.07-.315.07s-.157-.07-.315-.07a.898.898 0 00-.315.07v-.56z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)" fill="#fff">
            <path
              d="M2.839 11.07l-.028-.067a.834.834 0 01.342-.076.37.37 0 01.177.04.306.306 0 00.15.033.306.306 0 00.15-.034.37.37 0 01.178-.039c.114 0 .228.025.341.076l-.027.067a.767.767 0 00-.314-.07.306.306 0 00-.15.034.37.37 0 01-.178.039.37.37 0 01-.177-.04.306.306 0 00-.15-.033.767.767 0 00-.314.07zm0-.21l-.028-.067a.834.834 0 01.342-.076.37.37 0 01.177.04.306.306 0 00.15.033.306.306 0 00.15-.034.37.37 0 01.178-.039c.114 0 .228.025.341.076l-.027.067a.767.767 0 00-.314-.07.306.306 0 00-.15.034.37.37 0 01-.178.039.37.37 0 01-.177-.04.306.306 0 00-.15-.033.767.767 0 00-.314.07z"
            />
          </g>
          <path fill="#F1F9FF" d="M9.99 6.42h.7v3.64h-.7z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.97 5.79H9.71v.35h.21v.28h.84v-.28h.21v-.35zm-.21 4.48h.21v.35H9.71v-.35h.21v-.28h.84v.28z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.34 5.86c.152 0 .168-.057.258-.143.07-.067.232-.15.232-.242 0-.213-.22-.385-.49-.385s-.49.172-.49.385c0 .104.112.173.197.242.089.073.154.143.293.143z"
            fill="#AD1619"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.71 10.62h1.26v.56s-.158-.07-.315-.07-.315.07-.315.07-.158-.07-.315-.07a.89.89 0 00-.315.07v-.56z"
            fill="#005BBF"
          />
          <mask
            id="d"
            maskUnits="userSpaceOnUse"
            x="9"
            y="10"
            width="2"
            height="2"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.71 10.62h1.26v.56s-.158-.07-.315-.07-.315.07-.315.07-.158-.07-.315-.07a.89.89 0 00-.315.07v-.56z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#d)" fill="#fff">
            <path
              d="M9.699 11.07l-.028-.067a.834.834 0 01.342-.076.37.37 0 01.177.04.307.307 0 00.15.033.306.306 0 00.15-.034.371.371 0 01.178-.039c.114 0 .228.025.341.076l-.027.067a.767.767 0 00-.314-.07.307.307 0 00-.15.034.37.37 0 01-.178.039.371.371 0 01-.177-.04.306.306 0 00-.15-.033.767.767 0 00-.314.07zm0-.21l-.028-.067a.834.834 0 01.342-.076.37.37 0 01.177.04.307.307 0 00.15.033.306.306 0 00.15-.034.371.371 0 01.178-.039c.114 0 .228.025.341.076l-.027.067a.767.767 0 00-.314-.07.307.307 0 00-.15.034.37.37 0 01-.178.039.371.371 0 01-.177-.04.306.306 0 00-.15-.033.767.767 0 00-.314.07z"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.117 9.8c.127-.153.197-.292.197-.44a.395.395 0 00-.076-.24l.008-.003s.139-.06.187-.084c.09-.043.17-.089.247-.145a1.93 1.93 0 01.216-.13l.095-.05.026-.013.12-.066a.757.757 0 00.228-.18.335.335 0 00-.077-.499c-.087-.06-.204-.093-.376-.12l-.035-.005-.21-.033a13.234 13.234 0 01-.222-.036c.43-.072 1.045-.046 1.316.094l.256-.498c-.55-.284-1.806-.255-2.274.068-.344.237-.298.595.06.749.15.064.344.107.705.165-.06.035-.11.067-.157.101a.997.997 0 01-.16.093l-.157.07-.02.009c-.291.132-.433.316-.39.647l.023.179.04.012.43.355zm-.36-.463v.003-.003zm7.684.023c0 .148.07.287.197.44l.43-.355.04-.012.024-.18c.042-.33-.1-.514-.39-.646l-.02-.009h-.001a8.57 8.57 0 01-.156-.07 1.001 1.001 0 01-.16-.093 1.78 1.78 0 00-.157-.101c.36-.058.555-.1.705-.165.357-.154.404-.512.06-.75-.469-.322-1.724-.351-2.275-.067l.257.498c.27-.14.885-.166 1.315-.094l-.22.036-.211.033-.036.005c-.172.027-.289.06-.376.12a.335.335 0 00-.077.499.757.757 0 00.23.18c.033.02.07.04.119.066l.025.013.095.05a2.1 2.1 0 01.217.13c.077.056.156.102.246.145l.187.084.009.003a.395.395 0 00-.077.24z"
            fill="#AD1619"
          />
          <path
            d="M3.702 7.75l.207.043V8.1c-.22.175-.779.471-.779.471V7.75h.572zm6.495 0l-.207.043V8.1c.22.175.779.471.779.471V7.75h-.572z"
            fill="#F1F9FF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.235 4.504V4.4c-.36-.258-.737-.387-1.131-.387a2.258 2.258 0 00-1.147-.195v-.002c-.582-.057-1.168.197-1.168.197-.591 0-1.131.387-1.131.387v.103l.706.709s.198.682 1.59.522v.002s.921-.026.986-.047c.026-.009.053-.016.08-.024.18-.053.386-.113.509-.453l.706-.71zM6.954 3.85c-.02.236-.135 1.66 0 1.88V3.85z"
            fill="#AD1619"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.196 5.093v-.002L4.7 4.624l.048-.051.466.439.012-.055a.594.594 0 00.164.019V4.88l.104.056c.05.027.123.035.219.019.07-.011.118-.093.133-.267l.032-.352.105.337c.048.152.12.22.224.22.1 0 .141-.037.146-.13l.012-.265.12.236c.043.085.103.124.187.124.121 0 .202-.1.202-.26h.142c0 .16.08.26.202.26.084 0 .144-.039.187-.124l.12-.236.012.264c.005.094.045.13.146.13.104 0 .176-.067.224-.22l.105-.336.031.352c.016.174.063.256.134.267.096.016.168.008.22-.02L8.5 4.88v.095a.594.594 0 00.164-.02l.022.102.516-.485.048.051-.642.604c-.094.173-.14.286-.14.334 0 .072-.189.115-.555.159a9.025 9.025 0 01-.903.06v.001h-.07a9.024 9.024 0 01-.903-.061c-.367-.044-.554-.087-.554-.16a.147.147 0 00-.005-.033.55.55 0 01-.08-.194 3.518 3.518 0 00-.056-.106L5.2 5.094h-.004zm3.441.012c-.115.02-.197.018-.241-.018a.55.55 0 01-.242.007c-.098-.016-.166-.081-.208-.19a.32.32 0 01-.203.125c.448.063.762.153.762.153s-.008.066-.027.144l.071-.136.007-.009.081-.076zm-1.105-.103a.225.225 0 01-.093-.083.312.312 0 01-.113.064c.07.005.14.012.206.02zm-.453-.033a.32.32 0 01-.134-.117.32.32 0 01-.133.117l.097-.002h.056l.114.002zm-1.69.207l-.065-.061c.078.008.136 0 .17-.028a.55.55 0 00.242.007c.098-.016.166-.081.207-.19a.321.321 0 00.197.124 6.546 6.546 0 00-.751.148zm1.172-.194A6.277 6.277 0 006.362 5a.224.224 0 00.089-.081c.032.028.07.05.11.063zm1.722.581c.05.023.088 0 .12-.044a.226.226 0 00-.005.033.677.677 0 01-.123.04 4.23 4.23 0 01-.37.06c-.297.035-.65.058-.93.06a8.867 8.867 0 01-.93-.06 3.834 3.834 0 01-.37-.06.787.787 0 01-.092-.026.108.108 0 00.008-.003c.153-.071 1.164-.139 1.346-.15.182.011 1.193.079 1.346.15zm.193-.013l-.001.002V5.55h.001z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.945 3.342a.21.21 0 100-.42.21.21 0 000 .42z"
            fill="#005BBF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.809 4.373a.278.278 0 00.02.064.265.265 0 00-.094-.017c-.097 0-.175.047-.175.105 0 .058.078.105.175.105.097 0 .175-.047.175-.105 0 .058.078.105.175.105.097 0 .175-.047.175-.105 0-.058-.078-.105-.175-.105a.278.278 0 00-.069.009.265.265 0 00-.001-.096c-.019-.095-.08-.163-.137-.152-.057.011-.088.097-.07.192zm.101.152v-.003.003zm-1.131-.018a.278.278 0 01-.02-.064c-.019-.095.012-.18.07-.192.056-.01.117.057.136.152a.265.265 0 01.001.096.278.278 0 01.069-.009c.097 0 .175.047.175.105 0 .058-.078.105-.175.105-.097 0-.175-.047-.175-.105v-.003.003c0 .058-.078.105-.175.105-.097 0-.175-.047-.175-.105 0-.058.078-.105.175-.105a.25.25 0 01.094.017zm2.192.064c-.008.057-.092.093-.188.08-.095-.014-.166-.072-.158-.13.008-.056.092-.092.188-.079a.265.265 0 01.09.03.279.279 0 01-.011-.066c-.005-.097.038-.177.096-.18.058-.004.109.072.114.169a.265.265 0 01-.012.095.277.277 0 01.07.001c.095.013.166.07.158.128-.008.058-.092.093-.188.08-.096-.013-.167-.07-.159-.128zm0 0v-.004.004zm.667.277c.085.046.176.041.204-.01l.001-.003a.068.068 0 00.03.019c.055.017.123-.045.151-.137.029-.092.006-.181-.049-.198-.055-.017-.123.044-.152.137a.279.279 0 00-.012.065.265.265 0 00-.075-.058c-.085-.046-.176-.04-.204.01-.027.052.02.13.106.175zm-3.435.022c-.085.045-.177.04-.204-.01l-.001-.004a.068.068 0 01-.03.02c-.055.016-.123-.045-.152-.137-.028-.093-.006-.182.05-.199.055-.016.123.045.151.137a.271.271 0 01.012.066.265.265 0 01.075-.059c.086-.045.177-.04.204.01.027.052-.02.13-.105.176zm1.664-2.322h.146v.092h.095v.146h-.095v.292h.095v.145H6.77v-.145h.097v-.292H6.77V2.64h.097v-.092z"
            fill="#C88A02"
          />
          <path fill="#C88A02" d="M6.84 3.34h.28v.91h-.28z" />
          <path
            d="M5.713 3.492l-.001.07c-.621-.01-.977.08-1.067.26-.094.187-.077.414.054.684l-.063.03c-.14-.287-.158-.536-.054-.745.107-.214.484-.31 1.13-.299z"
            fill="#fff"
          />
          <path
            d="M5.833 4.113l-.036.06c-.135-.08-.203-.218-.203-.408 0-.273.14-.433.452-.542.198-.07.469-.041.813.083l-.023.066c-.331-.12-.587-.147-.767-.083-.285.1-.405.236-.405.476 0 .167.056.28.169.348z"
            fill="#fff"
          />
          <path
            d="M4.788 4.398l-.132.047c-.138-.39-.098-.655.136-.77.206-.1.507-.142.904-.125l-.006.14c-.376-.016-.655.022-.837.111-.154.075-.182.266-.065.597z"
            fill="#C88A02"
          />
          <path
            d="M6.33 3.4c-.32 0-.45.077-.526.307-.048.147-.001.272.15.39l-.087.11c-.194-.152-.263-.337-.196-.543.096-.293.284-.405.66-.405.246 0 .438.065.572.197l.021.02v.675h-.14v-.615c-.104-.09-.254-.137-.453-.137z"
            fill="#C88A02"
          />
          <path
            d="M8.156 3.562v.07c.622-.01.978.08 1.068.26.093.187.076.414-.055.684l.063.03c.14-.287.159-.536.055-.745-.108-.214-.484-.31-1.131-.299z"
            fill="#fff"
          />
          <path
            d="M7.936 4.128l.036.06c.135-.08.203-.219.203-.408 0-.273-.14-.433-.451-.543-.199-.07-.47-.04-.814.084l.024.066c.33-.12.586-.147.767-.084.285.1.404.237.404.477 0 .166-.056.28-.169.348z"
            fill="#fff"
          />
          <path
            d="M9.125 4.468l.132.047c.137-.39.098-.655-.137-.77-.206-.1-.507-.142-.903-.125l.005.14c.376-.016.655.022.837.111.154.075.182.266.066.597z"
            fill="#C88A02"
          />
          <path
            d="M7.573 3.41c.32 0 .452.078.527.308.048.147.001.272-.15.389l.087.11c.195-.15.263-.336.196-.542-.096-.294-.283-.405-.66-.405-.246 0-.438.065-.572.197l-.021.02v.675h.14v-.615c.104-.09.255-.137.453-.137z"
            fill="#C88A02"
          />
          <path
            opacity=".3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.67 5.79h4.55v4.088s-.338 1.372-2.275 1.372c-1.937 0-2.275-1.408-2.275-1.408V5.79z"
            fill="#E1E5E8"
          />
          <mask
            id="e"
            maskUnits="userSpaceOnUse"
            x="4"
            y="5"
            width="6"
            height="7"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.67 5.79h4.55v4.088s-.338 1.372-2.275 1.372c-1.937 0-2.275-1.408-2.275-1.408V5.79z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#e)">
            <path fill="#FFC034" d="M4.67 8.31h2.31v2.73H4.67z" />
            <path
              fill="#AD1619"
              d="M4.95 8.45h.28v2.59h-.28zm.98 0h.28v2.59h-.28zm-.49 0h.28v2.59h-.28zm.98 0h.28v2.59h-.28zM4.67 5.72h2.31v2.66H4.67z"
            />
            <path fill="#AD1619" d="M6.91 8.24h2.31v2.66H6.91z" />
            <path fill="#F1F9FF" d="M6.91 5.79h2.45v2.59H6.91z" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.65 6h.21v.58H6v-.29h.21v.29h.21v.364h-.21v.653h.21v.363H5.16v-.363h.21v-.653h-.21V6.58h.14v-.29h.21v.29h.14V6z"
              fill="#C88A02"
            />
            <path
              d="M8.112 6.122l.143-.154.301.282-.143.153-.301-.281z"
              fill="#C88A02"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.975 10.088V8.555h-1.75v1.52l.003.012c.088.377.39.568.872.568.481 0 .783-.186.872-.555l.003-.012zm-.875.357c-.387 0-.598-.13-.665-.395V8.765h1.33v1.297c-.067.256-.278.383-.665.383z"
              fill="#FFC034"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.172 8.683h-.146v.695l-.574-.625-.104.094.52.566h-.47v.21h.481l-.53.578.103.095.574-.626v.812h.146v-.739l.508.553.103-.095-.531-.578h.593v-.21h-.582l.52-.566-.103-.094-.508.552v-.622z"
              fill="#FFC034"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.427 10.902s-1.483.116-1.483-.84c0 0-.014.84-1.562.84v.755h3.045v-.755z"
              fill="#F1F9FF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.945 8.87c.29 0 .525-.25.525-.56 0-.31-.235-.56-.525-.56-.29 0-.525.25-.525.56 0 .31.235.56.525.56z"
              fill="#005BBF"
              stroke="#AD1619"
              stroke-width=".729"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="ET" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#FECA00"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#5EAA22"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#E31D1C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 11.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
            fill="#2B77B8"
          />
          <path
            clip-rule="evenodd"
            d="M10 8.75l-1.726.58.537-1.444-1.17-1.397h1.624L10 5l.735 1.489h1.66L11.19 7.886l.428 1.443L10 8.75z"
            stroke="#FECA00"
            stroke-width=".938"
          />
          <path
            d="M9.81 7.522l-1.303 2.725m1.098-3.072h-2.5m2.971.849l2.443 1.127m-1.915-1.73l1.769-1.936"
            stroke="#2B77B8"
            stroke-width=".625"
          />
        </g>
      </g>
    </symbol>
    <symbol id="FI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M7 .5h-.5v6h-7v2h7v7h2v-7h12v-2h-12v-6H7z"
            fill="#2E42A5"
            stroke="#2E42A5"
          />
        </g>
      </g>
    </symbol>
    <symbol id="FJ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#67BFE5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5 6.25h6.035v5.208s-.507 2.292-3.018 2.292c-2.511 0-3.017-2.292-3.017-2.292V6.25z"
            fill="#F7FCFF"
          />
          <mask
            id="e"
            maskUnits="userSpaceOnUse"
            x="12"
            y="6"
            width="7"
            height="8"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5 6.25h6.035v5.208s-.507 2.292-3.018 2.292c-2.511 0-3.017-2.292-3.017-2.292V6.25z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#e)">
            <path fill="#C3352C" d="M12.5 6.25h6.034v1.875H12.5z" />
            <path
              fill="#C3352C"
              d="M15.086 7.917h.862v5.833h-.862z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5 10.208h6.035v.834H12.5v-.834z"
              fill="#C3352C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.088 12.96c.363.514.658.714.867.411.147-.212.162-.424-.047-.466a3.509 3.509 0 01-.256-.358l.007-.007c.059-.057.061-.133.05-.162-.005-.038.024-.091.213-.235.17-.13.246-.254.134-.39-.058-.07-.111-.085-.278-.11l-.051-.008a.893.893 0 01-.108-.023l-.116-.222a1.43 1.43 0 00-.639.122l-.19.08a.738.738 0 01-.073.03c.005-.004.013-.01.001-.01-.043 0-.09-.006-.222-.022l-.025-.004c-.378-.047-.472-.045-.533.13-.093.267.457.757.75.816.146.03.321.17.516.429zm.41-.367a.336.336 0 00.087-.008l.007-.016a.164.164 0 01-.094.024zm-1.377-.738c-.007-.009-.01-.02-.004-.036-.001.003.002.01.01.02a.45.45 0 00.032.036.076.076 0 01-.038-.02zm.512.37c-.104-.02-.37-.242-.474-.35a.652.652 0 00.103.016l.054.006.025.003c.147.018.199.024.261.024.037 0 .03.012.025.02-.002.002-.003.004-.002.005.002.004.03-.009.173-.069l.188-.08c.11-.046.211-.077.322-.09.012.052.043.1.093.138.066.051.141.073.27.094-.16.133-.24.243-.266.351-.145.046-.132.209-.045.371.06.114.175.275.345.488l.122.058a.104.104 0 01-.072-.029c-.019-.016-.03-.025-.057.013-.001.002-.115-.075-.358-.417-.238-.318-.47-.504-.707-.551zm.763.188c.002-.002.001-.004.001-.007l-.002.007zm.1-.133h-.01.009zm.002 0h-.003.003z"
              fill="#979797"
            />
            <path
              d="M13.534 10.069s-.298-.413-.298-.56"
              stroke="#964C36"
              stroke-width=".625"
            />
            <path
              d="M13.35 9.714s-.382-.163-.382 0m.375-.171s-.268-.341-.47-.341c-.201 0-.196.17-.196.17m.513-.171s-.12-.558-.311-.558c-.192 0-.192.28-.192.28m.551.277s-.053-.478.194-.478"
              stroke="#2A8E51"
              stroke-width=".625"
            />
            <path
              d="M13.913 9.988s-.139-.49-.089-.628"
              stroke="#964C36"
              stroke-width=".625"
            />
            <path
              d="M13.86 9.592s-.302-.284-.358-.13m.411-.033s-.135-.413-.325-.482c-.189-.069-.243.093-.243.093m.541.015s.079-.565-.101-.63c-.18-.066-.276.196-.276.196m.423.449s.114-.467.345-.383"
              stroke="#2A8E51"
              stroke-width=".625"
            />
            <path
              d="M14.22 10.163s.198-.47.165-.613"
              stroke="#964C36"
              stroke-width=".5"
            />
            <path
              d="M14.32 9.775s.335-.244.372-.085m-.404-.083s.185-.393.381-.438c.197-.045.23.122.23.122m-.539-.051s-.008-.57.178-.614c.187-.043.25.229.25.229m-.475.395s-.056-.478-.296-.423m2.669 1.049s.151-.696.582-.696c.43 0 .623.735.623.735"
              stroke="#2A8E51"
              stroke-width=".5"
            />
            <path
              d="M16.33 9.401s.233-.411.998-.377c.764.033.904.377.904.377m-2.056-.523s.42-.52 1.01-.079l.199.08s.2-.59 1.166 0"
              stroke="#2A8E51"
              stroke-width=".5"
            />
            <path
              d="M17.337 10.023s.03-.65.133-.828m.717 2.251s-.387-.181-.502 0c-.116.182-1.508 1.851-1.508 1.851"
              stroke="#964C36"
              stroke-width=".625"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.853 11.622l.863.603s.397-.283.198-.443c-.198-.16-.74-.442-.74-.442l-.321.282z"
              fill="#FFF203"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.823 11.653s-.2.21-.2.37-.186.588-.186.588.52.32.628.116c.108-.204.81-.082.686-.393-.124-.312-.928-.681-.928-.681z"
              fill="#00A651"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.16 6.989s.461-.237.69 0c.227.236.414-.02.414-.162 0-.143.362-.633.362-.235 0 .397-.112.621.206.621s1.752-.549 2.096-.386c.343.162.607.122.52-.111-.088-.233-.313-.378-.745-.251-.433.127-.33.25-.704.25-.374 0-.79-.123-.79-.123s.117-.21.543-.06c.427.148 1.016-.184 1.176-.184.16 0 .6-.01.644.117.044.127.31.243.107.362-.203.118-.537.192-.307.344.23.152.759.123.784.28.026.158.277.394.176.394-.1 0-.283.222-.452.155-.17-.068-.19-.127-.027-.182.163-.055.161-.286.027-.286s-.068.081-.373 0c-.305-.08-.709-.17-.685 0 .025.17.223.433-.143.468-.366.035-.538.175-.61.062-.07-.113-.325-.263-.125-.312.2-.048.392.164.464.13.072-.035.236-.054.099-.201-.137-.147-.363-.233-.154-.343.21-.11.044-.112-.355.115-.399.228-.62.421-.97.394-.351-.027-.482.01-.595-.027-.113-.037-.66.407-.819.294-.158-.112-.668-.156-.576-.294.092-.139.215-.21.352-.139.138.071.274.143.367.071.092-.071.36-.316.292-.365-.067-.049-.002-.214-.383-.214-.38 0-.514.184-.604.068-.09-.116.098-.25.098-.25z"
              fill="#FFD100"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="FK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <path
            d="M16.219 12.227c-.628 0-1.052-.148-1.35-.394-.298-.249-.5-.624-.632-1.14-.132-.52-.186-1.158-.207-1.907a55.888 55.888 0 01-.009-1.712l.002-.554h4.453c.079 1.475.1 2.891-.184 3.953-.149.555-.375.99-.7 1.286-.32.291-.758.468-1.373.468z"
            fill="#6DC2FF"
            stroke="#F7FCFF"
            stroke-width=".5"
          />
          <mask
            id="e"
            maskUnits="userSpaceOnUse"
            x="13"
            y="6"
            width="6"
            height="7"
          >
            <path
              d="M16.219 12.227c-.628 0-1.052-.148-1.35-.394-.298-.249-.5-.624-.632-1.14-.132-.52-.186-1.158-.207-1.907a55.888 55.888 0 01-.009-1.712l.002-.554h4.453c.079 1.475.1 2.891-.184 3.953-.149.555-.375.99-.7 1.286-.32.291-.758.468-1.373.468z"
              fill="#fff"
              stroke="#fff"
              stroke-width=".5"
            />
          </mask>
          <g mask="url(#e)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.326 8.492s-.247-.183-.352-.478c-.106-.296-.315-1.083-.315-1.15 0-.07-.279 0-.279 0s.004-.334.11-.334c.104 0 .108-.308.363-.23.255.077.456.362.716.362.26 0 1.346.083 1.52.083.175 0 .635.369.635.644 0 .276-.125.687-.224.687s-.223.24-.41.16c-.188-.078-.637-.24-1.038-.16-.401.082-.483.03-.483.16s-.243.256-.243.256z"
              fill="#E1E5E8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.75 8.3h3.222l-.555.716H15.14l-.39-.717z"
              fill="#49801E"
            />
            <path
              d="M14.708 11.435s.557.199.79.175c.258-.027.486-.32.658-.32.172 0 .503.293.76.32.233.024.688-.175.688-.175m-3.507-.85c.192-.163.611-.175.611-.175s.557.2.79.175c.258-.027.486-.32.658-.32.172 0 .503.293.76.32.233.024.688-.175.688-.175s.254-.286.573.016"
              stroke="#fff"
              stroke-width=".667"
            />
            <path
              d="M14.038 9.706l-.421-.516c.165-.135.442-.268.847-.415l.197-.01c.42.108.7.155.803.145.034-.004.091-.031.195-.1.294-.195.322-.21.497-.21.16 0 .192.015.526.195.062.033.085.045.119.061a.54.54 0 00.148.054c.08.008.242-.03.467-.12.294-.267.665-.24.985.052.214.194.385.351.514.471l-.453.49a84.343 84.343 0 00-.51-.468c-.084-.077-.066-.077-.103-.036l-.116.081c-.35.148-.626.216-.85.193a1.103 1.103 0 01-.37-.116 3.222 3.222 0 01-.148-.076c-.16-.087-.222-.115-.21-.115.029 0-.01.022-.128.1-.19.126-.321.19-.496.207-.193.02-.494-.027-.934-.136-.286.108-.476.202-.559.27z"
              fill="#fff"
            />
          </g>
          <path
            d="M14.352 11.496s.615.59.244.988c-.372.4-.712.168-.712.168m4.272-1.156s-.615.59-.243.988c.37.4.711.168.711.168"
            stroke="#B85F3C"
            stroke-width=".625"
          />
          <path
            d="M13.95 11.97s1.06 1.013 2.362 1.013c1.303 0 2.351-.773 2.351-.773"
            stroke="#CB8B73"
            stroke-width=".625"
          />
        </g>
      </g>
    </symbol>
    <symbol id="FM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#63B3E1"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g
          mask="url(#b)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#F7FCFF"
        >
          <path
            d="M10 4.563l-1.102.579.21-1.227-.891-.87 1.232-.178L10 1.75l.551 1.117 1.232.179-.891.869.21 1.227L10 4.562zm0 7.5l-1.102.579.21-1.227-.891-.87 1.232-.178L10 9.25l.551 1.117 1.232.179-.891.869.21 1.227-1.102-.58zM6.125 8.438l-1.102.579.21-1.227-.891-.87 1.232-.178.551-1.117.551 1.117 1.232.179-.891.869.21 1.227-1.102-.58zm7.625 0l-1.102.579.21-1.227-.891-.87 1.232-.178.551-1.117.551 1.117 1.232.179-.891.869.21 1.227-1.102-.58z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="FO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M6.25-.625h-.625v6.25h-6.25v3.75h6.25v6.25h3.75v-6.25h11.25v-3.75H9.375v-6.25H6.25z"
            fill="#F50100"
            stroke="#2E42A5"
            stroke-width="1.25"
          />
        </g>
      </g>
    </symbol>
    <symbol id="FR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0z" fill="#F50100" />
        <path d="M0 0h7v15H0V0z" fill="#2E42A5" />
        <path d="M6 0h8v15H6V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="GA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 10h20v5H0v-5z" fill="#40A8FF" />
        <path d="M0 5h20v5H0V5z" fill="#FECA00" />
        <path d="M0 0h20v5H0V0z" fill="#73BE4A" />
      </g>
    </symbol>
    <symbol id="GB-ENG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path fill="#F7FCFF" d="M0 0h20v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 0H8.5v6.25H0v2.5h8.5V15H11V8.75h9v-2.5h-9V0z"
          fill="#F50302"
        />
      </g>
    </symbol>
    <symbol id="GB-NIR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="15"
          >
            <path fill="#fff" d="M0 0h20v15H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-2.227 13.928l4.401 1.862L20.1 2.024l2.32-2.766-4.706-.622-7.312 5.932L4.52 8.565l-6.746 5.363z"
              fill="#fff"
            />
            <path
              d="M-1.624 15.232l2.242 1.08 20.97-17.31h-3.149l-20.062 16.23z"
              fill="#F50100"
            />
            <path
              d="M22.227 13.928l-4.401 1.862L-.1 2.024-2.42-.742l4.706-.622 7.311 5.932 5.886 3.997 6.745 5.363z"
              fill="#fff"
            />
            <path
              d="M22.077 14.864l-2.242 1.08-8.93-7.412-2.647-.828L-2.645-.733H.504L11.4 7.504l2.895.993 7.782 6.367z"
              fill="#F50100"
            />
            <mask id="d" fill="#fff">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.361-1.25H7.64V5h-8.872v5H7.64v6.25h4.722V10h8.906V5h-8.906v-6.25z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.361-1.25H7.64V5h-8.872v5H7.64v6.25h4.722V10h8.906V5h-8.906v-6.25z"
              fill="#F50100"
            />
            <path
              d="M7.639-1.25V-2.5h-1.25v1.25h1.25zm4.722 0h1.25V-2.5h-1.25v1.25zM7.64 5v1.25h1.25V5H7.64zm-8.872 0V3.75h-1.25V5h1.25zm0 5h-1.25v1.25h1.25V10zm8.872 0h1.25V8.75H7.64V10zm0 6.25H6.39v1.25h1.25v-1.25zm4.722 0v1.25h1.25v-1.25h-1.25zm0-6.25V8.75h-1.25V10h1.25zm8.906 0v1.25h1.25V10h-1.25zm0-5h1.25V3.75h-1.25V5zm-8.906 0h-1.25v1.25h1.25V5zM7.64 0h4.722v-2.5H7.64V0zm1.25 5v-6.25h-2.5V5h2.5zM-1.233 6.25H7.64v-2.5h-8.872v2.5zM.017 10V5h-2.5v5h2.5zM7.64 8.75h-8.872v2.5H7.64v-2.5zm1.25 7.5V10h-2.5v6.25h2.5zM12.36 15H7.64v2.5h4.722V15zm-1.25-5v6.25h2.5V10h-2.5zm10.156-1.25H12.36v2.5h8.906v-2.5zM20.017 5v5h2.5V5h-2.5zm-7.656 1.25h8.906v-2.5h-8.906v2.5zm-1.25-7.5V5h2.5v-6.25h-2.5z"
              fill="#fff"
              mask="url(#d)"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="GB-SCT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#0067C3"
        />
        <path d="M-.75 1l20 15 1.5-2-20-15-1.5 2z" fill="#fff" />
        <path d="M20.75 1l-20 15-1.5-2 20-15 1.5 2z" fill="#fff" />
      </g>
    </symbol>
    <symbol id="UK" width="20" height="15" fill="none">
  
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="15"
          >
            <path fill="#fff" d="M0 0h20v15H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-2.227 13.928l4.401 1.862L20.1 2.024l2.32-2.766-4.706-.622-7.312 5.932L4.52 8.565l-6.746 5.363z"
              fill="#fff"
            />
            <path
              d="M-1.624 15.232l2.242 1.08 20.97-17.31h-3.149l-20.062 16.23z"
              fill="#F50100"
            />
            <path
              d="M22.227 13.928l-4.401 1.862L-.1 2.024-2.42-.742l4.706-.622 7.311 5.932 5.886 3.997 6.745 5.363z"
              fill="#fff"
            />
            <path
              d="M22.077 14.864l-2.242 1.08-8.93-7.412-2.647-.828L-2.645-.733H.504L11.4 7.504l2.895.993 7.782 6.367z"
              fill="#F50100"
            />
            <mask id="d" fill="#fff">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.361-1.25H7.64V5h-8.872v5H7.64v6.25h4.722V10h8.906V5h-8.906v-6.25z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.361-1.25H7.64V5h-8.872v5H7.64v6.25h4.722V10h8.906V5h-8.906v-6.25z"
              fill="#F50100"
            />
            <path
              d="M7.639-1.25V-2.5h-1.25v1.25h1.25zm4.722 0h1.25V-2.5h-1.25v1.25zM7.64 5v1.25h1.25V5H7.64zm-8.872 0V3.75h-1.25V5h1.25zm0 5h-1.25v1.25h1.25V10zm8.872 0h1.25V8.75H7.64V10zm0 6.25H6.39v1.25h1.25v-1.25zm4.722 0v1.25h1.25v-1.25h-1.25zm0-6.25V8.75h-1.25V10h1.25zm8.906 0v1.25h1.25V10h-1.25zm0-5h1.25V3.75h-1.25V5zm-8.906 0h-1.25v1.25h1.25V5zM7.64 0h4.722v-2.5H7.64V0zm1.25 5v-6.25h-2.5V5h2.5zM-1.233 6.25H7.64v-2.5h-8.872v2.5zM.017 10V5h-2.5v5h2.5zM7.64 8.75h-8.872v2.5H7.64v-2.5zm1.25 7.5V10h-2.5v6.25h2.5zM12.36 15H7.64v2.5h4.722V15zm-1.25-5v6.25h2.5V10h-2.5zm10.156-1.25H12.36v2.5h8.906v-2.5zM20.017 5v5h2.5V5h-2.5zm-7.656 1.25h8.906v-2.5h-8.906v2.5zm-1.25-7.5V5h2.5v-6.25h-2.5z"
              fill="#fff"
              mask="url(#d)"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="GB-WLS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#5DAA22"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v7.5h20V0H0z" fill="#F7FCFF" />
          <path
            d="M9.195 5.61c-.011-.348-.022-.683.41-1.083C10.735 3.53 11.882 2.75 13.164 2c-.26.46-.445 1.314.236 1.368.219.004 2.616-1.064 2.616-1.064-.834.644-1.793 1.542-.68 1.931-1.02.337-1.868 1.43-1.126 2.312-.53-.16-1.226.202-1.35.61.13 0 .36.02.642.044 1.021.09 2.719.238 2.804-.345-.55.285-1.503.169-1.532-.648.007-.7 1-1.093 1.847-.569l.129-.283.13-.287-.11.015c-.267.037-.517.072-.799.002.651-.654 1.264-1.298 1.818-2.023-.122.904 0 2.215.212 2.643a1.305 1.305 0 01-.686-.63l-.15.495-.15.495c.485 1.043-.034 2.59-.308 3.405-.085.254-.147.438-.147.513-.223.088-.386-.05-.549-.188a1.126 1.126 0 00-.252-.178c.14.385.041.995-.046 1.528-.032.2-.063.39-.08.552a.76.76 0 00.124.481c.01.018.019.032.022.041.133.055.44.204.461.225 0 0 .38.02.356.427-.186-.24-.44-.163-.44-.163-.031.022-.32-.074-.32-.074-.143-.102-.553-.188-.98-.17a3.502 3.502 0 00-.684.122c-.006 0-.352.244-.352.244s-.083-.02-.09-.02c-.014 0-.23-.003-.512.189a.735.735 0 01.378-.501c.133-.073.292-.109.391-.13.033-.008.059-.014.076-.02-.115-.04-.334-.099-.488-.084-.04.004-.094.005-.154.007-.218.005-.525.011-.606.152-.006-.165.161-.352.35-.44a.878.878 0 01.266-.067c.048-.006.08-.01.087-.021.038-.07-.089-.18-.128-.214a.087.087 0 01-.012-.01c0-.007-.236-.159-.403.013.032-.36.568-.364.621-.311l.157.162.157.162a60.982 60.982 0 01.294.198c.162.075.581.014.793-.224.124-.14.127-.402.128-.535l.001-.055.01-.149c.02-.28.055-.742-.01-.966-.029-.101-.267-.089-.574-.073-.308.016-.685.036-.988-.052-.478-.14-.96-.417-1.252-.586-.147-.085-.246-.142-.272-.14a.419.419 0 01-.1.097.605.605 0 00-.201.23c-.107.26-.087.628 0 .724 0 0 .752.006.92.1.422.232.396.58.383.758a1.261 1.261 0 00-.003.057 15.628 15.628 0 01-.626-.226l-.065-.025c-.414.706-1 1.2-1.839 1.43.093.046.278.088.428.123.11.025.201.045.226.06.249.056.424.14.422.387-.166-.197-.329-.192-.46-.095-.178.079-.304-.01-.431-.098-.064-.044-.127-.089-.197-.112-.177-.135-.881-.052-1.082-.027-.25.026-.535.094-.66.244-.063.053-.097.004-.113-.018-.004-.007-.007-.01-.008-.01-.288-.098-.416.17-.416.17-.068-.31.08-.376.236-.42l-.32-.197c-.006-.038-.22-.08-.358.054.012-.282.342-.459.48-.365a.332.332 0 01.416.026.61.61 0 00.531.089.501.501 0 00-.39-.312.346.346 0 01-.116-.078.683.683 0 00-.158-.112c-.153-.069-.346-.07-.437 0 .058-.35.711-.447.973-.04.158.17.402.258.602.291.369-.044.741-.351.977-.546.09-.074.159-.131.201-.152 0 0-.67-.685-1.178-1.038-.474-.33-1.831.31-2.015.397l-.02.01c-.033.307-.264.59-.264.59a2.558 2.558 0 00-.132-.28c-.092-.177-.178-.343-.168-.536a5.505 5.505 0 01-.607.706 7.201 7.201 0 00-.283.3c-.24.26-.363.569-.448.908.18.109.679.204.679.204.218.004.38.132.377.372-.195-.213-.39-.08-.39-.08-.16.14-.363.076-.558 0-.168-.191-.982-.25-1.37-.021-.275.265-.657.29-.762.128 0 0-.172-.006-.473.102.077-.495.365-.36.365-.36a.382.382 0 010-.06c0-.018.002-.035 0-.061l-.11-.04c-.194-.091-.434-.069-.543.026.074-.324.358-.326.57-.291a.456.456 0 00.063-.145l.02-.058-.03-.033c-.11-.119-.233-.252-.368-.133.13-.555.771-.13.994.017l.05.034c.456.161 1.64-1.686 1.698-1.814-.337-.016-.716.02-.98.118-.075.243-.208.37-.365.52l-.08.076c.005-.697-.307-1.049-.754-1.554l-.076-.085c-.559-.388-.806-1.17-.85-1.424-.087.238-.15.31-.168.331l-.006.008c-.124.143-.505.104-.42.047.054-.01.305-.407.305-.407l.109-1.063c-.066-.03-.096-.132-.135-.27a2.496 2.496 0 00-.096-.289c-.12-.282-.342-.588-.435-.614.177-.033.41-.036.557.14.128.153.214.397.281.589.039.11.071.204.103.254-.114-.389-.056-.651.057-.99v-.046c.002-.155.003-.25-.153-.347.313-.008.396.234.421.305a.09.09 0 00.008.02c.136.188.08.342.035.465-.03.082-.055.15-.016.206.023-.018.043-.045.063-.072.04-.054.079-.108.149-.097.087-.102.153-.212.147-.44.22.133.167.329.096.52.013.288-.025.367-.205.468-.18.114-.214.208-.193.346.039.044.065.136.099.255.054.189.127.445.299.68.253.348.66.667.87.831.066.052.112.089.128.106.027-.043.135-.132.237-.216.062-.051.122-.1.16-.137-.126-.105-.04-1.043.216-1.899.246-.82.659-1.56.738-1.571 0-.007-.109-.272-.109-.272s-.52.083-.614.59a2.28 2.28 0 01-.128-.264s-.454.59-.46.576c-.18-.116-.099-.4-.099-.4-.087-.1-.105-.22-.124-.34-.01-.059-.018-.118-.036-.175a37.561 37.561 0 01-.611-.034 37.846 37.846 0 00-.61-.034s.166.325.166.318C3.3 4.7 2.452 3.933 2.288 3.28c.428.356.884.454 1.369.558l.02.004a127.649 127.649 0 00-.39.204c1.35.123 2.746-.143 2.74-.15-.151-.333-.647-.331-.647-.331l-.02.204s-.617.107-.62.1c-.063-.339-.365-.345-.365-.345a2.365 2.365 0 00-.64.017c-.101.012-.202.025-.307.03.392-.521.91-.56 1.427-.6.095-.006.189-.013.282-.023.045-.274.272-.354.538-.393l1.254.067c.161-.225 1.109-.426 1.37-.426-.04.308-.427.646-.572.745-.147.236-.134.26-.078.366l.017.034.148.27c.249.082.43.194.486.367-.27-.034-.465.018-.461.142.004.061.098.1.185.135.041.017.081.033.108.05a.64.64 0 01.213.48.583.583 0 01-.212-.079c-.146-.074-.292-.15-.384.045-.066.142.007.335.18.4.316.091.345.549.339.549a.1.1 0 01-.01-.004c-.073-.034-.515-.24-.483.18-.002.032-.022.055-.045.082-.042.05-.096.112-.078.263.036.294.082.6.103.665a1185.192 1185.192 0 001.204-.258c.176-.17.255-.45.237-.752.005-.09.002-.179-.001-.266zm7.063.7c-.183-.206-.372-.276-.529-.274-.23.003-.393.163-.377.283.051.4.818.261.906-.008z"
            fill="#D21034"
          />
        </g>
      </g>
    </symbol>
    <symbol id="GD" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v13.75c0 .69-.56 1.25-1.25 1.25H1.25C.56 15 0 14.44 0 13.75V0z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.75 3.75h12.5v7.5H3.75v-7.5z"
          fill="#FECA00"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="3"
          y="3"
          width="14"
          height="9"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.75 3.75h12.5v7.5H3.75v-7.5z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M3.75 3.75L10 7.5l-6.25 3.75v-7.5zm12.5 0L10 7.5l6.25 3.75v-7.5z"
            fill="#23875F"
          />
          <path
            d="M10 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
            fill="#C51918"
          />
          <path
            d="M9.956 8.32l-1.294.899.413-1.538-.95-.982 1.287-.053.544-1.521.544 1.52h1.285l-.948 1.036.474 1.447-1.355-.807z"
            fill="#FECA00"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.485 2.776l.708-.438.74.394-.259-.707.518-.506H6.49L6.193.776l-.298.743-.703.026.52.48-.227.751zm3.75 0l.708-.438.74.394-.259-.707.518-.506h-.702L9.943.776l-.298.743-.703.026.52.48-.227.751zm4.458-.438l-.707.438.225-.751-.519-.48.703-.026.298-.743.297.743h.702l-.518.506.26.707-.741-.394zM5.485 13.855l.707-.44.741.395-.26-.707.519-.506H6.49l-.298-.742-.297.742-.703.026.519.48-.226.752zm4.457-.44l-.707.44.226-.752-.52-.48.704-.026.297-.742.298.742h.702l-.518.506.259.707-.74-.394zm3.043.44l.707-.44.741.395-.26-.707.519-.506h-.702l-.298-.742-.297.742-.703.026.519.48-.226.752z"
          fill="#FECA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.397 7.983s.336.3.52.401c.063-.24-.078-.782-.078-.782-.04-.13-.474-.363-.474-.363s-.122.41.032.744z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.747 8.706s-.864-.403-.952-.975c-.088-.57.098-1.481.098-1.481s1.404.32 1.5 1.004c.095.684-.222 1.114-.222 1.114s-.324-.834-.63-.927c0 0 0 .827.206 1.265z"
          fill="#FECA00"
        />
      </g>
    </symbol>
    <symbol id="GE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g
          mask="url(#b)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#E31D1C"
        >
          <path
            d="M8.75 0h2.5v6.25H20v2.5h-8.75V15h-2.5V8.75H0v-2.5h8.75V0z"
          />
          <path
            d="M6.25 10.764l1.375-.139v1.25s-1.376-.086-1.376-.061c0 .025.126 1.311.126 1.311h-1.25l.1-1.25h-1.35v-1.25l1.35.139-.1-1.389h1.25l-.126 1.389zm0-7.5l1.375-.139v1.25s-1.376-.086-1.376-.061c0 .025.126 1.311.126 1.311h-1.25l.1-1.25h-1.35v-1.25l1.35.139-.1-1.389h1.25l-.126 1.389zm8.75 0l1.375-.139v1.25s-1.376-.086-1.376-.061c0 .025.126 1.311.126 1.311h-1.25l.1-1.25h-1.35v-1.25l1.35.139-.1-1.389h1.25l-.126 1.389zm0 7.5l1.375-.139v1.25s-1.376-.086-1.376-.061c0 .025.126 1.311.126 1.311h-1.25l.1-1.25h-1.35v-1.25l1.35.139-.1-1.389h1.25l-.126 1.389z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="GF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path fill="#5EAA22" d="M0 0h20v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0l20 15H0V0z"
          fill="#FECA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.957 9.004l-2.179 1.511.696-2.588-1.599-1.653 2.165-.09.917-2.559.916 2.56h2.162l-1.596 1.742.8 2.435-2.282-1.358z"
          fill="#E21835"
        />
      </g>
    </symbol>
    <symbol id="GG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M7.5 0h5v5H20v5h-7.5v5h-5v-5H0V5h7.5V0z"
            fill="#E31D1C"
          />
          <path
            d="M8.128 1.904L8.75 3v3.25H4.29v-.036l-1.099-.623v3.725l1.04-.566H8.75v3.157l-.622 1.096h3.726l-.599-1.1h-.005V8.75h4.5l1.04.566V5.591l-1.099.623v.036H11.25V3.003h.005l.599-1.1H8.128z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="GH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 10h20v5H0v-5z" fill="#5EAA22" />
        <path d="M0 5h20v5H0V5z" fill="#FECA00" />
        <path d="M0 0h20v5H0V0z" fill="#E11C1B" />
        <path
          opacity=".9"
          d="M10.047 9.057l-2.178 1.51.696-2.588-1.6-1.653 2.166-.09.916-2.558.916 2.559h2.162L11.53 7.979l.799 2.436-2.282-1.358z"
          fill="#1D1D1D"
        />
      </g>
    </symbol>
    <symbol id="GI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path fill="#F7FCFF" d="M0 0h20v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10h20v5H0v-5z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.838 2.042h-.921v.916h.454L9.34 5.48H7.996V4.333h.46v-.916h-.92v.458h-.461v-.458h-.921v.916h.46V5.48h-.971v.917h.46v2.75h-.46v.916h8.75v-.916h-.921v-2.75h.92V5.48h-.902l.023-1.146h.47v-.916h-.922v.458h-.46v-.458h-.921v.916h.451l-.023 1.146H10.72l.033-2.52h.466v-.917h-.92V2.5h-.461v-.458z"
          fill="#DB000B"
        />
        <path
          d="M7.132 5.48a.23.23 0 11.46 0v1.145h-.46V5.48z"
          fill="#272727"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.76 8.556a.69.69 0 011.382 0V9.7H6.76V8.556zm5.066 0a.69.69 0 011.381 0V9.7h-1.381V8.556zm-2.763-.228a.921.921 0 011.842 0v1.83H9.063v-1.83z"
          fill="#272727"
        />
        <path
          d="M9.895 5.48a.23.23 0 01.46 0v1.145h-.46V5.48zm2.763 0a.23.23 0 01.46 0v1.145h-.46V5.48z"
          fill="#272727"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.326 9.498l-.113.208-.21-.314-1.724 1.155 1.922.915 1.696-1.108-1.57-.856zm-.787.957l.555-.372.586.32-.527.344-.614-.292zm-.565 2.378h.92v.917h-.92v-.917z"
          fill="#E8AA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.5 11.25h1.093v2.5H9.5v-2.5z"
          fill="#E8AA00"
        />
      </g>
    </symbol>
    <symbol id="GL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 7.5h20V15H0V7.5z"
          fill="#C51918"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="7"
          width="20"
          height="8"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 7.5h20V15H0V7.5z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.5 12.5a5 5 0 100-10 5 5 0 000 10z"
            fill="#F7FCFF"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v7.5H0V0z"
          fill="#F7FCFF"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="8"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0h20v7.5H0V0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.5 12.5a5 5 0 100-10 5 5 0 000 10z"
            fill="#C51918"
          />
        </g>
      </g>
    </symbol>
    <symbol id="GM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10h20v5H0v-5z"
          fill="#5EAA22"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v5H0V0z"
          fill="#E31D1C"
        />
        <path
          d="M0 5.25h-.75v4.5h21.5v-4.5H0z"
          fill="#3D58DB"
          stroke="#fff"
          stroke-width="1.5"
        />
      </g>
    </symbol>
    <symbol id="GN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M6 0h8v15H6V0z" fill="#FBCD17" />
        <path d="M14 0h6v15h-6V0z" fill="#0B9E7A" />
        <path d="M0 0h6v15H0V0z" fill="#E11C1B" />
      </g>
    </symbol>
    <symbol id="GP" width="20" height="15" fill="none">
      <path d="M0 0v5h20V0H0z" fill="#002488" />
      <path d="M0 5v10h20V5H0z" fill="#DA121A" />
      <path
        d="M3.468.708c-.241.397-.27.715-.105 1.264.079.255.166.638.202.845.049.292.044.32.05.384h.264c.009-.102.016-.219.038-.38.025-.187.1-.579.18-.85.16-.545.15-.879-.1-1.257C3.906.574 3.784.46 3.73.46c-.054 0-.178.107-.261.25zm.524 2.232c-.02.106-.025.143-.036.26.074.001.103.002.175.001.016-.08.027-.121.062-.234.137-.436.542-.611.524-.203A.358.358 0 014.611 3a1.59 1.59 0 00.316-.145c.627-.378.38-1.303-.277-1.023-.34.146-.546.55-.658 1.109zm-.735.425c.276.002.75.005.98.003V3.27c-.167-.002-.81.001-.978.001 0 .04 0 .06-.002.095zm-.173.488s.137.015.265.006a.686.686 0 00.274-.062c-.02.152-.021.3-.021.3.018.196.04.246.082.341.057.08.09.08.133-.004a.845.845 0 00.086-.339 1.505 1.505 0 00-.036-.296.759.759 0 00.276.06c.135.012.26.006.26.006s-.183-.092-.263-.204c-.08-.111-.063-.092-.12-.235-.07-.003-.425 0-.538 0-.061.13-.067.157-.144.24-.099.107-.254.187-.254.187zm-.247-2.021c.341.146.546.55.658 1.109.02.104.026.141.036.26h-.175a1.966 1.966 0 00-.061-.234c-.138-.436-.543-.611-.525-.203A.358.358 0 002.877 3a1.685 1.685 0 01-.317-.145c-.627-.378-.38-1.304.277-1.023zM9.768.708c-.241.397-.27.715-.105 1.264.079.255.166.638.202.845.049.292.044.32.05.384h.264c.009-.102.016-.219.038-.38.025-.187.1-.579.18-.85.16-.545.15-.879-.1-1.257-.091-.14-.213-.255-.268-.255-.054 0-.178.107-.261.25zm1.182 1.124c-.34.146-.546.55-.658 1.109-.02.105-.025.142-.036.26h.175c.016-.08.027-.121.062-.234.137-.436.542-.611.524-.203a.358.358 0 01-.106.236 1.59 1.59 0 00.316-.145c.627-.378.38-1.303-.277-1.023zM9.557 3.365c.276.002.75.005.98.003V3.27c-.167-.002-.81.001-.978.001 0 .04 0 .06-.002.095zm.081.301c-.099.107-.254.187-.254.187s.137.015.265.006a.686.686 0 00.274-.062c-.02.152-.021.3-.021.3.018.196.04.246.082.341.057.08.09.08.133-.004a.845.845 0 00.086-.339 1.502 1.502 0 00-.036-.296.76.76 0 00.276.06c.135.012.26.006.26.006s-.183-.092-.263-.204c-.08-.111-.063-.092-.12-.235-.07-.003-.425 0-.538 0-.061.13-.067.157-.144.24zm-.501-1.834c.341.146.546.55.658 1.109.02.104.026.141.036.26h-.175a1.966 1.966 0 00-.061-.234c-.138-.436-.543-.611-.525-.203A.358.358 0 009.177 3a1.685 1.685 0 01-.317-.145c-.627-.378-.38-1.304.277-1.023zM16.068.708c-.241.397-.27.715-.105 1.264.079.255.166.638.202.845.049.292.044.32.05.384h.264c.009-.102.016-.219.038-.38.025-.187.1-.579.18-.85.16-.545.15-.879-.1-1.257-.091-.14-.213-.255-.268-.255-.054 0-.178.107-.261.25zm1.182 1.124c-.34.146-.546.55-.658 1.109-.02.105-.025.142-.036.26h.175c.016-.08.027-.121.062-.234.137-.436.542-.611.524-.203a.358.358 0 01-.106.236 1.62 1.62 0 00.317-.145c.626-.378.38-1.303-.278-1.023zm-1.393 1.533c.276.002.75.005.98.003V3.27c-.167-.002-.81.001-.978.001 0 .04 0 .06-.002.095zm.081.301c-.099.107-.254.187-.254.187s.137.015.265.006a.686.686 0 00.274-.062c-.02.152-.021.3-.021.3.018.196.04.246.082.341.057.08.09.08.133-.004a.845.845 0 00.086-.339 1.502 1.502 0 00-.036-.296.76.76 0 00.276.06c.135.012.26.006.26.006s-.183-.092-.263-.204c-.08-.111-.063-.092-.12-.235-.07-.003-.425 0-.538 0-.061.13-.067.157-.144.24zm-.501-1.834c.341.146.546.55.658 1.109.02.104.026.141.036.26h-.175a1.957 1.957 0 00-.061-.234c-.138-.436-.543-.611-.525-.203a.358.358 0 00.107.236 1.685 1.685 0 01-.317-.145c-.627-.378-.38-1.304.277-1.023z"
        fill="#FCDD09"
      />
      <path
        d="M7.118 8.27c.132.063.301.111.386.114.1.003.074-.021-.114-.094a1.973 1.973 0 01-.4-.214c-.14-.115-.14-.115-.125-.014.008.058.113.147.253.209z"
        fill="green"
      />
      <path
        d="M6.296 7.082c.085.341.438.969.56.993.11.019.11.012.018-.091-.152-.177-.48-.823-.48-.945 0-.067-.03-.115-.067-.115-.043 0-.055.06-.03.158zM4.071 8.093c-.103.079-.097.085.128.048.134-.018.329-.054.426-.079.158-.042.146-.049-.128-.055-.182-.006-.353.03-.426.086z"
        fill="green"
      />
      <path
        d="M2.56 7.452c1.003.183 3.018.86 2.896.975-.03.03-.596-.11-.675-.165-.03-.03-.329-.018-.658.025-.614.067-.718.122-.706.371.006.122.006.122.037 0 .055-.225.146-.274.493-.274.377 0 1.412.153 1.868.274.609.171.627.171.426.061-.261-.146-.657-.414-.73-.493-.134-.153-2.562-.823-2.915-.81-.165.012-.17.012-.037.036zm3.563.701c.049.085.524.323.56.286.018-.018-.036-.067-.11-.11a.972.972 0 01-.225-.158c-.097-.091-.28-.11-.225-.018z"
        fill="green"
      />
      <path
        d="M6.16 8.732c.049.085.523.323.56.286.018-.018-.037-.067-.11-.11a.972.972 0 01-.225-.158c-.097-.091-.28-.11-.225-.018zm-.68-.726c.008-.008.145.037.308.1.162.063.372.123.462.129.16.007.723.276.717.34 0 .06-.853-.2-1.151-.352-.359-.179-.367-.187-.337-.217z"
        fill="green"
      />
      <path
        d="M6.487 8.451a.633.633 0 00-.263.18c-.042.068-.006.069.14-.005.115-.058.28-.105.372-.113.17-.008.17-.008.062-.076-.062-.039-.194-.035-.31.014zM3.64 6.398c.188.36.955 1.188 1.38 1.505.116.085.323.17.451.189l.237.036-.176-.195c-.286-.31-.724-.908-.864-1.17-.152-.286-.17-.213-.043.153.049.146.244.438.432.646.189.213.31.39.28.39-.079 0-.59-.604-.955-1.128-.396-.573-.414-.59-.305-.274.055.152.177.378.28.5.098.128.159.231.128.231-.06 0-.329-.304-.663-.743-.092-.128-.22-.293-.274-.366-.061-.079-.018.025.091.226zM6.218 9.46c-.459-.083-.677-.01-.862.277l-.159.246.204-.193c.277-.27.478-.295.975-.15.232.068.43.113.436.103.038-.055-.354-.247-.594-.284z"
        fill="green"
      />
      <path
        d="M6.343 9.587c-.426.19-.566.372-.56.713l.006.293.061-.274c.08-.378.231-.512.724-.67.232-.074.42-.147.42-.16 0-.066-.432-.005-.65.098z"
        fill="green"
      />
      <path
        d="M6.262 10.11a.621.621 0 00-.127.293c0 .08.03.061.115-.08.067-.109.183-.237.256-.292.14-.097.14-.097.012-.097-.073 0-.183.073-.256.177zm6.581.994c.197.085 1.223.344 1.948.557.726.213 1.574.458 1.762.484.268-.586-.22.51.058-.154-.362-.092-1.79-.429-2.363-.594-.494-.138-1.195-.354-1.375-.394-.18-.04-.182.035-.03.1z"
        fill="green"
      />
      <path
        d="M12.968 10.952c.2.078 1.234.301 1.967.489.732.187 1.589.402 1.777.422.248-.595-.202.517.053-.156-.365-.08-1.804-.366-2.383-.511-.498-.121-1.206-.313-1.387-.346-.18-.033-.18.04-.027.102zm-.284.262c.193.096 1.204.408 1.917.659.713.25 1.548.54 1.734.575.298-.57-.247.498.066-.15-.357-.112-1.765-.522-2.33-.717-.485-.164-1.174-.417-1.351-.466-.177-.049-.184.025-.036.1z"
        fill="green"
      />
      <path
        d="M12.561 11.339c.188.106 1.18.47 1.88.758.7.288 1.517.62 1.701.666.328-.554-.272.484.075-.147-.351-.13-1.736-.614-2.29-.838-.476-.19-1.15-.478-1.325-.536-.175-.058-.185.015-.04.097z"
        fill="green"
      />
      <path
        d="M12.445 11.496c.184.112 1.163.512 1.852.823.69.312 1.495.673 1.677.725.348-.542-.288.474.08-.144-.346-.142-1.714-.674-2.258-.918-.47-.205-1.134-.517-1.307-.581-.172-.065-.185.009-.044.095z"
        fill="green"
      />
      <path
        d="M10.392 13.076c.283.197.438.47.423.753l-.01.234.092-.23c.101-.24.087-.604-.032-.874l-.07-.157.222.097c.317.134.526.37.57.65l.038.23.043-.244c.05-.257-.04-.61-.213-.848l-.101-.14.237.049c.338.065.591.252.692.516l.086.218-.009-.248c-.005-.26-.165-.588-.385-.785l-.127-.115.242-.002c.344-.007.63.123.784.361l.129.195-.06-.24c-.059-.255-.284-.54-.54-.689l-.148-.086.236-.052c.336-.078.643-.01.843.19l.166.164-.108-.223c-.111-.236-.39-.47-.67-.56l-.164-.053.22-.101c.312-.146.627-.144.864.01l.196.126-.152-.195c-.157-.208-.48-.378-.772-.409l-.171-.018.195-.144c.274-.208.582-.272.846-.17l.219.083-.19-.16c-.197-.17-.547-.27-.84-.239l-.17.018.16-.182c.225-.26.513-.386.793-.341l.23.034-.218-.116c-.228-.126-.591-.15-.872-.06l-.163.054.12-.211c.165-.302.421-.485.704-.5l.233-.014-.238-.068c-.25-.076-.61-.024-.865.124l-.149.086.073-.232c.1-.33.312-.562.586-.635l.225-.062-.247-.017c-.26-.023-.601.103-.82.3l-.128.116.023-.242c.03-.343.189-.615.441-.743l.207-.108-.245.035c-.259.032-.566.226-.74.465l-.1.139-.028-.241c-.043-.342.057-.641.277-.819l.18-.148-.233.084c-.246.086-.507.34-.627.61l-.07.157-.076-.23c-.113-.326-.078-.64.1-.859l.146-.183-.21.132c-.223.134-.425.437-.487.726l-.036.168-.122-.209c-.179-.295-.21-.609-.08-.86l.104-.21-.178.172c-.19.179-.325.517-.325.812v.172l-.164-.179c-.235-.251-.33-.552-.257-.825l.059-.226-.139.205c-.149.214-.21.573-.15.862l.036.168-.197-.14c-.282-.198-.438-.472-.422-.755l.01-.233-.093.23c-.101.24-.087.604.033.874l.07.157-.222-.097c-.318-.134-.527-.37-.57-.65l-.039-.23-.043.244c-.049.256.04.61.214.848l.1.14-.237-.049c-.338-.065-.591-.252-.692-.517l-.085-.217.008.248c.005.26.166.587.385.785l.128.115-.243.002c-.344.007-.63-.123-.784-.361l-.129-.195.06.24c.06.254.284.54.54.688l.148.086-.236.053c-.336.078-.643.01-.842-.19L6.228 8l.109.222c.11.237.39.47.67.561l.164.053-.22.1c-.313.147-.627.145-.864-.01L5.89 8.8l.152.196c.158.208.48.378.773.409l.17.018-.194.144c-.275.208-.583.271-.847.17l-.219-.083.19.16c.197.17.547.27.84.239l.171-.018-.16.181c-.226.261-.514.387-.793.342l-.231-.035.218.117c.229.126.592.15.872.059l.163-.053-.119.21c-.166.303-.422.486-.705.5l-.233.014.238.069c.25.076.61.024.865-.124l.149-.086-.073.231c-.1.33-.312.563-.586.636l-.225.062.247.017c.26.022.602-.103.82-.3l.128-.116-.023.242c-.03.343-.188.615-.44.743l-.208.107.245-.034c.259-.032.567-.226.74-.465l.101-.14.027.242c.043.342-.056.64-.277.819l-.18.148.233-.085c.246-.085.507-.339.627-.609l.07-.157.076.23c.113.326.078.639-.1.859l-.146.182.21-.13c.223-.136.426-.438.487-.727l.036-.168.123.209c.178.295.208.608.08.86l-.105.21.178-.173c.19-.178.326-.516.326-.811v-.172l.163.179c.236.251.33.552.257.825l-.059.226.139-.205c.149-.214.21-.573.15-.862l-.036-.168.197.14z"
        fill="#FCDD09"
      />
    </symbol>
    <symbol id="GQ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15.36h20.48V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="21"
          height="16"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15.36h20.48V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5.12h20.48V0H0z" fill="#009D00" />
          <path d="M0 5.12v5.12h20.48V5.12H0z" fill="#fff" />
          <path d="M0 10.24v5.12h20.48v-5.12H0z" fill="#F80000" />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15.36l5.12-7.583L0 0z"
          fill="#0075D5"
        />
        <path
          d="M9.326 5.689l-.01.002-.008-.007-.126-.117-.016.172-.001.01-.01.005-.15.084.159.068.01.004.001.01.034.17.113-.13.007-.008.01.002.171.02-.087-.148-.006-.01.005-.009.072-.156-.168.038zm.64 0l-.01.002-.008-.007-.126-.117-.016.172-.001.01-.01.005-.15.084.159.068.01.004.001.01.034.17.113-.13.007-.008.01.002.171.02-.087-.148-.006-.01.005-.009.072-.156-.168.038zm.64 0l-.01.002-.008-.007-.127-.117-.015.172-.001.01-.01.005-.15.084.159.068.01.004.001.01.034.17.113-.13.007-.008.01.002.171.02-.087-.148-.006-.01.005-.009.072-.156-.168.038zm.64 0l-.01.002-.008-.007-.127-.117-.015.172-.001.01-.01.005-.15.084.159.068.01.004.001.01.034.17.113-.13.007-.008.01.002.171.02-.087-.148-.006-.01.005-.009.072-.156-.168.038zm.64 0l-.01.002-.008-.007-.127-.117-.015.172-.001.01-.01.005-.15.084.159.068.01.004.001.01.034.17.113-.13.007-.008.01.002.171.02-.087-.148-.006-.01.005-.009.072-.156-.168.038zm.64 0l-.01.002-.008-.007-.126-.117-.016.172-.001.01-.01.005-.15.084.159.068.01.004.001.01.034.17.113-.13.007-.008.01.002.171.02-.087-.148-.006-.01.005-.009.072-.156-.168.038z"
          fill="#FFD500"
          stroke="#000"
          stroke-width=".04"
        />
        <path
          d="M9.64 6.44h2.48v1.88a1.24 1.24 0 01-2.48 0V6.44z"
          stroke="#373737"
          stroke-width=".08"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.705 7.654s-.13 1.514-.258 1.606c-.129.092.618.137.689.069.071-.07-.326-1.303-.19-1.675.137-.372.357-.402.357-.402s-.277-.058-.356.053c-.08.112-.316-.053-.316-.053l.074.402z"
          fill="#6F3E1D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.677 7.569h-.1s-.067.263-.221.131c-.154-.131-.372-.085-.372-.085s.02-.157.256-.22c.237-.062.337-.57.337-.57s.335-.125.54.13c.203.256.49.147.49.147s.21.12.105.293c-.105.174-.284.3-.44.174-.156-.127-.595 0-.595 0z"
          fill="#009D29"
        />
      </g>
    </symbol>
    <symbol id="GR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path fill="#4564F9" d="M.017 3.438h20v1.875h-20z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v1.875H0V0z"
          fill="#4564F9"
        />
        <path
          fill="#4564F9"
          d="M-.037 6.875h20V8.75h-20zM.07 10.25h20v1.875h-20zm-.007 3.188h20v1.875h-20z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h10v8.75H0V0z"
          fill="#4564F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.044 0h1.978v3.438H10v2.366H6.022v3.571H4.044V5.804H0V3.437h4.044V0z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="GS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#2B409A"
        />
        <path
          d="M15.199 11.595a.817.817 0 01-.178-.075s-.101.16-.154.169c-.053.009-.327-.099-.327-.099s-.192.15-.235.14a81.61 81.61 0 01-.486-.102l-.24-.15s-.134.215-.14.21c-.004-.004-.403-.08-.403-.08s.12-.164.12-.168a.298.298 0 00-.057-.024l-.087.07-.356.034.087-.245.14-.206 1.705-1.62.841 1.516-.124.456s-.068.174-.106.174z"
          fill="#6A4C2D"
        />
        <path
          d="M13.569 11.288c.06.072.842.872.97 1.25.126.38-1.03-.104-1.03-.104s1.456-.946 2.183-.946c.727 0 2.157.946 2.157.946s-.96.675-.95.25c.01-.427.45-1.266.976-1.396"
          stroke="#FB0"
          stroke-width=".5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.464 11.35l-.24-.089-.211-.28-.877-.065-.8-.218-.336.225.181.237.444.163 1.839.027z"
          fill="#F7FCFF"
        />
        <g
          filter="url(#GS_-__S__Georgia_and_S__Sandwich_Islands__filter0_d)"
        >
          <path
            d="M14.962 6.166c.008.02.187-.016.225.092.192-.285.418-.014.418-.014l.19-.225.215.204.196-.016.206.483-1.623-.03s.165-.514.173-.494z"
            fill="#656263"
          />
        </g>
        <path
          d="M16.645 8.221c-.013-.153-.149-.17-.225-.165-.075.005-.143.068-.143.068l-.25-.155s.125-.772.258-.82c.126-.09.148-.128.148-.149a.509.509 0 00-.047-.103l-.816-.094-.772.09s-.06.12-.052.156c.008.035.01.074.149.178.152.115.258.775.258.775s-.217.104-.23.092c-.013-.013-.078-.026-.112-.02a.204.204 0 00-.146.206c0 .145.112.23.112.23s.738.54.848.739c.107-.24.808-.78.892-.821.034-.02.14-.054.128-.207z"
          fill="#656263"
        />
        <path
          d="M17.381 7.501c.062-.04.47-.06.568 0 .098.06.135.355.135.355s.061.104.065.18c.004.076.013.128.013.128s.326.415.33.79c.037.256.029.938-.073 1.197-.004.324-.143.535-.143.535s.033.056.029.116a.322.322 0 01-.037.116l-.306.132-.34-.056-.384-1.122.09-1.896.025-.096-.041-.255s.008-.084.07-.124z"
          fill="#000"
        />
        <path
          d="M15.164 8.496s.413 0 .458.131c.078-.174.435-.163.435-.163l.648-.022.011 1.528a1.647 1.647 0 01-1.05 1.19c-.577-.182-.942-.659-1.06-1.201l-.068-1.452.626-.01z"
          fill="#F7FCFF"
        />
        <path
          d="M14.76 8.502l.912 2.372.823-2.424c-.255.016-.803-.04-.87.188-.106-.203-.683-.121-.864-.136z"
          fill="#006B00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.817 8.674s.083.216 0 .323c-.083.107.007.195.057.195s.222.17.082.17c-.139 0-.217-.053-.217.096 0 .15.306 1.08.262.878-.045-.203-.088-.155-.088-.33 0-.176.043-.371.043-.371s.073.055.021.255c-.052.2-.29.49-.35.502-.06.011-.152.104-.164-.067-.012-.172-.061-.253-.022-.286.04-.034.092-.153.11-.06.016.095-.058.185-.046.219.012.034.019.11.07.046.052-.064.082-.17.12-.072.039.098.04.02-.04-.167s-.147-.29-.138-.455c.01-.165-.003-.226.01-.28.013-.052-.143-.31-.104-.383.04-.074.055-.314.104-.27.048.043.073.1.048.165-.025.064-.05.128-.025.172.025.043.111.168.128.137.017-.032.075-.001.075-.18 0-.178-.064-.241-.024-.284.041-.042.088.047.088.047z"
          fill="#FFD100"
        />
        <path
          d="M16.5 8.45l.123-.003-.22.272.264.3-.518.638.489.574a1.488 1.488 0 01-.2.352l-.28-.303.51-.62-.42-.463.252-.747zm-1.887.058l.246.26-.26.317.541.575-.448.586c.054.128.131.271.214.377l.266-.329-.547-.594.401-.498-.28-.697-.133.003z"
          fill="#1E5AA6"
        />
        <path
          d="M15.354 10.048l-.193.252.69.78c.122-.06.217-.128.322-.21l-.36-.407.146-.42.21.237-.657.82a1.452 1.452 0 01-.343-.205l.348-.432-.163-.415z"
          fill="#1E5AA6"
        />
        <path
          d="M17.74 8.032c0 .04.044 2.395.092 2.373.119-.056.146.066.146.066s.04.387-.062.439a1.503 1.503 0 01-.264.117l-.177-.129s-.18-.252-.22-.363a3.104 3.104 0 01-.074-.719c.017-.108.029-.738.02-.77-.008-.032-.04-.56-.02-.639.02-.08.147-.431.143-.431 0 0 .417.016.417.056z"
          fill="url(#GS_-__S__Georgia_and_S__Sandwich_Islands__paint0_linear)"
        />
        <path
          d="M17.332 7.629c.086 0 .151.072.172.136.004.027-.008.047-.004.1.004.051-.621.011-.625.007 0 0 .29-.275.457-.243z"
          fill="#FF7000"
        />
        <path
          d="M17.73 7.806a.05.05 0 11-.1 0 .05.05 0 01.1 0z"
          fill="#000"
        />
        <path
          d="M16.138 7.443s.325.344.536.34c.038.101-.096.195-.15.24-.107-.033-.204.006-.452-.293.015-.19.07-.28.066-.287zm1.294-1.732c.03.221.549.492.698.308-.015.083.012.34-.776.336.299.277-.297.576-.466.508.31-.232-.088-.37-.31-.22.042-.128.352-.767.854-.932z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.906 7.26c-.059-.243-.087-.522.043-.629-.172-.116-.36.004-.36.004 0 .003-.004.008-.01.015-.04.055-.173.24.01.573-.49-.127-.284.317-.248.35.019-.07.28-.137.344.225.022.074-.11.18-.152.214-.01.007-.015.011-.012.01 0 0 .414.085.468-.463a.847.847 0 00.404-.744c-.316.006-.455.354-.487.445z"
          fill="#00F"
        />
        <path
          d="M15.055 7.54s-.318.27-.498.183c-.134.08-.29-.06-.29-.06s.183.663.841.184a1.498 1.498 0 00-.053-.307z"
          fill="#F7FCFF"
        />
        <path
          d="M14.553 7.712c.027-.138.138-.206.226-.075.119.023.238-.452-.184-.374.12-.62-.237-.852-.237-.852s-.126.688-.069.815c.058.127-.084-.236-.54-.337-.007.52.51.763.51.763s.145.131.294.06z"
          fill="#00F"
        />
        <path
          d="M14.123 6.962c-.134.04-.46-.156-.253-.41-.678-.015-1.046-.587-.82-.478.225.109.386-.124.555 0-.207-.187.072-.337.072-.337s.578.169.681.67c-.034.097-.05.27-.057.262 0-.004-.358-.007-.178.293z"
          fill="#F7FCFF"
        />
        <path
          d="M15.422 4.672c-.064.186-.294.116-.294.116s.007.093-.016.138c.02.014.155.119.299.146.206.039.627-.068.769.09.142.157.134.284.134.284s-.184.02-.133.086c.033.042.125.073.133.117.026.138-.086.388-.046.481-.064.006-.069.071-.069.071-.003.074-.187.03-.187.03s.114-.288.122-.355c.008-.067-.08-.187-.15-.187-.068 0-.118.213-.118.213s-.034.16-.023.176l-.046-.052s-.018.065-.048.104c-.033.045-.078.064-.078.064s-.034-.098-.023-.135c.011-.037.188-.183.172-.288-.007-.046-.013-.127-.07-.153-.074-.034-.208-.01-.29-.026-.044.076-.065.493-.034.52.03.026-.076.082-.076.082l-.127.003c-.002-.056.075-.21.075-.342 0-.13.01-.27.01-.27s-.086.02-.13.104a.493.493 0 00-.035.22c.007.042.046.158.034.191-.011.034-.21.079-.21.079l-.008-.109s.084-.052.084-.183c0-.13.008-.318.004-.329-.002-.007-.069-.293-.157-.486-.058-.129-.148-.188-.153-.198-.011-.027-.011-.057-.011-.057s-.127.09-.276-.1c.137-.115.283-.03.283-.03s.039-.105.215-.098c.176.008.21.105.202.094 0 0 .13-.112.272-.011z"
          fill="#923F00"
        />
        <path
          d="M14.767 7.102l.806.515.725-.476s.151-.082.138-.14c-.013-.06-.065-.036-.091-.026-.026.01-.76.517-.76.517l-.78-.482s-.056-.017-.067.018c-.01.036.021.056.03.074z"
          fill="#B4B6B9"
        />
        <path
          d="M17.467 10.892s-.3-.02-.254.067c.025.048.422.042.422.042l-.168-.109zm.143.116l-.313.01s-.079.07-.084.086c-.005.017.052.021.052.021s.322.082.566.03c.123-.043.145-.093.059-.124-.087-.03-.278-.021-.28-.023z"
          fill="#FF7000"
        />
        <path
          d="M13.994 8.119s-.04.125 0 .187c.04.063.297.568.297.568s.174-.21.238-.216c.064-.005.035.546.035.546s-.105.096-.169.09c-.064-.005.157.217.151.404-.005.188-.29 1.12-.395 1.136-.104.017-.195-.175-.195-.342 0-.166.108-.43.102-.504-.006-.074-.52.792-.551.927a.416.416 0 00.028.118s-.202.017-.157.273c-.593-.205-.884-.557-.878-.915.002-.137-.129-.46 0-.816.207-.574.712-1.228.715-1.291.006-.103.047-.148.053-.205.005-.057-.018-.347.04-.398.058-.05.36-.176.436-.17.076.005.14.057.14.057s.285 0 .302.107c.018.109-.058.148-.058.148s.04.154-.134.296z"
          fill="#8A9396"
        />
        <path
          d="M14.164 11.341c.096.066.318.106.318.106s-.545.147-1.099-.138c-.05-.222.119-.272.16-.274.099-.025.525.24.62.306z"
          fill="#2B2B2B"
        />
        <path
          d="M14.83 11.317c.597.316.66.103 1.072-.196.028-.02.164.481.74.196.814-.402-.699-1.073-.913-1.059-.214.015-1.494.744-.898 1.06z"
          fill="#00713D"
        />
        <path
          d="M14.815 4.64s-.277-.364-.277-.447m.5.447s.277-.364.277-.447"
          stroke="#CDAD56"
          stroke-width=".25"
          stroke-linecap="round"
        />
        <path fill="#2B409A" d="M0 0h11.25v8.75H0z" />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="9"
        >
          <path fill="#fff" d="M0 0h11.25v8.75H0z" />
        </mask>
        <g mask="url(#b)">
          <path
            d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
            fill="#F7FCFF"
          />
          <path
            d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
            fill="#F50100"
          />
          <path
            d="M12.503 8.125L10.027 9.21-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
            fill="#F7FCFF"
          />
          <path
            d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
            fill="#F50100"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="14"
            height="11"
            fill="#000"
          >
            <path fill="#fff" d="M-1-1h14v11H-1z" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.24 0H4.99v3.75H0V5h4.99v3.75h1.25V5h5.01V3.75H6.24V0z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.24 0H4.99v3.75H0V5h4.99v3.75h1.25V5h5.01V3.75H6.24V0z"
            fill="#F50100"
          />
          <path
            d="M4.99 0v-.938h-.937V0h.937zm1.25 0h.938v-.938H6.24V0zM4.99 3.75v.938h.938V3.75H4.99zM0 3.75v-.938h-.938v.938H0zM0 5h-.938v.938H0V5zm4.99 0h.938v-.938H4.99V5zm0 3.75h-.937v.938h.937V8.75zm1.25 0v.938h.938V8.75H6.24zm0-3.75v-.938h-.937V5h.937zm5.01 0v.938h.938V5h-.938zm0-1.25h.938v-.938h-.938v.938zm-5.01 0h-.937v.938h.937V3.75zM4.99.937h1.25V-.938H4.99V.938zm.938 2.813V0H4.053v3.75h1.875zM0 4.688h4.99V2.813H0v1.874zM.938 5V3.75H-.938V5H.938zm4.052-.938H0v1.875h4.99V4.063zm.938 4.688V5H4.053v3.75h1.875zm.312-.938H4.99v1.875h1.25V7.813zM5.303 5v3.75h1.875V5H5.303zm5.947-.938H6.24v1.875h5.01V4.063zm-.938-.312V5h1.876V3.75h-1.876zm-4.072.938h5.01V2.813H6.24v1.874zM5.303 0v3.75h1.875V0H5.303z"
            fill="#F7FCFF"
            mask="url(#c)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="GS_-__S__Georgia_and_S__Sandwich_Islands__paint0_linear"
          x1="17.672"
          y1="9.754"
          x2="18.136"
          y2="9.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D5DFFF" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <filter
          id="GS_-__S__Georgia_and_S__Sandwich_Islands__filter0_d"
          x="14.789"
          y="6.019"
          width="1.623"
          height=".921"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy=".25" />
          <feColorMatrix
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="GT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 0h6v15h-6V0zM0 0h6v15H0V0z"
          fill="#58A5FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 0h8v15H6V0z"
          fill="#fff"
        />
        <path
          d="M7.978 10.648l-.454-.43 4.804-5.08.455.43-4.805 5.08z"
          fill="#C6C6C6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.115 5.066s-1.538.928-1.538 3.255 3.745 2.642 3.745 2.642-2.24-1.367-2.534-2.345c-.293-.979.327-3.552.327-3.552z"
          fill="#5AB92D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.909 5.066s1.538.928 1.538 3.255-3.745 2.642-3.745 2.642 2.355-1.35 2.685-2.642c.33-1.291-.478-3.255-.478-3.255z"
          fill="#5AB92D"
        />
        <path
          d="M9.255 4.75l.622.056c-.02.226.103.455.408.702.98.793 1.507 1.782 1.094 2.906-.3.815-.707 1.504-1.222 2.063l-.46-.423c.458-.497.823-1.114 1.095-1.856.297-.807-.104-1.56-.9-2.204-.454-.367-.679-.786-.637-1.244z"
          fill="#5AB92D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.859 6.13l.655 1.854h-.482s-.173.585.155.585h2.017s.22-.146.11-.585c-.11-.438-.665-1.648-.665-1.648s.237-.2.237-.35c0-.149-.237-.165-.237-.165H9.152c-.19.033-.293.31-.293.31z"
          fill="#EFE298"
        />
      </g>
    </symbol>
    <symbol id="GU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 2h16v11H2V2z"
          fill="#4564F9"
        />
        <path
          d="M2.625 2.625h14.75v9.75H2.625v-9.75z"
          stroke="#CBDAFF"
          stroke-opacity=".12"
          stroke-width="1.25"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="2"
          y="2"
          width="16"
          height="11"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2 2h16v11H2V2z"
            fill="#fff"
          />
          <path
            d="M2.625 2.625h14.75v9.75H2.625v-9.75z"
            stroke="#fff"
            stroke-width="1.25"
          />
        </mask>
        <g mask="url(#b)">
          <path
            opacity=".4"
            d="M10.25 3l.406-.81-.415-.208-.412.216.421.802zm0 0l.407-.81h0l.002.001.004.002.011.006.036.019c.03.016.072.038.123.067a9.147 9.147 0 011.655 1.201c.886.814 1.918 2.124 1.918 3.855 0 1.715-1.016 3.1-1.885 3.982a10.4 10.4 0 01-1.753 1.422l-.035.022-.011.007-.004.002h-.001v.001L10.25 12m0-9l-.422-.802h0-.002l-.003.003-.011.006-.036.02-.122.068a9.584 9.584 0 00-1.646 1.223c-.877.816-1.914 2.127-1.914 3.823 0 1.68 1.02 3.065 1.881 3.95a10.929 10.929 0 001.745 1.446l.035.022.01.007.004.002h.001v.001l.48-.769m0 0l.466.777-.475.285-.47-.292.479-.77z"
            fill="#CCE0E5"
            stroke="#6D87FB"
            stroke-width="1.813"
          />
          <path
            d="M10.25 3.773l.43-.798-.44-.236-.434.244.444.79zm0 0l.43-.798.002.001.003.002.01.006.03.016.1.059a7.307 7.307 0 011.311 1.02c.702.692 1.52 1.807 1.52 3.276 0 1.454-.804 2.627-1.488 3.374a8.396 8.396 0 01-1.384 1.203l-.03.02-.009.005-.003.003h-.001c-.001 0-.001.001-.491-.761m0-7.426a127.9 127.9 0 00-.445-.79l-.002.002-.003.002-.01.005-.03.017a6.89 6.89 0 00-.425.278 7.667 7.667 0 00-.975.82c-.694.692-1.516 1.806-1.516 3.248 0 1.426.808 2.6 1.485 3.346a8.803 8.803 0 001.375 1.222l.028.02.01.006.003.002.001.001.504-.753m0 0l.49.762-.5.32-.493-.329.503-.753z"
            fill="#CCE0E5"
          />
          <path
            d="M10.25 3.773l.43-.798-.44-.236-.434.244.444.79zm0 0l.43-.798h0l.002.001.003.002.01.006.03.016.1.059a7.307 7.307 0 011.311 1.02c.702.692 1.52 1.807 1.52 3.276 0 1.454-.804 2.627-1.488 3.374a8.396 8.396 0 01-1.384 1.203l-.03.02-.009.005-.003.003h-.001 0c-.001 0-.001.001-.491-.761m0-7.426a127.9 127.9 0 00-.445-.79h0l-.002.002-.003.002-.01.005-.03.017a6.89 6.89 0 00-.425.278 7.667 7.667 0 00-.975.82c-.694.692-1.516 1.806-1.516 3.248 0 1.426.808 2.6 1.485 3.346a8.803 8.803 0 001.375 1.222l.028.02.01.006.003.002h0l.001.001.504-.753m0 0l.49.762-.5.32-.493-.329.503-.753z"
            stroke="#C1C9F1"
            stroke-opacity=".748"
            stroke-width="1.813"
          />
          <path
            d="M10.25 3.773l.43-.798-.44-.236-.434.244.444.79zm0 0l.43-.798h0l.002.001.003.002.01.006.03.016.1.059a7.307 7.307 0 011.311 1.02c.702.692 1.52 1.807 1.52 3.276 0 1.454-.804 2.627-1.488 3.374a8.396 8.396 0 01-1.384 1.203l-.03.02-.009.005-.003.003h-.001 0c-.001 0-.001.001-.491-.761m0-7.426a127.9 127.9 0 00-.445-.79h0l-.002.002-.003.002-.01.005-.03.017a6.89 6.89 0 00-.425.278 7.667 7.667 0 00-.975.82c-.694.692-1.516 1.806-1.516 3.248 0 1.426.808 2.6 1.485 3.346a8.803 8.803 0 001.375 1.222l.028.02.01.006.003.002h0l.001.001.504-.753m0 0l.49.762-.5.32-.493-.329.503-.753z"
            stroke="#C51918"
            stroke-width="1.813"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="7"
            y="3"
            width="6"
            height="9"
          >
            <path
              d="M10.832 9.503c-.2.218-.4.404-.575.552a6.903 6.903 0 01-.586-.572c-.573-.631-1.015-1.38-1.015-2.128 0-.734.428-1.41.984-1.965.216-.216.434-.395.618-.533.18.132.394.305.606.513.548.54.98 1.216.98 1.985 0 .783-.446 1.532-1.012 2.148z"
              fill="#fff"
            />
            <path
              d="M10.832 9.503c-.2.218-.4.404-.575.552a6.903 6.903 0 01-.586-.572c-.573-.631-1.015-1.38-1.015-2.128 0-.734.428-1.41.984-1.965.216-.216.434-.395.618-.533.18.132.394.305.606.513.548.54.98 1.216.98 1.985 0 .783-.446 1.532-1.012 2.148z"
              stroke="#fff"
              stroke-width="1.813"
            />
          </mask>
          <g mask="url(#c)">
            <path
              fill="#91CBCB"
              d="M8.083 8.75h4.667v.938H8.083z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.501 9.499s3.309 0 3.613-.113c.304-.114-.571 2.192-1.689 2.192s-1.924-2.08-1.924-2.08z"
              fill="#FDF9A1"
            />
            <path
              d="M11.621 9.222l-.594.457c-.937-1.217-1.33-2.477-1.162-3.762l.743.097c-.14 1.077.192 2.14 1.013 3.208z"
              fill="#A68861"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.246 6.023l-.567.664c-.021.025-.062.005-.054-.027l.195-.829h-.887c-.034 0-.044-.046-.013-.06l.758-.332-.538-.709c-.019-.025.007-.06.036-.048l.847.33.193-.777c.008-.032.053-.032.06 0l.192.777.84-.327c.03-.011.055.024.035.05l-.581.704.801.332c.032.013.022.06-.012.06h-.79l.12.848c.005.031-.034.049-.054.025l-.581-.681zM9.75 8.125h3v.656h-3v-.656z"
              fill="#239E46"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.295 7.745h-.003a.137.137 0 01-.063.08.24.24 0 01-.131.033.293.293 0 01-.117-.024.247.247 0 01-.092-.067.324.324 0 01-.06-.112.497.497 0 01-.021-.153c0-.057.007-.108.021-.152a.309.309 0 01.06-.111.258.258 0 01.094-.068.306.306 0 01.122-.024.28.28 0 01.157.041.276.276 0 01.097.11l-.069.04a.194.194 0 00-.071-.086.2.2 0 00-.114-.031.212.212 0 00-.084.016.191.191 0 00-.108.117.27.27 0 00-.015.092v.111c0 .034.005.065.015.093a.187.187 0 00.11.117.247.247 0 00.159.007.17.17 0 00.057-.028.132.132 0 00.052-.113v-.068h-.154v-.073h.236v.354h-.078v-.1zm.522-.586v.425c0 .066.012.115.037.15.025.033.068.05.13.05s.105-.017.13-.05a.251.251 0 00.037-.15v-.425h.084v.405c0 .05-.005.093-.013.13a.226.226 0 01-.044.092.179.179 0 01-.079.054.347.347 0 01-.118.018.339.339 0 01-.117-.018.172.172 0 01-.077-.054.224.224 0 01-.041-.092.594.594 0 01-.013-.13V7.16h.084zm1.223.687l-.07-.203h-.282l-.07.203h-.085l.244-.687h.107l.244.687h-.088zm-.209-.61h-.005l-.118.334h.241l-.118-.335zm1.157.031h-.005l-.059.115-.167.3-.167-.3-.059-.115h-.005v.579h-.082v-.687h.112l.2.37h.005l.201-.37h.108v.687h-.082v-.579z"
              fill="#C51918"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="GW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M10 0h10v7.5H10V0z" fill="#FBCD17" />
        <path d="M10 7.5h10V15H10V7.5z" fill="#0B9E7A" />
        <path d="M0 0h10v15H0V0z" fill="#E11C1B" />
        <path
          d="M5.582 9.129L3.403 10.64 4.1 8.052 2.5 6.399l2.165-.09.917-2.559.916 2.56H8.66L7.064 8.051l.8 2.435L5.581 9.13z"
          fill="#1D1D1D"
        />
      </g>
    </symbol>
    <symbol id="GY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#5EAA22"
        />
        <path
          d="M.625 14.117V.883L19.372 7.5.625 14.117z"
          fill="#FECA00"
          stroke="#F7FCFF"
          stroke-width="1.25"
        />
        <path
          d="M-.625 14.972V.028L8.982 7.5l-9.607 7.472z"
          fill="#E11C1B"
          stroke="#272727"
          stroke-width="1.25"
        />
      </g>
    </symbol>
    <symbol id="HK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#EA1A1A"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <g filter="url(#HK_-_Hong_Kong__filter0_d)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.918 7.234s-3.618-3.227.7-5.107c0 0 1.256 1.385.314 2.94-.31.51-.57.875-.766 1.149-.401.56-.53.741-.248 1.018zm-5.34-2.317c-.249 4.703 4.256 2.91 4.256 2.91-.374.129-.478-.068-.8-.677a16.823 16.823 0 00-.685-1.199c-.97-1.538-2.771-1.034-2.771-1.034zm6.82 2.475s4.646 1.39 1.53 4.923c0 0-1.724-.723-1.53-2.531.065-.593.146-1.033.208-1.364.126-.678.167-.897-.207-1.028zm-1.22 1.084s.833 4.776-3.72 3.57c0 0-.123-1.866 1.58-2.5.56-.209.99-.332 1.314-.425.662-.19.876-.252.826-.645zm5.746-2.054c-2.847-3.751-5.128.527-5.128.527.202-.34.409-.257 1.048 0 .312.126.728.293 1.297.473 1.734.548 2.783-1 2.783-1z"
              fill="#fff"
            />
          </g>
          <path
            d="M6.35 6.38s.91 1.432 2.4 1.432m1.163-3.406s-.817 1.507-.117 2.822m4.023-1.127s-1.907-.289-2.904.818m1.79 2.671s-.38-1.89-1.762-2.448m-2.235 3.475s1.646-1.004 1.698-2.494"
            stroke="#EA1A1A"
            stroke-width=".625"
          />
        </g>
      </g>
      <defs>
        <filter
          id="HK_-_Hong_Kong__filter0_d"
          x="3.568"
          y="1.127"
          width="13.356"
          height="12.188"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation=".5" />
          <feColorMatrix
            values="0 0 0 0 0.6 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="HM" width="20" height="53" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#2E42A5"
        />
        <path fill="#2E42A5" d="M0 0h11v9H0z" />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="11"
          height="9"
        >
          <path fill="#fff" d="M0 0h11v9H0z" />
        </mask>
        <g mask="url(#b)">
          <path
            d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
            fill="#F7FCFF"
          />
          <path
            d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
            fill="#F50100"
          />
          <path
            d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
            fill="#F7FCFF"
          />
          <path
            d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
            fill="#F50100"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="13"
            height="11"
            fill="#000"
          >
            <path fill="#fff" d="M-1-1h13v11H-1z" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
            fill="#F50100"
          />
          <path
            d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
            fill="#F7FCFF"
            mask="url(#c)"
          />
        </g>
      </g>
      <path
        d="M5.92 12.278l-.82.758.081-1.114-1.104-.168.922-.631-.557-.968 1.068.327.41-1.039.41 1.039 1.068-.327-.557.968.922.63-1.104.17.081 1.113-.82-.758zm7.32-3.981l-.547.505.054-.743-.735-.112.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.645.613.421-.735.112.054.743-.547-.505zm1.28-5.334l-.547.506.054-.743-.735-.112.614-.42-.371-.646.712.218.273-.693.273.693.712-.218-.37.645.613.42-.735.113.054.743-.547-.506zm3.2 2.667l-.547.505.054-.742-.735-.113.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.646.613.42-.735.113.054.742-.547-.505zm-2.56 7.667l-.547.505.054-.742-.735-.113.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.646.613.42-.735.113.054.742-.547-.505zM17.4 9.14l-.555.291.106-.618-.45-.438.621-.09.278-.563.278.562.62.09-.449.439.107.618-.556-.292z"
        fill="#F7FCFF"
      />
      <path
        d="M14.846 51.778l1.5.025"
        stroke="#979797"
        stroke-width="2"
      />
    </symbol>
    <symbol id="HN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g
          mask="url(#b)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#4564F9"
        >
          <path
            d="M0 0v5h20V0H0zm0 10v5h20v-5H0zm10.511-1.793l-.734.387.14-.818-.595-.64h.822l.367-.804.368.804h.821l-.594.64.14.818-.735-.387zm-3.75-1.25l-.734.387.14-.818-.595-.64h.822l.367-.804.368.804h.821l-.594.64.14.818-.735-.387zm0 2.5l-.734.387.14-.818-.595-.64h.822l.367-.804.368.804h.821l-.594.64.14.818-.735-.387zm7.5-2.5l-.734.387.14-.818-.595-.64h.822l.367-.804.368.804h.821l-.594.64.14.818-.735-.387zm0 2.5l-.734.387.14-.818-.595-.64h.822l.367-.804.368.804h.821l-.594.64.14.818-.735-.387z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="HR" width="20" height="15" fill="none">
      <g mask="url(#HR_-_Croatia_(Hrvatska)__a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <g mask="url(#HR_-_Croatia_(Hrvatska)__b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#E31D1C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#3D58DB"
          />
          <path fill="#E31D1C" d="M6.298 3.998h7.125v2.5H6.298z" />
          <path
            d="M6.658 5.6h6.33c.01.48.014 1.319.014 2.126 0 .521-.002 1.023-.003 1.394l-.002.446v.144a3.071 3.071 0 01-.092.37 3.428 3.428 0 01-.433.895c-.434.634-1.222 1.286-2.69 1.286s-2.218-.651-2.617-1.279a3.23 3.23 0 01-.461-1.261l-.002-.011v-.03l-.001-.122-.006-.443A2267.225 2267.225 0 016.658 5.6zM6.7 9.7c0-.001 0-.001 0 0h0z"
            fill="#F7FCFF"
            stroke="#E31D1C"
            stroke-width=".703"
          />
          <g mask="url(#HR_-_Croatia_(Hrvatska)__c)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.562 5.65H7.88v1.339H6.562v-1.34zm2.636 1.339H7.88v1.338H6.562v1.339H7.88v1.339H6.562v1.338H7.88v-1.338h1.318v1.338h1.319v-1.338h1.318v1.338h1.318v-1.338h-1.318V9.666h1.318V8.327h-1.318V6.99h1.318V5.65h-1.318v1.34h-1.318V5.65H9.198v1.34zm0 1.338V6.99h1.319v1.338H9.198zm0 1.339V8.327H7.88v1.339h1.318zm1.319 0v1.339H9.198V9.666h1.319zm0 0V8.327h1.318v1.339h-1.318z"
              fill="#F50100"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.533 5.102s.408-.218.756-.33c.348-.113.622-.174.622-.174L7.394 2.69l-1.036-.387-.587.968.762 1.83z"
            fill="#56C6F5"
            stroke="#fff"
            stroke-width=".5"
          />
          <path
            d="M6.363 4.057l.12-.058c.122.263.284.345.507.262.227-.085.32-.245.286-.5l.131-.016c.04.315-.086.535-.372.641-.29.109-.521-.007-.672-.33z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.645 3.464l-.114.069a.034.034 0 01-.05-.036l.025-.13-.116-.065a.034.034 0 01.005-.061l.126-.043-.003-.133c0-.03.034-.046.057-.027l.1.088.114-.069a.034.034 0 01.05.036l-.025.13.116.064a.034.034 0 01-.005.062l-.126.043.003.133c0 .03-.034.046-.057.026l-.1-.087z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.088 4.422s.348-.03.713-.024c.365.008.675.01.675.01l.178-1.88-.783-.708-.87.724.087 1.878z"
            fill="#56C6F5"
            stroke="#fff"
            stroke-width=".5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.844 4.116c.301 0 .33-.326.33-.548-.077-.123-.061-.21-.308-.21-.248 0-.276.074-.348.21 0 .222.024.548.326.548zm.339-.92c.302 0 .33-.326.33-.548-.077-.123-.061-.21-.308-.21s-.275.074-.348.21c0 .222.025.548.326.548zm-.659 0c.301 0 .33-.326.33-.548-.077-.123-.061-.21-.308-.21s-.276.074-.348.21c0 .222.024.548.326.548z"
            fill="#FECA00"
          />
          <path
            d="M7.643 4.627l.072.244.243-.077h.004l.012-.005.047-.014a7.37 7.37 0 01.16-.046c.13-.036.279-.072.383-.087a5.6 5.6 0 01.514-.043l.042-.002h.014l.262-.012-.022-.26-.158-1.828-.01-.115-.094-.067-.852-.605-.175-.125-.15.155-.774.803-.1.104.04.14.542 1.84z"
            fill="#2E42A5"
            stroke="#fff"
            stroke-width=".5"
          />
          <g mask="url(#HR_-_Croatia_(Hrvatska)__d)" fill="#C51918">
            <path
              d="M7.773 4.149l-.157-.37c.336-.146.904-.237 1.502-.272l.023.401c-.555.033-1.081.115-1.368.24zm-.264-.892l-.157-.37c.336-.146 1.059-.266 1.657-.3l.023.4c-.556.033-1.236.144-1.523.27z"
            />
          </g>
          <path
            d="M11.988 4.621l-.068.252-.248-.079h0-.004l-.013-.005-.047-.014a7.505 7.505 0 00-.16-.046 3.4 3.4 0 00-.382-.087 5.604 5.604 0 00-.515-.043l-.042-.002h-.013 0-.001 0l-.261-.012.022-.26.158-1.828.01-.115.094-.067.852-.605.18-.128.15.163.729.8.092.1-.035.133-.498 1.843z"
            fill="#2E42A5"
            stroke="#fff"
            stroke-width=".5"
          />
          <g
            mask="url(#HR_-_Croatia_(Hrvatska)__e)"
            fill-rule="evenodd"
            clip-rule="evenodd"
          >
            <path
              d="M11.499 4.042s.183-.103.21-.275c.026-.173.31-.385.168-.36-.142.026-.06.045-.266 0-.206-.045-.472-.074-.472-.201 0-.126.132-.227.024-.227-.108 0-.34-.12-.293-.028.047.091-.106-.012-.03.178.077.19-.016.381.03.432.047.05-.03.297-.03.297s.028.092.077-.046c.05-.137.157-.233.103-.116-.053.116-.122.394-.06.346a.434.434 0 00.121-.23c0-.045.155-.224.155-.089s-.146.241-.073.241c.072 0 .113.029.159-.106s.157-.224.202-.135c.046.09.036.085-.025.202s0 .117 0 .117z"
              fill="#FECA00"
            />
            <path
              d="M11.067 3.042l-.068-.115c.122-.076.235-.096.334-.053a.82.82 0 01.167.103l.012.008c.092.064.14.09.17.09v.134c-.068 0-.127-.032-.245-.114l-.012-.008a.818.818 0 00-.143-.09c-.055-.023-.125-.01-.215.045zm-.216.873a.07.07 0 00.07-.07.07.07 0 00-.07-.07.07.07 0 00-.07.07c0 .039.03.07.07.07zm.202.064a.07.07 0 01-.07.07.07.07 0 01-.07-.07.07.07 0 01.07-.07.07.07 0 01.07.07zm.166.064a.07.07 0 00.07-.07.07.07 0 00-.07-.069.07.07 0 00-.07.07c0 .038.031.07.07.07zm.29.042a.07.07 0 01-.07.07.07.07 0 01-.07-.07.07.07 0 01.07-.07.07.07 0 01.07.07z"
              fill="#C51918"
            />
          </g>
          <path
            d="M13.431 5.154l-.108.248-.239-.127h0l-.003-.002-.013-.007a5.813 5.813 0 00-.698-.304 8.06 8.06 0 00-.556-.157l-.034-.008-.008-.002h-.002 0l-.26-.058.073-.255.529-1.86.034-.121.119-.045L13.3 2.07l.194-.072.108.177.587.967.067.11-.052.12-.774 1.783z"
            fill="#56C6F5"
            stroke="#fff"
            stroke-width=".5"
          />
          <g mask="url(#HR_-_Croatia_(Hrvatska)__f)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.205 3.18l-.09.1a.034.034 0 01-.058-.02l-.014-.132-.13-.027a.034.034 0 01-.013-.06l.108-.078-.041-.127a.034.034 0 01.046-.041l.121.054.089-.099a.034.034 0 01.059.02l.013.132.13.027a.034.034 0 01.013.06l-.107.078.041.127a.034.034 0 01-.046.041l-.121-.054z"
              fill="#FECA00"
            />
            <path
              d="M11.872 4.055l.133-.518c.588.155 1.2.354 1.65.546l-.205.494a12.27 12.27 0 00-1.578-.522z"
              fill="#E31D1C"
            />
            <path
              d="M12.052 3.576l.031-.13c.564.14 1.163.363 1.598.571l-.056.121a8.832 8.832 0 00-1.573-.562zm-.167.534l.031-.13a8.11 8.11 0 011.52.538l-.056.121a7.981 7.981 0 00-1.495-.529z"
              fill="#fff"
            />
            <path
              d="M12.14 3.86l.12-.055c.05.119.114.145.219.094.247-.12.862.048.862.275 0 .088-.051.142-.13.139a.413.413 0 01-.16-.054.82.82 0 00-.13-.063l.043-.128a.852.852 0 01.144.07.341.341 0 00.109.04c.001 0-.008.01-.008-.004 0-.1-.5-.237-.674-.152-.174.084-.316.025-.396-.163z"
              fill="#272727"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="HT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 7.5V15h20V7.5H0z"
            fill="#E31D1C"
          />
          <path fill="#fff" d="M6.25 5h7.5v5h-7.5z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="6"
            y="5"
            width="8"
            height="5"
          >
            <path fill="#fff" d="M6.25 5h7.5v5h-7.5z" />
          </mask>
          <g mask="url(#c)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.25 9.111s1.8-.473 3.75-.444c1.95.029 3.75.555 3.75.555V10h-7.5v-.889z"
              fill="#279E19"
            />
            <path
              d="M10.046 5.563s-.582-.262-.988-.262-.632.4-.632.4"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M10.175 5.826s-.535-.192-.909-.192-.581.293-.581.293"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M10.175 6.048s-.396-.191-.672-.191c-.277 0-.43.292-.43.292"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M10.012 6.27s-.244-.191-.415-.191c-.17 0-.266.292-.266.292"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M9.992 6.422s-.098-.12-.167-.12c-.068 0-.106.184-.106.184m.235-.923s.582-.262.988-.262.632.4.632.4"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M9.825 5.826s.535-.192.909-.192.581.293.581.293"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M9.825 6.048s.396-.191.672-.191c.277 0 .43.292.43.292"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M9.988 6.27s.244-.191.415-.191c.17 0 .266.292.266.292"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              d="M10.008 6.422s.098-.12.167-.12c.068 0 .106.184.106.184"
              stroke="#026A16"
              stroke-width=".5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.93 6.499s-.072.836-.072 1.176c0 .34.072 1.074.072 1.074h.183V7.675c0-.284-.107-1.176-.107-1.176H9.93z"
              fill="#FECA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.208 7.449s-.453.242-.453.96l.453.865h.816V7.848l-.816-.399z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.537 6.766S7.48 7.08 7.48 8.234l1.37.117s-.076-.671.346-.981l-.66-.604z"
              fill="#0A328C"
            />
            <path
              d="M8.1 6.326l1.813 1.66M7.471 6.702l2.528 1.642M7.036 7.337l2.85 1.304"
              stroke="#FFD018"
              stroke-width=".5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.487 8.225l1.891.212-.106.263h-.3l.204.15.46.107V8.7h.404v.546h-.864l-.33-.396s-.28.274-.55.274c-.272 0-.54-.09-.54-.388v-.208l-.269-.091v-.212z"
              fill="#FECA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.534 7.449s.452.242.452.96l-.452.865h-.817V7.848l.817-.399z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.204 6.766s1.057.313 1.057 1.468l-1.369.117s.075-.671-.346-.981l.659-.604z"
              fill="#0A328C"
            />
            <path
              d="M11.64 6.326l-1.812 1.66m2.442-1.284L9.742 8.344m2.964-1.007l-2.85 1.304"
              stroke="#FFD018"
              stroke-width=".5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.254 8.225l-1.891.212.106.263h.3l-.204.15-.46.107V8.7H9.7v.546h.864l.331-.396s.278.274.55.274.54-.09.54-.388v-.208l.268-.091v-.212z"
              fill="#FECA00"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="HU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#F14423" />
          <path d="M0 10v5h20v-5H0z" fill="#5EAA22" />
        </g>
      </g>
    </symbol>
    <symbol id="ID" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v7.5h20V0H0z"
            fill="#E31D1C"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0z" fill="#FF8C1A" />
        <path d="M0 0h6v15H0V0z" fill="#5EAA22" />
        <path d="M6 0h8v15H6V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="IL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g
          mask="url(#b)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#3D58DB"
        >
          <path
            d="M0 2.5v2.228h20V2.5H0zm0 7.717V12.5h20v-2.283H0z"
          />
          <path
            d="M7.113 9.337h5.86l-2.9-5.013-2.96 5.013zm4.669-.688H8.317l1.75-2.963 1.715 2.963z"
          />
          <path
            d="M6.932 5.578h5.993l-2.84 5.029-3.153-5.029zm4.816.688H8.175l1.88 2.998 1.693-2.998z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.808 2.588a.059.059 0 01.104-.043c.28.307 1.023 1.072 1.452 1.072.537 0 2.645-1.776 3.268-1.487.623.29 1.885 3.316 1.885 3.316l-.822 1.031-1.063-.58-.2-2.28s-2.046 1.053-3.068.67l-.575.483s-.553-1.095-.771-1.43c-.144-.222-.193-.553-.21-.752z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.164 5.078l-.35.212.067-.45-.283-.317.39-.066.176-.408.175.408.39.066-.282.318.067.449-.35-.212zM8.133 2.37a.227.227 0 11.453 0v1.071a.227.227 0 11-.453 0V2.37z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.763 3.19c.051.026.038.1-.019.11-.41.075-1.451.3-1.678.663-.285.455.104 3.185-.471 3.56-.576.375-3.81-.158-3.81-.158l-.44-1.244 1.055-.594 2.04 1.038s.192-2.293 1.057-2.957l-.105-.743s1.223.111 1.622.104c.265-.005.571.13.749.22z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.933 3.02l.006-.41.345.295.42-.071-.152.366.254.365-.44-.068-.262.297-.12-.409-.416-.181.365-.184zm.763 3.983a.245.245 0 11-.265.412l-.968-.647a.225.225 0 01.244-.378l.99.613z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.29 13.115a.06.06 0 01-.088-.071c.14-.393.467-1.407.266-1.786-.252-.474-2.81-1.501-2.848-2.187-.037-.687 2.042-3.221 2.042-3.221l1.297.242-.013 1.21L8.028 8.55s1.889 1.312 2.031 2.394l.697.28s-.708 1.003-.902 1.353c-.128.231-.397.43-.565.538z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.851 10.75l.351.209-.427.152-.148.399-.242-.315-.442.037.278-.346-.126-.376.414.1.365-.27-.023.41zM6.94 9.348a.254.254 0 01-.183-.474l1.042-.407a.258.258 0 11.186.482l-1.045.4z"
            fill="#FECA00"
          />
          <path
            d="M8.54 6.103a.153.153 0 01-.094-.193c.027-.08.151-.213.23-.186l1.084.38a.15.15 0 01.1.13l.097 1.19c.007.084-.115.152-.197.16a.15.15 0 01-.16-.14l-.09-1.023-.97-.318z"
            fill="#FECA00"
          />
          <path
            d="M10.425 5.48c.065-.052.181.008.231.074a.155.155 0 01-.026.214l-.751.77c-.065.052-.21-.049-.261-.115-.05-.066-.065-.247 0-.3l.807-.643z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#FF8C1A" />
          <path d="M0 10v5h20v-5H0z" fill="#5EAA22" />
          <path
            d="M7.5 7.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm4.375 0a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0z"
            fill="#3D58DB"
          />
          <path
            d="M9.997 8.038l-.522 1.921.306-1.967-1.258 1.543 1.079-1.673-1.776.898 1.666-1.089-1.989.098 1.965-.318-1.856-.719 1.925.51-1.403-1.413 1.55 1.248-.707-1.86.91 1.77L9.996 5l.11 1.987.91-1.77-.708 1.86 1.55-1.248-1.402 1.412 1.924-.509-1.856.72 1.965.317-1.988-.098 1.666 1.09-1.777-.899 1.08 1.673-1.258-1.543.305 1.967-.521-1.921z"
            fill="#3D58DB"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-.941 1.657l.93.886c.767-.726 1.491-1.068 2.18-1.068.332 0 .473.08.857.443.608.575 1.018.807 1.787.807.77 0 1.179-.232 1.787-.807.384-.363.525-.443.858-.443.332 0 .474.08.857.443.609.575 1.018.807 1.787.807.77 0 1.18-.232 1.787-.807.384-.363.526-.443.858-.443.333 0 .474.08.858.443.608.575 1.017.807 1.787.807s1.178-.232 1.787-.807c.383-.363.525-.443.857-.443.689 0 1.413.342 2.18 1.068l.93-.886C20.15.716 19.11.225 18.036.225c-.769 0-1.178.232-1.787.807-.383.363-.525.443-.857.443-.333 0-.474-.08-.858-.443-.608-.575-1.018-.807-1.787-.807-.77 0-1.179.232-1.787.807-.384.363-.525.443-.858.443-.332 0-.474-.08-.857-.443C8.637.457 8.227.225 7.458.225c-.77 0-1.18.232-1.787.807-.384.363-.525.443-.858.443-.332 0-.474-.08-.858-.443C3.347.457 2.938.225 2.168.225 1.093.225.055.716-.942 1.657zm.93 3.386l-.93-.886c.996-.941 2.034-1.432 3.11-1.432.769 0 1.178.232 1.786.807.384.363.526.443.858.443.333 0 .474-.08.858-.443.608-.575 1.017-.807 1.787-.807s1.178.232 1.787.807c.383.363.525.443.857.443.333 0 .474-.08.858-.443.608-.575 1.018-.807 1.787-.807.77 0 1.179.232 1.787.807.384.363.525.443.858.443.332 0 .474-.08.857-.443.609-.575 1.018-.807 1.787-.807 1.075 0 2.114.491 3.11 1.432l-.93.886c-.767-.726-1.491-1.068-2.18-1.068-.332 0-.474.08-.857.443-.608.575-1.018.807-1.787.807-.77 0-1.18-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.332 0-.474.08-.858.443-.608.575-1.017.807-1.787.807s-1.178-.232-1.787-.807c-.383-.363-.525-.443-.857-.443-.333 0-.474.08-.858.443-.608.575-1.018.807-1.787.807-.77 0-1.179-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.688 0-1.412.342-2.18 1.068zm0 2.5l-.93-.886c.996-.941 2.034-1.432 3.11-1.432.769 0 1.178.232 1.786.807.384.363.526.443.858.443.333 0 .474-.08.858-.443.608-.575 1.017-.807 1.787-.807s1.178.232 1.787.807c.383.363.525.443.857.443.333 0 .474-.08.858-.443.608-.575 1.018-.807 1.787-.807.77 0 1.179.232 1.787.807.384.363.525.443.858.443.332 0 .474-.08.857-.443.609-.575 1.018-.807 1.787-.807 1.075 0 2.114.491 3.11 1.432l-.93.886c-.767-.726-1.491-1.068-2.18-1.068-.332 0-.474.08-.857.443-.608.575-1.018.807-1.787.807-.77 0-1.18-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.332 0-.474.08-.858.443-.608.575-1.017.807-1.787.807s-1.178-.232-1.787-.807c-.383-.363-.525-.443-.857-.443-.333 0-.474.08-.858.443-.608.575-1.018.807-1.787.807-.77 0-1.179-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.688 0-1.412.342-2.18 1.068zm0 2.5l-.93-.886c.996-.941 2.034-1.432 3.11-1.432.769 0 1.178.232 1.786.807.384.363.526.443.858.443.333 0 .474-.08.858-.443.608-.575 1.017-.807 1.787-.807s1.178.232 1.787.807c.383.363.525.443.857.443.333 0 .474-.08.858-.443.608-.575 1.018-.807 1.787-.807.77 0 1.179.232 1.787.807.384.363.525.443.858.443.332 0 .474-.08.857-.443.609-.575 1.018-.807 1.787-.807 1.075 0 2.114.491 3.11 1.432l-.93.886c-.767-.726-1.491-1.068-2.18-1.068-.332 0-.474.08-.857.443-.608.575-1.018.807-1.787.807-.77 0-1.18-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.332 0-.474.08-.858.443-.608.575-1.017.807-1.787.807s-1.178-.232-1.787-.807c-.383-.363-.525-.443-.857-.443-.333 0-.474.08-.858.443-.608.575-1.018.807-1.787.807-.77 0-1.179-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.688 0-1.412.342-2.18 1.068zm0 2.5l-.93-.886c.996-.941 2.034-1.432 3.11-1.432.769 0 1.178.232 1.786.807.384.363.526.443.858.443.333 0 .474-.08.858-.443.608-.575 1.017-.807 1.787-.807s1.178.232 1.787.807c.383.363.525.443.857.443.333 0 .474-.08.858-.443.608-.575 1.018-.807 1.787-.807.77 0 1.179.232 1.787.807.384.363.525.443.858.443.332 0 .474-.08.857-.443.609-.575 1.018-.807 1.787-.807 1.075 0 2.114.491 3.11 1.432l-.93.886c-.767-.726-1.491-1.068-2.18-1.068-.332 0-.474.08-.857.443-.608.575-1.018.807-1.787.807-.77 0-1.18-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.332 0-.474.08-.858.443-.608.575-1.017.807-1.787.807s-1.178-.232-1.787-.807c-.383-.363-.525-.443-.857-.443-.333 0-.474.08-.858.443-.608.575-1.018.807-1.787.807-.77 0-1.179-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.688 0-1.412.342-2.18 1.068zm0 2.5l-.93-.886c.996-.941 2.034-1.432 3.11-1.432.769 0 1.178.232 1.786.807.384.363.526.443.858.443.333 0 .474-.08.858-.443.608-.575 1.017-.807 1.787-.807s1.178.232 1.787.807c.383.363.525.443.857.443.333 0 .474-.08.858-.443.608-.575 1.018-.807 1.787-.807.77 0 1.179.232 1.787.807.384.363.525.443.858.443.332 0 .474-.08.857-.443.609-.575 1.018-.807 1.787-.807 1.075 0 2.114.491 3.11 1.432l-.93.886c-.767-.726-1.491-1.068-2.18-1.068-.332 0-.474.08-.857.443-.608.575-1.018.807-1.787.807-.77 0-1.18-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.332 0-.474.08-.858.443-.608.575-1.017.807-1.787.807s-1.178-.232-1.787-.807c-.383-.363-.525-.443-.857-.443-.333 0-.474.08-.858.443-.608.575-1.018.807-1.787.807-.77 0-1.179-.232-1.787-.807-.384-.363-.525-.443-.858-.443-.688 0-1.412.342-2.18 1.068z"
            fill="#2E42A5"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="9"
            height="7"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 0h9v7H0V0z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)">
            <path fill="#2E42A5" d="M0 0h10v8H0z" />
            <path
              d="M-1.549 7.083l2.286.965L10.044.91 11.25-.524 8.806-.846 5.01 2.23 1.954 4.302-1.55 7.083z"
              fill="#fff"
            />
            <path
              d="M-1.236 7.76l1.164.56L10.817-.658H9.182L-1.236 7.759z"
              fill="#F50100"
            />
            <path
              d="M11.149 7.083l-2.286.965L-.444.91-1.65-.524.794-.846 4.59 2.23l3.056 2.072 3.503 2.781z"
              fill="#fff"
            />
            <path
              d="M11.07 7.569l-1.164.56L5.27 4.285l-1.374-.43-5.662-4.374H-.13l5.658 4.271 1.503.515 4.04 3.302z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="10"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13V9H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 0H4v3H0v1h4v4h1V4h6V3H5V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5 0H4v3H0v1h4v4h1V4h6V3H5V0z"
              fill="#F50100"
            />
            <path
              d="M4 0v-.5h-.5V0H4zm1 0h.5v-.5H5V0zM4 3v.5h.5V3H4zM0 3v-.5h-.5V3H0zm0 1h-.5v.5H0V4zm4 0h.5v-.5H4V4zm0 4h-.5v.5H4V8zm1 0v.5h.5V8H5zm0-4v-.5h-.5V4H5zm6 0v.5h.5V4H11zm0-1h.5v-.5H11V3zM5 3h-.5v.5H5V3zM4 .5h1v-1H4v1zM4.5 3V0h-1v3h1zM0 3.5h4v-1H0v1zm.5.5V3h-1v1h1zM4 3.5H0v1h4v-1zM4.5 8V4h-1v4h1zm.5-.5H4v1h1v-1zM4.5 4v4h1V4h-1zm6.5-.5H5v1h6v-1zm-.5-.5v1h1V3h-1zM5 3.5h6v-1H5v1zM4.5 0v3h1V0h-1z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <rect
            x="12.75"
            y="5.862"
            width=".625"
            height="7.888"
            rx=".313"
            fill="#D86D00"
          />
          <path
            d="M12.753 1.286c.638.876.72 2.052.638 3.105l-.498-.036c.077-1.005-.14-3.07-.14-3.07z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            d="M13.567 4.615l-.46-.19c.443-1.403 2.655-2.598 2.655-2.598-.99.474-1.327 1.757-2.195 2.788z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            d="M13.36 4.907l-.241-.426c1.182-.822 3.092-.999 3.092-.999-.985.28-1.98.958-2.85 1.425z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            d="M13.053 5.113l.208-.441c2.313.718 2.652 1.918 2.652 1.918-.304-.268-1.268-.768-2.86-1.477z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            d="M12.81 5.081l.49-.091c.17.862.609 1.384.84 1.937 0 0-1.297-.58-1.33-1.846z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            d="M12.772 4.677l.53.133c-.87 1.062-2.16 1.62-2.67 1.802 0 0 1.121-1.011 2.14-1.935z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            d="M13.007 4.447l-.08.494c-1.035-.316-2.897-.184-2.897-.184.782-.185 1.862-.492 2.977-.31z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            d="M13.097 4.195l-.204.443c-1.527-.66-2.344-1.895-2.344-1.895.052.227 1.199.868 2.548 1.452z"
            fill="#449A01"
            stroke="#fff"
            stroke-width=".15"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.945 9.567v-.09c-.288-.227-.59-.341-.905-.341a1.662 1.662 0 00-.918-.172v-.001c-.465-.05-.934.173-.934.173-.473 0-.905.341-.905.341v.09l.565.624s.159.601 1.272.46v.002s.737-.023.79-.042l.063-.021c.144-.046.31-.1.407-.399l.565-.624zm-1.825-.575c-.016.208-.108 1.46 0 1.655V8.992z"
            fill="#F50100"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.2 8.866c.06-.202.166-.271.422-.271.159 0 .279.04.362.12v.542h.045v.055c-.03.027-.045.081-.033.14a.18.18 0 00.018.054.198.198 0 00-.069-.012c-.077 0-.14.041-.14.092s.063.093.14.093c.077 0 .14-.042.14-.093 0 .026.016.05.042.066h-.071c0 .14-.065.228-.161.228-.068 0-.115-.034-.15-.11l-.096-.207-.01.233c-.003.082-.036.114-.117.114-.078 0-.134-.053-.172-.173a.208.208 0 00.035.003c.077 0 .14-.041.14-.092s-.063-.093-.14-.093a.205.205 0 00-.05.006.193.193 0 00.002-.083c-.015-.075-.067-.13-.117-.12-.05.01-.08.08-.064.156.003.02.01.037.018.053a.198.198 0 00-.069-.012c-.077 0-.14.042-.14.093 0 .05.063.092.14.092.063 0 .116-.027.134-.064l-.005.054c-.012.153-.05.225-.107.235-.076.014-.135.008-.175-.017l-.083-.049v.084a.434.434 0 01-.131-.017l-.01.048-.098-.102a.186.186 0 00.093-.023c.069-.036.104-.102.08-.147-.023-.045-.098-.052-.166-.016a.2.2 0 00-.05.037.21.21 0 00-.008-.043c-.023-.074-.08-.122-.13-.107-.024.008-.042.03-.05.06l-.044-.045-.038.045.08.084a.28.28 0 00.005.017c.02.068.072.114.118.11l.194.2v.002l.003.001.114.118.044.093a.513.513 0 00.064.17.142.142 0 01.004.03c0 .064.15.102.444.14.23.03.5.051.722.054h.056a6.57 6.57 0 00.722-.053c.293-.04.444-.077.444-.14 0-.042.037-.142.112-.294l.514-.532-.038-.045-.142.146a.227.227 0 00.008-.019c.022-.074 0-.146-.048-.16-.049-.016-.107.032-.13.106a.204.204 0 00-.008.043.201.201 0 00-.049-.037c-.068-.036-.143-.029-.167.016-.024.045.012.111.08.147.069.037.143.03.167-.015l.003-.006a.065.065 0 00.06.013l-.187.194-.018-.09a.434.434 0 01-.131.017v-.084l-.083.05c-.04.024-.099.03-.176.016-.056-.01-.094-.082-.106-.235l-.001-.014c.02.011.043.02.069.023.076.01.144-.021.151-.072.007-.05-.049-.1-.126-.111a.205.205 0 00-.052 0 .19.19 0 00.014-.085c-.004-.077-.049-.137-.1-.135-.05.003-.089.068-.085.145a.207.207 0 00.01.052.2.2 0 00-.064-.02c-.076-.01-.144.022-.151.072-.007.05.049.1.126.111a.175.175 0 00.11-.018l-.01.039c-.039.134-.097.193-.18.193-.08 0-.113-.032-.116-.114l-.01-.233-.096.208c-.035.075-.082.109-.15.109-.092 0-.155-.08-.16-.209a.203.203 0 00.054.008c.077 0 .14-.042.14-.093 0-.05-.063-.092-.14-.092a.205.205 0 00-.05.006.193.193 0 00.002-.083.194.194 0 00-.03-.073h.106v-.619c.084-.08.204-.12.363-.12.256 0 .36.068.42.27.04.13.002.24-.118.343l.068.097c.135-.115.194-.252.173-.404.288-.01.504.023.645.1.123.065.146.233.053.525l.105.04c.11-.343.079-.576-.109-.676-.165-.09-.405-.125-.723-.111v.009c-.08-.229-.23-.317-.514-.317a.658.658 0 00-.363.093v-.031h-.224v.054a.625.625 0 00-.407-.125c-.28 0-.43.084-.51.302l.001-.047c-.317-.014-.557.022-.723.11-.187.102-.218.335-.109.678l.106-.04c-.093-.292-.07-.46.053-.526.142-.077.358-.11.648-.1-.043.173.013.329.163.457l.069-.098c-.12-.103-.158-.213-.12-.342zm.885.72c0-.005 0-.01.002-.015h-.004l.002.015zm1.382.51c-.092.018-.158.016-.194-.015a.4.4 0 01-.192.006c-.08-.014-.134-.072-.167-.167a.254.254 0 01-.162.11c.358.055.609.134.609.134s-.006.058-.021.127l.056-.12.006-.008.065-.067zm-.885-.09a.187.187 0 01-.074-.074.245.245 0 01-.09.057c.056.005.111.01.165.017zm-.362-.029a.266.266 0 01-.107-.103.266.266 0 01-.106.103l.077-.002h.045l.09.002zm-1.352.182l-.052-.054c.063.007.109 0 .136-.024a.4.4 0 00.193.006c.079-.014.134-.072.167-.167a.255.255 0 00.157.108 4.75 4.75 0 00-.6.131zm.938-.17a4.13 4.13 0 00-.16.015.187.187 0 00.071-.072.246.246 0 00.089.056zm1.378.51c.039.021.07 0 .095-.038a.221.221 0 00-.004.03.51.51 0 01-.098.035 2.786 2.786 0 01-.296.051 6.42 6.42 0 01-.744.054 6.443 6.443 0 01-.744-.054 2.79 2.79 0 01-.296-.052.58.58 0 01-.073-.022l.006-.003c.122-.063.93-.122 1.077-.133.145.01.954.07 1.077.133zm.162-.01z"
            fill="#FECA00"
          />
          <path
            d="M12.127 8.677v.062c-.497-.01-.782.07-.854.229-.075.164-.061.364.043.6l-.05.028c-.112-.253-.127-.473-.043-.656.085-.189.387-.273.904-.263z"
            fill="#fff"
          />
          <path
            d="M12.223 9.223l-.028.053c-.109-.07-.163-.192-.163-.36 0-.24.113-.38.361-.476.16-.062.376-.037.651.073l-.019.058c-.264-.105-.469-.13-.613-.073-.228.088-.324.208-.324.419 0 .147.045.247.135.306zm1.859-.484V8.8c.497-.01.782.07.854.23.075.164.061.363-.044.6l.05.027c.112-.253.128-.472.044-.655-.086-.189-.387-.273-.905-.263z"
            fill="#fff"
          />
          <path
            d="M13.906 9.236l.029.053c.108-.071.162-.192.162-.36 0-.24-.112-.38-.361-.477-.159-.061-.376-.036-.651.074l.02.058c.264-.106.468-.13.612-.073.228.088.324.208.324.419 0 .146-.045.247-.135.306z"
            fill="#fff"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IQ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#BF2714" />
          <path d="M0 10v5h20v-5H0z" fill="#272727" />
          <path
            d="M3.335 8.007c.569.816-.21 1.368-.21 1.368s.68 0 .942-.546H9.64V7.625s-.117-.578-.613-.578-.608.578-.608.578H6.46L8.356 5.95l-.37-.326-2.106 1.86v.394h2.99v-.232s.017-.134.157-.134.106.134.106.134v.496H5.364v-.678l-.408.182v.496s-.5-.136-.816-.136c-.315 0-.334-.36-.334-.36l-.47.36zm7.57.046l.305.761H9.994V5.76l.513.164v2.13h.397zm5.664 0l.306.761h-1.216V5.76l.513.164v2.13h.397zm-1.506-2.262l-.317.214v2.046h-.322v-1.64l-.532.306V8.05h-.357v-.926l-.404.26v.251s-.778.054-.778 1.153h2.707l.003-2.998zM4.683 9.354c.097 0 .176-.07.176-.157 0-.086-.079-.156-.177-.156-.097 0-.177.07-.177.156 0 .087.08.157.177.157zm9.014-3.328c-.138.181-.555 0-.555 0l1.183-.137c-.122.238-.628.137-.628.137z"
            fill="#009C4E"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#5EAA22"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#E31D1C"
          />
          <path
            d="M.233 10.854h-1.421m-.015.563v-.326h.463v.315h.467v-.315h-.242m.726.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526H.716m1.956-.552H1.25m-.014.563v-.326h.463v.315h.467v-.315h-.242m.77.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.552h-1.42m-.015.563v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.552H6.172m-.014.563v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.253.033v.526h-.234m1.957-.552H8.61m-.013.563v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.552h-1.421m-.014.563v-.326h.462v.315h.467v-.315h-.242m.77.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526h-.233m1.956-.552h-1.422m-.014.563v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.552h-1.42m-.016.563v-.326h.463v.315h.467v-.315h-.242m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.552h-1.422m-.015.563v-.326h.463v.315h.468v-.315h-.243m.858.313h-.236v-.306h.496v-.251.557h.224v-.557M.233 3.23h-1.421m-.015.562v-.326h.463v.315h.467v-.315h-.242m.726.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526H.716m1.956-.551H1.25m-.014.562v-.326h.463v.315h.467v-.315h-.242m.77.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.551h-1.42m-.015.562v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.551H6.172m-.014.562v-.326h.462v.315h.468v-.315h-.243m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.253.033v.526h-.234m1.957-.551H8.61m-.013.562v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.551h-1.421m-.014.562v-.326h.462v.315h.467v-.315h-.242m.77.313h-.235v-.306h.496v-.251.557h.224v-.557m.253.033v.526h-.233m1.956-.551h-1.422m-.014.562v-.326h.462v.315h.468v-.315h-.243m.771.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.956-.551h-1.42m-.016.562v-.326h.463v.315h.467v-.315h-.242m.727.313h-.236v-.306h.496v-.251.557h.225v-.557m.252.033v.526h-.233m1.957-.551h-1.422m-.015.562v-.326h.463v.315h.468v-.315h-.243m.858.313h-.236v-.306h.496v-.251.557h.224v-.557"
            stroke="#F7FCFF"
            stroke-width=".625"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.129 5.156s.267.14.54.14c.274 0 .549-.14.549-.14v.188s-.3.14-.566.14c-.266 0-.523-.14-.523-.14v-.188zM7.16 7.37c0-1.111 1.526-1.838 1.526-1.838s-.882.473-.882 1.792c0 1.318.458 1.89.458 1.89S7.16 8.48 7.16 7.368zm5.149-.061c0-1.111-1.525-1.777-1.525-1.777s.882.473.882 1.792c0 1.318-.458 1.89-.458 1.89s1.1-.794 1.1-1.905zm-4.107.303c-.058-1.11.865-2.104.865-2.104s-.336.457-.267 1.774c.024.452.202 1.124.426 1.521V5.578h.938V8.83c.225-.37.398-1.002.422-1.46.069-1.318-.251-1.863-.251-1.863s.923.994.865 2.104c-.035.66-.543 1.36-.949 1.817.197.044.461.098.825.17.007.04-.074.038-.235.034a5.149 5.149 0 00-.813.035c-.165.17-.28.27-.28.27L9.7 9.88a1.55 1.55 0 00-.046.059s-.116-.101-.281-.27a5.148 5.148 0 00-.814-.036c-.16.004-.241.006-.234-.035.364-.071.628-.125.825-.169-.406-.457-.914-1.156-.949-1.817z"
            fill="#E31D1C"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#0061C1"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M5-.625h-.625v6h-5v4.25h5v6h4.25v-6h12v-4.25h-12v-6H5z"
            fill="#D21034"
            stroke="#F1F9FF"
            stroke-width="1.25"
          />
        </g>
      </g>
    </symbol>
    <symbol id="IT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0z" fill="#C51918" />
        <path d="M0 0h6v15H0V0z" fill="#5EAA22" />
        <path d="M6 0h8v15H6V0z" fill="#fff" />
      </g>
    </symbol>
    <symbol id="JE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          d="M-1.688.778l-1.28-.774v15.492l1.28-.774 10.336-6.25 1.194-.722-1.194-.722L-1.688.778z"
          fill="#F7FCFF"
          stroke="#E31D1C"
          stroke-width="1.688"
        />
        <path
          d="M21.826.77l1.267-.736v15.432l-1.267-.736-10.762-6.25-1.257-.73 1.257-.73L21.826.77z"
          fill="#F7FCFF"
          stroke="#E31D1C"
          stroke-width="1.688"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.547 2.94S8.01 5.312 9.863 6.224c0 0 1.779-.97 1.38-3.286 0 0-.765-.255-1.372-.255-.608 0-1.324.255-1.324.255z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.739 3.437s.198-.088.296 0c.098.087.179-.008.179-.06 0-.054.156-.235.156-.088 0 .148-.049.23.088.23s.753-.203.901-.143c.148.06.261.046.224-.04-.038-.087-.135-.141-.32-.094-.187.047-.143.093-.303.093-.161 0-.34-.046-.34-.046s.05-.077.234-.022c.183.055.437-.068.505-.068.07 0 .259-.004.277.043.02.047.134.09.046.134-.087.044-.23.072-.132.128.1.056.327.046.338.104.01.059.119.146.075.146-.043 0-.121.083-.194.058-.073-.025-.082-.048-.012-.068.07-.02.07-.106.012-.106-.058 0-.03.03-.16 0-.132-.03-.305-.063-.295 0 .01.063.096.16-.062.174-.157.013-.231.065-.262.023-.03-.042-.14-.098-.054-.116.086-.018.169.061.2.048.03-.013.101-.02.042-.074-.059-.055-.156-.087-.066-.128.09-.04.02-.041-.152.043-.172.085-.267.156-.418.146-.15-.01-.207.004-.256-.01-.048-.014-.284.151-.352.11-.068-.042-.287-.058-.247-.11.039-.051.092-.078.151-.051.06.026.118.053.158.026.04-.026.154-.117.125-.135-.029-.019 0-.08-.164-.08s-.222.068-.26.025c-.04-.043.042-.092.042-.092zm.164.78s.174-.077.26 0c.086.077.157-.007.157-.053 0-.047.137-.207.137-.077s-.043.203.078.203c.12 0 .662-.18.792-.126.13.053.23.04.197-.036-.034-.076-.118-.124-.282-.082-.164.041-.125.082-.266.082-.142 0-.299-.04-.299-.04s.044-.069.206-.02c.161.048.384-.06.444-.06s.227-.004.244.038c.016.041.117.08.04.118-.077.038-.203.063-.116.112.087.05.287.04.297.092.01.051.104.128.066.128-.038 0-.107.072-.17.05-.065-.022-.072-.041-.011-.059.061-.018.06-.093.01-.093-.05 0-.026.026-.141 0-.115-.026-.268-.056-.259 0 .01.056.084.141-.054.152-.139.012-.203.057-.23.02-.027-.036-.124-.085-.048-.101s.148.054.176.042c.027-.011.089-.017.037-.065s-.137-.076-.058-.112c.08-.036.017-.037-.134.038-.151.074-.235.137-.368.128-.132-.009-.182.003-.224-.009-.043-.012-.25.133-.31.096-.06-.037-.252-.05-.218-.096.035-.045.082-.069.134-.045.052.023.103.046.138.023.035-.023.136-.103.11-.12-.025-.015 0-.069-.144-.069s-.195.06-.229.022.038-.081.038-.081zm.231.791s.132-.058.197 0c.066.059.12-.004.12-.04 0-.035.103-.156.103-.058s-.032.154.06.154c.09 0 .502-.136.6-.096.099.04.174.03.149-.027-.025-.058-.09-.094-.213-.062-.124.031-.095.062-.202.062-.107 0-.227-.03-.227-.03s.034-.052.156-.016c.122.037.291-.045.337-.045.046 0 .172-.003.185.029.012.031.089.06.03.09-.058.029-.154.047-.088.084.066.038.218.03.225.07.008.039.08.097.05.097-.028 0-.08.055-.129.038-.048-.016-.054-.031-.008-.045.047-.013.047-.07.008-.07-.038 0-.02.02-.107 0s-.203-.042-.196 0c.007.042.064.107-.041.115-.105.01-.154.044-.175.016-.02-.028-.093-.065-.036-.077.058-.012.112.04.133.032.02-.009.068-.014.028-.05-.039-.036-.104-.058-.044-.085.06-.027.013-.027-.101.029-.115.056-.178.104-.279.097-.1-.007-.138.003-.17-.007-.032-.009-.19.101-.235.073-.045-.028-.191-.038-.165-.073.026-.034.062-.052.1-.034.04.018.08.035.106.018.026-.018.103-.078.084-.09-.02-.013 0-.054-.11-.054s-.147.046-.173.017c-.026-.028.028-.062.028-.062z"
          fill="#FFD100"
        />
      </g>
    </symbol>
    <symbol id="JM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#093"
        />
        <path
          d="M-.088-.65l-1.38-1.14v18.58l1.38-1.14 9.086-7.5.789-.65-.789-.65-9.086-7.5z"
          fill="#272727"
          stroke="#FECA00"
          stroke-width="1.688"
        />
        <path
          d="M20.103-.663l1.366-1.077v18.48l-1.366-1.077-9.512-7.5-.84-.663.84-.663 9.512-7.5z"
          fill="#272727"
          stroke="#FECA00"
          stroke-width="1.688"
        />
      </g>
    </symbol>
    <symbol id="JO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#272727" />
          <path d="M0 10v5h20v-5H0z" fill="#093" />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l12.5-7.5L0 0z"
          fill="#E31D1C"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="13"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15l12.5-7.5L0 0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.626 8.67l-1.17.705.268-1.377-.974-1.031 1.318-.056.558-1.286.558 1.286H7.5l-.971 1.087.292 1.377-1.195-.706z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="JP" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 12.188a4.688 4.688 0 100-9.376 4.688 4.688 0 000 9.376z"
            fill="#E31D1C"
          />
        </g>
      </g>
    </symbol>
    <symbol id="KE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v5h20V0H0z"
          fill="#272727"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10v5h20v-5H0z"
          fill="#4E8B1D"
        />
        <path
          d="M0 4.375h-.625v6.25h21.25v-6.25H0z"
          fill="#E31D1C"
          stroke="#F7FCFF"
          stroke-width="1.25"
        />
      </g>
      <path
        d="M11.812 2.418c.114-.246.42-.515.92-.807a.058.058 0 01.056-.002c.03.016.043.054.028.085L7.637 12.871l-.27-.139 4.565-9.852c-.206-.035-.247-.19-.12-.462z"
        fill="#fff"
      />
      <path
        d="M8.183 2.418c.126.273.086.427-.121.462l4.565 9.853-.27.138L7.18 1.694a.065.065 0 01.027-.085.058.058 0 01.056.002c.5.292.807.56.92.807z"
        fill="#fff"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 12.568c.598 0 3-2.262 3-5.052 0-2.79-2.402-5.053-3-5.053-.598 0-3 2.262-3 5.053 0 2.79 2.402 5.052 3 5.052z"
        fill="#E31D1C"
      />
      <mask
        id="b"
        maskUnits="userSpaceOnUse"
        x="7"
        y="2"
        width="6"
        height="11"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 12.568c.598 0 3-2.262 3-5.052 0-2.79-2.402-5.053-3-5.053-.598 0-3 2.262-3 5.053 0 2.79 2.402 5.052 3 5.052z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#b)">
        <path
          d="M4.3 11.937c2.32 0 4.2-1.98 4.2-4.421 0-2.442-1.88-4.421-4.2-4.421-2.32 0-4.2 1.98-4.2 4.42 0 2.442 1.88 4.422 4.2 4.422zm11.4 0c2.32 0 4.2-1.98 4.2-4.421 0-2.442-1.88-4.421-4.2-4.421-2.32 0-4.2 1.98-4.2 4.42 0 2.442 1.88 4.422 4.2 4.422z"
          fill="#272727"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.12 6.84c.274-.205.48-1.097.48-2.166 0-1.07-.206-1.962-.48-2.167V6.84zm-.3-.057c-.243-.282-.42-1.12-.42-2.11 0-.99.177-1.827.42-2.109v4.219zm0 1.466v4.218c-.243-.282-.42-1.12-.42-2.11 0-.989.177-1.827.42-2.108zm.3 4.275V8.192c.274.204.48 1.096.48 2.166 0 1.07-.206 1.961-.48 2.166z"
          fill="#F7FCFF"
        />
        <path
          d="M10 6.884c.331 0 .6.283.6.632 0 .349-.269.631-.6.631-.331 0-.6-.282-.6-.631 0-.349.269-.632.6-.632z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="KG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#C51918"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.989 11.167c.067 0 .133-.002.2-.005l.385 1.23.09-1.285c.129-.024.255-.054.38-.09l.66 1.109-.212-1.271c.12-.053.236-.11.349-.175l.902.929-.503-1.19a3.56 3.56 0 00.298-.248l1.094.697-.765-1.043c.083-.099.16-.202.233-.31l1.226.429-.986-.84a3.61 3.61 0 00.155-.354l1.291.136-1.154-.59a3.68 3.68 0 00.068-.382l1.288-.163-1.26-.31a4.105 4.105 0 00-.022-.387l1.214-.453-1.296-.014a3.644 3.644 0 00-.112-.372l1.075-.718-1.264.283a3.68 3.68 0 00-.195-.337l.878-.944-1.163.564a3.743 3.743 0 00-.269-.283l.635-1.119-1 .814a3.744 3.744 0 00-.328-.215l.358-1.232-.782 1.019a3.73 3.73 0 00-.371-.135l.061-1.278-.524 1.17a3.777 3.777 0 00-.392-.046L9.993 2.5l-.237 1.257a3.779 3.779 0 00-.394.045L8.84 2.634l.062 1.276a3.73 3.73 0 00-.373.134l-.78-1.016.356 1.227a3.747 3.747 0 00-.332.216l-.995-.81.632 1.113c-.095.09-.186.186-.272.286L5.98 4.5l.874.937a4 4 0 00-.2.341L5.4 5.497l1.068.713a3.655 3.655 0 00-.113.377l-1.288.014 1.206.45a3.91 3.91 0 00-.022.392L5 7.751l1.279.162c.016.131.039.26.069.386L5.2 8.886l1.283-.135c.046.123.099.243.157.36l-.98.833 1.22-.426c.072.109.151.213.235.313l-.76 1.037 1.088-.694c.096.089.196.172.301.25l-.5 1.185.899-.925c.113.064.23.122.35.174l-.21 1.268.659-1.107c.124.036.252.066.381.09l.09 1.282.385-1.229c.063.003.127.005.19.005zm2.812-3.72c0 1.553-1.269 2.812-2.835 2.812-1.565 0-2.835-1.259-2.835-2.812s1.27-2.812 2.835-2.812c1.566 0 2.835 1.26 2.835 2.812zm-.857.916a2.136 2.136 0 00.008-1.722c-.49.035-.904.164-1.24.329.746.326 1.084.864 1.232 1.393zm-.241.411c-.061.082-.128.16-.2.232-.04-.738-.355-1.3-.922-1.908.701.336 1.097 1.138 1.122 1.676zm-.537.507a2.14 2.14 0 01-.121.075c-.168-.829-.487-1.483-.93-2.006l.107-.081.044-.032c.567.652.925 1.212.9 2.044zm-1.181.355c.251 0 .492-.043.717-.123-.163-.789-.447-1.523-.858-2.053a3.062 3.062 0 00-.75 1.983c.272.124.573.193.89.193zm-.413-2.43l.049.04c-.523.594-.809 1.265-.858 2.009a2.152 2.152 0 01-.184-.144c.197-.787.523-1.436.993-1.905zm-1.56-.55c.49.055.878.174 1.169.313-.74.314-1.033.822-1.18 1.339a2.137 2.137 0 01.01-1.652zm.268 2.137a2.164 2.164 0 01-.048-.066c.037-.543.383-1.314 1.081-1.632A3.74 3.74 0 008.28 8.793zm.159-2.784a2.138 2.138 0 013.073-.02c-.612.072-1.13.225-1.552.464-.375-.216-.883-.361-1.521-.444z"
            fill="#FFDC17"
          />
        </g>
      </g>
    </symbol>
    <symbol id="KH" width="20" height="15" fill="none">
      <path d="M0 0h20v15H0V0z" fill="#032EA1" />
      <path d="M0 3.75h20v7.5H0v-7.5z" fill="#E00025" />
      <path
        d="M7.888 7.069h4.267V8.71H7.888V7.07z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
        stroke-linejoin="bevel"
      />
      <path
        d="M7.888 7.151h4.267v.162H7.888V7.15z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
        stroke-linejoin="bevel"
      />
      <path
        d="M6.219 8.794a.349.349 0 00.165-.199h7.241a.349.349 0 00.165.199H6.219z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.999 4.41c-.09.004-.087.157-.087.157h.17s.003-.157-.083-.157zm-.555 1.995v.206h1.11v-.206c.002-.056.032-.085.06-.11.023-.023.045-.043.045-.077 0 0 .015-.113-.019-.165-.038.15-.113.123-.113.06 0-.046.032-.092.096-.187l.032-.046c.03-.045.011-.176-.026-.225-.015.116-.034.169-.083.169-.03 0-.056-.019-.056-.075 0-.046.02-.078.04-.11.013-.022.026-.044.035-.07a.187.187 0 00-.037-.199 2.58 2.58 0 00-.009.053c-.01.074-.015.104-.055.104-.095-.027-.013-.16.017-.208l.005-.009c.019-.071-.037-.127-.037-.127-.03.097-.038.108-.075.097-.045-.011-.038-.075.015-.128.034-.033.03-.086-.008-.123-.037.075-.097.064-.09.019l.034-.162h-.045l.015-.116h-.056l.011-.097h-.506l.007.097H9.7l.015.116h-.042l.03.165c-.003.045-.048.049-.086-.022-.037.037-.041.086-.007.123.052.053.06.117.015.128-.038.011-.045.004-.075-.098 0 0-.06.087-.038.128l.007.01c.03.05.11.176.016.207-.04 0-.045-.03-.056-.104a2.713 2.713 0 00-.008-.053.188.188 0 00-.041.199c.01.024.022.045.034.065.021.034.04.067.04.115 0 .056-.022.075-.052.075-.049 0-.067-.056-.082-.169-.038.049-.056.18-.027.221l.02.03c.072.11.104.158.104.207 0 .063-.071.09-.112-.06-.03.052-.015.165-.015.165 0 .034.022.054.046.076.028.026.059.054.059.111zM9.75 4.77v.003h.488V4.77H9.75zm.087-.099l-.012-.1h.338l-.004.1h-.322zm1.05 3.935c0 .079.112.162.187.188H8.956c.075-.027.15-.109.15-.188v-.911l-.094-.128h1.973l-.098.128v.911z"
        fill="#fff"
      />
      <path
        d="M9.912 4.567h-.014v.015h.014v-.014zM10 4.41v-.015.015zm.082.157v.015h.015v-.014h-.015zm-.637 2.044H9.43v.015h.015v-.015zm1.11 0v.015h.015v-.015h-.015zm0-.206h-.015.015zm.06-.11l.01.01-.01-.01zm.045-.077l-.015-.003v.003h.015zm-.019-.165l.013-.009-.02-.029-.007.034.014.003zm-.017-.127l.013.009-.013-.009zm.032-.046l.012.008-.012-.008zm-.026-.225l.012-.01-.023-.028-.004.036.015.002zm-.1-.017l.014.008-.013-.008zm.036-.07l-.014-.005v.001l.014.005zm-.037-.198l.01-.01-.02-.022-.005.03.014.002zm-.009.053l.015.002-.015-.002zm0 0l-.014-.002.014.002zm-.055.104l-.005.016h.005v-.016zm.017-.208l.012.008-.012-.008zm.005-.009l.014.008v-.004l-.014-.004zm-.037-.127l.01-.011-.017-.018-.008.024.015.005zm-.075.097l.004-.014-.004.014zm.015-.128l.01.011-.01-.01zm-.008-.123l.01-.01-.014-.016-.01.019.014.007zm-.09.019l-.014-.004v.001l.014.003zm.034-.162l.015.003.004-.018h-.019v.015zm-.045 0l-.015-.002-.002.017h.017v-.015zm.015-.116l.015.002.002-.017h-.017v.015zm-.045-.097l.015.001.002-.017h-.017v.016zm-.506 0v-.016h-.016v.017l.016-.002zM9.7 4.77v-.015h-.017l.002.017.015-.002zm.015.116v.015h.017l-.002-.017-.015.002zm-.042 0v-.015h-.017l.003.018.014-.003zm.03.165l.016.002v-.004l-.015.002zm-.086-.022l.014-.007-.01-.018-.014.014.01.01zm-.007.123l-.011.01v.001l.01-.01zm.015.128l-.004-.015.004.015zm-.075-.098l.014-.004-.009-.03-.018.026.013.008zm-.038.128l-.013.007.013-.007zm.007.01l-.013.008.013-.008zm.016.207v.016l.005-.001-.005-.014zm-.056-.104l-.015.002.015-.002zM9.47 5.37l.015-.002-.005-.03-.02.021.01.011zm-.041.199l-.014.005.014-.005zm.034.065l.013-.008-.013.008zm-.094.021l.015-.002-.005-.036-.022.029.012.009zm-.027.221l.013-.008-.013.008zm.02.03l-.013.008.013-.009zm-.008.147l.014-.004-.01-.035-.017.031.013.008zm-.015.165h.015v-.002l-.015.002zm.046.076l-.01.011.01-.011zm.366-1.521h-.015l.001.014h.014v-.014zm.488 0v.014h.013l.002-.013-.015-.002zm-.413-.202v-.015H9.81l.002.017.015-.002zm.011.1l-.014.002.001.013h.014v-.015zm.327-.1h.015v-.015h-.015v.015zm-.004.1v.015h.014l.001-.014h-.015zm.915 4.123v.015l.005-.03-.005.015zm-2.119 0l-.005-.014.005.029v-.015zm.15-1.099h.019l-.007-.009-.012.009zm-.094-.128v-.014h-.03L9 7.575l.012-.008zm1.973 0l.012.01.018-.024h-.03v.014zm-.098.128l-.014-.011v.011h.014zm-.975-3.128h.015v-.006a.298.298 0 01.01-.067.128.128 0 01.022-.048.053.053 0 01.04-.021v-.03a.083.083 0 00-.063.032.158.158 0 00-.029.06.311.311 0 00-.01.074v.006h.015zm.17-.014h-.17v.03h.17v-.03zm-.083-.128c.016 0 .028.007.037.019.01.012.017.03.022.048a.298.298 0 01.008.069v.006h.03v-.006a.299.299 0 00-.01-.076.16.16 0 00-.026-.06.076.076 0 00-.061-.03v.03zm-.54 2.186v-.206h-.03v.206h.03zm1.095-.015h-1.11v.03h1.11v-.03zm-.015-.191v.206h.03v-.206h-.03zm.064-.121c-.027.025-.062.057-.064.12l.03.002c.001-.05.027-.075.055-.1l-.02-.022zm.04-.066c0 .027-.015.043-.04.066l.02.021c.024-.021.05-.045.05-.087h-.03zm-.016-.157c.015.022.02.06.02.094l-.001.043-.002.013v.004l.015.003.015.001v-.005l.002-.014.001-.046a.22.22 0 00-.024-.11l-.026.017zm-.115.051c0 .02.006.036.016.049.01.012.027.02.044.016.017-.003.033-.015.047-.034a.265.265 0 00.036-.087l-.03-.007a.238.238 0 01-.03.077.062.062 0 01-.028.022c-.006 0-.011-.001-.016-.007a.045.045 0 01-.008-.029h-.03zm.099-.194c-.032.047-.057.083-.073.113a.17.17 0 00-.026.082h.03c0-.02.007-.04.022-.068.016-.028.04-.062.072-.11l-.025-.017zm.032-.046l-.032.046.025.017.031-.047-.024-.016zm-.026-.208a.24.24 0 01.035.107.283.283 0 01.002.06.092.092 0 01-.011.04l.024.017a.12.12 0 00.017-.054.311.311 0 00-.002-.067.27.27 0 00-.041-.121l-.024.018zm-.07.175a.065.065 0 00.04-.013.094.094 0 00.027-.037.494.494 0 00.03-.132l-.03-.004a.467.467 0 01-.028.124.064.064 0 01-.018.025.035.035 0 01-.022.007v.03zm-.072-.09c0 .03.007.053.02.068a.065.065 0 00.051.022v-.03a.036.036 0 01-.028-.012c-.007-.008-.013-.022-.013-.048h-.03zm.042-.119c-.02.033-.042.068-.042.119h.03c0-.041.017-.07.038-.103l-.026-.016zm.034-.066a.316.316 0 01-.034.066l.026.016a.31.31 0 00.036-.073l-.028-.009zm-.034-.184c.046.05.06.12.034.183l.028.011a.202.202 0 00-.04-.214l-.022.02zm.017.045l.008-.053-.03-.004-.008.053.03.004zm0 0l-.03-.004.03.004zm-.07.118a.058.058 0 00.032-.009.055.055 0 00.02-.025.334.334 0 00.018-.084l-.03-.004a.34.34 0 01-.015.076.025.025 0 01-.01.012.028.028 0 01-.015.003v.03zm.004-.232c-.015.024-.044.07-.057.116a.121.121 0 00-.003.067.07.07 0 00.052.048l.008-.029c-.02-.006-.028-.016-.031-.027a.091.091 0 01.003-.05.482.482 0 01.053-.109l-.025-.016zm.005-.009l-.005.01.025.015.006-.01-.026-.015zm-.024-.12l-.01.011.001.002a.156.156 0 01.021.031c.01.021.019.05.01.08l.03.008c.01-.04 0-.076-.013-.101a.189.189 0 00-.028-.041l-.011.01zm-.08.112a.07.07 0 00.03.004.04.04 0 00.027-.017.144.144 0 00.018-.035l.02-.06-.03-.008a1.05 1.05 0 01-.018.057.116.116 0 01-.014.028c-.003.004-.005.005-.007.005l-.017-.002-.009.028zm.01-.152a.158.158 0 00-.05.088.065.065 0 00.008.04c.007.012.018.02.033.025l.007-.03a.022.022 0 01-.014-.01.036.036 0 01-.003-.022.129.129 0 01.04-.07l-.022-.021zm-.008-.103c.033.033.034.076.007.103l.021.021c.041-.04.035-.103-.007-.145l-.021.021zm-.095.006a.047.047 0 00.01.039c.008.01.02.015.034.014.027-.001.055-.023.075-.063l-.027-.013c-.018.035-.038.046-.05.046-.005 0-.008-.001-.01-.003-.001-.003-.003-.007-.002-.015l-.03-.005zm.034-.162l-.033.161.029.007.034-.162-.03-.006zm-.03.018h.045v-.03h-.045v.03zm0-.133l-.015.116.03.004.015-.116-.03-.004zm-.041.017h.056v-.03h-.056v.03zm.015-.013l.01-.098-.029-.003-.01.097.029.004zm-.004-.115h-.506v.03h.506v-.03zm-.521.017l.007.097.03-.002-.007-.098-.03.003zm-.03.111h.052v-.03H9.7v.03zm.03.1l-.015-.117-.03.004.015.116.03-.004zm-.056.016h.04v-.03h-.04v.03zm.044.148l-.03-.165-.03.005.03.165.03-.005zm-.114-.013c.02.036.043.059.067.062a.038.038 0 00.034-.01.056.056 0 00.013-.035l-.03-.003c0 .009-.003.014-.005.016s-.004.003-.008.003c-.009-.002-.026-.013-.044-.047l-.027.014zm.017.106a.068.068 0 01-.02-.05.082.082 0 01.027-.053l-.021-.02a.112.112 0 00-.035.07.098.098 0 00.027.074l.022-.02zm.007.153a.052.052 0 00.034-.025.065.065 0 00.007-.04.158.158 0 00-.049-.088l-.02.021a.13.13 0 01.039.07c.001.01 0 .017-.003.022a.022.022 0 01-.015.01l.007.03zm-.093-.108a.986.986 0 00.02.06.134.134 0 00.018.036.042.042 0 00.027.016c.01 0 .02-.002.03-.005l-.01-.028a.05.05 0 01-.017.003c-.002 0-.004 0-.007-.005a.107.107 0 01-.013-.027.957.957 0 01-.019-.059l-.029.009zm-.01.116c-.003-.006-.004-.015-.002-.028a.166.166 0 01.013-.038.328.328 0 01.024-.043l.002-.002-.012-.01-.013-.008v.001l-.002.003a.344.344 0 00-.041.092.072.072 0 00.005.047l.026-.014zm.006.01l-.006-.01-.026.015.007.01.025-.015zm.009.229a.074.074 0 00.05-.049.12.12 0 00-.002-.066c-.013-.045-.042-.09-.057-.114l-.025.015a.457.457 0 01.053.107.09.09 0 01.003.05c-.004.011-.013.022-.032.028l.01.029zm-.076-.117c.006.036.01.065.018.084.005.01.011.02.02.025a.06.06 0 00.033.009v-.03a.029.029 0 01-.016-.004.026.026 0 01-.01-.012.343.343 0 01-.015-.076l-.03.004zm-.008-.053l.008.053.03-.004a2.788 2.788 0 00-.008-.053l-.03.004zm-.012.191a.172.172 0 01.038-.182l-.022-.022a.203.203 0 00-.044.215l.028-.01zm.033.063a.393.393 0 01-.033-.063l-.028.011a.38.38 0 00.035.067l.026-.015zm.043.123a.22.22 0 00-.043-.123l-.026.015c.021.035.039.065.039.108h.03zm-.068.09a.06.06 0 00.05-.022.112.112 0 00.018-.068h-.03c0 .026-.006.041-.012.049-.006.007-.014.01-.026.01v.03zm-.097-.182c.007.056.016.1.03.13a.097.097 0 00.027.038c.011.01.025.014.04.014v-.03A.034.034 0 019.43 5.8a.068.068 0 01-.018-.026.478.478 0 01-.027-.122l-.03.004zm0 .21a.08.08 0 01-.01-.037.27.27 0 01.001-.06.243.243 0 01.036-.106l-.024-.018a.27.27 0 00-.042.12.3.3 0 00-.001.067c.002.02.007.039.016.052l.025-.018zm.02.03l-.019-.029-.025.016.02.03.024-.017zm.107.215a.184.184 0 00-.027-.087c-.017-.033-.044-.073-.08-.128l-.025.017c.037.055.062.094.079.125a.155.155 0 01.023.074h.03zm-.142-.056a.29.29 0 00.037.087c.014.02.03.031.047.034a.044.044 0 00.043-.016.076.076 0 00.015-.048h-.03a.047.047 0 01-.008.029c-.005.005-.01.007-.015.006-.006-.001-.016-.007-.027-.023a.25.25 0 01-.033-.076l-.029.007zm0 .162l.015-.002v-.005a.44.44 0 010-.108.129.129 0 01.013-.043l-.026-.015a.158.158 0 00-.017.053.372.372 0 00-.002.102.479.479 0 00.002.018v.001l.015-.002zm.056.065c-.025-.023-.041-.039-.041-.066h-.03c0 .042.027.067.05.088l.02-.022zm.064.122c0-.064-.036-.096-.064-.122l-.02.022c.028.026.054.05.054.1h.03zm.277-1.634v.003l.03-.003V4.77l-.03.002zm.015.016h.488v-.03H9.75v.03zm.503-.013v-.002l-.03-.004v.003l.03.003zm-.503.011h.488v-.03h-.488v.03zm.06-.212l.012.1.03-.003-.012-.1-.03.003zm.353-.017h-.338v.03h.338v-.03zm.011.116l.004-.1-.03-.001-.004.1h.03zm-.338.014h.323v-.03h-.322v.03zM11.08 8.78a.37.37 0 01-.117-.071c-.037-.034-.06-.07-.06-.103h-.03c0 .046.032.09.07.125a.402.402 0 00.127.077l.01-.028zm-2.124.029h2.119v-.03H8.956v.03zm.135-.203a.169.169 0 01-.043.104.23.23 0 01-.097.07l.01.028a.26.26 0 00.11-.079.194.194 0 00.05-.123h-.03zm0-.911v.911h.03v-.911h-.03zm-.09-.119l.093.128.024-.018-.093-.127L9 7.576zm1.984-.023H9.012v.03h1.973v-.03zm-.086.151l.098-.127-.024-.019-.097.128.023.018zm.004.902v-.911h-.03v.911h.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.492 7.973h-.135v1h.136v-1zm1.14 0h-.134v1h.135v-1z"
        fill="#fff"
      />
      <path
        d="M9.357 7.973v-.016l-.014.016h.014zm.136 0h.014l-.014-.016v.016zm-.136 1h-.014l.014.014v-.014zm.136 0v.014l.014-.014h-.014zm1.005-1v-.016l-.015.016h.014zm.135 0h.015l-.015-.016v.016zm-.135 1h-.015l.014.014v-.014zm.135 0v.014l.015-.014h-.015zm-1.275-.986h.134v-.03h-.135v.03zm.014.986v-1h-.03v1h.03zm.12-.016h-.135v.03h.136v-.03zm-.015-.985v1h.03v-1h-.03zm1.02.015h.136v-.03h-.135v.03zm.015.986v-1h-.03v1h.03zm.12-.016h-.134v.03h.135v-.03zm-.014-.985v1h.03v-1h-.03z"
        fill="#000"
      />
      <path
        d="M8.975 6.532v1.035H11V6.532a.157.157 0 00-.098.106v.442H9.076v-.442s-.022-.075-.105-.106h.004z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M10.723 8.794c-.068-.027-.21-.109-.21-.188v-1.02c.014-.056.09-.09.138-.127H9.313c.063.037.134.064.16.127v1.02c0 .079-.112.162-.18.188h1.43z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.902 6.735v.735H9.076v-.731h.188v-.075h1.455v.071h.184zm-.626 1.871c0 .079.094.162.162.188H9.56c.064-.027.161-.109.161-.188v-.873l-.056-.075h.664l-.053.078v.87z"
        fill="#fff"
      />
      <path
        d="M10.902 7.47v.015h.016V7.47h-.015zm0-.735h.016V6.72h-.015v.015zm-1.826.735h-.015v.015h.015V7.47zm0-.731v-.015h-.015v.015h.015zm.188 0v.015h.015v-.015h-.015zm0-.075v-.015h-.015v.015h.015zm1.455 0h.015v-.015h-.015v.015zm0 .071h-.015v.015h.015v-.015zm-.281 2.059v.015l.005-.03-.005.015zm-.878 0l-.006-.014.006.029v-.015zm.161-1.062h.019l-.007-.009-.012.01zm-.056-.075v-.014h-.03l.018.024.012-.01zm.664 0l.012.009.016-.024h-.028v.015zm-.053.08l-.015-.01v.01h.015zm.642-.267v-.735h-.03v.735h.03zm-1.842.015h1.826v-.03H9.076v.03zm-.015-.746v.731h.03v-.731h-.03zm.203-.015h-.188v.03h.188v-.03zm-.015-.06v.075h.03v-.075h-.03zm1.47-.015H9.264v.03h1.455v-.03zm.015.086v-.071h-.03v.071h.03zm.168-.015h-.183v.03h.184v-.03zm-.46 2.06a.297.297 0 01-.1-.07c-.03-.033-.05-.07-.05-.104h-.03c0 .045.026.09.059.124a.327.327 0 00.111.078l.01-.028zm-.882.029h.877v-.03H9.56v.03zm.146-.203c0 .034-.02.07-.052.103a.317.317 0 01-.1.07l.012.029a.347.347 0 00.11-.078c.033-.035.06-.079.06-.124h-.03zm0-.873v.873h.03v-.873h-.03zm-.053-.066l.056.075.024-.019-.056-.074-.024.018zm.676-.024h-.664v.03h.664v-.03zm-.04.102l.052-.08-.025-.016-.052.079.025.017zm.002.861v-.87h-.03v.87h.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.85 6.304s-.184.023-.184.241v-.183c-.056 0-.064.07-.064.26l-1.21-.003c0-.183 0-.26-.068-.26v.602c.139.055.236.234.236.234h.87s.098-.18.236-.234v.343h.135V6.75s-.056 0-.056-.097c0-.093.034-.16.105-.156v-.194z"
        fill="#fff"
      />
      <path
        d="M10.85 6.304h.015v-.017l-.017.002.002.015zm-.184.058h.015v-.015h-.015v.015zm-.064.26v.016h.015v-.015h-.015zm-1.21-.003h-.016v.015h.015v-.015zm-.068-.26v-.016h-.015v.015h.015zm0 .602h-.015v.01l.01.004.005-.014zm.236.234l-.013.007.004.008h.009v-.015zm.87 0v.015h.009l.004-.008-.013-.007zm.236-.234h.015V6.94l-.02.008.005.014zm0 .343h-.015v.015h.015v-.015zm.135 0v.015h.015v-.015h-.015zm0-.553h.015v-.015h-.015v.015zm.049-.253v.015l.015.001v-.016h-.015zm-.169.047c0-.104.044-.16.086-.19a.216.216 0 01.085-.036l-.002-.015-.002-.015h-.003a.244.244 0 00-.096.041c-.05.036-.098.101-.098.215h.03zm-.03-.183v.183h.03v-.183h-.03zm-.034.26c0-.095.002-.158.01-.198a.084.084 0 01.017-.038c.005-.006.012-.009.022-.009v-.03a.058.058 0 00-.045.019.112.112 0 00-.022.052c-.01.043-.011.11-.011.205h.03zm-1.226.012l1.211.004v-.03l-1.21-.004v.03zm-.067-.26c.013 0 .022.003.028.01a.08.08 0 01.016.039c.008.04.008.104.008.196h.03c0-.09 0-.158-.008-.202a.109.109 0 00-.024-.054.065.065 0 00-.05-.02v.03zm.015.587v-.603h-.03v.603h.03zm.221.234l.013-.007v-.001a.082.082 0 00-.005-.008.634.634 0 00-.062-.09.46.46 0 00-.177-.142l-.01.028a.43.43 0 01.163.133.752.752 0 01.064.092v.002l.014-.007zm.87-.015h-.87v.03h.87v-.03zm.23-.233a.46.46 0 00-.176.142.79.79 0 00-.05.069l-.012.021-.004.006a.082.082 0 00-.001.002l.013.008.013.007.001-.002.003-.005a.586.586 0 01.06-.087.43.43 0 01.165-.133l-.011-.028zm.021.357V6.96h-.03v.343h.03zm.12-.015h-.135v.03h.135v-.03zm-.015-.538v.553h.03V6.75h-.03zm-.056-.097c0 .052.015.08.033.096a.067.067 0 00.038.016v-.03h-.004a.038.038 0 01-.014-.008c-.01-.009-.023-.028-.023-.074h-.03zm.12-.17a.098.098 0 00-.092.048.233.233 0 00-.028.122h.03c0-.045.008-.082.024-.106a.068.068 0 01.065-.035l.002-.03zm-.015-.18v.194h.03v-.194h-.03z"
        fill="#000"
      />
      <path
        d="M9.324 6.536c0-.21-.184-.232-.184-.232v.187c.071-.003.105.06.105.15 0 .094-.056.094-.056.094v.532h.135v-.73z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M9.68 5.131h.645v-.03H9.68v.03zm-.075.203h.787v-.03h-.787v.03zm-.075.244h.934v-.03H9.53v.03zm-.079.296h1.106v-.03H9.451v.03zm-.026.337h1.14v-.03h-1.14v.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.823 5.134l.106.048.15-.003.102-.045v-.131a.474.474 0 01-.016.004c-.037.009-.076.019-.076.07-.014-.067-.03-.077-.058-.094-.008-.005-.017-.01-.027-.018-.01.009-.02.015-.028.02-.026.016-.046.028-.056.092-.008-.053-.044-.062-.083-.071a.857.857 0 01-.014-.003v.13zm-.208 2.042c.002-.137.005-.334-.115-.456h1c-.12.122-.117.319-.115.456v.043h-.77v-.043z"
        fill="#fff"
      />
      <path
        d="M9.93 5.183l-.008.015h.008v-.016zm-.107-.05h-.015v.01l.009.004.006-.013zm.257.046v.016l.006-.003-.006-.013zm.101-.045l.007.013.008-.003v-.01h-.015zm0-.131h.015v-.02l-.019.005.004.014zm-.016.004l-.004-.015.004.015zm-.076.07l-.015.004.03-.004h-.015zm-.058-.094l.008-.013-.008.013zm-.027-.018l.01-.012-.01-.007-.01.008.01.011zm-.028.02l-.008-.013.008.013zm-.056.092l-.014.003h.03l-.016-.003zm-.083-.071l.003-.015-.003.015zm-.014-.003l.004-.015-.019-.005v.02h.015zM9.5 6.72v-.015h-.036l.025.026.011-.011zm.115.456H9.6h.015zm.885-.456l.01.01.026-.025H10.5v.015zm-.115.456h.015-.015zm0 .043v.015h.015v-.015h-.015zm-.77 0H9.6v.015h.015v-.015zm.32-2.05L9.83 5.12l-.012.027.106.05.012-.028zm.144-.005l-.15.004v.03l.151-.004v-.03zm.096-.044l-.101.045.012.027.101-.045-.012-.027zm-.009-.117v.13h.03v-.13h-.03zm.002.018l.018-.004-.009-.029-.016.004.007.03zm-.064.056c0-.02.007-.031.018-.039a.144.144 0 01.046-.017l-.007-.029c-.017.005-.04.01-.057.022a.073.073 0 00-.03.063h.03zm-.081-.081a.092.092 0 01.03.024.16.16 0 01.02.06l.03-.006a.187.187 0 00-.026-.071c-.011-.016-.025-.024-.038-.033l-.016.026zm-.028-.02c.01.009.02.015.028.02l.016-.026-.025-.017-.019.024zm-.011.022a.237.237 0 00.03-.022l-.02-.022a.208.208 0 01-.026.018l.016.026zm-.049.082a.132.132 0 01.02-.058.092.092 0 01.029-.024l-.016-.026a.125.125 0 00-.038.032.16.16 0 00-.024.071l.03.005zm-.102-.06a.15.15 0 01.049.017c.011.008.02.02.024.043l.03-.005a.085.085 0 00-.037-.062C9.88 5 9.859 4.996 9.84 4.99l-.007.03zm-.014-.003l.014.003.007-.029a.767.767 0 01-.013-.003l-.008.029zm.019.117v-.131h-.03v.13h.03zM9.489 6.73a.393.393 0 01.1.214c.013.08.012.162.011.23h.03a1.302 1.302 0 00-.012-.235.423.423 0 00-.107-.23l-.022.02zm1.011-.026h-1v.03h1v-.03zm-.1.47a1.232 1.232 0 01.012-.23.394.394 0 01.099-.214l-.022-.022a.423.423 0 00-.107.23 1.324 1.324 0 00-.012.237h.03zm0 .044v-.043h-.03v.043h.03zm-.785.015h.77v-.03h-.77v.03zM9.6 7.176v.043h.03v-.043H9.6z"
        fill="#000"
      />
      <path
        d="M9.931 5.396l-.15-.105v-.116c.056.011.113.019.12.083.015-.094.049-.14.101-.177.05.038.083.083.102.176.004-.063.064-.07.112-.082v.12l-.146.101h-.139z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.886 5.73l-.255-.15v-.176l.023.003c.084.014.17.027.181.113a.36.36 0 01.17-.255c.092.053.148.124.182.255.01-.086.098-.1.182-.113l.023-.003v.176l-.261.15h-.245zm.478.199l-.228.213H9.87l-.233-.213h.728zm-.694.641c-.01-.158-.056-.244-.17-.285h1c-.114.041-.16.127-.17.285h-.66z"
        fill="#fff"
      />
      <path
        d="M9.63 5.58h-.014v.009l.007.004.008-.013zm.256.15l-.008.015h.008V5.73zm-.255-.326l.002-.015-.017-.003v.018h.015zm.023.003l-.002.015.002-.015zm.181.113l-.015.002.03.001-.015-.003zm.17-.255l.008-.013-.008-.004-.007.004.008.013zm.182.255l-.014.004.03-.002-.015-.002zm.182-.113l.002.015-.002-.015zm.023-.003h.015v-.018l-.017.003.002.015zm0 .176l.008.013.007-.004V5.58h-.015zm-.261.15v.017l.007-.004-.007-.013zm.005.412v.021l.01-.01-.01-.01zm.228-.213l.01.01.027-.025h-.037v.015zm-.495.213l-.013.015h.013v-.014zm-.233-.213v-.015h-.038l.028.026.01-.011zm-.136.356V6.27l-.005.03.005-.015zm.17.285l-.015.001.002.014h.013V6.57zm.83-.285l.005.014-.005-.029v.015zm-.17.285v.015h.014v-.014l-.014-.001zm-.707-.977l.256.15.015-.026-.256-.15-.015.026zm-.007-.19v.177h.03v-.176h-.03zm.04-.01l-.023-.004-.005.03.024.003.004-.03zm.194.125a.116.116 0 00-.071-.095.443.443 0 00-.123-.03l-.004.03a.44.44 0 01.114.027c.03.014.05.035.054.072l.03-.004zm.148-.266a.374.374 0 00-.177.265l.029.006a.345.345 0 01.164-.245l-.016-.026zm.204.264a.469.469 0 00-.072-.162.368.368 0 00-.117-.102l-.015.026c.044.025.08.055.108.094a.44.44 0 01.067.152l.029-.008zm.165-.123a.443.443 0 00-.123.03.116.116 0 00-.071.095l.03.004c.004-.037.024-.058.054-.072a.441.441 0 01.114-.028l-.005-.03zm.023-.004l-.024.004.005.03.023-.004-.004-.03zm.017.191v-.176h-.03v.176h.03zm-.269.163l.261-.15-.014-.026-.262.15.015.026zm-.252.002h.245v-.03h-.245v.03zm.26.408l.228-.213-.02-.022-.228.214.02.021zm-.277.005h.267v-.03H9.87v.03zm-.243-.218l.233.214.02-.023-.232-.213-.02.022zm.738-.026h-.728v.03h.728v-.03zm-.87.385c.055.02.092.05.117.092a.416.416 0 01.044.18l.03-.002a.445.445 0 00-.048-.193.237.237 0 00-.132-.105l-.01.028zM10.5 6.27h-1v.03h1v-.03zm-.155.301a.417.417 0 01.044-.18.208.208 0 01.116-.092l-.01-.028a.237.237 0 00-.131.105.444.444 0 00-.05.193l.03.002zm-.675.014h.66v-.03h-.66v.03z"
        fill="#000"
      />
      <path
        d="M10.332 5.925v-.21a.195.195 0 00-.142.124c0-.075-.094-.237-.195-.319-.101.09-.199.24-.195.315-.019-.056-.068-.101-.143-.12v.214l.675-.004z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
        stroke-linejoin="bevel"
      />
      <path
        d="M10.363 6.285v-.21c-.08.022-.132.064-.154.124 0-.075-.101-.236-.214-.319-.112.094-.217.24-.214.319-.019-.056-.075-.101-.154-.124v.214l.736-.004z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
        stroke-linejoin="bevel"
      />
      <path
        d="M10.453 6.724v-.248a.36.36 0 00-.192.143c0-.131-.15-.338-.266-.401-.12.067-.266.277-.266.4a.364.364 0 00-.195-.142v.248h.918z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
        stroke-linejoin="bevel"
      />
      <path
        d="M6.388 8.595V7.83c-.027-.098-.113-.188-.173-.202v-.676l.139.075.161.71v.862l-.127-.004z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M6.286 8.794c.064-.027.158-.109.158-.188v-.96l-.045-.075h1.638l-.063.075v.96a.224.224 0 00.127.188H6.286z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M7.768 8.794c-.064-.027-.158-.109-.158-.188v-.911l.135-.128h-1.11l.135.128v.911c0 .079-.094.162-.157.188h1.154z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M7.614 8.794c-.064-.027-.162-.109-.162-.188v-.825l.09-.123h-.704l.09.123v.825c0 .079-.094.162-.162.188h.848z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.447 6.81h.162v.12h.003v.638h-.165V6.81zm.117 1.163h.135v.618h-.135v-.618zm1.155 0h.131v.618h-.135l.004-.618zm.292-.904h-.228v.487h.228V7.07z"
        fill="#fff"
      />
      <path
        d="M6.609 6.81h.015l-.015-.015v.015zm-.162 0v-.015l-.014.015h.014zm.162.12h-.015l.015.015V6.93zm.003 0h.016l-.016-.015v.015zm0 .638v.014l.016-.014h-.016zm-.165 0h-.014l.014.014v-.014zm.252.405h.015l-.015-.016v.016zm-.135 0v-.016l-.015.016h.015zm.135.618v.015l.015-.015h-.015zm-.135 0h-.015l.015.015v-.015zm1.286-.618h.015l-.015-.016v.016zm-.131 0v-.016l-.015.015h.015zm.131.618v.015l.015-.015H7.85zm-.135 0H7.7l.015.015v-.015zm.067-1.522v-.015l-.014.015h.014zm.23 0h.014l-.015-.015v.015zm-.23.487h-.014l.014.015v-.015zm.23 0v.015l.014-.015h-.015zm-1.403-.761h-.162v.03h.162v-.03zm.015.135v-.12h-.03v.12h.03zm-.011-.015h-.004v.03h.003v-.03zm.014.652V6.93h-.03v.638h.03zm-.18.015h.165v-.03h-.165v.03zm-.014-.652v.638h.03V6.93h-.03zm0-.12v.12h.03v-.12h-.03zm.266 1.147h-.135v.03h.135v-.03zm.015.634v-.618h-.03v.618h.03zm-.15.015h.135v-.03h-.135v.03zm-.015-.633v.618h.03v-.618h-.03zm1.301-.016h-.131v.03h.131v-.03zm.015.634v-.618h-.03v.618h.03zm-.15.015h.135v-.03h-.135v.03zm-.011-.634l-.004.62h.03l.004-.62h-.03zm.079-.888h.228v-.03h-.228v.03zm.014.472V7.07h-.03v.487h.03zm.214-.015h-.228v.03h.228v-.03zm-.015-.472v.487h.03V7.07h-.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.609 6.473V7.56H7.79V6.476c-.018 0-.03.025-.044.055-.022.045-.05.103-.114.103-.056 0-.048-.068-.018-.12.026-.049.06-.113.015-.237-.034.094-.116.124-.101.068a.306.306 0 01.034-.078c.028-.049.052-.09.01-.196-.018.128-.1.124-.082.049a.283.283 0 01.02-.056c.02-.053.037-.097-.009-.188-.034.139-.075.131-.075.045v-.008c0-.122 0-.255-.157-.303 0 0-.011-.113-.068-.113-.06 0-.071.113-.071.113-.157.049-.157.184-.157.311 0 .087-.042.094-.075-.045-.046.091-.029.135-.008.188a.499.499 0 01.019.056c.019.075-.064.079-.083-.049-.04.105-.017.147.01.196a.306.306 0 01.035.078c.015.056-.067.026-.101-.067-.045.123-.011.187.015.236.034.052.037.12-.019.12-.063 0-.091-.06-.113-.106-.015-.03-.026-.055-.044-.055zM6.35 7.567v-.83c.032-.018.064-.018.1 0v.83h-.1z"
        fill="#fff"
      />
      <path
        d="M6.609 7.56h-.015v.015h.015V7.56zm0-1.087v-.016h-.015v.016h.015zM7.79 7.56v.015h.015V7.56H7.79zm0-1.084h.015v-.015H7.79v.015zm-.044.055l.013.006-.013-.006zm-.132-.017l.013.007-.013-.007zm.015-.237l.014-.005-.014-.039-.014.04.014.005zm-.101.068l.014.004-.014-.004zm.034-.078l-.013-.007.013.007zm.01-.196l.014-.005-.02-.053-.008.056.014.002zm-.082.049l-.015-.004.015.004zm.02-.056l-.015-.006.014.006zm-.01-.188l.014-.006-.019-.037-.01.04.015.003zm-.075.037H7.41h.015zM7.27 5.61l-.015.001v.01l.01.003.005-.014zm-.139 0l.004.014.01-.003v-.01L7.13 5.61zm-.232.266l.014-.003-.01-.04-.018.037.013.006zm-.008.188l.014-.006-.014.006zm.019.056l.014-.004-.014.004zm-.083-.049l.015-.002-.008-.056-.02.053.013.005zm.01.196l.014-.007-.013.007zm.035.078l-.014.004.014-.004zm-.101-.067l.014-.006-.014-.039-.014.04.014.005zm.015.236l-.013.007.013-.007zm-.132.014l.013-.006-.013.006zm-.303.21l-.008-.012-.007.004v.009h.015zm0 .83h-.015v.014h.015v-.014zm.1-.83h.015V6.73l-.008-.005-.007.014zm0 .83v.014h.015v-.014H6.45zm.174-.008V6.473h-.03V7.56h.03zm1.166-.015H6.609v.03H7.79v-.03zm-.015-1.069V7.56h.03V6.476h-.03zm-.016.061a.274.274 0 01.02-.036c.006-.009.01-.01.011-.01v-.03c-.017 0-.028.012-.036.023-.007.01-.015.026-.022.04l.027.013zm-.127.112a.108.108 0 00.084-.04c.02-.022.032-.05.043-.072l-.027-.013a.29.29 0 01-.039.065.078.078 0 01-.06.03v.03zm-.031-.143a.17.17 0 00-.025.088.06.06 0 00.015.039c.01.01.024.016.042.016v-.03c-.011 0-.017-.003-.02-.007-.004-.004-.007-.01-.007-.02a.14.14 0 01.02-.07l-.025-.016zm.014-.223c.021.06.024.104.018.138a.261.261 0 01-.032.086l.026.014a.29.29 0 00.036-.095.302.302 0 00-.02-.154l-.028.01zm-.102.058c-.004.016-.004.034.012.043a.033.033 0 00.021.004.064.064 0 00.02-.007.18.18 0 00.077-.098l-.028-.01a.152.152 0 01-.062.081.035.035 0 01-.011.004H7.54c.003.002-.001.004.002-.01l-.029-.007zm.036-.081a.307.307 0 00-.036.081l.029.008a.292.292 0 01.033-.075L7.55 6.26zm.01-.183a.22.22 0 01.02.111.197.197 0 01-.03.072l.026.014a.226.226 0 00.033-.081.249.249 0 00-.022-.127l-.027.01zm-.084.04c-.005.02-.004.04.005.053.004.007.01.012.018.015a.038.038 0 00.023.001.074.074 0 00.04-.035.206.206 0 00.026-.078l-.03-.004a.177.177 0 01-.02.066c-.01.015-.018.02-.024.022h-.005s-.002 0-.003-.003c-.002-.004-.005-.014 0-.03l-.03-.008zm.02-.059c-.006.017-.014.036-.02.058l.03.008a.484.484 0 01.018-.055l-.028-.01zm-.007-.175a.205.205 0 01.027.1.227.227 0 01-.02.075l.028.011c.01-.026.02-.052.022-.084a.235.235 0 00-.03-.115l-.027.013zm-.077.038a.15.15 0 00.008.055.041.041 0 00.013.018.026.026 0 00.024.003.042.042 0 00.018-.013.116.116 0 00.015-.023.403.403 0 00.027-.081l-.03-.007a.376.376 0 01-.024.074.087.087 0 01-.01.018l-.006.004h.004l-.003-.005a.122.122 0 01-.006-.043h-.03zm0-.008v.008h.03v-.008h-.03zm-.147-.289c.075.023.11.065.129.115a.525.525 0 01.018.174h.03c0-.06 0-.127-.02-.184a.209.209 0 00-.148-.133l-.009.028zm-.063-.111c.009 0 .016.003.023.012.007.008.013.02.018.034a.248.248 0 01.011.048v.004l.016-.001.015-.002a.157.157 0 01-.001-.005.295.295 0 00-.013-.054.138.138 0 00-.023-.044.06.06 0 00-.046-.022v.03zm-.071.097l.015.002V5.61a.118.118 0 01.002-.015.234.234 0 01.01-.036.105.105 0 01.019-.034.034.034 0 01.025-.013v-.03c-.02 0-.036.01-.047.023a.135.135 0 00-.025.044.265.265 0 00-.014.06l.015.001zm-.143.311c0-.064 0-.127.02-.18a.18.18 0 01.127-.117l-.008-.028a.21.21 0 00-.148.135c-.02.059-.02.127-.02.19h.03zm-.104-.041a.404.404 0 00.027.08c.005.01.01.018.015.024a.042.042 0 00.018.013.026.026 0 00.024-.003.04.04 0 00.012-.018.15.15 0 00.008-.055h-.03a.134.134 0 01-.005.043l-.003.005h.003l-.004-.004a.086.086 0 01-.011-.018.376.376 0 01-.025-.074l-.03.007zm.02.178a.226.226 0 01-.02-.074.205.205 0 01.028-.101l-.027-.013a.235.235 0 00-.03.115.226.226 0 00.022.084l.028-.01zm.02.058c-.005-.022-.013-.04-.02-.058l-.027.011a.48.48 0 01.018.055l.03-.008zm-.112-.043c.005.034.015.06.026.078.011.018.025.03.04.035a.038.038 0 00.024 0 .036.036 0 00.018-.016c.009-.014.01-.033.004-.054l-.029.008c.004.016.002.026 0 .03l-.004.003h-.004c-.006-.001-.015-.007-.024-.022a.177.177 0 01-.02-.066l-.03.004zm.039.187a.197.197 0 01-.03-.072.22.22 0 01.02-.111l-.028-.011a.249.249 0 00-.021.127.226.226 0 00.033.081l.026-.014zm.036.081a.367.367 0 00-.036-.081l-.026.014a.292.292 0 01.033.075l.029-.008zm-.13-.058a.18.18 0 00.076.098.064.064 0 00.02.007c.007 0 .015 0 .022-.004.016-.009.016-.027.012-.043l-.03.008c.004.013 0 .011.003.01h-.002a.034.034 0 01-.011-.005.152.152 0 01-.062-.082l-.028.01zm.042.224a.261.261 0 01-.032-.086.272.272 0 01.018-.138l-.028-.01a.302.302 0 00-.02.153.29.29 0 00.036.095l.026-.014zm-.032.142a.057.057 0 00.042-.016.06.06 0 00.016-.038.153.153 0 00-.026-.09l-.026.017a.123.123 0 01.022.07.03.03 0 01-.007.02c-.004.004-.01.007-.02.007v.03zm-.127-.114c.011.023.024.05.044.073.02.023.046.04.083.04v-.03a.077.077 0 01-.06-.03.298.298 0 01-.04-.066l-.027.013zm-.03-.048s.004.001.01.01a.284.284 0 01.02.038l.027-.013c-.007-.015-.014-.03-.022-.042-.007-.01-.018-.023-.035-.023v.03zm-.274.252v.829h.03v-.83h-.03zm.122-.014a.11.11 0 00-.115 0l.016.027a.08.08 0 01.04-.012c.014 0 .029.004.045.012l.014-.027zm.008.843v-.83h-.03v.83h.03zm-.115.014h.1v-.03h-.1v.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.348 5.955l-.068.056h-.169l-.067-.06v-.075c.026.008.037.011.056.038a.188.188 0 01.098-.109.187.187 0 01.093.113c.019-.027.034-.038.056-.038v.075zm.442 1.609c.03-.165.146-.233.263-.289v.289H7.79z"
        fill="#fff"
      />
      <path
        d="M7.28 6.011v.02l.01-.008-.01-.012zm.067-.056l.015.018v-.018h-.014zm-.236.056l-.013.015h.013v-.015zm-.067-.06H7.02l.013.011.01-.01zm0-.075l.004-.014-.02-.006v.02h.016zm.056.038l-.012.008.017.024.01-.027-.015-.005zm.098-.109l.01-.022-.017.008.006.014zm.093.113l-.014.004.009.03.017-.026-.012-.008zm.056-.038h.015v-.015h-.014v.015zm.705 1.395h.016v-.024l-.022.01.007.014zm-.262.289l-.015-.003-.003.018h.018v-.015zm.263 0v.015h.014v-.015h-.014zM7.29 6.023l.067-.056-.02-.024L7.27 6l.02.023zm-.179.003h.169v-.03h-.169v.03zm-.077-.064l.067.06.02-.022-.067-.06-.02.022zm-.005-.086v.075h.03v-.075h-.03zm.083.029a.103.103 0 00-.03-.03.136.136 0 00-.034-.013l-.008.029a.11.11 0 01.027.01c.006.003.012.01.02.021l.025-.017zm.08-.114a.203.203 0 00-.106.118l.028.01a.172.172 0 01.09-.1L7.19 5.79zm.114.122a.203.203 0 00-.102-.121l-.013.026a.173.173 0 01.086.104l.029-.009zm.042-.048a.065.065 0 00-.038.012.128.128 0 00-.031.032l.024.017a.1.1 0 01.023-.025.035.035 0 01.022-.006v-.03zm.014.09V5.88h-.03v.075h.03zm.684 1.306c-.117.057-.24.127-.27.3l.029.005c.028-.157.138-.221.254-.277l-.013-.027zm.022.303v-.289h-.03v.289h.03zm-.278.015h.263v-.03H7.79v.03z"
        fill="#000"
      />
      <path
        d="M7.317 6.195l.03-.071V6.03c-.022 0-.037.011-.056.037a.187.187 0 00-.094-.112.188.188 0 00-.097.109c-.019-.027-.03-.03-.056-.034v.094l.03.071h.244z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M7.325 6.442l.098-.123v-.12c-.038 0-.057.019-.083.06-.026-.087-.075-.102-.143-.143-.07.038-.12.057-.142.139-.03-.041-.049-.053-.086-.056v.12l.101.123h.255z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M7.351 6.686s.12-.101.124-.157v-.131c-.045.003-.086.014-.12.07-.03-.108-.075-.138-.158-.187-.086.049-.13.079-.157.188-.037-.057-.075-.068-.124-.075v.135a.56.56 0 00.124.157h.311z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M7.4 7.136s.165-.176.169-.247v-.203c-.06.008-.12.049-.165.135-.038-.168-.098-.285-.207-.367-.112.082-.172.199-.21.367-.045-.086-.1-.127-.16-.135v.203c.01.071.164.247.164.247H7.4z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M7.4 7.402s.139-.138.169-.198V7c-.06.008-.12.049-.165.131a.525.525 0 00-.207-.345.518.518 0 00-.21.346c-.045-.083-.1-.124-.16-.132v.203c.037.06.164.199.164.199H7.4z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M7.456 7.56c-.037-.176-.075-.307-.266-.439-.195.131-.229.263-.27.439h.536zm6.158 1.035V7.83c.026-.098.112-.188.172-.202v-.676l-.138.075-.162.71v.862l.128-.004z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M13.715 8.794c-.064-.027-.158-.109-.158-.188v-.96l.045-.075h-1.638l.063.075v.96a.225.225 0 01-.127.188h1.815z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M12.234 8.794c.063-.027.157-.109.157-.188v-.911l-.135-.128h1.11l-.135.128v.911c0 .079.094.162.158.188h-1.155z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M12.387 8.794c.064-.027.162-.109.162-.188v-.825l-.09-.123h.705l-.09.123v.825c0 .079.094.162.161.188h-.848z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.554 6.81h-.162v.12h-.003v.638h.165V6.81zm-.117 1.163h-.134v.618h.134v-.618zm-1.154 0h-.132v.618h.135l-.003-.618zm-.293-.904h.229v.487h-.229V7.07z"
        fill="#fff"
      />
      <path
        d="M13.393 6.81h-.016l.015-.015v.015zm.16 0v-.015l.016.015h-.015zm-.16.12h.014l-.014.015V6.93zm-.004 0h-.015l.015-.015v.015zm0 .638v.014l-.015-.014h.015zm.165 0h.015l-.015.014v-.014zm-.252.405h-.014l.014-.016v.016zm.136 0v-.016l.014.016h-.014zm-.136.618v.015l-.014-.015h.014zm.136 0h.014l-.014.015v-.015zm-1.287-.618h-.015l.015-.016v.016zm.132 0v-.016l.014.015h-.014zm-.132.618v.015l-.015-.015h.015zm.135 0h.015l-.015.015v-.015zM12.22 7.07v-.015l.015.015h-.015zm-.229 0h-.015l.015-.015v.015zm.229.487h.015l-.015.015v-.015zm-.229 0v.015l-.015-.015h.015zm1.402-.761h.162v.03h-.162v-.03zm-.014.135v-.12h.03v.12h-.03zm.01-.015h.005v.03h-.004v-.03zm-.014.652V6.93h.03v.638h-.03zm.18.015h-.165v-.03h.165v.03zm.015-.652v.638h-.03V6.93h.03zm0-.12v.12h-.03v-.12h.03zm-.267 1.147h.136v.03h-.136v-.03zm-.014.634v-.618h.03v.618h-.03zm.15.015h-.136v-.03h.136v.03zm.014-.633v.618h-.03v-.618h.03zm-1.3-.016h.13v.03h-.13v-.03zm-.016.634v-.618h.03v.618h-.03zm.15.015h-.135v-.03h.135v.03zm.011-.634l.004.62h-.03l-.004-.62h.03zm-.078-.888h-.229v-.03h.229v.03zm-.015.472V7.07h.03v.487h-.03zm-.214-.015h.229v.03h-.229v-.03zm.015-.472v.487h-.03V7.07h.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.393 6.473V7.56H12.21V6.476c.018 0 .03.025.044.055.022.045.05.103.114.103.056 0 .049-.068.018-.12-.026-.049-.06-.113-.014-.237.033.094.116.124.1.068a.282.282 0 00-.034-.078c-.027-.049-.051-.09-.01-.196.018.128.101.124.082.049a.49.49 0 00-.019-.056c-.02-.053-.037-.097.008-.188.034.139.075.131.075.045v-.008c0-.122 0-.255.158-.303 0 0 .01-.113.067-.113.06 0 .071.113.071.113.158.049.158.184.158.311 0 .087.041.094.075-.045.045.091.028.135.008.188a.515.515 0 00-.02.056c-.018.075.064.079.083-.049.041.105.017.147-.01.196a.282.282 0 00-.035.078c-.015.056.067.026.101-.067.045.123.011.187-.015.236-.034.052-.037.12.019.12.064 0 .091-.06.113-.106.015-.03.027-.055.044-.055zm.258 1.095v-.83c-.032-.018-.064-.018-.1 0v.83h.1z"
        fill="#fff"
      />
      <path
        d="M13.393 7.56h.014v.015h-.014V7.56zm0-1.087v-.016h.014v.016h-.014zM12.21 7.56v.015h-.015V7.56h.015zm0-1.084h-.015v-.015h.015v.015zm.044.055l-.013.006.013-.006zm.132-.017l-.013.007.013-.007zm-.014-.237l-.015-.005.015-.039.014.04-.014.005zm.1.068l-.014.004.015-.004zm-.034-.078l.013-.007-.013.007zm-.01-.196l-.014-.005.02-.053.009.056-.015.002zm.082.049l.015-.004-.015.004zm-.019-.056l.014-.006-.014.006zm.008-.188l-.013-.006.018-.037.01.04-.015.003zm.075.037h.015-.015zm.158-.303l.014.001v.01l-.01.003-.005-.014zm.138 0l-.004.014-.01-.003v-.01l.014-.001zm.233.266l-.015-.003.01-.04.018.037-.013.006zm.008.188l-.014-.006.014.006zm-.02.056l-.014-.004.014.004zm.083-.049l-.015-.002.008-.056.021.053-.014.005zm-.01.196l-.013-.007.013.007zm-.035.078l.014.004-.014-.004zm.101-.067l-.014-.006.014-.039.014.04-.014.005zm-.015.236l.014.007h-.001l-.013-.007zm.132.014l-.013-.006.013.006zm.303.21l.008-.012.007.004v.009h-.015zm0 .83h.015v.014h-.015v-.014zm-.1-.83h-.015V6.73l.008-.005.007.014zm0 .83v.014h-.015v-.014h.015zm-.174-.008V6.473h.03V7.56h-.03zm-1.166-.015h1.181v.03h-1.18v-.03zm.015-1.069V7.56h-.03V6.476h.03zm.016.061a.279.279 0 00-.02-.036c-.006-.009-.01-.01-.01-.01v-.03c.016 0 .027.012.035.023a.296.296 0 01.022.04l-.027.013zm.127.112a.108.108 0 01-.084-.04c-.019-.022-.032-.05-.043-.072l.027-.013a.288.288 0 00.039.065c.015.018.034.03.06.03v.03zm.031-.143a.17.17 0 01.025.088.06.06 0 01-.014.039.055.055 0 01-.042.016v-.03c.01 0 .016-.003.02-.007a.038.038 0 00.007-.02.14.14 0 00-.022-.07l.026-.016zm-.013-.223a.272.272 0 00-.019.138.26.26 0 00.033.086l-.027.014c-.013-.025-.029-.055-.036-.095a.302.302 0 01.02-.154l.029.01zm.101.058c.004.016.004.034-.011.043a.033.033 0 01-.022.004.064.064 0 01-.02-.007.18.18 0 01-.077-.098l.029-.01a.152.152 0 00.061.081.035.035 0 00.011.004h.002c-.003.002.002.004-.002-.01l.03-.007zm-.036-.081a.32.32 0 01.036.081l-.029.008a.304.304 0 00-.033-.075l.026-.014zm-.01-.183a.22.22 0 00-.019.111.197.197 0 00.03.072l-.027.014a.226.226 0 01-.033-.081.249.249 0 01.022-.127l.028.01zm.084.04c.005.02.004.04-.004.053a.036.036 0 01-.042.016.074.074 0 01-.04-.035.206.206 0 01-.026-.078l.03-.004c.004.03.012.052.021.066.009.015.018.02.023.022h.005s.002 0 .003-.003c.003-.004.005-.014 0-.03l.03-.008zm-.02-.059a.486.486 0 01.02.058l-.03.008a.394.394 0 00-.018-.055l.028-.01zm.007-.175a.206.206 0 00-.027.1c.001.027.01.049.02.075l-.028.011c-.01-.026-.02-.052-.022-.084a.234.234 0 01.03-.115l.027.013zm.077.038a.15.15 0 01-.008.055.04.04 0 01-.013.018.026.026 0 01-.023.003.042.042 0 01-.019-.013.114.114 0 01-.014-.023.404.404 0 01-.028-.081l.03-.007a.38.38 0 00.024.074.09.09 0 00.011.018l.005.004h-.004s.002 0 .003-.005a.123.123 0 00.006-.043h.03zm0-.008v.008h-.03v-.008h.03zm.147-.289c-.074.023-.11.065-.128.115a.526.526 0 00-.019.174h-.03c0-.06 0-.127.02-.184a.208.208 0 01.148-.133l.009.028zm.063-.111a.028.028 0 00-.023.012.11.11 0 00-.018.034.24.24 0 00-.011.048v.004l-.015-.001-.015-.002v-.005l.002-.013a.27.27 0 01.011-.041.137.137 0 01.023-.044.06.06 0 01.046-.022v.03zm.071.097l-.015.002v-.005a.2.2 0 00-.012-.048.104.104 0 00-.019-.034.033.033 0 00-.025-.013v-.03c.02 0 .036.01.048.023.01.013.019.029.024.044a.27.27 0 01.014.054v.005l-.015.002zm.143.311c0-.064 0-.127-.02-.18a.18.18 0 00-.127-.117l.009-.028a.21.21 0 01.147.135c.02.059.02.127.02.19h-.03zm.104-.041a.404.404 0 01-.027.08.114.114 0 01-.014.024.042.042 0 01-.019.013.026.026 0 01-.023-.003.04.04 0 01-.013-.018.15.15 0 01-.008-.055h.03c0 .021.002.035.006.043l.002.005h-.003s.002 0 .005-.004a.08.08 0 00.01-.018.372.372 0 00.025-.074l.03.007zm-.02.178a.225.225 0 00.02-.074.205.205 0 00-.028-.101l.027-.013a.235.235 0 01.03.115c0 .032-.011.058-.021.084l-.028-.01zm-.02.058a.511.511 0 01.02-.058l.028.011a.47.47 0 00-.019.055l-.029-.008zm.112-.043a.206.206 0 01-.026.078.074.074 0 01-.04.035.038.038 0 01-.024 0 .036.036 0 01-.018-.016.07.07 0 01-.004-.054l.03.008c-.005.016-.003.026 0 .03a.006.006 0 00.003.003h.005c.005-.001.014-.007.023-.022a.176.176 0 00.021-.066l.03.004zm-.038.187a.199.199 0 00.029-.072.22.22 0 00-.02-.111l.028-.011a.249.249 0 01.021.127c-.004.032-.019.057-.032.081l-.027-.014zm-.036.081a.266.266 0 01.036-.081l.026.014a.292.292 0 00-.034.075l-.028-.008zm.13-.058a.181.181 0 01-.077.098.064.064 0 01-.02.007.033.033 0 01-.022-.004c-.015-.009-.016-.027-.011-.043l.029.008c-.004.013 0 .011-.003.01h.003a.034.034 0 00.01-.005.151.151 0 00.062-.082l.028.01zm-.043.224a.26.26 0 00.033-.086.273.273 0 00-.019-.138l.028-.01a.302.302 0 01.02.153.292.292 0 01-.036.095l-.026-.014zm.032.142a.057.057 0 01-.042-.016.06.06 0 01-.016-.038.153.153 0 01.027-.09l.025.017a.123.123 0 00-.022.07c0 .01.003.016.007.02s.01.007.021.007v.03zm.127-.114a.31.31 0 01-.043.073.107.107 0 01-.084.04v-.03a.077.077 0 00.06-.03.299.299 0 00.04-.066l.027.013zm.03-.048s-.004.001-.01.01a.278.278 0 00-.02.038l-.027-.013a.313.313 0 01.022-.042c.007-.01.019-.023.036-.023v.03zm.274.252v.829h-.03v-.83h.03zm-.122-.014a.11.11 0 01.114 0l-.014.027a.08.08 0 00-.041-.012.096.096 0 00-.045.012l-.014-.027zm-.008.843v-.83h.03v.83h-.03zm.115.014h-.1v-.03h.1v.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.654 5.955l.067.056h.169l.067-.06v-.075c-.026.008-.037.011-.056.038a.188.188 0 00-.097-.109.187.187 0 00-.094.113c-.019-.027-.034-.038-.056-.038v.075zm-.443 1.609c-.03-.165-.146-.233-.262-.289v.289h.262z"
        fill="#fff"
      />
      <path
        d="M12.721 6.011v.02l-.01-.008.01-.012zm-.067-.056l-.015.018v-.018h.015zm.236.056l.013.015h-.013v-.015zm.067-.06h.023l-.013.011-.01-.01zm0-.075l-.004-.014.02-.006v.02h-.016zm-.056.038l.013.008-.018.024-.009-.027.014-.005zm-.097-.109l-.011-.022.017.008-.006.014zm-.094.113l.014.004-.008.03-.018-.026.012-.008zm-.056-.038h-.015v-.015h.015v.015zm-.705 1.395h-.015v-.024l.021.01-.006.014zm.262.289l.015-.003.003.018h-.018v-.015zm-.262 0v.015h-.015v-.015h.015zm.763-1.541l-.068-.056.02-.024.067.057-.02.023zm.178.003h-.169v-.03h.169v.03zm.077-.064l-.067.06L12.88 6l.067-.06.02.022zm.005-.086v.075h-.03v-.075h.03zm-.083.029a.103.103 0 01.03-.03.136.136 0 01.034-.013l.009.029a.11.11 0 00-.028.01.072.072 0 00-.02.021l-.025-.017zm-.079-.114a.2.2 0 01.105.118l-.028.01a.173.173 0 00-.09-.1l.013-.028zm-.114.122a.203.203 0 01.1-.121l.015.026a.172.172 0 00-.087.104l-.028-.009zm-.042-.048c.014 0 .026.004.038.012.01.007.02.018.03.032l-.024.017a.099.099 0 00-.023-.025.035.035 0 00-.021-.006v-.03zm-.015.09V5.88h.03v.075h-.03zm-.684 1.306c.117.057.24.127.271.3l-.03.005c-.028-.157-.138-.221-.254-.277l.013-.027zm-.021.303v-.289h.03v.289h-.03zm.277.015h-.262v-.03h.262v.03z"
        fill="#000"
      />
      <path
        d="M12.684 6.195l-.03-.071V6.03c.022 0 .037.011.056.037a.187.187 0 01.094-.112c.046.022.08.06.097.109.019-.027.03-.03.056-.034v.094l-.03.071h-.243z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M12.676 6.442l-.097-.123v-.12c.037 0 .056.019.082.06.027-.087.075-.102.143-.143.071.038.12.057.142.139.03-.041.049-.053.087-.056v.12l-.102.123h-.255z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M12.65 6.686s-.12-.101-.124-.157v-.131c.045.003.087.014.12.07.03-.108.075-.138.158-.187.086.049.131.079.157.188.038-.057.075-.068.124-.075v.135a.563.563 0 01-.124.157h-.311z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M12.601 7.136s-.165-.176-.169-.247v-.203c.06.008.12.049.165.135.038-.168.098-.285.207-.367.112.082.172.199.21.367.045-.086.101-.127.161-.135v.203c-.011.071-.165.247-.165.247h-.409z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M12.601 7.402s-.139-.138-.169-.198V7c.06.008.12.049.165.131a.525.525 0 01.207-.345.518.518 0 01.21.346c.045-.083.101-.124.161-.132v.203c-.038.06-.165.199-.165.199h-.409z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        d="M12.545 7.56c.037-.176.075-.307.266-.439.195.131.229.263.27.439h-.536z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.113 9.03H5.885v.304h8.228V9.03zM5.4 9.735h9.2v.469h.244v.468H5.158v-.468H5.4v-.469z"
        fill="#fff"
      />
      <path
        d="M5.885 9.03v-.015H5.87v.015h.015zm8.228 0h.014v-.015h-.014v.015zm-8.228.304H5.87v.015h.015v-.015zm8.228 0v.015h.014v-.015h-.014zm.487.401h.015V9.72H14.6v.015zm-9.199 0V9.72h-.015v.015h.015zm9.199.469h-.015v.015h.015v-.015zm.244 0h.015v-.015h-.015v.015zm0 .468v.015h.015v-.014h-.015zm-9.686 0h-.016v.015h.015v-.014zm0-.468v-.015h-.016v.015h.015zm.243 0v.015h.015v-.015h-.015zm.484-1.159h8.228v-.03H5.885v.03zm.015.289V9.03h-.03v.304h.03zm8.213-.015H5.885v.03h8.228v-.03zm-.015-.289v.304h.03V9.03h-.03zm.502.69H5.401v.03H14.6v-.03zm.015.484v-.469h-.03v.469h.03zm.229-.015H14.6v.03h.244v-.03zm.015.483v-.468h-.03v.468h.03zm-9.701.015h9.686v-.03H5.158v.03zm-.016-.483v.468h.03v-.468h-.03zm.26-.015h-.245v.03h.244v-.03zm-.016-.454v.469h.03v-.469h-.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.977 8.77h-7.95v.249h7.95V8.77zm.383.574H5.645v.426h8.715v-.426z"
        fill="#fff"
      />
      <path
        d="M6.027 8.77v-.015h-.014v.015h.014zm7.95 0h.015v-.015h-.015v.015zm-7.95.249h-.014v.015h.014v-.015zm7.95 0v.015h.015v-.015h-.015zm-8.332.325V9.33H5.63v.015h.015zm8.715 0h.015V9.33h-.015v.015zm-8.715.426H5.63v.015h.015V9.77zm8.715 0v.015h.015V9.77h-.015zm-8.332-.985h7.95v-.03h-7.95v.03zm.015.234V8.77h-.03v.249h.03zm7.934-.015h-7.95v.03h7.95v-.03zm-.014-.234v.249h.03V8.77h-.03zm-8.318.59h8.715v-.03H5.645v.03zm.015.41v-.426h-.03v.426h.03zm8.7-.015H5.645v.03h8.715v-.03zm-.015-.41v.425h.03v-.426h-.03z"
        fill="#000"
      />
      <path
        d="M6.89 8.786h.6v1.875h-.6V8.786z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.359 8.786h-.334l-.004 1.875h.338V8.786zm2.928 0h-.6v1.875h.6V8.786z"
        fill="#fff"
      />
      <path
        d="M7.025 8.786v-.015H7.01v.015h.015zm.334 0h.015v-.015h-.015v.015zm-.338 1.875h-.015v.015h.015v-.015zm.338 0v.015h.015v-.015h-.015zm2.329-1.875v-.015h-.016v.015h.015zm.6 0h.014v-.015h-.014v.015zm-.6 1.875h-.016v.015h.015v-.015zm.6 0v.015h.014v-.015h-.014zm-3.263-1.86h.334v-.03h-.334v.03zm.011 1.86l.004-1.875h-.03l-.004 1.875h.03zm.323-.015H7.02v.03h.338v-.03zm-.015-1.86v1.875h.03V8.786h-.03zm2.343.015h.6v-.03h-.6v.03zm.016 1.86V8.786h-.03v1.875h.03zm.585-.015h-.6v.03h.6v-.03zm-.015-1.86v1.875h.03V8.786h-.03z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.164 8.786h-.338v1.875h.338V8.786zm2.944 0h-.6v1.875h.6V8.786z"
        fill="#fff"
      />
      <path
        d="M9.826 8.786v-.015h-.015v.015h.015zm.338 0h.015v-.015h-.015v.015zm-.338 1.875h-.015v.015h.015v-.015zm.338 0v.015h.015v-.015h-.015zm2.344-1.875v-.015h-.015v.015h.014zm.6 0h.014v-.015h-.014v.015zm-.6 1.875h-.015v.015h.014v-.015zm.6 0v.015h.014v-.015h-.014zm-3.282-1.86h.338v-.03h-.338v.03zm.015 1.86V8.786h-.03v1.875h.03zm.323-.015h-.338v.03h.338v-.03zm-.015-1.86v1.875h.03V8.786h-.03zm2.359.015h.6v-.03h-.6v.03zm.015 1.86V8.786h-.03v1.875h.03zm.585-.015h-.6v.03h.6v-.03zm-.016-1.86v1.875h.03V8.786h-.03z"
        fill="#000"
      />
      <path
        d="M12.639 8.786h.337v1.875h-.337V8.786z"
        fill="#fff"
        stroke="#000"
        stroke-width=".03"
      />
    </symbol>
    <symbol id="KI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.577 10.736l.286-.62.286.62.17-.662.393.56.049-.68.487.48-.075-.677.566.387-.196-.654.627.28-.31-.609.667.165-.415-.543.686.044-.506-.462.683-.078-.581-.365.658-.198-.638-.255.612-.312-.673-.138.546-.415-.688-.017.463-.505-.68.105.365-.579-.65.224.254-.634-.599.335.136-.669-.529.436.014-.682-.442.523-.11-.674-.34.593-.23-.644-.229.644-.34-.593-.11.674-.442-.523.013.682-.529-.436.136.67-.599-.336.254.634-.65-.224.365.579-.68-.105.463.505-.688.017.547.415-.674.138.612.312-.638.255.659.198-.582.365.684.078-.507.462.686-.044-.415.543.668-.165-.311.61.627-.281-.196.654.566-.387-.075.678.488-.481.048.68.393-.56.17.662z"
            fill="#FFC84A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-.495 8.7l1.634-.663a.976.976 0 01.743.003l2.269.944c.257.107.547.1.797-.02l1.83-.88a.976.976 0 01.833-.005l1.917.885c.258.12.556.12.814.002l1.962-.894a.976.976 0 01.814.002l1.937.894c.255.117.547.12.803.007l2.116-.932a.98.98 0 01.724-.025l1.898.682v6.259H-.551L-.495 8.7z"
            fill="#F7FCFF"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="7"
            width="22"
            height="8"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M-.495 8.7l1.634-.663a.976.976 0 01.743.003l2.269.944c.257.107.547.1.797-.02l1.83-.88a.976.976 0 01.833-.005l1.917.885c.258.12.556.12.814.002l1.962-.894a.976.976 0 01.814.002l1.937.894c.255.117.547.12.803.007l2.116-.932a.98.98 0 01.724-.025l1.898.682v6.259H-.551L-.495 8.7z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-.495 10.154l1.634-.664a.976.976 0 01.743.004l2.269.944c.257.107.547.1.797-.021l1.83-.879a.976.976 0 01.833-.006l1.917.886c.258.12.556.12.814.002l1.962-.895a.976.976 0 01.814.002l1.937.894c.255.118.547.12.803.008l2.116-.932a.98.98 0 01.724-.026l1.898.683m-21.091 2.08l1.634-.663a.977.977 0 01.743.003l2.269.945a.976.976 0 00.797-.022l1.83-.878a.976.976 0 01.833-.006l1.917.886c.258.119.556.12.814.002l1.962-.895a.976.976 0 01.814.002l1.937.894c.255.117.547.12.803.007l2.116-.932a.98.98 0 01.724-.025l1.898.682"
              stroke="#015989"
              stroke-width="1.25"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M-.495 13.892l.682-.277a3.477 3.477 0 012.643.012l1.32.55a.978.978 0 00.798-.022l.77-.369a3.476 3.476 0 012.961-.022l.849.392c.258.12.556.12.814.002l.918-.418a3.476 3.476 0 012.9.006l.895.414c.255.117.547.12.803.007l1.203-.53a3.476 3.476 0 012.577-.09l.958.345v2.072H-.38l-.115-2.072z"
              fill="#015989"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.113 2.137h1.162c.293 0 .954-.448 1.336-.3.382.15 1.026.632 1.026.632s1.062-.838 1.695-.838c.634 0 1.777-.094 1.777-.094s-.268.696-1.023.814c-.754.118-1.656.696-1.656.696h1.226c.187 0 .43.281.43.281s-.502.342-.754.342h-.528s-.534.458-1.193.36c-.66-.097-1.189-.702-1.189-.702s-.577-.082-.577-.182c0 0-.356-.182-.463 0-.107.182.463-.244.463-.244s.228-.214.403-.214c.174 0 .756.358.756.358l.14-.144-.722-.55c-1.47.153-2.31-.215-2.31-.215z"
            fill="#FFC84A"
          />
        </g>
      </g>
    </symbol>
    <symbol id="KM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#5196ED"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 7.5v3.75h20V7.5H0z" fill="#AF0100" />
          <path d="M0 3.75V7.5h20V3.75H0z" fill="#F7FCFF" />
          <path d="M0 0v3.75h20V0H0z" fill="#FECA00" />
          <path d="M0 0l12.5 7.5L0 15V0z" fill="#5EAA22" />
          <path
            d="M4.94 10.683S2.7 9.904 2.78 7.468c.08-2.437 2.36-2.914 2.36-2.914-.799-.587-3.657.1-3.748 2.914-.092 2.813 2.697 3.438 3.548 3.215zm.068-4.26l.07-.416-.297-.295.41-.06.184-.38.184.38.41.06-.297.295.07.417-.367-.197-.367.197zm.07.857l-.07.417.367-.197.367.197-.07-.417.297-.295-.41-.06-.184-.38-.184.38-.41.06.297.295zm-.07 1.69l.07-.417-.297-.295.41-.06.184-.38.184.38.41.06-.297.295.07.416-.367-.196-.367.196zm0 1.272l.07-.416-.297-.295.41-.061.184-.38.184.38.41.06-.297.296.07.416-.367-.197-.367.197z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="KN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15L20 0H0z"
          fill="#5EAA22"
        />
        <path
          d="M.397 17.47l.453.504.563-.376L24.076 2.471l.75-.5-.602-.671-3.326-3.71-.452-.504-.563.376L-2.78 12.589l-.75.5.602.671 3.325 3.71z"
          fill="#272727"
          stroke="#FFD018"
          stroke-width="1.563"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.555 10.574l-.68 1.184-.434-1.334-1.352-.43 1.126-.687L6.08 7.91l1.11.855 1.152-.638-.323 1.421.924 1.063-1.388-.038zm6.25-4.096l-.68 1.184-.434-1.334-1.352-.43 1.126-.687-.135-1.395 1.11.854 1.152-.638-.323 1.421.924 1.063-1.388-.038z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="KP" width="20" height="15" fill="none">
      <g mask="url(#KP_-_Korea_(North)__a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3D58DB"
        />
        <g mask="url(#KP_-_Korea_(North)__b)">
          <path
            d="M0 3.125h-.625v8.75h21.25v-8.75H0z"
            fill="#C51918"
            stroke="#F7FCFF"
            stroke-width="1.25"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.25 10.625a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.247 8.669L4.549 9.85l.6-1.98L3.5 6.62l2.068-.041.679-1.954.679 1.954 2.068.042-1.648 1.25.599 1.979-1.698-1.181z"
            fill="#C51918"
          />
        </g>
      </g>
    </symbol>
    <symbol id="KR" width="20" height="15" fill="none">
      <g mask="url(#KR_-_Korea_(South)__a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <g mask="url(#KR_-_Korea_(South)__b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 11.387c2.002 0 3.624-1.723 3.624-3.849 0-2.126-1.622-3.849-3.624-3.849s-3.624 1.723-3.624 3.85c0 2.125 1.622 3.848 3.624 3.848z"
            fill="#3D58DB"
          />
          <g mask="url(#KR_-_Korea_(South)__c)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.751 7.833s-.203-1.815-1.71-1.914c-1.507-.098-1.913 1.331-2 1.71-.087.379-.307 1.39-1.893 1.39s-1.73-2.57-1.73-2.57V3.42h7.333v4.414z"
              fill="#E31D1C"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.562 1.283l.572.517-2.65 3.095-.572-.517 2.65-3.095zm.943.837l.572.517-2.555 3.05-.572-.517 2.555-3.05zm1.51 1.364l-.571-.517L3.882 6.04l.572.517 2.562-3.073zm8.837-2.418l-.572.515.993 1.164.572-.515-.993-1.164zm1.764 2.141l-.572.516.992 1.164.572-.515-.992-1.165zm-4.223.051l.571-.515.993 1.164-.572.515-.992-1.164zm2.335 1.626l-.572.516.992 1.164.572-.515-.992-1.165zm-1.356-2.49l.572-.515 2.762 3.363-.572.516-2.762-3.364zm1.912 6.508l-.576-.517-1.001 1.168.577.518 1-1.17zm-1.682 2.057l-.577-.517-1 1.168.577.518 1-1.17zm2.927-.938l.577.517-1 1.169-.578-.518 1.001-1.168zm-1.023 2.621l-.577-.517-1 1.169.576.517 1.001-1.169zm-1.527-1.406l.577.518-1.044 1.248-.577-.518 1.044-1.248zm2.29-1.562l-.576-.517-1.045 1.248.577.517 1.044-1.248zM4.004 9.306l.572-.516 2.553 2.926-.572.515-2.553-2.925zm.596 2.559l.572-.516 1.078 1.185-.572.515L4.6 11.865zm-1.907-1.433l-.572.516 2.567 2.964.572-.516-2.567-2.964zm.407-.337l.572-.516.935 1.096-.572.516-.935-1.096z"
            fill="#272727"
          />
        </g>
      </g>
    </symbol>
    <symbol id="KW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#093" />
          <path d="M0 10v5h20v-5H0z" fill="#E31D1C" />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l7.5-5V5L0 0z"
          fill="#272727"
        />
      </g>
    </symbol>
    <symbol id="KY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#2E42A5"
        />
      </g>
      <path fill="#2E42A5" d="M0 0h11v9H0z" />
      <mask
        id="b"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="11"
        height="9"
      >
        <path fill="#fff" d="M0 0h11v9H0z" />
      </mask>
      <g mask="url(#b)">
        <path
          d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
          fill="#F7FCFF"
        />
        <path
          d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
          fill="#F50100"
        />
        <path
          d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
          fill="#F7FCFF"
        />
        <path
          d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
          fill="#F50100"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="-1"
          y="-1"
          width="13"
          height="11"
          fill="#000"
        >
          <path fill="#fff" d="M-1-1h13v11H-1z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
          fill="#F50100"
        />
        <path
          d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
          fill="#F7FCFF"
          mask="url(#c)"
        />
      </g>
      <g clip-path="url(#KY_-_Cayman_Islands__clip0)">
        <path
          d="M13.481 9.272V6.995h4.641v2.277c0 1.465-.543 2.434-1.096 3.037a3.777 3.777 0 01-.771.647 2.564 2.564 0 01-.345.181.291.291 0 01-.025.007 1.223 1.223 0 01-.108-.042 2.896 2.896 0 01-.285-.147 4.05 4.05 0 01-.83-.647c-.595-.604-1.181-1.572-1.181-3.036z"
          fill="#fff"
        />
        <path
          d="M13.481 9.272V6.995h4.641v2.277c0 1.465-.543 2.434-1.096 3.037a3.777 3.777 0 01-.771.647 2.564 2.564 0 01-.345.181.291.291 0 01-.025.007 1.223 1.223 0 01-.108-.042 2.896 2.896 0 01-.285-.147 4.05 4.05 0 01-.83-.647c-.595-.604-1.181-1.572-1.181-3.036z"
          stroke="#0B50A0"
          stroke-width=".1"
        />
        <path
          d="M13.481 9.272V6.995h4.641v2.277c0 1.465-.543 2.434-1.096 3.037a3.777 3.777 0 01-.771.647 2.564 2.564 0 01-.345.181.291.291 0 01-.025.007 1.223 1.223 0 01-.108-.042 2.896 2.896 0 01-.285-.147 4.05 4.05 0 01-.83-.647c-.595-.604-1.181-1.572-1.181-3.036z"
          stroke="#F7FCFF"
          stroke-width=".1"
        />
        <mask
          id="d"
          maskUnits="userSpaceOnUse"
          x="13"
          y="6"
          width="6"
          height="8"
        >
          <path
            d="M13.481 9.272V6.995h4.641v2.277c0 1.465-.543 2.434-1.096 3.037a3.777 3.777 0 01-.771.647 2.564 2.564 0 01-.345.181.291.291 0 01-.025.007 1.223 1.223 0 01-.108-.042 2.896 2.896 0 01-.285-.147 4.05 4.05 0 01-.83-.647c-.595-.604-1.181-1.572-1.181-3.036z"
            fill="#fff"
          />
          <path
            d="M13.481 9.272V6.995h4.641v2.277c0 1.465-.543 2.434-1.096 3.037a3.777 3.777 0 01-.771.647 2.564 2.564 0 01-.345.181.291.291 0 01-.025.007 1.223 1.223 0 01-.108-.042 2.896 2.896 0 01-.285-.147 4.05 4.05 0 01-.83-.647c-.595-.604-1.181-1.572-1.181-3.036z"
            stroke="#fff"
            stroke-width=".1"
          />
        </mask>
        <g mask="url(#d)">
          <path fill="#F50100" d="M13.126 6.633h5.4v2.125h-5.4z" />
          <path
            d="M15.534 9.195c.172 0 .518-.195.604-.24.317-.197.548-.016.735.075.201.09.576.196.806 0 .23-.196.36-.181.519-.181.028-.226.028-.452.028-.708V7.96c-.201-.045-.302.015-.518.21-.216.197-.46.151-.778.03-.302-.135-.604-.376-.907 0-.086.106-.288.257-.49.257-.215 0-.403-.15-.489-.256-.317-.377-.605-.136-.907 0-.317.12-.576.166-.792-.03-.202-.196-.303-.256-.519-.211v.18c0 .257.015.483.044.709.158 0 .273-.015.504.18.23.197.619.091.806 0 .202-.09.432-.27.749-.075.086.046.417.241.605.241z"
            fill="#F50100"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.077 7.601s.13.006.284.172c.154.166.721.06.721-.04s-.344-.16-.212-.33c.133-.171.356-.172.536-.083.052 0 .046.585.164.553.373-.102.975-.303 1.152-.217.232.114.41.086.35-.077-.058-.163-.21-.265-.502-.176-.293.089-.224.176-.476.176-.253 0-.686.142-.494-.176.173-.286.379-.291.457-.171.04.061-.287.197-.287.26 0 .087.843-.171.952-.171.108 0 .405-.007.435.082.03.089.21.17.072.253-.137.083-.363.135-.207.242.155.106.549.155.566.265.017.11.187.276.119.276s-.191.156-.305.108c-.115-.047-.128-.089-.019-.127.11-.039.11-.2.019-.2-.09 0-.083-.012-.29-.07-.205-.056-.478-.119-.461 0 .016.12.155.377-.092.402-.248.024-.363.122-.412.043-.048-.079-.22-.184-.085-.218.136-.034.265.115.314.09.049-.024.154-.11.061-.213-.092-.103-.272-.107-.13-.184.14-.077.056-.135-.213.024-.27.16-.42.295-.656.276-.237-.019-.343.069-.42.043-.075-.026-.446.285-.553.206-.106-.079-.45-.109-.389-.206.062-.097.146-.147.238-.097.093.05.185.1.248.05.062-.05.26-.284.215-.318-.046-.035-.206-.093-.463-.093s-.263-.178-.324-.26c-.06-.08.087-.094.087-.094z"
            fill="#FFD100"
          />
          <path
            d="M15.534 10.695c.172 0 .518-.195.604-.24.317-.197.548-.016.735.075.201.09.576.196.806 0 .23-.196.36-.181.519-.181.028-.226.028-.452.028-.708V9.46c-.201-.045-.302.015-.518.21-.216.197-.46.151-.778.03-.302-.135-.604-.376-.907 0-.086.106-.288.257-.49.257-.215 0-.403-.15-.489-.256-.317-.377-.605-.136-.907 0-.317.12-.576.166-.792-.03-.202-.196-.303-.256-.519-.211v.18c0 .257.015.483.044.709.158 0 .273-.015.504.18.23.197.619.091.806 0 .202-.09.432-.27.749-.075.086.046.417.241.605.241zm0 1.438c.172 0 .518-.196.604-.241.317-.196.548-.015.735.075.201.09.576.196.806 0 .23-.196.36-.18.519-.18.028-.227.028-.453.028-.709v-.18c-.201-.046-.302.014-.518.21-.216.196-.46.15-.778.03-.302-.135-.604-.376-.907 0-.086.106-.288.257-.49.257-.215 0-.403-.151-.489-.257-.317-.376-.605-.135-.907 0-.317.12-.576.166-.792-.03-.202-.196-.303-.256-.519-.21v.18c0 .256.015.482.044.708.158 0 .273-.015.504.181.23.196.619.09.806 0 .202-.09.432-.271.749-.075.086.045.417.241.605.241zm0 1.437c.172 0 .518-.195.604-.24.317-.197.548-.016.735.075.201.09.576.196.806 0 .23-.196.36-.181.519-.181.028-.226.028-.452.028-.708v-.181c-.201-.046-.302.015-.518.21-.216.197-.46.151-.778.03-.302-.135-.604-.376-.907 0-.086.106-.288.257-.49.257-.215 0-.403-.15-.489-.256-.317-.377-.605-.136-.907 0-.317.12-.576.166-.792-.03-.202-.196-.303-.256-.519-.211v.18c0 .257.015.483.044.709.158 0 .273-.015.504.18.23.197.619.091.806 0 .202-.09.432-.27.749-.075.086.046.417.241.605.241z"
            fill="#0B50A0"
          />
          <path
            d="M15.871 11.656l-.025-.013-.024.014-.27.16.079-.333.007-.028-.022-.02-.262-.242h.372l.012-.033.113-.306.133.309.013.03h.313l-.231.244-.02.022.009.029.11.329-.307-.162zm-1.2-1.25l-.025-.013-.024.014-.27.16.079-.333.007-.028-.022-.02-.262-.242h.372l.012-.033.113-.306.133.309.013.03h.313l-.231.244-.02.022.009.029.11.329-.307-.162zm2.4 0l-.025-.013-.024.014-.27.16.079-.333.007-.028-.022-.02-.262-.242h.372l.012-.033.113-.306.133.309.013.03h.313l-.231.244-.02.022.009.029.11.329-.307-.162z"
            fill="#059334"
            stroke="#FFD100"
            stroke-width=".1"
          />
        </g>
      </g>
      <path
        d="M13.029 12.967c.055.123.45.284.91.077.311-.146.514-.354.706-.722.056-.092.083-.207-.045-.277-.102-.061-.267-.13-.34-.192-.037-.03-.074-.053-.101-.076.018.015.036.03.055.053.183.185-.01.453-.212.615-.147.115-.413.4-.799.13-.082-.061-.275.192-.174.392zm5.585 0c-.064.123-.46.284-.91.077-.312-.146-.514-.354-.716-.722-.046-.092-.073-.207.055-.277.101-.061.267-.13.34-.192.037-.03.064-.053.101-.076a.364.364 0 00-.055.053c-.184.185.01.453.202.615.147.115.423.4.808.13.083-.061.267.192.175.392z"
        fill="#FFD100"
      />
      <path
        d="M15.821 13.627c.735 0 1.865-.276 2.472-1.244.1-.161 0-.245-.12-.3a1.419 1.419 0 01-.367-.222c.147.123.12.207.018.346-.469.652-1.112.983-2.003.983-.89 0-1.534-.33-2.002-.983-.101-.139-.129-.223.009-.346-.074.07-.239.177-.368.223-.119.053-.22.138-.119.3.606.967 1.745 1.243 2.48 1.243z"
        fill="#FFD100"
      />
      <path
        d="M14.122 12.33c-.019-.077-.138-.047-.175.046a1.182 1.182 0 01-.128-.17c-.11-.138-.129-.23.027-.36.074-.062.22-.13.322-.054.211.146.1.384-.046.537zm3.39 0c.018-.077.147-.047.183.046.046-.054.092-.108.129-.17.11-.138.129-.23-.037-.36-.064-.062-.211-.13-.321-.054-.202.146-.101.384.046.537z"
        fill="#F50100"
      />
      <path
        d="M14.88 5.923c-.071-.102-.267-.148-.35-.057-.03.023-.072.023-.103.034-.051 0-.117.03-.097.143.056 0 .056.029.087.029.02-.012.074.197.177.186a.39.39 0 01.235.076c.031.034.072.125.02.171a.247.247 0 000 .354c.135.114.475.285.857-.046.371-.32.949-.137.99-.023.051.114.072.183.082.24.01.045.29.114.33.148.052.034.124.023.104-.08-.042-.32-.217-.365-.238-.513.104.011.176.011.217-.034.03-.046.072-.126.113-.149.031-.022.031-.045-.01-.034-.052.012-.082.034-.175.023-.22-.026-.166-.892-.892-1.06-.448-.104-1.008.61-1.161.68a.077.077 0 01-.01.003.213.213 0 01-.175-.09z"
        fill="#059334"
      />
      <defs>
        <clipPath id="KY_-_Cayman_Islands__clip0">
          <path
            fill="#fff"
            transform="translate(13.426 6.945)"
            d="M0 0h5v7H0z"
          />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="KZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#4EC7EE"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M2.556 14.523c-.04.294.149.503.464.638.425.18.853.011 1.247-.425l-.51-.46c-.176.193-.302.268-.4.267a32.6 32.6 0 01.734-.506l.144-.207c.115-.493-.243-.76-.788-.76-.321 0-.578.063-.74.2-.268.224-.223.582.059.769a.735.735 0 00.068.04c-.158.133-.254.27-.278.444z"
            fill="#FFE402"
          />
          <path
            d="M2.853 14.06s.078-.173.039-.263"
            stroke="#FFE402"
            stroke-width=".688"
          />
          <path
            d="M5.356 14.523c.04.294-.149.503-.464.638-.425.18-.853.011-1.247-.425l.51-.46c.176.193.302.268.4.267a32.006 32.006 0 00-.734-.506l-.143-.207c-.115-.493.242-.76.787-.76.321 0 .578.063.74.2.268.224.223.582-.059.769a.735.735 0 01-.068.04c.158.133.254.27.278.444z"
            fill="#FFE402"
          />
          <path
            d="M5.372 13.918l-.626.283c-.088-.195-.115-.372-.041-.54l.63.273c.022-.05.021-.051.037-.016zM2.556.477c-.04-.294.149-.503.464-.638.425-.18.853-.011 1.247.425l-.51.46c-.176-.193-.302-.268-.4-.267.191.137.436.306.734.506l.144.207c.115.493-.243.76-.788.76-.321 0-.578-.063-.74-.2-.268-.224-.223-.582.059-.769a.728.728 0 01.068-.04C2.676.789 2.58.652 2.556.478z"
            fill="#FFE402"
          />
          <path
            d="M5.356.477c.04-.294-.149-.503-.464-.638-.425-.18-.853-.011-1.247.425l.51.46c.176-.193.302-.268.4-.267-.191.137-.436.306-.734.506l-.143.207c-.115.493.242.76.787.76.321 0 .578-.063.74-.2.268-.224.223-.582-.059-.769a.728.728 0 00-.068-.04c.158-.133.254-.27.278-.444z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.184 12.54c-.395.01-.64.092-.64.472 0 .42.407.55.84.55.393 0 .835-.243.835-.68 0-.265-.337-.8-1.187-1.961-.03-.028-.046-.042-.059-.042a.548.548 0 01.262-.062.36.36 0 01.15.048v.455h.9v-.344c0-.388-.575-.847-1.05-.847-.414 0-.747.198-.916.481-.166.28-.039.55.2.764.356.491.633.897.806 1.165h-.141zm.042.316a.566.566 0 01-.036-.009c.009.01.041.048.041.165 0 .064-.003.109-.007.14a.33.33 0 01-.063-.418l.002-.003-.013-.026a.107.107 0 00.005-.002c.02-.01.036-.02.008.028l.063.125zm-.036-.009l-.012-.003c.002 0 .003 0 .005.002l.007.001zm.342.036c0-.012-.004-.019-.011-.023l.004.005c.004.01.007.015.007.018z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.728 12.54c.395.01.64.092.64.472 0 .42-.407.55-.84.55-.393 0-.835-.243-.835-.68 0-.265.337-.8 1.187-1.961.03-.028.046-.042.059-.042a.548.548 0 00-.262-.062.374.374 0 00-.15.048v.455h-.899v-.344c0-.388.574-.847 1.049-.847.414 0 .747.198.916.481.166.28.039.55-.2.764-.356.491-.633.897-.806 1.165h.141zm-.042.316a.566.566 0 00.036-.009c-.008.01-.041.048-.041.165 0 .064.003.109.007.14a.33.33 0 00.063-.418l-.002-.003.013-.026a.107.107 0 01-.005-.002c-.02-.01-.036-.02-.008.028l-.063.125zm.036-.009l.012-.003a.024.024 0 00-.005.002l-.007.001zm-.342.036c0-.012.004-.019.011-.023l-.004.005a.061.061 0 00-.007.018z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.184 8.347c-.395-.012-.64-.093-.64-.473 0-.42.407-.55.84-.55.393 0 .835.243.835.68 0 .265-.337.8-1.187 1.961-.03.028-.046.042-.059.042a.547.547 0 00.262.062.374.374 0 00.15-.048v-.455h.9v.344c0 .388-.575.847-1.05.847-.414 0-.747-.197-.916-.481-.166-.28-.039-.55.2-.764.356-.49.633-.897.806-1.165a3.5 3.5 0 01-.141 0zm.042-.317a.58.58 0 00-.036.009c.009-.009.041-.048.041-.165 0-.064-.003-.109-.007-.14a.33.33 0 00-.063.418l.002.003-.013.026.005.002c.02.01.036.02.008-.028l.063-.125zm-.036.009l-.012.003a.022.022 0 00.005-.002l.007-.001zm.342-.036c0 .012-.004.02-.011.023l.004-.005a.061.061 0 00.007-.018z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.728 8.347c.395-.012.64-.093.64-.473 0-.42-.407-.55-.84-.55-.393 0-.835.243-.835.68 0 .265.337.8 1.187 1.961.03.028.046.042.059.042a.547.547 0 01-.262.062.374.374 0 01-.15-.048v-.455h-.899v.344c0 .388.574.847 1.049.847.414 0 .747-.197.916-.481.166-.28.039-.55-.2-.764a28.69 28.69 0 01-.806-1.165h.141zm-.042-.317a.58.58 0 01.036.009c-.008-.009-.041-.048-.041-.165 0-.064.003-.109.007-.14a.33.33 0 01.063.418l-.002.003.013.026-.005.002c-.02.01-.036.02-.008-.028l-.063-.125zm.036.009l.012.003a.022.022 0 01-.005-.002l-.007-.001zm-.342-.036c0 .012.004.02.011.023l-.004-.005a.061.061 0 01-.007-.018z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.184 6.653c-.395.012-.64.093-.64.473 0 .42.407.55.84.55.393 0 .835-.243.835-.68 0-.265-.337-.8-1.187-1.961-.03-.028-.046-.042-.059-.042a.547.547 0 01.262-.062.36.36 0 01.15.048v.455h.9V5.09c0-.388-.575-.847-1.05-.847-.414 0-.747.197-.916.481-.166.28-.039.55.2.764.356.491.633.897.806 1.165h-.141zm.042.317a.581.581 0 01-.036-.009c.009.009.041.048.041.165 0 .064-.003.109-.007.14a.33.33 0 01-.063-.418l.002-.003-.013-.026a.49.49 0 00.005-.002c.02-.01.036-.02.008.028l.063.125zm-.036-.009l-.012-.003c.002 0 .003 0 .005.002l.007.001zm.342.036c0-.012-.004-.02-.011-.023l.004.005c.004.009.007.015.007.018z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.728 6.653c.395.012.64.093.64.473 0 .42-.407.55-.84.55-.393 0-.835-.243-.835-.68 0-.265.337-.8 1.187-1.961.03-.028.046-.042.059-.042a.547.547 0 00-.262-.062.373.373 0 00-.15.048v.455h-.899V5.09c0-.388.574-.847 1.049-.847.414 0 .747.197.916.481.166.28.039.55-.2.764-.356.491-.633.897-.806 1.165h.141zm-.042.317a.581.581 0 00.036-.009c-.008.009-.041.048-.041.165 0 .064.003.109.007.14a.33.33 0 00.063-.418l-.002-.003.013-.026a.49.49 0 01-.005-.002c-.02-.01-.036-.02-.008.028l-.063.125zm.036-.009l.012-.003a.022.022 0 00-.005.002l-.007.001zm-.342.036c0-.012.004-.02.011-.023l-.004.005a.061.061 0 00-.007.018z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.184 2.46c-.395-.01-.64-.092-.64-.472 0-.42.407-.55.84-.55.393 0 .835.243.835.68 0 .265-.337.8-1.187 1.961-.03.028-.046.042-.059.042a.547.547 0 00.262.062.373.373 0 00.15-.048V3.68h.9v.344c0 .388-.575.847-1.05.847-.414 0-.747-.198-.916-.481-.166-.28-.039-.55.2-.764.356-.491.633-.898.806-1.165h-.141zm.042-.316a.58.58 0 00-.036.009c.009-.01.041-.048.041-.165 0-.064-.003-.109-.007-.14a.33.33 0 00-.063.418l.002.003-.013.026a.81.81 0 01.005.002c.02.01.036.02.008-.028l.063-.125zm-.036.009l-.012.003a.022.022 0 00.005-.002l.007-.001zm.342-.036c0 .012-.004.019-.011.023l.004-.005a.061.061 0 00.007-.018z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.728 2.46c.395-.01.64-.092.64-.472 0-.42-.407-.55-.84-.55-.393 0-.835.243-.835.68 0 .265.337.8 1.187 1.961.03.028.046.042.059.042a.547.547 0 01-.262.062.373.373 0 01-.15-.048V3.68h-.899v.344c0 .388.574.847 1.049.847.414 0 .747-.198.916-.481.166-.28.039-.55-.2-.764a28.69 28.69 0 01-.806-1.165h.141zm-.042-.316a.58.58 0 01.036.009c-.008-.01-.041-.048-.041-.165 0-.064.003-.109.007-.14a.33.33 0 01.063.418l-.002.003.013.026a.81.81 0 00-.005.002c-.02.01-.036.02-.008-.028l-.063-.125zm.036.009l.012.003a.022.022 0 01-.005-.002l-.007-.001zm-.342-.036c0 .012.004.019.011.023l-.004-.005a.061.061 0 01-.007-.018zm7.487-.377l.256.955s.003.217-.242.217a.238.238 0 01-.258-.217l.244-.954zm2.164 3.647c0 1.243-.948 2.25-2.118 2.25S9.794 6.63 9.794 5.387c0-1.242.948-2.25 2.119-2.25 1.17 0 2.118 1.008 2.118 2.25zm-1.168-2.5l.035-.987-.512.842s-.052.21.182.283a.219.219 0 00.295-.137zm.975-.52l-.322.935s-.119.182-.322.045-.092-.324-.092-.324l.736-.655zm.185 1.535l.58-.8-.894.412s-.161.146-.007.337c.154.19.321.051.321.051zm1.109.146l-.8.582s-.201.08-.29-.149a.238.238 0 01.111-.318l.979-.115zm-.702 1.378l.934-.321-.969-.177s-.215.028-.198.272c.017.245.233.226.233.226zm.858.759l-.988.035s-.212-.046-.157-.285c.055-.239.27-.202.27-.202l.875.452zm-1.334.753l.954.256-.705-.688s-.194-.098-.316.114a.219.219 0 00.067.318zm.306 1.104l-.838-.523s-.15-.157.029-.324c.18-.167.336-.017.336-.017l.473.864zm-1.508-.133l.648.746-.2-.965s-.105-.19-.326-.082c-.22.107-.122.3-.122.3zm-.347 1.068l-.402-.903s-.037-.214.205-.252a.238.238 0 01.288.174l-.09.98zm-1.156-.981l.104.983.39-.905s.021-.217-.22-.255c-.243-.038-.274.177-.274.177zm-.893.664l.189-.97s.092-.197.313-.09c.22.108.136.309.136.309l-.637.751zM9.96 7.178l-.464.873.829-.532s.139-.168-.04-.335c-.18-.167-.325-.006-.325-.006zm-1.116.027l.7-.7s.186-.11.308.102a.237.237 0 01-.059.331l-.949.267zm.49-1.472l-.872.464.985.023s.208-.061.153-.3c-.055-.239-.266-.187-.266-.187zm-.953-.616l.97-.189s.217.012.2.257c-.017.244-.234.241-.234.241l-.936-.31zm1.213-.954L8.61 4.06l.805.57s.207.066.294-.163c.088-.229-.115-.304-.115-.304zm-.459-1.05l.903.401s.17.134.016.325c-.154.19-.33.063-.33.063l-.589-.79zm1.51-.09l-.746-.648.332.927s.131.173.334.036c.204-.137.08-.315.08-.315zm.192-1.12l.524.839s.066.206-.168.278c-.234.072-.31-.132-.31-.132l-.046-.984z"
            fill="#FFE402"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.638 6.67a3.156 3.156 0 01-.023-.096l.043.088-.02.008zm.06.206a4.035 4.035 0 01-.06-.206l-.268.107.04.1h-.03l-.011.005a1.206 1.206 0 01-.024-.233v-.617l.269.542a1.827 1.827 0 01-.052-.398v-.77l.312.78-.296.092.116.371H7.69l-.032.013.11.222.107.34c-.1-.183-.15-.304-.15-.348h-.027zm.342.867a8.263 8.263 0 01-.342-.867H7.41l.293.734-.109-.116a2.465 2.465 0 01-.224-.612L7.132 7l-.048-.05v.074l-.01.005.01.022v.084a.858.858 0 01-.047-.259V5.412l.309.62v-1.17l.217.545v-1.48l.87 2.777-.061.02c-.081-.241-.121-.425-.121-.548h-.344l-.032.01.247.62-.06.019a.665.665 0 01-.029-.176h-.338l.074.235.383.772-.015.007a7.666 7.666 0 01-.262-.44l.15.482.112-.042.015.024-.112.056zm.12-.045l-.12.045-.144.072-.193-.205.092.23a.33.33 0 01-.021-.019 5.236 5.236 0 01-.18-.327L7.132 7l-.048.024v.027l.381.768h-.037l-.003.002a3.444 3.444 0 01-.34-.686v.502l-1.366-.973 1.739 2.07a5.523 5.523 0 002.05 1.523l-1.575-.034 1.6.452-.827.61 1.43-.44.39.11c.525.148.817.296.836.342l.074.174.186.03c.409.069 1.163-.037 2.134-.252.33-.074.661-.155.917-.224a5.5 5.5 0 00.24-.069l.017-.006.027-.01.01-.005a.645.645 0 00.042-.021c.032-.005.055-.008.07-.02.043-.035.027-.142-.032-.544-.27-.073-.308-.083-.319-.07l-.003.007c-.093.02-.238.018-.43-.007 1.615-.795 2.677-1.591 3.185-2.41l.93-1.5-.563.412.203-.653-.803.516a1.88 1.88 0 00.24-.41l.605-1.462-.955.89.518-1.706-1.229 1.646-5.03 3.702-.08-.018C10.079 9 9.209 8.125 8.692 6.62l-.258.084.003.01-.06.02-.004-.01-.25.081.004.01-.06.02-.004-.01-.025.008c.084.271.175.526.274.763l-.159.06.012.025-.012.006.007.011zm.01-.004l-.01.004.024.038-.247.124-.041-.045-.081.04a.645.645 0 01-.02-.015l.008.022.012-.006.054.038-.04.02a6.91 6.91 0 01-.055-.093l-.002-.002h-.307l.07.14-.045-.033a9.24 9.24 0 01-.065-.105l-.035.034-.306-.218v.182c0 .325.229.571.622.773l-.185.2 2.057 1.466-.07-.001c.067.029.136.057.205.085l.178.07-.357.263.602.17.48-.148 1.708.673-.55-.392c.067 0 .132-.002.195-.003a.686.686 0 00-.102-.14.992.992 0 01-.132-.011l-.019.113-.576-.41a13 13 0 00.642-.24c.853-.008 1.364-.054 1.44-.11l.131-.098.159.041c.153.04.293.072.422.098l.109.183c.085-.04.169-.08.251-.121a3.878 3.878 0 01-.063-.009l3.16-2.305-.264-.246c.334-.172.552-.398.643-.689l.077-.249-.34.248-.066-.101-.328-.102c-.03.097-.129.195-.304.285a3.28 3.28 0 00.438-.467l-.496.32.653-.61-.408-.282c.036-.08.065-.16.089-.238l.052-.171-.23.214-.342-.173.158-.32-.297.218-.703.942-.24-.2c-.642 1.303-1.798 2.338-3.48 3.101l-.608-.14-.174.127.018-.155c-1.146 0-1.991-.85-2.545-2.648l-.258.085.246.784-.246.094-.015-.039.246-.093a8.17 8.17 0 01-.292-.727l-.249.082.295.738-.021.008.016-.008c-.183-.298-.299-.54-.35-.719l-.025.008c.09.263.19.51.302.74l-.032.013.004.01-.15.075.006.013zm.157-.06l-.156.06.02.039-.007.003.023.036-.229.131-.04-.043-.069.034.06.037-.24.138-.154-.11.077.154.078-.044.036.025-.094.054a12.62 12.62 0 01-.142-.222l-.1-.071-.213.199.441.47.25-.235.036-.068 1.12.798.414.442a4.793 4.793 0 01-1.454-1.17l-.278.301.007.004 1.753.895-.028-.03c.169.089.344.169.527.24l-.303.559-.084-.002.061.044.023-.042.423.009-.194.143.725.285.025-.007c.17-.053.336-.107.5-.163l-.125-.089.202-.15c.202.002.39.002.564 0 .254-.102.499-.21.734-.322h1.267l.15.252.085.017.08.133.133-.097a5.057 5.057 0 01-.213-.036l-.16-.27h.386l-.448-.103-.048-.082c1.33-.632 2.27-1.252 2.82-1.848.212-.06.398-.13.559-.212l-.115-.106.615-.396-.12-.188-1.038.757-.13-.302c.175-.126.332-.25.47-.373-.098.05-.22.097-.368.141l.31-.289-.94.605c.585-.541.982-1.037 1.185-1.496l-.041-.03.077-.102-.125-.063-.791.738.449-.91-.138-.07c-.084.277-.293.603-.628.972l-.076-.063-.424.568.106.095-3.128 2.302-.273-.064a12.26 12.26 0 01-.823.337l.04-.35-.526.387C9.686 9.46 8.91 8.728 8.372 7.642l.07-.035-.006-.014-.075.028-.015-.032.054-.027-.057.022.003.005-.031.016.012.03zm.01.025l-.147.074.037.074-.22.127-.029-.03-.048.027.04.023-.244.14.178.127.121-.238a2.05 2.05 0 01-.054-.029l.036-.02 1.017 1.085 1.402 1-.34.25.478.01.18.359.272-.2-.217-.154.42.005.439-.323h.858c.184-.09.363-.181.535-.277l.659.153.073.124h.075l-.062-.104-.086-.02-.018-.029 2.426-1.77.305-.073c.05-.012.098-.025.145-.038a3.66 3.66 0 00.069-.077l.375-.241-.116-.107c-.071.115-.158.23-.26.348l-.108.07-.059-.138-.351.257-1.245.302c.139-.139.27-.282.395-.429l.399-.256.136.178a9 9 0 00.536-.354l-.041-.098.143-.134a3.71 3.71 0 01-.18.048l.037.086-.44.41-.133-.173.082-.053.003-.002-.003.002-.162-.147.036-.052.169.152 1.105-1.48-.103-.072c-.112.27-.407.586-.887.934.047-.085.092-.17.135-.258l.016-.032-.146.136-.171-.144a7.34 7.34 0 01-.458.458l.116.104-.052.038.039.035-.056.052.18.237a5.77 5.77 0 01-.3.385l-.832.535.437-.106a8.168 8.168 0 01-1.822 1.343l-.774-.18-.62.457h-.418a2.91 2.91 0 01-.472-.038l.126-.043c.088.027.177.05.268.072l.02-.174c-.095.035-.19.069-.288.102a4.106 4.106 0 01-.198-.065l-.1.074c-.968-.226-1.722-.983-2.257-2.235zm0 0l.035-.017-.01-.02-.035.012.01.025zm2.107 2.372l-.018-.013.17-.124c.056.013.113.024.17.034-.105.035-.213.07-.322.103zm5.166-2.557l.035-.05-.195-.175.056-.035.175.158a6.2 6.2 0 00.284-.466c-.137.1-.29.203-.459.308L15.49 7.2l.278-.26.227-.167-.025-.02-.202.187-.311.23.033.03-.046.043.006.006-.007.005.167.22zm0 0l.115.15-.058.037-.098-.129.041-.058zm-5.166 2.557l.355.253-.172-.004-.063-.001-.125-.247.005-.001zm1.272.906l-.007.041h.064l-.057-.041zm1.915-.208l-.1-.135-.149.032-.041.16.118.03a.658.658 0 00.172-.087z"
            fill="#FFE402"
          />
        </g>
      </g>
    </symbol>
    <symbol id="LA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 10h20v5H0v-5z" fill="#E31D1C" />
        <path d="M0 5h20v5H0V5z" fill="#2E42A5" />
        <path d="M0 0h20v5H0V0z" fill="#E31D1C" />
        <path
          d="M10 9.837a2.344 2.344 0 100-4.687 2.344 2.344 0 000 4.687z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="LB" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path
          d="M20 0H0v3.75h20V0zm0 11.25H0V15h20v-3.75z"
          fill="#F50101"
        />
        <path d="M0 3.75h20v7.5H0v-7.5z" fill="#F7FCFF" />
        <path
          d="M13.447 7.82c.046.543-1.954-.224-1.954-.007s2.143.598 2.14 1.084c-.004.486-2.542-.139-1.973.08.57.218 1.791.741 1.652 1.067-.296.696-2.266-.483-2.43-.25-.264.375 1.454 1.249 1.44 1.333-.029.16-1.174-.252-1.44.08-.215-.06-.314-.35-.381-.388l-.423-5.452s.38 5.133-.105 5.28c-.485.148-1.832.597-1.872.373-.014-.084 1.622-.851 1.358-1.226-.195-.276-2.17.703-2.296.136-.561-.405 1.818-.755 1.818-1.169 0-.414-2.176.49-1.916-.086.26-.576 2.003-.782 2.035-.862.06-.146-1.937.227-1.937 0 0-.43 1.195-.514 1.937-.901.044-.442-1.8.434-1.937.08-.137-.353 2.357-1.27 2.296-1.341-.096-.113-2.106.396-1.775.128.643-.518 1.9-1.223 2.188-1.412 0 0 .035-.07.072-.046.037-.025.078-.05.078-.05s0 .443-.006.096c-.006-.346 2.944 1.17 2.977 1.554.039.449-1.822-.338-1.779.103.379.234 1.455.688 1.9.888.201.09-1.486-.192-1.45-.053.09.353 1.734.396 1.783.962z"
          fill="#52AB0B"
        />
      </g>
    </symbol>
    <symbol id="LC" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#7CCFF5" />
        <path d="M10 2.5l5 10H5l5-10z" fill="#F7FCFF" />
        <path d="M10 5l4.375 7.5h-8.75L10 5z" fill="#272727" />
        <path d="M10 8.75l5 3.75H5l5-3.75z" fill="#FECA00" />
      </g>
    </symbol>
    <symbol id="LI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v7.5h20V0H0z"
            fill="#2E42A5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.999 6.908s.754.47 2.502.47c1.747 0 2.675-.47 2.675-.47s-1.37-.796-2.596-.796c-1.225 0-2.58.796-2.58.796z"
            fill="#000"
          />
          <path
            d="M3.044 4.214l-.216.126.072.124h5.531l.055-.175-.239-.075.239.075h0v-.002l.002-.004.004-.013a2.141 2.141 0 00.052-.213c.03-.138.061-.33.07-.543.017-.413-.049-.98-.475-1.35-.439-.381-.99-.315-1.432-.205a8.9 8.9 0 00-.453.13l-.19.058c-.2.06-.356.094-.476.094a1.48 1.48 0 01-.427-.086A10.7 10.7 0 015 2.102a6.292 6.292 0 00-.406-.125c-.425-.112-.928-.157-1.484.158a1.141 1.141 0 00-.548.662 1.543 1.543 0 00-.028.734 2.662 2.662 0 00.283.788l.007.014.003.004v.002h.001l.216-.125z"
            fill="#FFD83D"
            stroke="#000"
            stroke-width=".5"
          />
          <path
            d="M2.502 4.454l-.117-.22-.193.101.075.205.72 1.98.08.221.226-.067h.003l.01-.003.037-.01.146-.04c.127-.032.31-.075.53-.118A8.526 8.526 0 015.62 6.33c.58 0 1.152.085 1.58.172a9.313 9.313 0 01.655.158l.036.01.009.003h.002l.225.07.083-.22.74-1.981.078-.206-.195-.103-.117.221.117-.22h0l-.001-.001h-.001l-.004-.003-.012-.006a3.03 3.03 0 00-.2-.086 5.368 5.368 0 00-.607-.194c-.536-.14-1.334-.277-2.4-.277-1.065 0-1.863.137-2.4.277-.267.07-.47.14-.607.194a3.034 3.034 0 00-.199.086l-.012.006-.004.002h0l-.001.001h0l.116.221zM5.546 2.76c.42 0 .67-.405.67-.779 0-.373-.25-.778-.67-.778-.42 0-.67.405-.67.778 0 .374.25.778.67.778z"
            fill="#FFD83D"
            stroke="#000"
            stroke-width=".5"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="4.074"
            y="-1"
            width="3"
            height="4"
            fill="#000"
          >
            <path fill="#fff" d="M4.074-1h3v4h-3z" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.704 0h-.315l.04.577-.355-.049v.397l.36-.05-.045.908h.315l-.047-.91.362.052V.528L5.664.58l.04-.58z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.704 0h-.315l.04.577-.355-.049v.397l.36-.05-.045.908h.315l-.047-.91.362.052V.528L5.664.58l.04-.58z"
            fill="#FFD83D"
          />
          <path
            d="M5.389 0v-.5h-.537l.038.535L5.389 0zm.315 0l.499.035L6.24-.5h-.536V0zm-.275.577l-.067.495.61.083-.044-.613-.499.035zM5.074.528L5.14.033l-.567-.077v.572h.5zm0 .397h-.5v.573l.568-.078-.068-.495zm.36-.05l.5.025.03-.603-.598.082.069.496zm-.045.908l-.5-.025-.026.525h.526v-.5zm.315 0v.5h.526l-.027-.526-.5.026zm-.047-.91l.07-.495-.6-.085.03.606.5-.026zm.362.052l-.07.495.57.08V.925h-.5zm0-.397h.5v-.577l-.571.082.07.495zM5.664.58l-.5-.034-.042.617.613-.088L5.664.58zM5.389.5h.315v-1h-.315v1zm.539.042l-.04-.577-.998.07.04.577.998-.07zm-.922.482l.356.048.135-.99-.356-.05-.135.992zm.568-.1V.529h-1v.397h1zM5.366.38l-.36.05.136.99.36-.049-.136-.99zm.522 1.43L5.934.9 4.935.85l-.046.908.999.05zm-.184-.526h-.315v1h.315v-1zM5.158.899l.046.91 1-.052-.048-.91L5.158.9zm.931-.47L5.727.38l-.14.99.362.05.14-.99zm-.57.1v.396h1V.528h-1zm.216.545l.355-.05-.142-.99-.355.05.142.99zm-.53-1.109l-.04.58.997.069.04-.58-.997-.069z"
            fill="#000"
            mask="url(#c)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="LK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#FECA00"
        />
        <path fill="#1F8A6E" d="M1.25 1.25H5v12.5H1.25z" />
        <path fill="#F56800" d="M5 1.25h3.75v12.5H5z" />
        <path fill="#B01D00" d="M8.75 1.25h10v12.5h-10z" />
        <path fill="#E8AA00" d="M7.5 1.25h1.25v12.5H7.5z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.688 3.858s-.796-.002-.796 1.384v2.033s-.38.067-.38.303c0 .235.081.441.23.441.15 0 .3.69.15.69s-.299.297-.15.297c.036 0 .063-.005.084-.008.022-.004.036-.007.046-.001.02.011.02.057.02.194 0 .269-.15.377-.15.377s-.14-.039-.14.12c0 .158.14.198.14.198s.08.035-.074.11c-.155.075-.155.111-.155.111h.379l.19.347.18-.347h.375s-.189-.12-.21-.146c-.023-.025-.05-.062 0-.104a.246.246 0 01.057-.032c.054-.024.117-.053.117-.137 0-.12-.238-.12-.238-.12s-.146-.263-.1-.377a.78.78 0 00.026-.086c.016-.063.025-.099.104-.099.108 0 .17-.137.033-.296 0 0 .158.17.111.389-.046.22.049.319.1.319.05 0 .132-.076.132-.076s.425.38.611.38c.187 0 .455-.304.455-.304l.384.216s.281.394.24.665c-.042.27-.202.421-.39.38-.19-.043-.496.043-.52.16l-.014.063c-.033.133-.08.331.067.282.174-.057.208-.102.208-.102s-.023.102.118.102c.14 0 .18-.102.18-.102s.146.102.248.102c.103 0 .217-.078.217-.078s.075.116.242.078c.167-.038.292-.473.171-.57 0 0 .402-.058.505-.408 0 0-.389-.005-.348-.245.04-.239.245-.393.245-.393s.59-.286.845-.377c.255-.092.677-.185.782-.185.043 0 .073.1.114.234.06.197.144.469.32.617.3.25.096.821.096.821s-.665.067-.665.247.01.26.135.26.122-.103.122-.103.074.102.194.102c.119 0 .214-.102.214-.102s.032.102.188.102c.157 0 .155-.102.155-.102s.029.102.167.102c.137 0 .42-.102.42-.102s.045.102.188.102c.143 0 .146-.102.146-.102s.077.102.201.102c.124 0 .197-.102.197-.102s.178.102.301.102.079-.184 0-.345c-.02-.04-.043-.075-.064-.107-.062-.094-.107-.161-.002-.278.03-.033.064-.066.099-.1.128-.124.256-.249.162-.358a.472.472 0 00-.094-.078c-.107-.075-.217-.151-.167-.576.03-.254.088-.46.141-.652.063-.226.12-.432.12-.67 0-.442-.26-.947-.26-.947s.35-.245.35-.743-.783-.553-.783-.553-.778.2-1.122.1a5.023 5.023 0 00-.196-.052c-.185-.046-.242-.06-.242-.19 0-.165-.25.142-.25.142s-.196-.078-.063-.241c.133-.163.194-.227.194-.227s-.118-.134-.316-.067-.233.178-.233.178-.226-.231-.085-.399c.14-.168.318 0 .318 0s.202.106.219-.033c.016-.139 0-.25 0-.25s.507.146.364.373c-.144.226-.053.31-.053.31s.349.02.412-.22a.507.507 0 00.002-.249c.1.048.215.104.183.197a2.62 2.62 0 01-.185.387s.348-.02.452-.294c.104-.273.067.067.067.067s.133-.005.334.111c.2.116 0-.178 0-.178s.416.516.81.455c.393-.061.371-.388.371-.388s-.093-.16-.288-.16c-.195 0-.084.16-.084.16s.19.108-.11 0c-.088-.031-.218-.132-.38-.258-.396-.308-.981-.763-1.584-.693-.848.098-1.145.477-1.145.477V4.52s-.142.219-.275.219c-.133 0-.502-.22-.502-.22l-.235.22s-.09-.22-.245-.22c-.157 0-.157.22-.157.22s-.196-.097-.413-.097a.556.556 0 01-.222-.057c-.084-.036-.132-.057-.132.057v.066c.005.155.007.251-.217.28-.256.033-.453.033-.453.033s-.152-.186-.271-.186c-.119 0-.257.144-.257.276 0 .131.154.506.257.586.027.021.022.019 0 .009-.062-.029-.257-.118-.257.071 0 .13.033.164.057.187.023.024.038.038.007.126a2.007 2.007 0 01-.05.123c-.072.171-.155.37-.014.37.077 0 .15-.017.201-.029.069-.016.1-.023.056.029l-.066.071c-.082.086-.166.174-.02.107a.974.974 0 00.194-.128c.078-.062.132-.104.163-.05.02.034.004.08-.01.12-.022.065-.038.113.126.058a.653.653 0 00.11-.044c0 .01.01.025.035.044.056.04.045.08.037.108-.01.034-.015.055.08.055.093 0 .223-.071.3-.113.074-.041.099-.055-.008.05a.944.944 0 01-.273.158c-.241.109-.535.241-.668.693-.18.61-.1.735-.088.75l-.553-.607s.132-.104.132-.277c0-.174-.343-.303-.343-.303s.012-2.161.111-2.633c.1-.471.15-.784.15-.784zm1.104 2.838a.019.019 0 00-.017.02c.024-.013.024-.02.017-.02zm4.167-1.744l-.007-.003c-.081-.038-.15-.071-.124-.114.038-.06.103.003.131.117zm.367 4.677s-.263.257-.096.314c.05.017.112.026.17.035.13.02.239.037.14.135-.143.14-.264.328-.264.5 0 .17.004.316.05.243.025-.04.129-.081.24-.126a1.56 1.56 0 00.253-.118c.12-.079.118-.165.115-.319l-.001-.086c0-.21-.607-.578-.607-.578zM14.289 6.18c.062-.049.066-.649.066-.649s.214.072.214.165c0 .059-.016.092-.04.143-.015.03-.033.067-.053.12-.047.128.082.209.2.284l.028.017c.08.052.103-.06.12-.146.01-.048.019-.088.034-.088.044 0 .369.073.614.198.213.108.423.055.903-.067l.229-.058c.647-.16.732.081.798.27.067.19-.436.454-.799.502-.159.02-.297.014-.424.008-.162-.008-.306-.015-.453.037-.23.082-.953.074-1.235.071h-.09c-.129 0-.153-.042-.202-.124a1.397 1.397 0 00-.045-.07c-.088-.13.02-.213.088-.213.07 0 .047-.152 0-.21-.047-.059-.014-.141.047-.19zM8.857 1.326v.226a.42.42 0 01-.025.108c-.043.135-.1.316.164.366.347.067.603.22.68.362.05.092.036-.06.02-.24a3.345 3.345 0 01-.02-.29c0-.222-.247-.653-.423-.532-.176.122-.396 0-.396 0zm0 12.116v.226s.22-.122.396 0c.176.121.424-.31.424-.531 0-.08.01-.19.019-.29.016-.18.03-.333-.02-.241-.077.143-.333.295-.68.362-.264.05-.207.231-.164.366.013.042.025.08.025.108zm9.79 0v.226s-.22-.122-.396 0c-.175.121-.423-.31-.423-.531 0-.08-.01-.19-.02-.29-.016-.18-.03-.333.02-.241.078.143.333.295.68.362.265.05.207.231.165.366a.395.395 0 00-.026.108zm0-11.89v-.226s-.22.122-.396 0c-.175-.121-.423.31-.423.531 0 .08-.01.19-.02.29-.016.18-.03.333.02.241.078-.143.333-.295.68-.362.265-.05.207-.231.165-.366a.395.395 0 01-.026-.108z"
          fill="#FECA00"
        />
      </g>
    </symbol>
    <symbol id="LR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path fill="#E31D1C" d="M.017 3.438h20v1.875h-20z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v1.875H0V0z"
          fill="#E31D1C"
        />
        <path
          fill="#E31D1C"
          d="M-.037 6.875h20V8.75h-20zM.07 10.25h20v1.875h-20zm-.007 3.188h20v1.875h-20z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h10v8.75H0V0z"
          fill="#3D58DB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.083 5.758L3.257 7.025l.583-2.17L2.5 3.47l1.815-.075.768-2.145.768 2.145h1.811l-1.337 1.46.67 2.042-1.912-1.139z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="LS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 10h20v5H0v-5z" fill="#55BA07" />
        <path d="M0 5h20v5H0V5z" fill="#F7FCFF" />
        <path d="M0 0h20v5H0V0z" fill="#3D58DB" />
        <path
          d="M9.531 5.15c-.326.088-.499.314-.499.713 0 .457.224.885.5 1.106V5.15zm.781 1.807c.268-.224.483-.645.483-1.093 0-.388-.17-.612-.482-.706v1.799zm-.026-2.124c.512.113.882.462.882 1.028 0 .411-.196.912-.5 1.255l1.522 1.492.375-.124.56.85S11.709 10 9.958 10c-1.75 0-3.083-.666-3.083-.666l.477-.726.385.126 1.411-1.592c-.316-.344-.522-.86-.522-1.281 0-.586.396-.94.936-1.04a.39.39 0 01.724.012zM7.501 8.935l-.158.22h.308l-.15-.22zm.18.307l-.272.055.273.095v-.15zm.14-.317l.139.325.346-.094-.069-.13-.416-.1zm.752.649l-.508-.1-.058-.098.383-.084.183.282zm.03-.466l.158.284.347-.105-.097-.128-.408-.05zm.284.522l-.062-.117.384-.103.222.27-.544-.05zm.718-.195l.495-.13-.06-.113h-.644l.209.243zm.177.25l-.078-.121.475-.156.253.278h-.65zm.602-.484l.152.186.412-.143-.052-.097-.512.054zm.894.387l-.554.061-.081-.137.418-.138.217.214zm-.035-.477l.155.19.372-.19-.104-.058-.423.058zm.321.426l-.067-.103.354-.213.18.213-.467.103zm.351-.593l.225.214.219-.214-.07-.088-.373.088zm.357.287l.183-.18.131.18-.314.102V9.23z"
          fill="#1D1D1D"
        />
      </g>
    </symbol>
    <symbol id="LT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#55BA07"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#FECA00" />
          <path d="M0 10v5h20v-5H0z" fill="#C51918" />
        </g>
      </g>
    </symbol>
    <symbol id="LU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#F05234" />
          <path d="M0 10v5h20v-5H0z" fill="#2EB7EC" />
        </g>
      </g>
    </symbol>
    <symbol id="LV" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 9h20v6H0V9z" fill="#C51918" />
        <path d="M0 5h20v3.75H0V5z" fill="#F7FCFF" />
        <path d="M0 0h20v6H0V0z" fill="#C51918" />
      </g>
    </symbol>
    <symbol id="LY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 11h20v4H0v-4z" fill="#55BA07" />
        <path d="M0 3.75h20v7.5H0v-7.5z" fill="#1D1D1D" />
        <path d="M0 0h20v4H0V0z" fill="#E11C1B" />
        <path
          d="M9.873 9.416c-1.12-.231-1.41-.817-1.398-1.721 0-.957.504-1.925 1.387-2.031.884-.106 1.607.224 1.986.684-.317-1.249-1.368-1.385-2.175-1.385-1.214-.011-2.46.912-2.46 2.649 0 1.513 1.098 2.65 2.495 2.678 1.748 0 2.021-1.206 2.072-1.617-.101.072-.195.159-.292.247-.351.324-.736.678-1.615.496zm2.791-2.359l-.827.26.927.363-.13.971.629-.668.91.187-.615-.72.545-.735-.76.16-.539-.607-.14.789z"
          fill="#fff"
        />
      </g>
    </symbol>
    <symbol id="MA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path
          d="M0 0h20v13.75c0 .69-.56 1.25-1.25 1.25H1.25C.56 15 0 14.44 0 13.75V0z"
          fill="#C51918"
        />
        <path d="M0 0h20v15H0V0z" fill="#E31D1C" />
        <path
          d="M14.051 12.266L10.104 1.688h-.172l-3.81 10.578 3.957-2.378 3.972 2.378zM9.667 5.14l.423-1.65.439 1.697 1.262 3.535.74 1.712-1.599-1.127-.854-.511-.84.505-1.562 1.133.722-1.747L9.667 5.14z"
          fill="#579D20"
        />
        <path
          d="M7.914 8.42L10.1 9.874l2.039-1.452 3.872-3.273H3.99L7.915 8.42zm.045-1.249l-1.486-.91h7.015l-1.276.809-2.122 1.61-2.13-1.509z"
          fill="#579D20"
        />
      </g>
    </symbol>
    <symbol id="MC" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v7.5h20V0H0z"
            fill="#C51918"
          />
        </g>
      </g>
    </symbol>
    <symbol id="MD" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13 0h7v15h-7V0z"
          fill="#D9071E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h7v15H0V0z"
          fill="#3D58DB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 0h8v15H6V0z"
          fill="#FBCD17"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.574 12.259l-.658.36-2.182-3.994.658-.36 2.182 3.994zm-7.003.096l.658.36L9.411 8.72l-.658-.36-2.182 3.994z"
          fill="#FD1900"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.111 5.868v3.47c0 .77-.663 1.775-.998 2.149-.335.373-1 1.23-1 1.23V3.38c0-1.047 1-1.407 1-1.407s.83.164.998 1.407v1.211c.257.203 1.115.823 1.669.561.658-.31.885-1.203.885-1.203s-.061-.9-.331-.9-.292-1.267.742-1.267 1.155.488 1.155.878c0 .204-.164.532-.32.844-.141.283-.276.553-.276.705 0 .321.242.943.596.943.248 0 1.442-.464 2.132-.74V3.38c.169-1.243.999-1.407.999-1.407s1 .36 1 1.407v9.336s-.665-.856-1-1.23c-.335-.373-.999-1.378-.999-2.148v-3.47H7.111zm1.108 6.527c.676-.44 1.665-2.414 1.665-2.414l.328.077s.501 1.307 1.975 2.337c-1.57.42-1.975 1.261-1.975 1.261 0-.673-1.993-1.26-1.993-1.26zm-.109-1.25c.456 0 .825-.349.825-.78 0-.432-.37-.782-.825-.782-.456 0-.825.35-.825.782 0 .431.37.78.825.78zm4.84-.78c0 .431-.37.78-.825.78-.456 0-.825-.349-.825-.78 0-.432.37-.782.825-.782.456 0 .825.35.825.782z"
          fill="#A77B3B"
        />
        <path
          d="M15.713 6.505l.573.248-2.337 5.407-.574-.248 2.338-5.407z"
          fill="#FDFF00"
        />
        <path
          opacity=".3"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.9 4.896h6.6V9.67s-1.68.506-3.3 1.336C9.004 10.12 6.9 9.67 6.9 9.67V4.896z"
          fill="#E1E5E8"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="6"
          y="4"
          width="8"
          height="8"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.9 4.896h6.6V9.67s-1.68.506-3.3 1.336C9.004 10.12 6.9 9.67 6.9 9.67V4.896z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#3D58DB" d="M6.9 8.021h6.6v3.125H6.9z" />
          <path fill="#FD1900" d="M6.9 4.896h6.6v3.125H6.9z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.867 6.301l-.5.042.288-.39-.307-.402.502.064.193-.444.214.454.5-.042-.288.39.307.403-.502-.065-.193.444-.214-.454z"
            fill="#FDFF00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.969 5.42s-1.344.817-.896 1.404c.448.587 1.012.662 1.012.662s-1.375 2.062 1.044 3.24c2.59-1.137 1.228-3.24 1.228-3.24s.798-.176.957-.81c.16-.635-1.042-1.363-1.042-1.363s.75 1.087.579 1.362c-.171.276-1.089.556-1.722.556s-1.61-.178-1.768-.659c-.158-.481.608-1.152.608-1.152z"
            fill="#FDFF00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.725 7.5l.825.52-.825.522L6.9 8.02l.825-.521zm4.95 0l.825.52-.825.522-.825-.521.825-.521zM7.7 9.563a.25.25 0 100-.5.25.25 0 000 .5zm5.319-.473c-.215-.175-.544-.124-.735.112-.191.236-.172.568.042.742.117.095.056-.28.233-.52.148-.2.558-.255.46-.335z"
            fill="#FDFF00"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.96 7.206s.66.778 1.28.524c.62-.255.47-1.168.47-1.168l-.47.426h-.4v.218l-.313-.218v.218H2.96zm.446 1.197s.803.7 1.344.502c.541-.198.405-1.146.405-1.146l-.47.426h-.4v.218l-.312-.218v.218h-.567zm2.162 1.589c-.54.198-1.344-.503-1.344-.503h.567v-.217l.313.217v-.217h.4l.47-.426s.135.948-.406 1.146z"
          fill="#048F02"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.737 1.405h-.625v.373h-.294v.625h.294v1.09h.625v-1.09h.358v-.625h-.358v-.373z"
          fill="#FDFF00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.474 2.115l-1.448.373 1.448.458v-.83z"
          fill="#DB4400"
        />
      </g>
    </symbol>
    <symbol id="ME" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#E8AA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 2h16v11H2V2z"
          fill="#C51918"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="2"
          y="2"
          width="16"
          height="11"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2 2h16v11H2V2z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.644 9.845a.467.467 0 00.462-.473.467.467 0 00-.462-.473.467.467 0 00-.461.473c0 .26.206.473.461.473z"
            fill="#1E5E91"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.642 7.707c-1.21-1.407.525-3.849.525-3.849s.26 1.459 1.22 2.44c0 .07-.091.173-.183.277a1.36 1.36 0 00-.164.209c-.084.153.206.24.346.24.064 0 .098.092.13.175.038.101.072.19.146.078.135-.202-.135-.647-.135-.647l.428-.45.144-.292h-.144v-.3l-.102.084s-.11-.268-.326-.268c-.214 0-.281-.123-.281-.123h.281c.141 0-.022-.187-.14-.284-.054-.044-.134-.029-.207-.015-.09.017-.167.031-.167-.069 0-.11.085-.124.184-.14a.445.445 0 00.19-.063c.091-.066.215-.046.35-.024.07.012.144.024.218.024h.348c.125 0-.204.203-.204.203l.204.181.303.31-.152.09.313.302s-.106.173 0 .173c.043 0 .072.036.09.078.02-.042.048-.078.092-.078.106 0 0-.173 0-.173l.312-.303-.151-.09.303-.309.203-.18s-.329-.204-.203-.204h.348c.073 0 .147-.012.218-.024.134-.022.258-.042.35.024.056.04.126.052.19.063.098.016.184.03.184.14 0 .1-.078.086-.167.069-.073-.014-.154-.029-.207.015-.118.097-.282.284-.14.284h.28s-.066.123-.28.123c-.216 0-.327.268-.327.268l-.101-.083v.3h-.145l.145.29.427.451s-.27.445-.135.647c.075.111.108.023.147-.078.031-.083.066-.174.13-.174.14 0 .43-.088.345-.241-.035-.063-.1-.137-.163-.21-.092-.103-.183-.206-.183-.276.96-.981 1.22-2.44 1.22-2.44s1.735 2.442.524 3.85c-1.21 1.407-2.1.982-2.1.982l.497.445-.14.122h.413l-.152.102.112.049.118.052s-.32.235 0 .235l.16-.003c.06-.002.121-.004.184-.004.016 0-.021-.092-.058-.183-.037-.09-.073-.18-.057-.179.035.002.103.084.17.166.055.065.11.131.147.156.025.017.12-.016.208-.047.075-.026.144-.05.162-.041.074.037.055.113.037.185a.69.69 0 00-.012.055c-.003.016.092-.046.192-.111.105-.068.216-.14.224-.13a.372.372 0 00.006.008c.036.043.093.112-.332.44 0 .063.003.114.004.156.006.134.008.168-.083.168-.04 0-.097.02-.163.044-.168.06-.395.14-.56-.043-.229-.255-.58-.637-.58-.637v.187l-.417-.422-.08.235-.56-.644-.152.084s.516 1.424.792 1.434c.137.005-.07.138-.347.314-.279.179-.627.401-.757.58-.039.053-.068-.028-.091-.204-.023.176-.053.257-.091.204-.13-.179-.479-.401-.758-.58-.276-.176-.484-.31-.347-.314.276-.01.792-1.434.792-1.434l-.151-.084-.56.644-.08-.235-.417.422v-.187s-.352.382-.58.636c-.166.184-.393.103-.56.044-.066-.023-.123-.043-.163-.043-.145 0-.193-.202 0-.45.162-.208.5-.198.792-.19l.16.003c.319 0 0-.235 0-.235l.118-.052.112-.05-.152-.101h.413l-.14-.122.496-.445s-.889.425-2.1-.983z"
            fill="#F6C540"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.77 10.644l-.546-.959s-.715-1.649-.715-1.849c0-.2-.288-.793-.288-.62v.62l1.206 2.718v.214h.163l.18-.124z"
            fill="#F6C540"
          />
          <path
            d="M12.151 9.353l.083-.276 1.017.306-.084.276-1.016-.306z"
            fill="#F6C540"
          />
          <path
            d="M12.692 8.85l.275.09-.268.861-.275-.09.268-.86z"
            fill="#F6C540"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.948 8.57l-.059-.014-.024.095-.108-.027-.014.058.108.027-.028.108.06.013.027-.107.106.026.014-.058-.106-.026.024-.096zM9.809 3.264l.03.104h.09l.03-.104c.075.023.143.048.204.077l.002-.023c.482.044.733.246.706.601-.022.294-.171.448-.42.444v.22s-.403.155-.605.155c-.202 0-.606-.155-.606-.155V4.36c-.204-.026-.326-.177-.346-.44-.027-.356.224-.558.706-.602l.002.024c.062-.029.13-.055.207-.078zm-.51.903a3.753 3.753 0 00-.055.015c-.11-.02-.165-.109-.177-.275-.013-.168.066-.285.252-.353-.127.163-.136.37-.02.613zm.171-.045a2.34 2.34 0 01.314-.057v-.607c-.387.136-.48.344-.314.664zm.487-.052c.13.017.288.056.39.084l-.051-.029c.172-.329.072-.54-.339-.676v.621zm.492-.514c.13.166.136.38.01.631.153.002.225-.086.24-.28.012-.167-.066-.284-.25-.351z"
            fill="#F6C540"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.846 3.45a.202.202 0 100-.404.202.202 0 000 .403z"
            fill="#3D58DB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.874 2.811l-.06.002v.098h-.112v.06h.111v.11h.06V2.97h.11v-.06h-.109v-.099z"
            fill="#F6C540"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.721 6.475s.711-.135 1.096-.135c.346 0 1.097.135 1.097.135 0 .85.239 1.37 0 1.95-.24.581-.824.302-1.089.858-.338-.527-.795-.237-1.104-.988-.309-.75.188-1.096 0-1.82z"
            fill="#1E5E91"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="8"
            y="6"
            width="4"
            height="4"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.721 6.475s.711-.135 1.096-.135c.346 0 1.097.135 1.097.135 0 .85.239 1.37 0 1.95-.24.581-.824.302-1.089.858-.338-.527-.795-.237-1.104-.988-.309-.75.188-1.096 0-1.82z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)">
            <path
              fill="#5EAA22"
              d="M8.721 8.248h2.192v1.064H8.721z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.37 6.894c-.084-.178.44-.2.44-.2s.113.2 0 .482c-.083.206.054.188.243.162.071-.01.15-.02.226-.02.118 0 .18-.008.231.011.072.027.123.108.276.342.07.107.067.178.025.22.004.109-.115.199-.334.257l-.029-.115c.116-.03.187-.06.22-.092-.165.01-.389-.071-.389-.176 0-.155-.528-.122-.846-.103-.08.005-.148.01-.19.01-.184 0-.042-.226.087-.432l.04-.064c.066-.107.087-.134.082-.155-.005-.022-.04-.037-.083-.127zm1.256-.028c-.316-.05-.494-.002-.494.175 0 .17.169.242.477.241a.43.43 0 01.031.012.48.48 0 01-.042.017l.039.111c.194-.07.194-.194-.003-.256l-.008-.002h-.009c-.256.002-.37-.046-.37-.123 0-.069.108-.098.362-.058l.017-.117z"
              fill="#F6C540"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="MF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0z" fill="#F50100" />
        <path d="M0 0h6v15H0V0z" fill="#2E42A5" />
        <path d="M6 0h8v15H6V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="MG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M7 7.5h13V15H7V7.5z" fill="#78D843" />
        <path d="M7 0h13v7.5H7V0z" fill="#EA1A1A" />
        <path d="M0 0h8v15H0V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="MH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3D58DB"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5 6.875l-.51 1.84.004-1.91-.988 1.635.52-1.838-1.393 1.307.997-1.63-1.694.884 1.4-1.3-1.87.393 1.698-.875-1.905-.125 1.87-.384-1.8-.635 1.904.135L1.67 3.275l1.798.644L2.26 2.44l1.558 1.106-.765-1.75 1.2 1.484-.265-1.89.757 1.752L5 1.25l.255 1.892.757-1.753-.265 1.891 1.201-1.484-.765 1.75L7.741 2.44 6.53 3.92l1.799-.644-1.563 1.097 1.905-.135-1.801.635 1.87.384-1.905.125 1.697.875-1.868-.393 1.399 1.3L6.37 6.28l.997 1.629-1.393-1.307.52 1.838-.988-1.635.005 1.91L5 6.875z"
            fill="#F7FCFF"
          />
          <path
            d="M-.489 15.466L20.786.759v4.795L-.489 15.466z"
            fill="#fff"
          />
          <path
            d="M-.489 15.466L20.786-2.991v4.795L-.489 15.466z"
            fill="#E2AE57"
          />
        </g>
      </g>
    </symbol>
    <symbol id="MK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F50100"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill="#FFD018">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0-.026v2.552l8.75 3.72L2.035-.026H0zM10 7.5L11.875 0h-3.75L10 7.5zm0 0L8.125 15h3.75L10 7.5zM0 12.47v2.552h2.035L8.75 8.75 0 12.47zm20-9.93V-.01h-2.035L11.25 6.261 20 2.541zm0 12.496v-2.552l-8.75-3.72 6.715 6.272H20zm0-9.412L12.5 7.5 20 9.375v-3.75zM7.5 7.5L0 5.625v3.75L7.5 7.5z"
          />
          <path
            d="M10 10.625a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25z"
            stroke="#F50100"
            stroke-width="1.25"
          />
        </g>
      </g>
    </symbol>
    <symbol id="ML" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M6 0h8v15H6V0z" fill="#FBCD17" />
        <path d="M14 0h6v15h-6V0z" fill="#E11C1B" />
        <path d="M0 0h6v15H0V0z" fill="#0B9E7A" />
      </g>
    </symbol>
    <symbol id="MM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 10h20v5H0v-5z" fill="#E31D1C" />
        <path d="M0 5h20v5H0V5z" fill="#5EAA22" />
        <path d="M0 0h20v5H0V0z" fill="#FFD018" />
        <path
          d="M10.039 9.985l-3.22 2.046L7.9 8.448l-2.296-2.34 3.166-.07 1.4-3.537 1.277 3.584 3.158.055-2.373 2.384 1.108 3.409-3.3-1.948z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="MN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M6 0h8v15H6V0z" fill="#4C67E8" />
        <path d="M13 0h7v15h-7V0zM0 0h8v15H0V0z" fill="#C51918" />
        <path
          d="M3.759 4.303c-.634 0-.55-.617-.55-.617l.3-.649v.649c0 .083.114-.084.114-.285 0-.2.136-.501.136-.501l.009-.2a.588.588 0 00.132.162l.036.038c.079.08.068.292.059.476-.008.167-.015.31.046.31.128 0 .119-.575.119-.575l.215.575s.017.617-.616.617zm0-1.763c.016-.094.014.032.009.16a.272.272 0 01-.01-.16zm.953 2.887c0 .502-.42.909-.938.909s-.937-.407-.937-.909c0-.501.42-.908.937-.908.518 0 .938.407.938.908zm-2.356 1.7H1.25v5.358h1.106V7.128zm3.894 0H5.144v5.358H6.25V7.128zm-3.606.047l1.078.668 1.215-.668H2.644zM3.722 12.5l-1.078-.667h2.293l-1.215.667zM2.644 8.06h2.26v.419h-2.26v-.42zm2.26 3.12h-2.26v.42h2.26v-.42zm-1.106-.232c.637 0 1.154-.501 1.154-1.119 0-.617-.517-1.118-1.154-1.118-.637 0-1.154.501-1.154 1.118 0 .618.517 1.118 1.154 1.118zM2.502 5.76s.039 1.167 1.19 1.167c1.15 0 1.335-1.167 1.335-1.167s-.445.715-1.262.715c-.818 0-1.263-.715-1.263-.715z"
          fill="#F8D000"
        />
      </g>
    </symbol>
    <symbol id="MO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#1C9975"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.014 4.284L8.992 4.9l.233-1.203-.85-.9 1.151-.049.488-1.123.487 1.123h1.149l-.848.95.255 1.202-1.043-.616zm-2.9.456l-.631.381.144-.743L6.1 3.82l.712-.03.301-.695.301.695h.711l-.525.587.158.743-.645-.38zm5.749 0l-.631.381.144-.743-.526-.557.712-.03.301-.695.301.695h.711l-.524.587.157.743-.645-.38zM5.48 6.007l-.508.306.116-.597-.422-.447.571-.024.242-.558.242.558h.57l-.42.47.126.598-.518-.306zm9.246 0l-.507.306.115-.597-.421-.447.57-.024.242-.558.242.558h.57l-.42.47.126.598-.518-.306z"
            fill="#FECA00"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="5"
            y="3"
            width="10"
            height="11"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 13.75a5 5 0 100-10 5 5 0 000 10z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)" fill="#F7FCFF">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.926 13.165h4.149v.67h-4.15v-.67zm-1.703-1.003h7.98v.615h-7.98v-.614z"
            />
            <path
              d="M7.888 11.888h-2.44v-.625h2.435c.863-.012 1.494-.259 1.915-.733l.21-.236.233.212c.562.51 1.123.757 1.691.757h2.69v.625h-2.69c-.652 0-1.282-.245-1.884-.726-.533.473-1.258.713-2.16.726z"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.022 4.755S8.954 5.81 8.954 7.258c0 .31.049.602.125.871-.344-.763-.367-1.59-.07-2.491l-.405-.134c-.302.918-.303 1.78-.003 2.58a5.133 5.133 0 00-2.067-.706l-.047.423a4.7 4.7 0 011.814.6 3.36 3.36 0 00-.426-.14c-1.351-.344-2.678.145-2.678.145s.765 1.716 2.247 1.97c.074.012.147.022.22.03h-.012c-.706 0-1.363-.29-1.979-.877l-.293.308c.69.66 1.45.994 2.272.994.803 0 1.55-.32 2.231-.95a2.34 2.34 0 00.184-.122l.026.023c-.014.024-.02.038-.02.038s.066.04.188.098c.673.521 1.515.913 2.181.913.822 0 1.582-.335 2.273-.994l-.294-.308c-.615.587-1.272.876-1.979.876-.258 0-.51-.041-.759-.125a3.24 3.24 0 001.126-.133c1.46-.447 2.069-1.797 2.069-1.797s-.777-.419-1.764-.423c.221-.057.452-.1.692-.126l-.046-.423c-.925.103-1.726.415-2.397.936.392-.863.423-1.803.091-2.81l-.404.134c.271.822.275 1.581.013 2.287.045-.209.072-.432.072-.667 0-1.527-1.113-2.503-1.113-2.503zm.47 4.467l-.016.023.019-.023h-.003zm-1.033-.1l.042-.038c.038.063.076.123.113.178a4.854 4.854 0 00-.155-.14z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="MP" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h21.25v15H0V0z"
          fill="#2993EC"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.883 7.24c0 3.307 2.739 5.99 6.117 5.99s6.117-2.683 6.117-5.99c0-3.308-2.739-5.99-6.117-5.99S3.883 3.932 3.883 7.24zm10.904 0c0 2.588-2.143 4.687-4.787 4.687S5.213 9.828 5.213 7.24c0-2.59 2.143-4.688 4.787-4.688s4.787 2.099 4.787 4.688z"
          fill="#F1F9FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.415 7.24c0 3.02 2.5 5.468 5.585 5.468s5.585-2.448 5.585-5.468-2.5-5.47-5.585-5.47-5.585 2.45-5.585 5.47zm10.904 0c0 2.876-2.381 5.208-5.319 5.208S4.68 10.116 4.68 7.24c0-2.877 2.383-5.21 5.32-5.21s5.32 2.332 5.32 5.209z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 1.38c-.067.14-.101.337-.101.594 0 .256-.1.512-.298.77a6.003 6.003 0 01-.055-.77c0-.23.151-.429.454-.594zm1.398.212c-.097.12-.175.305-.232.555-.058.25-.213.478-.464.683a6.01 6.01 0 01.12-.762c.051-.225.243-.383.576-.476zm.96 1.013c.117-.228.236-.39.36-.483-.345.01-.57.117-.675.323a5.997 5.997 0 00-.3.71c.294-.138.499-.322.615-.55zm1.511.322c-.14.064-.294.194-.458.39-.165.196-.406.33-.723.398.153-.24.304-.448.452-.625.148-.177.391-.23.73-.163zm.399 1.32c.204-.154.382-.246.534-.276-.314-.142-.563-.144-.747-.005a5.998 5.998 0 00-.582.507c.325.004.59-.071.794-.225zm1.199.963c-.155-.008-.35.039-.586.139s-.511.109-.825.027a6 6 0 01.687-.352c.212-.09.453-.028.724.186zm-.247 1.347c.253-.045.453-.046.602-.004-.215-.27-.436-.384-.663-.344a6.07 6.07 0 00-.749.188c.288.151.558.204.81.16zM3.803 6.106c.125.09.314.158.566.203.253.044.488.186.707.427a6.001 6.001 0 01-.768-.08c-.227-.04-.395-.223-.505-.55zm.96-.99c-.236-.1-.405-.208-.506-.324.033.343.156.56.368.65.212.09.456.173.73.25-.158-.283-.356-.475-.592-.575zm.254-1.508c.07.138.208.284.413.438.205.155.35.388.436.701a6.001 6.001 0 01-.649-.419c-.184-.138-.25-.378-.2-.72zm1.311-.453c-.165-.196-.266-.37-.304-.52-.126.322-.114.57.034.747.148.176.327.361.537.554-.013-.324-.102-.585-.267-.781zm.905-1.239c.003.155.063.346.18.575.116.228.144.502.083.82a6.002 6.002 0 01-.398-.66c-.105-.205-.06-.45.135-.735zm1.393.175c-.058-.25-.07-.45-.035-.601-.258.229-.361.455-.31.68.052.224.128.47.228.738.135-.295.174-.568.117-.817z"
          fill="#FDDA33"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.116 3.594c-.229 0-.4.212-.35.436l.241 1.104a.365.365 0 00.16.228.358.358 0 00-.136.241l-.867 7.279a.332.332 0 00.16.33c.327.187 1.035.538 1.742.538.708 0 1.416-.35 1.742-.537a.332.332 0 00.16-.331l-.866-7.279a.359.359 0 00-.137-.241c.08-.05.14-.13.16-.228l.242-1.104a.359.359 0 00-.35-.436h-1.9z"
          fill="#A7A7A7"
        />
        <path
          d="M4.075 7.508a.2.2 0 01.249-.13.195.195 0 01.132.244c-.056.179-.056.442.006.787a1.754 1.754 0 00.133.435l.05.105a.978.978 0 01.085.427c0 .108-.09.195-.2.195a.197.197 0 01-.199-.195.588.588 0 00-.053-.272 8.385 8.385 0 00-.046-.099 2.007 2.007 0 01-.163-.529c-.072-.4-.072-.721.006-.968z"
          fill="#73BE4A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.133 10.112l-2.572 1.752.908-2.936-2.497-1.853 3.132-.063 1.029-2.897 1.029 2.897 3.132.063-2.497 1.853.907 2.936-2.571-1.752z"
          fill="#F7FCFF"
        />
        <path
          d="M15.975 7.768a.2.2 0 00-.25-.13.195.195 0 00-.132.245c.056.178.056.442-.006.787a1.756 1.756 0 01-.133.434l-.049.106a.966.966 0 00-.086.426c0 .108.09.196.2.196.11 0 .2-.088.2-.196 0-.118.014-.184.052-.271l.046-.1a1.971 1.971 0 00.163-.528c.072-.4.072-.722-.005-.969z"
          fill="#73BE4A"
        />
        <path
          d="M10.038 1.967s.728.324.413.835m.119-.835s.728.324.413.835"
          stroke="#73BE4A"
          stroke-width=".625"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.787 3.973a.171.171 0 01.248-.061c.084.057.11.178.056.269-.1.175-.154.415-.154.724 0 .108-.08.195-.18.195-.098 0-.179-.087-.179-.195 0-.377.069-.688.21-.932z"
          fill="#73BE4A"
        />
        <path
          d="M5.505 5.758c0 .108-.08.195-.18.195-.098 0-.179-.087-.179-.195V5.2c0-.393.062-.703.192-.93a.171.171 0 01.248-.062c.084.058.11.178.057.27-.09.155-.138.396-.138.722v.557zm9.173-.261c0 .108.08.196.18.196.098 0 .179-.088.179-.196v-.556c0-.394-.062-.704-.192-.93a.171.171 0 00-.248-.062.206.206 0 00-.057.27c.09.154.138.395.138.722v.556z"
          fill="#73BE4A"
        />
        <path
          d="M15.21 6.409c0 .108.08.195.18.195.098 0 .179-.087.179-.195v-.556c0-.394-.062-.704-.192-.93a.171.171 0 00-.248-.063.206.206 0 00-.057.27c.09.155.138.396.138.723v.556z"
          fill="#73BE4A"
        />
      </g>
    </symbol>
    <symbol id="MQ" width="20" height="15" fill="none">
      <path fill="#21428E" d="M0 0h20v15H0z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.75 0h2.5v6.25H20v2.5h-8.75V15h-2.5V8.75H0v-2.5h8.75V0z"
        fill="#F7FCFF"
      />
      <path
        d="M1.597 3.963c.277.044.763.096.809-.008.061-.138.29-.78 1.116-.765.825.016 1.513-.153 1.513-.688 0-.544-.244-.565-.733-.428-.49.138-1.294.04-1.315-.275-.014-.209-.943-.089-.935-.255.003-.063.847-.071.957-.198.08-.204.3-.32.819-.311.84.015 1.941.29 2.048 1.04.122.855.122 1.39-.84 1.605-.911.202-1.208.152-1.07.275.29.259 1.91-.26 2.506 0 .35.152.474 1.13-.688 1.146-1.161.015-1.987.184-2.583-.275-.596-.459-.245-.275-.795-.367-.505-.084-.637-.439-.809-.496zm0 8.847c.277.044.763.096.809-.008.061-.138.29-.78 1.116-.764.825.015 1.513-.153 1.513-.688 0-.545-.244-.566-.733-.428-.49.137-1.294.04-1.315-.276-.014-.208-.943-.089-.935-.255.003-.063.847-.071.957-.198.08-.204.3-.32.819-.31.84.015 1.941.29 2.048 1.039.122.856.122 1.39-.84 1.605-.911.202-1.208.153-1.07.275.29.259 1.91-.26 2.506 0 .35.153.474 1.131-.688 1.146-1.161.016-1.987.184-2.583-.275-.596-.458-.245-.275-.795-.367-.505-.084-.637-.439-.809-.496zm11.465-8.847c.278.044.763.096.81-.008.06-.138.29-.78 1.115-.765.826.016 1.513-.153 1.513-.688 0-.544-.244-.565-.733-.428-.49.138-1.294.04-1.315-.275-.014-.209-.943-.089-.935-.255.003-.063.848-.071.957-.198.08-.204.3-.32.819-.311.84.015 1.941.29 2.048 1.04.122.855.122 1.39-.84 1.605-.91.202-1.208.152-1.07.275.29.259 1.91-.26 2.506 0 .35.152.474 1.13-.688 1.146-1.161.015-1.987.184-2.583-.275-.596-.459-.245-.275-.795-.367-.505-.084-.637-.439-.809-.496zm0 8.847c.278.044.763.096.81-.008.06-.138.29-.78 1.115-.764.826.015 1.513-.153 1.513-.688 0-.545-.244-.566-.733-.428-.49.137-1.294.04-1.315-.276-.014-.208-.943-.089-.935-.255.003-.063.848-.071.957-.198.08-.204.3-.32.819-.31.84.015 1.941.29 2.048 1.039.122.856.122 1.39-.84 1.605-.91.202-1.208.153-1.07.275.29.259 1.91-.26 2.506 0 .35.153.474 1.131-.688 1.146-1.161.016-1.987.184-2.583-.275-.596-.458-.245-.275-.795-.367-.505-.084-.637-.439-.809-.496z"
        fill="#fff"
      />
    </symbol>
    <symbol id="MR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#1C7B4D"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M0 0v3.75h20V0H0zm0 11.25V15h20v-3.75H0z"
            fill="#E31D1C"
          />
          <path
            d="M10.151 8.987a4.276 4.276 0 004.154-2.696c-.184 2.321-1.468 3.896-4.154 3.896S6.48 8.147 5.998 6.113c0 0 .912 2.856 4.153 2.874z"
            fill="#FECA00"
          />
          <path
            d="M11.023 6.134l.21 1.227-1.101-.58-1.103.58.211-1.227-.892-.96h1.233l.55-1.205.552 1.206h1.232l-.892.959z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="MS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <path
            d="M16.205 13.477c-.795 0-1.341-.18-1.726-.488-.386-.31-.642-.771-.807-1.396-.166-.628-.234-1.398-.26-2.3-.018-.633-.014-1.32-.01-2.058l.002-.715h5.677c.1 1.788.132 3.515-.228 4.81-.187.671-.473 1.204-.89 1.569-.411.36-.974.579-1.758.579z"
            fill="#6DC2FF"
            stroke="#F7FCFF"
            stroke-width=".5"
          />
          <mask
            id="e"
            maskUnits="userSpaceOnUse"
            x="13"
            y="6"
            width="7"
            height="8"
          >
            <path
              d="M16.205 13.477c-.795 0-1.341-.18-1.726-.488-.386-.31-.642-.771-.807-1.396-.166-.628-.234-1.398-.26-2.3-.018-.633-.014-1.32-.01-2.058l.002-.715h5.677c.1 1.788.132 3.515-.228 4.81-.187.671-.473 1.204-.89 1.569-.411.36-.974.579-1.758.579z"
              fill="#fff"
              stroke="#fff"
              stroke-width=".5"
            />
          </mask>
          <g mask="url(#e)">
            <path
              fill="#2EBED7"
              d="M13.083 6.25h6.294v4.986h-6.294z"
            />
            <path fill="#A95601" d="M13 11.196h6.625v2.554H13z" />
            <path
              d="M16.716 8.415s-1.167.265-1.054 0c.113-.265.415-1.22.415-1.22"
              stroke="#FFC6B5"
              stroke-width=".625"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.067 8.604s-.213-.13-.213-.368-.519-.327-.153-.698c.366-.371.524-.208.524 0s.294.698.294.698l-.452.368z"
              fill="#FFC6B5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.478 6.453h-.58v.567H14.74v.568h1.16v4.946h.58V7.588h1.159V7.02h-1.16v-.567z"
              fill="#272727"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.726 12.7s-.21-.975-.21-1.643-.354-1.146-.253-1.5c.101-.353.344-.743.223-.985-.122-.242.118-.36-.223-.242-.341.118-.433-.118-.762 0-.33.118-.371.674-.371.832 0 .159.146 1.228.146 1.561 0 .334-.12 2.384.225 2.384s.722-.534.853-.534c.132 0 .372.128.372.128z"
              fill="#0C7C38"
            />
            <path
              clip-rule="evenodd"
              d="M15.644 10.088c-.21 0-.017.49-.553.704-.536.214-.64.516-.472.516.169 0 1.503 1.5 1.503 1.5l.327-.507v-1.597s-.595-.616-.805-.616z"
              stroke="#FF9A06"
              stroke-width=".625"
            />
            <path
              d="M17.215 12.599s.25.536 0 .536"
              stroke="#979797"
              stroke-width=".625"
            />
            <path
              d="M17.134 8.619s-.11.602-.319.728c-.209.126-1.068.37-1.068.578 0 .208-.085.282-.085.282"
              stroke="#FFC6B5"
              stroke-width=".625"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.717 7.377s.21.25.328.661c.118.412.459.552.459.36 0-.193.252-1.021 0-1.021h-.787z"
              fill="#FF9A06"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="MT" width="20" height="15" fill="none">
      <path fill="#F7FCFF" d="M0 0h20v15H0z" />
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <mask id="b" fill="#fff">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.25 3.8h-2.5v1.87a.625.625 0 00-.48.63H1.25v2.5h2.082c.08.167.233.293.418.337V11.3h2.5V9.145a.626.626 0 00.458-.345H8.75V6.3H6.77a.625.625 0 00-.52-.638V3.8z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.25 3.8h-2.5v1.87a.625.625 0 00-.48.63H1.25v2.5h2.082c.08.167.233.293.418.337V11.3h2.5V9.145a.626.626 0 00.458-.345H8.75V6.3H6.77a.625.625 0 00-.52-.638V3.8z"
          fill="#A0A0A0"
        />
        <path
          d="M3.75 3.8v-.625h-.625V3.8h.625zm2.5 0h.625v-.625H6.25V3.8zm-2.5 1.87l.144.608.481-.114V5.67H3.75zm-.48.63v.625h.647l-.022-.646-.625.021zm-2.02 0v-.625H.625V6.3h.625zm0 2.5H.625v.625h.625V8.8zm2.082 0l.562-.272-.17-.353h-.392V8.8zm.418.337h.625v-.494l-.48-.115-.145.609zm0 2.163h-.625v.625h.625V11.3zm2.5 0v.625h.625V11.3H6.25zm0-2.155l-.104-.617-.521.089v.528h.625zm.458-.345v-.625h-.392l-.17.353.562.272zm2.042 0v.625h.625V8.8H8.75zm0-2.5h.625v-.625H8.75V6.3zm-1.98 0l-.625-.021-.022.646h.646V6.3zm-.52-.638h-.625v.528l.52.089.105-.617zm-2.5-1.237h2.5v-1.25h-2.5v1.25zm.625 1.245V3.8h-1.25v1.87h1.25zm-.48.608l-.29-1.216c-.55.13-.96.625-.96 1.216h1.25zm0 0h-1.25v.043l1.25-.042zm-2.645.647h2.02v-1.25H1.25v1.25zM1.875 8.8V6.3H.625v2.5h1.25zm1.457-.625H1.25v1.25h2.082v-1.25zm.562.353l-1.125.544c.161.333.466.585.837.673l.288-1.217zm.481 2.772V9.137h-1.25V11.3h1.25zm1.875-.625h-2.5v1.25h2.5v-1.25zm-.625-1.53V11.3h1.25V9.145h-1.25zm.73.616a1.25 1.25 0 00.916-.69l-1.126-.543.21 1.233zM8.75 8.175H6.708v1.25H8.75v-1.25zM8.125 6.3v2.5h1.25V6.3h-1.25zm-1.356.625H8.75v-1.25H6.77v1.25zm-.624-.647l1.25.043v-.043h-1.25zm0 0h1.25a1.25 1.25 0 00-1.04-1.232l-.21 1.233zM5.626 3.8v1.862h1.25V3.8h-1.25z"
          fill="#FECA00"
          mask="url(#b)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 0h10v15H10V0z"
          fill="#E31D1C"
        />
      </g>
    </symbol>
    <symbol id="MU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#579D20"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 7.5v3.75h20V7.5H0z" fill="#FECA00" />
          <path d="M0 3.75V7.5h20V3.75H0z" fill="#3D58DB" />
          <path d="M0 0v3.75h20V0H0z" fill="#E11C1B" />
        </g>
      </g>
    </symbol>
    <symbol id="MV" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v13.75c0 .69-.56 1.25-1.25 1.25H1.25C.56 15 0 14.44 0 13.75V0z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 3h14v9H3V3z"
          fill="#579D20"
        />
        <path
          d="M3.625 3.625h12.75v7.75H3.625v-7.75z"
          stroke="#B6EB9A"
          stroke-opacity=".238"
          stroke-width="1.25"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="3"
          y="3"
          width="14"
          height="9"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 3h14v9H3V3z"
            fill="#fff"
          />
          <path
            d="M3.625 3.625h12.75v7.75H3.625v-7.75z"
            stroke="#fff"
            stroke-width="1.25"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.02 7.789c-.01 1.916 1.498 2.938 1.498 2.938-1.72.202-2.866-1.359-2.866-2.92 0-1.56 1.561-2.85 2.866-3.431 0 0-1.487 1.497-1.497 3.413z"
            fill="#F9FAFA"
          />
        </g>
      </g>
    </symbol>
    <symbol id="MW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E11C1B"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v6h20V0H0z" fill="#272727" />
          <path d="M0 10v5h20v-5H0z" fill="#5EAA22" />
          <path
            d="M2.501 8.666v-.001h-.006l.006.001zm.393-2.387h.064l-.098-.015.034.015zm1.83 0c.032-.063.066-.125.102-.186l-1.43-.948 1.687.55a5.12 5.12 0 01.303-.384l-1.24-1.18 1.58.824a5.56 5.56 0 01.364-.319L5.087 3.251l1.417 1.083c.132-.087.268-.17.408-.248l-.722-1.55 1.196 1.313c.143-.064.29-.122.438-.176l-.407-1.665.927 1.502c.15-.04.3-.075.455-.104L8.73 1.684l.616 1.64c.152-.017.306-.028.462-.034l.28-1.715.278 1.715c.156.007.31.018.461.035l.617-1.641-.068 1.724c.154.03.305.065.453.105l.929-1.505-.408 1.669c.148.054.293.112.435.176l1.2-1.317-.725 1.555c.14.078.275.16.405.248L15.09 3.25l-1.01 1.393c.126.1.246.206.36.316l1.59-.829-1.248 1.187a5.1 5.1 0 01.3.38l1.698-.552-1.44.954c.035.06.068.12.1.18h-1.229c-.846-1.173-2.393-1.958-4.16-1.958-1.769 0-3.316.785-4.162 1.958H4.724zm1.876 0c.802-.827 2.06-1.36 3.476-1.36s2.675.533 3.477 1.36H6.6zm10.618 0h.064l.035-.015-.099.015zm.458 2.386h.005l-.005.001v-.001z"
            fill="#E11C1B"
          />
        </g>
      </g>
    </symbol>
    <symbol id="MX" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 0h6v15h-6V0z"
          fill="#D9071E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h6v15H0V0z"
          fill="#006923"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 0h8v15H6V0z"
          fill="#fff"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.99 4.946s-.43.333-.349.688c.08.355.926 0 .824-.344-.102-.344-.475-.344-.475-.344z"
          fill="#FCCA3D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.335 5.793c-.322 0-.455-.268-.389-.553.035-.152.128-.344.278-.595l.536.322a3.585 3.585 0 00-.137.247 1.2 1.2 0 01.313.141c.292.193.4.535.087.789-.061.049-.16.216-.213.377a.74.74 0 01.354.09c.276.162.25.46.04.69-.15.164-.348.296-.536.364-.312.113-.646.07-.646-.33v-.003c0-.016-.002-.044.138-.047m.006 0H8.16c-.238-.004-.289-.13-.319-.354a2.316 2.316 0 01-.014-.227l-.003-.076-.003-.074-.001-.016c-.005-.072-.008-.122.153-.122h-.362V5.79h.362c.206 0 .32.07.385.213.036-.065.075-.127.117-.182a.482.482 0 00-.14-.03m-.17 1.493h.022-.021zm.568-.395l.01-.01a.024.024 0 00-.004.004l-.006.006zm-.274.186zm0-.236l.002.01a.5.5 0 01-.002-.019v.01z"
          fill="#A8AC71"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.041 7.752s.579-1.714-.34-2.6c-.92-.887-1.981-.828-1.981-.828s-.306.227 0 .4c.306.174.177.34.177.34s-.512-.52-.852-.216c-.34.304.318.257.248.486-.07.229-.364 1.245.066 1.757.431.513-.407.402-.236.402.17 0 .774.12.774 0s.21.464.39.464c.18 0 .319-.205.319-.205s.252.205.406.205c.153 0 .689-.134.689-.134l-1.013-.853s.061-.376-.082-.458c-.144-.081 1.151.722 1.252.98.102.26.183.26.183.26z"
          fill="#8F4620"
        />
        <path
          d="M6.917 7.33s.093-.3.194-.32c.087-.019.27.143.27.143.325 1.806 1.111 2.511 2.416 2.511 1.32 0 2.12-.536 2.586-2.202 0 0 .249-.253.336-.225.096.03.215.366.215.366-.535 1.911-1.547 2.762-3.137 2.762-1.605 0-2.507-.962-2.88-3.036z"
          fill="#9FAB2F"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.334 8.535s1.878.399 2.619.399c.74 0-.65.604-1.193.604S8.334 8.535 8.334 8.535z"
          fill="#2FC2DC"
        />
        <rect
          x="9.167"
          y="8.813"
          width="1.25"
          height=".67"
          rx=".104"
          fill="#F9AA51"
        />
        <path
          d="M7.61 7.585l.511-.359c.666.95 1.662 1.261 3.055.935l.142.609c-1.628.381-2.886-.014-3.708-1.185z"
          fill="#259485"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.37 7.719s-.759.4-.506.4 1.242.199 1.05 0c-.193-.2-.544-.4-.544-.4zm-.897-.476s-.144-.417-.444-.417c-.3 0-.216.342-.36.342s.135.24.259.24.545-.165.545-.165z"
          fill="#FCCA3D"
        />
      </g>
    </symbol>
    <symbol id="MY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill="#E31D1C"
          d="M.017 3.125h20v1.813h-20zm0 3.25h20v1.813h-20zM.07 9.5h20v1.563h-20zm0 3.125h20v1.688h-20z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v1.563H0V0z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h10v8.5H0V0z"
          fill="#3D58DB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.246 3.876c0 .86.405 1.674 1.23 1.674 1.236 0 1.477-.264 2.054-.627.136.306-.324 1.617-2.072 1.617C2.061 6.512.931 5.39.931 3.876c0-1.736 1.278-2.674 2.492-2.663 1.073 0 2.21.608 2.176 1.385-.506-.494-1.054-.494-1.968-.494-.913 0-1.385.912-1.385 1.772z"
          fill="#FECA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.875 4.563l-.58.845.029-1.025-.966.344.625-.812L5 3.625l.983-.29-.625-.812.966.344-.028-1.025.579.845.58-.845-.029 1.025.966-.344-.625.812.983.29-.983.29.625.812-.966-.344.028 1.025-.579-.846z"
          fill="#FECA00"
        />
      </g>
    </symbol>
    <symbol id="MZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#093"
          />
          <path
            d="M0 4.375h-.625v6.25h21.25v-6.25H0z"
            fill="#272727"
            stroke="#fff"
            stroke-width="1.25"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l11.25-7.5L0 0z"
          fill="#F50100"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15l11.25-7.5L0 0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.043 8.97l-2.362 1.907L3.765 8.33 1.903 6.537H4.1l.902-2.162.957 2.162h2.194l-1.96 1.792.981 2.548-2.131-1.906z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.847 7.49l-.4 1.338s1.352-.013 1.515.123c.489-.305 1.496-.123 1.496-.123l-.535-1.432s-.68-.308-.961-.139c-.69-.156-1.115.233-1.115.233z"
            fill="#F7FCFF"
          />
          <path
            d="M7.227 9.51a.313.313 0 01-.499.376l-2.612-3.47a.312.312 0 11.499-.375l2.612 3.47z"
            fill="#000"
          />
          <path
            d="M4.359 6.15l-.25-.3"
            stroke="#000"
            stroke-width=".625"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.503 5.852l-.755 1.21.377.653.864-1.284.156-.397-.156-.182h-.486zm-.979 3.591l.365.513 2.81-3.324.116.13.647-.61 1.036-1.125-1.035.846-.335-.093-.313.492H5.5L3.206 8.826l-.682.617z"
            fill="#000"
          />
        </g>
      </g>
    </symbol>
    <symbol id="NA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#093"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15L20 0H0z"
            fill="#3195F9"
          />
          <path
            d="M-.633 16.933l.332.601.567-.386L22.036 2.33l.439-.299-.224-.481-1.464-3.15-.307-.66-.606.404-22.097 14.722-.479.32.278.502 1.791 3.245z"
            fill="#E31D1C"
            stroke="#F7FCFF"
            stroke-width="1.25"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.894 5.778l-.81 1.009-.195-1.278-1.205.47.47-1.206-1.279-.196 1.01-.808-1.01-.81 1.278-.195-.47-1.205 1.206.47L3.085.75l.809 1.01.808-1.01.196 1.278 1.205-.47-.47 1.206 1.279.196-1.009.809 1.009.808-1.278.196.47 1.205-1.206-.47-.196 1.279-.808-1.009zm0-.447a1.563 1.563 0 100-3.125 1.563 1.563 0 000 3.125zm1.25-1.562a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="NC" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M13.75 0H20v15h-6.25V0z" fill="#F50100" />
        <path d="M0 0h7.5v15H0V0z" fill="#2E42A5" />
        <path d="M6.25 0h7.5v15h-7.5V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="NE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#FC6500" />
          <path d="M0 10v5h20v-5H0z" fill="#5EAA22" />
          <path
            d="M10 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
            fill="#FC6500"
          />
        </g>
      </g>
    </symbol>
    <symbol id="NF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0zM0 0h6v15H0V0z" fill="#409100" />
        <path d="M6 0h8v15H6V0z" fill="#fff" />
        <path
          d="M7.935 11.732c-.973.158-1.28-.317-1.28-.317l.123-.1c.082-.068.36-.045.628-.022.132.01.262.022.366.022.151 0 .326-.023.508-.047.198-.026.404-.053.6-.053.374 0-1.108-.49-1.425-.19-.317.3-1.205-.139-1.205-.39 0-.17.327-.108.625-.051.14.027.272.052.362.052.285 0-.285-.556-.581-.556-.297 0 .296-.13.581-.13.163 0 .313.043.443.079.098.027.184.05.255.05.163 0-.818-.42-.983-.42h.82c.28 0 .35.039.414.076.058.034.114.066.319.066.433 0 .196-.237.196-.237s-1.464-.152-1.749-.361c-.192-.142.325-.092.813-.045.234.023.462.045.602.045.432 0-.912-.309-1.13-.309h.99c.218 0 .456.07.705.143.276.08.566.166.857.166.308 0-.292-.184-.951-.385-.533-.163-1.104-.337-1.267-.436-.167-.103-.04-.063.193.01.27.083.683.211.937.211.473 0-.63-.464-.93-.464-.3 0-.586-.135-.316-.26.166-.076.598.04.974.14.236.063.45.12.563.12.137 0 .238.053.345.11a.895.895 0 00.452.133c.377 0-.797-.502-1.284-.502-.488 0-.57-.237-.277-.237.293 0-.657-.403-.657-.403s-.137-.285.2-.285h.457c.156 0-.156-.496-.456-.496-.3 0-.039-.15.456-.15.3 0 .476.104.688.229.136.08.288.17.497.246.533.193.13-.325 0-.325-.131 0-1.478-.422-1.478-.422s.137-.156 0-.368c-.104-.16.326-.078.588-.029.085.017.152.03.178.03.062 0 .24.044.458.098.148.037.314.078.475.113.4.088-1.36-.646-1.563-.646-.203 0 .434-.12.808-.12a1 1 0 01.364.058c.093.03.188.062.391.062.4 0-.755-.43-1.13-.43-.374 0-.152-.369 0-.369.06 0 .211.02.395.044.29.038.66.087.89.087.175 0 .015-.049-.217-.12-.268-.082-.632-.194-.693-.294-.066-.111.07-.091.306-.056l.138.02c.161.084.296.139.316.074a.073.073 0 01.034-.041c.039.002.077.003.116.003.224 0 .12-.034-.094-.075l-.02-.006c-.326-.1-1.03-.313-.767-.181.052.026.11.057.17.09a4.5 4.5 0 00-.377-.039c-.178 0-.357-.138 0-.138h.712c-.222 0-.534 0-.534-.174 0-.118.247-.075.475-.036.107.018.21.036.28.036.222 0 .277 0 .155-.103-.115-.098-.512-.098-.759-.098h-.038c-.241 0 .513-.126.797-.126h.07c0-.002-.014-.003-.037-.005-.124-.012-.536-.052-.83-.185-.263-.12-.032-.09.27-.05.18.023.386.05.527.05.377 0-.155-.253-.555-.253-.321 0-.168-.088.03-.202.05-.028.1-.058.149-.088.144-.09.25.064.312.156.042.062.064.094.064-.003a.35.35 0 00-.044-.185c.01.008.025.02.044.032.156.104 0-.271 0-.271s-.155-.104 0-.104c.156 0-.05-.178-.155-.178s.277-.17.277-.17l.084-.722s.208.786.208.892v.553c0 .132-.093.224-.155.285-.079.077-.108.107.155.107.473 0 .453.15.165.15-.288 0 .083.191.6.191s-.434.224-.765.224.331.103.765.103c.293 0-.008.101-.285.195a2.826 2.826 0 00-.315.117c-.086.046.126.045.35.032-.118.035-.235.07-.324.098-.108.033-.144.044-.143.049 0 .002.01.002.026.003.045.003.136.008.154.067.027.09.274-.049.507-.179l.11-.061.1-.009s.215.247.215.398c0 .088-.282.114-.583.142l-.03.003c.015-.02-.049-.01-.143.013a2.162 2.162 0 00-.404.07c-.097.03-.08.044-.002.046l-.021.007c-.074.022-.1.03-.099.035 0 .002.008.003.02.006.032.006.097.019.115.078.027.09.192-.024.348-.13l.015-.01.148-.01c.17-.012.332-.023.421-.023.28 0-.279.135-.492.135-.091 0 .024.02.198.052.236.042.58.104.678.162.117.069-.225.043-.53.02-.139-.01-.27-.02-.346-.02-.243 0-.288.198-.122.198h.614c.233 0 .475.356.384.356a.855.855 0 00-.167.044c-.188.058-.498.155-.831.155h.829c.214 0 .825 0 .825.212 0 .132-.115.16-.267.198a1.25 1.25 0 00-.298.104c-.267.145.797.276.797.276s-.421.131-.626.131c-.205 0 .095.194.626.194.41 0 .29.223.214.363a.277.277 0 00-.04.093c0 .037-.078.069-.19.115-.145.059-.347.141-.515.288-.193.17.042.12.308.063.144-.03.299-.063.397-.063.279 0 .398.012.307.147-.091.135-.902.35-1.107.35h1.107c.307 0-.086.242-.481.242-.265 0-.413.1-.51.165-.049.032-.085.056-.116.056h.8c.04 0 .086-.065.127-.124.036-.053.069-.101.094-.097.362.057.2.512 0 .512-.23 0-.926.154-.816.309.053.075.136.04.27-.014.143-.059.345-.141.632-.141.555 0 .053.155-.086.155-.14 0-.73.112-.926.21-.13.064.325.043.78.021.226-.01.451-.022.603-.022.457 0-1.084.39-1.65.39-.565 0 .377.149.566.149.073 0 .214.019.388.042.28.038.643.087.945.087.49 0-.49.322-.927.322h-.1c-.39-.002-.684-.003-.495.234.105.131.455.096.82.058.346-.035.707-.072.885.031.32.186-1.095.17-1.705.163l-.205-.002c-.375 0 .375.14 1.02.14h.082c.577 0 .714-.001.714.189 0 .167-1.257.123-1.781.105a8.881 8.881 0 00-.206-.005c-.1 0-.159.06-.22.123-.064.067-.13.137-.255.137-.101 0-.15-.065-.193-.124-.059-.08-.11-.15-.275-.036-.288.2.288 2.21.288 2.21H9.413v-1.893s-.506-.159-1.478 0zM9.72 2.51c-.002 0 .004.01.024.028-.012-.02-.022-.028-.024-.028zm-.541 7.505c-.246-.093.377-.097.665-.097.093 0 .126 0 .128.008 0 .004-.007.01-.02.021a.255.255 0 00-.108.208c0 .178-.234.064-.454-.044a2.427 2.427 0 00-.211-.096zm.509-.724c-.288 0-.91.005-.665.097.062.024.136.06.21.096.221.108.455.222.455.045 0-.12.072-.179.108-.208.013-.01.02-.018.02-.022-.002-.008-.035-.008-.128-.008zm-.52-.419c-.2-.048.308-.05.543-.05.078 0 .104 0 .105.004 0 .002-.006.005-.016.01-.03.016-.089.048-.089.11 0 .093-.19.033-.37-.023a2.867 2.867 0 00-.172-.05zm.506-1.98c-.326-.1-1.03-.313-.767-.182.067.033.145.077.224.121.233.13.48.269.507.18.018-.06.109-.065.154-.067.015-.001.026-.002.026-.004 0-.005-.036-.016-.144-.049zm-.767-.808c-.264-.132.441.081.767.18.108.034.145.045.144.05 0 .002-.01.002-.026.003-.045.003-.136.008-.154.067-.027.09-.274-.049-.507-.18a5.654 5.654 0 00-.224-.12zm.767-.602c-.326-.1-1.03-.313-.767-.182.067.034.145.077.224.122.233.13.48.268.507.18.018-.06.109-.066.154-.068.015 0 .026-.001.026-.004 0-.004-.036-.015-.144-.048zm.706 4.279c.288 0 .91.005.665.097-.063.024-.136.06-.211.096-.22.108-.454.222-.454.045a.255.255 0 00-.108-.208c-.013-.01-.021-.018-.02-.022.002-.008.035-.008.128-.008zm.665-.373c.245-.092-.377-.097-.665-.097-.093 0-.126 0-.128.008-.001.004.007.011.02.022.036.03.108.089.108.208 0 .177.233.063.454-.045.075-.036.148-.072.21-.096zm.385-1.083a.256.256 0 01-.007.002c-.066.016-.205.07-.361.132-.317.124-.706.277-.706.194 0-.063-.058-.094-.088-.11-.01-.005-.017-.008-.016-.01 0-.005.027-.005.104-.005.196 0 .946-.173 1.074-.203zm-.27-1.908c.264-.132-.44.081-.767.181a.674.674 0 00-.143.049c0 .002.01.003.026.003.045.003.136.008.154.067.027.09.274-.048.507-.179.079-.044.157-.088.224-.121zm-.767.808c.326-.1 1.031-.313.768-.182a5.52 5.52 0 00-.224.122c-.233.13-.48.268-.507.179-.018-.06-.11-.065-.154-.067-.016 0-.026-.001-.026-.004-.001-.004.035-.015.143-.048zm.768-1.435c.263-.131-.442.082-.768.182A.674.674 0 0010.25 6c0 .002.01.003.026.004.045.002.136.007.154.067.027.089.274-.049.507-.18.079-.044.157-.087.224-.12zm-.982-.366c.225-.069.711-.215.534-.11a2.727 2.727 0 00-.15.099c-.156.107-.32.22-.348.13-.018-.06-.083-.072-.116-.078-.011-.002-.018-.004-.019-.006 0-.005.025-.012.099-.035zm.143 2.384c-.258 0 0-.204 0-.204h.133a.339.339 0 00.14-.044c.102-.047.252-.116.571-.116.486 0-.585.364-.844.364z"
          fill="#409100"
        />
      </g>
    </symbol>
    <symbol id="NG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#F7FCFF" />
        <path d="M14 0h6v15h-6V0zM0 0h6v15H0V0z" fill="#093" />
      </g>
    </symbol>
    <symbol id="NI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0zm0 10v5h20v-5H0z"
            fill="#0080EC"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 5c.118 0 .234.008.347.024l-.124.797a1.71 1.71 0 00-.545.016L9.62 5.03A2.52 2.52 0 0110 5zm.72.105l-.217.778a1.694 1.694 0 011.19 1.673l.804.068a2.501 2.501 0 00-1.777-2.519zm1.476 3.591a2.5 2.5 0 01-2.01 1.297v-.81c.462-.05.869-.287 1.143-.634l.867.147zm-4.335.098a2.5 2.5 0 001.996 1.202v-.809a1.691 1.691 0 01-1.21-.668l-.787.275zm-.359-1.187A2.5 2.5 0 019.095 5.17l.209.787c-.585.264-.992.85-.997 1.532l-.805.12z"
            fill="#D0AB00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.984 5.594L8.274 8.55h3.448L9.984 5.594z"
            fill="#7CDFFF"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="8"
            y="5"
            width="4"
            height="4"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.984 5.594L8.274 8.55h3.448L9.984 5.594z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)">
            <path
              d="M10 9.449a1.494 1.494 0 100-2.989 1.494 1.494 0 000 2.989z"
              stroke="#E31D1C"
              stroke-width=".625"
            />
            <path
              d="M10 9.449a1.494 1.494 0 100-2.989 1.494 1.494 0 000 2.989z"
              stroke="#FFD018"
              stroke-width=".625"
            />
            <path
              d="M10 9.449a1.494 1.494 0 100-2.989 1.494 1.494 0 000 2.989z"
              stroke="#4EDD00"
              stroke-width=".625"
            />
            <path
              d="M10 9.449a1.494 1.494 0 100-2.989 1.494 1.494 0 000 2.989z"
              stroke="#3D58DB"
              stroke-width=".625"
            />
            <path
              fill="#3D58DB"
              d="M8.136 7.636h3.909v1.136H8.136z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.398 8.12l.78-.775.238.387.167-.473.186.355.195-.27.252.27.231-.355.198.355.226-.27.53.563.095.212-3.098.157V8.12z"
              fill="#97C923"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="NL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#E31D1C" />
          <path d="M0 10v5h20v-5H0z" fill="#3D58DB" />
        </g>
      </g>
    </symbol>
    <symbol id="NO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M6.25-.625h-.625v6.25h-6.25v3.75h6.25v6.25h3.75v-6.25h11.25v-3.75H9.375v-6.25H6.25z"
            fill="#2E42A5"
            stroke="#F7FCFF"
            stroke-width="1.25"
          />
        </g>
      </g>
    </symbol>
    <symbol id="NP" width="20" height="15" fill="none">
      <path fill="#fff" d="M0 0h20v15H0z" />
      <path
        d="M7.118 7.938l5.554 6.562H.5V.978l11.501 6.137H6.422l.696.823z"
        fill="#C51918"
        stroke="#4857A1"
      />
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="15">
        <path
          d="M7.118 7.938l5.554 6.562H.5V.978l11.501 6.137H6.422l.696.823z"
          fill="#fff"
          stroke="#fff"
        />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path
          d="M3.644 12.545l-.766.978-.036-1.234-1.203.348.708-1.02-1.181-.414 1.181-.415-.708-1.02 1.203.35.036-1.236.766.979.765-.979.036 1.235 1.203-.348-.708 1.02 1.181.414-1.181.415.708 1.019-1.203-.348-.036 1.234-.765-.978zM3.625 5.24l-.4.51-.018-.645-.629.182.37-.532-.617-.217.617-.216-.37-.533.629.182.018-.644.4.51.4-.51.018.644.629-.182-.37.533.617.216-.617.217.37.532-.629-.182-.018.645-.4-.51z"
          fill="#F7FCFF"
        />
        <path
          d="M3.54 5.09c1.37.005 2.101-.785 2.101-.785.145.901-.971 1.5-2.087 1.5s-1.792-.817-2.208-1.5c0 0 .825.779 2.195.784z"
          fill="#F9FAFA"
        />
      </g>
    </symbol>
    <symbol id="NR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 5v2.5h20V5H0z" fill="#FECA00" />
          <path
            d="M5.519 12.237l-.966 1.254-.045-1.582-1.518.446.894-1.305-1.49-.532 1.49-.53-.894-1.306 1.518.446.045-1.582.966 1.254.965-1.254.045 1.582 1.518-.446-.894 1.305 1.49.531-1.49.532.894 1.305-1.518-.446-.045 1.582-.965-1.254z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="NU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#FECA00"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="10"
          >
            <path fill="#fff" d="M0 0h20v10H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.414 9.456l3.964.917 8.451-4.67.894-.522L19.922.983l1.902-1.325-4.35-.401-7.013 3.956-5.069 2.49-6.806 3.753z"
              fill="#fff"
            />
            <path
              d="M-1.066 10.012l2.135.7L21.03-.508h-2.997l-19.1 10.52z"
              fill="#F50100"
            />
            <path
              d="M21.482 9.207l.157.943-4.19.223-6.753-3.956-.637.218L-2.55.257 2.657-.745l6.96 3.844L15.06 5.73l6.422 3.477z"
              fill="#fff"
            />
            <path
              d="M21.496 9.773l-2.134.7-8.5-4.804-2.52-.537L-2.037-.336H.96l10.373 5.339 2.755.643 7.408 4.127z"
              fill="#F50100"
            />
            <path
              d="M8.243-.781v-.781h-.781v.78h.781zm0 3.75v.781h.781v-.781h-.78zm-9.024 0v-.781h-.781v.78h.78zm0 4.062h-.781v.782h.78V7.03zm9.024 0h.781V6.25h-.78v.781zm0 5h-.781v.781h.781v-.78zm3.556 0v.781h.78v-.78h-.78zm0-5V6.25h-.782v.781h.782zm8.982 0v.782h.782V7.03h-.782zm0-4.062h.782v-.781h-.782v.78zm-8.982 0h-.782v.781h.782v-.781zm0-3.75h.78v-.781h-.78v.78zm-1.563 3.75v.781h.781v-.781h-.781zm0-2.188h.781V0h-.781v.781zm-.43 0V0h-.782v.781h.782zm0 2.188h-.782v.781h.782v-.781zm.43 1.562h.781V3.75h-.781v.781zm-.43 0V3.75h-.782v.781h.782zm.43.938v.781h.781v-.781h-.781zm-.43 0h-.782v.781h.782v-.781zM8.243 4.53h.781v-.78h-.78v.781zm-7.462 0v-.78H0v.781h.781zm0 .938H0v.781h.781v-.781zm7.462 0v.781h.781v-.781h-.78zM9.806 7.03v-.78h-.782v.781h.782zm0 3.438h-.782v.781h.782v-.781zm.43 0v.781h.781v-.781h-.781zm0-3.438h.781v-.78h-.781v.781zm1.563-2.5v-.78h-.782v.781h.782zm0 .938h-.782v.781h.782v-.781zm7.42-.938H20v-.78h-.781v.781zm0 .938v.781H20v-.781h-.781zM8.243 0h.781v-1.563h-.78V0zm.781 0v-.781H7.462V0h1.562zm0 2.969V0H7.462v2.969h1.562zM0 3.75h8.243V2.187H0V3.75zm-.781 0H0V2.187h-.781V3.75zm.781 0v-.781h-1.563v.781H0zm0 2.5v-2.5h-1.563v2.5H0zm0 .781V6.25h-1.563v.781H0zm0-.781h-.781v1.563H0V6.25zm8.243 0H0v1.563h8.243V6.25zm.781 5V7.031H7.462v4.219h1.562zm0 .781v-.781H7.462v.781h1.562zm0-.781h-.78v1.563h.78V11.25zm1.993 0H9.024v1.563h1.993V11.25zm.782 0h-.782v1.563h.782V11.25zm-.782 0v.781h1.563v-.781h-1.563zm0-4.219v4.219h1.563V7.031h-1.563zM20 6.25h-8.201v1.563H20V6.25zm.781 0H20v1.563h.781V6.25zm-.781 0v.781h1.563V6.25H20zm0-2.5v2.5h1.563v-2.5H20zm0-.781v.781h1.563v-.781H20zm0 .781h.781V2.187H20V3.75zm-8.201 0H20V2.187h-8.201V3.75zM11.017 0v2.969h1.563V0h-1.563zm0-.781V0h1.563v-.781h-1.563zm0 .781h.782v-1.563h-.782V0zM9.024 0h1.993v-1.563H9.024V0zm1.993 2.969V.78H9.455v2.19h1.562zM10.236 0h-.43v1.563h.43V0zM9.024.781V2.97h1.563V.78H9.024zm.782 2.969h.43V2.187h-.43V3.75zm.43 0h-.43v1.563h.43V3.75zm.781 1.719V4.53H9.455v.938h1.562zm-1.211.781h.43V4.687h-.43V6.25zm-.782-1.719v.938h1.563V4.53H9.024zm-.78-.781H.78v1.563h7.462V3.75zM0 4.531v.938h1.563V4.53H0zM.781 6.25h7.462V4.687H.781V6.25zm8.243-.781V4.53H7.462v.938h1.562zm0 1.562v3.438h1.563V7.03H9.024zm.782 4.219h.43V9.687h-.43v1.563zm1.211-.781V7.03H9.455v3.438h1.562zm-.781-4.219h-.43v1.563h.43V6.25zm.781-1.719v.938h1.563V4.53h-1.563zm8.202-.781h-7.42v1.563h7.42V3.75zM20 5.469V4.53h-1.563v.938H20zm-8.201.781h7.42V4.687h-7.42V6.25z"
              fill="#fff"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.058-.833H8.942V3.75H0v2.5h8.942v5.833h2.116V6.25H21.25v-2.5H11.058V-.833z"
              fill="#F50100"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.031 6.625a1.719 1.719 0 100-3.437 1.719 1.719 0 000 3.437z"
            fill="#2E42A5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.063 5.432l-.812.565.287-.946-.788-.597.988-.02.325-.934.324.933.988.02-.787.598.286.946-.812-.565zM4.438 5.36l-.676.47L4 5.042l-.656-.497.823-.017.27-.778.27.778.824.017-.656.497.238.788-.676-.47zm11.25 0l-.677.47.239-.788-.656-.497.823-.017.27-.778.27.778.824.017-.656.497.238.788-.675-.47zm-5.625-3l-.676.47.238-.788-.656-.497.823-.017.27-.778.27.778.824.017-.656.497.239.788-.677-.47zm0 6.625l-.676.47.238-.788-.656-.497.823-.017.27-.778.27.778.824.017-.656.497.239.788-.677-.47z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="NZ" width="20" height="15" fill="none">
      <g mask="url(#NZ_-_New_Zealand_(Aotearoa)__a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <g mask="url(#NZ_-_New_Zealand_(Aotearoa)__b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <g mask="url(#NZ_-_New_Zealand_(Aotearoa)__c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#NZ_-_New_Zealand_(Aotearoa)__d)"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.533 12.813l-1.102.579.21-1.227-.891-.87 1.232-.178.551-1.117.551 1.117 1.233.179-.892.869.21 1.227-1.102-.58zM13.25 8.669l-.85.446.162-.946-.687-.67.95-.138.425-.861.425.86.95.139-.688.67.163.946-.85-.446zm4.373-.003l-.848.447.162-.946-.687-.67.949-.137.424-.86.425.86.949.138-.687.67.162.945-.849-.447zM15.75 5.169l-.85.446.162-.946-.687-.67.95-.138L15.75 3l.425.86.95.139-.688.67.163.946-.85-.446z"
            fill="#F50100"
            stroke="#F7FCFF"
            stroke-width=".5"
          />
        </g>
      </g>
    </symbol>
    <symbol id="OM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F50101"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#5EAA22"
          />
          <path fill="#F50101" d="M0 0h7.5v15H0z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.731 1.27c.006-.056-.067-.078-.096-.029a23.922 23.922 0 01-1.73 2.5v-.573c-.09-.097-.375-.358-.375-.358v-.573l.515-.466-.707-.521-.745.521.563.466v.573c0 .274-.341.358-.341.358l-.063.505A23.357 23.357 0 012.11 1.267c-.03-.05-.104-.027-.095.031.069.461.276 1.483.85 2.575H2.71v-.02a.054.054 0 00-.054-.055H1.338a.054.054 0 00-.055.054v.83c0 .03.025.054.055.054h1.318c.03 0 .054-.025.054-.055v-.435h.166c.056.13.185.221.337.224.105.163.22.326.344.486-.286-.028-2.174-.189-2.174.498 0 .41.46.627 1.035.74-.58.525-1.127 1.019-1.38 1.246-.04.037-.008.1.045.087.45-.111 1.63-.455 2.752-1.22h.035a.854.854 0 00.688-.323C5.7 6.915 6.991 7.346 7.552 7.5c.058.016.09-.06.04-.094A16.983 16.983 0 015.06 5.225l.028-.033c.214-.252.4-.512.563-.773.068-.04.122-.1.154-.173h.166v.435c0 .03.024.055.054.055h1.318c.03 0 .054-.025.054-.055v-.829a.054.054 0 00-.054-.054H6.025a.054.054 0 00-.036.014 7.722 7.722 0 00.742-2.541zm-.76 2.603v-.025l-.013.025h.013zM3.525 4.1a.304.304 0 01-.306.302.304.304 0 01-.305-.302c0-.167.137-.303.305-.303.17 0 .306.136.306.303zm1.63 0c0 .167.137.302.306.302a.304.304 0 00.306-.302.304.304 0 00-.306-.303.304.304 0 00-.305.303z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="PA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M10 0v7.5h10V0H10zm4.388 11.969l-1.439.89.559-1.495-1.223-1.132h1.483l.62-1.616.473 1.617h1.486l-1.07 1.131.524 1.495-1.413-.89z"
            fill="#E31D1C"
          />
          <path
            d="M5.638 5.228l-1.439.89.559-1.494-1.223-1.132h1.483l.62-1.617.473 1.617h1.486l-1.07 1.132.523 1.494-1.412-.89zM0 7.5V15h10V7.5H0z"
            fill="#2E42A5"
          />
        </g>
      </g>
    </symbol>
    <symbol id="PE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 0h10.625v15H5V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15 0h5v15h-5V0zM0 0h5v15H0V0z"
          fill="#F50101"
        />
        <path
          d="M9.838 5.466l.021.226c-.624.063-.96-.242-.96-.875 0-.628.329-.961.95-.965v.227c-.502.003-.733.237-.733.738 0 .496.224.7.722.649zm.277 0l-.021.226c.624.063.96-.242.96-.875 0-.628-.329-.961-.95-.965v.227c.502.003.734.237.734.738 0 .496-.225.7-.723.649z"
          fill="#A2BB6A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.462 10.702c-.18.064-1.396 0-1.396 0v.339h.807c.269 0 .37.048.464.092.08.037.152.072.316.072.319 0 .313-.237.308-.435l-.001-.068a.55.55 0 01.023-.167c.015-.053.024-.084-.023-.176-.079-.153-.83-.133-.83 0 0 .063.114.129.215.187.114.065.212.122.117.156zm1.094 0c.18.064 1.396 0 1.396 0v.339h-.807c-.269 0-.37.048-.464.092-.08.037-.152.072-.316.072-.319 0-.313-.237-.308-.435v-.068a.55.55 0 00-.022-.167c-.015-.053-.024-.084.023-.176.079-.153.83-.133.83 0 0 .063-.114.129-.215.187-.114.065-.212.122-.117.156z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.254 10.734s.95-.094 1.165-.437c.214-.342.572-.926.698-1.068.125-.141.133.202.133.202s.208.295.208-.082c0-.376-.148-.113-.341-.68-.194-.565-.303-1.12-.249-1.205.055-.084.184.084.184 0v-.248l.199.248.207-.078s.17.365.276.479c.105.113.167-.152.136-.4-.03-.25-.412-.25-.412-.25s-.488-.262-.488-.372c0-.11.211-.078.211-.078l-.064-.34s.174.207.257.103c.084-.104-.123-.285-.123-.285h.33v-.16l.153.086-.153-.35s-.448.068-.53 0a8.345 8.345 0 01-.337-.33v-.124h-.148l.148-.25v-.4l.537.108v-.295s.755.368.619.665c-.136.296-.136.627-.136.627v.263s.023-.08.136-.08c.113 0 .242.058.242.24 0 .181.231-.074.231-.074v.756s.054.081.173 0c.118-.082.066-.018-.29.46-.356.48-.228.48-.114.363.114-.117.577-.45.404-.284-.173.167-.184.517 0 .4.184-.116.149-.198.149 0 0 .2-.325.875-.439.981-.114.106-.22.171-.356.278-.136.106-.289.232-.289.308 0 .077.289-.082.289-.082l-.136.486h.264s-.21.644-.624.644h-.808c-.083 0-.458.177-.458.177l-.275.078s.438.042.585.174c.148.131 0 .223 0 .223s-.405-.04-.707-.132c-.303-.091-.457.082-.457-.091v-.174z"
          fill="#00A854"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.99 5.568a.111.111 0 01-.11.114.111.111 0 01-.108-.114c0-.063.048-.113.108-.113s.11.05.11.113zm-.544.455a.111.111 0 01-.109.113.111.111 0 01-.109-.113c0-.063.049-.114.109-.114s.109.051.109.114zm.543-.114c.06 0 .109-.05.109-.114a.111.111 0 00-.109-.113c-.06 0-.109.05-.109.113s.05.114.11.114zm-.217 1.705a.111.111 0 01-.109.113.111.111 0 01-.109-.113c0-.063.049-.114.109-.114s.109.05.109.114zm-.544 1.477c.06 0 .109-.05.109-.114a.111.111 0 00-.109-.113c-.06 0-.108.05-.108.113s.048.114.108.114zm.87.227a.111.111 0 01-.109.114.111.111 0 01-.109-.114c0-.063.05-.113.11-.113s.108.05.108.113zm.108-.113c.06 0 .11-.051.11-.114a.111.111 0 00-.11-.114c-.06 0-.108.051-.108.114s.048.114.108.114zm0-1.705a.111.111 0 01-.108.114.111.111 0 01-.109-.114c0-.063.049-.114.109-.114s.108.051.108.114z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.803 10.534s-1.727-.341-1.821-1.002c-.095-.66-.093-1.364-.093-1.364l-.16.43s-.009-.586.32-1.003c.328-.417-.41.277-.41.277s.373-.59.53-.647c.155-.056-.627.37-.627.37s.224-.495.398-.635c.174-.14-.398.265-.398.265s.13-.49.285-.608c.154-.117-.507.608-.507.608s.35-1.122.546-1.227c.196-.104-.324.206-.324.206s.319-.48.604-.719c.285-.238-.516.102-.418.102 0 0 .29-.327.456-.42.167-.091-.642.318-.642.318s.58-.64.755-.734c.173-.095-.855.508-.855.508s.06-.279.086-.479c.026-.2-.476.547-.408 1.218.069.671-.273-.513-.273-.513s-.137.257.196.93l-.361-.506s.05.46.165.708c.116.248-.329-.413-.329-.413s-.085.413 0 .413c0 0 .508.679.527.876.019.198-.57-.706-.65-.706-.078 0-.122.29 0 .29.123 0 .355.416.355.416s-.301-.218-.366-.23c-.065-.013.05.129.134.23 0 0-.236.193-.218.339.018.145.643.176.916.868 0 0-.564-.298-.698-.298s.216.311.33.414c.112.103-.175-.103-.252 0-.078.103.429.541.524.541h-.37s.124.175.295.175c.17 0 .782.274.782.363 0 .09-.516-.113-.611-.113-.096 0 .672.725 1.08.752.409.028.666.137.842.137h.3l-.831.424h.276c.361 0 .637.1.779-.107.141-.207.141-.454.141-.454z"
          fill="#00A854"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="7.236"
          y="3.551"
          width="6"
          height="8"
          fill="#000"
        >
          <path fill="#fff" d="M7.236 3.551h6v8h-6z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.054 5.566l.026-.015v.03c.12.066.423.221.62.221.25 0 .591-.251.591-.251l.57.804s-.384.804-.09 1.786c.293.983-.016 1.74-1.321 1.824 0 0-.257.05-.37.127v.072c0-.018-.01-.035-.026-.05-.016.015-.026.032-.026.05v-.072c-.112-.078-.37-.127-.37-.127-1.305-.084-1.614-.841-1.32-1.824a2.693 2.693 0 00-.09-1.786l.57-.804s.34.251.59.251c.197 0 .5-.155.62-.222v-.03l.026.016z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.054 5.566l.026-.015v.03c.12.066.423.221.62.221.25 0 .591-.251.591-.251l.57.804s-.384.804-.09 1.786c.293.983-.016 1.74-1.321 1.824 0 0-.257.05-.37.127v.072c0-.018-.01-.035-.026-.05-.016.015-.026.032-.026.05v-.072c-.112-.078-.37-.127-.37-.127-1.305-.084-1.614-.841-1.32-1.824a2.693 2.693 0 00-.09-1.786l.57-.804s.34.251.59.251c.197 0 .5-.155.62-.222v-.03l.026.016z"
          fill="#E8AA00"
        />
        <path
          d="M10.08 5.55h.625v-1.1l-.945.564.32.537zm-.026.016l-.308.544.308.174.308-.174-.308-.544zm.026.014h-.625v.37l.323.178.302-.548zm1.211-.03l.51-.36-.368-.52-.513.378.371.503zm.57.805l.564.27.158-.332-.212-.3-.51.362zm-.09 1.786l-.6.18.6-.18zM10.45 9.965l-.04-.623-.039.002-.038.007.117.614zm-.37.127l-.355-.514-.27.186v.328h.625zm-.026.021l.438-.446-.438-.43-.437.43.437.446zm-.026-.02h.625v-.329l-.27-.186-.355.514zm-.37-.128l.117-.614-.038-.007-.038-.002-.04.623zm-1.41-3.61l-.51-.361-.212.3.158.33.564-.269zm.57-.804l.37-.503-.512-.379-.369.52.51.362zm1.21.03l.302.547.323-.179V5.58h-.625zm0-.03l.32-.537-.945-.563v1.1h.625zm.052 0l-.32-.537a1.019 1.019 0 01-.013.008l.616 1.088.026-.015.008-.005.002-.001h.001v-.001h.001l-.32-.537zm.625.03v-.03h-1.25v.03h1.25zm-.927.547c.071.039.2.107.347.167.127.052.348.132.575.132v-1.25c.027 0 .03.004 0-.004a.898.898 0 01-.102-.035 2.182 2.182 0 01-.216-.105l-.604 1.095zm.922.3c.293 0 .56-.133.687-.201a2.568 2.568 0 00.266-.166l.006-.005.002-.001.001-.001a203.712 203.712 0 00-.742-1.006h.001v-.001c.001 0 .001 0 0 0a.295.295 0 01-.03.021c-.025.016-.06.038-.098.059a.747.747 0 01-.102.046c-.03.011-.025.004.01.004v1.25zm.081-.516l.57.804 1.02-.722-.57-.804-1.02.722zm1.08.443a79.579 79.579 0 00-.565-.268l-.001.003a.698.698 0 01-.003.005l-.006.014a2 2 0 00-.071.183 3.33 3.33 0 00-.043 2.029l1.198-.358a2.082 2.082 0 01.052-1.332l.005-.012a.132.132 0 01-.001.004c-.001.001-.001.001-.565-.268zm-.69 1.965c.124.414.075.634.01.737-.053.085-.222.25-.771.285l.08 1.247c.756-.049 1.395-.305 1.748-.865.343-.543.302-1.192.132-1.761l-1.198.357zm-.721 1.645l-.117-.614-.002.001h-.005a1.66 1.66 0 00-.055.012l-.132.034a1.429 1.429 0 00-.414.18l.71 1.028c-.03.02-.043.024-.023.016a.78.78 0 01.133-.038l.02-.004h.002l-.117-.615zm.255.2v-.073h-1.25v.072h1.25zm-1.088.394a.554.554 0 01-.162-.395h1.25a.697.697 0 00-.213-.497l-.875.892zm0-.892a.696.696 0 00-.214.497h1.25a.554.554 0 01-.161.395l-.875-.892zm1.036.497v-.072h-1.25v.072h1.25zm-.995-.199l-.116.614H9.54h.003a1.012 1.012 0 01.153.043c.02.008.006.005-.024-.016l.71-1.028a1.428 1.428 0 00-.413-.18 2.626 2.626 0 00-.188-.045l-.004-.001h-.002l-.118.613zm-1.92-2.002c-.17.569-.21 1.218.132 1.761.354.56.992.816 1.748.865l.08-1.247c-.549-.036-.717-.2-.77-.285-.066-.103-.115-.323.009-.737l-1.198-.357zm.51-1.608c-.564.27-.565.27-.565.269v-.003L7.68 6.62c0-.001 0-.001 0 0l.005.011a2.008 2.008 0 01.102.361 2.07 2.07 0 01-.05.97l1.199.358a3.332 3.332 0 00-.123-2.23l-.001-.002v-.001h-.001l-.564.268zm.06-1.165l-.57.804 1.02.722.57-.804-1.02-.722zm1.1-.013c.034 0 .04.007.01-.004a.743.743 0 01-.102-.046 1.343 1.343 0 01-.13-.08h.002v.001l-.37.503-.372.503h.002c0 .001 0 .002.002.002l.006.005a1.669 1.669 0 00.075.051c.047.031.113.072.19.115.128.068.395.2.687.2v-1.25zm.318-.144c-.049.027-.131.07-.216.105a.9.9 0 01-.101.035c-.03.008-.027.004-.001.004v1.25c.228 0 .449-.08.575-.132.147-.06.276-.128.347-.167l-.604-1.095zm.927.547v-.03h-1.25v.03h1.25zm-.625-.03l-.32.538h.002a1.325 1.325 0 01.036.022l.616-1.088-.012-.007a.102.102 0 01-.003-.001h.001l-.32.537z"
          fill="#E8AA00"
          mask="url(#b)"
        />
        <mask
          id="d"
          maskUnits="userSpaceOnUse"
          x="7"
          y="4"
          width="6"
          height="7"
        >
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="7.236"
            y="3.551"
            width="6"
            height="8"
            fill="#000"
          >
            <path fill="#fff" d="M7.236 3.551h6v8h-6z" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.054 5.566l.026-.015v.03c.12.066.423.221.62.221.25 0 .591-.251.591-.251l.57.804s-.384.804-.09 1.786c.293.983-.016 1.74-1.321 1.824 0 0-.257.05-.37.127v.072c0-.018-.01-.035-.026-.05-.016.015-.026.032-.026.05v-.072c-.112-.078-.37-.127-.37-.127-1.305-.084-1.614-.841-1.32-1.824a2.693 2.693 0 00-.09-1.786l.57-.804s.34.251.59.251c.197 0 .5-.155.62-.222v-.03l.026.016z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.054 5.566l.026-.015v.03c.12.066.423.221.62.221.25 0 .591-.251.591-.251l.57.804s-.384.804-.09 1.786c.293.983-.016 1.74-1.321 1.824 0 0-.257.05-.37.127v.072c0-.018-.01-.035-.026-.05-.016.015-.026.032-.026.05v-.072c-.112-.078-.37-.127-.37-.127-1.305-.084-1.614-.841-1.32-1.824a2.693 2.693 0 00-.09-1.786l.57-.804s.34.251.59.251c.197 0 .5-.155.62-.222v-.03l.026.016z"
            fill="#fff"
          />
          <path
            d="M10.08 5.55h.625v-1.1l-.945.564.32.537zm-.026.016l-.308.544.308.174.308-.174-.308-.544zm.026.014h-.625v.37l.323.178.302-.548zm1.211-.03l.51-.36-.368-.52-.513.378.371.503zm.57.805l.564.27.158-.332-.212-.3-.51.362zm-.09 1.786l-.6.18.6-.18zM10.45 9.965l-.04-.623-.039.002-.038.007.117.614zm-.37.127l-.355-.514-.27.186v.328h.625zm-.026.021l.438-.446-.438-.43-.437.43.437.446zm-.026-.02h.625v-.329l-.27-.186-.355.514zm-.37-.128l.117-.614-.038-.007-.038-.002-.04.623zm-1.41-3.61l-.51-.361-.212.3.158.33.564-.269zm.57-.804l.37-.503-.512-.379-.369.52.51.362zm1.21.03l.302.547.323-.179V5.58h-.625zm0-.03l.32-.537-.945-.563v1.1h.625zm.052 0l-.32-.537a1.019 1.019 0 01-.013.008l.616 1.088.026-.015.008-.005.002-.001h.001v-.001h.001l-.32-.537zm.625.03v-.03h-1.25v.03h1.25zm-.927.547c.071.039.2.107.347.167.127.052.348.132.575.132v-1.25c.027 0 .03.004 0-.004a.898.898 0 01-.102-.035 2.182 2.182 0 01-.216-.105l-.604 1.095zm.922.3c.293 0 .56-.133.687-.201a2.568 2.568 0 00.266-.166l.006-.005.002-.001.001-.001a203.712 203.712 0 00-.742-1.006h.001v-.001c.001 0 .001 0 0 0a.295.295 0 01-.03.021c-.025.016-.06.038-.098.059a.747.747 0 01-.102.046c-.03.011-.025.004.01.004v1.25zm.081-.516l.57.804 1.02-.722-.57-.804-1.02.722zm1.08.443a79.579 79.579 0 00-.565-.268l-.001.003a.698.698 0 01-.003.005l-.006.014a2 2 0 00-.071.183 3.33 3.33 0 00-.043 2.029l1.198-.358a2.082 2.082 0 01.052-1.332l.005-.012a.132.132 0 01-.001.004c-.001.001-.001.001-.565-.268zm-.69 1.965c.124.414.075.634.01.737-.053.085-.222.25-.771.285l.08 1.247c.756-.049 1.395-.305 1.748-.865.343-.543.302-1.192.132-1.761l-1.198.357zm-.721 1.645l-.117-.614-.002.001h-.005a1.66 1.66 0 00-.055.012l-.132.034a1.429 1.429 0 00-.414.18l.71 1.028c-.03.02-.043.024-.023.016a.78.78 0 01.133-.038l.02-.004h.002l-.117-.615zm.255.2v-.073h-1.25v.072h1.25zm-1.088.394a.554.554 0 01-.162-.395h1.25a.697.697 0 00-.213-.497l-.875.892zm0-.892a.696.696 0 00-.214.497h1.25a.554.554 0 01-.161.395l-.875-.892zm1.036.497v-.072h-1.25v.072h1.25zm-.995-.199l-.116.614H9.54h.003a1.012 1.012 0 01.153.043c.02.008.006.005-.024-.016l.71-1.028a1.428 1.428 0 00-.413-.18 2.626 2.626 0 00-.188-.045l-.004-.001h-.002l-.118.613zm-1.92-2.002c-.17.569-.21 1.218.132 1.761.354.56.992.816 1.748.865l.08-1.247c-.549-.036-.717-.2-.77-.285-.066-.103-.115-.323.009-.737l-1.198-.357zm.51-1.608c-.564.27-.565.27-.565.269v-.003L7.68 6.62c0-.001 0-.001 0 0l.005.011a2.008 2.008 0 01.102.361 2.07 2.07 0 01-.05.97l1.199.358a3.332 3.332 0 00-.123-2.23l-.001-.002v-.001h-.001l-.564.268zm.06-1.165l-.57.804 1.02.722.57-.804-1.02-.722zm1.1-.013c.034 0 .04.007.01-.004a.743.743 0 01-.102-.046 1.343 1.343 0 01-.13-.08h.002v.001l-.37.503-.372.503h.002c0 .001 0 .002.002.002l.006.005a1.669 1.669 0 00.075.051c.047.031.113.072.19.115.128.068.395.2.687.2v-1.25zm.318-.144c-.049.027-.131.07-.216.105a.9.9 0 01-.101.035c-.03.008-.027.004-.001.004v1.25c.228 0 .449-.08.575-.132.147-.06.276-.128.347-.167l-.604-1.095zm.927.547v-.03h-1.25v.03h1.25zm-.625-.03l-.32.538h.002a1.325 1.325 0 01.036.022l.616-1.088-.012-.007a.102.102 0 01-.003-.001h.001l-.32.537z"
            fill="#fff"
            mask="url(#c)"
          />
        </mask>
        <g mask="url(#d)">
          <path fill="#67BAFF" d="M8.315 5.455h1.739v2.386H8.315z" />
          <path fill="#fff" d="M10.054 5.455h1.739v2.386h-1.739z" />
          <path fill="#C51918" d="M8.098 8.068h4.348v2.727H8.098z" />
          <path
            d="M10.897 7.672h-.218V6.038h.218v1.634z"
            fill="#C9A951"
          />
          <path
            d="M10.809 6.928l-.106.19-.376-.21.106-.189.376.21zm0-.454l-.106.19-.376-.21.106-.19.376.21z"
            fill="#C9A951"
          />
          <path
            d="M10.762 6.928l.106.19.375-.21-.106-.189-.375.21zm0-.454l.106.19.375-.21-.106-.19-.375.21z"
            fill="#C9A951"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.08 8.566s.152-.173.152-.087c0 .087 0 .232-.076.232-.075 0-.428-.07-.562-.232-.134-.163-.418-.446-.783-.379-.366.067-.8.54-.906.54-.107 0-.34.366-.17.65.17.286.46.197.46.28 0 .083.073.092.344.092.272 0 .371.096.606.096s-.077-.003.301-.096c.379-.092.666-.371.445-.371h-.445c-.153 0-.493.11-.493 0s.076-.346.285-.228c.208.118.788.207.994 0 .206-.208.277-.334.242-.584-.037-.25-.318-.178-.318-.178l-.075.265z"
            fill="#FBCD17"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.61 5.981c-.13.115-.046.534-.261.534-.215 0-.517-.314-.593-.107-.076.207 0 .137 0 .314 0 .176-.182.666-.091.749.09.082.184.3.168.198-.016-.102-.085-.252-.056-.415-.028-.168.153-.33.153-.33s-.02.175-.034.24c0 0-.06.132-.035.219 0 0 .061.246.087.263 0 0 .016-.583.035-.679.018-.096.152.108.196.085 0 0 .015.399-.008.446 0 0-.047.095-.03.125 0 0 .044.109.081.077l.02-.108s-.022-.064.012-.21c0 0 .036-.322.051-.252 0 0-.006.152.01.23 0 0 .028.194.034.215 0 0 .13.187.134.108 0 0-.126-.15-.099-.264 0 0-.072-.323.029-.395 0 0 .267-.123.283-.335 0 0 .038-.24.045-.35 0 0-.058-.033.063-.09 0 0 .194-.074.073-.178"
            fill="#D18219"
          />
        </g>
      </g>
    </symbol>
    <symbol id="PF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v3.75h20V0H0zm0 11.25V15h20v-3.75H0z"
            fill="#BF2714"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="6"
            y="3"
            width="8"
            height="9"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 11.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.593 8.603a.123.123 0 01.179-.144l.233.136c.035.02.078.022.114.005l.577-.27a.123.123 0 01.124.011l.623.45.86-.464a.123.123 0 01.108-.004l.648.282c.033.014.07.013.103-.002l.581-.28a.123.123 0 01.1-.004l.719.288a.123.123 0 00.1-.004l.557-.276a.123.123 0 01.112.001l.511.268a.12.12 0 00.118-.002l.266-.15a.123.123 0 01.18.138l-.056.209H6.653l-.06-.188zm-.003.741a.123.123 0 01.181-.141l.213.127c.036.022.08.024.117.006l.548-.266a.123.123 0 01.128.012l.597.447.827-.462a.123.123 0 01.11-.005l.62.279a.123.123 0 00.105-.002l.555-.277a.123.123 0 01.101-.004l.688.285a.123.123 0 00.103-.004l.531-.273a.123.123 0 01.115.002l.486.264c.038.02.084.02.12-.002l.245-.144a.123.123 0 01.181.137l-.053.206h-6.46l-.057-.185zm.123.492a.123.123 0 01.181-.142l.213.128a.12.12 0 00.117.005l.548-.266a.123.123 0 01.128.013l.597.447.827-.462a.123.123 0 01.11-.005l.62.279a.123.123 0 00.105-.002l.554-.277a.123.123 0 01.102-.004l.688.285a.123.123 0 00.103-.004l.531-.273a.123.123 0 01.115.002l.486.263a.12.12 0 00.12-.002l.245-.143a.123.123 0 01.181.137l-.053.206h-6.46l-.058-.185zm.738.492a.123.123 0 01.181-.142l.213.128c.035.021.08.023.117.005l.548-.266a.123.123 0 01.127.012l.598.447.827-.461a.123.123 0 01.11-.005l.619.278a.123.123 0 00.105-.002l.555-.276a.123.123 0 01.102-.004l.688.285a.123.123 0 00.103-.005l.53-.272a.123.123 0 01.116.002l.486.263c.037.02.083.02.12-.002l.244-.143a.123.123 0 01.182.137l-.053.205H7.508l-.057-.184zm-.983.615a.123.123 0 01.18-.142l.213.128c.036.021.08.023.117.005l.548-.266a.123.123 0 01.128.012l.597.447.827-.462a.123.123 0 01.11-.004l.62.278a.123.123 0 00.105-.002l.554-.277a.123.123 0 01.102-.003l.688.284a.123.123 0 00.103-.004l.531-.272a.123.123 0 01.115.001l.486.264c.038.02.084.02.12-.002l.245-.143a.123.123 0 01.181.136l-.053.206h-6.46l-.057-.184z"
              fill="#5277B9"
            />
            <path
              d="M7.917 5.904h.625l-.014 2.47c.104.332.254.462.486.462v.625c-.528 0-.901-.324-1.097-.993V5.904zm4.225 0h-.625l.014 2.47c-.104.332-.254.462-.486.462v.625c.528 0 .9-.324 1.097-.993V5.904z"
              fill="red"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.453 4.318s-1.037-.271-1.037.416v2.164l1.209.359V5.488s-.604-.369-.604-.658c0-.288.432-.512.432-.512z"
              fill="red"
            />
            <path
              d="M8.709 8.057l.394-.504m-.035.487l-.378-.507m.584.524l.394-.504m-.034.487l-.378-.507m.559.524l.394-.504m-.034.487l-.378-.507m.583.524l.395-.504m-.035.487l-.378-.507m.584.524l.394-.504m-.034.487l-.378-.507"
              stroke="#000"
              stroke-width=".625"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.409 4.434l.748 1.462.092-1.462-.092-.288-.748.288zm-.375 1.247l-.539-.571.54-.642 1.132 1.81v.46l-.545-.46v-.597h-.588zm-1.186.44l.983.471.077-.727-.819-.7-.241.957zM7.88 7.33l-1.293-.133v-.912l1.293.498v.547zm-1.328.895L6.4 7.45l1.457.073v.702H6.552zM8.604 6.95v-.438l.546.438-.06.231-.486-.23zm5.071.499l-.153.775h-1.304v-.702l1.457-.073zm-1.481-.12l1.293-.133v-.912l-1.293.498v.547zm1.032-1.207l-.983.47-.076-.727.818-.7.241.957zm-1.186-.44l.539-.572-.54-.642-1.132 1.81v.46l.545-.46v-.597h.588zm-.375-1.248l-.748 1.462-.092-1.462.092-.288.748.288zM11.47 6.95v-.438l-.545.438.059.231.486-.23z"
              fill="#FA8F21"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="PG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <rect width="20" height="15" rx="1.25" fill="#E11C1B" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0l20 15H0V0z"
          fill="#1D1D1D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.427 11.418h.833l.395-.933.466.927.852.046-.728.793.374.956-.927-.532-.855.537.323-.928-.733-.866zm-2.5-2.5h.833l.395-.934.466.927.852.047-.728.793.374.956-.927-.532-.855.537.323-.928-.733-.866zm2.5-1.25h.833l.395-.934.466.927.852.047-.728.793.374.956-.927-.532-.855.537.323-.928-.733-.866z"
          fill="#EEEEF6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.07 10.353l.572-.02.206-.59.232.587.527.051-.474.335.382.594-.664-.248-.574.256.303-.585-.51-.38zm1.25-1.25l.572-.02.206-.59.232.587.527.051-.474.335.382.594-.664-.248-.575.256.304-.585-.51-.38z"
          fill="#EEEEF6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.177 1.25s-1.93.385-1.388 3.069h-.276s.023-.14-.242-.222c-.265-.083-.212-.052-.348 0-.137.05-.968 0-.968 0v.102l.588.254s-.014.212.231.33c.246.116.425.173.425.173s.036.233-.194.233-1.158-.3-1.487.438a6.455 6.455 0 01-.768 1.28h.494l-.132.165h.556l-.15.085s.688-.008.742-.085c.054-.078 0 .21 0 .21s.667-.304.704-.375l.311.213.089-.361.334.148.09-.345s.946 1.581 1.663 1.49V7.79l.654.262.083-.116s.79.322 1.033.352l-.173-.352h.173l-.173-.654h.173l-.347-.523.097-.142-.064-.186s1.272.405 1.215 1.05c-.058.645-.624.905-.624.905s-.543.166-1.034.13c0 0 .39.46 1.214.305.824-.156 1.097-.955 1.097-.955s.378.785.067 1.198c-.311.412-1.697.702-1.697.702s.502.294.977.219c.475-.076 1.214-.49 1.357-1.164.144-.675-.494-1.92-.783-2.062l-.114-.432.26.104-.533-1.303.258.057-.753-.938.207-.064-1.041-.748.311-.083s-.77-.39-1.647.083l.008-.163-.23.039.013-.18.23-.347-.345-.133s.278-.418.237-.412c0 0-.31.089-.293.051 0 0 .157-.403.115-.392 0 0-.36.123-.306.061l.138-.246-.034-.463z"
          fill="#FBCD17"
        />
      </g>
    </symbol>
    <symbol id="PH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#BF2714"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0-1.25V7.5h20v-8.75H0z"
            fill="#3D58DB"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l11.25-7.5L0 0z"
          fill="#F7FCFF"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15l11.25-7.5L0 0z"
            fill="#fff"
          />
        </mask>
        <g
          mask="url(#c)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#FECA00"
        >
          <path
            d="M8.503 6.825l.798.308.474-.559.013.747.733.239-.772.262.05.686-.508-.526-.8.153.473-.606-.46-.704zm-7.5 3.75l.733.324.539-.575-.052.764.799.222-.837.278.115.67-.583-.478-.726.105.408-.59-.396-.72zm0-7.5l.811.299.461-.55.026.738.72.248-.758.253.037.695-.505-.504-.804.13.486-.613-.474-.696zm4.073 6.008a1.563 1.563 0 100-3.125 1.563 1.563 0 000 3.125z"
          />
          <path
            d="M4.891 5.15l.084 1.004a.14.14 0 00.277.004l.11-1a.238.238 0 10-.471-.008zm-.261.485l.13.437c.012.04.052.065.098.057a.07.07 0 00.052-.084l-.104-.438a.099.099 0 00-.122-.073.08.08 0 00-.054.1zm.702.455c-.01.037.011.075.053.087a.083.083 0 00.096-.056l.145-.431a.08.08 0 00-.061-.105.1.1 0 00-.115.07l-.118.435zm1.298-.44l-.699.772a.14.14 0 00.192.2l.834-.632a.238.238 0 10-.327-.34zm-.213 1.638l1.043-.08a.238.238 0 11-.008.471l-1.04-.114a.14.14 0 01.005-.277zM6.96 8.95l-.81-.706a.14.14 0 00-.2.193l.67.84a.238.238 0 10.34-.327zm-1.676-.22l.061 1.054a.238.238 0 11-.47-.009l.132-1.05a.14.14 0 01.277.006zm-1.645.57l.688-.838a.14.14 0 00-.192-.2l-.823.698a.239.239 0 10.327.34zm.202-1.704l-1.05.086a.238.238 0 11.01-.471l1.045.108a.14.14 0 01-.005.277zM3.22 5.95l.89.689a.14.14 0 00.2-.193l-.75-.823a.238.238 0 10-.34.327zm2.618.26l.217-.4a.08.08 0 01.118-.027c.042.03.054.088.026.132l-.236.383a.07.07 0 01-.096.023.084.084 0 01-.03-.11zm1.099.732l-.437.13a.084.084 0 00-.057.098.07.07 0 00.084.052l.438-.104a.099.099 0 00.072-.121.08.08 0 00-.1-.055zM6.359 8.15l.4.217a.08.08 0 01.028.118.099.099 0 01-.132.027l-.383-.237a.07.07 0 01-.023-.096.084.084 0 01.11-.029zm-.731 1.1l-.13-.437a.084.084 0 00-.098-.058.07.07 0 00-.052.084l.103.438a.099.099 0 00.122.073.08.08 0 00.055-.1zM4.42 8.671l-.217.4a.08.08 0 01-.118.028.099.099 0 01-.027-.132l.237-.383a.07.07 0 01.096-.023.084.084 0 01.029.11zm-1.1-.731l.437-.13a.084.084 0 00.058-.098.07.07 0 00-.084-.052l-.438.104a.099.099 0 00-.073.122.08.08 0 00.1.054zm.58-1.206l-.4-.217a.08.08 0 01-.028-.118.099.099 0 01.132-.027l.383.237a.07.07 0 01.023.096.084.084 0 01-.11.029zm2.33-.105c-.034.02-.046.062-.024.1a.084.084 0 00.107.028l.407-.203a.08.08 0 00.032-.117.099.099 0 00-.131-.03l-.391.222zm.165 1.069c.012-.041.05-.063.087-.053l.435.119a.099.099 0 01.068.124.08.08 0 01-.103.051l-.432-.145a.083.083 0 01-.055-.096zm-.452.844c-.02-.034-.062-.045-.1-.024a.083.083 0 00-.028.107l.203.408a.08.08 0 00.117.03.099.099 0 00.03-.13l-.222-.391zm-1.069.166a.07.07 0 01.053.086l-.119.435a.099.099 0 01-.124.068.08.08 0 01-.051-.102l.145-.432a.083.083 0 01.096-.055zm-.844-.453c.034-.02.045-.062.024-.099a.083.083 0 00-.107-.029l-.408.203a.08.08 0 00-.03.117.099.099 0 00.13.031l.391-.223zm-.166-1.069a.07.07 0 01-.086.053l-.435-.119a.099.099 0 01-.068-.124.08.08 0 01.102-.05l.432.144c.04.014.064.055.055.096zm.453-.844a.07.07 0 00.099.024.083.083 0 00.029-.107l-.203-.408a.08.08 0 00-.117-.03.099.099 0 00-.031.13l.223.391z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="PK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M5 0h15v15H5V0z" fill="#2F8D00" />
        <path d="M0 0h5v15H0V0z" fill="#F7FCFF" />
        <path
          d="M14.018 9.566s-2.79.728-5.006-.756C6.796 7.325 7.91 3.905 7.91 3.905c-1.155.168-2.97 4.384-.045 6.499 2.925 2.114 5.728.082 6.153-.838zm-3.097-4.024l-1.482.724 1.564.279.21 1.528.886-1.302 1.743.118-1.365-1.018.727-1.36-1.36.622-1.009-.949.086 1.358z"
          fill="#F1F9FF"
        />
      </g>
    </symbol>
    <symbol id="PL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 7.5V15h20V7.5H0z"
            fill="#C51918"
          />
        </g>
      </g>
    </symbol>
    <symbol id="PM" width="20" height="15" fill="none">
      <path fill="#C00" d="M0 0h5v5H0z" />
      <path d="M5 .65V0h-.612L0 4.35V5h.611L5 .65z" fill="#08672F" />
      <path d="M0 .65V0h.611L5 4.35V5h-.624L0 .65z" fill="#08672F" />
      <path d="M0 2.005L5 2v.995L0 3v-.995z" fill="#fff" />
      <path d="M2 0h.995L3 5h-.995L2 0zM0 5h5v5H0V5z" fill="#fff" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.24 5.573a.18.18 0 01.006-.054c.01-.02.028-.02.036.002a.63.63 0 01.012.09.515.515 0 00.057.208c.025.051.045.08.107.157l.033.04-.061-.001a.352.352 0 01-.074-.008c-.01-.005-.012 0-.015.031-.003.042-.021.074-.05.09-.017.01-.023.01-.038-.002a.145.145 0 01-.052-.09c-.005-.028-.006-.03-.02-.023a.317.317 0 01-.123.005c0-.003.017-.026.038-.05a.61.61 0 00.144-.395zM.586 7.503a.132.132 0 01.025-.052c.022-.026.042-.032.031-.01-.016.038-.012.07.015.105a.13.13 0 01.015.135C.65 7.723.6 7.725.57 7.683.546 7.65.545 7.612.566 7.565a.361.361 0 00.02-.062zm2.445-.04a.131.131 0 01.025-.052c.022-.026.041-.032.03-.01a.1.1 0 00.015.105c.03.04.037.095.016.134-.023.043-.072.044-.102.003-.024-.033-.026-.072-.005-.118a.362.362 0 00.021-.063zm-1.235.024a.132.132 0 01.025-.052c.022-.025.041-.031.03-.01a.1.1 0 00.015.105c.03.041.037.096.016.135-.023.042-.072.044-.102.003-.024-.033-.025-.072-.005-.119a.364.364 0 00.021-.062zm2.329.173c-.033.025-.069.031-.095.017-.021-.012-.023-.005-.006.019a.094.094 0 00.047.028.722.722 0 01.065.023c.044.02.084.018.113-.002.06-.04.02-.111-.06-.11a.098.098 0 00-.064.025zm.178.083a.182.182 0 00-.007.054.61.61 0 01-.144.395.321.321 0 00-.038.05c0 .008.11.004.124-.005.013-.007.015-.005.02.023a.145.145 0 00.05.09c.016.012.022.012.039.002.029-.015.047-.048.05-.09.003-.03.006-.036.016-.03.006.003.04.006.073.007l.061.002-.033-.04a.73.73 0 01-.107-.157.524.524 0 01-.057-.21.63.63 0 00-.012-.089c-.007-.021-.026-.022-.035-.002zm-2.395-.058a.093.093 0 00-.034.026c-.04.059.054.12.12.08.072-.044.074-.044.109-.032.03.01.03.01.025-.003-.012-.024-.03-.035-.102-.06-.082-.027-.085-.027-.118-.01zm-.374.04c.027.015.062.01.095-.016a.098.098 0 01.064-.025c.081-.001.12.07.06.11-.029.02-.068.021-.113.002a.72.72 0 00-.065-.023.094.094 0 01-.047-.028c-.017-.024-.015-.03.006-.02zm.273.067a.181.181 0 00-.006.054.61.61 0 01-.145.395.322.322 0 00-.038.05c0 .008.11.004.125-.005.013-.007.014-.005.019.023a.145.145 0 00.051.09c.016.012.022.012.038.002.03-.015.048-.048.05-.09.004-.03.006-.036.016-.03a.35.35 0 00.073.007l.062.002-.033-.04a.728.728 0 01-.107-.157.524.524 0 01-.057-.21.632.632 0 00-.012-.089c-.008-.021-.026-.022-.036-.002zm1.336-.132a.094.094 0 00-.034.026c-.04.059.054.12.12.08.072-.043.074-.044.109-.032.03.01.03.01.025-.003-.012-.024-.03-.034-.102-.06-.082-.027-.085-.027-.118-.01zm-.374.041c.026.015.062.008.095-.017a.098.098 0 01.064-.025c.081-.001.12.07.06.11-.03.02-.069.021-.113.002a.717.717 0 00-.065-.022.094.094 0 01-.047-.029c-.017-.023-.015-.03.006-.019zm.273.067a.181.181 0 00-.007.054.61.61 0 01-.144.394.322.322 0 00-.038.05c0 .008.11.004.124-.005.013-.007.015-.005.02.023a.145.145 0 00.051.09c.016.012.021.012.038.003.029-.016.047-.049.05-.09.003-.031.006-.037.016-.031a.35.35 0 00.073.007l.062.002-.033-.04a.73.73 0 01-.108-.157.524.524 0 01-.057-.21.633.633 0 00-.011-.089c-.008-.02-.026-.022-.036-.001zM.698 7.7a.094.094 0 00-.034.026c-.04.058.054.12.12.08.072-.044.075-.045.11-.033.029.01.03.01.024-.002-.012-.024-.03-.035-.102-.06C.735 7.683.732 7.683.698 7.7zm1.053-2.133a.181.181 0 00-.007.054.61.61 0 01-.144.394.323.323 0 00-.038.05c0 .009.11.005.124-.004.013-.008.015-.005.02.022a.145.145 0 00.051.091c.016.011.021.012.038.002.029-.016.047-.048.05-.09.003-.03.006-.036.016-.03a.35.35 0 00.073.007l.061.002-.032-.041a.729.729 0 01-.108-.157.524.524 0 01-.057-.209.629.629 0 00-.011-.09c-.008-.02-.026-.022-.036-.001zm1.228.03c0-.022.003-.046.007-.055.01-.02.028-.02.035.002.004.01.01.05.012.09a.536.536 0 00.057.209c.025.05.045.08.107.156l.033.04-.061-.001a.35.35 0 01-.073-.008c-.01-.005-.013 0-.016.032-.003.04-.021.074-.05.09-.017.01-.023.008-.038-.002a.145.145 0 01-.051-.092c-.005-.027-.007-.03-.02-.022a.317.317 0 01-.124.005c0-.003.017-.026.038-.05a.61.61 0 00.144-.395zM.554 5.582a.181.181 0 00-.006.055.657.657 0 01-.041.218l.002.244a.145.145 0 00.052.09c.015.012.02.012.038.003.029-.016.047-.049.05-.09.003-.031.006-.037.015-.031.007.003.04.006.074.007l.061.002-.033-.04a.729.729 0 01-.107-.157.524.524 0 01-.057-.21.63.63 0 00-.012-.089c-.008-.021-.026-.022-.036-.002zM3.69 8.6a.132.132 0 01.025-.052c.022-.026.04-.032.03-.01-.016.037-.012.07.015.105.03.04.037.095.015.135-.022.042-.072.044-.102.002-.024-.033-.025-.072-.004-.118a.363.363 0 00.02-.062zm.112.198a.094.094 0 00-.034.026c-.04.058.054.12.12.08.072-.044.074-.045.108-.033.03.01.031.01.025-.003-.012-.023-.03-.034-.102-.059-.081-.028-.084-.028-.117-.011zm-.375.04c.027.015.063.009.096-.016a.098.098 0 01.064-.025c.08-.002.12.069.06.11-.03.02-.069.02-.113.002a.723.723 0 00-.066-.023.094.094 0 01-.046-.028c-.017-.024-.015-.031.005-.02zm.287.061a.178.178 0 00-.007.054.601.601 0 01-.144.39.319.319 0 00-.038.05c0 .008.11.004.124-.005.013-.007.015-.005.02.023a.143.143 0 00.05.09c.016.01.022.011.039.002.029-.016.047-.048.05-.09.003-.03.006-.035.016-.03.006.003.04.006.073.007l.061.002-.033-.04a.72.72 0 01-.107-.155.515.515 0 01-.057-.207.622.622 0 00-.012-.089c-.007-.021-.026-.022-.035-.002zm-2.52-.25a.132.132 0 01.025-.052c.022-.026.041-.032.03-.01a.1.1 0 00.015.105c.03.04.037.095.016.135-.023.042-.072.044-.102.002-.024-.033-.026-.072-.005-.118a.361.361 0 00.021-.062zm.112.198a.094.094 0 00-.034.026c-.04.058.054.12.12.08.072-.044.074-.045.109-.033.03.01.03.01.025-.003-.012-.023-.03-.034-.102-.059-.082-.028-.085-.028-.118-.011zm-.374.04c.026.015.062.009.095-.016a.098.098 0 01.064-.025c.081-.002.12.069.06.11-.03.02-.069.02-.113.002a.724.724 0 00-.065-.023.094.094 0 01-.047-.029c-.017-.023-.015-.03.006-.019zm.287.061a.178.178 0 00-.007.054.601.601 0 01-.144.39.319.319 0 00-.038.05c0 .008.11.004.124-.005.013-.007.015-.005.02.023a.143.143 0 00.05.09c.016.01.022.011.039.002.029-.016.047-.048.05-.09.003-.03.006-.036.016-.03.006.003.04.006.073.007l.061.002-.033-.04a.722.722 0 01-.107-.155.515.515 0 01-.057-.207.62.62 0 00-.012-.09c-.007-.02-.025-.021-.035 0zm1.21-.324a.131.131 0 01.025-.052c.022-.026.041-.031.03-.01a.097.097 0 00.015.105c.03.041.037.096.016.135-.023.042-.072.044-.102.002-.024-.033-.026-.071-.005-.118a.365.365 0 00.02-.062zm.112.198a.094.094 0 00-.034.026c-.04.059.054.12.12.08.072-.044.074-.045.109-.032.03.01.03.01.025-.003-.013-.024-.031-.035-.102-.06-.082-.028-.085-.027-.118-.011zm-.374.04c.026.015.062.01.095-.016a.098.098 0 01.064-.025c.081-.001.12.07.06.11-.03.02-.069.021-.113.002a.722.722 0 00-.065-.023.094.094 0 01-.047-.028c-.017-.024-.015-.03.006-.02zm.286.061a.178.178 0 00-.006.054.601.601 0 01-.145.39.32.32 0 00-.037.05c0 .009.11.004.124-.005.013-.007.014-.004.02.023a.143.143 0 00.05.09c.016.01.022.012.038.002.03-.016.048-.048.05-.089.004-.03.007-.036.016-.03.007.002.04.005.073.006l.062.003-.033-.04a.721.721 0 01-.107-.156.515.515 0 01-.057-.207.618.618 0 00-.012-.089c-.008-.02-.026-.022-.036-.002zm1.193-2.577a.132.132 0 01.025-.052c.022-.025.042-.031.031-.01-.016.038-.012.07.014.106.03.04.037.095.016.134-.023.043-.072.044-.102.003-.024-.033-.025-.072-.004-.118a.36.36 0 00.02-.063zm.112.198a.094.094 0 00-.034.026c-.04.059.054.12.12.08.072-.043.075-.044.11-.032.029.01.03.01.024-.003-.012-.024-.03-.034-.102-.06-.081-.027-.084-.027-.118-.01zm-.374.04c.027.016.062.01.096-.016a.098.098 0 01.063-.025c.081-.001.12.07.06.11-.029.02-.068.021-.112.002a.714.714 0 00-.066-.022.094.094 0 01-.046-.029c-.018-.023-.016-.03.005-.02zm.273.068a.181.181 0 00-.006.054.61.61 0 01-.145.394.321.321 0 00-.037.05c0 .008.11.004.124-.005.013-.007.014-.005.019.023a.145.145 0 00.051.09c.016.012.022.012.038.003.03-.016.048-.049.05-.09.004-.031.007-.037.016-.031a.35.35 0 00.073.007l.062.002-.033-.04a.729.729 0 01-.107-.157.523.523 0 01-.057-.21.63.63 0 00-.012-.089c-.008-.021-.026-.022-.036-.001zm-2.506-.257a.131.131 0 01.025-.052c.022-.025.041-.031.03-.01-.016.038-.012.07.015.106.03.04.037.095.016.134-.023.043-.072.044-.102.003-.024-.033-.026-.072-.005-.118a.361.361 0 00.02-.063zm.112.198a.094.094 0 00-.034.026c-.04.059.054.12.12.08.072-.043.074-.044.109-.032.029.01.03.01.024-.003-.012-.024-.03-.034-.101-.06-.082-.027-.085-.027-.118-.01zm-.374.04c.026.015.062.01.095-.016a.098.098 0 01.064-.025c.08-.001.12.07.06.11-.03.02-.069.021-.113.002a.719.719 0 00-.065-.022.094.094 0 01-.047-.029c-.017-.023-.015-.03.006-.02zm.273.067a.181.181 0 00-.007.055.61.61 0 01-.144.394.321.321 0 00-.038.05c0 .008.11.004.124-.005.013-.007.015-.005.02.023a.145.145 0 00.05.09c.016.012.022.012.039.003.029-.016.047-.049.05-.09.003-.031.006-.037.016-.031.006.003.04.006.073.007l.061.002-.033-.04A.729.729 0 011.266 7a.524.524 0 01-.057-.21.633.633 0 00-.012-.089c-.007-.021-.026-.022-.035-.002zm1.224-.33a.131.131 0 01.025-.051c.022-.026.04-.032.03-.01-.016.037-.012.07.015.105.03.04.037.095.015.134-.022.043-.072.044-.102.003-.024-.033-.025-.072-.004-.118a.363.363 0 00.02-.062zm.112.199a.094.094 0 00-.034.025c-.04.06.054.12.12.08.072-.043.074-.044.108-.032.03.01.031.01.025-.003-.012-.023-.03-.034-.102-.06-.081-.027-.084-.027-.117-.01zm-.375.04c.027.015.063.009.096-.017a.098.098 0 01.064-.025c.08 0 .12.07.06.11-.03.02-.069.021-.113.002a.718.718 0 00-.066-.022.094.094 0 01-.046-.029c-.017-.023-.015-.03.005-.019zm.273.067a.181.181 0 00-.006.054.61.61 0 01-.144.394.32.32 0 00-.038.05c0 .009.11.004.124-.005.013-.007.014-.005.02.023a.145.145 0 00.05.091c.016.01.022.012.039.002.029-.016.047-.049.05-.09.003-.03.006-.037.015-.031a.35.35 0 00.074.007l.061.002-.033-.04a.73.73 0 01-.107-.157.524.524 0 01-.057-.21.63.63 0 00-.012-.088c-.007-.022-.026-.023-.036-.002zM.59 7.867c0-.021.003-.045.006-.054.01-.02.028-.02.036.002.003.01.009.05.012.09a.52.52 0 00.057.209.73.73 0 00.107.156l.033.041-.062-.002A.351.351 0 01.705 8.3c-.01-.005-.012 0-.015.032-.003.041-.022.074-.05.09-.017.01-.023.008-.039-.002a.145.145 0 01-.05-.091l-.003-.244a.657.657 0 00.04-.219z"
        fill="#000"
      />
      <path d="M0 15h5v-5H0v5z" fill="#C00" />
      <path d="M5 0h15v15H5V0z" fill="#0092C8" />
      <path
        d="M1.669 11.346c-.048-.058-.001-.164.042-.119-.023-.043.014-.078.03-.056-.008-.035.027-.058.045-.026-.007-.04.045-.062.059-.02 0-.038.051-.069.062-.012.01-.043.067-.05.071.013.017-.036.06-.034.062.019.018-.025.065.012.057.056.03-.007.065.055.03.101.063-.035.078.08.04.132.02.013.02.002.038.011a.35.35 0 00.079.032c.026 0 .122-.003.142-.006.02-.003.047-.014.079-.026.033-.011.082-.012.127-.023.035-.004 1.024.017 1.053.014.028-.003.07-.032.067-.067-.002-.035-.035-.061-.067-.064a1.886 1.886 0 00-.232.003.21.21 0 00-.097.045c-.01.007-.028.034-.042.052-.014.012-.053.014-.053-.002 0-.01-.003.002-.013.006-.012.008-.068.01-.066 0 .004-.012 0-.016-.015-.003a.186.186 0 01-.103.003c.009-.015.009-.014-.014-.002-.015.007-.076.013-.08 0 0-.01-.008-.006-.016-.003-.07.02-.076-.003-.065-.012.01-.01.027-.065.01-.062a5.514 5.514 0 01-.164.032c-.038.007-.307 0-.344-.003-.037-.003-.079-.04-.081-.092-.004-.085.061-.106.1-.119a.861.861 0 01.178-.031c.04 0 .152.014.182.001.031-.012.124-.048.15-.05.04-.005.15.01.203.076-.027.014-.04.021-.009.01l.18-.04c.098-.005.072.01.024.023-.016.054-.161.13-.207.14a.648.648 0 01-.166-.002c-.021-.002-.125-.007-.163-.033a.474.474 0 00-.223-.071c-.046 0-.177.015-.177.064 0 .084.123.089.175.086.053-.003.184-.01.221-.026a.532.532 0 01.162-.02c.044 0 .108.01.127.008.02-.004.066-.004.088-.02a.222.222 0 01.118-.033c.048 0 .405-.015.453-.011.07 0 .12.08.12.148 0 .032-.014.079-.027.086.022.002.076.009.094.013.033.007.087.046.094.081a.25.25 0 00-.104-.044h-.849a.44.44 0 01.326.233c.029.048.099.029.125.022.026-.006.057-.035.079-.057.022-.023.056-.028.071-.023.034-.003.04.036.027.055-.013.019.003.011.038.011a.1.1 0 01.086.043c-.02.019-.03.003-.001.006.028.004.063.059.042.074-.019.01-.024.006 0 .01.035.003.045.027.05.07-.03.007-.015-.003 0 .012.015.016.038.087-.018.09-.02-.01-.019-.012-.015.01.004.023-.006.076-.037.076-.043.009-.081-.016-.085-.045-.005-.028-.004.056-.064.07-.057.012-.088-.022-.092-.038-.004-.016-.002-.003-.024-.006s-.05-.004-.061-.042c0-.022.004-.051.043-.055.018-.004.022-.028.01-.03-.014-.004-.003-.052.026-.04.028.014.094.017.109.033s.02-.013-.004-.038c-.024-.026-.171-.077-.21-.058a.528.528 0 01-.272.035c-.026-.006-.102.011-.138-.105a.255.255 0 00-.19-.184c-.248-.025-.234-.006-.073.002-.002.022-.007.068.019.074.044-.006.135-.026.157-.007.021.019.043.035.039.08-.004.044.002.032-.018.05-.02.02-.01.058.02.071.03.013.044.029.064.048.02.019-.01.057-.027.045-.017-.013-.017-.013-.02.012-.002.026-.023.074-.06.078-.008-.003-.006-.017-.005-.027.002-.022-.007.028-.019.042-.007.01-.07.028-.087.018.008-.02.004-.012-.012-.002-.015.006-.095.018-.06-.022.01-.015-.012.018-.024.024-.01.006-.058.01-.058-.008-.016.014-.052.014-.057.003-.011-.013-.012.01-.032.013-.02.003-.063-.004-.065-.03-.002-.025.005-.009-.02-.006-.058.041-.087-.016-.087-.035 0-.019-.002-.041.004-.054.007-.013-.04-.017-.026-.042.016-.03.034-.053.066-.047.015.003.013-.007.006-.02-.006-.012.018-.019.046-.006.029.013.048.045.057.073.009.03.077.007.105.01.029.003.03-.048.013-.064s-.065-.073-.085-.092c-.02-.02-.006-.087.011-.103.102-.072.046-.095.009-.089a.395.395 0 00-.164.082c-.03.035-.268.207-.29.226-.022.02-.054.024-.067.002-.013-.023-.022-.007-.02.025.017.12-.085.16-.103.158a.088.088 0 01-.044-.02c-.013.067-.069.074-.12.067 0-.008.01-.023.004-.017-.017.023-.069.02-.113.017-.003-.014.015-.031.006-.021-.015.03-.04.024-.082.02 0-.005.02-.026.01-.014-.018.021-.056.015-.086.015-.003-.005.016-.038-.002-.016-.016.019-.05.022-.084.017-.006-.016.007-.016.01-.026.01-.016-.004 0-.015 0-.01 0-.026.003-.032-.012-.007-.017-.003.015-.01.024-.006.008-.013.025-.035.032-.022.006-.079.013-.088-.016-.011-.013-.017-.042-.008-.058.008-.016-.042.031-.064.035-.064.014-.072-.092-.044-.102.029-.01.024-.025.01-.038-.016-.013-.025-.064-.005-.08s.065-.025.094-.006c.017.012.053.054.046.022-.005-.02.007-.044.021-.055.013-.012.05-.015.06.01.023.06.04.084.068.083a1.07 1.07 0 01.166-.037c.031-.008.195-.024.195-.04-.098.035-.138-.011-.149-.008-.01.003-.038-.01-.038-.02 0-.018.025-.016-.01-.01-.021-.001-.04-.002-.057-.025-.003-.012.023-.053.032-.087-.022-.006-.072.037-.089.075-.011-.015-.016-.002-.057.009a.088.088 0 01-.068-.004c-.018-.01-.086-.064-.053-.072l-.025-.009c-.025-.01-.047-.031-.04-.037-.006-.01.007-.01-.003-.012-.013-.003-.045-.028-.037-.037-.008-.006-.028-.015-.036-.02-.016-.01-.031-.042-.033-.058-.014.001-.045-.027-.031-.036-.023-.018-.043-.047-.027-.057-.014-.01-.023-.031-.014-.024-.014-.018-.01-.037.002-.037.01 0 .006-.05-.014-.05s-.05.015-.074 0c-.019-.016-.035-.084-.017-.112.017-.03.052-.061.07-.058.017.003.008.01.004-.02-.004-.028.025-.05.044-.057.023-.01.068-.003.08.01.014.013.018.013.018-.01 0-.015.017-.024.032-.028.025-.006.045.002.054.013.013.02.022.044.004.063-.018.02-.002.003.026-.003.018-.006.052.002.057.023.008.022.013.06-.006.08-.02.019-.049.066-.033.082.015.016.063.086.074.096.011.01.024.032.042.029l.052-.01c.061-.013.089-.02.01-.017.018-.026.055-.034.07-.038-.013-.022.039-.07.039-.076zm0 1.74c-.048-.058-.001-.164.042-.119-.023-.043.014-.078.03-.056-.008-.035.027-.059.045-.026-.007-.04.045-.062.059-.02 0-.038.051-.069.062-.012.01-.044.067-.05.071.013.017-.036.06-.034.062.019.018-.025.065.012.057.056.03-.007.065.055.03.101.063-.035.078.08.04.132.02.013.02.002.038.011a.35.35 0 00.079.032c.026 0 .122-.003.142-.006.02-.003.047-.014.079-.026.033-.011.082-.012.127-.023.035-.004 1.024.017 1.053.014.028-.003.07-.032.067-.067-.002-.036-.035-.061-.067-.064a1.905 1.905 0 00-.232.003.21.21 0 00-.097.045c-.01.007-.028.034-.042.052-.014.012-.053.014-.053-.002 0-.01-.003.002-.013.006-.012.008-.068.01-.066 0 .004-.012 0-.016-.015-.003a.186.186 0 01-.103.003c.009-.015.009-.014-.014-.002-.015.007-.076.013-.08 0 0-.01-.008-.006-.016-.003-.07.02-.076-.003-.065-.012.01-.01.027-.065.01-.062a5.514 5.514 0 01-.164.032c-.038.007-.307 0-.344-.003-.037-.003-.079-.04-.081-.092-.004-.085.061-.106.1-.119a.861.861 0 01.178-.032c.04 0 .152.015.182.002.031-.012.124-.048.15-.05.04-.005.15.01.203.076-.027.014-.04.021-.009.01l.18-.04c.098-.005.072.01.024.024-.016.053-.161.129-.207.139a.648.648 0 01-.166-.002c-.021-.002-.125-.007-.163-.033a.473.473 0 00-.223-.071c-.046 0-.177.015-.177.064 0 .084.123.089.175.086.053-.003.184-.01.221-.026a.532.532 0 01.162-.02c.044 0 .108.01.127.008.02-.004.066-.004.088-.02a.222.222 0 01.118-.033c.048 0 .405-.015.453-.011.07 0 .12.08.12.148 0 .032-.014.079-.027.086.022.002.076.009.094.013.033.007.087.046.094.081a.25.25 0 00-.104-.044h-.849a.44.44 0 01.326.233c.029.048.099.029.125.022.026-.006.057-.035.079-.057.022-.023.056-.028.071-.023.034-.003.04.036.027.055-.013.019.003.011.038.011a.1.1 0 01.086.043c-.02.019-.03.003-.001.006.028.004.063.059.042.074-.019.01-.024.006 0 .01.035.003.045.027.05.07-.03.007-.015-.003 0 .012.015.016.038.087-.018.09-.02-.01-.019-.012-.015.01.004.023-.006.076-.037.076-.043.009-.081-.016-.085-.045-.005-.028-.004.056-.064.07-.057.012-.088-.022-.092-.038-.004-.016-.002-.003-.024-.006s-.05-.004-.061-.042c0-.022.004-.051.043-.055.018-.004.022-.028.01-.03-.014-.004-.003-.052.026-.04.028.014.094.017.109.033s.02-.013-.004-.038c-.024-.026-.171-.077-.21-.058a.528.528 0 01-.272.035c-.026-.006-.102.011-.138-.105a.255.255 0 00-.19-.184c-.248-.025-.234-.006-.073.002-.002.022-.007.068.019.074.044-.006.135-.026.157-.007.021.019.043.035.039.08-.004.044.002.031-.018.05-.02.02-.01.058.02.071.03.013.044.029.064.048.02.019-.01.057-.027.045-.017-.013-.017-.013-.02.012-.002.026-.023.074-.06.078-.008-.003-.006-.016-.005-.027.002-.022-.007.028-.019.042-.007.01-.07.028-.087.018.008-.02.004-.012-.012-.002-.015.006-.095.018-.06-.022.01-.015-.012.018-.024.024-.01.006-.058.01-.058-.008-.016.014-.052.014-.057.003-.011-.013-.012.01-.032.013-.02.003-.063-.004-.065-.03-.002-.025.005-.009-.02-.006-.058.041-.087-.016-.087-.035 0-.019-.002-.041.004-.054.007-.013-.04-.017-.026-.042.016-.03.034-.053.066-.047.015.003.013-.007.006-.02-.006-.012.018-.019.046-.006.029.013.048.045.057.073.009.03.077.007.105.01.029.003.03-.048.013-.064s-.065-.073-.085-.092c-.02-.02-.006-.087.011-.103.102-.072.046-.095.009-.089a.393.393 0 00-.164.082c-.03.035-.268.207-.29.226-.022.02-.054.024-.067.002-.013-.023-.022-.007-.02.025.017.12-.085.16-.103.158a.088.088 0 01-.044-.02c-.013.067-.069.074-.12.067 0-.008.01-.023.004-.017-.017.023-.069.02-.113.017-.003-.014.015-.031.006-.021-.015.03-.04.024-.082.02 0-.005.02-.026.01-.014-.018.021-.056.015-.086.015-.003-.005.016-.038-.002-.016-.016.019-.05.022-.084.017-.006-.016.007-.016.01-.026.01-.016-.004 0-.015 0-.01 0-.026.003-.032-.013-.007-.015-.003.016-.01.025-.006.008-.013.025-.035.032-.022.006-.079.012-.088-.016-.011-.013-.017-.042-.008-.058.008-.016-.042.031-.064.035-.064.014-.072-.092-.044-.102.029-.01.024-.025.01-.038-.016-.013-.025-.064-.005-.08s.065-.025.094-.006c.017.012.053.054.046.022-.005-.02.007-.044.021-.055.013-.012.05-.015.06.01.023.06.04.084.068.083a1.07 1.07 0 01.166-.037c.031-.008.195-.025.195-.04-.098.035-.138-.011-.149-.008-.01.003-.038-.01-.038-.02 0-.018.025-.016-.01-.01-.021-.001-.04-.002-.057-.025-.003-.012.023-.053.032-.087-.022-.006-.072.037-.089.075-.011-.015-.016-.002-.057.009a.088.088 0 01-.068-.004c-.018-.01-.086-.064-.053-.072l-.025-.009c-.025-.01-.047-.031-.04-.037-.006-.01.007-.01-.003-.012-.013-.003-.045-.028-.037-.037-.008-.006-.028-.015-.036-.02-.016-.01-.031-.042-.033-.058-.014.001-.045-.027-.031-.036-.023-.018-.043-.047-.027-.057-.014-.01-.023-.031-.014-.024-.014-.018-.01-.037.002-.037.01 0 .006-.05-.014-.05s-.05.015-.074 0c-.019-.016-.035-.084-.017-.112.017-.03.052-.061.07-.058.017.003.008.01.004-.02-.004-.028.025-.05.044-.057.023-.01.068-.003.08.01.014.013.018.013.018-.01 0-.015.017-.024.032-.028.025-.006.045.002.054.012.013.021.022.045.004.064-.018.02-.002.003.026-.003.018-.006.052.002.057.023.008.022.013.06-.006.08-.02.019-.049.066-.033.082.015.016.063.086.074.096.011.01.024.032.042.029l.052-.01c.061-.013.089-.02.01-.017.018-.026.055-.034.07-.038-.013-.022.039-.07.039-.076z"
        fill="#FFCF00"
        stroke="#650000"
        stroke-width=".08"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.278 1.936c.233-.058.607-.076.808-.042.04.008.113.015.186.022.119.011.238.022.22.039-.042.04-.185.42-.185.494 0 .027.945.682.984.682.053 0 .132.095.111.132-.01.016-.069.077-.13.132-.058.055-.152.338-.242.653a.839.839 0 01.206-.169 80.821 80.821 0 001.707-1.295c.04-.03-.061-.048-.27-.045a2.285 2.285 0 00-.524.071c-.281.07-.491-.148-.581-.242a.356.356 0 00-.04-.038c-.079-.053-.192-.217-.192-.277 0-.014.077-.003.177.023.232.067.438.064.701-.005.238-.06.491-.074.758-.042l.034.005c.048.008.08.013.098.013.017.114.131.486.152.503.043.037.974.404 1.045.412.106.013.148.055.148.145 0 .088-.108.17-.261.199-.18.034-.628.552-.942 1.086-.211.36-.327.627-.327.756 0 .132.079.637.16 1.02.05.228.064.267.09.23.03-.037.109-.042.636-.042h.607L17.618 6a4.11 4.11 0 00.198-.367 11.958 11.958 0 00-.684-.056 19.28 19.28 0 01-.68-.05c-.003-.005.126-.246.287-.537l.293-.528.596.1.186.032.484.082c.058.01.08 0 .127-.082a.503.503 0 00.033-.073v.012c-.007.171-.024.605-.21.962l-.456.87v.6h-.106a.56.56 0 00-.105.005l.02.124.02.106a.88.88 0 01.023.215c-.008.013-.076.024-.15.024l-.137.002-.077.2c-.135.3-.48.857-.773 1.246l-.063.082.148.069c.208.095.424.322.567.597.11.217.116.233.116.463 0 .224-.061.512-.111.515a89.6 89.6 0 01-.637.098h-.002l-.29.045c-.5.076-.923.135-.941.13-.056-.022-.188-.244-.232-.39l-.018-.053a2.17 2.17 0 00-.038-.115c-.005-.022-.108.015-.32.124a4.3 4.3 0 01-1.065.383 4.662 4.662 0 01-2.588-.159 7.57 7.57 0 01-1.05-.52c-.487-.302-.688-.479-1.503-1.333-.264-.274-.332-.33-.512-.42-.182-.09-.235-.103-.393-.103-.148 0-.187-.008-.219-.05-.066-.093-.04-.201.087-.339 0 0 .04-.088.026-.097l-.309-.201c-.237-.122.624-1.555.98-1.93.174-.185.182-.196.182-.322 0-.254.16-.754.332-1.045.08-.132.087-.156.06-.216-.05-.111 0-.175.323-.405.638-.457 1.01-.737 1.02-.769.019-.058-.258-.037-.472.037-.427.15-.812.185-.997.09-.084-.042-.214-.19-.214-.246 0-.008.087-.008.196 0 .08.006.064-.126.051-.24-.005-.041-.01-.08-.01-.109 0-.037.003-.066.009-.066l.082.03.029.01c.187.066.472.05.836-.05.18-.05.406-.098.501-.109 0 0 .538-.1.459-.016-.042.045-.087.159-.13.32a6.034 6.034 0 00-.063.254l.082.016.53.108c.401.082.636.119.694.108.1-.02.164.022.164.109 0 .074-.053.119-.264.217a2.245 2.245 0 00-.33.2 4.791 4.791 0 00-.773.81c-.137.195-.137.195-.137.399 0 .222.053.56.121.793l.043.145.073-.198a3.14 3.14 0 01.407-.775c.118-.164.14-.209.105-.222-.055-.021 0-.235.048-.264.047-.03.364-.31.701-.627l.612-.576V2.92c0-.148.003-.154.082-.17.045-.007.127-.015.18-.015.076-.003.124-.03.253-.146.084-.08.147-.153.134-.164a.787.787 0 00-.234-.029c-.172-.008-.288.008-.562.072-.388.092-.578.1-.757.04-.124-.043.06-.117.176-.149 0 0-.274-.473-.232-.46.364.111.515.117.829.037zm6.189 2.525c-.005-.014-.007.01-.009.059.01-.026.013-.048.009-.06zm-2.356-2.443c-.01-.01-.01.003-.007.03.025 0 .026-.008.007-.03zm-2.118 2.16c-.115.417-.216.843-.216.843l.092-.2c.05-.112.124-.564.124-.632v-.01zm.236-.952l-.002-.001.002.001zm-.002-.001a162.23 162.23 0 01-.965-.675l-.031.105c-.03.1.744.454.949.548.024.012.04.02.047.022zm-3.426-.21c.554.114.565.116.462.145l-.265.076-.323.09-.512.144.018-.072c.058-.243.127-.478.14-.478.01 0 .224.042.48.095zm-.923.534l.053-.19.066-.223c.008-.015.008-.031.005-.031-.008 0-.863.626-.884.645a.703.703 0 00.17-.037c.1-.03.274-.08.384-.109l.206-.055zm3.854 1.591l-.066.217c-.08.27-.135.537-.177.864-.026.212-.047.273-.137.42a1.948 1.948 0 00-.13.25c-.07.161-.077.046-.089-.323a4.595 4.595 0 01.098-1.177c.055-.25.396-.468.432-.39l.069.14zm-3.326.857c.02-.09.013-.146-.04-.302a2.852 2.852 0 01-.148-.692c.005-.264-.022-.281-.121-.03-.169.379-.206.543-.206.934 0 .214.013.402.035.468.029.1.042.113.11.113h.08v.33c0 .276-.006.331-.04.331-.056 0-.05.03.029.217.127.304.791 1.012.725.883-.216-.447-.527-1.354-.477-1.858.016-.156.04-.336.053-.394zm5.655.48c.035.136.035.16-.013.297l-.017.05c-.031.094-.079.238-.136.301-.124.138-.127.14-.158.082-.127-.24-.174-.85-.095-1.266.034-.182.169-.669.184-.669.006 0 .022.098.04.217.034.243.137.767.195.989zm-7.752-.84l.171.584s-.235-.489-.24-.539l.069-.045zm1.543.828c0 .013-.108.023-.24.023h-.24l-.657.01c.004-.016.188-.092.401-.18l.13-.054c.247.013.491.029.516.06.05.067.09.13.09.14zm-.606-.2l-.099-.006c-.215-.01-.41-.02-.432-.038l.77-.156.293-.06c-.01.039-.271.151-.532.26zm-.49.884l-.17-.27c0-.219-.011-.298-.059-.41a.692.692 0 00-.084-.167c-.004 0-.037.124-.085.308l-.118.447-.198.724.08.029c.044.016.2.098.345.185.147.087.287.159.311.159.084 0 .095-.109.042-.333a2.346 2.346 0 01-.058-.44l-.005-.232zm4.778.22c.06.306.172.594.343.896.082.142.145.264.14.27a.973.973 0 01-.32.052c-.036-.024-.184-.343-.284-.618-.114-.31-.216-.738-.198-.817.008-.037.066-.17.127-.294l.108-.224.02.259c.011.143.038.357.064.476zm2.103.037c.005-.045-.024-.072-.127-.125-.137-.068-.504.157-.504.157.085.174.314.478.375.478.015 0 .118-.08.232-.177.219-.19.242-.254.103-.267-.071-.008-.085-.019-.08-.066zm-.33.576l-.069.047c-.092.064-.699.363-.712.352-.005-.005.06-.243.143-.529l.128-.185c.027.051.102.07.18.088.068.017.137.034.177.074l.153.153zm-1.208.473A6.3 6.3 0 0014.257 8c.074-.238-.169-.055-.2.159-.019.14.007.33.042.296zm-2.876-.473c-.06.188-.121.354-.132.365-.01.013-.066 0-.123-.03-.088-.044-.109-.07-.138-.187-.031-.13-.031-.14.035-.254a.571.571 0 01.348-.275c.142-.034.15-.034.137.003a9.508 9.508 0 00-.078.232l-.049.146zm.863.38a2.273 2.273 0 01-.187-.489c-.037-.18-.056-.219-.103-.232-.106-.03-.116-.016-.185.214l-.085.274-.05.16-.063.203.27.056c.144.029.326.063.403.07l.137.017-.137-.272zm.293-.5l.274.133-.121.138a.984.984 0 00-.166.259.723.723 0 01-.061.14c-.048.053-.343-.635-.343-.796 0-.055.098-.024.417.127zm.85.794l.329-.024c.053-.005-.335-.299-.625-.476a1.649 1.649 0 00-.19-.108c-.005 0-.058.053-.116.116a.862.862 0 00-.225.402l-.015.082.269.016c.147.008.406.002.572-.008z"
        fill="#FFCF00"
      />
      <path
        d="M13.086 1.894l.039-.196-.005-.001-.034.197zm-.808.042l-.048-.194.048.194zm.994-.02l-.018.2.018-.2zm.22.039l-.135-.148-.002.002.137.146zm.91 1.308l.167.112.007-.013-.174-.099zm-.13.132l-.134-.147h-.001l.136.147zm-.242.653l-.192-.055.354.172-.162-.117zm.206-.169l-.112-.166.112.166zm1.707-1.295l-.119-.161-.006.004.125.157zm-.27-.045l-.002-.2.003.2zm-.524.071l-.048-.194H15.1l.049.194zm-.581-.242l-.144.139.144-.139zm-.04-.038l.112-.166-.111.166zm-.015-.254l.055-.192-.004-.001-.051.193zm.701-.005l-.05-.194.05.194zm.758-.042l.031-.198h-.008l-.023.198zm.034.005l.032-.197-.032.197zm.25.516l.132-.15-.006-.006-.126.156zm1.045.412l.025-.199h-.003l-.022.199zm-.113.344l-.038-.197.038.197zm-.942 1.086l-.172-.101.172.101zm-.166 1.776l-.196.042v.002l.196-.044zm.09.23l-.158-.123-.006.007.163.116zm1.242-.042v.2h.115l.058-.1-.173-.1zM17.618 6l.173.1-.173-.1zm.198-.367l-.142.141.023.023.029.015.09-.18zm-.684-.056l-.013.2.013-.2zm-.68-.05l-.18.09.03.06.06.029.09-.179zm.287-.537l-.175-.096.175.096zm.293-.528l.033-.197-.14-.024-.068.124.175.097zm.596.1l-.033.197.033-.197zm.186.032l.035-.197h-.002l-.033.197zm0 0l-.034.197h.001l.033-.197zm.484.082l-.04.196h.004l.036-.196zm.127-.082l.173.1.002-.004-.175-.096zm.033-.061l-.2-.008.2.008zm-.21.962l.177.093-.177-.093zm-.456.87l-.177-.093-.023.044v.05h.2zm0 .6v.2h.2v-.2h-.2zm-.19.13l.197-.032V7.06l-.197.034zm0 0l-.198.031v.003l.198-.035zm0 0l.197-.035-.197.035zm.018.105l.197-.034-.197.034zm.024.215l-.16-.12-.006.008-.006.01.172.102zm-.15.024v-.2h-.004l.004.2zm-.137.002l-.004-.2-.135.003-.048.126.186.071zm-.077.2l.183.083.004-.01-.187-.072zm-.773 1.246l.158.122.002-.002-.16-.12zm-.063.082l-.159-.122-.152.198.226.105.085-.181zm.148.069l-.085.18.001.002.084-.182zm.567.597l.178-.091v-.001l-.178.092zm.005.978l-.01-.2-.02.001-.019.005.049.194zm-.637.098l.03.198-.03-.198zm-.002 0l-.03-.197.03.197zm-.29.045l-.03-.198.03.198zm-.941.13l-.072.186.008.003.008.003.056-.193zm-.232-.39l.19-.058v-.002l-.19.06zm-.018-.053l-.19.06.19-.06zm0 0l.191-.06-.19.06zm-.038-.115l-.194.048.004.015.006.015.184-.078zm-.32.124l.09.179.002-.001-.091-.178zm-1.065.383l.044.195-.044-.195zm-2.588-.159l-.068.188.068-.188zm-1.05-.52l.106-.17-.105.17zM8.48 8.822l.145-.138-.145.138zm-.512-.42l.09-.179h-.001l-.089.18zm-.612-.153l-.163.116.003.004.16-.12zm.087-.339l.147.136.023-.024.013-.03-.183-.082zm.026-.097l.11-.168-.11.168zm-.309-.201l.11-.168-.01-.006-.009-.004-.09.178zm.98-1.93l.145.138-.145-.138zm.514-1.367l-.172-.102.172.102zm.06-.216l.184-.08-.001-.003-.182.083zm.323-.405l.116.163-.116-.163zm1.02-.769l.19.063.001-.002-.19-.061zm-.472.037l-.065-.189h-.001l.066.189zm-.997.09l.092-.178-.002-.001-.09.179zm-.018-.246l.014-.2-.014.2zm.051-.24l-.199.022.199-.023zm.081-.146l-.068.188.068-.188zm.029.01l-.069.189h.002l.067-.188zm.836-.05l.053.193-.053-.193zm.501-.108l.022.199.007-.001.008-.001-.037-.197zm.459-.016l.146.137-.146-.137zm-.13.32l.194.052v-.001l-.193-.051zm-.063.254h-.2v.2h.2v-.2zm.082.016l-.04.196.04-.196zm0 0l.04-.196h-.002l-.038.196zm.53.108l.04-.196-.04.196zm.694.108l.036.197h.005l-.04-.197zm-.1.326l-.084-.182h-.002l.086.182zm-.33.2l.121.16-.12-.16zm-.773.81l.164.114-.164-.115zm-.015 1.192l.191-.056v-.001l-.191.057zm.042.145l-.192.056.168.58.211-.566-.187-.07zm.073-.198l.188.07v-.002l-.188-.068zm.407-.775l-.162-.117.162.117zm.105-.222l.072-.186-.072.186zm.048-.264l-.105-.17.105.17zm.701-.627l.137.146-.137-.146zm.612-.576l.137.146.063-.06v-.086h-.2zm.082-.322l-.035-.197h-.004l.04.197zm.18-.016v.2h.006l-.006-.2zm.253-.146l.134.149.003-.003-.137-.146zm.134-.164l-.141.142.008.007.008.007.125-.156zm-.234-.029l-.01.2h.005l.005-.2zm-.562.072l-.045-.195h-.002l.047.195zm-.757.04l-.065.189.065-.19zm.176-.149l.053.193.25-.068-.13-.225-.173.1zm-.232-.46l-.06.191h.002l.058-.19zm7.017 2.562l.187-.07-.002-.006-.185.076zm-2.356-2.443l.154-.128-.009-.01-.145.138zm-2.334 3.003l-.195-.046.377.13-.182-.084zm.216-.843l.2.002-.393-.055.193.053zm-.124.642l.182.084v-.001l-.182-.083zm.124-.631l-.2-.002v.002h.2zm.236-.963l.142-.14-.021-.022-.027-.014-.094.176zm-.966-.676l.115-.164-.227-.16-.08.266.191.058zm-.032.105l.191.058-.191-.058zm.949.548l-.084.182.084-.182zm-2.917-.043l-.054-.192-.006.001.06.191zm-.462-.145l-.04.196.04-.196zm.197.22l-.054-.192h-.002l.056.193zm0 0l.054.193h.001l-.055-.192zm-.323.092l.053.192h.001l-.054-.192zm-.512.143l-.194-.05-.087.335.335-.093-.054-.192zm.018-.072l.194.05v-.003l-.194-.047zm-.25-.04L9.74 3.3l-.002.005.193.053zm-.053.19l.052.194.11-.03.03-.11-.192-.053zm.119-.412l-.18-.089-.007.017-.006.018.193.054zm-.879.614l-.132-.15-.02.017-.014.022.166.11zm.17-.037l.05.193.005-.001-.056-.192zm.384-.109l.051.194h.001l-.052-.194zm3.994 1.753l-.191-.058V5.3l.191.056zm.066-.217l.191.058.023-.075-.034-.07-.18.087zm-.243 1.081l-.198-.025.198.025zm-.137.42l-.17-.103-.003.003.173.1zm-.13.25l.184.079.005-.01.003-.01-.191-.06zm-.089-.323l.2-.007v-.003l-.2.01zm.098-1.177l-.195-.043v.001l.195.042zm.432-.39l-.18.086v.001l.18-.088zm-3.297.694l-.19.064.19-.064zm.04.302l-.195-.046v.001l.195.045zm-.188-.994l-.2-.004v.007l.2-.003zm-.121-.03l.183.082.003-.008-.186-.073zm-.171 1.402l.192-.056-.002-.005-.19.06zm.19.113h.2v-.2h-.2v.2zm-.011.878l.184-.077-.184.077zm.725.883l-.18.087.002.004.178-.091zm-.477-1.858l-.2-.02.2.02zm5.695.383l.189.067v-.002l-.189-.065zm.013-.296l.194-.05-.194.05zm-.03.345l-.19-.063v.001l.19.062zm0 0l.19.064v-.001l-.19-.062zm0 0l-.19-.063.19.064zm-.136.302l.149.134-.149-.134zm-.158.082l-.177.093.001.003.176-.096zm-.095-1.266l.196.038-.196-.038zm.224-.452l.198-.028v-.003l-.198.031zm-7.386.732l-.18.087.372-.143-.192.056zm-.171-.584l.191-.056-.076-.259-.225.148.11.167zm-.07.045l-.109-.167-.102.067.013.121.199-.02zm1.133.806v-.2h-.003l.003.2zm-.657.01l-.194-.051-.068.255.265-.004-.003-.2zm.401-.18l.076.185.01-.004.008-.005-.094-.176zm0 0l-.076-.185-.01.004-.008.005.094.176zm.646.006l.16-.12-.003-.004-.157.124zm-.615-.065l.01-.2-.01.2zm-.432-.038l-.04-.196-.437.089.357.267.12-.16zm.77-.156l.04.196-.04-.196zm.293-.06l.193.054.087-.314-.32.065.04.196zm-1.193.875h-.2v.058l.032.049.168-.107zm.172.27l.2-.005-.001-.056-.03-.047-.17.107zm-.23-.68l-.184.076v.002l.184-.078zm-.169.14l.193.053V6.66l-.193-.05zm0 0l-.193-.052v.002l.193.05zm-.118.447l.193.052-.193-.052zm-.198.724l-.193-.053-.048.177.172.064.07-.188zm.08.029l-.07.188h.003l.066-.188zm.345.185l-.103.171.001.001.102-.172zm.353-.174l.195-.046-.001-.004-.194.05zm-.058-.44l.2-.003-.2.004zm5.115.884l-.174.099.174-.1zm-.343-.896l.196-.04v-.004l-.196.044zm.483 1.165l.134.15.008-.009-.142-.14zm-.32.053l-.108.169.011.006.098-.175zm-.284-.618L13.6 7.9l-.188.069zm-.198-.817l.195.045v-.003l-.195-.042zm.127-.294l.18.088-.18-.088zm.108-.224l.2-.017-.06-.734-.32.664.18.087zm.02.259l.2-.015v-.001l-.2.016zm2.04.388l.091-.178H15.6l-.09.178zm.127.125l-.2-.024v.002l.2.022zm-.63.032l-.105-.17-.155.094.08.163.18-.087zm.606.3l.13.152h.001l-.131-.151zm.103-.266l-.022.198h.003l.019-.198zm-.478.557l.114.165-.114-.165zm.069-.047l.114.164.196-.136-.169-.17-.141.142zm-.781.399l-.142.141.008.008.009.007.125-.156zm.143-.529l-.165-.114-.019.027-.009.032.192.055zm.128-.185l.177-.093-.153-.291-.188.27.164.114zm.18.088l.047-.194-.047.194zm.177.074l-.142.14.142-.14zM14.257 8l.19.062.001-.002-.191-.06zm-.158.455l.141.141.008-.008.007-.008-.156-.125zm-.043-.296l-.197-.03v.004l.197.026zm-2.964.188l-.142-.142-.008.008-.007.009.156.125zm.131-.365l-.19-.063v.001l.19.062zm-.256.336l-.091.177.002.001.09-.178zm-.137-.188l-.194.047v.001l.194-.048zm.035-.254l-.172-.102-.001.002.173.1zm.348-.275l-.047-.194.047.194zm.137.003l.184.079.004-.012-.188-.067zm-.078.232l.19.063-.19-.063zm.627.037l-.196.04v.005l.196-.045zm.187.49l.179-.09-.179.09zm-.29-.722l.053-.193-.053.193zm-.185.214l.191.058-.19-.058zm-.085.274l.191.06-.19-.06zm0 0l.19.061-.19-.06zm0 0l-.19-.06-.001.002.19.059zm-.05.16l.192.059-.191-.06zm-.063.203l-.19-.06-.066.211.216.045.04-.196zm.27.056l-.041.195h.001l.04-.195zm.403.07l.023-.198h-.002l-.021.199zm.137.017l-.023.198.369.043-.167-.331-.179.09zm.43-.64l.15.132.175-.198-.238-.114-.087.18zm-.274-.132l.087-.18-.002-.001-.085.18zm.153.27l.149.133v-.001l-.15-.132zm-.166.259l.188.067-.188-.067zm-.061.14l-.142-.142-.007.008.149.134zm1.253.1v.2h.02l-.02-.2zm-.33.024l.013.2h.003l-.016-.2zm-.295-.5l-.106.17.002.001.104-.17zm-.306.008l.146.137.001-.002-.147-.135zm-.225.402l.197.038v-.001l-.197-.037zm-.015.082l-.197-.038-.043.224.228.014.012-.2zm.269.016l-.012.2h.001l.01-.2zm.463-6.967a2.603 2.603 0 00-.89.045l.098.388a2.23 2.23 0 01.725-.039l.068-.394zm.172.02a2.292 2.292 0 01-.166-.02l-.079.393c.054.01.14.019.208.025l.037-.398zm.336.386a.204.204 0 00.012-.29c-.04-.043-.088-.057-.093-.06a.499.499 0 00-.083-.017c-.05-.008-.115-.014-.172-.02l-.037.4c.06.005.114.01.15.015.021.003.022.005.014.002a.186.186 0 01-.072-.047.196.196 0 01.011-.279l.27.296zm-.12.346c0 .015-.002.02.002.003a2.425 2.425 0 01.138-.371c.008-.015.002 0-.018.02l-.274-.292c-.03.03-.05.065-.058.079a2.683 2.683 0 00-.179.476.402.402 0 00-.01.085h.4zm.784.482c.029 0 .05.007.055.008l.017.006.004.002a17.29 17.29 0 01-.915-.634l.008.008a.17.17 0 01.017.023c.002.003.03.044.03.105h-.4c0 .062.03.104.032.109a.227.227 0 00.045.052l.04.033.113.085a17.652 17.652 0 00.797.546.923.923 0 00.073.04.235.235 0 00.084.017v-.4zm.285.431a.242.242 0 00.012-.205.39.39 0 00-.145-.178.28.28 0 00-.152-.048v.4c-.042 0-.066-.017-.067-.017-.004-.003-.004-.004-.003-.002.002.002-.003-.002-.007-.015a.134.134 0 01-.008-.042.17.17 0 01.022-.09l.348.197zm-.168.181c.033-.03.066-.062.092-.09a.662.662 0 00.069-.079l-.333-.222.006-.008-.005.005a1.044 1.044 0 01-.1.099l.27.295zm-.186.56c.045-.156.09-.3.13-.411.02-.056.037-.1.052-.13.018-.04.022-.035.005-.02l-.272-.293a.468.468 0 00-.095.142 1.948 1.948 0 00-.067.165 7.273 7.273 0 00-.137.437l.384.11zm-.098-.39a1.001 1.001 0 00-.256.218l.324.234a.757.757 0 01.156-.12l-.224-.331zm1.694-1.286a81.798 81.798 0 01-1.694 1.286l.224.332a80.068 80.068 0 001.719-1.304l-.249-.314zm-.142.312c.102-.001.164.003.191.008h.001s-.023-.007-.048-.028a.19.19 0 01-.065-.184.177.177 0 01.07-.112l.236.322a.209.209 0 00.012-.336.25.25 0 00-.082-.043.41.41 0 00-.056-.014 1.574 1.574 0 00-.264-.013l.005.4zm-.48.066c.18-.045.33-.064.48-.066l-.006-.4a2.486 2.486 0 00-.57.077l.097.389zm-.772-.298c.044.046.136.143.262.217a.672.672 0 00.511.08l-.097-.388a.274.274 0 01-.213-.038.826.826 0 01-.175-.148l-.288.277zm-.006-.01a.139.139 0 01-.01-.008l-.005-.003h.001l.008.008.012.013.288-.277-.027-.028c-.006-.006-.024-.024-.045-.038l-.222.332zm-.282-.444c0 .063.025.12.039.148a.81.81 0 00.063.107.746.746 0 00.18.189l.222-.333-.008-.007a.56.56 0 01-.096-.13l-.004-.007.002.008.002.025h-.4zm.428-.17a1.304 1.304 0 00-.15-.032.41.41 0 00-.075-.004.23.23 0 00-.074.016.204.204 0 00-.129.19h.4a.197.197 0 01-.121.181.167.167 0 01-.055.013c-.01 0-.012 0 0 0 .02.004.056.01.102.023l.102-.387zm.6-.005a1.045 1.045 0 01-.596.006l-.11.385c.272.077.514.072.807-.004l-.1-.387zm.831-.048a2.255 2.255 0 00-.83.047l.1.388c.21-.054.438-.067.683-.038l.047-.397zm.043.007l-.035-.006-.063.395.035.006.063-.395zm.07.01c.003 0 .003 0 0 0l-.014-.001a3.134 3.134 0 01-.056-.01l-.063.396c.038.006.089.015.126.015l.007-.4zm.274.547a.17.17 0 01.036.039l.009.014c.002.003.003.005.001.001a3.222 3.222 0 01-.126-.43l-.396.058a3.576 3.576 0 00.155.531.401.401 0 00.03.054.209.209 0 00.04.045l.25-.312zm.941.37c.015 0 .023.004.011 0a17.012 17.012 0 01-.968-.382c-.013-.006.003 0 .022.017l-.263.301c.024.021.053.035.058.038l.044.021.123.054a16.96 16.96 0 00.872.335c.01.003.033.01.057.013l.044-.398zm.326.343a.333.333 0 00-.094-.243.386.386 0 00-.23-.1l-.049.396c.016.002.022.005.02.004a.073.073 0 01-.022-.016.096.096 0 01-.023-.036c-.003-.01-.002-.012-.002-.005h.4zm-.424.395a.654.654 0 00.271-.114.357.357 0 00.153-.28h-.4c0-.044.025-.054.006-.039a.26.26 0 01-.105.04l.075.393zm-.807.991a4.96 4.96 0 01.5-.7 2.19 2.19 0 01.221-.226.631.631 0 01.074-.056c.021-.013.024-.011.012-.009l-.075-.393a.444.444 0 00-.146.061 1.015 1.015 0 00-.125.093c-.082.07-.172.163-.263.268-.182.21-.38.482-.543.76l.345.202zm-.3.655c0-.02.014-.086.069-.212.05-.118.128-.267.231-.443l-.345-.202a4.645 4.645 0 00-.253.486 1.02 1.02 0 00-.101.371h.4zm.157.979a11.76 11.76 0 01-.109-.594 3.711 3.711 0 01-.047-.385h-.4c0 .085.023.26.052.447.03.194.071.42.113.615l.391-.083zm-.268.155c0-.001.014-.021.041-.04a.191.191 0 01.262.05c.009.013.011.022.01.02a2.08 2.08 0 01-.045-.187l-.39.087c.023.106.042.19.062.242a.304.304 0 00.028.057.21.21 0 00.297.063.24.24 0 00.06-.06l-.326-.232zm.798-.126c-.261 0-.42.001-.518.008a.657.657 0 00-.136.02.266.266 0 00-.139.091l.315.247a.137.137 0 01-.065.046.446.446 0 01.052-.005 9.66 9.66 0 01.491-.007v-.4zm.607 0h-.607v.4h.607v-.4zm.032-.257l-.205.357.346.2.206-.357-.347-.2zm.282-.088a.2.2 0 01-.103-.23l.004-.014.002-.004-.006.01a11.614 11.614 0 01-.18.326l.348.2a12.441 12.441 0 00.191-.348.599.599 0 00.016-.034l.01-.029c.001-.005.006-.023.008-.046a.202.202 0 00-.11-.189l-.18.358zm-.607-.035a27.39 27.39 0 01.655.051c.003 0 .003 0 0 0a.17.17 0 01-.034-.01.193.193 0 01-.066-.044l.283-.283a.21.21 0 00-.13-.06 27.76 27.76 0 00-.68-.054l-.028.4zm-.757-.071a.208.208 0 00.086.022l.043.004.15.012.478.033.026-.4a46.975 46.975 0 01-.658-.047h-.006a.1.1 0 01.015.002.185.185 0 01.045.016l-.179.358zm.202-.812a33.99 33.99 0 00-.288.535.383.383 0 00-.017.043.2.2 0 00-.006.032c0 .003-.009.056.02.113l.358-.18c.028.057.02.11.02.112a.195.195 0 01-.012.048l-.001.002a33.296 33.296 0 01.277-.512l-.35-.193zm.293-.53l-.293.53.35.193.293-.528-.35-.194zm.804.001l-.596-.1-.066.394.596.1.066-.394zm.186.031l-.186-.031-.066.394.186.032.066-.395zm.002 0l-.07.395.07-.394zm.488.084l-.49-.084-.066.395c.254.042.45.075.478.081l.078-.392zm-.085.014a.263.263 0 01-.017.026c-.001.002.006-.009.024-.02a.137.137 0 01.062-.02h.013l-.072.393c.04.007.125.02.21-.034a.4.4 0 00.126-.145l-.346-.2zm.017-.04a.32.32 0 01-.02.044l.351.192a.69.69 0 00.047-.103l-.378-.132zm.389.087v-.012l-.4-.016v.012l.4.016zm-.232 1.046c.208-.402.225-.878.232-1.046l-.4-.016c-.007.175-.025.565-.188.878l.356.184zm-.457.871l.456-.87-.354-.186-.456.87.354.186zm.023.507v-.6h-.4v.6h.4zm-.306.2h.106v-.4h-.106v.4zm.095-.195a.2.2 0 01-.117.182.15.15 0 01-.036.012.157.157 0 01-.012.003h-.004.01l.064-.002v-.4a1.714 1.714 0 00-.12.005.255.255 0 00-.067.018.2.2 0 00-.118.182h.4zm.018.09a60.621 60.621 0 01-.015-.086l-.004-.024v-.004.003a.207.207 0 010 .021h-.4l.001.017.001.007.001.008a.377.377 0 00.007.04l.015.087.394-.07zm0 .003l-.395.063.395-.063zm0-.003l-.394.07.394-.07zm.018.106l-.018-.106-.394.07.018.105.394-.069zm-.013.369a.206.206 0 00.04-.103.693.693 0 00-.003-.106 3.022 3.022 0 00-.024-.16l-.394.069a2.6 2.6 0 01.023.156v.004l.002-.012a.193.193 0 01.036-.088l.32.24zm-.31.104a.873.873 0 00.13-.01.42.42 0 00.112-.035.214.214 0 00.08-.076l-.344-.206a.191.191 0 01.069-.067.14.14 0 01.024-.01c.006-.003.006-.002-.003 0a.476.476 0 01-.068.004v.4zm-.134.002l.137-.002-.007-.4-.137.002.007.4zm.107.072l.076-.2-.373-.143-.077.2.374.143zm-.8 1.294c.298-.395.653-.966.795-1.283l-.364-.164c-.127.28-.463.825-.75 1.207l.319.24zm-.065.084l.063-.082-.316-.244-.064.082.317.244zm.074-.235l-.148-.068-.169.362.148.069.169-.363zm.66.687c-.156-.301-.4-.568-.661-.687l-.167.364c.156.07.344.258.473.507l.355-.184zm.139.555c0-.11 0-.198-.023-.286-.022-.086-.063-.166-.115-.268l-.356.182a.969.969 0 01.083.185c.008.03.01.066.01.187h.4zm-.3.715a.227.227 0 00.168-.093.371.371 0 00.044-.08.96.96 0 00.047-.16c.024-.112.04-.255.04-.382h-.4c0 .097-.013.21-.032.299a.595.595 0 01-.025.09c-.003.008-.002.003.006-.008.002-.002.043-.061.13-.066l.021.4zm-.618.096l.451-.07.135-.02.038-.006.032-.006-.098-.388c.01-.002.018-.003.002 0-.008 0-.02.003-.036.005l-.133.02-.451.07.06.395zm-.002 0h.002l-.06-.396h-.002l.06.396zm-.29.045l.29-.045-.06-.395-.29.044.06.396zm-1.027.124c.027.007.05.008.052.008h.019a.705.705 0 00.093-.01 44.915 44.915 0 00.864-.123l-.06-.395a46.74 46.74 0 01-.851.121 1.917 1.917 0 01-.053.006h-.008.009a.173.173 0 01.046.008l-.11.385zm-.368-.522a1.412 1.412 0 00.214.405.356.356 0 00.138.111l.143-.373a.146.146 0 01.04.023l-.008-.01a1.03 1.03 0 01-.144-.273l-.383.117zm-.016-.052l.017.053.381-.121-.017-.054-.381.122zm0-.001l.381-.12-.381.12zm-.032-.097l.001.004.008.022.023.072.381-.121c-.015-.047-.034-.108-.045-.134l-.368.157zm-.044.224a2.56 2.56 0 01.217-.102c.023-.009.028-.009.02-.008-.001 0-.025.005-.057-.002a.195.195 0 01-.146-.142l.388-.097a.208.208 0 00-.159-.152.245.245 0 00-.089-.002.52.52 0 00-.1.03 2.488 2.488 0 00-.256.119l.182.356zm-1.113.4a4.493 4.493 0 001.112-.4l-.18-.357a4.1 4.1 0 01-1.02.367l.088.39zm-2.7-.165c.86.309 1.806.366 2.7.165l-.088-.39a4.46 4.46 0 01-2.476-.152l-.135.377zm-1.087-.54c.292.181.819.441 1.087.54l.137-.376a7.394 7.394 0 01-1.013-.503l-.21.34zM8.335 8.962c.818.856 1.033 1.048 1.543 1.364l.21-.34c-.465-.288-.65-.45-1.463-1.3l-.29.276zm-.456-.38c.082.041.13.07.187.117.062.05.137.125.27.263l.288-.277a3.74 3.74 0 00-.305-.296 1.29 1.29 0 00-.261-.165l-.18.358zM7.575 8.5c.075 0 .107.003.137.011a.938.938 0 01.168.071l.177-.358a1.294 1.294 0 00-.244-.1.9.9 0 00-.238-.024v.4zm-.379-.13a.301.301 0 00.182.116.94.94 0 00.197.014v-.4a1.506 1.506 0 01-.109-.004s.011.002.025.011a.1.1 0 01.025.023l-.32.24zm.1-.594a.651.651 0 00-.162.272.375.375 0 00.06.318l.325-.232.002.006v.007a.284.284 0 01.07-.1l-.295-.271zm.064.206a.195.195 0 01-.088-.149c-.001-.021.002-.036.002-.037l-.001.004a.453.453 0 01-.012.029v.002l.182.08.183.081.001-.002.002-.003a.856.856 0 00.038-.117.25.25 0 00.005-.062c-.001-.014-.007-.105-.094-.162l-.218.336zm-.309-.202l.31.202.217-.336-.309-.2-.218.334zm.944-2.235c-.196.207-.51.677-.743 1.102-.117.214-.22.428-.279.602a.92.92 0 00-.053.255c-.002.07.01.216.149.287l.182-.356c.08.04.067.115.068.081a.618.618 0 01.034-.14c.047-.14.137-.33.25-.537.227-.415.522-.85.682-1.018l-.29-.276zm.127-.184a.254.254 0 01-.002.046l.001-.003.001-.003a.3.3 0 01-.031.04 4.045 4.045 0 01-.097.105l.291.274c.079-.083.146-.153.185-.22.052-.092.052-.174.052-.24h-.4zm.36-1.146a2.972 2.972 0 00-.249.576c-.063.2-.111.411-.111.57h.4c0-.096.032-.26.092-.448a2.58 2.58 0 01.212-.495l-.344-.203zm.05-.036l-.003-.012a.112.112 0 01.003-.04c0-.005 0-.002-.008.015a1.614 1.614 0 01-.042.072l.344.205a.796.796 0 00.09-.183.296.296 0 00-.018-.216l-.367.16zm.388-.647c-.154.111-.273.2-.34.286A.353.353 0 008.5 4a.347.347 0 00.032.181l.365-.165c-.005-.01.003.002 0 .026-.002.025-.013.034-.004.024a.539.539 0 01.077-.072 3.59 3.59 0 01.183-.137L8.92 3.53zm.948-.67a.186.186 0 01.034-.06c.002-.003.002-.003-.002.001a6.712 6.712 0 01-.238.188c-.172.13-.423.313-.742.542l.233.325c.32-.23.574-.415.75-.547a7.077 7.077 0 00.27-.215.412.412 0 00.028-.029.215.215 0 00.046-.078l-.38-.126zm-.217.29a1.182 1.182 0 01.318-.06l.015.001a.156.156 0 01-.056-.028.185.185 0 01-.062-.2l.382.122a.215.215 0 00-.074-.237.268.268 0 00-.115-.05.656.656 0 00-.166-.004 1.58 1.58 0 00-.373.078l.13.378zm-1.155.079c.144.073.332.085.518.068a2.69 2.69 0 00.638-.147l-.133-.378a2.294 2.294 0 01-.541.127c-.16.014-.257-.004-.298-.026l-.184.356zm-.322-.424c0 .073.036.134.05.159.022.035.048.07.075.1a.73.73 0 00.2.166l.179-.358s-.002 0-.008-.005a.505.505 0 01-.103-.11c-.003-.004-.002-.004 0 0 0 .002.007.02.007.048h-.4zm.41-.2a2.195 2.195 0 00-.214-.003.21.21 0 00-.104.035.202.202 0 00-.092.168h.4A.198.198 0 018.415 3H8.41h.021c.03 0 .073.002.124.005l.03-.398zm-.162-.018a1.883 1.883 0 01.01.124c-.002.011-.002-.012.02-.042a.155.155 0 01.132-.063l-.029.398a.246.246 0 00.22-.1.313.313 0 00.054-.155c.007-.072-.004-.158-.01-.208l-.397.046zm-.01-.13c0 .043.006.094.01.13l.398-.046a.91.91 0 01-.008-.085h-.4zm.208-.267a.202.202 0 00-.195.148.282.282 0 00-.01.05.651.651 0 00-.003.068h.4a.427.427 0 010-.025v.005a.186.186 0 01-.027.066.198.198 0 01-.165.088v-.4zm.15.041a10.903 10.903 0 00-.1-.035.2.2 0 00-.013-.003c-.003 0-.018-.003-.037-.003v.4a.196.196 0 01-.056-.008c-.002 0-.002 0 0 0a.914.914 0 01.07.025l.137-.376zm.03.01l-.03-.01-.136.376.028.01.137-.375zm.714-.054c-.354.097-.59.1-.717.054l-.133.377c.247.087.582.058.956-.046l-.106-.385zm.532-.115a4.28 4.28 0 00-.533.115l.108.385a3.93 3.93 0 01.47-.102l-.045-.398zm.627.32a.224.224 0 00.06-.13.21.21 0 00-.083-.19.241.241 0 00-.092-.042.363.363 0 00-.057-.008 1.203 1.203 0 00-.197.01 4.136 4.136 0 00-.266.041l-.005.001h-.001l.036.197.037.197a.373.373 0 00.02-.004 4.333 4.333 0 01.225-.034.885.885 0 01.126-.008c.004 0 .001 0-.006-.002a.149.149 0 01-.06-.028.19.19 0 01-.074-.171.173.173 0 01.045-.102l.292.273zm-.082.234c.02-.076.04-.136.057-.18.02-.05.03-.06.025-.054l-.292-.274a.58.58 0 00-.104.179c-.026.065-.05.142-.073.227l.387.102zm-.057.203a.183.183 0 01-.003.037c0 .001 0 0 0 0l.003-.014a4.986 4.986 0 01.057-.225l-.386-.104a7.908 7.908 0 00-.06.24l-.005.017a.214.214 0 00-.001.008l-.002.006v.008s-.003.012-.003.027h.4zm-.078-.18l-.06-.012a3.114 3.114 0 00-.023-.004l-.004-.001-.006-.001-.007-.001-.022-.001v.4a.195.195 0 01-.033-.003H10.3h.002l.015.003.06.012.08-.392zm-.002 0l-.077.393.077-.393zm.531.108a77.17 77.17 0 01-.529-.108l-.08.392.531.108.078-.392zm.62.108c.015-.003.014 0-.024-.004a2.084 2.084 0 01-.128-.017 10.94 10.94 0 01-.467-.087l-.08.392c.202.041.364.072.485.09.06.01.112.017.155.02a.509.509 0 00.13 0l-.072-.394zm.399.305a.306.306 0 00-.134-.262.354.354 0 00-.271-.042l.082.391c.02-.004 0 .006-.032-.015a.108.108 0 01-.038-.044.07.07 0 01-.007-.028h.4zm-.38.398c.104-.048.192-.093.254-.145a.354.354 0 00.092-.11.31.31 0 00.034-.143h-.4c0-.007.001-.023.01-.04.008-.015.015-.02.01-.015a.342.342 0 01-.05.032 1.933 1.933 0 01-.118.058l.168.363zm-.293.179a2.05 2.05 0 01.295-.18l-.172-.361a2.438 2.438 0 00-.365.222l.242.319zm-.73.764c.155-.222.53-.613.73-.764l-.242-.319a5.02 5.02 0 00-.816.854l.328.229zm-.1.285a.51.51 0 01.005-.138.823.823 0 01.095-.147l-.328-.23c-.06.088-.116.164-.145.247-.03.088-.028.178-.028.268h.4zm.112.736a3.059 3.059 0 01-.113-.736h-.4c0 .243.056.6.13.85l.383-.114zm.043.146l-.043-.145-.384.111.043.146.384-.112zm-.306-.212l-.074.198.375.14.074-.198-.375-.14zm.431-.822a3.339 3.339 0 00-.431.823l.376.137a2.94 2.94 0 01.38-.726l-.325-.234zm.196.082a.182.182 0 01-.112-.147.159.159 0 01.004-.059l.004-.012a2.743 2.743 0 01-.091.136l.324.234c.057-.078.103-.146.129-.199a.27.27 0 00.028-.145.218.218 0 00-.142-.181l-.144.373zm.015-.622a.262.262 0 00-.078.077.641.641 0 00-.087.328.287.287 0 00.025.098.23.23 0 00.126.119l.143-.374a.171.171 0 01.094.086c.01.022.01.038.011.04l.004-.026a.24.24 0 01.014-.045c.002-.005.002-.004 0 0a.155.155 0 01-.043.039l-.209-.342zm.67-.601a24.15 24.15 0 01-.612.554l-.058.047.21.341c.027-.017.07-.052.106-.083a24.543 24.543 0 00.627-.568l-.273-.291zm.611-.577l-.612.577.274.29.612-.575-.274-.292zm-.063-.007v.153h.4V2.92h-.4zm.243-.366c-.015.003-.053.01-.088.026a.245.245 0 00-.123.118.326.326 0 00-.03.121 1.51 1.51 0 00-.002.1h.4c0-.038 0-.059.002-.072v-.003a.157.157 0 01-.084.102l-.013.004a.383.383 0 01.016-.003l-.078-.393zm.219-.02c-.066 0-.16.01-.215.02l.07.393c.034-.006.104-.012.145-.012v-.4zm.119-.093a.782.782 0 01-.112.09l-.006.003h-.008l.014.4a.412.412 0 00.199-.056c.058-.033.116-.082.18-.14l-.267-.297zm.143.14a.195.195 0 01-.07-.188.157.157 0 01.017-.046c.004-.007.004-.005-.006.007a1.096 1.096 0 01-.087.09l.274.291c.045-.043.089-.087.12-.126a.452.452 0 00.048-.067.24.24 0 00.027-.07.206.206 0 00-.072-.203l-.25.312zm-.114.015a1.309 1.309 0 01.17.016c.003 0 0 0-.005-.002a.188.188 0 01-.067-.043l.283-.283a.212.212 0 00-.084-.051.794.794 0 00-.109-.023 1.704 1.704 0 00-.179-.014l-.009.4zm-.512.067c.268-.062.363-.074.507-.067l.019-.4c-.199-.009-.335.012-.616.077l.09.39zm-.867.034c.236.08.474.06.868-.035l-.093-.389c-.381.091-.523.086-.646.045l-.129.379zm.189-.53a.966.966 0 00-.23.092.34.34 0 00-.066.051.237.237 0 00-.068.136c-.01.084.028.15.07.19a.29.29 0 00.105.06l.13-.378h.002a.118.118 0 01.036.026.178.178 0 01.01.246c-.009.01-.014.012-.01.01a.61.61 0 01.126-.048l-.105-.386zm-.12-.459a.203.203 0 00-.263.172c-.005.047.008.086.01.092.007.027.02.056.03.078a10.323 10.323 0 00.179.334l.031.055a2.382 2.382 0 00.011.02h.001l.173-.1.173-.1v-.001l-.003-.004-.008-.015a7.794 7.794 0 01-.194-.358c-.01-.02-.011-.026-.01-.023l.003.016a.196.196 0 01-.253.216l.12-.382zm.72.034a1.134 1.134 0 01-.338.047 1.555 1.555 0 01-.383-.081l-.117.383c.186.057.335.092.482.098.15.006.288-.017.454-.059l-.098-.388zm6.422 2.643a.201.201 0 00-.39.057.905.905 0 00-.004.07l.4.016a1.33 1.33 0 01.002-.036l-.004.016a.197.197 0 01-.201.148.199.199 0 01-.173-.12l.37-.15zm-.005.201a.4.4 0 00.018-.07.247.247 0 00-.01-.125l-.375.14a.17.17 0 01-.01-.078c.001-.005.002-.006 0 0l.377.133zm-2.39-2.705a.204.204 0 00-.317.02.209.209 0 00-.037.14c0 .013.002.025.003.035l.396-.057c0-.004 0-.003 0 0 0 0 .001.018-.004.042a.197.197 0 01-.332.095l.29-.275zm-.157.366c.012 0 .043 0 .078-.01a.207.207 0 00.119-.301.286.286 0 00-.032-.046l-.307.257c.002.002-.005-.005-.012-.019a.193.193 0 01.148-.28h.014l-.008.4zm-2.323 2.774l.195.046v-.004l.004-.014.013-.054a23.64 23.64 0 01.197-.763l-.386-.107a24.122 24.122 0 00-.2.776l-.013.055-.004.014v.005l.194.046zm-.09-.284l-.092.2.364.168.092-.201-.364-.167zm.106-.548l-.002.02a5.069 5.069 0 01-.076.43 1.465 1.465 0 01-.027.097l-.001.002.364.165a1.03 1.03 0 00.053-.173 4.186 4.186 0 00.09-.541h-.4zm0-.012v.01l.4.003v-.01l-.4-.003zm.53-1.127l-.002-.001-.189.352.003.002.188-.353zm-.204.343l.015.01a.19.19 0 00.04.016c.005.001.035.01.075.007a.2.2 0 00.122-.34l-.284.282a.197.197 0 01-.057-.16.2.2 0 01.18-.18c.04-.004.07.005.075.006a.21.21 0 01.038.016l.01.005.001.002-.215.336zm-.857-.843l-.115.163h.001l.002.002.008.005.029.02.103.074.32.224c.23.162.477.335.509.355l.215-.336-.003-.003-.011-.007a6.06 6.06 0 01-.153-.106 180.782 180.782 0 01-.646-.454l-.104-.073a.191.191 0 00-.03-.02l-.007-.006-.002-.001-.116.163zm.16.163l.032-.106-.383-.115-.032.106.383.115zm.841.309c-.103-.048-.343-.158-.553-.268a2.861 2.861 0 01-.26-.15.392.392 0 01-.052-.04c-.002-.002.006.005.015.022a.172.172 0 01.01.127l-.384-.115a.228.228 0 00.017.17.31.31 0 00.055.074.74.74 0 00.114.093c.082.055.19.116.3.173.22.116.47.23.571.277l.167-.363zm.052.024l-.052-.024-.167.363.03.014.01.004.002.002.177-.36zm-2.998.307l.047-.015a.219.219 0 00.106-.073.205.205 0 00-.05-.3.316.316 0 00-.082-.037c-.071-.022-.228-.054-.496-.11l-.08.393c.284.058.41.085.457.1.014.004-.001 0-.022-.013-.008-.006-.049-.033-.07-.09a.195.195 0 01.028-.19c.025-.032.052-.046.057-.049a.145.145 0 01.011-.005l.004-.002-.004.002a.695.695 0 01-.014.004l.108.385zm-.265.075l.27-.077-.119-.382-.26.074.109.385zm.001 0l-.11-.385.11.385zm-.324.091l.323-.09-.108-.386-.324.091.11.385zm-.512.143l.511-.143-.107-.385-.512.143.108.385zm-.23-.314l-.018.071.388.1.018-.07-.387-.1zm.334-.628a.202.202 0 00-.167.088.557.557 0 00-.04.085 7.427 7.427 0 00-.127.458l.389.094a7.04 7.04 0 01.114-.418l.005-.012-.003.007a.177.177 0 01-.04.049.198.198 0 01-.13.049v-.4zm.52.099a43.57 43.57 0 00-.486-.097h-.01a.084.084 0 00-.024-.002v.4a.192.192 0 01-.02-.001l.027.005.102.02c.087.017.203.04.33.067l.082-.392zm-1.103.486l-.053.19.386.107.053-.19-.386-.107zm.066-.224a11.41 11.41 0 01-.064.219l.382.117.067-.226-.385-.11zm.198.224a.199.199 0 01-.197-.17.171.171 0 010-.042.133.133 0 01.013-.046l.358.179a.264.264 0 00.025-.147.201.201 0 00-.2-.174v.4zM9.25 3.9c-.005.005 0 0 .031-.023a30.303 30.303 0 01.402-.295 77.89 77.89 0 01.421-.305l.003-.002-.007.004-.014.007a.206.206 0 01-.02.008.195.195 0 01-.064.01v-.4c-.034 0-.059.01-.064.011a.2.2 0 00-.06.032 77.34 77.34 0 00-.835.61l-.057.042.264.301zm-.014-.38l-.117.03-.017.003a.18.18 0 01.082.01.199.199 0 01.1.298l-.332-.222a.201.201 0 00.145.311c.029.004.054 0 .058 0a4.514 4.514 0 00.183-.043l-.102-.388zm.386-.11c-.114.03-.29.082-.39.11l.11.385c.102-.03.273-.079.381-.107l-.101-.387zm.204-.054l-.206.055.104.386.206-.055-.104-.386zm4.031 2.06l.066-.218-.382-.116-.066.217.382.116zm-.17.83c.042-.318.095-.574.171-.833l-.384-.112c-.082.28-.14.558-.183.895l.397.05zm-.164.5c.047-.078.085-.146.111-.228.027-.08.04-.164.054-.272l-.397-.05a1.058 1.058 0 01-.037.197.692.692 0 01-.073.145l.342.207zm-.11.204c0 .003.001-.002.009-.018l.026-.053.077-.137-.346-.201c-.028.05-.059.103-.084.151a.928.928 0 00-.063.139l.382.119zm-.48-.376c.003.092.006.171.01.234.003.06.008.118.018.163a.272.272 0 00.047.107.21.21 0 00.273.055c.054-.03.082-.08.09-.093a.624.624 0 00.035-.07l-.367-.16a.738.738 0 01-.008.019l-.003.006.002-.003a.166.166 0 01.051-.046.19.19 0 01.245.05c.024.031.028.06.025.049a.858.858 0 01-.009-.1 9.59 9.59 0 01-.009-.224l-.4.013zm.102-1.225a4.798 4.798 0 00-.102 1.228l.4-.019a4.382 4.382 0 01.093-1.124l-.39-.085zm.809-.436a.23.23 0 00-.193-.128.322.322 0 00-.13.02.702.702 0 00-.19.11.807.807 0 00-.295.433l.39.086a.418.418 0 01.152-.204.322.322 0 01.077-.048c.007-.003-.006.004-.033.002a.171.171 0 01-.139-.097l.36-.174zm.068.14l-.069-.14-.36.175.07.14.359-.176zm-3.735.706a.81.81 0 01.038.138.128.128 0 01-.004.054l.39.091a.525.525 0 00.01-.198 1.155 1.155 0 00-.056-.213l-.378.128zm-.159-.753c.003.183.077.51.159.753l.379-.127a2.716 2.716 0 01-.138-.633l-.4.007zm.265.041a1.12 1.12 0 01.05-.115c.006-.01.004-.003-.008.01a.17.17 0 01-.05.035.19.19 0 01-.235-.062.162.162 0 01-.022-.041c-.003-.012-.003-.015-.002-.003a.904.904 0 01.002.128l.4.008a1.6 1.6 0 00-.003-.175.393.393 0 00-.016-.083.24.24 0 00-.032-.064.212.212 0 00-.11-.08.216.216 0 00-.221.06.355.355 0 00-.052.073 1.455 1.455 0 00-.073.162l.372.147zm-.192.86c0-.19.01-.312.035-.429.026-.117.07-.237.154-.423l-.366-.163a2.581 2.581 0 00-.178.5 2.308 2.308 0 00-.045.515h.4zm.025.407l-.002-.009a1.45 1.45 0 01-.014-.123 3.949 3.949 0 01-.009-.275h-.4c0 .11.004.216.01.304.006.08.015.166.034.224l.381-.121zm-.08-.026c-.014 0-.007 0 .006.003a.14.14 0 01.067.038c.018.018.023.034.021.029a.398.398 0 01-.012-.039l-.385.111a.778.778 0 00.028.082c.01.026.029.063.062.097.079.08.178.08.213.08v-.4zm.08 0h-.08v.4h.08v-.4zm.2.53v-.33h-.4v.33h.4zm-.24.531a.222.222 0 00.195-.115.332.332 0 00.036-.124c.007-.062.008-.158.008-.291h-.4c0 .141-.001.21-.005.245v.005c0-.002.003-.014.012-.03a.178.178 0 01.154-.09v.4zm.213-.06a2.838 2.838 0 01-.042-.105c-.01-.028-.01-.032-.009-.024a.17.17 0 01-.056.143.175.175 0 01-.079.043c-.016.003-.027.003-.027.003v-.4c-.015 0-.098-.002-.167.061a.231.231 0 00-.067.205.531.531 0 00.03.107c.012.034.029.075.049.122l.368-.156zm.363 1.05s-.006-.01-.01-.027a.192.192 0 01.028-.162.197.197 0 01.214-.078.146.146 0 01.045.019c.008.005.002.001-.028-.027a5.006 5.006 0 01-.46-.533 1.381 1.381 0 01-.152-.242l-.369.154c.042.1.12.217.2.326a5.384 5.384 0 00.504.583.642.642 0 00.093.078c.008.005.03.018.06.027.014.004.142.037.222-.08a.203.203 0 00.028-.171.26.26 0 00-.018-.048l-.357.182zm-.498-1.968c-.03.292.046.676.145 1.025.102.356.238.705.351.94l.36-.174a5.824 5.824 0 01-.326-.875c-.097-.342-.153-.664-.132-.877l-.398-.04zm.057-.419a4.929 4.929 0 00-.057.418l.398.04c.016-.157.039-.325.049-.37l-.39-.088zm6.026.887a.714.714 0 00.048-.206.702.702 0 00-.03-.205l-.388.1c.018.07.019.082.018.089a.35.35 0 01-.026.092l.378.13zm-.016.047l.016-.045-.377-.134-.018.053.38.126zm0 0l-.38-.125.38.125zm0 0l-.38-.126.38.127zm-.177.373a.704.704 0 00.114-.197c.026-.063.048-.13.063-.175l-.38-.126c-.015.047-.033.1-.053.149a.64.64 0 01-.042.082l.298.267zm-.483.044c.004.007.01.019.018.03a.259.259 0 00.047.056.218.218 0 00.248.028.379.379 0 00.092-.073l.078-.085-.297-.268a3.02 3.02 0 01-.076.082l-.002.002.003-.003a.176.176 0 01.11-.029.18.18 0 01.13.069l-.35.19zm-.116-1.4a2.99 2.99 0 00-.032.752c.018.24.064.487.147.645l.354-.186c-.044-.082-.085-.26-.102-.49a2.599 2.599 0 01.026-.645l-.393-.075zm.381-.83a.201.201 0 00-.181.113 1.214 1.214 0 00-.04.105 6.203 6.203 0 00-.16.613l.393.074a5.867 5.867 0 01.164-.613L16 5.37a.196.196 0 01-.173.103v-.4zm.238.385a8.862 8.862 0 00-.037-.213.333.333 0 00-.008-.032c-.002-.005-.007-.02-.016-.036a.201.201 0 00-.176-.105v.4a.2.2 0 01-.175-.102c-.008-.015-.012-.028-.013-.03l-.002-.006a7.989 7.989 0 01.031.186l.396-.062zm.19.97c-.055-.215-.157-.73-.19-.967l-.396.056c.035.25.14.781.2 1.011l.387-.1zm-7.582-.263L8.5 5.581l-.383.112.171.585.384-.113zm-.631-.462c.003.025.01.046.012.054a8.266 8.266 0 00.21.473l.026.056.008.016.002.004v.001l.181-.086.18-.086v-.002l-.002-.004-.008-.015a19.578 19.578 0 01-.187-.405 1.655 1.655 0 01-.029-.073c-.002-.005.003.006.005.025l-.398.042zm.158-.233l-.069.045.22.334.068-.045-.22-.334zm1.413 1.218c.07 0 .137-.002.189-.008a.619.619 0 00.077-.011.268.268 0 00.056-.02.203.203 0 00.118-.185h-.4a.197.197 0 01.108-.175.155.155 0 01.027-.01s-.007.002-.026.003a1.632 1.632 0 01-.15.006v.4zm-.24 0h.24v-.4h-.24v.4zm-.654.01l.657-.01-.006-.4-.657.01.006.4zm.322-.565c-.106.044-.208.086-.283.119a1.942 1.942 0 00-.142.07.254.254 0 00-.032.024c-.004.005-.045.04-.062.1l.387.104a.195.195 0 01-.056.093l-.018.014.006-.003.077-.036.275-.115-.152-.37zm-.018.009l.188.352-.188-.352zm.148-.063l-.13.054.153.37.13-.054-.153-.37zm.749.121c-.04-.051-.095-.07-.108-.075a.464.464 0 00-.066-.017 1.465 1.465 0 00-.138-.02 7.44 7.44 0 00-.35-.023l-.021.399c.123.006.242.013.331.022.046.005.079.01.099.014.01.002.012.003.009.001a.176.176 0 01-.07-.053L9.92 6.2zm.133.265c0-.046-.016-.08-.017-.083a.704.704 0 00-.04-.074 1.585 1.585 0 00-.074-.104l-.318.241a1.191 1.191 0 01.065.096l-.003-.007a.164.164 0 01-.01-.036.194.194 0 01-.003-.033h.4zm-.915-.006l.1.005.02-.4-.1-.004-.02.399zm-.542-.078c.039.03.081.039.088.04a1.782 1.782 0 00.16.02c.082.007.187.013.294.018l.02-.4a12.289 12.289 0 01-.367-.024l-.011-.002.012.004a.176.176 0 01.044.024l-.24.32zm.85-.512l-.77.156.08.392.77-.156-.08-.392zm.293-.06l-.293.06.08.392.293-.06-.08-.391zm-.415.64c.13-.054.264-.11.368-.16.051-.023.1-.047.138-.07a.503.503 0 00.096-.074.221.221 0 00.046-.086l-.385-.106a.18.18 0 01.052-.086l-.012.007a1.503 1.503 0 01-.105.054 9.396 9.396 0 01-.351.152l.153.369zm-.906.538l.171.27.338-.215-.172-.27-.337.215zm-.073-.439c.03.073.041.12.041.332h.4c0-.227-.01-.34-.074-.489l-.367.157zm.1-.046a.197.197 0 01-.157-.079.11.11 0 01-.002-.002.074.074 0 01.004.007l.009.016.045.102.37-.153a2.395 2.395 0 00-.085-.18.22.22 0 00-.06-.07.204.204 0 00-.125-.041v.4zm.108.159l.058-.221.016-.057.001-.004-.008.018a.194.194 0 01-.061.069.2.2 0 01-.115.036v-.4a.2.2 0 00-.19.134 26.607 26.607 0 00-.089.323l.388.102zm0 .002l-.387-.105.386.105zm-.119.446l.119-.448-.387-.101-.118.444.386.105zm-.198.725l.198-.725-.386-.105-.198.724.386.106zm-.045-.212l-.079-.029-.138.376.08.029.137-.376zm.38.202a5.02 5.02 0 00-.22-.125 1.46 1.46 0 00-.162-.078L8.055 8l.031.014c.02.01.047.023.076.04.06.031.132.072.202.113l.206-.342zm.208.13a.174.174 0 01.049.007l-.008-.004a3.7 3.7 0 01-.25-.135l-.204.345a4.094 4.094 0 00.296.158.51.51 0 00.04.015c.006.002.039.014.077.014v-.4zm-.152-.088a.992.992 0 01.026.182c0 .007 0-.018.026-.047a.143.143 0 01.1-.047v.4a.262.262 0 00.2-.089.31.31 0 00.071-.17.978.978 0 00-.034-.32l-.39.091zm-.064-.48c.003.141.031.355.064.484l.388-.099a2.158 2.158 0 01-.052-.393l-.4.008zm-.005-.232l.005.232.4-.009-.005-.232-.4.009zm5.494 1.012a2.732 2.732 0 01-.32-.836l-.393.077c.065.33.185.639.365.957l.348-.198zm.108.51a.201.201 0 00.046-.213 1.48 1.48 0 00-.048-.104 5.58 5.58 0 00-.106-.194l-.347.2a5.24 5.24 0 01.122.227c.003.006.002.004 0-.001a.192.192 0 01-.008-.074.199.199 0 01.057-.124l.284.282zm-.559.086c.037.02.072.025.08.025a.615.615 0 00.09 0 1.652 1.652 0 00.292-.054.23.23 0 00.09-.05l-.269-.297a.185.185 0 01.041-.028l.008-.003a1.225 1.225 0 01-.212.035h-.002a.081.081 0 00.012 0 .188.188 0 01.065.022l-.195.35zm-.375-.725c.052.143.116.297.172.419a2.679 2.679 0 00.116.22c.006.01.014.021.024.032a.21.21 0 00.052.047l.217-.336c.023.015.036.03.036.031l.003.003a2.353 2.353 0 01-.084-.165 5.424 5.424 0 01-.16-.388l-.376.137zm-.205-.93a.366.366 0 00-.006.103c.002.028.006.059.01.09a4.97 4.97 0 00.2.737l.377-.137a4.559 4.559 0 01-.181-.662.687.687 0 01-.007-.054c0-.016.002-.007-.003.013l-.39-.09zm.142-.336a4.888 4.888 0 00-.087.187.964.964 0 00-.056.152l.392.084.005-.014.026-.063c.022-.05.05-.11.08-.17l-.36-.176zm.107-.224l-.108.225.36.173.109-.225-.36-.173zm.401.33l-.02-.26-.4.033.021.259.4-.032zm.06.448a3.908 3.908 0 01-.06-.447l-.399.03c.011.147.039.372.068.504l.39-.087zm1.688.134a.71.71 0 01.05.028c.011.007.011.008.007.003a.136.136 0 01-.037-.108l.397.047a.265.265 0 00-.082-.226.636.636 0 00-.152-.1l-.183.356zm-.412-.021l.105.17.002-.001.01-.006a1.664 1.664 0 01.164-.084.706.706 0 01.128-.045c.044-.009.035.003.005-.012l.18-.357a.41.41 0 00-.268-.022 1.097 1.097 0 00-.206.07 2.003 2.003 0 00-.205.105l-.014.008-.004.002-.001.001.104.17zm.375.278c.035 0 .06.01.069.014l.016.009s-.005-.003-.016-.015a1.773 1.773 0 01-.263-.373l-.36.174a2.146 2.146 0 00.34.482c.02.02.043.041.068.059.015.01.07.05.146.05v-.4zm.101-.129a3.39 3.39 0 01-.184.148c-.004.003-.004.002 0 0a.149.149 0 01.018-.008.186.186 0 01.065-.011v.4a.212.212 0 00.102-.026 1.114 1.114 0 00.099-.067 3.75 3.75 0 00.161-.133l-.26-.303zm.215.084l.01.001s-.018-.005-.04-.021a.167.167 0 01-.055-.184c.007-.018.011-.015-.017.015-.024.025-.06.06-.113.106l.262.302c.057-.05.105-.094.143-.135a.466.466 0 00.099-.145.248.248 0 00.012-.139.233.233 0 00-.087-.137.34.34 0 00-.176-.061l-.038.398zm-.26-.287c-.002.027-.015.142.083.223a.26.26 0 00.103.051c.025.007.05.01.07.012l.045-.397-.016-.002a.169.169 0 01.11.124c.005.023.003.038.003.033l-.397-.044zm-.085.81l.069-.048-.228-.328-.069.047.228.329zm-.951.343a.21.21 0 00.194.033 2.124 2.124 0 00.118-.049 9.226 9.226 0 00.639-.327l-.227-.33v.001c-.002 0-.002.001-.003.002a.429.429 0 01-.038.022 10.98 10.98 0 01-.602.297c-.008.003-.01.003-.006.003l.02-.005a.19.19 0 01.038-.003c.01 0 .065.002.117.044l-.25.312zm.075-.74a29.906 29.906 0 00-.136.492.852.852 0 00-.013.068.221.221 0 00.005.071.2.2 0 00.052.094l.284-.282a.2.2 0 01.057.158l-.001.008.005-.022.029-.11c.025-.094.062-.224.103-.367l-.385-.11zm.157-.244l-.129.185.329.228.128-.185-.328-.228zm.391.008a1.536 1.536 0 01-.08-.022c-.005-.003-.003-.003.002.002a.102.102 0 01.028.033l-.354.186a.33.33 0 00.17.148c.05.02.105.033.14.042l.094-.389zm.271.126a.408.408 0 00-.15-.091c-.043-.016-.09-.027-.12-.035l-.096.389c.037.009.06.014.078.021.02.007.015.009.005-.001l.283-.283zm.153.154l-.153-.154-.283.283.153.153.283-.282zm-1.381.098a17.661 17.661 0 01-.146.425v-.001l.005-.009.016-.024.313.25c.016-.02.025-.04.026-.042a17.782 17.782 0 00.166-.476l-.38-.123zm.187.25a.215.215 0 01.052-.107.146.146 0 01.008-.01l.003-.002.001-.001h-.001l-.005.004a.123.123 0 01-.028.01.174.174 0 01-.213-.157c0-.009.001-.006-.005.015l.382.119a.462.462 0 00.023-.126.246.246 0 00-.068-.18.226.226 0 00-.218-.058.31.31 0 00-.11.056.618.618 0 00-.216.378l.395.058zm-.297.125a.192.192 0 01.284.02.153.153 0 01.016.025c.005.013.002.012-.001-.014a.652.652 0 01-.001-.16l-.397-.052a.99.99 0 00.002.267.465.465 0 00.033.127c.007.014.033.071.097.106a.209.209 0 00.25-.037l-.283-.282zm-2.724.174a.204.204 0 00.035-.047.296.296 0 00.025-.054l.034-.088a8.22 8.22 0 00.087-.256l-.38-.123a7.95 7.95 0 01-.111.316l-.006.015.003-.006c0-.002.003-.006.007-.012a.19.19 0 01.023-.028l.283.283zm-.355.008c.04.02.082.037.123.047.02.004.048.01.08.009a.22.22 0 00.167-.08l-.313-.25a.188.188 0 01.136-.07l.022.001a.194.194 0 01-.036-.014l-.18.357zm-.242-.318c.015.06.035.13.08.191a.434.434 0 00.16.126l.183-.355c-.038-.02-.03-.02-.021-.008.004.005.004.006 0-.001a.492.492 0 01-.014-.05l-.388.097zm.056-.402c-.028.048-.069.115-.08.195-.01.078.011.154.024.206l.389-.095a.911.911 0 01-.014-.063c-.002-.01 0-.005-.002.004-.001.01-.004.013 0 .006a.781.781 0 01.029-.053l-.346-.2zm.473-.369a.77.77 0 00-.472.367l.344.204a.372.372 0 01.224-.183l-.096-.388zm.373.264a.22.22 0 00.01-.134.207.207 0 00-.106-.137.222.222 0 00-.099-.024.406.406 0 00-.087.01 3.071 3.071 0 00-.09.02l.094.39a.807.807 0 01.077-.018c.021-.005.015-.002 0-.002a.18.18 0 01-.079-.02.192.192 0 01-.098-.127c-.01-.041-.003-.074-.002-.08l.004-.012.376.134zm-.076.228l.052-.157.016-.048.004-.012-.368-.157-.032.09a47.91 47.91 0 00-.052.158l.38.126zm-.049.146l.049-.146-.38-.126-.048.146.38.126zm.29-.127c.037.158.11.348.205.535l.356-.18a2.078 2.078 0 01-.17-.444l-.39.09zm.04-.084a.129.129 0 01-.053-.03c-.017-.016-.022-.03-.021-.028a2.001 2.001 0 01.034.138l.392-.08a1.132 1.132 0 00-.061-.22.31.31 0 00-.07-.103.271.271 0 00-.115-.063l-.107.386zm.06.078a2.213 2.213 0 01.047-.143l-.009.012a.143.143 0 01-.1.048h-.018l.02.005.106-.386c-.023-.006-.073-.02-.126-.018a.255.255 0 00-.185.09.423.423 0 00-.071.13c-.015.041-.03.091-.048.148l.384.114zm-.086.277c.03-.093.061-.196.085-.276l-.382-.116-.085.272.382.12zm0 0l-.382-.12v.001l.382.12zm0 .001l-.382-.12.381.12zm-.05.158l.05-.159-.382-.118-.05.158.383.119zm-.063.203l.064-.203-.382-.119-.064.204.382.118zm.119-.2l-.27-.055-.08.392.269.055.08-.391zm.384.069a6.17 6.17 0 01-.385-.069l-.079.393c.142.028.334.065.422.074l.042-.398zm.14.016l-.138-.016-.046.398.137.015.046-.397zm-.34.017l.137.272.358-.18-.137-.272-.358.18zm.833-.638l-.274-.132-.174.36.274.132.174-.36zm-.058.45l.121-.138-.3-.264-.121.137.3.265zm-.128.194a.82.82 0 01.127-.193l-.298-.267c-.08.09-.17.227-.206.325l.377.135zm-.108.214c.029-.028.045-.063.048-.067a1.923 1.923 0 00.06-.146l-.377-.136a1.551 1.551 0 01-.04.1l.002-.004a.177.177 0 01.024-.03l.283.283zm-.684-.937c0 .044.01.091.018.13.01.04.024.086.039.132a3.756 3.756 0 00.24.554c.018.033.042.07.069.101.01.012.039.043.082.062a.208.208 0 00.243-.05l-.297-.267a.192.192 0 01.22-.047.168.168 0 01.05.035 2.26 2.26 0 01-.126-.25 3.374 3.374 0 01-.101-.263 1.303 1.303 0 01-.03-.1c-.007-.031-.007-.041-.007-.037h-.4zm.702-.054a3.133 3.133 0 00-.354-.151.352.352 0 00-.162-.017.224.224 0 00-.186.222h.4c0 .02-.005.065-.039.108a.176.176 0 01-.134.066.08.08 0 01-.01 0l.013.003c.048.015.14.054.301.13l.171-.361zm1.094.75c-.024 0-.186.012-.346.025l.032.398.22-.016.094-.007v-.4zm-.73-.105c.139.085.303.198.425.29.062.048.108.086.134.11.016.015.014.015.006.004a.19.19 0 01-.03-.102.196.196 0 01.175-.196l.04.398a.204.204 0 00.166-.29.23.23 0 00-.021-.037.444.444 0 00-.064-.07c-.04-.038-.1-.085-.164-.135a5.905 5.905 0 00-.458-.313l-.209.341zm-.085-.08a.196.196 0 01-.074-.014l.002.001.034.02c.032.017.075.043.122.072l.212-.34a4.2 4.2 0 00-.21-.12.251.251 0 00-.02-.007c-.001 0-.03-.011-.066-.011v.4zm.031.052a2.57 2.57 0 01.09-.093l-.004.003a.172.172 0 01-.044.025.195.195 0 01-.073.014v-.4a.202.202 0 00-.102.028l-.024.015a2.876 2.876 0 00-.138.138l.295.27zm-.175.304a.668.668 0 01.174-.302l-.292-.273a1.058 1.058 0 00-.275.501l.393.074zm-.016.083l.016-.082-.393-.076-.016.082.393.076zm.085-.222l-.27-.016-.023.4.269.015.024-.399zm.548-.008c-.162.01-.412.016-.55.008l-.021.4c.158.008.425.002.596-.008l-.025-.4z"
        fill="#000"
      />
      <path
        d="M19.569 10.892v3.22H6.588v-3.417c.013.054.212.121.352.176.256.095.275.095.525-.082.339-.239.55-.232.933.027.576.39.73.396.902.055.128-.266.416-.266.908.007.21.116.428.204.492.204.058 0 .199-.109.307-.238.243-.3.384-.28 1.01.109.506.32.678.34.73.075.07-.334.127-.389.422-.389.179.007.447.089.722.225.237.123.48.218.525.218.05 0 .108-.095.134-.211a.565.565 0 01.172-.307c.173-.116.352-.068.915.239.563.3.723.273.723-.13 0-.123.121-.204.306-.204.058 0 .295.123.531.28.512.327.652.327.697-.008.045-.34.256-.347.806-.04.41.238.869.335.869.191z"
        fill="#0091C8"
      />
      <path
        d="M6.636 10.811c.013.055.147.137.287.191.255.096.274.096.523-.082.338-.238.549-.231.931.028.574.388.727.395.9.054.127-.266.414-.266.905.007.21.116.428.205.491.205.058 0 .198-.11.306-.239.243-.3.383-.28 1.008.11.504.32.676.34.727.074.07-.334.128-.389.421-.389.179.007.447.09.721.226.236.122.478.218.523.218.051 0 .108-.096.134-.212a.566.566 0 01.172-.307c.172-.116.35-.068.912.24.562.3.72.272.72-.13 0-.123.122-.205.307-.205.058 0 .294.123.53.28.51.327.65.327.695-.007.044-.341.255-.348.803-.041.409.239.791.32.791.177"
        stroke="#fff"
        stroke-width=".5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="PN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.943 7.032s.057.643-.069 1.007c-.126.364-.19.575-.19.343 0-.233-.09-.418-.16-.418-.072 0-.015.231-.087.231s-.319.04-.319-.095c0-.136-.032.363.128.407.16.045-.078.183-.184.14 0 0 .437.143.609.265 0 0 .513.646.994.567 0 0-.654-.227-.54-.662.116-.435.54-.497.54-.497s.199.067.193.242c-.006.175.146-.055.146-.055s.024-.222-.003-.276c-.027-.054.456-.158.486-.387 0 0-.493.023-.527-.036-.034-.058.153-.15.095-.264-.059-.115-.93.651-.93.651s.301-.521.301-.801-.076-.471-.3-.471c-.224 0-.183.109-.183.109zm4.531.153h.001c.032-.031.232-.217.4-.07.182.16-.093.315-.093.315s.129.125.276.125c.147 0 .183-.125.183-.125s.011.279.49.385c0 0 .17-.247 0-.383 0 0 .202-.042.187-.206 0 0-.166.057-.284-.074-.119-.131-.35-.191-.517-.161-.426-.155-.618.149-.643.194z"
            fill="#5EAA22"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.569 8.593s.495.938.186 1.132c-.31.194 1.472.056 1.64 0 .168-.056-.034-.352-.22-.434-.187-.082-.952-.355-1.156-.561-.203-.206-.079-.28.085-.483.164-.203.771-.285.771-.475s.385-.974.654-1.033c.27-.059.124-.152.062-.152s-.434.386-.575.316c-.14-.07-.158-.064 0-.233.159-.168.278-.362.069-.223-.21.14-.555.36-.72.36-.167 0-.757-.075-.684.096.074.171.105.468.423.669.319.2.18.347-.085.54-.264.194-.45.48-.45.48z"
            fill="#96877D"
          />
          <path
            d="M17.856 7.352l-.944 1.906s-.028.538.647.18c.675-.36.648-.614.843-.614.195 0 .256-.108.256-.108l-.13-.103s-.014-.187.068-.23c0 0-.161-.088-.184-.014-.023.075-.137-.156-.072-.156 0 0-.142.232-.172.322 0 0-.206-.084-.196-.474a2.01 2.01 0 00-.116-.709zm-4.493-.302s-.48.113-.429.23c.052.117.128-.003-.107.138 0 0-.413.322-.504.287-.09-.035.064.081.064-.287s-.24-.068 0-.314c.24-.245.324-.054.44-.195.115-.141.012-.066.325-.066s.21.207.21.207zm1.467 1.894s-1.346 1.065-1.615 1.144c-.27.08.553-.021.754-.162.2-.14.86-.982.86-.982z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.498 10.812s.129.839-.208.756a10.141 10.141 0 01-.478-.125s.124.39.3.39c0 0 .302.591.186.778 0 0 .519-.424.435-.76-.084-.337.134.055.134.055s.19.093.329-.01c.138-.104-.002-.058-.14-.256-.138-.197-.104-.751-.523-1.038-.42-.287-.518-.278-.518-.278s-.309-.509-.124-.475c0 0 1.327.458 1.362.575.034.117.386.096.21-.24-.176-.335-1.124-.538-1.237-.632-.113-.095-.008-.454-.21-.532-.204-.078-.757-.633-.757-.9 0-.268-.26-.394-.487-.394-.227 0-.654-.066-.834-.066-.18 0-.348.304-.174.304s.025.568-.266.692c-.292.125-.517.303-.85.303-.333 0 .471.29.6.175.128-.114.086-.284.516-.478.43-.193.842-.308.79-.154-.053.154.08.412.283.319.203-.093.268-.329.268-.165 0 .165.311 1.009.549 1.338.237.33.844.818.844.818z"
            fill="#5EAA22"
          />
          <path
            d="M14.666 7.73s-.157.253 0 .253c.158 0 .412 0 .258-.127-.155-.126-.258-.126-.258-.126zm.528-.006s0 .168.11.168.207.168.207 0 .152-.113-.083-.168c-.234-.056-.234 0-.234 0zm.673.038s-.105.08-.052.223c.052.142.171.424 0 .424-.172 0-.314.102-.18.102.135 0 .374.102.374 0s.097.168.097 0v-.346c0-.099.097-.127 0-.265s-.239-.138-.239-.138zm.243.981s.22.696.34.786c.12.09.173.846.226.928.052.082.767.497.767.72 0 .223.22-.171.11-.392-.11-.22-.457-.69-.706-.792-.249-.102-.217-.35-.27-.524-.052-.175.31.14 0-.255s-.302-.183-.214-.183c.087 0 .174-.046.087-.108-.087-.061-.34-.18-.34-.18zm-2.328 1.436s-.714 1.269-.841 1.334c-.128.066-.223.08-.288 0-.065-.079-.072.212 0 .292.072.079.287.079.407-.062 0 0 .02.357.205.626.187.269.264.195.264.347 0 .152.045.353.101.353.057 0 .101.48 0 .48-.1 0 .234.039.38-.081s.209-.211.178-.211c-.032 0-.406-.199-.406-.34 0-.14-.252-.25-.252-.458 0-.209-.131-.457-.131-.556 0-.098.112.038.232-.055.12-.094.15-.335.15-.335s-.188.128-.252.064c-.063-.064-.261-.19-.13-.406.13-.216.383-.992.383-.992z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.018 6.177s-.255.115-.17.285c.085.17.116.245.17.208.055-.038.438-.11.352-.3-.086-.193-.265-.193-.265-.193h-.087z"
            fill="#5EAA22"
          />
          <path
            d="M15.905 6.086s-.338-.15-.225 0c.112.15.256.23.36.23.103 0 .319-.032.21-.093a2.632 2.632 0 00-.345-.137z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.573 9.992c.001-.008-.01-.015-.016-.008-.07.067-.282.292-.192.489.107.233.214.314.214.314s.065.357.199.455c0 0 .18-.01.19-.288 0 0 .306-.09.396.102 0 0-.06.022-.06.186 0 .163.14.34.14.34s.063-.564.348-.928c.285-.364.367-.436.367-.436v-.41s-.59.485-.716.888c0 0-.297.01-.418-.042-.12-.051.15-.136 0-.32-.15-.182-.082.259-.247.139-.26-.073-.223-.384-.205-.48z"
            fill="#5EAA22"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.859 9.638h3.024v1.86s-.246 1.52-1.563 2.269c0 0-1.276-.76-1.461-2.27v-1.86z"
            fill="#5EAA22"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="13"
            y="9"
            width="4"
            height="5"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.859 9.638h3.024v1.86s-.246 1.52-1.563 2.269c0 0-1.276-.76-1.461-2.27v-1.86z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.297 9.537l-1.322 2.76 1.792-1.638 1.234 2.058v-3.18l-1.234 1.018-.47-1.018z"
              fill="#58A5FF"
            />
            <path
              d="M15.255 11.527a.099.099 0 11.197 0v1.774a.099.099 0 11-.197 0v-1.774z"
              fill="#FFD018"
            />
            <path
              d="M14.913 11.965a.097.097 0 110-.195h.89a.098.098 0 010 .195h-.89zm.585 1.474l-.086.07c-.127-.155-.242-.23-.345-.23-.15 0-.272-.126-.372-.365l.103-.043c.084.203.176.297.27.297.142 0 .284.092.43.27z"
              fill="#FFD018"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.595 12.532h-.001v.541c0 .001 0 .002.001.001l.404-.167v-.002l-.404-.373z"
              fill="#FFD018"
            />
            <path
              d="M15.319 13.439l.086.07c.127-.155.242-.23.345-.23.15 0 .272-.126.372-.365l-.103-.043c-.084.203-.176.297-.27.297-.142 0-.284.092-.43.27z"
              fill="#FFD018"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.221 12.532h.002v.541c0 .001 0 .002-.001.001l-.404-.167v-.002l.403-.373z"
              fill="#FFD018"
            />
            <path fill="#fff" d="M15.155 10.732h.394v.592h-.394z" />
          </g>
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="d"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#d)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="e"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#e)"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="PR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#EF0000"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M0 5h-1.25v5h22.5V5H0z"
            fill="#EF0000"
            stroke="#F7FCFF"
            stroke-width="2.5"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15l11.25-7.5L0 0z"
          fill="#3D58DB"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15l11.25-7.5L0 0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.18 8.886l-2.295 1.21 1.117-2.433-1.424-1.3 1.758-.065.844-2.2.644 2.2h1.754l-1.17 1.365.931 2.434-2.16-1.211z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="PS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#F7FCFF" />
        <path d="M0 0v5h20V0H0z" fill="#5EAA22" />
        <path d="M0 10v5h20v-5H0z" fill="#272727" />
        <path d="M0 1.25L10 7.5 0 13.75V1.25z" fill="#E31D1C" />
      </g>
    </symbol>
    <symbol id="PT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 0h15v15H5V0z"
          fill="#EF0000"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h7.5v15H0V0z"
          fill="#2F8D00"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="2"
          y="2"
          width="11"
          height="11"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.44 12.38c-2.662 0-4.82-2.185-4.82-4.88-.001-2.695 2.158-4.88 4.82-4.88 2.663 0 4.822 2.185 4.822 4.88s-2.159 4.88-4.822 4.88z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill="#FFE017">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.143 2.5h.625v1.687h-.625V2.5zm0 8.434h.625V12.5h-.625v-1.566z"
          />
          <path
            d="M2.697 7.752l-.175-.448c1.928-.77 3.383-1.266 4.37-1.49a36.708 36.708 0 014.777-.729l.042.48a36.242 36.242 0 00-4.714.72c-.958.216-2.393.706-4.3 1.467z"
          />
          <path
            d="M11.963 4.79l-.142.46c-1.457-.46-2.644-.658-3.557-.597l-.031-.48c.98-.066 2.221.14 3.73.617zm.504 2.572l-.27.398c-.742-.516-1.657-.775-2.751-.775v-.482c1.186 0 2.195.286 3.021.86z"
          />
          <path
            d="M12.064 7.507l.123.465c-1.602.434-3.105.68-4.511.738-1.416.058-3.066-.189-4.952-.74l.132-.462c1.84.537 3.44.777 4.8.72 1.37-.056 2.839-.296 4.408-.721z"
          />
          <path
            d="M11.882 9.772l-.752.772C9.7 9.115 8.44 8.094 7.36 7.48c-1.1-.624-2.533-1.258-4.298-1.9l.362-1.02c1.817.66 3.303 1.317 4.46 1.975 1.175.667 2.505 1.747 3.998 3.238zm-8.471.438l-.284-.387a5.802 5.802 0 01.742-.451c.531-.27 1.064-.438 1.573-.453l.074-.001V9.4h-.06c-.428.013-.899.162-1.374.403a5.335 5.335 0 00-.67.407z"
          />
          <path
            d="M3.633 10.377l.12-.467c1.587.418 2.811.627 3.665.627.851 0 2.118-.246 3.792-.74l.133.463c-1.714.505-3.02.759-3.925.759-.902 0-2.162-.215-3.785-.642zm-.619-4.318l.754-.77 1.105 1.109-.754.77-1.105-1.109z"
          />
          <path
            d="M9.272 9.905l.562-.924 1.752 1.09-.561.924-1.753-1.09z"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.619 7.5c0 2.695 2.159 4.88 4.821 4.88 2.663 0 4.822-2.185 4.822-4.88S10.103 2.62 7.44 2.62c-2.662 0-4.82 2.185-4.82 4.88zm9.048.06c0 2.33-1.866 4.217-4.167 4.217-2.301 0-4.167-1.888-4.167-4.217 0-2.329 1.866-4.217 4.167-4.217 2.301 0 4.167 1.888 4.167 4.217z"
          fill="#F9E813"
        />
        <path
          d="M4.785 4.49v3.914c.258 1.549 1.126 2.323 2.604 2.323 1.478 0 2.346-.774 2.603-2.323V4.49H4.785z"
          fill="#fff"
        />
        <path
          d="M4.428 4.13h5.921v4.304l-.005.03c-.286 1.72-1.3 2.624-2.955 2.624-1.656 0-2.67-.904-2.956-2.624l-.005-.03V4.129z"
          fill="#C51918"
        />
        <path
          d="M5.783 5.444h3.212V8.22s-.238 1.433-1.606 1.433S5.783 8.22 5.783 8.22V5.444z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 4.428h.452v.3H5v-.3z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.762 4.548h.833v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.762 4.669h.452v.15h-.452v-.15zm.476 0h.452v.15h-.452v-.15zm-.476.361h.301v.452h-.301V5.03zm.595 0h.301v.452h-.3V5.03zm-.238 0h.15v.452h-.15V5.03z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.762 4.91h.833v.15h-.833v-.15zm0 .361h.833v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.881 4.79h.15v.15h-.15v-.15zm.476 0h.15v.15h-.15v-.15zm-.238-.121h.15v.3h-.15v-.3zm2.143-.241h.452v.3h-.452v-.3z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.024 4.548h.833v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.024 4.669h.452v.15h-.452v-.15zm.476 0h.452v.15H7.5v-.15zm-.476.361h.301v.452h-.301V5.03zm.595 0h.301v.452h-.3V5.03zm-.238 0h.15v.452h-.15V5.03z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.024 4.91h.833v.15h-.833v-.15zm0 .361h.833v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.143 4.79h.15v.15h-.15v-.15zm.476 0h.15v.15h-.15v-.15zm-.238-.121h.15v.3h-.15v-.3zm2.024-.241h.452v.3h-.452v-.3z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.167 4.548H10v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.167 4.669h.451v.15h-.451v-.15zm.476 0h.452v.15h-.452v-.15zm-.476.361h.3v.452h-.3V5.03zm.595 0h.301v.452h-.301V5.03zm-.238 0h.15v.452h-.15V5.03z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.167 4.91H10v.15h-.833v-.15zm0 .361H10v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.286 4.79h.15v.15h-.15v-.15zm.476 0h.15v.15h-.15v-.15zm-.238-.121h.15v.3h-.15v-.3zm-.119 1.927h.452v.302h-.452v-.302z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.167 6.717H10v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.167 6.837h.451v.15h-.451v-.15zm.476 0h.452v.15h-.452v-.15zm-.476.362h.3v.452h-.3v-.452zm.595 0h.301v.452h-.301v-.452zm-.238 0h.15v.452h-.15v-.452z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.167 7.078H10v.15h-.833v-.15zm0 .362H10v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.286 6.958h.15v.15h-.15v-.15zm.476 0h.15v.15h-.15v-.15zm-.238-.121h.15v.302h-.15v-.302zM5 6.596h.452v.302H5v-.302z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.762 6.717h.833v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.762 6.837h.452v.15h-.452v-.15zm.476 0h.452v.15h-.452v-.15zm-.476.362h.301v.452h-.301v-.452zm.595 0h.301v.452h-.3v-.452zm-.238 0h.15v.452h-.15v-.452z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.762 7.078h.833v.15h-.833v-.15zm0 .362h.833v.15h-.833v-.15z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.881 6.958h.15v.15h-.15v-.15zm.476 0h.15v.15h-.15v-.15zm-.238-.121h.15v.302h-.15v-.302zm.171 2.478l.29-.346.231.193-.29.347-.231-.194z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.23 9.575l.535-.639.115.097-.536.639-.115-.097z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.321 9.652l.29-.346.116.097-.29.346-.116-.097zm.306-.365l.29-.346.116.097-.29.346-.116-.097zm-.029.598l.194-.231.346.29-.194.231-.346-.29zm.382-.456l.194-.231.347.29-.194.231-.346-.29zm-.152.182l.097-.115.346.29-.097.115-.346-.29z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.506 9.807l.536-.638.115.097-.536.638-.115-.097zm.277.233l.536-.639.115.097-.536.638-.115-.096z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.49 9.638l.097-.115.115.097-.096.115-.116-.097zm.306-.364l.097-.116.115.097-.096.116-.116-.097zm-.245.105l.097-.116.23.194-.096.115-.231-.193zm3.811-.338l.29.346-.23.194-.291-.346.23-.194z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.116 8.936l.536.639-.116.097-.535-.639.115-.097z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.024 9.014l.29.346-.115.097-.29-.346.115-.097zm.306.365l.29.346-.115.097-.29-.347.115-.096zm-.583-.133l.194.23-.346.291-.194-.23.346-.29zm.383.456l.193.23-.346.291-.193-.23.346-.29zm-.153-.182l.096.115-.346.29-.097-.115.347-.29z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.84 9.169l.535.638-.115.097-.536-.638.115-.097zm-.278.232l.536.639-.115.096-.536-.638.115-.097z"
          fill="#060101"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.008 9.182l.097.116-.115.097-.097-.116.115-.097zm.306.365l.097.116-.115.096-.097-.115.115-.097zm-.061-.26l.097.116-.23.193-.097-.115.23-.194z"
          fill="#F9E813"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.849 5.753h-.825v.6s.061.311.412.311c.352 0 .413-.31.413-.31v-.601zm-.468.24a.12.12 0 01-.12.121.12.12 0 01-.118-.12.12.12 0 01.119-.12.12.12 0 01.119.12zm-.12.603a.12.12 0 00.12-.12.12.12 0 00-.12-.12.12.12 0 00-.118.12c0 .066.053.12.119.12zm.477-.12a.12.12 0 01-.119.12.12.12 0 01-.119-.12.12.12 0 01.119-.12.12.12 0 01.12.12zm-.298-.12a.12.12 0 00.12-.121.12.12 0 00-.12-.12.12.12 0 00-.119.12c0 .066.054.12.12.12zm.298-.362a.12.12 0 01-.119.12.12.12 0 01-.119-.12.12.12 0 01.119-.12.12.12 0 01.12.12zm.111 1.084h-.825v.601s.061.31.412.31c.352 0 .413-.31.413-.31v-.6zm-.468.241a.12.12 0 01-.12.12.12.12 0 01-.118-.12.12.12 0 01.119-.12.12.12 0 01.119.12zm-.12.603a.12.12 0 00.12-.12.12.12 0 00-.12-.121.12.12 0 00-.118.12c0 .067.053.12.119.12zm.477-.12a.12.12 0 01-.119.12.12.12 0 01-.119-.12.12.12 0 01.119-.121.12.12 0 01.12.12zM7.44 7.68a.12.12 0 00.12-.12.12.12 0 00-.12-.121.12.12 0 00-.119.12c0 .067.054.12.12.12zm.298-.362a.12.12 0 01-.119.12.12.12 0 01-.119-.12.12.12 0 01.119-.12.12.12 0 01.12.12zm1.182-.24h-.825v.601s.061.31.413.31c.351 0 .412-.31.412-.31v-.6zm-.468.241a.12.12 0 01-.119.12.12.12 0 01-.119-.12.12.12 0 01.12-.12.12.12 0 01.118.12zm-.119.603a.12.12 0 00.12-.12.12.12 0 00-.12-.121.12.12 0 00-.119.12c0 .067.054.12.12.12zm.477-.12a.12.12 0 01-.12.12.12.12 0 01-.119-.12.12.12 0 01.12-.121.12.12 0 01.119.12zm-.298-.121a.12.12 0 00.119-.12.12.12 0 00-.12-.121.12.12 0 00-.118.12c0 .067.053.12.119.12zm.298-.362a.12.12 0 01-.12.12.12.12 0 01-.119-.12.12.12 0 01.12-.12.12.12 0 01.119.12zm-2.032-.241h-.826v.601s.062.31.413.31.413-.31.413-.31v-.6zm-.468.241a.12.12 0 01-.12.12.12.12 0 01-.119-.12.12.12 0 01.12-.12.12.12 0 01.119.12zm-.12.603a.12.12 0 00.12-.12.12.12 0 00-.12-.121.12.12 0 00-.119.12c0 .067.054.12.12.12zm.477-.12a.12.12 0 01-.12.12.12.12 0 01-.118-.12.12.12 0 01.119-.121.12.12 0 01.119.12zm-.298-.121a.12.12 0 00.12-.12.12.12 0 00-.12-.121.12.12 0 00-.119.12c0 .067.053.12.119.12zm.298-.362a.12.12 0 01-.12.12.12.12 0 01-.118-.12.12.12 0 01.119-.12.12.12 0 01.119.12zm1.182 1.085h-.825v.6s.061.31.412.31c.352 0 .413-.31.413-.31v-.6zm-.468.24a.12.12 0 01-.12.121.12.12 0 01-.118-.12.12.12 0 01.119-.12.12.12 0 01.119.12zm-.12.603a.12.12 0 00.12-.12.12.12 0 00-.12-.121.12.12 0 00-.118.12.12.12 0 00.119.121zm.477-.12a.12.12 0 01-.119.12.12.12 0 01-.119-.12.12.12 0 01.119-.121.12.12 0 01.12.12zm-.298-.121a.12.12 0 00.12-.12.12.12 0 00-.12-.121.12.12 0 00-.119.12.12.12 0 00.12.121zm.298-.361a.12.12 0 01-.119.12.12.12 0 01-.119-.12.12.12 0 01.119-.12.12.12 0 01.12.12z"
          fill="#013399"
        />
      </g>
    </symbol>
    <symbol id="PW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#61C6F0"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.188 11.25a4.062 4.062 0 100-8.125 4.062 4.062 0 000 8.125z"
            fill="#FBCD17"
          />
        </g>
      </g>
    </symbol>
    <symbol id="PY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M12.188 7.5a2.188 2.188 0 11-4.376 0 2.188 2.188 0 014.375 0z"
            stroke="#272727"
            stroke-width=".625"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#F05234"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#3D58DB"
          />
          <path
            d="M9.174 6.36s-.704.487-.45 1.432c.252.945 1.24.98 1.24.98"
            stroke="#73BE4A"
            stroke-width=".625"
          />
          <path
            d="M10.73 6.36s.704.487.45 1.432c-.253.945-1.24.98-1.24.98"
            stroke="#73BE4A"
            stroke-width=".625"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.002 7.967a.625.625 0 100-1.25.625.625 0 000 1.25z"
            fill="#FBCD17"
          />
        </g>
      </g>
    </symbol>
    <symbol id="QA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path fill="#B61C49" d="M0 0h20v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h4.25L7.5 1.25 4.25 2.5 7.5 3.75 4.25 5 7.5 6.25 4.25 7.5 7.5 8.75 4.25 10l3.25 1.25-3.25 1.25 3.25 1.25L4.25 15H0V0z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="RE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M13.75 0H20v15h-6.25V0z" fill="#F50100" />
        <path d="M0 0h7.5v15H0V0z" fill="#2E42A5" />
        <path d="M6.25 0h7.5v15h-7.5V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="RO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M6.25 0h7.5v15h-7.5V0z" fill="#FBCD17" />
        <path d="M13.75 0H20v15h-6.25V0z" fill="#E11C1B" />
        <path d="M0 0h6.25v15H0V0z" fill="#2E42A5" />
      </g>
    </symbol>
    <symbol id="RS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#4857A1"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#C51918" />
          <path d="M0 10v5h20v-5H0z" fill="#F7FCFF" />
          <path
            d="M7.16 2.377l-.07-.283.194.057v-.004c.824.075 2.1.502 2.337.956.092.175 0 .324-.119.52l-.055.091c-.06.102-.115.2-.166.292-.185.331-.33.59-.55.722l.005.75-3.685-.03-.005-.759c-.188-.141-.323-.382-.491-.683-.052-.092-.106-.19-.166-.292l-.055-.09c-.12-.197-.211-.346-.12-.521.18-.342.988-.673 1.729-.849.146-.051.298-.1.449-.146l.067.049c.059-.008.116-.015.17-.02l.085.19h.3s.181.537.181.836c0 .299-.18.546-.18.546v.206c.03.002.064.006.098.01a.35.35 0 01.005-.057c.018-.098.072-.171.12-.162.05.008.076.095.059.194a.355.355 0 01-.012.046c.195.026.413.063.619.1A5.81 5.81 0 018.17 3.6c.236-.371.444-.697.25-.891a.547.547 0 00-.189-.104 6.008 6.008 0 00-.891-.152l-.01-.049a31.84 31.84 0 00-.17-.027zm1.4 1.8l.168.036v.107c.366-.281.624-.905.648-1.109.014-.123-.182-.265-.488-.394.145.275-.049.548-.292.89a5.67 5.67 0 00-.28.42l.089.017a.34.34 0 01.011-.092c.026-.097.087-.165.135-.152.048.013.066.102.04.199a.334.334 0 01-.031.078zm-1.883-.26v-.23s-.157-.176-.18-.54a2.929 2.929 0 01.068-.723c-.234.03-.481.076-.72.133-.159.044-.285.095-.341.152-.194.194.014.52.25.891.088.14.18.284.258.431.133-.029.267-.055.392-.076a.346.346 0 01-.011-.063c-.01-.1.024-.184.074-.188.05-.005.097.072.106.172a.352.352 0 010 .052l.104-.012zm-1.07.208a5.616 5.616 0 00-.279-.418c-.249-.35-.446-.627-.282-.908-.358.139-.6.29-.586.412.022.193.254.76.587 1.06.024-.007.153-.043.334-.09a.334.334 0 01-.035-.076c-.031-.095-.018-.185.03-.2.048-.016.111.049.142.144.01.033.016.065.017.094l.073-.018z"
            fill="#F6C540"
          />
          <path
            d="M7.283 2.191c0 .22-.183.398-.408.398a.403.403 0 01-.408-.398c0-.22.183-.398.408-.398.225 0 .408.179.408.398zm-.408 2.954c.175 0 .317-.081.317-.181 0-.1-.142-.181-.317-.181-.175 0-.317.08-.317.18 0 .1.142.182.317.182zM5.29 5.1a.136.136 0 11-.272 0 .136.136 0 01.272 0zm3.623 0a.136.136 0 11-.272 0 .136.136 0 01.272 0z"
            fill="#2E42A5"
          />
          <path
            d="M6.196 5.01c0 .074-.102.135-.227.135s-.226-.06-.226-.136c0-.075.101-.136.226-.136s.227.061.227.136zm1.902 0c0 .074-.102.135-.227.135s-.226-.06-.226-.136c0-.075.101-.136.226-.136s.227.061.227.136z"
            fill="#C5363C"
          />
          <path
            d="M7.645 3.877c0 .1-.04.181-.09.181-.05 0-.091-.081-.091-.181 0-.1.04-.181.09-.181.05 0 .09.08.09.18zm-1.363-.028c.03.095.017.185-.03.2-.048.016-.112-.05-.142-.144-.031-.095-.018-.185.03-.2.047-.016.11.049.142.144zm-1.066.491c.048-.016.061-.105.03-.2-.03-.095-.094-.16-.142-.145-.047.016-.06.106-.03.2.031.096.095.16.142.145zM8.8 4.217c-.053.085-.13.132-.172.106-.043-.027-.034-.117.019-.202.053-.085.13-.132.173-.106.042.027.033.117-.02.202z"
            fill="#F7FCFF"
          />
          <path
            d="M6.106 2.37a.153.153 0 10-.047-.192.152.152 0 00-.219.04.153.153 0 00-.25.132.153.153 0 00-.27.074.153.153 0 00-.27.062.152.152 0 00-.235.076.153.153 0 00-.22.11.153.153 0 00-.183.148.154.154 0 00-.181.151c0 .01.001.021.003.031a.153.153 0 00-.089.292.154.154 0 00.091.181.154.154 0 00.142.192.153.153 0 10.103-.034.153.153 0 00-.04-.26.153.153 0 00-.09-.182.153.153 0 00.002-.07.153.153 0 00.184-.148.154.154 0 00.179-.124.154.154 0 00.176-.102.152.152 0 00.158-.013.16.16 0 00.026.056.153.153 0 00.117.244.153.153 0 00.04.26.153.153 0 00.09.181.153.153 0 10.205-.102.153.153 0 00-.09-.182A.153.153 0 005.296 3a.153.153 0 00.027-.21.152.152 0 000-.18.152.152 0 00.028-.068.153.153 0 00.272-.108.153.153 0 00.248-.013.152.152 0 00.235-.05zm-.996.272a.152.152 0 00.213-.033.153.153 0 00-.124-.063.028.028 0 100-.056.028.028 0 000 .056.152.152 0 00-.09.03.153.153 0 00-.06-.09.154.154 0 00.027.123.152.152 0 00-.026.125.153.153 0 00.06-.092zm0 0a.154.154 0 01-.034-.033.154.154 0 01.033-.034.153.153 0 01.001.067zm.09.21a.153.153 0 01-.124-.062.153.153 0 01.247 0 .153.153 0 01-.124.062zm0 0a.028.028 0 110 .057.028.028 0 010-.057zm0-.125a.028.028 0 110-.056.028.028 0 010 .056zm.328.646a.152.152 0 00-.205.102.153.153 0 00.205-.102zm-.09-.182a.152.152 0 00-.206.103.153.153 0 00.206-.103zM5.296 3H5.29a.152.152 0 00-.097.034H5.2A.15.15 0 005.297 3zm-.815.634h-.006a.152.152 0 00-.097.034h.006a.15.15 0 00.097-.034zm-.04-.26a.153.153 0 01-.205.102.153.153 0 01.205-.102zm-.09-.182a.153.153 0 01-.206.103.153.153 0 01.206-.103zm-.117-.189c.013.06.06.107.119.119a.153.153 0 00-.119-.119zm.303-.029a.153.153 0 01-.125-.15V2.82a.153.153 0 01.125.15v.002zm.179-.124a.153.153 0 01-.12-.176.153.153 0 01.12.176zm.176-.102a.153.153 0 01-.077-.185.153.153 0 01.077.185zm.459-.206a.152.152 0 01-.031-.117.152.152 0 01.03.117zm.24-.19c.002.03.014.06.032.082a.152.152 0 00-.033-.082zm.28.069a.153.153 0 01-.03-.201.153.153 0 01.03.201zm.235-.05a.153.153 0 01-.047-.192.153.153 0 01.047.192zm-1.54.481a.028.028 0 100-.056.028.028 0 000 .056zM4.384 3a.028.028 0 100-.056.028.028 0 000 .056zm-.181.181a.028.028 0 100-.056.028.028 0 000 .056zm.09.181a.028.028 0 100-.056.028.028 0 000 .056zm.091.182a.028.028 0 100-.057.028.028 0 000 .057zm.119.243a.028.028 0 11-.056 0 .028.028 0 01.056 0zm.243-1.059a.028.028 0 100-.056.028.028 0 000 .056zm.214-.089a.028.028 0 100-.056.028.028 0 000 .056zm.511-.163a.028.028 0 100-.056.028.028 0 000 .056zm.272-.11a.028.028 0 100-.056.028.028 0 000 .056zm.226-.035a.028.028 0 100-.056.028.028 0 000 .056zm.227-.056a.028.028 0 100-.056.028.028 0 000 .056zm-.906.906a.028.028 0 100-.056.028.028 0 000 .056zm.09.181a.028.028 0 100-.056.028.028 0 000 .056zm.091.182a.028.028 0 100-.057.028.028 0 000 .057zm3.986.271a.028.028 0 100-.056.028.028 0 000 .056zm-.154-.028a.153.153 0 10.25-.119.153.153 0 00.142-.192.153.153 0 00.09-.18.153.153 0 00-.088-.293.154.154 0 00-.178-.181.153.153 0 00-.183-.148.153.153 0 00-.22-.11.153.153 0 00-.234-.077.153.153 0 00-.27-.062.153.153 0 00-.271-.073.154.154 0 00-.153-.167.152.152 0 00-.097.035.153.153 0 00-.218-.041.153.153 0 10-.047.192.153.153 0 00.234.05.153.153 0 00.248.013v.014a.153.153 0 00.273.094.152.152 0 00.027.068.152.152 0 000 .18.152.152 0 00.027.21.153.153 0 00-.142.192.153.153 0 00-.09.182.153.153 0 10.205.102.153.153 0 00.09-.18.153.153 0 00.04-.262.153.153 0 00.117-.243.152.152 0 00.026-.056.152.152 0 00.158.013.153.153 0 00.176.102.153.153 0 00.18.124.153.153 0 00.183.148.154.154 0 00.002.07.153.153 0 00-.09.182.153.153 0 00-.04.26.153.153 0 00-.147.153zm-.482-1.144a.152.152 0 01-.213-.033.153.153 0 01.214-.034.153.153 0 000 .067zm.034-.033a.152.152 0 01.026.125.153.153 0 01-.06-.092.154.154 0 00.034-.033zm0 0a.154.154 0 00-.033-.034.153.153 0 01.06-.09.154.154 0 01-.027.124zm-.123-.063a.028.028 0 110-.056.028.028 0 010 .056zm0 .306a.153.153 0 01-.124-.062.153.153 0 01.247 0 .153.153 0 01-.123.062zm0 0a.028.028 0 110 .057.028.028 0 010-.057zm0-.125a.028.028 0 110-.056.028.028 0 010 .056zm-.124.748a.153.153 0 00-.205-.102.153.153 0 00.205.102zm.09-.18a.153.153 0 00-.205-.104.153.153 0 00.206.103zm.04-.262A.152.152 0 008.64 3h-.006c.027.022.06.035.097.035h.006zm-.912-.663a.153.153 0 00.046-.192.153.153 0 00-.046.192zm.234.05a.153.153 0 00.031-.201.153.153 0 00-.031.201zm.28-.07a.152.152 0 01-.032.083.152.152 0 01.033-.082zm.24.191a.152.152 0 00.031-.117.152.152 0 00-.03.117zm.46.206a.153.153 0 00.076-.185.153.153 0 00-.077.185zm.175.102a.153.153 0 00.12-.176.153.153 0 00-.12.176zm.363.272a.153.153 0 00.119-.119.153.153 0 00-.119.119zm-.059-.3v.002a.153.153 0 01-.125.15v-.002c0-.075.054-.137.125-.15zm.061.37a.152.152 0 01.206.103.153.153 0 01-.206-.103zm-.09.182a.152.152 0 01.205.102.153.153 0 01-.205-.102zm.057.295a.152.152 0 01-.096-.035h.006c.036 0 .07.013.096.034h-.006zm0-.125a.028.028 0 100-.057.028.028 0 000 .057zm.09-.182a.028.028 0 100-.056.028.028 0 000 .056zm.091-.18a.028.028 0 100-.057.028.028 0 000 .056zM9.548 3a.028.028 0 100-.056.028.028 0 000 .056zm-.182-.148a.028.028 0 100-.056.028.028 0 000 .056zm-.181-.124a.028.028 0 100-.056.028.028 0 000 .056zm-.214-.089a.028.028 0 100-.056.028.028 0 000 .056zm-.51-.163a.028.028 0 100-.056.028.028 0 000 .056zm-.273-.11a.028.028 0 100-.056.028.028 0 000 .056zm-.225-.035a.028.028 0 100-.056.028.028 0 000 .056zm-.227-.056a.028.028 0 100-.056.028.028 0 000 .056zm.905.906a.028.028 0 100-.056.028.028 0 000 .056zm-.09.181a.028.028 0 100-.056.028.028 0 000 .056zm-.09.182a.028.028 0 100-.057.028.028 0 000 .057z"
            fill="#fff"
          />
          <path
            d="M6.939 1.346l-.135.003v.22h-.247l.003.134h.245v.252l.134-.002v-.25h.244L7.18 1.57h-.241v-.223z"
            fill="#F6C540"
          />
          <path
            d="M3.615 5.459h6.5v5.52s-.196 2.75-3.25 2.75c-3.053 0-3.25-2.75-3.25-2.75V5.46z"
            fill="#C51918"
          />
          <path
            d="M5.577 5.65c-.06 0-.151.043-.273.091-.121.049-.25.153-.124.258.124.105.303.335.303.249 0-.086.213-.17.213-.128 0 .042-.066.128.107.128s.262.051.078.051c-.185 0-.205.085-.325.085-.12 0-.376-.085-.376-.136 0-.05.148.248.303.248s.242.146.32.073c.078-.073.069-.073.194-.073s.08-.293.08-.293-.44-.553-.5-.553zm2.509 0c.06 0 .151.043.273.091.121.049.249.153.124.258-.124.105-.303.335-.303.249 0-.086-.213-.17-.213-.128 0 .042.066.128-.107.128s-.263.051-.078.051.205.085.325.085c.12 0 .376-.085.376-.136 0-.05-.148.248-.303.248s-.243.146-.32.073c-.078-.073-.069-.073-.194-.073s-.08-.293-.08-.293.44-.553.5-.553z"
            fill="#E8AA00"
          />
          <path
            d="M8.882 6.25c.125.29-.83 1.37-.83 1.37h-.107c-.045 0-.128-.11-.23-.244a3.695 3.695 0 00-.224-.279c-.148-.16-.07-.293.003-.418.023-.039.045-.076.06-.113a.543.543 0 00.041-.15c.005-.035.01-.074.042-.166.046-.134.206-.307.318-.428.043-.046.078-.084.097-.11.06-.08.014-.079-.11-.078h-.055c-.166 0-.482.078-.577.169-.094.09-.193.11-.34.11-.145 0-.055.098.078.164-.143.028-.235.266-.288.477-.03-.211-.095-.45-.237-.477.132-.066.222-.164.076-.164-.145 0-.244-.02-.339-.11-.094-.09-.41-.168-.576-.168h-.056c-.124-.002-.17-.002-.11.077.02.026.055.064.098.11.11.12.271.294.317.428.032.092.037.131.042.167.006.036.01.068.042.149a.867.867 0 00.06.113c.072.125.15.259.003.418a3.713 3.713 0 00-.225.28c-.101.133-.185.243-.23.243h-.107s-.955-1.08-.83-1.37c.048-.112.126-.218.19-.306.102-.139.17-.232.033-.232-.223 0-1.114.565-1.114 1.838 0 1.274.083 1.998.274 2.505.13.346.01.683-.078.933a1.015 1.015 0 00-.077.287c0 .226.351.028.351-.114 0-.067.048.033.098.138.056.116.114.238.114.148 0-.096.056-.198.105-.288a.465.465 0 00.074-.18c0-.048.049-.046.104-.044.07.002.15.005.15-.091 0-.065.025-.078.056-.095.052-.026.12-.062.12-.353 0-.216.044-.14.093-.052.046.08.097.171.125.052.003-.012.031-.062.067-.124.051-.09.117-.206.138-.264a1.98 1.98 0 01-.32.647c-.103.13-.28.415-.28.415s.166.092.28 0c.064-.051.069-.003.073.05.004.042.008.086.042.086.021 0 .041.004.06.007l.035.005c-.039.097-.073.253.042.149a.775.775 0 01.178-.125c.045-.023.063-.033.063-.081 0-.049.018-.032.046-.006.024.022.056.051.091.051.045 0 .054-.062.068-.152.009-.061.02-.135.044-.21l.017-.051c.05-.156.073-.229.13-.032.026.092.073.157.114.214.055.077.1.139.066.231-.013.037-.03.077-.047.121-.06.15-.133.335-.133.48 0 .087-.079.204-.153.315-.086.13-.167.25-.106.298.112.09-.024.39-.137.545-.114.155-.095.344.077.344a.31.31 0 01.192.065c.038.026.073.049.127.049.118 0 .18-.058.18-.058s.073.11.194.11c.12 0 .145-.11.145-.11l.09.11.007-.482v.482l.275-.11s.025.11.146.11c.12 0 .193-.11.193-.11s.063.058.18.058c.054 0 .09-.023.127-.049a.309.309 0 01.192-.065c.172 0 .191-.189.078-.344-.114-.154-.25-.456-.138-.545.06-.049-.02-.168-.106-.298-.074-.11-.152-.228-.152-.315 0-.145-.074-.33-.134-.48a3.835 3.835 0 01-.047-.12c-.033-.093.011-.155.067-.232.04-.057.087-.122.114-.214.056-.197.08-.124.13.032l.016.05c.025.076.036.15.045.21.013.091.023.153.067.153.035 0 .067-.03.091-.051.029-.026.047-.043.047.006 0 .049.018.058.062.081.038.02.096.05.178.125.115.104.08-.052.043-.15.01 0 .022-.002.035-.004.018-.003.038-.007.06-.007.033 0 .037-.044.041-.086.005-.053.01-.101.073-.05.115.092.28 0 .28 0s-.177-.284-.28-.415a1.98 1.98 0 01-.32-.647c.021.059.087.174.139.264.035.062.064.112.066.124.028.12.08.029.125-.052.05-.088.093-.164.093.052 0 .291.069.327.12.353.032.017.057.03.057.095 0 .096.08.093.15.09.054-.001.104-.003.104.044s.034.11.073.181c.05.09.105.192.105.288 0 .09.058-.032.114-.148.05-.105.098-.205.098-.138 0 .142.351.34.351.114 0-.072-.035-.17-.076-.287-.09-.25-.209-.587-.078-.933.19-.507.273-1.231.273-2.505 0-1.273-.89-1.838-1.114-1.838-.137 0-.069.093.033.232a1.6 1.6 0 01.19.306zm-.83 3.73zm.075 1.18c0-.03.022.005.043.057-.027.001-.043-.01-.043-.056zm-2.726.057c.026.001.042-.01.042-.056 0-.032-.022.004-.042.056zm.11-1.209z"
            fill="#F7FCFF"
          />
          <path
            d="M5.118 12.001c0-.088.225-.291.225-.291v.017c.031.025.232.191.232.272 0 .05-.026.123-.048.185a.46.46 0 00-.031.109c0 .014.005.004.017-.015.027-.048.088-.152.172-.083.112.092.11.228.11.315v.014c0 .027 0 .027-.003.014-.008-.027-.032-.113-.107-.113-.11 0-.19.1-.19.1v.17s.014.14.08.07.08.086 0 .086c-.04 0-.082.043-.123.085-.04.04-.078.08-.113.08v-.014c-.034-.002-.062-.037-.09-.073-.032-.038-.063-.078-.104-.078-.08 0-.065-.157 0-.086.066.07.08-.07.08-.07v-.17s-.08-.1-.19-.1c-.075 0-.099.086-.107.113-.003.013-.003.013-.003-.014v-.014c0-.087-.001-.223.11-.315.085-.07.145.035.173.082.01.02.017.03.017.016a.365.365 0 00-.042-.108.522.522 0 01-.065-.184zm2.989 0c0-.088.225-.291.225-.291v.017c.031.025.232.191.232.272 0 .05-.026.123-.048.185a.46.46 0 00-.031.109c0 .014.006.004.017-.015.027-.048.088-.152.172-.083.112.092.111.228.11.315v.014c0 .027 0 .027-.003.014-.008-.027-.032-.113-.107-.113-.11 0-.19.1-.19.1v.17s.015.14.08.07c.066-.07.08.086 0 .086-.04 0-.082.043-.123.085-.04.04-.078.08-.113.08v-.014c-.034-.002-.062-.037-.09-.073-.032-.038-.063-.078-.104-.078-.08 0-.065-.157 0-.086.066.07.08-.07.08-.07v-.17s-.08-.1-.19-.1c-.075 0-.099.086-.107.113-.003.013-.003.013-.003-.014v-.014c0-.087-.001-.223.11-.315.085-.07.145.035.173.082.01.02.017.03.017.016a.365.365 0 00-.042-.108.522.522 0 01-.065-.184z"
            fill="#E8AA00"
          />
          <path
            d="M4.894 11.475c.2 0 .24-.381.24-.381s.169-.175.169-.046c0 .068-.048.155-.084.22-.032.058-.055.1-.03.1h.278c.229 0-.04.107-.164.154a1.396 1.396 0 01-.134.044c-.046.013-.09.026-.157.055-.122.053-.175.402-.118.515.057.112-.057.065-.104 0-.026-.036-.045.013-.071.082a.631.631 0 01-.086.17c-.074.09-.073.01-.072-.16l.001-.092c0-.152.03-.153.075-.155.024-.002.052-.003.082-.027.065-.052.073-.078.092-.146l.026-.083c.047-.136-.204.079-.275.18-.043.062-.073.07-.118.08a.43.43 0 00-.113.038c-.079.04-.057-.038-.031-.135a.7.7 0 00.031-.163c0-.082.05-.061.112-.034.037.016.08.034.12.034.1 0 .153-.043.217-.096l.01-.008c.052-.042-.06-.03-.195-.014l-.14.014c-.103.008-.11.002-.135-.021a.408.408 0 00-.128-.078c-.194-.084.124-.047.264 0 .077.027.142.01.219-.012a.782.782 0 01.22-.035zm3.884 0c-.2 0-.24-.381-.24-.381s-.168-.175-.168-.046c0 .068.047.155.084.22.032.058.055.1.03.1h-.278c-.229 0 .04.107.164.154.056.022.096.033.134.044.046.013.09.026.156.055.123.053.175.402.118.515-.056.112.057.065.104 0 .026-.036.045.013.072.082a.631.631 0 00.086.17c.074.09.073.01.071-.16v-.092c0-.152-.03-.153-.076-.155-.024-.002-.052-.003-.082-.027-.064-.052-.072-.078-.091-.146a1.67 1.67 0 00-.027-.083c-.047-.136.205.079.276.18.043.062.073.07.118.08a.43.43 0 01.112.038c.08.04.058-.038.032-.135a.7.7 0 01-.032-.163c0-.082-.049-.061-.112-.034a.318.318 0 01-.118.034c-.102 0-.154-.043-.218-.096a1.173 1.173 0 00-.01-.008c-.053-.042.06-.03.194-.014l.14.014c.103.008.11.002.136-.021.019-.017.047-.043.128-.078.193-.084-.125-.047-.264 0-.077.027-.142.01-.22-.012a.782.782 0 00-.219-.035z"
            fill="#E8AA00"
          />
          <path
            d="M5.654 7.713h2.423v2.21s-.26 1.1-1.212 1.1c-.95 0-1.21-1.1-1.21-1.1v-2.21z"
            fill="#C51918"
          />
          <path
            d="M7.192 7.681h-.634V8.95h-.906v.453h.906v1.63h.634v-1.63h.906V8.95h-.906V7.681z"
            fill="#F7FCFF"
          />
          <path
            d="M6.063 8.318c.06 0 .09-.051.058-.096a.06.06 0 00-.085-.011A.732.732 0 016 8.2a.062.062 0 00-.038 0c-.015.005-.023-.01-.016-.104.007-.026.043-.042.126-.042.153 0 .215.016.215.03v.225l-.074.067c-.035.032-.01.087.04.087h.034v.171c-.046.037-.088.054-.124.054-.137 0-.213-.051-.216-.111l.002-.04.012.004a.062.062 0 00.04 0l.004-.001c.005-.002.008-.003.01-.002.002.002.002.007.001.02v.016c-.001.028.024.052.055.052s.057-.021.058-.05c.002-.099-.053-.156-.146-.136-.054-.016-.092-.015-.122.019-.021.025-.024.045-.027.118.005.125.137.213.329.213a.34.34 0 00.22-.096.049.049 0 00.017-.037v-.245a.05.05 0 00-.022-.04l.006-.006A.049.049 0 006.4 8.33v-.245c0-.105-.108-.133-.328-.133-.13 0-.215.038-.238.129-.012.155.034.247.147.22.035.01.061.016.081.016zm1.59-.096c-.031.045-.002.096.059.096a.3.3 0 00.08-.015c.114.026.16-.066.147-.221-.023-.09-.108-.13-.237-.13-.22 0-.329.029-.329.134v.245c0 .014.006.027.017.036l.005.005a.05.05 0 00-.022.04v.246a.05.05 0 00.018.037.34.34 0 00.22.096c.192 0 .324-.088.328-.213-.002-.073-.005-.093-.027-.118-.03-.034-.067-.035-.122-.02-.092-.019-.147.038-.145.137 0 .029.027.05.058.05.031 0 .056-.024.055-.052v-.017c0-.012-.001-.017.001-.019l.01.002.005.002a.062.062 0 00.038 0l.012-.005.002.04c-.002.06-.079.11-.215.11a.208.208 0 01-.125-.053v-.171h.034c.05 0 .076-.055.04-.087l-.074-.067v-.224c0-.015.063-.03.216-.03.083 0 .119.015.126.041.007.094-.002.11-.016.104a.062.062 0 00-.038 0 .732.732 0 01-.035.01.06.06 0 00-.085.01zm.192.312h-.003.002zm-.133 1.414c-.061 0-.09-.05-.058-.096a.06.06 0 01.085-.01.71.71 0 00.035-.01.062.062 0 01.038 0c.014.005.023-.01.016-.104-.007-.026-.043-.042-.126-.042-.153 0-.216.016-.216.03v.224l.074.067c.036.032.01.087-.04.087h-.034v.172a.215.215 0 00.125.053c.136 0 .213-.05.215-.11l-.002-.04-.012.004a.062.062 0 01-.038 0l-.006-.002c-.005-.001-.007-.002-.009-.001-.002.001-.002.006-.001.019v.017c0 .028-.024.051-.055.052-.031 0-.057-.022-.058-.05-.002-.1.053-.156.145-.137.055-.016.093-.014.122.02.022.024.025.044.027.117-.004.126-.136.213-.328.213a.34.34 0 01-.22-.096.049.049 0 01-.018-.037v-.245a.05.05 0 01.022-.04l-.005-.005a.049.049 0 01-.017-.037v-.245c0-.105.108-.133.329-.133.13 0 .214.039.237.13.013.154-.033.247-.146.22a.312.312 0 01-.081.015zm-1.649 0c.06 0 .09-.05.058-.096a.06.06 0 00-.085-.01.71.71 0 01-.035-.01.062.062 0 00-.038 0c-.015.005-.023-.01-.016-.104.007-.026.043-.042.126-.042.153 0 .215.016.215.03v.224l-.074.067c-.035.032-.01.087.04.087h.034v.172a.21.21 0 01-.124.053c-.137 0-.213-.05-.216-.11l.002-.04.012.004a.062.062 0 00.04 0l.004-.002c.005-.001.008-.002.01-.001s.002.006.001.019v.017c-.001.028.024.051.055.052.031 0 .057-.022.058-.05.002-.1-.053-.156-.146-.137-.054-.016-.092-.014-.122.02-.021.024-.024.044-.027.117.005.126.137.213.329.213a.34.34 0 00.22-.096.049.049 0 00.017-.037v-.245a.05.05 0 00-.022-.04l.006-.005A.049.049 0 006.4 9.96v-.245c0-.105-.108-.133-.328-.133-.13 0-.215.039-.238.13-.012.154.034.247.147.22.035.01.061.015.081.015z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="RU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#3D58DB" d="M0 5h20v5H0z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#C51918"
          />
        </g>
      </g>
    </symbol>
    <symbol id="RW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#FECA00"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v8.75h20V0H0z" fill="#3CA5D9" />
          <path d="M0 11.25V15h20v-3.75H0z" fill="#5A962A" />
          <path
            d="M15.051 7.416a2.582 2.582 0 01-.116 0l-.377 1.234-.08-1.285a2.485 2.485 0 01-.114-.026L13.71 8.45l.221-1.267a2.518 2.518 0 01-.105-.052l-.895.932.51-1.18a2.443 2.443 0 01-.091-.076l-1.087.702.77-1.03a2.596 2.596 0 01-.072-.096l-1.218.435.988-.826a2.405 2.405 0 01-.049-.11l-1.284.144 1.152-.577a2.357 2.357 0 01-.022-.12l-1.282-.152 1.255-.298.007-.122-1.21-.44 1.288-.004c.011-.04.023-.079.036-.118l-1.075-.704 1.256.29.062-.106-.882-.93 1.155.569c.027-.03.056-.06.085-.089L12.58 2.12l.992.817a1.78 1.78 0 01.102-.066l-.366-1.225.775 1.023a2.25 2.25 0 01.115-.042l-.071-1.276.516 1.173c.04-.005.08-.01.12-.013l.23-1.26.228 1.26.12.015.517-1.175-.071 1.28c.038.012.075.026.113.04l.777-1.025-.368 1.23c.034.02.067.042.1.065l.996-.821-.645 1.113c.028.028.055.057.081.086l1.162-.572-.888.936.06.102 1.264-.292-1.083.71c.012.036.024.074.034.112l1.298.004-1.22.443c.004.039.006.078.007.117l1.264.3-1.291.154a2.397 2.397 0 01-.02.114l1.16.581-1.293-.145a2.47 2.47 0 01-.047.106l.995.83-1.226-.436a2.38 2.38 0 01-.07.092l.775 1.036-1.091-.705c-.03.025-.059.05-.089.073l.513 1.186-.898-.935a2.506 2.506 0 01-.103.051l.222 1.271-.656-1.114a2.48 2.48 0 01-.112.026l-.08 1.287-.378-1.234zm-.085-.907c.876 0 1.585-.699 1.585-1.562 0-.862-.71-1.562-1.585-1.562s-1.585.7-1.585 1.562c0 .863.71 1.562 1.585 1.562zm.912-1.516a.893.893 0 11-1.787 0 .893.893 0 011.787 0z"
            fill="#FFDC17"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path fill="#67BD23" d="M0 0h20v15H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.024 2.546c-.08.123-.147.3-.147.383v.025c-.001.094-.004.268.107.148.122-.132.24-.287.214-.406-.026-.12-.092-.274-.174-.15zm-1.133.283c0-.17.21-.3.266-.3.057 0 0 .15-.104.215-.076.048-.016.071.056.1.026.01.053.02.077.033.087.047-.029.17-.162.21-.133.04-.133-.087-.133-.258zm-.208.208c-.075.177-.218.524-.086.8l.044.095c.109.235.197.426.395.4.21-.03.307-.406.339-.53l.005-.021c.026-.096.13-.257.158-.155a.954.954 0 010 .247c-.007.095-.014.189 0 .233.028.09.157.484.446.391.152-.048.25-.157.327-.242.07-.077.123-.136.183-.115.048.017.097.08.151.147.086.11.185.234.313.21.165-.03.284-.208.36-.32.02-.03.036-.054.05-.071.05-.063.075-.025.108.026.01.017.023.035.037.052.056.067.168.113.244 0 .077-.114.19-.46.043-.403l-.01.003c-.145.056-.35.134-.422-.01-.074-.148-.276-.605-.175-.605.1 0 .267 0 .233-.163s.311.366.374.477l.07.126c.136.25.41.752.466.794.058.045.108.922.12 1.318a1.16 1.16 0 00-.177-.009c-.234 0-.422.026-.573.047-.167.023-.29.04-.385.01-.053-.017-.117-.027-.172-.037-.133-.022-.22-.037-.015-.109.058-.02.125-.037.194-.055.276-.07.593-.15.568-.507-.031-.447-.09-.644-.426-.585-.336.06-.442.326-.442.585 0 .216-.029.219-.12.228a.53.53 0 00-.06.007 1.75 1.75 0 01-.05.008c-.173.023-.538.072-.77.408-.22.318-.193-.15-.18-.378l.004-.093c0-.13-.045-.246-.147-.477l-.007-.018c-.1-.227-.216-.49-.378-.24-.168.258.03.622.1.678.072.057.438.857.078 1.253-.36.396-.87.785-1.008.66-.137-.125-.219-.203-.063-.303.025-.017.067-.037.118-.061.26-.125.772-.37.677-.894a4.684 4.684 0 00-.153-.62c-.031-.098-.04-.126-.006-.126h.028c.066.005.134.01.059-.192-.087-.23-.21-.492-.44-.236s-.137.416 0 .576c.137.16.37.445.103.7a6.572 6.572 0 00-.22.223c-.146.153-.238.249-.238.16 0-.129-.039-.3-.108-.15a1.045 1.045 0 00-.04.098c-.058.15-.131.34-.324.421-.24.1-.774.497-.774.497s-.352.314-.19.287c.161-.027.579-.146.692-.243.114-.098.389-.166.389-.166s.32.604.655.507c.335-.098 1.08-.913 1.08-.913s.459.631.975.673c.517.042.645-.128.501-.238a1.323 1.323 0 00-.152-.095c-.16-.092-.345-.198-.274-.309.096-.151.296-.201.638-.256l.15-.022c.285-.039.539-.073.61-.329.037-.134.16-.224.239-.281l.037-.028a3.7 3.7 0 01.001.092c0 .237-.009 1.03-.04 1.118-.032.088.161.031.217-.064l.004-.006c.056-.095.135-.228.135-.428l.001-.134c.003-.302.01-.891-.047-1.025-.068-.159-.046-.313 0-.274.021.019.162.289.315.583.18.344.377.722.419.767.048.051.07-.075.092-.202a.816.816 0 01.047-.192c.052-.097.093-.172.093 0l.001.054c.005.199.014.593-.326.818-.12.08-.221.15-.308.21-.184.128-.3.208-.372.227-.108.027-.091.231.039.231l.036.001c.177.006.688.022.998-.566.297-.563.113-2.337.067-2.781a2.42 2.42 0 01-.01-.1c0-.02-.014-.064-.03-.121-.04-.132-.1-.331-.057-.432.035-.08.055-.07.078-.058.018.01.038.02.067-.012.066-.074.144-.18 0-.365a1.131 1.131 0 01-.124-.23c-.062-.142-.11-.25-.194-.135-.131.18-.193.704-.13.958.064.255.343 2.282.172 2.112-.101-.1-.194-.29-.296-.498a4.85 4.85 0 00-.23-.433c-.205-.333-.608-1.007-.497-1.208.032-.059.06-.098.081-.13.052-.073.068-.096.03-.216a.645.645 0 00-.14-.224.935.935 0 01-.132-.19c-.084-.17-.261-.28-.261-.118 0 .161-.09.329-.146.164-.056-.164-.354-.516-.5-.395-.09.076-.07.121-.053.16.011.024.02.046.006.07a.718.718 0 00-.02.042h-.001c-.032.065-.066.133-.11.03a.97.97 0 01-.025-.073c-.047-.143-.11-.34-.312-.151-.24.225-.267.456-.133.589.133.132.333.45.233.594-.1.146-.288.253-.378.099a.757.757 0 01-.104-.546c.04-.22.101-.891-.162-.814-.263.078-.235.466-.173.64.063.174.098.461.05.559l-.006.01c-.053.108-.192.39-.34.294-.153-.1-.267-.38-.196-.645.071-.264.024-.683-.192-.555s-.458.538-.458.748c0 .21-.085.463-.173.309L7.95 3.91c-.088-.153-.209-.363-.143-.572.07-.22-.05-.479-.124-.301zM3.538 2.65c-.012.016-.003.026.018.05.024.028.065.074.104.171.031.079.04.193.048.282.009.114.015.188.059.096.08-.163.12-.52 0-.6-.12-.08-.202-.035-.229 0zm1.56.34c-.236 0-.204-.347-.204-.347s0-.033.105-.033c.071 0 .078.038.085.071.003.016.006.03.015.04.012.014.014 0 .016-.02.002-.025.006-.058.033-.058.048 0 .058.05.058.132 0 .081.068.016.068-.054s.062-.078.117-.078c.055 0-.055.347-.292.347zM3.805 6.802c-.029-.332.048-.651.191-.651.143 0 .143.317.143.317s.08.653.74.682c.659.03 1.1-1.115 1.1-1.115.037-.193.026-.434.026-.434-.043-.09-.067 0-.117.184a4.035 4.035 0 01-.207.617c-.22.494-.679.483-.967.476H4.68c-.285-.006-.516-.482-.541-.727-.025-.246.058-.439.058-.439s.227-.238.219.178c-.008.415.197.483.566.512.369.03.641-.536.699-.75.058-.215-.293.118-.293.118-.095.09-.303.006-.406-.217-.103-.223.103-.487.273-.668.17-.182.362-.033.362-.033.25.043.35.213.35.213.124.093-.01-.421-.01-.421-.086-.216-.19-.908-.19-.908a1.965 1.965 0 01-.05-.256c-.028.048-.036.155-.036.155s.164.714-.07.936c-.115.108-.173.163-.234.166-.065.003-.132-.052-.269-.166-.268-.222-.282 0-.282.266V5.91c0 .166-.104.164-.198.162-.048-.001-.093-.002-.12.02.017-.174.035-.488.035-.488.01-.148-.188-.74-.188-.74-.173-.146-.376-.516-.376-.516-.047-.275-.147-.13-.147-.13 0 .193-.062.603-.375.483-.314-.121-.138-1.245-.138-1.245s.126.013.138.299c.011.285.163.498.163.498.08.208.108-.457.108-.457 0-.272.335-.514.335-.514.186-.1.181.324.181.324.089.281-.007.493-.007.493-.012.276.19.136.19.136.141-.007-.106-.807-.106-.807-.12-.284-.054-.534-.054-.534.012-.152.2-.191.2-.191.129.012.13.583.13.583 0 .359.098.68.185.746.087.066-.014-.202-.087-.277-.046-.048-.033-.157-.018-.286.01-.072.018-.151.018-.229 0-.215.13-.113.271-.002l.003.002c.112.088.104.232.096.387a1.802 1.802 0 00-.005.128c0 .2.1.335.265.463.14.11.134-.061.13-.19-.002-.023-.002-.044-.002-.063 0-.096-.077-.242-.153-.385a5.672 5.672 0 01-.063-.124c-.072-.144-.037-.196.033-.301l.055-.086c.102-.17.285.012.356.171l.012.026a4.536 4.536 0 01-.013-.188c-.043-.128.325-.411.325-.411.23-.052.271.695.271.695.082.267-.191.162-.191.162-.134-.012.144 1.084.144 1.084.02.375.202.177.202.177.14-.056.15.305.15.305.095.143.274-.345.274-.345.125-.179.322.229.322.229.094.126.288-.234.288-.234.11-.07.081.04.045.179a1.097 1.097 0 00-.045.246c0 .192-.031.206-.236.3l-.007.003c-.212.097-.277-.064-.277-.064-.051-.061-.405.148-.405.148-.133.05-.216-.06-.216-.06-.057-.075-.056.237-.054.633v.209c0 .487-.74 1.099-1.426 1.218a.858.858 0 01-1.039-.75zm.68-.633c.005.08.014.025.023-.076-.016.014-.026.038-.023.076zm-.739-.921c.301-.264.512-.214.512-.214s.066 0 .152.092c.086.091-.211.276-.407.334-.132.039-.293.12-.448.198a8.07 8.07 0 01-.214.104c-.21.096.105-.25.405-.514zm-.368 1.106s-.293.48-.245.789c.048.31.25.373.386.341.134-.032.196-.341.196-.341s-.093-.213-.196-.098c0 0-.17.072-.138-.126.031-.198-.003-.565-.003-.565zM5.372 5.19s-.197.061-.098.153c.098.092.25.103.25 0s-.152-.153-.152-.153zm3.949-.469s-.02.349.217.34c.237-.008.335-.359.28-.357-.055.002-.117.013-.115.083.002.07-.062.137-.065.055-.003-.081-.015-.131-.064-.13-.027.001-.029.035-.03.06-.002.02-.002.034-.016.02-.009-.009-.012-.023-.016-.039-.008-.033-.016-.07-.088-.068-.104.003-.103.036-.103.036zm2.769-.498c-.237.008-.217-.34-.217-.34s-.001-.033.104-.037c.07-.002.08.035.087.069.004.015.007.03.017.04.013.012.014-.002.015-.022.001-.025.004-.058.03-.059.05-.002.061.048.064.13.003.081.068.014.065-.056-.002-.07.06-.08.115-.083.055-.001-.043.35-.28.358zM6.646 5.995c-.108-.058-.097-.1 0-.188.096-.088.214.04.331.188.1.124.038.223-.02.315l-.03.051c-.058.106-.216.087-.157 0 .06-.087-.016-.309-.124-.366zm7.936-.506c-.097.089-.108.13 0 .188.108.058.06.3 0 .387-.059.087.106.183.165.077l.01-.019c.056-.102.123-.222.077-.401-.049-.19-.155-.32-.252-.232zm1.374-2.03c-.108-.057-.097-.1 0-.187.096-.089.203.04.252.231.046.18-.02.3-.077.401l-.01.019c-.059.106-.224.01-.165-.077s.108-.329 0-.386zm-4.102-.7c-.096.089-.108.131 0 .189.108.057.234.422.175.509-.06.087.099.106.157 0 .058-.106.117-.362 0-.51-.118-.147-.235-.275-.332-.187zM10.45 4.897c-.133.06-.21.096-.14.144.07.049.236.06.236 0l.002-.035c.006-.067.014-.16-.098-.109zM9.16 6.092c.143 0 .255-.025.255-.025s.194.025.347.025c.153 0 .126.135-.056.22-.167.08-.178.131-.2.236l-.005.03c-.028.124-.049.21-.185.168-.13-.04-.255-.354-.321-.52l-.01-.025c-.05-.124 0-.12.094-.113a.979.979 0 00.082.004zM7.47 3.03c.054 0 .119-.33 0-.376-.117-.047-.461.011-.42.15.014.045.047.09.08.138.07.096.14.196.052.3a5.126 5.126 0 01-.598.534l-.027.016c-.081.049-.24.142-.128.142.04 0 .088.004.139.007.108.008.227.016.293-.007.049-.016.126-.106.21-.205.08-.093.167-.195.243-.25.157-.11.19-.33.157-.36-.01-.009-.032-.018-.059-.03-.072-.03-.177-.075-.144-.148.046-.101.084-.036.084 0 0 .035.066.089.119.089zm-.088 1.097l-.124.045s-.071 0-.096-.086c-.01-.038.006-.083.02-.124.02-.052.035-.095-.02-.095-.096 0-.168.162-.2.26-.033.097.117.216.2.268.083.052.186-.052.276-.145.09-.093-.056-.123-.056-.123zm5.73 2.934c-.121-.163-.069-.528.043-.757.086-.177.083-.08.077.1a5.24 5.24 0 00-.003.173c0 .217.064.291.154.395.023.027.048.056.073.09.127.163.233 0 .233-.1s.224-.56.386-.735c.162-.175.297-.07.297 0s.157.297.34.35c.182.053.247-.42.247-.42V4.731c0-.413-.103-.493-.19-.56-.02-.016-.04-.031-.057-.05a3.739 3.739 0 00-.148-.144c-.13-.123-.298-.281-.367-.382-.087-.126-.083-.364-.08-.603V2.86c0-.28.387.125.478.28.059.1.042.166.022.242-.01.042-.022.086-.022.14 0 .153.117.117.117 0 0-.021-.003-.054-.005-.094-.013-.183-.036-.515.096-.568.124-.05.15.017.222.203.02.055.046.119.078.193.09.21.066.308.036.428a.985.985 0 00-.036.26c0 .227.166.427.282.565.04.048.073.088.092.12.073.124-.074-.806-.201-.99-.127-.184-.058-.613.127-.843.14-.175.23.047.319.264.028.07.057.14.086.196.102.19-.002.328-.08.43l-.042.06c-.032.05-.008.112.027.203.04.107.095.254.095.466 0 .393.158.788.39 1.105.22.3.268.65.317 1l.008.058c.052.37.056-.58 0-1.058-.056-.478-.238-2.16-.164-2.595.048-.284.1-.157.18.032.04.1.09.217.148.3l.036.05c.136.189.146.203.064.332-.047.073-.089.063-.118.055-.026-.007-.042-.01-.042.052 0 .039.021.218.052.472.073.61.197 1.647.197 2.185 0 .762-.405 1.06-.756 1.19-.35.13-.54 0-.54-.13 0-.07-.05-.03-.115.024-.058.048-.13.106-.19.106-.126 0-.083-.15 0-.299.052-.09.04-.098.024-.109-.01-.007-.023-.016-.023-.05 0-.085 0-.172.127-.172s.24 0 .117.172c-.075.106-.07.106-.02.112.033.004.083.01.143.047.083.052.09.053.099.055.007 0 .014.002.066.032.116.066.394-.167.663-.418.19-.178.095-.22-.006-.263a.286.286 0 01-.106-.062c-.036-.042-.1-.15-.168-.262-.089-.147-.183-.303-.225-.335-.035-.026-.022.062-.005.176.02.133.045.302.005.361-.075.11-.246.25-.323.25-.078 0 0-1.408 0-1.408s-.437-.605-.367-.378c.07.227-.07 1.69-.267 1.92-.198.231-.608-.064-.71-.23-.1-.165-.222-.004-.268.166-.046.17-.146.542-.391.695-.183.114-.32-.15-.428-.357a1.437 1.437 0 00-.1-.174zm1.346-2.039s-.409.275-.477.362c-.068.086-.093.15 0 .198.093.048.465-.13.603-.28.138-.15.241-.294.19-.386-.052-.091-.316.106-.316.106zm-.673-.624c-.165-.195.087-.277.087-.277s.134 0 .279.119c.079.065.07.004.059-.09-.01-.076-.023-.173.007-.24.066-.151.29.025.349.21.04.131-.004.136-.072.144a.323.323 0 00-.096.021c-.074.032-.05.176-.025.323.012.075.025.151.025.214 0 .185-.447-.23-.613-.424z"
          fill="#fff"
        />
        <path
          d="M8.877 2.93h.075-.075zm.147-.384l-.062-.042.062.042zm-.147.408h.075-.075zm.107.148L8.93 3.05l.055.05zm.214-.406l.073-.016-.073.016zm-1.145.048l.04.064-.04-.064zm.056.1l-.027.07.027-.07zm.077.033l.035-.066-.035.066zm-.59.96l.068-.033-.067.032zm.087-.8l-.07-.03.07.03zm-.042.895l-.068.031v.001l.068-.032zm0 0l.069-.031-.001-.001-.068.032zm.395.4l-.01-.075.01.074zm.339-.53l-.073-.02.073.02zm.005-.021l-.072-.02.072.02zm.158-.155l.073-.02-.073.02zm0 .247l-.075-.006v.006h.075zm0 0l.075.005v-.005h-.075zm0 .233l.072-.022-.072.022zm.446.391l.023.072-.023-.072zm.327-.242l.056.05-.056-.05zm.183-.115l-.025.071.025-.07zm.151.147l.059-.046-.059.046zm.313.21l.013.074-.013-.074zm.36-.32l.062.041-.062-.042zm0 0l-.063-.042.063.041zm.05-.071l-.059-.047.059.047zm.108.026l.063-.04-.063.04zm.037.052l.057-.049-.057.049zm.244 0l-.062-.042.062.042zm.043-.403l-.027-.07.027.07zm-.01.003l-.026-.07.027.07zm-.422-.01l-.068.034.067-.034zm.058-.768l.073-.015-.073.015zm.374.477l-.065.037.065-.037zm.07.126l-.066.036.065-.036zm.466.794l.045-.06-.046.06zm.12 1.318l-.013.073.092.017-.003-.093-.075.003zm-.75.038l.01.074-.01-.074zm-.385.01l-.023.072.023-.072zm-.172-.037l.013-.074-.013.074zm-.015-.109l-.025-.07.025.07zm.194-.055l.019.073-.019-.073zm.568-.507l.075-.005-.075.005zm-.987.228L9.9 5.214l.008.075zm-.06.007l.012.074-.012-.074zm-.052.008l-.01-.075.01.075zm0 0l.01.074-.01-.074zm0 0l-.01-.075.01.075zm-.77.408l.062.043-.061-.043zm-.18-.378l.076.004v-.004h-.075zm0 0l-.074-.004v.004h.075zm-.142-.57l-.068.03.068-.03zm-.007-.018l-.07.03.07-.03zm-.378-.24l.062.041-.062-.04zm.1.678l-.046.059.047-.059zm.078 1.253l-.055-.05.055.05zm-1.008.66l-.05.055.05-.055zm-.063-.303l-.04-.063.04.063zm.118-.061l.032.068-.032-.068zm.677-.894l-.074.014.074-.014zm-.153-.62l.071-.023-.071.023zm.022-.125l-.005.075.005-.075zM8.15 4.9l.07-.026-.07.026zm-.44-.236l.056.05-.056-.05zm0 .576l.057-.049-.057.049zm.103.7l-.051-.055.051.055zm-.22.223l.052.053h.001l-.054-.053zm0 0l-.054-.053-.001.002.054.051zm-.346.01l-.068-.032.068.031zm-.04.098l-.07-.027.07.027zm-.324.421l.029.07-.03-.07zm-.774.497l-.045-.06-.005.004.05.056zm-.19.287l-.012-.074.012.074zm.692-.243l-.048-.057.048.057zM7 7.068l.066-.035-.027-.052-.057.015.018.072zm.655.507l.021.072-.02-.072zm1.08-.913l.06-.044-.054-.074-.062.067.055.051zm.975.673l.006-.075-.006.075zm.501-.238l.046-.06-.046.06zm-.152-.095l.037-.065-.037.065zm-.274-.309l-.064-.04.064.04zm.638-.256l-.012-.074.012.074zm.15-.022l.01.074-.01-.074zm.61-.329l-.072-.02.072.02zm.239-.281l.044.06-.044-.06zm.037-.028l.075-.002-.004-.149-.118.092.047.06zm-.04 1.21l.071.025-.07-.025zm.218-.064l-.064-.038.064.038zm.004-.006l-.065-.038.065.038zm.136-.562h-.075.075zM11.73 5.33l-.069.03.069-.03zm0-.274l-.05.057.05-.057zm.315.583l-.066.034.066-.034zm.419.767l-.055.05.055-.05zm.092-.202l.074.013-.074-.013zm.047-.192l.066.035-.066-.035zm.094.054l-.075.002.075-.002zm-.326.818l.042.063-.042-.063zm-.308.21l.043.062-.043-.061zm-.372.227l.018.072-.018-.072zm.075.232l-.003.075.003-.075zm.998-.566l.067.034-.066-.034zm.067-2.781l-.075.008.075-.008zm-.04-.221l-.072.022.072-.022zm-.057-.432l.07.03-.07-.03zm.078-.058l-.035.067.035-.067zm.067-.012l.056.05-.056-.05zm0-.365l.059-.046-.06.046zm-.124-.23l-.069.03.07-.03zm-.194-.135l.06.044-.06-.044zm-.13.958l.073-.018-.073.018zm.172 2.112l.053-.053-.053.053zm-.296-.498l-.067.033.067-.033zm-.23-.433l-.063.04.064-.04zm-.497-1.208l-.066-.037.066.037zm.081-.13l.062.044-.062-.043zm.03-.216l-.072.023.072-.023zm-.14-.224l-.057.048.057-.048zm-.132-.19l.068-.033-.068.033zm-.906-.349l.048.058-.048-.058zm-.054.16l-.068.032.068-.031zm.006.07l.065.038-.065-.037zm-.02.042l-.068-.034-.002.004.07.03zm-.001 0l.067.033.002-.004-.069-.03zm-.11.03l.07-.028-.07.029zm-.025-.073l.071-.023-.071.023zm-.312-.151l-.051-.055.051.055zm-.133.589l.052-.053-.052.053zm.233.594l-.061-.042.061.042zm-.378.099l.064-.038-.064.038zm-.266-1.36l-.021-.072.021.072zM9.33 3.774l-.067-.033.067.033zm-.005.01l-.067-.033.067.034zm-.34.294l.04-.063-.04.063zm-.388-1.2l.039.064-.039-.064zm-.631 1.057l.065-.037-.065.037zM7.95 3.91l.065-.038-.065.038zm-.143-.572l-.072-.022.072.022zM3.556 2.7l-.057.049.057-.05zm-.018-.05l-.06-.045.06.045zm.122.221l.07-.028-.07.028zm.048.282l-.075.006.075-.006zm.059.096l-.068-.032.068.032zm1.127-.606l.075.007v-.007h-.075zm.19.038l.073-.014-.073.014zm.015.04l.054-.051-.054.051zm.016-.02l-.075-.008.075.008zm-1.31 4.101l-.075.007.074-.007zm.333-.334h-.076l.002.01.074-.01zm1.84-.433l.07.027.003-.013-.074-.014zm.026-.434l.075-.003v-.015l-.007-.014-.068.032zm-.117.184l-.072-.02.072.02zm-.207.617l.068.03-.068-.03zm-.967.476l.001-.075-.001.075zm-.034 0l.002-.075-.002.075zm-.541-.727l-.075.007.075-.007zm.058-.439L4.14 5.66l-.009.01-.005.012.069.03zm.219.178l-.075-.002.075.002zm1.265-.24l-.072-.02.072.02zm-.293.12l.052.054-.052-.055zm-.406-.218l.068-.031-.068.031zm.273-.668l-.054-.05.055.05zm.362-.033l-.046.06.015.01.018.004.013-.074zm.35.213l-.064.038.007.013.012.009.045-.06zm-.01-.421l.073-.02-.003-.008-.07.028zm-.19-.908l.074-.011-.002-.01-.072.021zm-.05-.256l.074-.01-.03-.22-.11.193.065.037zm-.036.155l-.075-.006v.012l.002.01.073-.016zm-.07.936l-.052-.055.051.055zm-.234.166l-.004-.075.004.075zm-.269-.166l-.05.056.002.001.048-.057zm0 0l.05-.056-.001-.001-.05.057zm0 0l.049-.057-.001-.001-.048.058zm0 0l.048-.058-.002-.002-.046.06zm0 0l-.049.057.003.002.046-.06zm0 0l.049-.057-.001-.001-.048.058zm-.48 1.502l.002-.075-.002.075zm-.085-.468L4.467 5.6l.075.005zm-.188-.74l.071-.023-.006-.02-.016-.013-.049.057zm-.376-.516l-.074.012.002.013.006.01.066-.035zm-.147-.13l-.062-.043-.013.02v.023h.075zm-.375.483l-.027.07.027-.07zm-.138-1.245l.008-.074-.07-.008-.012.07.074.012zm.138.299l-.075.003.075-.003zm.163.498l.07-.027-.003-.009-.006-.008-.06.044zm.108-.457l.075.003v-.003h-.075zm.335-.514l-.036-.067-.008.006.044.06zm.181.324h-.075v.011l.004.012.071-.023zm-.007.493l-.068-.031-.006.013v.014l.074.004zm.19.136l-.004-.075-.022.001-.017.012.043.062zm-.106-.807l.072-.022-.003-.007-.07.029zm-.054-.534l.074.02V2.9l-.074-.006zm.2-.191l.007-.075-.011-.001-.012.002.016.074zm.13.583h.075-.075zm.098.47l.055-.053-.055.052zm-.018-.287l.075.009-.075-.009zm0 0l-.074-.009.074.01zm.29-.231l-.047.059.046-.06zm.002.002l-.046.06.046-.06zm.096.387l.074.004-.074-.004zm0 0l-.075-.005.075.005zm.26.591l-.046.06.046-.06zm.13-.19l.074-.004-.075.003zm-.155-.448l.067-.035-.067.035zm-.063-.124l-.068.033.068-.033zm.033-.301l-.062-.043v.001l.062.042zm0 0l-.061-.043.061.043zm0 0l.062.043v-.002l-.062-.041zm0 0l.062.041-.062-.041zm.055-.086l-.065-.038.065.038zm.356.171l-.069.03.069-.03zm.012.026l-.069.031.144-.037-.075.006zm-.013-.188l.075-.003v-.01l-.004-.011-.07.024zm.325-.411l-.016-.073-.017.003-.013.01.046.06zm.271.695l-.075.004v.01l.003.008.072-.022zm-.191.162l.027-.07-.01-.004-.01-.001-.007.075zm.144 1.084l.075-.004v-.007L6.3 4.59l-.072.018zm.202.177l-.027-.07-.016.006-.012.013.055.05zm.15.305l-.074.002v.02l.012.019.063-.041zm.274-.345l-.062-.043-.005.008-.004.01.07.025zm.322.229l-.069.033.009.011.06-.044zm.288-.234l-.04-.064-.017.01-.01.018.067.036zm.045.179l.072.019-.072-.02zm-.28.546l-.032-.069.031.069zm-.008.003L7.189 5.4l.032.068zm-.277-.064l.07-.029-.005-.01L7 5.355l-.057.049zm-.405.148l.027.072.011-.007-.038-.065zm-.216-.06l.06-.045-.06.045zm-.054.633h.075-.075zm0 .001h-.075.075zM4.843 7.553l-.013-.074.013.074zm-.36-1.384l.076-.004-.075.004zm-.226-1.135l-.017.073.008.002h.01v-.075zm-.512.214l.05.056-.05-.056zm.664-.122l-.055.051.055-.051zm-.407.334l.021.072-.02-.072zm-.448.198L3.52 5.59l.035.067zm0 0l.033.067h.002l-.035-.067zm-.214.104l.031.068-.031-.068zm-.208 1.38l-.074.012.074-.011zm.245-.788l.074-.007-.021-.224-.117.192.064.04zm.14 1.13l.018.073-.017-.073zm.197-.341l.074.014.004-.023-.009-.021-.069.03zm-.196-.098l.029.07.015-.007.011-.013-.055-.05zm-.138-.126l-.074-.012.074.012zm1.894-1.577l.05-.055-.05.055zm.098-.153l.024-.072-.023-.007-.023.007.022.072zm4.166-.129l-.003-.075.003.075zm-.217-.34l.075.005v-.007l-.075.002zm.497-.017l-.003-.075.003.075zm-.115.083l.075-.003-.075.003zm-.065.055l-.075.003.075-.003zm-.064-.13l-.002-.074.002.074zm-.03.06l.075.004-.075-.004zm-.016.02l.053-.053-.053.054zm-.016-.039l.073-.017-.073.017zm-.088-.068l.003.075-.003-.075zm2.45-.802l.074.004V3.88l-.075.003zm.216.34l.002.075-.002-.075zm-.113-.377l.002.075-.002-.075zm.087.069l.073-.017-.073.017zm.017.04l.052-.054-.052.053zm.015-.022l-.075-.005.075.005zm.03-.059l-.002-.075.003.075zm.064.13l-.075.002.075-.002zm.065-.056l.075-.003-.075.003zm-5.61 1.86l-.05-.056.05.056zm0 .188l-.035.066.036-.066zm.332 0l.059-.047-.059.047zm-.02.315l.065.04-.064-.04zm-.03.051l-.065-.036.065.036zm-.157 0l.062.042-.062-.042zm7.812-.872l.05.056-.05-.056zm0 .575l.062.042-.062-.042zm.165.077l-.066-.037.066.037zm.01-.019l-.066-.036.066.036zm.077-.401l.073-.019-.073.019zm1.122-2.45l.05.056-.05-.055zm0 .189l.035-.067-.035.067zm.252.043l.072-.019-.072.019zm-.077.401l-.066-.036.066.036zm-.01.019l-.066-.036.065.036zm-.165-.077l.062.042-.062-.042zm-4.102-.898l-.035.066.035-.066zm0-.188l-.05-.056.05.056zm.175.697l.062.042-.063-.042zm.157 0l-.066-.036.066.036zm0-.51l-.059.047.059-.046zm-1.737 1.95l.031.068-.03-.069zm.098.108L10.473 5l.074.006zM9.414 6.067l.01-.075-.014-.002-.013.003.017.074zm.29.246l-.031-.068.032.068zm-.198.235l.073.015-.073-.015zm-.006.03l.073.015-.073-.016zm-.185.168l-.022.072.022-.072zm-.321-.52l.07-.028-.07.028zm-.01-.025l.07-.028-.07.028zm.094-.113l.005-.075-.005.075zM7.47 2.654l-.028.07.028-.07zm-.42.15l-.072.021.072-.021zm.08.138l.06-.044-.06.044zm.051.3l-.057-.048.057.048zm-.598.534l.038.065h.001l-.04-.065zm-.027.016l.038.065-.038-.065zm.01.15l.01-.075h-.004l-.005.074zm0 0l-.009.074h.005l.005-.075zm.294-.008l.024.072-.024-.072zm.21-.205l-.057-.048.057.048zm.243-.25l.044.062-.044-.061zm.157-.36l-.051.054.05-.054zm-.059-.03l-.03.07.03-.07zm-.144-.148L7.2 2.909l.068.032zm-.01 1.23v.076h.013l.013-.005-.026-.07zm.124-.044l.015-.074-.02-.004-.02.007.025.07zm-.22-.041l-.072.02.072-.02zm.02-.124l.07.026-.07-.026zm-.22.165l.07.024-.07-.024zm.2.268l-.04.064.04-.064zm.276-.145l.054.052-.054-.052zm5.717 2.054l.067.033-.067-.033zm-.043.757l.06-.045-.06.045zm.12-.656l.075.002-.075-.002zm.15.567l.06-.047-.002-.002-.057.05zm0 0l-.058.047.002.002.057-.049zm.074.09l.06-.046-.06.045zm.62-.835l-.056-.051.055.05zm.636.35l.02-.072-.02.072zm.247-.42l.075.01v-.01h-.075zm-.19-1.986l.046-.06-.046.06zm-.057-.05l.055-.051-.055.05zm-.148-.144l-.052.055.052-.055zm0 0l.052-.054-.052.054zm-.367-.382l.062-.042-.062.042zm-.08-.603l.075.001h-.075zm0 0h-.075.075zm.478.147l.065-.038-.065.038zm.022.242l.073.019-.073-.019zm.09.046l-.075.003v.002l.075-.005zm0 0l.074-.004v-.002l-.074.005zm.096-.568l-.029-.07.029.07zm.222.203l-.07.027.07-.027zm.078.193l-.07.03.07-.03zm.036.428l-.072-.018.072.018zm.246.825l.057-.048-.057.048zm.092.12l-.065.038.065-.038zm-.201-.99l-.062.043.062-.043zm.127-.843l.059.047-.059-.047zm.319.264l.07-.028-.07.028zm.086.196l-.066.036.066-.036zm-.08.43l-.06-.044.06.045zm-.042.06l-.063-.04.063.04zm.027.203l.07-.026-.07.026zm.485 1.57l-.061.045.06-.044zm.317 1.002l-.075.01.075-.01zm.008.057l-.074.01.074-.01zm-.164-3.653l.074.013-.074-.013zm.18.032l-.07.029.001.003.068-.032zm0 0l.068-.029-.001-.003-.068.032zm.148.3l-.061.043.06-.044zm.036.05l-.061.043.06-.044zm.064.332l-.063-.04.063.04zm-.118.055l-.019.073.019-.073zm.01.524l-.075.01.075-.01zm-.559 3.375l-.026-.07.026.07zm-.655-.106l-.048-.058.048.058zm-.19-.193l-.064-.037.065.037zm.024-.109l-.042.062.042-.062zm.221-.05l-.061-.043.061.043zm-.02.112l.01-.074-.01.074zm.143.047l.04-.063-.04.063zm.099.055l-.012.074.012-.074zm.066.032l-.037.065.037-.065zm.663-.418l.051.055-.051-.055zm-.006-.263l.03-.069-.03.07zm-.106-.062l-.057.048.057-.048zm-.168-.262l-.066.036.001.003.065-.039zm0 0l.066-.036-.001-.001-.065.037zm0 0l.065-.037-.001-.002-.064.039zm-.225-.335l-.046.06.046-.06zm-.005.176l.075-.011-.075.011zm.005.361l-.062-.042.062.042zm-.323-1.158l.075.004v-.026l-.015-.022-.06.044zm-.367-.378l-.072.022.072-.022zm-.267 1.92l-.057-.048.057.049zm-.71-.23l.065-.039-.064.04zm-.268.166l.072.02-.072-.02zm-.391.695l-.04-.064.04.064zm-.428-.357l-.067.035.067-.035zm.769-1.851l.059.046-.06-.046zm.477-.362l.042.062.003-.002-.045-.06zm-.477.56l-.035.067.035-.067zm.603-.28l.055.05-.055-.05zm.19-.386l.065-.037-.065.037zm-.902-.795v-.075h-.012l-.011.004.023.07zm-.087.277l-.057.048.057-.048zm.366-.158l.047-.058-.047.058zm.059-.09l.074-.01-.074.01zm.007-.24l-.069-.031.069.03zm.349.21l.072-.021-.072.022zm-.072.144l.008.074-.008-.074zm-.096.021l-.03-.068.03.068zm-.025.323l.074-.012-.074.012zM8.952 2.93c0-.027.012-.081.038-.15.025-.066.06-.136.097-.192l-.125-.083a1.185 1.185 0 00-.112.222.636.636 0 00-.048.203h.15zm0 .025V2.93l-.15-.001v.024l.15.001zm-.023.097a.118.118 0 01-.02.02c-.004.001.002-.004.016-.003.015 0 .027.009.032.015.005.005.004.007.003.002a.236.236 0 01-.008-.055v-.075l-.15-.002v.084c.002.03.005.065.015.095.008.024.033.082.1.086a.122.122 0 00.07-.02.26.26 0 00.052-.045l-.11-.102zm.195-.34c.007.032-.004.08-.042.145-.038.063-.093.13-.153.195l.11.102c.062-.068.126-.144.172-.22.044-.076.079-.165.06-.253l-.147.031zm-.037-.124c.016-.025.018-.013 0-.012-.02.001-.024-.012-.014 0a.22.22 0 01.028.056c.01.025.017.053.023.08l.147-.031a.518.518 0 00-.08-.197c-.02-.026-.058-.061-.113-.058-.055.003-.092.042-.116.08l.125.082zm-.93-.134a.163.163 0 00-.052.01.537.537 0 00-.153.096.376.376 0 00-.136.27h.15c0-.055.034-.111.087-.159a.387.387 0 01.101-.065c.008-.003.008-.002.003-.002v-.15zm-.064.355a.384.384 0 00.141-.166.209.209 0 00.02-.094.105.105 0 00-.024-.062.095.095 0 00-.073-.033v.15a.055.055 0 01-.04-.02.046.046 0 01-.012-.025c0-.002 0 .006-.008.024a.234.234 0 01-.083.099l.079.127zm.043-.034a.754.754 0 01-.057-.025c-.002-.002-.001-.002 0 0 .003.003.01.01.012.022a.055.055 0 01-.002.035l-.007.01.01-.008-.078-.127a.153.153 0 00-.063.066.095.095 0 00.02.106c.018.018.04.03.056.038l.055.022.054-.14zm.085.037a.665.665 0 00-.085-.037l-.054.14c.027.01.05.019.068.029l.071-.132zm-.176.349a.431.431 0 00.2-.127.18.18 0 00.046-.106.125.125 0 00-.07-.116l-.071.132s-.01-.008-.009-.021c0-.005.002 0-.011.015a.283.283 0 01-.128.079l.043.144zm-.23-.33c0 .041 0 .084.003.122a.42.42 0 00.018.11.156.156 0 00.078.094.18.18 0 00.131.004l-.043-.144c-.024.007-.028.002-.023.005.006.002.004.006 0-.008a.28.28 0 01-.012-.07 2.033 2.033 0 01-.001-.114h-.15zm-.15.974a.62.62 0 01-.03-.39 1.82 1.82 0 01.117-.348l-.138-.059a1.964 1.964 0 00-.125.378.769.769 0 00.04.484l.135-.065zm.044.097a8.344 8.344 0 00-.045-.097l-.135.065.044.094.136-.062zm0-.001l-.135.064.135-.064zm.317.357a.15.15 0 01-.088-.011.222.222 0 01-.075-.064 1.398 1.398 0 01-.154-.281l-.136.062c.053.115.106.232.174.314a.37.37 0 00.127.104.3.3 0 00.172.025l-.02-.15zm.276-.474a1.59 1.59 0 01-.097.287.526.526 0 01-.086.132.16.16 0 01-.093.055l.02.149a.31.31 0 00.181-.1.673.673 0 00.113-.171c.058-.12.092-.253.108-.315l-.146-.037zm.006-.021l-.006.02.146.038.005-.02-.145-.038zm.303-.155a.13.13 0 00-.035-.062.097.097 0 00-.082-.025.126.126 0 00-.057.026.234.234 0 00-.036.036.524.524 0 00-.093.18l.145.038a.377.377 0 01.076-.135c.003-.003-.001.001-.012.003a.053.053 0 01-.044-.013c-.009-.009-.009-.015-.007-.009l.145-.04zm.002.271c.003-.048.007-.098.008-.144 0-.043 0-.09-.01-.127l-.145.039a.351.351 0 01.005.085c-.001.04-.004.088-.008.136l.15.011zm0-.005h-.15.15zm-.003.21a.293.293 0 01-.005-.073c.001-.038.004-.084.008-.132l-.15-.01c-.003.047-.007.096-.008.139 0 .04 0 .086.011.121l.144-.044zm.351.343a.172.172 0 01-.133-.006.293.293 0 01-.105-.094.86.86 0 01-.113-.242l-.144.044c.014.045.057.177.136.286a.44.44 0 00.162.142c.07.033.152.042.243.013l-.046-.143zm.295-.222c-.079.087-.164.18-.295.222l.046.143c.174-.056.284-.18.36-.264l-.111-.1zm.262-.135c-.063-.022-.117.003-.156.031-.037.027-.073.068-.106.104l.111.1a.664.664 0 01.083-.083.059.059 0 01.018-.01h.001l.05-.142zm.186.172a1.011 1.011 0 00-.082-.098.275.275 0 00-.104-.074l-.049.142a.14.14 0 01.044.035c.022.023.046.053.073.088l.118-.093zm.24.183c-.034.006-.068-.005-.11-.04a.933.933 0 01-.13-.143l-.118.093c.042.053.093.118.152.166.06.05.139.089.233.071l-.027-.147zm.311-.29a1.324 1.324 0 01-.138.182.337.337 0 01-.173.108l.027.147a.483.483 0 00.254-.151c.065-.068.118-.146.155-.202l-.125-.083zm0 .002l.126.081-.126-.081zm.054-.077a.972.972 0 00-.053.076l.124.083a.985.985 0 01.046-.065l-.117-.094zm.23.032l-.028-.04a.146.146 0 00-.05-.042.105.105 0 00-.09-.001.173.173 0 00-.062.05l.117.095a.076.076 0 01.009-.01l-.003.002a.045.045 0 01-.04-.003l-.002-.002.001.001.003.003a.238.238 0 01.008.012l.011.017.126-.082zm.031.044a.448.448 0 01-.031-.044l-.126.082a.62.62 0 00.042.059l.115-.097zm.125.007a.086.086 0 01-.033.031.04.04 0 01-.025.004.116.116 0 01-.067-.042l-.115.097a.265.265 0 00.163.094c.075.01.15-.022.202-.1l-.125-.084zm.132-.291c.01-.004.002.001-.011-.004a.036.036 0 01-.021-.02v.007l.001.016a.808.808 0 01-.1.291l.124.084a.95.95 0 00.116-.291.312.312 0 00.001-.154.115.115 0 00-.066-.072.133.133 0 00-.098.002l.054.14zm-.01.003l.01-.003-.054-.14-.01.003.054.14zm-.517-.046a.213.213 0 00.117.106c.047.018.097.02.143.015.09-.01.187-.048.257-.075l-.053-.14a.966.966 0 01-.22.066.161.161 0 01-.074-.006.063.063 0 01-.035-.034l-.135.068zm-.107-.714a.098.098 0 00-.064.023.106.106 0 00-.032.05.205.205 0 00-.004.086 1 1 0 00.051.188c.048.137.118.29.156.367l.135-.068a3.51 3.51 0 01-.15-.349.87.87 0 01-.043-.158c-.003-.02 0-.025-.002-.021a.044.044 0 01-.014.02.052.052 0 01-.033.012v-.15zm.16-.073c.006.03 0 .04 0 .044-.002.003-.007.009-.021.014a.406.406 0 01-.139.015v.15c.046 0 .13.001.196-.026a.185.185 0 00.095-.082.21.21 0 00.015-.145l-.146.03zm.513.425a5.227 5.227 0 00-.228-.348 1.369 1.369 0 00-.124-.155.205.205 0 00-.03-.025.11.11 0 00-.022-.012.086.086 0 00-.043-.005.08.08 0 00-.054.033.088.088 0 00-.015.04.143.143 0 00.003.047l.146-.03v.002a.062.062 0 01-.012.028.07.07 0 01-.046.028.064.064 0 01-.032-.003l-.009-.004.008.007c.024.024.063.073.108.136.089.124.19.282.219.335l.13-.074zm.07.127l-.07-.127-.131.074.069.125.131-.072zm.445.77l-.015-.02a6.43 6.43 0 01-.168-.277c-.092-.16-.194-.348-.263-.473l-.131.072c.068.124.17.313.264.476a6.552 6.552 0 00.176.29.251.251 0 00.046.052l.09-.12zm.15 1.375a19.315 19.315 0 00-.043-.794 6.412 6.412 0 00-.036-.362 1.328 1.328 0 00-.022-.124.341.341 0 00-.014-.045.115.115 0 00-.035-.05l-.09.12c-.015-.011-.018-.023-.014-.014a1.16 1.16 0 01.026.134c.013.092.025.216.036.353.021.273.037.59.043.787l.15-.005zm-.252.07c.09 0 .14.002.164.006l.027-.147a1.212 1.212 0 00-.191-.01v.15zm-.563.045c.151-.02.334-.046.563-.046v-.15c-.24 0-.432.027-.584.048l.021.148zm-.418.008c.06.019.125.022.193.018a2.74 2.74 0 00.225-.026l-.02-.148a2.706 2.706 0 01-.213.024.397.397 0 01-.14-.011l-.045.143zm-.162-.035c.057.01.115.02.162.035l.046-.143c-.06-.019-.128-.03-.182-.04l-.026.148zm-.027-.254a.606.606 0 00-.118.052.122.122 0 00-.043.044.087.087 0 00.01.096.116.116 0 00.046.032.29.29 0 00.04.013l.092.017.026-.148a1.373 1.373 0 01-.102-.02h.001a.05.05 0 01.012.01.064.064 0 01.007.07.048.048 0 01-.01.013h.002a.91.91 0 01.087-.037l-.05-.142zm.2-.057c-.068.018-.138.035-.2.057l.05.142c.054-.02.117-.035.188-.053l-.037-.146zm.512-.429a.332.332 0 01-.03.18.305.305 0 01-.107.114c-.098.065-.233.1-.374.135l.037.146c.134-.034.296-.074.42-.156a.455.455 0 00.156-.17.48.48 0 00.048-.26l-.15.011zm-.338-.516a.357.357 0 01.168.001c.034.011.06.032.082.067a.5.5 0 01.057.168c.014.076.024.169.031.28l.15-.01a2.66 2.66 0 00-.034-.297.642.642 0 00-.076-.22.296.296 0 00-.164-.13.502.502 0 00-.24-.007l.026.148zm-.38.51c0-.12.025-.235.083-.326a.418.418 0 01.297-.184l-.026-.148a.567.567 0 00-.397.251.754.754 0 00-.107.408h.15zm-.187.303c.02-.002.048-.004.072-.012a.139.139 0 00.077-.058.236.236 0 00.032-.097 1.06 1.06 0 00.006-.135h-.15a.926.926 0 01-.01.143.053.053 0 01-.003.006v.002c.001-.003.005-.004.003-.004a.24.24 0 01-.041.006l.014.15zm-.055.007a.762.762 0 01.055-.007l-.014-.149-.066.008.025.148zm-.054.008l.054-.008-.025-.148a1.666 1.666 0 01-.049.007l.02.149zm0 0l-.02-.149.02.149zm0 0l-.02-.149.02.149zm-.718.377c.212-.306.545-.354.718-.377l-.02-.149c-.172.024-.568.075-.82.44l.122.086zm-.316-.425c-.006.11-.017.295.004.411.005.03.013.062.028.088a.12.12 0 00.093.065.146.146 0 00.107-.04.512.512 0 00.084-.1l-.123-.085a.372.372 0 01-.058.07c-.015.013-.012.004.004.006.02.002.027.016.024.01a.146.146 0 01-.012-.04 1.962 1.962 0 01-.001-.377l-.15-.008zm0 .004h.15-.15zm.004-.093l-.004.089.15.008.004-.097h-.15zm-.14-.447c.102.234.14.335.14.447h.15c0-.15-.053-.279-.153-.507l-.137.06zm-.008-.017l.008.017.137-.06-.008-.018-.137.06zm-.247-.23c.038-.057.061-.066.066-.067h.006a.083.083 0 01.025.02.49.49 0 01.074.112c.026.05.05.107.076.165l.137-.06a2.274 2.274 0 00-.08-.174.63.63 0 00-.1-.148c-.039-.04-.096-.077-.167-.062-.066.013-.119.065-.162.133l.125.081zm.085.579a.303.303 0 01-.05-.072.735.735 0 01-.064-.154c-.034-.12-.037-.25.03-.353l-.126-.081c-.1.154-.088.335-.048.475.02.071.049.136.077.186a.416.416 0 00.088.116l.093-.117zm.087 1.361c.206-.226.197-.558.14-.82a1.911 1.911 0 00-.17-.466.493.493 0 00-.026-.041.17.17 0 00-.03-.034l-.094.117c-.004-.003-.003-.004.002.004.005.006.01.016.018.029a1.763 1.763 0 01.154.424c.054.25.049.517-.105.686l.11.101zm-1.114.665c.068.062.164.047.24.021a1.16 1.16 0 00.273-.15c.196-.134.418-.335.6-.536l-.11-.1c-.177.194-.39.386-.575.513a1.061 1.061 0 01-.237.131c-.07.024-.09.011-.09.01l-.101.111zm-.054-.421a.279.279 0 00-.1.1.157.157 0 00-.007.132c.014.037.04.07.067.099.027.029.06.06.094.09l.1-.11a1.513 1.513 0 01-.084-.082.18.18 0 01-.037-.05c-.002-.007-.002-.007 0-.01.003-.006.014-.021.049-.043l-.082-.126zm.126-.066c-.048.024-.095.046-.126.066l.082.126c.02-.014.056-.03.11-.056l-.066-.136zm.636-.812a.555.555 0 01-.183.528c-.138.133-.32.221-.453.284l.065.136c.13-.062.333-.16.492-.311a.705.705 0 00.226-.664l-.147.027zm-.15-.611c.032.105.091.29.15.611l.147-.027a4.76 4.76 0 00-.155-.63l-.143.046zm.065-.224a.096.096 0 00-.075.032.1.1 0 00-.021.076.303.303 0 00.01.052l.02.064.143-.046a2.263 2.263 0 01-.024-.084c0-.005.003.015-.013.035a.06.06 0 01-.028.018c-.007.003-.012.003-.012.003v-.15zm.033.001l-.033-.001v.15h.023l.01-.149zm-.017-.092a.444.444 0 01.028.098c.003.02-.002.017.004.008.009-.013.02-.014.017-.013l-.032-.001-.01.15c.014 0 .04.003.063 0a.122.122 0 00.087-.052.158.158 0 00.02-.109.583.583 0 00-.036-.133l-.14.052zm-.313-.212c.052-.058.089-.076.11-.08.017-.003.035.001.058.022a.38.38 0 01.076.108c.025.05.048.106.07.162l.14-.052a1.683 1.683 0 00-.077-.179.523.523 0 00-.11-.152.214.214 0 00-.183-.056.359.359 0 00-.196.127l.112.1zm0 .477c-.067-.08-.11-.145-.119-.212-.008-.063.012-.146.119-.265l-.112-.1c-.123.137-.171.262-.156.383a.58.58 0 00.155.292l.114-.098zm.099.803a.447.447 0 00.138-.233.434.434 0 00-.019-.23 1.103 1.103 0 00-.217-.34l-.114.098c.07.081.152.182.19.29a.284.284 0 01.013.151.299.299 0 01-.094.155l.103.109zm-.219.221c.065-.067.138-.144.219-.221l-.103-.109c-.084.08-.16.16-.224.227l.108.103zm0 .001l-.107-.106.106.106zm-.366.107a.13.13 0 00.012.058.09.09 0 00.072.05.112.112 0 00.06-.012.245.245 0 00.04-.026c.048-.036.112-.104.182-.178l-.108-.103a2.008 2.008 0 01-.18.173c-.003.001.005-.004.021-.003a.06.06 0 01.047.032c.005.01.004.015.004.009h-.15zm.035-.12a.133.133 0 01.014-.025c.003-.004-.003.006-.02.01a.055.055 0 01-.047-.012c-.006-.005-.006-.008-.004-.002a.23.23 0 01.015.06c.004.029.007.06.007.089h.15a.574.574 0 00-.035-.211.142.142 0 00-.034-.048.095.095 0 00-.085-.023.116.116 0 00-.063.042.273.273 0 00-.034.058l.136.063zm-.039.095a1.64 1.64 0 01.039-.094l-.136-.063c-.015.032-.029.068-.043.103l.14.054zm-.364.463c.226-.095.309-.319.364-.463l-.14-.054c-.06.155-.123.312-.282.379l.058.138zm-.803.428l.045.06h.001l.005-.004a5.008 5.008 0 01.08-.058l.209-.147a3.36 3.36 0 01.463-.279l-.058-.138a3.461 3.461 0 00-.49.294 10.71 10.71 0 00-.293.208l-.005.003h-.001v.001l.044.06zm-.202.213h-.003c.004.001.018.004.03.017.03.03.012.062.016.051a.704.704 0 01.06-.077 1.952 1.952 0 01.145-.144l.003-.003a.038.038 0 01.001 0l-.05-.057-.05-.056v.002l-.004.002a2.188 2.188 0 00-.207.215.29.29 0 00-.037.063c-.006.014-.025.067.016.109a.1.1 0 00.058.028.16.16 0 00.046-.002l-.024-.148zm.656-.226a.507.507 0 01-.115.064 2.791 2.791 0 01-.541.163l.024.147a2.926 2.926 0 00.577-.173.639.639 0 00.152-.087l-.097-.114zM7 7.068l-.018-.072h-.005a1.336 1.336 0 00-.155.048.876.876 0 00-.26.133l.097.114a.744.744 0 01.213-.106 1.853 1.853 0 01.142-.043h.003L7 7.067zm.634.435c-.058.017-.12.005-.186-.032a.758.758 0 01-.19-.163 1.582 1.582 0 01-.191-.274 16.602 16.602 0 01-.133.07.126.126 0 00.004.007 1.231 1.231 0 00.054.09c.037.058.09.133.154.206a.905.905 0 00.23.195c.087.05.191.076.3.045l-.042-.144zm1.1-.841l-.055-.05c-.001 0-.002 0-.002.002a7.208 7.208 0 01-.118.125 9.048 9.048 0 01-.29.288 4.735 4.735 0 01-.35.304c-.116.09-.216.151-.285.172l.042.144c.099-.03.218-.106.335-.197.12-.092.246-.205.36-.314a9.202 9.202 0 00.416-.42c0-.002.002-.002.002-.003l-.055-.051zm.982.598c-.232-.019-.46-.173-.637-.333a2.411 2.411 0 01-.283-.308h-.001v-.001l-.06.044-.061.044.001.002a1.425 1.425 0 00.082.102c.053.062.128.144.221.228.183.166.442.349.726.372l.012-.15zm.45-.104c.012.01.019.018.022.024l.003.005v.002s0 .002-.002.003a.072.072 0 01-.022.02c-.056.037-.196.07-.45.05l-.013.15c.262.02.445-.01.545-.074.052-.034.092-.085.092-.15 0-.063-.038-.114-.084-.149l-.091.12zm-.145-.09c.06.035.11.065.144.09l.092-.119a1.552 1.552 0 00-.161-.1l-.075.13zm-.3-.413a.163.163 0 00-.016.148c.016.044.047.08.08.11.064.058.159.111.236.156l.075-.13a1.314 1.314 0 01-.21-.138.143.143 0 01-.04-.05c-.002-.005-.003-.008.002-.016l-.127-.08zm.69-.29c-.17.027-.312.054-.425.095a.497.497 0 00-.265.195l.127.08c.036-.057.094-.099.19-.134.097-.035.226-.06.397-.088l-.024-.148zm.152-.022c-.049.006-.1.013-.152.022l.024.148.149-.022-.02-.148zm.548-.275a.284.284 0 01-.182.197c-.097.04-.22.058-.366.078l.02.148c.14-.019.286-.038.405-.088a.433.433 0 00.267-.295l-.144-.04zm.266-.322c-.075.055-.22.158-.266.322l.144.04c.03-.105.128-.18.21-.24l-.088-.122zm.035-.026a.318.318 0 01-.035.026l.089.122.039-.03-.093-.118zm.123.151c0-.023 0-.055-.002-.094l-.15.004c.002.038.002.069.002.09h.15zm-.045 1.143a.392.392 0 00.015-.081l.009-.119c.005-.091.01-.207.013-.326.006-.24.008-.498.008-.617h-.15a26.981 26.981 0 01-.02.935 2.56 2.56 0 01-.014.146l-.002.011.141.05zm.083-.127a.187.187 0 01-.098.067c-.023.006-.025.002-.016.005a.051.051 0 01.03.031c.005.016 0 .026.001.024l-.141-.05a.115.115 0 00-.002.076c.011.032.035.05.058.06a.179.179 0 00.112-.002.333.333 0 00.185-.135l-.13-.076zm.003-.006l-.003.006.129.076.004-.006-.13-.076zm.125-.39c0 .179-.07.297-.125.39l.13.076c.056-.096.145-.244.145-.466h-.15zm.001-.134l-.001.134h.15l.001-.133-.15-.001zm-.041-.996a.633.633 0 01.026.152c.007.076.012.17.014.27.005.2.003.422.001.574l.15.001c.002-.15.004-.375 0-.579a4.327 4.327 0 00-.015-.28.737.737 0 00-.038-.196l-.138.058zm.118-.36a.095.095 0 00-.076-.023.094.094 0 00-.065.043.198.198 0 00-.026.096.577.577 0 00.049.244l.138-.058a.428.428 0 01-.037-.178c.002-.024.006-.028.002-.022a.056.056 0 01-.039.023.056.056 0 01-.044-.01L11.779 5zm.333.605a47.524 47.524 0 00-.28-.527 1.26 1.26 0 00-.036-.058.115.115 0 00-.017-.02l-.098.114-.006-.006.005.008.021.036.07.129c.058.106.13.246.208.393l.133-.069zm.406.75l-.014-.02a7.41 7.41 0 01-.132-.235l-.26-.495-.133.07c.09.172.184.353.261.496a7.56 7.56 0 00.138.244c.01.015.02.032.031.043l.11-.103zm-.036-.162a1.19 1.19 0 01-.039.169c-.002.002 0-.003.009-.008a.057.057 0 01.062-.002.032.032 0 01.003.002l.002.001-.11.103c.011.012.03.027.055.033a.092.092 0 00.075-.015.123.123 0 00.034-.04.238.238 0 00.017-.039 1.16 1.16 0 00.04-.179l-.148-.025zm.055-.216a.416.416 0 00-.033.1c-.008.036-.015.077-.022.116l.148.025c.007-.04.013-.076.02-.108a.29.29 0 01.019-.062l-.132-.07zm.234.036a.4.4 0 00-.01-.108.1.1 0 00-.038-.055.085.085 0 00-.09-.004.127.127 0 00-.036.031 1.237 1.237 0 00-.06.1l.132.071a1.088 1.088 0 01.044-.076c.003-.004 0 .001-.008.006a.066.066 0 01-.067-.004.06.06 0 01-.02-.024v.003l.002.013a.549.549 0 01.001.047h.15zm.001.052v-.052h-.15v.056l.15-.004zm-.359.883c.377-.251.364-.689.36-.883l-.15.004c.004.204.008.554-.293.754l.083.125zm-.307.21c.087-.06.188-.131.307-.21l-.083-.125c-.12.08-.223.15-.31.21l.086.124zm-.397.236a.627.627 0 00.166-.081c.063-.04.14-.092.231-.156l-.085-.123a6.48 6.48 0 01-.225.152.504.504 0 01-.123.063l.036.145zm.02.084c-.01 0-.016-.003-.02-.008a.059.059 0 01-.014-.032.064.064 0 01.005-.035c.003-.007.006-.008.009-.009l-.037-.145c-.106.027-.135.135-.125.208.01.078.067.171.183.171v-.15zm.039.001h-.038v.15h.033l.005-.15zm.93-.526c-.146.277-.336.407-.508.47a1.091 1.091 0 01-.422.056l-.005.15c.09.003.275.01.478-.065.206-.075.426-.23.59-.542l-.133-.07zm.058-2.738c.023.221.08.773.095 1.34.007.283.004.568-.02.816-.023.25-.066.455-.133.582l.133.07c.081-.155.126-.384.15-.638.024-.256.027-.548.02-.834a17.875 17.875 0 00-.096-1.352l-.15.016zm-.01-.108l.003.038.007.07.15-.016-.008-.068a2.02 2.02 0 01-.002-.02v-.004h-.15zm-.027-.1c.008.03.016.053.02.073a.4.4 0 01.006.022v.005h.15a.279.279 0 00-.01-.066l-.023-.076-.143.043zm-.054-.482a.454.454 0 00-.007.247c.015.083.041.17.06.236l.144-.043a2.146 2.146 0 01-.057-.22c-.014-.079-.014-.134-.002-.162l-.138-.058zm.182-.095c-.004-.002-.05-.032-.102-.007a.128.128 0 00-.049.043.326.326 0 00-.03.059l.137.058a.182.182 0 01.016-.03c.003-.005 0 0-.01.005a.051.051 0 01-.033.003l-.004-.001s.002 0 .005.003l.07-.133zm-.024.004c-.003.004-.004.003 0 .001a.038.038 0 01.03-.002l-.006-.003-.07.133c.006.003.033.019.066.018a.127.127 0 00.092-.047l-.112-.1zm-.003-.269c.064.082.07.134.064.166a.221.221 0 01-.061.103l.112.1a.36.36 0 00.097-.179c.014-.086-.013-.179-.094-.282l-.118.092zm-.133-.247c.033.076.075.173.133.247l.118-.092a1.034 1.034 0 01-.114-.215l-.137.06zm-.066-.12c.019-.025.024-.02.014-.018-.018.004-.027-.008-.022-.002a.208.208 0 01.03.048c.014.025.028.057.043.092l.138-.06a1.841 1.841 0 00-.047-.1.344.344 0 00-.057-.086.125.125 0 00-.119-.039.182.182 0 00-.1.077l.12.088zm-.117.896a1.444 1.444 0 01-.006-.479c.011-.09.028-.176.05-.25a.574.574 0 01.073-.167l-.12-.088a.717.717 0 00-.097.213 1.787 1.787 0 00-.055.273c-.025.19-.025.394.01.535l.145-.037zm.046 2.184c.01.01.026.023.05.029a.09.09 0 00.075-.016.11.11 0 00.033-.043.206.206 0 00.012-.04.949.949 0 00.012-.208 15.34 15.34 0 00-.228-1.906l-.145.037a15.382 15.382 0 01.223 1.872.893.893 0 01-.008.174l-.002.007v.003l.002-.004a.05.05 0 01.01-.011.061.061 0 01.052-.01.05.05 0 01.015.006l.005.003-.106.107zm-.31-.519c.05.104.1.205.15.294.05.087.102.167.16.225l.105-.107a.9.9 0 01-.135-.192 6.137 6.137 0 01-.146-.285l-.134.065zm-.226-.426c.082.132.155.282.226.426l.134-.065c-.07-.144-.146-.3-.233-.44l-.127.079zm-.5-1.285a.264.264 0 00-.028.134c.001.046.01.097.023.148.028.104.076.222.133.342.115.239.269.494.372.66l.127-.078a7.359 7.359 0 01-.363-.647 1.89 1.89 0 01-.123-.315.506.506 0 01-.019-.113c0-.031.004-.049.01-.058l-.132-.073zm.086-.135a1.412 1.412 0 00-.086.135l.132.073c.03-.055.056-.092.077-.122l-.123-.086zm.02-.151c.018.058.018.078.016.089-.002.01-.008.021-.036.062l.123.086c.023-.034.05-.072.06-.12a.333.333 0 00-.02-.162l-.144.045zm-.126-.2a.576.576 0 01.125.2l.143-.045c-.034-.11-.098-.184-.153-.25l-.115.096zm-.142-.204c.042.086.096.15.142.205l.115-.096a.851.851 0 01-.122-.175l-.135.066zm-.12-.151c0-.032.01-.018-.01-.008-.015.009-.02-.002 0 .009.037.02.093.075.13.15l.135-.066a.5.5 0 00-.195-.217c-.034-.018-.09-.036-.141-.008-.055.03-.068.09-.068.14h.15zm-.291.189a.253.253 0 00.032.066.122.122 0 00.064.048c.066.02.112-.03.13-.055a.463.463 0 00.066-.248h-.15a.403.403 0 01-.013.098.206.206 0 01-.025.063c-.012.016 0-.012.035-.002.013.004.017.011.015.008a.114.114 0 01-.012-.027l-.142.049zm-.38-.362c.008-.007.022-.013.057 0 .036.013.08.044.126.087a.826.826 0 01.197.275l.142-.049a.966.966 0 00-.236-.335.562.562 0 00-.177-.119c-.063-.024-.14-.028-.206.026l.097.115zm-.033.072c-.01-.022-.009-.023-.009-.024 0 0 0-.004.006-.012a.192.192 0 01.036-.036l-.097-.115c-.051.043-.085.088-.093.14-.008.05.012.09.02.109l.137-.062zm.002.138c.036-.062.006-.12-.002-.138l-.137.062.006.013v.003a.023.023 0 01.002-.014l.131.074zm-.019.037a.673.673 0 01.02-.037l-.13-.075c-.01.015-.017.031-.024.045l.134.067zm.002-.004l-.138-.06.138.06zm-.247.031c.011.028.028.06.056.08a.098.098 0 00.114 0 .176.176 0 00.048-.055.657.657 0 00.027-.052l-.134-.067a.629.629 0 01-.029.052l.003-.002a.05.05 0 01.026-.008.05.05 0 01.032.01c.005.003.006.006.004.002a.122.122 0 01-.01-.018l-.137.058zm-.028-.08a.832.832 0 00.028.08l.138-.058a.945.945 0 01-.024-.068l-.143.046zm-.19-.12c.046-.042.074-.054.088-.056.009-.002.015 0 .024.008a.201.201 0 01.04.065c.014.031.026.067.038.103l.142-.046a1.08 1.08 0 00-.043-.118.344.344 0 00-.075-.114.173.173 0 00-.15-.046.333.333 0 00-.166.095l.102.11zm-.132.482a.203.203 0 01-.052-.193.567.567 0 01.184-.289l-.102-.11a.713.713 0 00-.23.37.353.353 0 00.095.328l.105-.106zm.243.69a.264.264 0 00.037-.188.643.643 0 00-.06-.189 1.209 1.209 0 00-.22-.313l-.105.106c.06.06.139.166.19.272a.5.5 0 01.046.144c.006.041 0 .067-.011.083l.123.085zm-.505.094c.03.052.074.089.127.104a.239.239 0 00.149-.008.512.512 0 00.229-.19l-.123-.085a.365.365 0 01-.157.134.09.09 0 01-.056.005c-.011-.003-.025-.011-.04-.036l-.13.076zm-.113-.598a.832.832 0 00.113.598l.13-.076a.682.682 0 01-.095-.495l-.148-.027zm-.067-.728c.019-.005.027-.003.03 0 .006.002.015.009.025.028.023.04.038.11.044.2.012.178-.012.394-.032.5l.148.027a2.46 2.46 0 00.034-.536.659.659 0 00-.062-.264.211.211 0 00-.09-.09.188.188 0 00-.139-.009l.042.144zm-.123.543a.73.73 0 01-.032-.32c.016-.116.065-.196.155-.223l-.042-.144c-.172.051-.242.204-.262.345a.88.88 0 00.04.392l.141-.05zm.045.617a.355.355 0 00.03-.133 1.432 1.432 0 00-.075-.485l-.141.051a1.284 1.284 0 01.066.425.22.22 0 01-.014.076l.134.066zm-.005.011l.005-.01-.134-.067-.005.01.134.067zm-.448.323c.06.038.122.04.178.016a.348.348 0 00.126-.101 1.26 1.26 0 00.144-.238l-.134-.066a1.101 1.101 0 01-.125.208.204.204 0 01-.07.058c-.013.006-.023.006-.037-.003l-.082.126zm-.227-.727c-.04.148-.028.3.015.427a.572.572 0 00.212.3l.082-.126a.426.426 0 01-.152-.221.598.598 0 01-.012-.341l-.145-.04zm-.081-.472a.076.076 0 01.035-.013.02.02 0 01.012.004c.013.01.031.038.045.093a.864.864 0 01-.011.388l.145.039c.038-.143.045-.326.012-.462a.31.31 0 00-.1-.177.167.167 0 00-.105-.035.223.223 0 00-.11.034l.077.13zm-.422.684c0-.083.052-.224.137-.366a.968.968 0 01.285-.318l-.077-.129c-.123.074-.246.22-.336.37-.09.147-.159.317-.159.443h.15zm-.314.346a.192.192 0 00.056.064.112.112 0 00.093.018.134.134 0 00.067-.045.265.265 0 00.038-.06.841.841 0 00.06-.323h-.15a.69.69 0 01-.047.26.12.12 0 01-.015.026c-.004.005-.001 0 .01-.003a.038.038 0 01.029.004c.002.001-.002 0-.01-.015l-.13.074zm-.014-.025l.014.025.13-.074-.014-.026-.13.075zm-.15-.631a.562.562 0 00.015.353c.036.106.092.203.135.278l.13-.075a1.44 1.44 0 01-.123-.251.413.413 0 01-.014-.26l-.143-.045zm.017-.25c.007-.017.012-.022.011-.021a.039.039 0 01-.03.007c-.013-.002-.018-.009-.015-.006.002.003.007.01.012.022a.39.39 0 01.005.248l.143.045a.537.537 0 00-.01-.353.23.23 0 00-.04-.062.125.125 0 00-.075-.042.113.113 0 00-.092.03.208.208 0 00-.047.073l.138.059zm-4.14-.416a.336.336 0 01-.01-.012c-.003-.003 0-.001.001.004a.055.055 0 01-.005.052l-.12-.09a.095.095 0 00-.012.097c.009.022.026.04.033.048l.113-.099zm.117.193a.618.618 0 00-.117-.193l-.113.099a.473.473 0 01.091.15l.14-.056zm.053.304c-.007-.085-.016-.212-.053-.304L3.59 2.9c.026.066.035.167.043.26l.15-.012zm-.083.07a.155.155 0 01-.01.017c-.002.004.002-.003.012-.01a.068.068 0 01.072.003.06.06 0 01.017.018l.004.006-.002-.007a2.137 2.137 0 01-.01-.097l-.15.012.008.08a.293.293 0 00.014.066c.003.009.012.03.035.046a.082.082 0 00.09.002.116.116 0 00.035-.035.293.293 0 00.02-.036L3.7 3.217zm.026-.505c.008.005.021.02.031.06a.48.48 0 01.01.143.849.849 0 01-.067.302l.135.065a.995.995 0 00.083-.36.664.664 0 00-.015-.186.244.244 0 00-.093-.149l-.084.125zm-.127-.018a.048.048 0 01.03-.014c.017-.002.05 0 .097.032l.084-.125a.29.29 0 00-.202-.055.195.195 0 00-.13.073l.121.09zm1.296-.051l-.075-.007v.002a.245.245 0 000 .016c-.001.011-.002.026-.001.045 0 .035.004.085.017.135.012.05.035.107.077.153a.247.247 0 00.187.078v-.15a.097.097 0 01-.077-.03.196.196 0 01-.042-.087.479.479 0 01-.011-.148l-.075-.007zm.105-.108a.242.242 0 00-.132.028.106.106 0 00-.038.04.09.09 0 00-.01.036v.003a2.413 2.413 0 00.15.001v.002a.121.121 0 01-.002.013.06.06 0 01-.005.015.045.045 0 01-.015.017c-.004.002.005-.005.052-.005v-.15zm.158.132a.173.173 0 00-.034-.083c-.03-.036-.075-.05-.124-.05v.15c.011 0 .016.002.016.002h-.001l-.002-.001a.021.021 0 01-.004-.004l-.001-.002.001.006.002.01.147-.028zm-.004.003c.006.006.008.012.007.01v-.003a.398.398 0 01-.003-.01l-.147.028.008.032a.12.12 0 00.026.046l.11-.103zm-.113.023v.01c-.001.003 0-.004.004-.013a.072.072 0 01.101-.027.048.048 0 01.008.007l-.109.103c.004.004.023.024.053.028a.079.079 0 00.08-.044.106.106 0 00.01-.031l.002-.018-.149-.015zm.108-.125a.1.1 0 00-.065.023.11.11 0 00-.03.044c-.01.023-.012.049-.013.058l.15.015.001-.015V2.69a.04.04 0 01-.011.016.052.052 0 01-.032.012v-.15zm.133.207a.362.362 0 00-.015-.123.122.122 0 00-.118-.084v.15a.03.03 0 01-.016-.007c-.007-.005-.008-.01-.007-.006a.463.463 0 01.006.07h.15zM5.2 2.72a.051.051 0 01-.005.02l-.004.007c.001 0 .007-.006.018-.009a.062.062 0 01.05.01.05.05 0 01.023.027v-.001h-.15c0 .014.002.03.007.046a.096.096 0 00.037.052.088.088 0 00.072.011.107.107 0 00.043-.023.194.194 0 00.059-.14H5.2zm.192-.153a.26.26 0 00-.112.02.14.14 0 00-.08.133h.15c0-.006 0-.005-.001-.001l-.004.003a.056.056 0 01.016-.004.229.229 0 01.031-.001v-.15zm-.292.497c.158 0 .265-.115.32-.21a.48.48 0 00.057-.144.184.184 0 00.002-.067.098.098 0 00-.021-.046.086.086 0 00-.066-.03v.15a.064.064 0 01-.048-.023.052.052 0 01-.012-.023c-.001-.005 0-.002-.003.01a.332.332 0 01-.038.097c-.045.078-.112.136-.191.136v.15zm-1.104 3.01a.194.194 0 00-.154.085.507.507 0 00-.078.172 1.408 1.408 0 00-.033.477l.15-.013a1.26 1.26 0 01.027-.424.362.362 0 01.053-.12c.019-.025.03-.026.035-.026v-.15zm.143.393h.075v-.004a.699.699 0 00-.002-.05.848.848 0 00-.018-.12.402.402 0 00-.053-.136.173.173 0 00-.145-.082v.15c.003 0 .01 0 .02.016a.258.258 0 01.032.084.698.698 0 01.016.14v.002h.075zm.743.608a.648.648 0 01-.557-.317.86.86 0 01-.11-.295l-.002-.004-.074.008a6.748 6.748 0 00-.074.01.73.73 0 01.005.033 1.01 1.01 0 00.127.327.798.798 0 00.678.387l.007-.15zm1.096-1.041l-.07-.027v.002a.88.88 0 01-.019.044 3.01 3.01 0 01-.275.507 1.61 1.61 0 01-.331.368.614.614 0 01-.401.147l-.007.15a.762.762 0 00.5-.178c.142-.11.264-.258.363-.402a3.169 3.169 0 00.309-.58v-.003l.001-.001-.07-.027zm.027-.434l-.075.004v.01a1.789 1.789 0 010 .13 1.714 1.714 0 01-.025.276l.147.029a1.861 1.861 0 00.03-.408 2.037 2.037 0 00-.002-.043l-.075.003zm-.044.203l.032-.117a.425.425 0 01.023-.063c.003-.005.002-.003-.002.002a.06.06 0 01-.05.014.052.052 0 01-.032-.017l.005.01.136-.064a.197.197 0 00-.026-.041.09.09 0 00-.136-.011.144.144 0 00-.029.039.551.551 0 00-.032.088l-.034.122.145.038zm-.212.629c.108-.242.17-.472.212-.629l-.145-.038c-.042.156-.101.376-.204.606l.137.06zm-1.037.52c.143.004.342.009.534-.054a.81.81 0 00.503-.466l-.137-.061a.66.66 0 01-.412.385c-.165.053-.339.05-.485.046l-.003.15zm-.033 0h.033l.003-.15h-.033l-.003.15zm-.615-.795c.014.137.083.328.185.487.051.08.113.154.183.21.07.056.154.096.247.098l.003-.15a.264.264 0 01-.157-.066.714.714 0 01-.15-.173 1.077 1.077 0 01-.161-.421l-.15.015zm.133-.446a12.25 12.25 0 00-.07-.03v.004a.426.426 0 00-.014.036 1.06 1.06 0 00-.049.436l.15-.015a.91.91 0 01.051-.401l-.068-.03zm.294.179a.487.487 0 00-.04-.241.145.145 0 00-.151-.08.252.252 0 00-.113.051.408.408 0 00-.043.038h-.001v.001l.054.052.054.052v-.001a.188.188 0 01.026-.021.111.111 0 01.042-.023h-.002c-.003-.002-.002-.003.003.004.01.018.023.065.02.165l.15.003zm.497.436c-.186-.014-.308-.038-.385-.096-.07-.052-.116-.144-.112-.34l-.15-.003c-.004.22.048.37.172.463.116.087.28.112.463.126l.012-.15zm.62-.695a1.494 1.494 0 01-.22.442c-.119.16-.257.265-.4.253l-.012.15c.226.018.408-.146.533-.314a1.64 1.64 0 00.244-.492l-.144-.04zm-.22.138l.052.055a.05.05 0 00.003-.004 1.46 1.46 0 01.205-.16c.015-.008.02-.007.015-.007-.003 0-.014 0-.025-.007a.053.053 0 01-.024-.027c-.004-.012.001-.013-.005.012l.144.039a.173.173 0 00.003-.101.097.097 0 00-.1-.066.193.193 0 00-.077.024.571.571 0 00-.066.04 1.534 1.534 0 00-.172.144l-.003.003h-.001l.051.055zm-.474-.185a.54.54 0 00.241.261c.092.045.205.054.285-.021l-.103-.11c-.016.016-.054.027-.116-.003a.391.391 0 01-.17-.19l-.137.063zm.286-.751c-.086.092-.186.21-.25.335-.065.126-.102.274-.036.416l.136-.063c-.037-.081-.022-.177.033-.284a1.43 1.43 0 01.227-.302l-.11-.102zm.417.018a7.6 7.6 0 00.046-.06.037.037 0 00-.004-.003.276.276 0 00-.039-.024.394.394 0 00-.105-.038.325.325 0 00-.315.107l.11.102c.064-.069.127-.072.175-.062a.245.245 0 01.086.037l.046-.06zm.35.213l.065-.039-.001-.001a.216.216 0 00-.007-.01.546.546 0 00-.09-.098.63.63 0 00-.304-.14l-.026.149a.48.48 0 01.285.159.253.253 0 01.014.019l.064-.04zm-.01-.421l-.073.019v.001l.002.004a2.45 2.45 0 01.048.233c.01.058.013.104.01.127-.001.005-.002.005 0 .003 0-.002.005-.013.018-.021.035-.022.061.003.05-.005l-.09.12c.02.015.07.044.12.012a.102.102 0 00.04-.047.162.162 0 00.01-.042.656.656 0 00-.01-.17 2.568 2.568 0 00-.051-.247l-.001-.004a.065.065 0 010-.002l-.073.019zm-.19-.908l-.075.012v.002l.002.006a7.338 7.338 0 00.016.104c.011.068.027.162.046.263.036.197.085.432.131.549l.14-.056c-.04-.1-.086-.319-.124-.52a13.172 13.172 0 01-.061-.363v-.006l-.001-.001-.074.01zM5.64 3.49c.013.092.03.186.052.267l.145-.041a1.892 1.892 0 01-.048-.246l-.149.02zm.039.145l.075.006v-.004a.598.598 0 01.026-.12l-.13-.074a.389.389 0 00-.038.12.854.854 0 00-.007.06v.006l.074.006zm-.019.99a.503.503 0 00.132-.281c.02-.106.02-.223.015-.329a2.63 2.63 0 00-.054-.394v-.002l-.074.016-.073.017a.134.134 0 00.001.007 1.487 1.487 0 01.02.103c.011.069.024.162.03.262.005.1.004.203-.012.293a.359.359 0 01-.088.2l.103.108zm-.282.187a.25.25 0 00.139-.059c.04-.03.087-.075.143-.128l-.103-.109a1.83 1.83 0 01-.13.118c-.033.024-.048.028-.056.028l.007.15zm-.32-.184c.067.056.122.102.168.132.046.03.096.055.152.052l-.007-.15c-.008 0-.024-.002-.062-.027a2.1 2.1 0 01-.155-.122l-.096.115zm-.002-.001l.1-.112-.1.112zm.001 0l.098-.113-.098.114zm0 .001l.097-.115-.096.115zm.003.002l.092-.119-.092.119zm-.003-.002l.098-.114-.098.114zm-.158.209c0-.067.001-.127.006-.178a.263.263 0 01.024-.1c.004-.006.005-.006.003-.005-.002.002-.002 0 .005.001a.32.32 0 01.121.073l.096-.115a.435.435 0 00-.193-.106.156.156 0 00-.095.013.16.16 0 00-.066.062.397.397 0 00-.044.162 2.009 2.009 0 00-.007.193h.15zm0 1.074V4.837h-.15V5.91h.15zm-.274.237c.04 0 .112.004.17-.027.071-.038.104-.11.104-.21h-.15a.146.146 0 01-.01.062.03.03 0 01-.014.015c-.017.01-.045.01-.097.01l-.003.15zm-.07.003c-.003.002-.003 0 .012-.002a.453.453 0 01.058-.001l.003-.15c-.023 0-.052-.001-.079.002a.17.17 0 00-.091.036l.097.115zm-.014-.546L4.467 5.6v.014a24.272 24.272 0 01-.034.472l.149.014a12.019 12.019 0 00.034-.477V5.61h.001l-.075-.005zm-.188-.74l-.071.025v.001l.002.005a5.86 5.86 0 01.028.087c.018.058.043.135.066.218.024.082.048.168.064.243a.725.725 0 01.024.156l.15.01a.823.823 0 00-.027-.2 4.543 4.543 0 00-.066-.25 9.212 9.212 0 00-.09-.292l-.006-.019-.002-.005v-.001l-.072.023zm-.376-.516a22.83 22.83 0 00-.066.036v.001a.816.816 0 01.01.016 3.29 3.29 0 00.116.191c.073.111.172.249.268.33l.097-.114a1.518 1.518 0 01-.24-.298 3.584 3.584 0 01-.118-.195l-.001-.003-.066.036zm-.147-.13l.061.043.001-.001a.053.053 0 01.005-.005c.006-.006.004-.001-.007 0-.02 0-.025-.013-.02-.003a.32.32 0 01.033.108l.148-.025a.45.45 0 00-.054-.164c-.026-.04-.066-.07-.116-.066a.142.142 0 00-.086.04.205.205 0 00-.026.029v.001h-.001l.062.043zm-.402.553a.305.305 0 00.25 0 .337.337 0 00.15-.161.96.96 0 00.077-.392h-.15a.8.8 0 01-.063.326.19.19 0 01-.08.092c-.026.013-.067.019-.13-.005l-.054.14zm-.11-1.315l-.075-.011v.003a3.305 3.305 0 00-.023.178 4.556 4.556 0 00-.026.406c-.003.15.004.309.034.44a.618.618 0 00.067.179c.03.052.073.097.133.12l.054-.14a.121.121 0 01-.059-.057.472.472 0 01-.049-.135 1.805 1.805 0 01-.03-.405 4.406 4.406 0 01.047-.563v-.003l-.074-.012zm.212.296c-.006-.153-.044-.246-.09-.302a.21.21 0 00-.098-.065.128.128 0 00-.016-.003 3.273 3.273 0 00-.016.149h-.003a.03.03 0 01-.002-.001h.001a.06.06 0 01.02.017c.018.022.05.078.055.21l.15-.005zm.088.501a11.383 11.383 0 01.061-.043v-.002a.382.382 0 01-.02-.03.943.943 0 01-.13-.426l-.15.006a1.061 1.061 0 00.178.538l.061-.043zm.108-.457l-.075-.003a.089.089 0 010 .007 4.381 4.381 0 01-.024.294.718.718 0 01-.028.146c-.002.006-.001.002.004-.003a.063.063 0 01.084-.005l.007.007-.006-.013-.14.054a.21.21 0 00.023.045.097.097 0 00.06.042.088.088 0 00.082-.028.137.137 0 00.025-.04.813.813 0 00.038-.187 4.019 4.019 0 00.024-.305v-.007l-.074-.004zm.335-.514l-.044-.06a.062.062 0 00-.005.003.815.815 0 00-.052.042c-.033.029-.078.07-.123.12-.086.098-.186.245-.186.41h.15c0-.108.068-.219.149-.31a1.127 1.127 0 01.155-.144l-.044-.061zm.181.324l.075.001v-.006a.926.926 0 00-.002-.064.921.921 0 00-.02-.148.32.32 0 00-.074-.152.15.15 0 00-.09-.044.178.178 0 00-.106.023l.071.132c.014-.008.019-.006.017-.006l.002.001c.01.01.023.037.033.08a.772.772 0 01.02.179v.003h-.001l.075.001zm-.007.493l.068.03.001-.001a.16.16 0 00.005-.012.747.747 0 00.037-.147.863.863 0 00-.032-.385l-.143.045a.713.713 0 01-.002.433.223.223 0 01-.002.006l.068.03zm.19.136l-.043-.062a.121.121 0 01-.02.012.098.098 0 01-.037.01h-.003c-.004-.006-.015-.03-.012-.093l-.15-.007a.304.304 0 00.037.183.149.149 0 00.129.068.244.244 0 00.129-.041.286.286 0 00.01-.007l.002-.001-.042-.062zm-.106-.807l-.072.022v.002l.003.007a4.048 4.048 0 01.033.114c.02.075.047.173.069.272.021.1.038.195.04.264a.231.231 0 01-.003.068c-.003.01.002-.015.032-.017l.007.15c.065-.003.094-.056.105-.09a.366.366 0 00.01-.117 1.828 1.828 0 00-.045-.29 5.288 5.288 0 00-.105-.398l-.002-.007v-.002l-.072.022zm-.054-.534l-.072-.02v.002a.325.325 0 00-.01.05.998.998 0 00.067.531l.138-.058a.848.848 0 01-.05-.485v-.001l-.073-.02zm.2-.191L4.45 2.63h-.001l-.003.001a.295.295 0 00-.034.01.43.43 0 00-.08.037.27.27 0 00-.14.21l.149.013c.003-.042.03-.071.068-.094a.28.28 0 01.073-.03l-.016-.073zm.13.583h.075V3.28a2.333 2.333 0 00-.002-.085 2.842 2.842 0 00-.015-.203 1.131 1.131 0 00-.042-.215.32.32 0 00-.043-.089.136.136 0 00-.096-.059l-.014.15c-.014-.002-.017-.01-.011-.002a.178.178 0 01.021.047.99.99 0 01.036.185 2.688 2.688 0 01.016.273v.005h.075zm.231.686a.204.204 0 01-.044-.067.925.925 0 01-.054-.156 1.85 1.85 0 01-.058-.463h-.15c0 .186.025.362.063.502.018.07.04.132.064.182a.334.334 0 00.088.121l.091-.119zm-.187-.165a.33.33 0 01.044.068.718.718 0 01.054.134l.002.011c0-.001 0-.01.007-.02a.066.066 0 01.043-.031.058.058 0 01.034.002c.004.002.005.003.003.001l-.091.12a.14.14 0 00.03.018.1.1 0 00.055.006c.058-.012.067-.068.068-.082a.192.192 0 00-.005-.056.866.866 0 00-.067-.173.466.466 0 00-.068-.102l-.109.104zm-.038-.347c-.007.063-.015.128-.015.183.001.053.009.118.053.164l.109-.104c-.002-.002-.011-.015-.012-.061 0-.044.006-.098.014-.164l-.149-.018zm0 0l.149.017-.15-.016zm.017-.22c0 .073-.008.147-.017.22l.149.018c.008-.072.018-.155.018-.238h-.15zm.393-.061a1.857 1.857 0 00-.107-.08.364.364 0 00-.11-.055.144.144 0 00-.071 0 .121.121 0 00-.067.044.252.252 0 00-.038.152h.15c0-.05.009-.063.008-.061a.029.029 0 01-.015.01h-.003a.23.23 0 01.062.034c.03.02.062.046.098.074l.093-.118zm.002.002l-.002-.002-.093.118.003.002.092-.118zm.124.45c.005-.075.01-.159-.003-.235a.33.33 0 00-.12-.215l-.093.118a.18.18 0 01.065.122.97.97 0 01.002.202l.15.008zm0 0l-.15-.009.15.01zm-.004.124c0-.04.002-.081.004-.124l-.15-.008a2.781 2.781 0 00-.004.132h.15zm.236.404c-.156-.12-.236-.237-.236-.404h-.15c0 .232.119.387.294.522l.092-.118zm.008-.129c.002.033.003.065.002.095s-.004.052-.008.063c-.004.012-.001-.007.022-.01.013-.002.008.006-.024-.02l-.092.12c.038.029.085.056.136.049.061-.009.089-.058.1-.09a.375.375 0 00.016-.108c0-.035 0-.073-.002-.105l-.15.006zm-.001-.065l.001.065.15-.006-.001-.059h-.15zm-.144-.35c.038.072.075.142.102.205a.416.416 0 01.042.145h.15a.55.55 0 00-.054-.205c-.03-.07-.07-.144-.107-.215l-.133.07zm-.065-.126c.02.042.043.084.065.126l.133-.07a5.602 5.602 0 01-.063-.122l-.135.066zm.039-.376c-.033.049-.07.102-.081.164a.33.33 0 00.042.212l.135-.066c-.032-.065-.034-.097-.03-.118a.336.336 0 01.059-.109l-.125-.083zm0 0l.124.084-.124-.085zm0-.001l.124.086-.123-.086zm0 0l.124.084-.124-.083zm.052-.081l-.052.082.125.083c.016-.025.036-.054.056-.088l-.129-.077zm.49.179a.588.588 0 00-.194-.242.225.225 0 00-.153-.04.199.199 0 00-.143.103l.13.077c.016-.029.029-.031.033-.032.008-.001.025.001.05.018a.44.44 0 01.14.177l.136-.061zm.011.026l-.012-.027-.136.062.011.026.137-.061zm-.08-.158l-.076.003v.001a.6.6 0 01.001.014 4.13 4.13 0 00.012.177l.15-.013a4.936 4.936 0 01-.012-.172v-.013l-.076.003zm.324-.411l-.046-.06-.001.001-.003.003-.013.01a2.18 2.18 0 00-.169.15.934.934 0 00-.123.148.334.334 0 00-.04.083.164.164 0 000 .1l.141-.048c.002.004 0 .002.003-.01a.189.189 0 01.022-.044.79.79 0 01.104-.123 1.91 1.91 0 01.167-.148l.003-.002-.045-.06zm.271.695l.075-.004V3.35a1.902 1.902 0 00-.01-.11 2.552 2.552 0 00-.041-.26.956.956 0 00-.09-.263c-.041-.07-.113-.147-.221-.122l.033.146c.006-.001.025-.005.057.051.03.052.055.132.074.22a2.407 2.407 0 01.048.348v.007l.075-.004zm-.191.162l-.027.07a.266.266 0 01.015.005.328.328 0 00.147.018.159.159 0 00.128-.083c.027-.054.022-.12 0-.194l-.144.044c.019.06.01.08.01.082 0-.001 0-.001 0 0a.035.035 0 01-.012.002.182.182 0 01-.059-.005.306.306 0 01-.03-.009H6.11l-.027.07zm.144 1.084l.072-.018V4.59a.184.184 0 01-.003-.011 7.12 7.12 0 01-.037-.158 10.252 10.252 0 01-.08-.373 3.38 3.38 0 01-.055-.364.466.466 0 010-.103c.002-.01.004-.008 0-.002a.054.054 0 01-.048.02l.013-.15a.097.097 0 00-.087.042.156.156 0 00-.025.064.598.598 0 00-.003.14c.008.105.03.245.057.382a10.442 10.442 0 00.12.538l.002.01v.002h.001l.073-.018zm.202.177a7.758 7.758 0 01-.055-.051l-.004.004a.156.156 0 01-.03.022.041.041 0 01-.007.002h-.002s.004 0 .006.002c.002.001 0 0-.005-.008a.365.365 0 01-.03-.152l-.15.008c.005.098.021.17.05.22a.166.166 0 00.06.062c.026.015.053.02.078.018a.203.203 0 00.105-.042.307.307 0 00.038-.033l.001-.001-.055-.051zm.15.305l.076-.003v-.005a.762.762 0 00-.004-.055.945.945 0 00-.021-.128.359.359 0 00-.06-.137.153.153 0 00-.07-.051.142.142 0 00-.098.004l.055.14c.004-.002 0 0-.005-.002-.004-.001-.003-.003.001.002a.22.22 0 01.031.079.797.797 0 01.02.155v.002l.076-.001zm.274-.345l-.07-.026a.058.058 0 00-.003.005 1.197 1.197 0 01-.026.066 1.663 1.663 0 01-.068.145.406.406 0 01-.073.104c-.01.008-.006.002.008.002.018 0 .025.013.021.007l-.125.083c.02.03.053.059.1.06a.141.141 0 00.094-.038.535.535 0 00.106-.146 1.815 1.815 0 00.104-.23l.002-.004v-.002l-.07-.026zm.322.229l.068-.033-.001-.001-.002-.004a1.017 1.017 0 00-.033-.06 1.009 1.009 0 00-.088-.13.344.344 0 00-.138-.111.154.154 0 00-.103-.002.178.178 0 00-.087.07l.123.085c.01-.013.014-.014.013-.013l.003.001a.209.209 0 01.073.064.86.86 0 01.103.163l.001.003.068-.032zm.288-.234l-.066-.036-.002.003a.862.862 0 01-.028.048 1.2 1.2 0 01-.071.102.269.269 0 01-.07.067c-.008.004-.007.001 0 .002.009.001.012.006.01.003l-.121.09c.02.028.05.05.088.055a.149.149 0 00.09-.017.404.404 0 00.12-.106 1.164 1.164 0 00.113-.171c0-.002.002-.003.002-.003v-.001l-.065-.036zm.117.198c.01-.035.018-.07.025-.1a.366.366 0 00.01-.092.125.125 0 00-.015-.054.095.095 0 00-.063-.047.118.118 0 00-.065.006.253.253 0 00-.05.025l.081.127a.111.111 0 01.02-.011c.003-.001-.004.002-.017 0a.055.055 0 01-.037-.027c-.005-.008-.004-.014-.004-.01a.24.24 0 01-.007.052 2.177 2.177 0 01-.023.093l.145.038zm-.042.227c0-.06.02-.142.042-.227L7.436 4.9c-.02.079-.047.181-.047.265h.15zm-.28.368c.05-.023.094-.043.129-.062a.32.32 0 00.092-.07c.053-.063.059-.141.059-.236h-.15c0 .097-.01.122-.024.138a.178.178 0 01-.05.037 1.907 1.907 0 01-.118.056l.063.137zm-.007.003l.008-.003-.063-.137-.008.004.063.136zm-.308-.132l-.07.028.001.002a.163.163 0 00.005.011.234.234 0 00.082.09c.067.044.164.059.29.001l-.063-.136c-.086.04-.127.021-.145.01a.095.095 0 01-.03-.034l-.001-.002a.004.004 0 010 .001l-.07.029zm-.405.148l.038.065h.001l.003-.002a2.75 2.75 0 01.173-.092.839.839 0 01.125-.05.136.136 0 01.032-.006c.007 0-.01.003-.025-.015L7 5.356a.114.114 0 00-.089-.038.276.276 0 00-.073.012.98.98 0 00-.149.058 2.443 2.443 0 00-.185.098l-.003.002.037.065zm-.216-.06l-.06.045.001.001a.112.112 0 00.006.008.263.263 0 00.074.06c.052.03.13.05.221.016l-.052-.14a.106.106 0 01-.095-.007.14.14 0 01-.035-.029l-.06.046zm.02.633c0-.2 0-.373.006-.489a.561.561 0 01.013-.11c0-.003 0-.001-.002.003a.059.059 0 01-.028.022.065.065 0 01-.055-.003.051.051 0 01-.013-.01l.119-.092a.109.109 0 00-.034-.03.085.085 0 00-.072-.004.092.092 0 00-.044.037.14.14 0 00-.014.032.662.662 0 00-.02.147c-.007.12-.006.3-.005.498h.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 .001h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm0 0h-.15.15zm.001.208v-.208h-.15v.208h.15zM4.856 7.627a2.218 2.218 0 001.006-.488c.275-.232.482-.526.482-.804h-.15c0 .21-.163.465-.43.69a2.068 2.068 0 01-.934.454l.026.148zM3.73 6.809a.97.97 0 00.296.592c.187.177.463.289.83.226l-.026-.148c-.319.055-.548-.042-.7-.187a.821.821 0 01-.25-.496l-.15.013zm.679-.635a.47.47 0 00.009.057.077.077 0 00.033.04.076.076 0 00.096-.015.073.073 0 00.015-.026 1.005 1.005 0 00.02-.13l-.15-.014a.914.914 0 01-.011.095l.001-.003s.003-.01.012-.02a.073.073 0 01.094-.015.073.073 0 01.03.036l.002.005a.328.328 0 01-.001-.02l-.15.01zm.05-.138c-.042.035-.053.086-.05.138l.15-.01v-.018.001a.016.016 0 01-.003.004l-.097-.115zm-.202-1.002l.018-.072h-.001l-.002-.001a.134.134 0 00-.014-.002.508.508 0 00-.16.01.927.927 0 00-.402.223l.099.112a.78.78 0 01.336-.189.359.359 0 01.11-.007H4.24l.017-.074zm.207.04a.396.396 0 00-.134-.097.236.236 0 00-.069-.017h-.003v.149h-.002a.126.126 0 01-.002 0c.003.001.01.002.018.006a.25.25 0 01.082.062l.11-.102zm-.44.458c.106-.031.237-.096.332-.166a.45.45 0 00.117-.119.166.166 0 00.026-.081.128.128 0 00-.035-.091l-.11.102a.023.023 0 01-.005-.015c0-.003.001-.001-.004.008a.31.31 0 01-.079.075.99.99 0 01-.285.143l.042.144zm-.437.193c.158-.08.312-.156.436-.193l-.042-.144a3 3 0 00-.46.203l.066.134zm.002 0l-.07-.134.07.133zm-.218.105a5.27 5.27 0 00.216-.105L3.52 5.59a6.766 6.766 0 01-.211.103l.062.136zm.325-.638a4.12 4.12 0 00-.402.4.927.927 0 00-.06.078.226.226 0 00-.035.074.093.093 0 00.011.068c.019.031.05.04.07.041a.137.137 0 00.048-.006.324.324 0 00.043-.017l-.062-.136a.18.18 0 01-.023.01h.005a.06.06 0 01.047.03c.012.02.009.039.008.04 0 .004 0-.002.013-.021a.78.78 0 01.05-.065c.087-.103.237-.253.386-.384l-.1-.112zm-.49 1.94c-.02-.133.032-.313.1-.47a2.368 2.368 0 01.132-.264l.002-.004-.063-.04-.064-.039-.001.002a.45.45 0 00-.013.021 2.265 2.265 0 00-.132.265c-.067.16-.137.374-.11.551l.149-.023zm.294.28a.208.208 0 01-.165-.032c-.053-.037-.107-.11-.13-.249l-.147.023c.026.17.097.284.192.35a.36.36 0 00.285.053L3.5 7.411zm.214-.27l-.073-.014v.002a.765.765 0 01-.044.144.453.453 0 01-.052.099c-.02.027-.036.036-.045.038l.035.146a.236.236 0 00.13-.095.6.6 0 00.071-.133 1.092 1.092 0 00.05-.167l.002-.003v-.001l-.074-.015zm-.14-.047c.013-.015.014-.008.006-.01 0 0 .006.002.02.017a.257.257 0 01.046.07l.068-.03.069-.03a.165.165 0 00-.006-.011.489.489 0 00-.067-.102.19.19 0 00-.106-.061c-.054-.01-.104.014-.142.057l.111.1zm-.268-.188a.236.236 0 00.016.15.14.14 0 00.102.073.215.215 0 00.11-.011.215.215 0 00.011-.004h.001a8.332 8.332 0 00-.057-.14l-.003.002a.12.12 0 01-.012.003.068.068 0 01-.024.002c-.002 0-.002 0 0 0a.013.013 0 01.003.004s-.006-.013 0-.055l-.147-.024zm.07-.553l-.074.007v.004a1.626 1.626 0 01.005.055c.002.037.006.088.008.145.005.117.005.251-.01.342l.149.024a2.07 2.07 0 00.011-.372 4.58 4.58 0 00-.013-.207v-.004l-.075.006zm1.949-1.067l-.005-.005a.027.027 0 010 .015c-.002.008-.004.005.01-.005a.224.224 0 01.064-.032 12.973 12.973 0 01-.044-.143h-.002a.146.146 0 00-.01.004.465.465 0 00-.096.05.166.166 0 00-.067.09c-.014.054.01.101.048.136l.102-.11zm.123.055c0 .006 0 0 .005-.003.002-.002-.001.002-.016.001a.19.19 0 01-.112-.053l-.102.11c.06.056.14.091.21.093a.172.172 0 00.11-.032.142.142 0 00.055-.116h-.15zm-.076-.153l-.024.07.004.002a.26.26 0 01.054.028c.032.022.042.04.042.053h.15c0-.09-.066-.148-.108-.177a.426.426 0 00-.093-.047h-.001l-.024.07zm4.163-.204a.097.097 0 01-.078-.027.196.196 0 01-.044-.085.48.48 0 01-.017-.146v-.002L9.32 4.72l-.075-.004a.054.054 0 000 .006.462.462 0 000 .057.629.629 0 00.022.135c.015.05.039.106.083.15.046.046.11.074.19.071l-.006-.15zm.285-.207a.064.064 0 01-.049-.02.052.052 0 01-.013-.024l-.001.011a.332.332 0 01-.036.097c-.042.08-.107.14-.186.143l.005.15c.159-.005.261-.124.314-.222a.48.48 0 00.05-.144.184.184 0 000-.068.098.098 0 00-.022-.045.086.086 0 00-.067-.028l.005.15zm-.042.005c0-.006.001-.005-.001-.002l-.003.004a.056.056 0 01.015-.004.228.228 0 01.031-.003l-.005-.15a.26.26 0 00-.111.025.14.14 0 00-.076.135l.15-.005zm-.215.06c0 .015.002.031.008.047a.096.096 0 00.039.05.088.088 0 00.072.01.107.107 0 00.042-.025.194.194 0 00.054-.142l-.15.005a.051.051 0 01-.004.02c-.003.007-.005.01-.003.008 0-.001.006-.007.017-.01a.062.062 0 01.051.007.05.05 0 01.023.027c.002.004.001.004 0-.001l-.15.005zm.014-.057a.03.03 0 01-.016-.005c-.007-.005-.008-.01-.007-.007a.465.465 0 01.009.07l.15-.005a.362.362 0 00-.02-.123.122.122 0 00-.12-.08l.004.15zm.042-.01V4.76l.001-.004a.041.041 0 01-.011.016.052.052 0 01-.032.013l-.005-.15a.1.1 0 00-.064.026.11.11 0 00-.03.045c-.007.023-.009.05-.01.059l.15.01zm-.143.07c.004.003.023.023.053.025a.078.078 0 00.08-.046.095.095 0 00.008-.032l.002-.018-.15-.01v.01l.003-.013a.072.072 0 01.1-.03.049.049 0 01.009.006l-.105.107zm-.037-.077c.002.007.004.019.009.03a.12.12 0 00.028.046l.105-.107c.006.006.008.012.008.01l-.002-.003-.002-.01-.146.034zm-.012-.01h.016-.002a.022.022 0 01-.004-.004c-.003-.003-.003-.005-.002-.002l.001.006a.32.32 0 01.003.01l.146-.034c-.003-.013-.01-.05-.037-.08-.032-.036-.077-.048-.126-.046l.005.15zm-.106-.039a2.343 2.343 0 01.075-.001.058.058 0 01-.001.014.06.06 0 01-.005.015.045.045 0 01-.014.017c-.005.003.004-.005.051-.006l-.005-.15a.246.246 0 00-.13.032.106.106 0 00-.037.041.09.09 0 00-.01.037v.002a.03.03 0 00.001.002l.075-.003zm2.552-.838l-.075-.004v.005a.408.408 0 000 .057.626.626 0 00.022.136c.015.049.04.105.083.15.046.045.11.074.19.07l-.006-.15a.097.097 0 01-.078-.027.197.197 0 01-.044-.085.48.48 0 01-.017-.146v-.002l-.075-.004zm.1-.112a.246.246 0 00-.13.033.106.106 0 00-.036.041.093.093 0 00-.009.032v.008l.075-.002.075-.003v.008a.068.068 0 01-.006.022.046.046 0 01-.014.018c-.005.003.004-.005.051-.007l-.005-.15zm.164.127c-.003-.013-.01-.051-.037-.081-.032-.036-.077-.048-.126-.046l.005.15.016.001-.002-.001a.022.022 0 01-.004-.004l-.002-.002a.07.07 0 01.002.006l.002.01.146-.033zm-.004.003l.008.01-.002-.004c0-.002 0-.005-.002-.009l-.146.033c.002.007.004.02.009.031a.12.12 0 00.028.046l.105-.107zm-.112.027v.01l.003-.013a.071.071 0 01.1-.03.05.05 0 01.01.006l-.106.107a.089.089 0 00.053.026.078.078 0 00.08-.047.104.104 0 00.008-.032l.002-.017-.15-.01zm.103-.129a.099.099 0 00-.064.026.11.11 0 00-.029.045.203.203 0 00-.01.058l.15.01v-.015l.001-.003a.04.04 0 01-.011.016.052.052 0 01-.032.013l-.005-.15zm.14.202a.362.362 0 00-.02-.122.122.122 0 00-.12-.08l.005.15c-.001 0-.008 0-.016-.006-.007-.005-.008-.01-.007-.006a.493.493 0 01.009.07l.15-.006zm-.084-.05a.05.05 0 01-.003.02l-.004.007s.007-.006.018-.01a.062.062 0 01.05.008c.017.01.022.023.023.027.002.003.001.004 0-.002l-.149.005c0 .015.002.031.008.046a.096.096 0 00.039.05.087.087 0 00.072.01.107.107 0 00.042-.025.194.194 0 00.054-.142l-.15.006zm.187-.16a.26.26 0 00-.111.024.14.14 0 00-.076.136l.15-.006v-.001l-.004.004a.057.057 0 01.015-.005.232.232 0 01.032-.003l-.006-.15zm-.275.507c.159-.006.261-.125.314-.222a.48.48 0 00.051-.145.185.185 0 000-.068.098.098 0 00-.023-.045.086.086 0 00-.067-.028l.006.15a.065.065 0 01-.05-.02.053.053 0 01-.013-.024l-.001.012a.334.334 0 01-.036.097c-.042.08-.107.14-.186.143l.005.15zM6.595 5.75a.523.523 0 00-.065.07.162.162 0 00-.036.088.13.13 0 00.038.096c.02.022.049.04.078.056l.071-.132a.165.165 0 01-.04-.027c-.002-.003.003.003.003.014 0 .007-.003.006.006-.006a.384.384 0 01.046-.048l-.1-.11zm.44.197a1.042 1.042 0 00-.188-.197.242.242 0 00-.12-.048.173.173 0 00-.132.048l.101.111c.01-.01.016-.01.02-.009.008 0 .022.005.044.02a.915.915 0 01.159.169l.117-.094zm-.013.401c.026-.043.064-.102.077-.17a.273.273 0 00-.063-.231l-.117.094c.036.045.039.079.033.108a.389.389 0 01-.058.12l.128.08zm-.029.048l.029-.048-.128-.079-.032.055.131.072zm-.285-.078c-.023.034-.04.084-.011.132a.126.126 0 00.103.057.211.211 0 00.193-.11l-.131-.073a.062.062 0 01-.053.034c-.008 0 .006-.003.017.015.013.023 0 .039.006.03l-.124-.085zM6.61 6.06c.03.016.067.064.09.13.01.03.015.06.016.085 0 .026-.005.039-.008.043l.124.084a.224.224 0 00.034-.129.434.434 0 00-.024-.131.383.383 0 00-.161-.214l-.07.132zm8.007-.45a.164.164 0 01-.04-.026c-.002-.003.004.003.003.014 0 .007-.003.006.006-.006a.382.382 0 01.047-.048l-.101-.111a.53.53 0 00-.066.069.163.163 0 00-.035.088.13.13 0 00.037.097.33.33 0 00.079.056l.07-.133zm.027.495a.54.54 0 00.076-.24.381.381 0 00-.012-.138.19.19 0 00-.09-.117l-.071.133c.004.002.011.008.017.027.006.02.009.05.006.083a.396.396 0 01-.05.168l.124.084zm.037-.001a.02.02 0 01-.005.006l-.003.001a.03.03 0 01-.018-.004.037.037 0 01-.009-.006l-.002-.003v.007l-.124-.084a.14.14 0 00-.015.134.172.172 0 00.08.085.179.179 0 00.118.018.16.16 0 00.11-.082l-.132-.072zm.01-.02l-.01.02.131.072.01-.018-.13-.073zm.07-.346c.038.15-.014.246-.07.347l.131.073c.058-.104.138-.247.085-.457l-.146.037zm-.128-.194a.039.039 0 01.012-.008h.002c.002 0 .01.001.026.017a.428.428 0 01.088.185l.146-.037a.569.569 0 00-.128-.254.196.196 0 00-.115-.06.167.167 0 00-.132.046l.1.11zm1.272-2.329a.522.522 0 00-.065.069.162.162 0 00-.036.088.13.13 0 00.038.097c.02.022.049.04.079.056l.07-.133a.166.166 0 01-.04-.026c-.002-.003.003.003.003.014 0 .007-.003.006.006-.006a.39.39 0 01.046-.048l-.1-.11zm.375.268a.569.569 0 00-.127-.254.196.196 0 00-.116-.06.167.167 0 00-.132.046l.101.111a.04.04 0 01.012-.008h.003c.001 0 .01.001.026.017a.428.428 0 01.088.186l.145-.038zm-.084.457c.057-.103.138-.246.084-.457l-.145.038c.038.149-.014.245-.07.346l.131.073zm-.01.018l.01-.018-.131-.073-.01.019.13.072zm-.292-.155a.14.14 0 00-.015.134.172.172 0 00.08.085.179.179 0 00.117.018.16.16 0 00.11-.082l-.131-.072a.02.02 0 01-.006.006l-.002.001a.03.03 0 01-.018-.004.034.034 0 01-.009-.006l-.002-.003v.007l-.124-.084zm.027-.278c.004.002.01.008.017.028.006.02.008.048.006.082a.398.398 0 01-.05.168l.124.084a.54.54 0 00.075-.24.384.384 0 00-.012-.138.19.19 0 00-.09-.117l-.07.133zM11.89 2.88a.166.166 0 01-.04-.026c-.003-.003.003.003.002.014 0 .007-.003.006.006-.006a.39.39 0 01.047-.048l-.101-.11a.522.522 0 00-.066.068.161.161 0 00-.035.088.13.13 0 00.038.097c.02.022.049.04.078.056l.07-.133zm.2.618a.172.172 0 00.027-.079.376.376 0 00-.001-.08A.902.902 0 0012 3a.316.316 0 00-.11-.119l-.071.133a.19.19 0 01.052.064.758.758 0 01.096.279.181.181 0 010 .047c0 .012-.003.014 0 .01l.123.085zm.03-.078a.062.062 0 01-.052.033c-.008 0 .005-.002.016.016.014.023 0 .039.007.029l-.125-.084c-.023.034-.04.084-.01.132a.126.126 0 00.103.057.211.211 0 00.193-.111l-.132-.072zm.007-.427c.042.053.057.131.05.218a.56.56 0 01-.057.209l.132.072a.709.709 0 00.075-.27.458.458 0 00-.082-.322l-.118.093zm-.222-.179c.01-.01.016-.01.02-.009.007 0 .021.005.044.02a.916.916 0 01.158.168l.117-.093a1.042 1.042 0 00-.188-.197.242.242 0 00-.12-.048.173.173 0 00-.132.048l.1.111zM10.352 4.98c-.013-.01.005-.002.006.023.001.026-.016.036-.007.029a.26.26 0 01.044-.026c.023-.012.052-.025.085-.04l-.062-.137-.09.043a.4.4 0 00-.073.044c-.017.015-.05.046-.047.095.002.048.037.077.059.092l.085-.123zm.118.061c0-.029.024-.038.02-.037a.221.221 0 01-.139-.024l-.084.123c.05.035.125.052.184.054.03 0 .065-.002.095-.014s.074-.042.074-.102h-.15zM10.473 5l-.003.041h.15l.002-.029-.15-.012zm.007-.034a.107.107 0 01.021-.008h-.002a.037.037 0 01-.025-.02v.003l.001.014c0 .013 0 .028-.002.045l.15.012.002-.06a.193.193 0 00-.014-.075.114.114 0 00-.086-.067.184.184 0 00-.107.02l.062.136zM9.414 6.067a26.072 26.072 0 01-.017-.074.386.386 0 01-.017.004 1.085 1.085 0 01-.22.02v.15a1.41 1.41 0 00.269-.027.009.009 0 01.001 0l-.016-.073zm.347-.05a2.543 2.543 0 01-.335-.025h-.002l-.01.075-.01.074h.003l.006.001a3.155 3.155 0 00.348.025v-.15zm-.024.364a.479.479 0 00.127-.085.23.23 0 00.068-.109.128.128 0 00-.04-.13.196.196 0 00-.131-.04v.15c.03 0 .036.007.032.004a.024.024 0 01-.007-.011v-.007a.093.093 0 01-.026.035.33.33 0 01-.087.057l.064.136zm-.158.182c.012-.055.017-.077.032-.098.015-.02.046-.046.126-.084l-.064-.136a.458.458 0 00-.183.131c-.037.052-.047.107-.058.156l.147.031zm-.006.03l.006-.03-.147-.03-.006.029.147.03zm-.28.225c.04.012.08.018.118.011a.157.157 0 00.096-.058.265.265 0 00.043-.086 1.07 1.07 0 00.023-.092l-.147-.032a.935.935 0 01-.02.079.122.122 0 01-.016.038l-.006.004a.104.104 0 01-.047-.007l-.044.143zm-.369-.564c.033.082.082.206.14.314a.938.938 0 00.098.15.293.293 0 00.13.1l.045-.143a.177.177 0 01-.06-.052.793.793 0 01-.08-.125c-.054-.1-.1-.216-.134-.3l-.139.056zm-.01-.025l.01.025.14-.056-.01-.025-.14.056zm.17-.216a.554.554 0 00-.07-.003.142.142 0 00-.082.026.112.112 0 00-.043.098c.002.03.012.062.025.095l.14-.056a.305.305 0 01-.015-.047l-.002.01a.044.044 0 01-.015.02l-.01.005h.028c.009 0 .02 0 .031.002l.011-.15zm.076.004c-.027 0-.052-.002-.077-.004l-.011.15c.025.002.055.004.088.004v-.15zM7.442 2.724c-.003-.002.005 0 .013.027a.409.409 0 01-.025.22c-.005.006.008-.016.04-.016v.15c.045 0 .071-.033.08-.045a.235.235 0 00.03-.056.556.556 0 00.02-.29c-.012-.047-.04-.105-.103-.13l-.055.14zm-.32.058c-.001-.002 0-.001-.001 0 0 0 .001-.003.009-.01a.242.242 0 01.09-.04.561.561 0 01.13-.019c.044 0 .076.004.092.01l.055-.139a.404.404 0 00-.15-.02.711.711 0 00-.167.023.386.386 0 00-.148.071c-.043.037-.076.095-.054.167l.143-.043zm.069.116a.462.462 0 01-.07-.116l-.143.043c.018.06.06.117.09.16l.123-.087zm.047.393a.24.24 0 00.056-.113.233.233 0 00-.008-.111c-.02-.064-.063-.124-.095-.169l-.123.087c.037.051.064.09.075.126a.082.082 0 01.003.04.091.091 0 01-.022.043l.114.097zm-.616.55c.021-.014.063-.046.11-.085.05-.04.11-.092.174-.147.125-.109.262-.236.332-.318l-.114-.097a3.632 3.632 0 01-.317.302 6.871 6.871 0 01-.263.216l.078.128zm-.027.016l.026-.016-.077-.13-.026.017.077.129zm-.167.002c-.011 0-.008-.001 0 .002a.06.06 0 01.024.02.06.06 0 01.012.042c0 .02-.011.031-.008.027a1.188 1.188 0 01.139-.093l-.077-.13c-.039.024-.105.063-.146.097a.238.238 0 00-.032.03.105.105 0 00-.025.061.086.086 0 00.016.055.09.09 0 00.037.03.15.15 0 00.06.01v-.15zm.144.007c-.05-.003-.101-.007-.144-.007v.15c.037 0 .082.004.134.007l.01-.15zm.004 0l-.019.15.019-.15zm.26-.003a.368.368 0 01-.106.01c-.049 0-.103-.003-.158-.007l-.01.15c.053.004.113.008.167.008.053 0 .11-.003.155-.018l-.048-.143zm.177-.182c-.043.05-.081.095-.115.13a.486.486 0 01-.057.05l-.005.002.048.143a.22.22 0 00.064-.038.63.63 0 00.057-.053c.038-.039.08-.088.122-.137l-.114-.097zm.257-.262c-.086.06-.18.17-.257.262l.114.097c.083-.097.163-.19.23-.237L7.27 3.42zm.149-.246c-.013-.011-.014-.023-.013-.019v.016a.342.342 0 01-.136.249l.087.122a.491.491 0 00.2-.366.23.23 0 00-.005-.052.112.112 0 00-.03-.06l-.103.11zm-.037-.015a.836.836 0 01.04.018l-.003-.003.102-.11a.166.166 0 00-.041-.026l-.04-.017-.058.138zm-.183-.249a.134.134 0 00-.003.11.179.179 0 00.057.071c.04.031.095.054.129.068l.058-.138a.463.463 0 01-.095-.049c-.01-.008-.011-.011-.01-.01.002.005 0 .01 0 .01L7.2 2.91zm.227.032a.15.15 0 00-.013-.06.12.12 0 00-.051-.058.096.096 0 00-.056-.01.104.104 0 00-.051.02.194.194 0 00-.056.076l.136.063c.01-.021.015-.023.01-.019a.047.047 0 01-.023.009.054.054 0 01-.031-.007.042.042 0 01-.015-.012V2.94h.15zm.044.014c-.001 0-.006 0-.013-.004a.094.094 0 01-.034-.025v.001a.028.028 0 01.003.014h-.15c0 .03.013.055.024.071a.213.213 0 00.045.046c.03.023.076.047.125.047v-.15zm-.187 1.287l.123-.045-.05-.14-.124.044.05.141zm-.194-.136a.19.19 0 00.095.122.177.177 0 00.072.019h.001v-.15h.001a.089.089 0 01.002 0 .026.026 0 01-.007-.003c-.004-.002-.013-.007-.02-.03l-.144.042zm.022-.169c-.007.02-.017.045-.023.072a.198.198 0 00.001.097l.144-.041a.056.056 0 01.002-.024.437.437 0 01.017-.053l-.141-.051zm.05.005c.006 0-.005.002-.018-.009a.053.053 0 01-.016-.02.042.042 0 01-.003-.015c0-.004 0-.002-.002.007a.544.544 0 01-.011.032l.14.05.015-.041a.175.175 0 00.008-.053.1.1 0 00-.037-.076.119.119 0 00-.076-.025v.15zm-.13.209A.696.696 0 017.1 4a.209.209 0 01.04-.048c.013-.01.02-.01.021-.01v-.15a.182.182 0 00-.114.043.355.355 0 00-.073.084.843.843 0 00-.085.183l.142.048zm.17.18a.651.651 0 01-.128-.103.204.204 0 01-.038-.055c-.006-.014-.004-.02-.004-.022l-.142-.048a.18.18 0 00.008.129c.015.036.04.069.065.097.05.055.115.102.16.13l.079-.127zm.182-.133a.85.85 0 01-.128.116c-.04.027-.051.02-.054.018l-.08.127c.08.05.162.016.217-.02a.98.98 0 00.153-.137l-.108-.104zm-.002-.071a11.3 11.3 0 01-.015.073.073.073 0 01.012.004.078.078 0 01.02.01c.004.002-.005-.003-.006-.018-.001-.014.007-.014-.009.002l.108.104c.03-.03.053-.07.05-.116a.127.127 0 00-.053-.093.225.225 0 00-.091-.04h-.001l-.015.074zm5.705 2.145a1.27 1.27 0 00-.116.43c-.012.145.004.3.081.404l.12-.09c-.043-.058-.063-.167-.051-.302.011-.132.05-.271.101-.377l-.135-.065zm.22.135a3.013 3.013 0 000-.167.186.186 0 00-.009-.046c-.004-.01-.023-.055-.075-.058a.086.086 0 00-.05.013.114.114 0 00-.024.02.466.466 0 00-.062.103l.135.065a.71.71 0 01.034-.062l.003-.003V6.27v.002a.064.064 0 01-.043.014.068.068 0 01-.047-.021c-.007-.009-.01-.016-.011-.018v.007l.002.035-.003.113.15.005zm-.003.17c0-.06.002-.118.003-.17l-.15-.005a5.303 5.303 0 00-.003.175h.15zm.136.346a.6.6 0 01-.1-.138.48.48 0 01-.036-.208h-.15c0 .116.017.2.05.272.033.07.078.121.122.172l.114-.098zm.001.003l-.117.093.117-.093zm.075.09c-.027-.036-.054-.066-.076-.093l-.114.098c.023.027.047.054.07.086l.12-.091zm.098-.054a.131.131 0 01-.04.09c-.008.005-.01.004-.012.004-.004-.001-.02-.007-.046-.04l-.12.091a.238.238 0 00.134.095.162.162 0 00.136-.032.28.28 0 00.098-.208h-.15zm.406-.786a2.034 2.034 0 00-.266.413c-.039.076-.073.15-.098.213-.012.032-.022.06-.03.086a.282.282 0 00-.012.074h.15l.001-.009a.861.861 0 01.031-.096c.023-.057.055-.127.092-.2.075-.148.168-.3.242-.38l-.11-.101zm.427.05c0-.076-.066-.144-.145-.164-.088-.021-.189.013-.282.114l.11.102c.07-.075.117-.075.136-.07.029.007.03.026.03.019h.15zm.285.279a.46.46 0 01-.202-.145.56.56 0 01-.08-.125c-.004-.01-.003-.012-.003-.008h-.15c0 .021.005.042.011.058a.714.714 0 00.108.172c.067.078.164.16.275.192l.041-.144zm.227-.348l-.074-.01v.004l-.003.014a1.273 1.273 0 01-.049.197.402.402 0 01-.063.123c-.02.024-.03.022-.038.02l-.041.144c.084.024.15-.017.193-.067a.543.543 0 00.09-.17 1.31 1.31 0 00.056-.222l.003-.016v-.006l-.074-.01zm-.075-1.426v1.426h.15V4.731h-.15zm-.16-.501c.041.032.076.06.105.122.03.066.055.177.055.379h.15c0-.212-.026-.347-.069-.441-.044-.097-.104-.143-.15-.179l-.092.119zm-.068-.058c.023.024.048.043.067.058l.092-.119a.384.384 0 01-.048-.041l-.11.102zm-.143-.14c.064.06.116.11.143.14l.11-.102c-.031-.035-.088-.088-.15-.147l-.103.109zm0 0l.103-.109-.104.109zm-.378-.395c.039.057.102.126.17.194.067.068.143.14.208.201l.103-.109a8.465 8.465 0 01-.205-.198 1.438 1.438 0 01-.152-.172l-.124.084zm-.093-.645c-.002.118-.004.241.006.35a.62.62 0 00.087.295l.124-.084a.487.487 0 01-.061-.224c-.01-.1-.008-.215-.006-.336l-.15-.001zm0 0h.15-.15zm0 0h.15-.15zm0 0h.15-.15zm0-.133v.132l.15.002V2.86h-.15zm.618.242a1.42 1.42 0 00-.291-.324.59.59 0 00-.09-.06.229.229 0 00-.098-.029.125.125 0 00-.108.054.203.203 0 00-.03.117h.15c0-.028.005-.034.003-.031a.027.027 0 01-.01.008l-.008.002c.002 0 .012.002.032.012.019.01.04.025.066.045.101.08.214.213.255.282l.129-.076zm.03.299a.464.464 0 00.02-.132.333.333 0 00-.05-.167l-.13.076c.024.04.03.069.03.093a.347.347 0 01-.015.092l.145.038zm-.02.121c0-.043.01-.08.02-.121l-.145-.038c-.011.042-.025.094-.025.16h.15zm-.033 0a.06.06 0 01-.007.031c-.003.005-.001-.002.012-.004a.04.04 0 01.023.004c.007.003.01.007.01.008l-.002-.007a.137.137 0 01-.003-.032h-.15c0 .046.009.09.031.123.025.037.066.06.114.052a.135.135 0 00.092-.064c.02-.031.03-.07.03-.11h-.15zm-.005-.09l.005.09h.15c0-.024-.003-.06-.006-.1l-.15.01zm0-.001l.15-.007-.15.007zm.142-.64a.214.214 0 00-.114.127.617.617 0 00-.034.171c-.01.12 0 .253.006.344l.15-.01a2.251 2.251 0 01-.007-.322.475.475 0 01.025-.128c.013-.032.025-.04.03-.043l-.056-.14zm.32.245a1.582 1.582 0 00-.049-.121.35.35 0 00-.056-.093.156.156 0 00-.102-.052.24.24 0 00-.113.02l.056.14c.027-.01.039-.011.042-.01h.001s.002 0 .005.004a.216.216 0 01.031.053l.046.113.14-.054zm.078.19c-.032-.072-.056-.135-.077-.19l-.14.054a5 5 0 00.079.196l.138-.06zm.04.476c.015-.06.031-.123.03-.2a.73.73 0 00-.07-.276l-.138.06a.583.583 0 01.057.22c.002.054-.01.1-.024.16l.145.036zm-.034.242a.91.91 0 01.034-.242l-.145-.036c-.018.071-.04.157-.04.278h.15zm.264.517a1.806 1.806 0 01-.177-.24.556.556 0 01-.087-.277h-.15c0 .132.048.252.108.354.06.102.134.19.191.26l.115-.097zm.1.13c-.023-.039-.062-.084-.1-.13l-.115.096c.041.05.07.085.085.11l.13-.076zm-.328-.91a.907.907 0 01.085.228 4.268 4.268 0 01.12.649.642.642 0 01.003.042l-.001.015.001-.005.005-.011a.07.07 0 01.06-.034c.03 0 .047.017.049.02.005.004.006.007.005.006l-.129.076c.004.006.01.015.018.023a.08.08 0 00.126-.015.098.098 0 00.012-.03.404.404 0 00.001-.098 4.391 4.391 0 00-.125-.678 1.006 1.006 0 00-.107-.273l-.123.086zm.13-.932c-.102.128-.17.306-.196.474-.025.166-.014.343.066.459l.123-.086c-.047-.068-.064-.197-.04-.35a.888.888 0 01.165-.403l-.117-.094zm.447.283a2.927 2.927 0 00-.07-.162.654.654 0 00-.082-.137c-.03-.037-.078-.076-.14-.075-.064 0-.114.04-.154.09l.117.095c.03-.038.042-.035.038-.035-.004 0 .004-.003.024.021.02.023.04.059.062.106.022.046.044.099.066.154l.14-.057zm.084.189a2.114 2.114 0 01-.084-.189l-.139.057c.028.069.058.142.09.203l.133-.071zm-.087.511a.722.722 0 00.119-.204.38.38 0 00-.032-.307l-.133.07a.23.23 0 01.022.19.567.567 0 01-.095.16l.12.091zm-.039.054a.873.873 0 01.04-.054l-.12-.09a.674.674 0 00-.046.063l.126.081zm.034.137a.708.708 0 01-.035-.105c-.004-.023 0-.03.001-.032l-.126-.08a.187.187 0 00-.022.14c.008.04.025.086.042.13l.14-.053zm.1.492c0-.226-.06-.384-.1-.492l-.14.053c.04.105.09.241.09.439h.15zm.375 1.06c-.225-.307-.375-.686-.375-1.06h-.15c0 .413.165.822.404 1.149l.121-.089zm.331 1.035c-.048-.347-.098-.716-.331-1.035l-.121.089c.207.283.254.614.303.967l.15-.02zm.008.058l-.008-.058-.149.021.009.057.148-.02zm-.149-1.04c.028.235.04.589.04.838a2.2 2.2 0 01-.01.258c-.002.013-.002.008.003-.001a.073.073 0 01.124-.003c.004.008.003.01 0-.004a.643.643 0 01-.008-.048l-.148.02a.822.822 0 00.01.06.167.167 0 00.016.048.078.078 0 00.137-.002.148.148 0 00.015-.047c.008-.051.01-.156.011-.28a8.38 8.38 0 00-.04-.856l-.15.017zm-.163-2.615c-.02.117-.022.31-.015.536.008.228.026.495.047.763.044.536.103 1.077.131 1.316l.15-.017a40.304 40.304 0 01-.131-1.31c-.022-.268-.04-.532-.047-.757a2.992 2.992 0 01.013-.506l-.148-.025zm.322.015a2.332 2.332 0 00-.056-.129.463.463 0 00-.029-.052.166.166 0 00-.043-.045.095.095 0 00-.094-.01.121.121 0 00-.056.057.603.603 0 00-.044.164l.148.025a.941.941 0 01.03-.12c.001-.003.001-.002 0 0a.044.044 0 01-.016.01.057.057 0 01-.032.005.05.05 0 01-.02-.008c-.005-.003-.004-.004.002.005l.02.035c.015.032.032.073.052.12l.138-.057zm-.001-.003l-.136.064.136-.064zm.142.288a1.544 1.544 0 01-.14-.285l-.14.058c.041.097.093.223.158.314l.122-.087zm.036.05l-.036-.05-.122.087.036.05.122-.088zm.066.416c.039-.06.077-.122.06-.2a.316.316 0 00-.045-.099 2.462 2.462 0 00-.082-.118l-.121.088c.034.048.059.082.076.11a.18.18 0 01.026.051c.001.01.003.02-.04.088l.126.08zm-.2.088c.014.003.05.014.091.002a.194.194 0 00.109-.09l-.126-.08c-.018.027-.026.027-.023.026l-.013-.004-.038.146zm.052-.021v-.02l-.002.008a.055.055 0 01-.015.017.057.057 0 01-.039.013h-.002l.006.002.038-.146c-.005 0-.018-.004-.032-.005a.093.093 0 00-.066.02.103.103 0 00-.034.058.24.24 0 00-.004.052h.15zm.051.463a49.383 49.383 0 01-.037-.316 2.357 2.357 0 01-.014-.147h-.15c0 .025.006.085.015.164l.037.317.15-.018zm.198 2.194c0-.543-.125-1.586-.198-2.194l-.149.018c.073.612.197 1.644.197 2.176h.15zm-.805 1.26c.184-.068.386-.182.543-.382.157-.201.262-.483.262-.878h-.15c0 .367-.097.615-.23.786a1.06 1.06 0 01-.477.333l.052.14zm-.642-.2c0 .104.076.193.189.233.113.04.267.036.453-.033l-.052-.14c-.165.06-.28.056-.35.032-.07-.025-.09-.068-.09-.093h-.15zm.008.082c.017-.014.03-.025.043-.034a.221.221 0 01.014-.01l.005-.003-.004.002a.06.06 0 01-.05-.014.052.052 0 01-.015-.025v.001h.15c0-.019-.003-.06-.034-.088a.096.096 0 00-.102-.015.245.245 0 00-.053.032 1.202 1.202 0 00-.049.038l.095.116zm-.236.123c.052 0 .1-.025.135-.047.037-.023.073-.053.101-.076l-.095-.116a.9.9 0 01-.086.065c-.03.019-.047.024-.055.024v.15zm-.065-.41a.651.651 0 00-.089.234.168.168 0 00.029.12.152.152 0 00.125.056v-.15c-.017 0-.012-.005-.006.003.004.006 0 .005.001-.015a.517.517 0 01.07-.175l-.13-.074zm.046-.011c.003.002.002.001 0 0a.055.055 0 01-.019-.045c0-.004.001-.002-.003.009a.532.532 0 01-.024.046l.13.074a.666.666 0 00.031-.06.182.182 0 00.016-.053.097.097 0 00-.016-.066c-.012-.018-.029-.028-.03-.029l-.085.124zm-.056-.112a.14.14 0 00.019.075c.014.022.032.033.037.037l.085-.124c-.006-.004 0 0 .005.007.005.008.004.013.004.005h-.15zm.202-.247a.229.229 0 00-.109.024.16.16 0 00-.07.072c-.025.051-.023.114-.023.151h.15c0-.022 0-.04.002-.055a.092.092 0 01.006-.03.011.011 0 01.006-.006.085.085 0 01.038-.006v-.15zm.178.29a.351.351 0 00.064-.128.134.134 0 00-.004-.069.117.117 0 00-.04-.057.2.2 0 00-.101-.033c-.031-.003-.066-.003-.097-.003v.15a.866.866 0 01.105.006c.005.002.005.002.002 0a.033.033 0 01-.01-.015c-.003-.007-.002-.01-.002-.008a.222.222 0 01-.039.071l.122.087zm-.071-.005a.368.368 0 01-.014-.002c-.003 0 0 0 .004.002a.06.06 0 01.028.023.063.063 0 01.01.042c0 .008-.003.011-.002.01l.006-.012.04-.057-.123-.087a1.329 1.329 0 00-.044.065.163.163 0 00-.026.062.087.087 0 00.055.093c.018.007.04.009.048.01l.018-.149zm.172.058a.39.39 0 00-.172-.058l-.018.149a.24.24 0 01.111.036l.08-.127zm.071.044l.006.001-.004-.002a1.386 1.386 0 01-.073-.043l-.079.127a1.448 1.448 0 00.107.06.11.11 0 00.02.005l.023-.148zm.093.04a.27.27 0 00-.093-.04l-.023.148-.003-.001c-.002 0-.002 0 0 0a.576.576 0 01.044.024l.075-.13zm.574-.407a3.703 3.703 0 01-.38.321.65.65 0 01-.142.079c-.04.014-.052.008-.052.008l-.075.13c.058.033.124.022.177.003a.792.792 0 00.177-.097c.123-.084.263-.209.397-.334l-.102-.11zm.015-.139c.027.012.046.02.06.029.015.009.013.012.011.007-.002-.008.003-.007-.007.012a.406.406 0 01-.08.091l.103.11a.547.547 0 00.108-.13.162.162 0 00.018-.131.167.167 0 00-.073-.086c-.026-.017-.057-.03-.08-.04l-.06.138zm-.133-.083c.02.024.045.04.067.052.022.013.047.023.066.031l.06-.138a.623.623 0 01-.054-.024.093.093 0 01-.025-.018l-.114.097zm-.176-.271l.098.159a.944.944 0 00.078.112l.114-.097a.967.967 0 01-.066-.095l-.095-.157-.129.078zm-.001-.003l.132-.072-.132.072zm0 .001l.13-.074-.13.074zm0 0l.13-.074-.13.074zM15.92 6.1s.003.001.008.007a1.319 1.319 0 01.07.098c.039.06.084.135.128.209l.129-.078c-.044-.073-.09-.15-.131-.212-.02-.032-.04-.06-.058-.084a.314.314 0 00-.055-.06l-.09.12zm.116.105a1.429 1.429 0 01-.017-.143c0-.003 0 .004-.005.013a.067.067 0 01-.056.035c-.023.001-.038-.01-.038-.01l.091-.12a.092.092 0 00-.06-.02.083.083 0 00-.07.045.113.113 0 00-.01.041.224.224 0 00-.002.032c.002.038.01.094.018.149l.149-.022zm-.008.414a.214.214 0 00.031-.096.614.614 0 00.002-.103c-.004-.07-.016-.15-.025-.215l-.149.022c.01.068.02.14.024.201a.468.468 0 010 .078c-.003.022-.007.029-.007.029l.124.084zm-.385.284a.24.24 0 00.107-.033.898.898 0 00.277-.25l-.123-.085a.754.754 0 01-.224.203.19.19 0 01-.028.012l-.01.003v.15zm0-1.484l-.075-.004v.004l-.001.012-.003.045a34.585 34.585 0 00-.026.645 9.548 9.548 0 00-.003.489c.002.066.005.125.01.167a.31.31 0 00.014.06.114.114 0 00.018.033c.01.013.031.033.066.033v-.15c.029 0 .046.017.051.024.006.006.007.011.006.01a1.528 1.528 0 01-.016-.18 9.379 9.379 0 01.004-.482 27.316 27.316 0 01.026-.641l.003-.045v-.015l-.074-.005zm-.295-.4a.196.196 0 01-.004-.013v-.004l-.002.01a.064.064 0 01-.018.033.065.065 0 01-.068.016c-.005-.002-.005-.003.001.002.024.019.067.067.118.13a5.801 5.801 0 01.202.264l.003.004.001.002.062-.044.06-.044v-.001l-.005-.006a2.011 2.011 0 00-.062-.085 5.917 5.917 0 00-.145-.186 1.15 1.15 0 00-.14-.151.157.157 0 00-.04-.024c-.012-.005-.056-.02-.092.016a.086.086 0 00-.024.045.108.108 0 00-.001.03.237.237 0 00.01.05l.144-.044zm-.282 1.992a.537.537 0 00.085-.163 2.24 2.24 0 00.066-.235 7.662 7.662 0 00.15-1.206 3.17 3.17 0 000-.23.684.684 0 00-.02-.158l-.143.044a.55.55 0 01.014.12c.002.059.001.134-.002.219a7.45 7.45 0 01-.145 1.178c-.02.085-.04.158-.062.217a.405.405 0 01-.057.116l.114.098zm-.83-.24c.059.097.2.221.35.292.148.07.346.103.48-.052l-.114-.098c-.064.075-.17.076-.302.014a.744.744 0 01-.286-.235l-.129.079zm-.133.146a.365.365 0 01.09-.171c.014-.012.017-.008.013-.009-.002 0 .01 0 .03.034l.128-.079c-.031-.05-.072-.09-.127-.102a.165.165 0 00-.14.04.505.505 0 00-.139.248l.145.039zm-.423.738a.845.845 0 00.298-.373c.064-.14.102-.28.125-.365l-.145-.04a2.126 2.126 0 01-.116.343.7.7 0 01-.242.308l.08.127zm-.535-.385c.053.1.119.228.197.315.04.043.089.083.148.1a.228.228 0 00.19-.03l-.08-.127c-.03.018-.05.019-.068.013a.188.188 0 01-.079-.057 1.418 1.418 0 01-.175-.283l-.133.069zm-.093-.164c.026.035.056.092.093.164l.133-.07c-.035-.067-.07-.137-.106-.184l-.12.09zm.988-1.676a.7.7 0 01.09-.08 4.472 4.472 0 01.306-.222l.047-.032.013-.009.003-.002h.001l-.042-.063-.041-.062h-.002l-.003.003-.013.009a8.22 8.22 0 00-.361.26.79.79 0 00-.116.105l.118.093zm-.025.085a.062.062 0 01-.02-.014v.003a.07.07 0 01.01-.023.397.397 0 01.035-.051l-.118-.093a.313.313 0 00-.076.153.142.142 0 00.024.095c.02.028.047.048.076.064l.07-.134zm.514-.264a1.04 1.04 0 01-.295.197.883.883 0 01-.157.059.258.258 0 01-.051.008c-.014 0-.015-.002-.01 0l-.07.134a.171.171 0 00.084.016.404.404 0 00.083-.013.974.974 0 00.184-.068 1.18 1.18 0 00.342-.231l-.11-.102zm.18-.298c.005.01.01.036-.025.098a1.146 1.146 0 01-.155.2l.11.102c.07-.076.135-.155.177-.23.039-.07.07-.161.023-.244l-.13.074zm-.25.069l.044.06.003-.002a.504.504 0 01.036-.025.992.992 0 01.09-.054.325.325 0 01.083-.033c.024-.004.005.006-.007-.015l.13-.074c-.037-.066-.108-.066-.149-.059a.464.464 0 00-.127.048 1.144 1.144 0 00-.136.085l-.009.006-.003.002v.001l.044.06zm-.587-.901l-.023-.071h-.002l-.003.001a.296.296 0 00-.043.019.33.33 0 00-.089.065.201.201 0 00-.058.137.27.27 0 00.074.174l.114-.097c-.034-.04-.038-.065-.038-.076 0-.01.005-.022.017-.035a.183.183 0 01.068-.044.206.206 0 01.005-.002h.002l-.024-.071zm.326.06a.615.615 0 00-.293-.133.343.343 0 00-.03-.002h-.003v.15a.098.098 0 01.014.001.465.465 0 01.217.1l.095-.115zm-.063-.02a1.064 1.064 0 01.007.072c0 .004 0 .002.002-.003a.057.057 0 01.023-.029.059.059 0 01.042-.008c.007.001.01.003.006.001a.145.145 0 01-.017-.012l-.095.115a.18.18 0 00.078.043.091.091 0 00.067-.012.093.093 0 00.037-.05.187.187 0 00.007-.07l-.008-.067-.149.02zm.013-.282a.357.357 0 00-.025.149c.001.047.007.095.012.132l.15-.02a1.03 1.03 0 01-.012-.115c0-.038.004-.066.012-.086l-.137-.06zm.49.22a.542.542 0 00-.202-.272.25.25 0 00-.15-.05.159.159 0 00-.138.102l.137.06c.007-.014.01-.011.01-.011.008 0 .028.003.057.023.058.04.119.116.142.192l.144-.044zm-.136.24a.458.458 0 00.057-.01.131.131 0 00.07-.044.136.136 0 00.027-.09.365.365 0 00-.018-.096l-.144.044c.01.03.012.047.012.056 0 .008-.001.002.006-.007.007-.009.013-.01.008-.008a.26.26 0 01-.034.005l.016.15zm-.074.015a.254.254 0 01.074-.016l-.016-.149a.379.379 0 00-.118.028l.06.137zm.019.242a1.3 1.3 0 01-.023-.192c0-.025.002-.04.006-.049.002-.006.002-.003-.002 0l-.06-.138a.146.146 0 00-.079.085.29.29 0 00-.015.101c0 .066.013.146.025.218l.148-.025zm.026.226c0-.07-.014-.153-.026-.226l-.148.025c.012.077.024.146.024.2h.15zm-.745-.376c.086.101.242.257.379.365a.77.77 0 00.193.12c.026.01.07.021.11.001.051-.024.063-.074.063-.11h-.15c0 .01-.003-.013.023-.025.016-.008.023 0 .004-.007a.647.647 0 01-.15-.097 2.929 2.929 0 01-.358-.344l-.114.097z"
          fill="#fff"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.709 9.91c-.509.061-3.077.05-3.844-.134-.172-.037-.074.747.037.928.112.18.985.36 1.29.402.26.035 1.267-.02 2.313-.08l.52-.028c.915-.05 2.253.037 2.953.083.226.014.386.025.443.025.214 0 .198.072.166.217a4.646 4.646 0 00-.009.04c-.037.171.156.54.24.575.085.035.716 0 1.06-.133.195-.075.218-.065.269-.042.038.018.093.042.25.042.236 0 .248-.338.256-.576.005-.13.009-.23.047-.23.043 0 .1.127.155.246.082.182.156.346.156.008 0-.558-.656-1.289-.871-1.23-.15.04-.398-.005-.567-.035a1.225 1.225 0 00-.158-.024c-.042 0-.03-.01-.001-.033.036-.029.099-.08.099-.155 0-.134-.128-.153-.234-.153a.16.16 0 00-.163.153c0 .066.08.134.08.134l-.234-.003c-.864-.012-3.813-.05-4.253.003zm4.338 1.181s.067-.039.224-.232c.174-.214.235-.146.3-.075.032.037.066.075.116.075.147 0 .342 0 .468.107.127.108-.166.255-.252.255-.042 0-.073-.026-.105-.053s-.064-.054-.109-.054c-.052 0-.096.038-.132.068-.024.021-.045.04-.061.04-.015 0-.047-.02-.089-.043-.076-.044-.184-.105-.273-.105a.194.194 0 00-.087.017z"
          fill="#fff"
        />
        <path
          d="M4.865 9.776l.011-.049h-.001l-.01.049zm3.844.134l.006.05-.006-.05zm-3.807.793l.043-.026-.043.027zm1.29.403l-.008.05.007-.05zm2.313-.08l-.003-.049.003.05zm.52-.028l-.003-.05.002.05zm2.953.083l.003-.05-.003.05zm.609.242l.048.011-.048-.01zm-.009.04l.049.01-.049-.01zm.24.575l.02-.046-.02.046zm1.06-.133l.017.047-.018-.047zm.269-.042l-.02.046.02-.046zm.506-.534l-.05-.002.05.002zm.202.016l-.046.02.046-.02zm-.715-1.222l.013.048-.013-.048zm-.567-.035l-.009.049.01-.05zm-.16-.057l-.03-.038.03.038zm-.217-.021v.05h.136l-.104-.088-.032.038zm-.234-.003l-.001.05v-.05zm.31.952l.038.031-.039-.031zm-.225.232l.043-.025-.043.025zm.523-.306l-.037.033.037-.034zm.585.181l.033-.038-.033.038zm-.357.202l.032-.038-.032.038zm-.24.014l.032.038-.033-.038zm-.15-.003l-.026.043.025-.043zM4.852 9.824c.39.094 1.23.143 2.03.161.8.018 1.573.006 1.832-.026l-.012-.099c-.25.03-1.016.043-1.818.025-.803-.018-1.631-.067-2.009-.158l-.023.097zm.092.853a.79.79 0 01-.07-.21 2.294 2.294 0 01-.048-.313c-.008-.105-.007-.2.005-.265a.16.16 0 01.02-.062l.004-.003h-.002l.021-.097a.097.097 0 00-.06.005.108.108 0 00-.043.036.252.252 0 00-.039.103 1.196 1.196 0 00-.006.291c.01.11.027.226.05.326.022.1.05.19.083.242l.085-.053zm1.253.38a6.484 6.484 0 01-.71-.149 2.953 2.953 0 01-.36-.118.847.847 0 01-.124-.061.188.188 0 01-.06-.052l-.084.053c.02.032.053.06.09.083a.94.94 0 00.138.07c.106.044.237.085.373.122.273.073.569.13.723.15l.014-.099zm2.304-.08c-.523.03-1.036.058-1.45.075-.417.017-.729.021-.854.004l-.014.1c.136.018.459.012.872-.005.415-.016.929-.045 1.452-.074l-.006-.1zm.52-.029l-.52.029.006.1.519-.029-.005-.1zm2.96.083c-.7-.046-2.04-.133-2.96-.083l.005.1c.912-.05 2.247.037 2.948.083l.006-.1zm.439.025c-.055 0-.212-.01-.44-.025l-.006.1c.225.014.387.025.446.025v-.1zm.214.278c.008-.035.016-.07.02-.1a.17.17 0 00-.014-.097.136.136 0 00-.084-.065.457.457 0 00-.136-.016v.1c.051 0 .085.004.105.01.02.007.024.014.026.017.003.005.005.016.003.04a.818.818 0 01-.017.09l.097.021zm-.008.04l.008-.04-.097-.021-.009.04.098.02zm.21.518l-.005-.004a.377.377 0 01-.05-.059.974.974 0 01-.145-.32.327.327 0 01-.01-.136l-.098-.02a.42.42 0 00.01.179 1.105 1.105 0 00.16.354.473.473 0 00.047.059c.015.015.033.03.053.04l.038-.093zm1.022-.133a2.566 2.566 0 01-.613.126 3.068 3.068 0 01-.368.013.31.31 0 01-.029-.004l-.009-.002h-.003l-.037.092a.257.257 0 00.07.013 2.868 2.868 0 00.386-.013 2.66 2.66 0 00.64-.132l-.037-.093zm.308-.041a.174.174 0 00-.106-.02.885.885 0 00-.202.06l.036.094a.814.814 0 01.177-.055.075.075 0 01.027.001.165.165 0 01.027.01l.041-.09zm.23.037a.747.747 0 01-.16-.013c-.032-.007-.052-.016-.07-.024l-.04.09c.02.01.046.022.09.032a.87.87 0 00.18.015v-.1zm.207-.528a1.58 1.58 0 01-.042.365.291.291 0 01-.063.122.135.135 0 01-.102.041v.1c.072 0 .13-.026.174-.071a.388.388 0 00.087-.163c.036-.122.041-.273.046-.39l-.1-.004zm.096-.279a.074.074 0 00-.067.045.22.22 0 00-.018.064c-.007.045-.01.106-.011.17l.1.004c.002-.067.004-.12.01-.159a.125.125 0 01.008-.033c.002-.004-.004.01-.022.01v-.1zm.2.277a2.002 2.002 0 00-.083-.173.392.392 0 00-.045-.065c-.013-.015-.038-.039-.072-.039v.1c-.012 0-.014-.007-.002.005a.3.3 0 01.032.048 2.2 2.2 0 01.08.165l.09-.041zm.061.028a.67.67 0 01-.011.153l-.002.007.002-.002a.028.028 0 01.006-.006.037.037 0 01.026-.005c.008 0 .011.004.012.004l-.003-.003a.422.422 0 01-.032-.053 2.486 2.486 0 01-.059-.123l-.09.04c.02.046.04.092.06.129l.029.05c.009.014.02.03.035.04a.074.074 0 00.032.014c.015.003.03 0 .044-.009a.094.094 0 00.036-.056.743.743 0 00.015-.18h-.1zm-.808-1.182c.012-.003.033-.002.067.011a.53.53 0 01.116.07c.088.065.187.165.28.285.189.242.345.554.345.816h.1c0-.295-.172-.629-.366-.877a1.68 1.68 0 00-.298-.304.63.63 0 00-.14-.083.209.209 0 00-.13-.015l.026.097zm-.589-.034c.084.015.19.034.294.045a.86.86 0 00.295-.011l-.026-.097a.77.77 0 01-.259.008c-.1-.01-.201-.028-.286-.044l-.018.099zm-.149-.023c.01 0 .029.002.056.006l.093.017.018-.099-.096-.016a.496.496 0 00-.07-.008v.1zm-.033-.121l-.02.016a.115.115 0 00-.01.011.062.062 0 00-.012.024.054.054 0 00.01.048c.01.012.023.016.029.018a.127.127 0 00.036.004v-.1h-.007a.047.047 0 01.029.054.038.038 0 01-.007.015c-.001.001-.001.001 0 0l.015-.013-.063-.078zm.08-.117a.106.106 0 01-.024.064.335.335 0 01-.056.053l.063.077a.392.392 0 00.071-.068.203.203 0 00.047-.126h-.1zm-.183-.103c.052 0 .1.005.135.021a.083.083 0 01.035.029.093.093 0 01.014.053h.1a.192.192 0 00-.03-.108.183.183 0 00-.076-.064.425.425 0 00-.178-.031v.1zm-.113.103a.11.11 0 01.113-.103v-.1a.21.21 0 00-.213.203h.1zm.03.134l.032-.038-.002-.002a.306.306 0 01-.031-.034c-.019-.023-.03-.045-.03-.06h-.1c0 .05.03.096.052.123a.37.37 0 00.042.045l.003.003h.001l.033-.037zm-.235.047l.235.003v-.1l-.234-.003-.001.1zm-4.246.002c.106-.012.37-.02.723-.024.351-.003.788-.003 1.238 0 .9.004 1.853.016 2.285.022l.001-.1a289.72 289.72 0 00-2.286-.023c-.45-.002-.887-.002-1.24.001a9.35 9.35 0 00-.733.025l.012.1zm4.517.868a1.84 1.84 0 01-.202.215.118.118 0 01-.008.006h-.001v.001h-.002s0 .002-.002.002l-.004.004a.151.151 0 00-.007.008.088.088 0 00-.002.053l.086-.05a.088.088 0 01-.002.054.075.075 0 01-.007.008l-.004.003-.002.002c-.001 0 0 0 0 0l.003-.002a1.923 1.923 0 00.232-.24l-.078-.064zm.375-.076a.419.419 0 00-.056-.055.144.144 0 00-.09-.031.192.192 0 00-.108.041.672.672 0 00-.12.121l.077.063a.575.575 0 01.101-.103c.027-.019.043-.022.052-.022.008 0 .016.002.028.011a.32.32 0 01.042.042l.074-.067zm.08.058c-.024 0-.043-.017-.08-.058l-.074.067c.03.033.078.09.154.09v-.1zm.5.12a.505.505 0 00-.25-.106c-.088-.014-.177-.014-.25-.014v.1c.074 0 .156 0 .234.013a.406.406 0 01.202.082l.065-.076zm-.284.342a.325.325 0 00.113-.028.596.596 0 00.122-.069.253.253 0 00.09-.105.119.119 0 00.004-.074.134.134 0 00-.044-.067l-.065.076c.01.009.012.015.013.017l-.002.012a.16.16 0 01-.055.06.496.496 0 01-.102.057.243.243 0 01-.074.021v.1zm-.137-.065c.029.024.074.065.137.065v-.1c-.02 0-.038-.012-.073-.041l-.064.076zm-.077-.042c.024 0 .042.013.077.042l.064-.076c-.029-.025-.075-.066-.14-.066v.1zm-.099.056a.42.42 0 01.053-.04.09.09 0 01.046-.016v-.1a.189.189 0 00-.098.03c-.026.016-.049.036-.066.05l.065.076zm-.094.051a.101.101 0 00.056-.02l.038-.03-.065-.076a.375.375 0 01-.03.023l-.006.004h.007v.1zm-.114-.049a1.275 1.275 0 00.082.043.092.092 0 00.032.006v-.1c.005 0 .007.002.003 0a.133.133 0 01-.015-.007l-.052-.028-.05.086zm-.248-.098a.32.32 0 01.121.032c.045.02.089.044.127.066l.05-.086a1.446 1.446 0 00-.137-.072.416.416 0 00-.161-.04v.1zm-.13-.008c.01.013.03.024.04.025h.012l.008-.003a.026.026 0 00.004-.001l.002-.001.003-.002a.172.172 0 01.06-.01v-.1a.273.273 0 00-.109.023l.002-.001.004-.002.007-.002h.014c.008 0 .03.012.04.024l-.087.05z"
          fill="#fff"
        />
      </g>
    </symbol>
    <symbol id="SB" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3D58DB"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 15h20V0L0 15z"
            fill="#579D20"
          />
          <path
            d="M-.489 15.466l-1.127-1.56L21.047-1.221l1.127 1.56L-.489 15.466z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.283 4.092l.853-.591.892.53-.313-.952.625-.682h-.846l-.358-1-.359 1-.847.035.626.647-.273 1.013zm3.537 0l.852-.591.892.53-.312-.952.624-.682H7.03l-.358-1-.359 1-.847.035.626.647-.272 1.013z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.155 5.91l.852-.592.893.531-.313-.952.624-.682h-.845l-.359-1.001-.358 1-.847.036.625.647-.272 1.012zm-1.02 1.34l-.852.592.273-1.013-.626-.647.847-.035.359-1 .358 1h.846l-.625.682.313.953-.892-.532zm3.537 0l-.852.592.272-1.013-.626-.647.847-.035.359-1 .358 1h.846l-.624.682.312.953-.892-.532z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SC" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 14.998L10.094-1.25H20.19L0 14.998z"
            fill="#FFD018"
          />
          <path
            d="M0 14.998l21.54-8.124V-3.19L0 14.998z"
            fill="#E31D1C"
          />
          <path
            d="M0 14.998l21.54-3.124V6.81L0 14.998z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 14.998h21.54V10.56L0 14.998z"
            fill="#5EAA22"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SD" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#F7FCFF" />
        <path d="M0 0v5h20V0H0z" fill="#E31D1C" />
        <path d="M0 10v5h20v-5H0z" fill="#272727" />
        <path d="M0 0l10 7.5L0 15V0z" fill="#5EAA22" />
      </g>
    </symbol>
    <symbol id="SE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3D58DB"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.25 0h2.5v6.25H20v2.5H8.75V15h-2.5V8.75H0v-2.5h6.25V0z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v7.5h20V0H0z" fill="#E31D1C" />
          <path
            d="M5.543 6.619s-1.766-.71-1.766-2.635c0-1.925 1.766-2.612 1.766-2.612-.859-.217-3.136-.023-3.136 2.612 0 2.635 2.243 3.131 3.136 2.635zm.452-.319l.507-.305.518.305-.127-.596.42-.471h-.57l-.241-.558-.242.558-.571.024.422.447-.116.596zm2.348-.34l-.506.306.115-.597-.422-.446.572-.024.241-.558.242.558h.57l-.42.47.126.597-.518-.306zM7.054 3.606l.507-.306.518.306-.127-.597.421-.47h-.57L7.56 1.98l-.242.557-.57.025.421.446-.116.597zm-1.198.908l-.507.306.116-.597-.422-.446.571-.025.242-.557.242.557h.57l-.42.471.126.597-.518-.306zm2.842.279l.507-.306.518.306-.127-.597.421-.471h-.57l-.242-.557-.242.557-.57.024.421.447-.116.597z"
            fill="#F1F9FF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <path
            d="M13.774 6.02h-.25v.25c0 .27-.001.535-.003.793-.003.618-.005 1.201.01 1.736.02.76.076 1.443.221 2.016.147.575.389 1.062.798 1.402.412.343.962.51 1.669.51.72 0 1.284-.21 1.71-.598.42-.383.683-.918.846-1.527.324-1.208.275-2.8.187-4.346l-.013-.236h-5.175z"
            fill="#B7E1FF"
            stroke="#F7FCFF"
            stroke-width=".5"
          />
          <mask
            id="e"
            maskUnits="userSpaceOnUse"
            x="13"
            y="5"
            width="7"
            height="8"
          >
            <path
              d="M13.774 6.02h-.25v.25c0 .27-.001.535-.003.793-.003.618-.005 1.201.01 1.736.02.76.076 1.443.221 2.016.147.575.389 1.062.798 1.402.412.343.962.51 1.669.51.72 0 1.284-.21 1.71-.598.42-.383.683-.918.846-1.527.324-1.208.275-2.8.187-4.346l-.013-.236h-5.175z"
              fill="#fff"
              stroke="#fff"
              stroke-width=".5"
            />
          </mask>
          <g mask="url(#e)">
            <path fill="#2E42A5" d="M15 11.25h3.75v1.25H15z" />
            <g filter="url(#SH_-_Saint_Helena__filter0_d)">
              <path fill="#FDFF00" d="M12.5 5H20v3.75h-7.5z" />
            </g>
            <path
              d="M15.737 6.798a.889.889 0 00-.032-.172l.295.917a1.247 1.247 0 00-.077-.069l-.012-.01-.049-.042c-.063-.056-.094-.099-.099-.18a16.785 16.785 0 01-.01-.182 5.389 5.389 0 00-.016-.262zm-.234 1.614s0 0 0 0l.056.044h0l-.056-.044z"
              fill="#F7FCFF"
              stroke="#272727"
              stroke-width=".625"
            />
            <path
              d="M15.516 8.778h.125v2.472h-.125V8.778z"
              fill="#FDFF00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.063 10.508h1.114s.01.321-.158.262c-.17-.06.017.06-.24 0-.258-.06-.485.187-.543.064-.057-.124-.281.034-.227-.146l.054-.18z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M15.083 10.477h1.083v.125h-1.083z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.217 10.04h.891s.009.258-.127.21c-.135-.047.014.048-.192 0-.206-.047-.387.15-.433.051-.046-.098-.226.028-.182-.116l.043-.144z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M15.233 10.017h.867v.125h-.867z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.054 9.528h.966s.01.257-.137.21c-.147-.048.015.047-.209 0-.223-.048-.42.15-.47.05-.05-.098-.243.029-.196-.116l.046-.144z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M15.072 9.504h.939v.125h-.939z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.133 9.098h.892s.009.321-.127.262c-.135-.06.014.06-.192 0-.206-.06-.387.186-.434.063-.046-.123-.225.035-.182-.145l.043-.18z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M15.15 9.067h.867v.125h-.867z"
            />
            <path
              d="M16.714 9.09h.125v2.472h-.125V9.09z"
              fill="#FDFF00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.313 10.61h1.114s.01.257-.158.21c-.17-.048.017.047-.24 0-.258-.048-.485.149-.543.05-.057-.098-.281.028-.227-.116l.054-.144z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M16.333 10.585h1.083v.125h-1.083z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.478 10.144h.875s.009.193-.124.157c-.133-.036.013.036-.189 0s-.38.112-.426.038c-.045-.074-.221.021-.179-.087l.043-.108z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M16.494 10.125h.851v.125h-.851z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.304 9.631h.955s.009.193-.136.157c-.145-.035.015.036-.206 0-.22-.035-.415.112-.464.039-.05-.074-.242.02-.195-.088l.046-.108z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M16.321 9.613h.929v.125h-.929z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.389 9.2h.875s.009.257-.124.21c-.133-.048.013.047-.19 0-.201-.048-.38.149-.425.05-.045-.098-.221.028-.179-.116l.043-.144z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M16.405 9.175h.851V9.3h-.851z"
            />
            <path
              d="M18.431 8.787h.125v3.286h-.125V8.787z"
              fill="#FDFF00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.92 10.783h1.419s.014.257-.202.21c-.215-.048.022.047-.306 0-.327-.048-.616.15-.69.05-.073-.098-.358.029-.289-.116l.069-.144z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M17.947 10.759h1.379v.125h-1.379z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.13 10.16h1.115s.01.193-.158.157c-.17-.036.017.036-.24 0-.258-.036-.485.112-.543.038-.057-.074-.281.021-.227-.087l.054-.108z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M18.151 10.144h1.083v.125h-1.083z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.017 9.334h1.114s.011.258-.158.21c-.17-.048.017.048-.24 0-.258-.048-.485.15-.542.05-.058-.098-.282.029-.228-.115l.054-.145z"
              fill="#F7FCFF"
            />
            <path
              fill="#212123"
              d="M18.038 9.31h1.083v.125h-1.083z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.116 11.054s.578.315 1.46.26c.882-.054.819.117 1.048-.126.229-.242.249-.188.534-.315.285-.127.326-.247.473-.247.148 0 1.714-.063 1.714-.063s-.143.129-.143.31.095.2 0 .364c-.096.165-.204.384-.342.448-.14.064-2.012.104-2.49.104-.477 0-1.457.053-1.57 0-.113-.053-.684-.735-.684-.735z"
              fill="#272727"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.823 9.804l.559-.514s.024 0 .128.257c.104.257.109.609.216.52.108-.087.274-.006.344-.263.07-.257.066-.59.155-.424.089.167.036-.076.178.306s.198-.165.276.382c.078.546.144.735.144.862s.71.506.438.766c-.272.261-.195.138-.438.302-.242.164-.491.069-.144.198s.298.362.298.534c0 .172-.022.25-.298.21-.276-.038-.612.1-.679.1-.067 0-.877-.165-.877-.505 0-.34-.3-2.731-.3-2.731z"
              fill="#CE6201"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="SH_-_Saint_Helena__filter0_d"
          x="12.5"
          y="5"
          width="7.5"
          height="3.75"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </symbol>
    <symbol id="SI" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#C51918"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.588 3.148s-1.316-.622-2.952-.622-2.952.622-2.952.622.147 2.496.378 3.819c.099.565.574 1.388 1.004 1.778.49.445 1.57.971 1.57.971.313-.215.897-.312 1.644-.97.748-.66.933-1.779.933-1.779l.375-3.82z"
            fill="#2E42A5"
          />
          <path
            d="M8.414 3.066l.548.274-.377 3.764c-.131.796-.46 1.425-.988 1.89-.286.251-.565.44-.864.596l-.87.45a1.15 1.15 0 00-.167.093l-.069.047-.073-.036C4.822 9.788 4.139 9.308 3.8 9c-.463-.42-.951-1.28-1.056-1.874-.155-.89-.295-2.116-.393-3.786l.492-.258c.098 1.658.215 2.98.368 3.854.09.517.54 1.31.951 1.682.304.275.793.58 1.465.912.04-.023.085-.046.136-.07.001-.002.459-.205.618-.288a3.98 3.98 0 00.805-.556c.467-.412.76-.967.877-1.673l.35-3.877z"
            fill="#C51918"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.464 6.89s.119.365.34.775c.323.085.521.08.584.01.181-.202.825-.289.946-.116.074.107.335.181.62.083l-.032.006c.05-.018.165-.064.237-.092l.058-.023a.937.937 0 01.267-.068c.1-.008.197.011.3.06.224.107.502.157.69.124.232-.402.397-.759.397-.759L6.773 5.837l-.436.473-.724-1.032-.607 1.032-.465-.473L3.464 6.89zm.634 1.244a3.42 3.42 0 01-.143-.21c.28.051.471.024.577-.094.05-.056.199-.11.368-.134a.978.978 0 01.212-.007.286.286 0 01.063.011c.005.002.004.002 0-.005l-.001-.001c.129.185.48.284.811.163l-.031.006c.09-.028.25-.091.309-.114l.02-.008a.77.77 0 01.214-.056.392.392 0 01.206.042c.199.095.43.151.635.153a7.41 7.41 0 01-.135.208c-.158.037-.404-.011-.602-.12a.47.47 0 00-.273-.062.751.751 0 00-.239.07 10.445 10.445 0 01-.257.115l.036-.008c-.248.096-.465.026-.527-.077-.11-.182-.69-.093-.852.116-.044.056-.175.066-.391.012zm.216.256l.037.037c.564.55 1.262.82 1.262.82s.831-.252 1.303-.781c.04-.045.08-.094.12-.146a1.262 1.262 0 01-.525-.154.284.284 0 00-.167-.04.586.586 0 00-.195.061 4 4 0 01-.281.117l.036-.007c-.292.122-.602.025-.723-.157a.202.202 0 00-.049-.01.723.723 0 00-.18.007c-.143.022-.268.075-.31.128-.07.09-.179.13-.328.125z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.467 3.679h-.44l.341-.32-.34-.337h.439l.185-.327.187.327h.438l-.323.317.287.34h-.402l-.187.346-.185-.346zm2.071 0h-.44l.341-.32-.34-.337h.439l.185-.327.187.327h.438l-.323.317.287.34H6.91l-.187.346-.185-.346zM5.375 4.73h-.44l.341-.32-.34-.337h.439l.185-.328.187.328h.438l-.323.317.287.34h-.402l-.187.345-.185-.345z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SJ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M6.25-.625h-.625v6.25h-6.25v3.75h6.25v6.25h3.75v-6.25h11.25v-3.75H9.375v-6.25H6.25z"
            fill="#2E42A5"
            stroke="#F7FCFF"
            stroke-width="1.25"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3D58DB"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 10v5h20v-5H0z"
            fill="#E31D1C"
          />
          <path
            d="M9.752 3.769l.311-.033-.03-.28h-6.36l-.02.292.313.021-.312-.021h0v.003l-.001.007-.002.029-.007.11a78.473 78.473 0 00-.089 1.68c-.04.962-.067 2.089.003 2.615.137 1.026.762 3.33 3.18 4.375l.125.054.126-.056c2.296-1.026 3.064-3.094 3.241-4.372.09-.644.044-1.772-.018-2.71a51.146 51.146 0 00-.134-1.607l-.011-.103-.003-.028v-.008h0v-.001l-.312.033z"
            fill="#E31D1C"
            stroke="#fff"
            stroke-width=".625"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="3"
            y="3"
            width="8"
            height="10"
          >
            <path
              d="M9.752 3.769l.311-.033-.03-.28h-6.36l-.02.292.313.021-.312-.021h0v.003l-.001.007-.002.029-.007.11a78.473 78.473 0 00-.089 1.68c-.04.962-.067 2.089.003 2.615.137 1.026.762 3.33 3.18 4.375l.125.054.126-.056c2.296-1.026 3.064-3.094 3.241-4.372.09-.644.044-1.772-.018-2.71a51.146 51.146 0 00-.134-1.607l-.011-.103-.003-.028v-.008h0v-.001l-.312.033z"
              fill="#fff"
              stroke="#fff"
              stroke-width=".625"
            />
          </mask>
          <g mask="url(#c)" fill-rule="evenodd" clip-rule="evenodd">
            <path
              d="M6.41 4.119s.13.196.188.497c.057.3.067.827.067.827l-1.224-.15v.928l1.252-.16-.02.882s-.375.038-.682 0a9.994 9.994 0 01-.912-.202v1.063s.614-.197.912-.242c.297-.045.681 0 .681 0v1.305h.508V7.562s.556-.048.887.004c.332.052.646.238.646.238V6.741s-.319.159-.619.198c-.3.04-.914.004-.914.004l.02-.881s.417-.043.65-.012c.233.032.525.171.525.171v-.928s-.285.155-.508.183c-.224.028-.694-.033-.694-.033s.009-.543.057-.808.184-.516.184-.516H6.411z"
              fill="#F7FCFF"
            />
            <path
              d="M4.31 10.153s.276-.59.722-.701c.447-.112.916.35.916.35s.286-.935.984-.935c.697 0 .942.936.942.936s.298-.351.726-.351.824.701.824.701-1.278 2.321-2.556 2.321c-1.279 0-2.557-2.32-2.557-2.32z"
              fill="#2E42A5"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="SL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#78D843" />
          <path d="M0 10v5h20v-5H0z" fill="#3D58DB" />
        </g>
      </g>
    </symbol>
    <symbol id="SM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 7.5V15h20V7.5H0z"
            fill="#56C6F5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.409 5.643a.35.35 0 00-.035-.134c-.16-.3-.109-.674-.109-.674s-.191.439-.304.851c-.118-.192-.16-.384-.16-.384s-.076 1.21.158 1.497c.234.287.39.413.39.413s.018-.502-.05-.896a2.94 2.94 0 00.106-.498 5.96 5.96 0 00.213-.166c-.042.235-.044.363-.044.363s.881-.64.904-.979c.022-.339.264-.629.264-.629s-.2.138-.429.321c.06-.284.248-.508.248-.508s-1.001.685-1.084 1.046a4.093 4.093 0 00-.068.377zm.043 2.081c-.096-.181-.514-.94-.806-1.007-.33-.075-.58-.36-.58-.36s.52 1.096.865 1.234c.276.11.457.154.518.167-.01.148-.011.25-.011.25s.162-.117.41-.392c.25-.274.236-1.487.236-1.487s-.098.365-.363.577c-.178.143-.244.68-.27 1.018zM5.67 7.61c.378-.003.96.925.96.925s-.226.012-.62-.05c-.393-.062-1.007-1.12-1.007-1.12s.288.247.667.245zm1.844 2.16s.224-1.182-.113-1.458a1.198 1.198 0 01-.396-.687s-.3 1.311 0 1.65c.299.34.509.495.509.495zm-1.36-.319c.22.261.921 0 .921 0s.155.14-.402-.368c-.556-.508-1.688-.187-1.383-.187.305 0 .643.294.864.555zm.52 1.388c.407.345 1.29-.476 1.29-.476s-.228-.275-.648-.478c-.421-.203-1.973 0-1.973 0l.69.308s-.768.3-.564.283c.204-.016.796.017 1.204.363z"
            fill="#006923"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.008 10.123s-.35-.59 0-.875c.351-.285.49-.095.49-.423 0-.327.036-.23.208-.392.172-.163.05-.558.281-.36.231.197.274-.181.274.605V7.523c0-.442-.274-.337-.274-.633 0-.297-.274-.74 0-.74s.435.33.435.33.27.459.27 0-.48-.322-.705-.829c-.225-.506-.19.057-.489-.595-.3-.653-.656-.86-.328-.86h.536c.281 0 .716-.233.716 0v.493c0 .367.27.367.27.367s.146-.733.33-.367c.184.367.058.962.193.962.134 0 .023-.615.317-.144.294.472 0 .791 0 .973 0 .182-.317.628-.317.628s.062.217.317 0c.255-.218.497-.436.497-.218s.497.285 0 .633c-.497.348-.18.696-.497.696s-.69.46-.84.46c-.15 0-.711.35-.43.35.28 0 .566-.702.76-.35.193.35.19-.058.35.146.16.205.32 1.313.16.868-.16-.445-.41-.445-.84-.445s-1.267.032-.986.239c.281.206.597-.207.716 0 .12.206.085.413.27.206.184-.206.366 0 .523 0 .157 0-.157.231 0 .43.157.198.508.462.157.462-.35 0-.53-.28-.68 0-.15.28-.157.767-.43.384-.275-.384-.764-.19-.764-.384s.107-.226-.191-.226c-.299 0-.299-.236-.299-.236z"
            fill="#093"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.448 5.906a.154.154 0 01-.152.157.154.154 0 01-.15-.157c0-.086.067-.156.15-.156.084 0 .152.07.152.156zm-6.986.344c.083 0 .15-.07.15-.156a.154.154 0 00-.15-.157.154.154 0 00-.152.157c0 .086.068.156.152.156zm.15.656a.154.154 0 01-.15.157.154.154 0 01-.152-.157c0-.086.068-.156.152-.156.083 0 .15.07.15.156zM6.705 8.5c.083 0 .15-.07.15-.156a.154.154 0 00-.15-.156.154.154 0 00-.152.156c0 .086.068.156.152.156zm1.21 1.563c.083 0 .15-.07.15-.157a.154.154 0 00-.15-.156.154.154 0 00-.152.156c0 .087.068.156.151.156zm5.806-2.376c.083 0 .151-.07.151-.156a.154.154 0 00-.151-.156.154.154 0 00-.152.156c0 .087.068.157.152.157zm-.333 1.094a.154.154 0 01-.151.156.154.154 0 01-.151-.156c0-.086.067-.156.15-.156.084 0 .152.07.152.156zm-1.421 1.531c.083 0 .15-.07.15-.156a.154.154 0 00-.15-.156.154.154 0 00-.151.156c0 .086.067.156.15.156zm-3.841.032a.154.154 0 01-.151.156.154.154 0 01-.151-.156c0-.086.067-.156.15-.156.084 0 .152.07.152.156z"
            fill="#C51918"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.274 12.387c0-.128-1.938-1.463-2.458-1.758-.52-.294-3.06-1.915-2.369-4.379h-.104S5.875 9.285 9.1 11.172c1.468.985 1.541 1.215 1.541 1.215s.633.128.633 0z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.703 12.387c0-.128 1.938-1.463 2.458-1.758.52-.294 3.06-1.915 2.368-4.379h.105s.468 3.035-2.757 4.922c-1.469.985-1.542 1.215-1.542 1.215s-.632.128-.632 0z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.03 10.553c1.353 0 2.45-1.75 2.45-3.46 0-1.708-1.097-2.593-2.45-2.593-1.353 0-2.45.885-2.45 2.594 0 1.708 1.097 3.46 2.45 3.46z"
            fill="#56C6F5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.946 5.962s.377-.333.188-.333a.868.868 0 01-.129-.015c-.2-.032-.46-.074-.46.348v.725H8.49a.062.062 0 100 .125h.049l-.038.705-.071.006a.067.067 0 00-.061.073l.004.053a.067.067 0 00.073.061l.045-.004c-.017.321-.03.602-.03.637 0 .084.573.051.573.051l-.037-.732.038-.003a.067.067 0 00.061-.073l-.004-.053a.067.067 0 00-.073-.061l-.032.002c-.011-.235-.023-.475-.03-.662h.073a.062.062 0 100-.125h-.079a6.52 6.52 0 01-.005-.198v-.527z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.67 6.875h.201v.269h-.202v-.269zm-.061.938h.336v.625h-.336v-.626z"
            fill="#000"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.216 5.962s.377-.333.189-.333a.851.851 0 01-.13-.015c-.2-.032-.46-.074-.46.348v.725H9.76a.062.062 0 100 .125h.049l-.038.705-.071.006a.067.067 0 00-.061.073l.004.053a.067.067 0 00.073.061l.045-.004c-.016.321-.03.602-.03.637 0 .084.573.051.573.051l-.037-.732.038-.003a.067.067 0 00.061-.073l-.004-.053a.067.067 0 00-.073-.061l-.031.002-.031-.662h.073a.063.063 0 000-.125h-.078a6.476 6.476 0 01-.006-.198v-.527z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.94 6.875h.201v.269H9.94v-.269zm-.061.938h.336v.625H9.88v-.626z"
            fill="#000"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.426 5.962s.377-.333.188-.333a.868.868 0 01-.129-.015c-.2-.032-.46-.074-.46.348v.725h-.055a.062.062 0 100 .125h.049l-.038.705-.072.006a.067.067 0 00-.06.073l.004.053a.067.067 0 00.073.061l.045-.004c-.017.321-.03.602-.03.637 0 .084.573.051.573.051l-.037-.732.038-.003a.067.067 0 00.061-.073l-.005-.053a.067.067 0 00-.072-.061l-.032.002c-.011-.235-.023-.475-.03-.662h.073a.063.063 0 000-.125h-.079a6.476 6.476 0 01-.005-.198v-.527z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.15 6.875h.2v.269h-.2v-.269zm-.061.938h.336v.625h-.336v-.626z"
            fill="#000"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.573 4H8.367v.479l-.022.001S6.775 5.7 7.211 7.53c.436 1.827 2.167 3.183 2.167 3.183l.087-.315s-1.65-2.244-1.65-3.14c0-.896.312-1.738.641-1.868.199-.08.233-.063.287-.038.036.017.08.038.187.038.267 0 .535-.192.535-.192s.187.192.36.192c.172 0 .175-.192.175-.192v-.636h.02v.636s.002.192.175.192.359-.192.359-.192.268.192.535.192a.37.37 0 00.187-.038c.055-.025.089-.041.287.038.33.13.64.972.64 1.868 0 .896-1.65 3.14-1.65 3.14l.088.315s1.732-1.356 2.167-3.184c.436-1.828-1.134-3.049-1.134-3.049l-.101-.009V4z"
            fill="#E8AA00"
          />
          <path
            d="M8.367 4v-.313h-.313V4h.313zm3.206 0h.312v-.313h-.312V4zm-3.206.479l.028.31.284-.025V4.48h-.312zm-.022.001l-.027-.31-.092.007-.072.057.191.246zM7.211 7.53l.304-.073-.304.072zm2.167 3.183l-.193.246.37.29.124-.453-.301-.083zm.087-.315l.301.083.04-.146-.089-.123-.252.186zM8.456 5.39l.116.29-.116-.29zm.287-.038l.132-.283-.132.283zm.722-.154l.224-.218-.187-.193-.219.157.182.254zm.535 0l.312.004v-.004H10zm0-.636V4.25h-.313v.313H10zm.02 0h.312V4.25h-.313v.313zm0 .636h-.313v.004l.312-.004zm.534 0l.182-.254-.219-.157-.187.193.224.218zm.722.154l-.132-.283.132.283zm.287.038l-.115.29.115-.29zm-1.01 5.008l-.25-.185-.09.122.04.146.3-.083zm.088.315l-.301.084.125.451.369-.289-.193-.246zm2.167-3.184l.304.073-.304-.073zM11.674 4.48l.192-.246-.073-.057-.091-.008-.028.311zm-.101-.009h-.313v.286l.285.026.028-.312zm-3.206-.159h3.206v-.625H8.367v.626zm.312.167V4h-.625v.479h.625zm-.306.313l.022-.002-.056-.623-.021.002.055.623zm-.858 2.665c-.193-.807.054-1.483.364-1.97a3.474 3.474 0 01.648-.751l.01-.008v-.001l-.192-.247-.192-.246-.002.002-.005.004a1.475 1.475 0 00-.073.062 4.1 4.1 0 00-.722.85c-.368.58-.688 1.428-.444 2.45l.608-.145zm1.863 3.256l.193-.246-.003-.002-.013-.01a5.953 5.953 0 01-.243-.212 7.677 7.677 0 01-.617-.64c-.472-.55-.979-1.301-1.18-2.146l-.608.145c.234.983.811 1.823 1.314 2.408a8.29 8.29 0 00.94.93l.017.014.005.003.001.002h.001l.193-.246zm-.214-.399l-.087.316.602.166.087-.315-.602-.167zM7.503 7.258c0 .298.13.66.286 1 .162.352.376.728.585 1.07a20.018 20.018 0 00.82 1.228l.014.02.004.005.001.001.252-.184.252-.185v-.002c-.002 0-.003-.002-.004-.004l-.013-.018a12.722 12.722 0 01-.235-.333A19.373 19.373 0 018.907 9a10.009 10.009 0 01-.55-1.005c-.153-.333-.229-.587-.229-.738h-.625zM8.341 5.1a.876.876 0 00-.382.336c-.095.14-.176.312-.242.498a4.107 4.107 0 00-.214 1.325h.625c0-.415.072-.814.18-1.118a1.57 1.57 0 01.168-.354c.06-.089.098-.107.096-.106L8.34 5.1zm.534-.03c-.037-.017-.12-.057-.242-.049a.998.998 0 00-.292.08l.23.58a1.04 1.04 0 01.092-.033l.012-.003a.148.148 0 01-.055-.006.152.152 0 01-.017-.006l.008.003.264-.566zm.055.008a.314.314 0 01-.044-.003h.001l-.012-.005-.264.566c.02.01.063.03.122.045a.797.797 0 00.197.022v-.625zm.535.121a65.861 65.861 0 01-.181-.254.013.013 0 010-.001.409.409 0 01-.028.019 1.016 1.016 0 01-.093.05.587.587 0 01-.233.065v.625c.201 0 .384-.07.502-.126a1.643 1.643 0 00.212-.122l.002-.001-.18-.255zm.36-.12c.012 0 .011.002-.006-.005a.62.62 0 01-.128-.091l-.003-.003h.001v.001l-.224.218-.224.218h.001l.001.002a.842.842 0 00.046.043c.027.024.065.056.111.089.08.055.237.152.424.152v-.625zm.175.12l-.313-.004v-.002a.102.102 0 01.001-.014s.001-.006.006-.016a.146.146 0 01.046-.055.15.15 0 01.084-.03v.625a.477.477 0 00.481-.424.568.568 0 00.007-.064v-.011L10 5.197zm-.313-.636v.636h.625v-.636h-.625zm.332-.312H10v.625h.02V4.25zm-.312.313v.635h.625v-.636h-.625zm.312.635l-.312.004v.002a1.016 1.016 0 01.001.026.578.578 0 00.05.195.477.477 0 00.436.277v-.625a.15.15 0 01.085.03.158.158 0 01.047.055l.005.016v.015l-.312.005zm.176.504a.762.762 0 00.424-.152 1.25 1.25 0 00.144-.119l.01-.01.003-.003.001-.001v-.001l-.223-.218-.224-.218.001-.001-.002.002a.563.563 0 01-.129.092c-.017.007-.018.004-.005.004v.625zm.359-.504l-.182.254.001.001.002.001.004.003a1.297 1.297 0 00.208.119c.118.056.301.126.502.126v-.625a.586.586 0 01-.233-.065 1.023 1.023 0 01-.117-.066l-.004-.003-.181.255zm.535.504a.797.797 0 00.197-.022c.06-.015.102-.035.123-.045l-.265-.566a.216.216 0 01-.012.005h.001l-.01.002a.313.313 0 01-.034.001v.625zm.32-.067l.007-.003a.182.182 0 01-.071.012c-.01 0-.008-.002.01.003.02.006.048.016.093.033l.23-.58a.998.998 0 00-.292-.08c-.122-.008-.204.032-.242.049l.265.566zm.039.045c-.002 0 .035.017.095.106.057.083.116.202.169.354.107.304.18.703.18 1.118h.624a4.12 4.12 0 00-.214-1.325 2.185 2.185 0 00-.241-.498.876.876 0 00-.383-.336l-.23.581zm.443 1.578c0 .15-.076.405-.229.738-.147.32-.347.673-.55 1.005a19.333 19.333 0 01-.741 1.117l-.051.07-.014.019-.003.004v.001l.25.186.253.185.001-.002.004-.005.014-.02a11.583 11.583 0 00.244-.345c.157-.228.366-.541.576-.884.21-.341.423-.717.585-1.07.156-.34.286-.701.286-.999h-.625zm-1.638 3.223l.087.316.602-.167-.087-.316-.602.167zm.388.232l.193.246.002-.002.005-.003.017-.014a4.707 4.707 0 00.272-.237c.176-.162.415-.398.668-.693.503-.585 1.08-1.425 1.314-2.408l-.607-.145c-.202.845-.709 1.596-1.18 2.146a7.666 7.666 0 01-.861.852l-.013.01-.002.002.192.246zm2.471-3.111c.244-1.022-.076-1.87-.444-2.45a4.096 4.096 0 00-.778-.899l-.017-.013a.577.577 0 01-.005-.004l-.001-.001h-.001v-.001l-.192.246-.192.247.001.001a1.022 1.022 0 01.051.043 3.473 3.473 0 01.606.715c.31.488.557 1.164.364 1.97l.608.146zm-1.41-3.433l-.102-.01-.055.623.1.009.057-.623zM11.26 4v.471h.625V4h-.625z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.19 8.616s.196-.528.54-.352c.344.176.314.788.626.57.313-.218.136-.57.6-.57.463 0 .394.57.672.57s.302-.57.613-.57c.31 0 .626.352.626.352l-1.839 2.501L8.19 8.616z"
            fill="#8FC753"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.956 11.536l-.198-.267s.82 0 .931.193c.031.055.045.096.056.128.026.08.031.096.254.096.31 0 0-.307-.13-.417-.128-.11-.05-.3.13-.3a3.2 3.2 0 00.337-.036c.236-.03.542-.071.823-.071.456 0 .078.407.078.407s.59 0 .444-.17c-.147-.169.492-.375.768-.375.258 0 1.417.058 1.573.066a75.94 75.94 0 011.631-.066c.277 0 .916.206.769.376-.147.17.444.17.444.17s-.378-.408.078-.408c.28 0 .587.04.823.071.148.02.268.036.337.036.18 0 .258.19.129.3-.129.11-.439.417-.129.417.222 0 .228-.016.254-.096a.622.622 0 01.056-.128c.107-.186.874-.192.928-.193a.159.159 0 01-.02-.076c0-.086.068-.156.152-.156.083 0 .151.07.151.156a.154.154 0 01-.151.156.15.15 0 01-.13-.077l-.197.264.204.253a.15.15 0 01.123-.065c.083 0 .151.07.151.156a.154.154 0 01-.151.157.154.154 0 01-.151-.157c0-.018.002-.035.008-.05-.116-.057-.316-.144-.445-.144h-.361c.09 0 .59.33.44.473l-.027.024c-.148.141-.342.325-.524.225a1.15 1.15 0 01-.31-.249l-.152-.473s-.893-.23-.893-.07c0 .159-.002.237-.32.237-.176 0-.348-.03-.498-.056a1.957 1.957 0 00-.311-.04c-.124 0-.315.038-.456.066a1.41 1.41 0 01-.174.03c-.068 0-.43-.016-.181-.167.248-.15.305-.307.305-.307s-.992.147-1.385.156h-.036c-.389-.009-1.324-.156-1.324-.156s.057.157.305.307-.114.167-.181.167a1.41 1.41 0 01-.174-.03 2.788 2.788 0 00-.456-.066c-.086 0-.192.019-.31.04-.152.026-.323.056-.5.056-.317 0-.32-.078-.32-.238 0-.16-.893.071-.893.071L6 12.16s-.116.143-.31.25c-.183.1-.376-.085-.525-.226l-.025-.024c-.152-.143.348-.473.439-.473h-.361c-.192 0-.536.19-.536.19l.275-.34zm-.43-.187c.084 0 .151-.07.151-.156a.154.154 0 00-.15-.156.154.154 0 00-.152.156c0 .086.068.156.151.156zm0 .688c.084 0 .151-.07.151-.157a.154.154 0 00-.15-.156.154.154 0 00-.152.156c0 .087.068.157.151.157z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.934 1.268h.125v.134h.154v.125h-.154v.228c.172.03.304.184.304.37A.37.37 0 0110 2.5a.37.37 0 01-.363-.375c0-.184.128-.337.297-.369v-.229h-.141v-.125h.141v-.134z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.592 3.266c-.175 0-.544.187-.544.187l.287.637 1.73-.065 1.73.065.287-.637s-.369-.187-.543-.187c-.077 0-.087-.045-.098-.096-.014-.065-.03-.138-.19-.138a1.04 1.04 0 00-.258.034c-.099.023-.162.038-.253-.034a8.982 8.982 0 01-.012-.01c-.147-.116-.3-.237-.549-.237-.05 0-.086.047-.114.122-.027-.075-.064-.122-.114-.122-.248 0-.401.121-.55.238a9.002 9.002 0 01-.01.009c-.092.072-.155.057-.254.034-.064-.015-.144-.034-.258-.034-.16 0-.176.073-.19.138-.01.051-.02.096-.097.096z"
            fill="#E31D1C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.755 2.23l-.121.042c-.321.112-.6.149-.834.112-.484-.074-1.114.177-1.035.546a5.2 5.2 0 00.24.724c.146.359.249.54.368.54l.232.011.017.001c.176.01.33.014.48.013.43-.002.697-.044.792-.173l.028-.038-.013-.046c-.113-.389-.165-.923-.156-1.6l.002-.132zm-1.813.66c-.039-.182.455-.378.831-.32.235.036.5.009.798-.08-.002.6.047 1.09.148 1.466-.086.045-.313.074-.619.076a8.46 8.46 0 01-.47-.013c.002 0-.177-.01-.239-.012a.596.596 0 01-.066-.098 5.14 5.14 0 01-.383-1.02zm2.342-.66l.122.042c.32.112.599.149.833.112.484-.074 1.114.177 1.035.546a5.306 5.306 0 01-.24.724c-.146.359-.248.54-.368.54l-.232.011-.017.001c-.175.01-.33.014-.48.013-.43-.002-.697-.044-.792-.173l-.028-.038.013-.046c.113-.389.166-.923.156-1.6l-.002-.132zm1.813.66c.04-.182-.454-.378-.83-.32a1.828 1.828 0 01-.798-.08c.001.6-.048 1.09-.148 1.466.086.045.312.074.618.076.145 0 .297-.004.47-.013-.002 0 .177-.01.239-.012a.595.595 0 00.066-.098 5.13 5.13 0 00.383-1.02z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.947 4.044a.81.81 0 01.064-.213c.06-.16.1-.21.188-.263.045-.027.062-.05.083-.13a1.152 1.152 0 01.073-.208l.02-.043a.279.279 0 00.018-.113c0-.056-.014-.1-.053-.182a1.09 1.09 0 01-.034-.076.303.303 0 01-.025-.114v-.24c0-.141-.006-.15-.075-.14a.45.45 0 00-.02.003l-.042.008a.078.078 0 01-.044-.006c-.024-.011-.043-.033-.086-.098-.02-.03-.043-.028-.121.01a1.187 1.187 0 01-.025.012c-.08.037-.136.038-.183-.02-.073-.089-.121-.083-.21.003-.043.042-.065.058-.093.062h-.002c-.03.005-.031.005-.114-.045-.005.011-.018.016-.038.02a.278.278 0 01-.092.005c-.022-.004-.038-.01-.048-.032a4.167 4.167 0 00-.124-.002V2.18c.061 0 .112 0 .153.002l.012-.01c.023-.02.058-.05.075-.046.002 0 .008.007.018.015.014.012.033.03.052.042l.002.001c.082.05.086.052.098.05.01-.001.026-.012.06-.046.111-.107.198-.118.297.003.025.03.054.03.112.003l.024-.011c.105-.051.151-.058.197.01.036.054.05.072.06.077h.003c.002.002.005.001.032-.004l.016-.003a.557.557 0 01.023-.003c.115-.016.143.028.143.202v.24a.25.25 0 00.02.09c.008.02.011.025.033.072.043.09.06.142.06.21a.343.343 0 01-.024.137l-.021.047-.019.043a1.1 1.1 0 00-.05.152c-.025.097-.052.134-.11.17-.076.046-.108.083-.163.23a1.753 1.753 0 00-.059.181c.009.007.008.012.005.026l-.004.007-.001.002-.008.008a.049.049 0 01-.005.004l.003-.002a.348.348 0 00-.015.019c-.059.077-.133.077-.205.002l.043-.044c.047.05.08.05.115.003l.011-.015zm-3.924 0a.803.803 0 00-.064-.213c-.06-.16-.1-.21-.188-.263-.045-.027-.062-.05-.083-.13a1.162 1.162 0 00-.053-.162l-.02-.046-.02-.043a.279.279 0 01-.018-.113c0-.056.014-.1.053-.182.023-.049.026-.055.034-.076a.302.302 0 00.025-.114v-.24c0-.141.006-.15.075-.14.007 0 .013.002.02.003l.042.008a.09.09 0 00.044-.006c.024-.011.043-.033.086-.098.02-.03.043-.028.121.01l.025.012c.08.037.136.038.183-.02.073-.089.12-.083.21.003.043.042.065.058.093.062h.002c.03.005.031.005.114-.045.005.011.018.016.038.02a.279.279 0 00.092.005c.022-.004.038-.01.048-.032l.124-.002V2.18c-.061 0-.112 0-.153.002l-.012-.01c-.023-.02-.058-.05-.075-.046-.002 0-.009.007-.018.015a.429.429 0 01-.054.043c-.083.05-.086.052-.098.05-.01-.001-.026-.012-.06-.046-.111-.107-.198-.118-.297.003-.025.03-.054.03-.113.003a1.084 1.084 0 01-.023-.011c-.105-.051-.151-.058-.197.01-.036.054-.05.072-.06.077h-.003c-.002.002-.005.001-.032-.004l-.016-.003a.537.537 0 00-.023-.003c-.115-.016-.143.028-.143.202v.24a.241.241 0 01-.02.09c-.008.02-.011.025-.033.072a.453.453 0 00-.06.21c0 .057.007.095.024.137l.02.047.02.043a1.1 1.1 0 01.05.152c.025.097.052.134.11.17.076.046.108.083.163.23a1.74 1.74 0 01.059.181c-.009.007-.008.012-.005.026a.057.057 0 00.004.007l.001.002c.003.005.003.005.008.008a.043.043 0 00.005.004l-.003-.002.015.019c.059.077.133.077.205.002l-.043-.044c-.047.05-.08.05-.115.003l-.011-.015zm.726-1.835z"
            fill="#5E5E5E"
          />
          <path
            d="M8.609 11.178l.038-.31c.671.082 1.12.123 1.346.123.34.016.747-.009 1.217-.074l.043.31a7.105 7.105 0 01-1.267.077c-.236 0-.693-.042-1.377-.126z"
            fill="#272727"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M6.25 0h7.5v15h-7.5V0z" fill="#FBCD17" />
        <path
          d="M10.047 9.056L7.87 10.568l.696-2.589-1.6-1.653 2.166-.09.916-2.558.916 2.559h2.162L11.53 7.979l.799 2.436-2.282-1.359z"
          fill="#006923"
        />
        <path d="M13.75 0H20v15h-6.25V0z" fill="#E11C1B" />
        <path d="M0 0h6.25v15H0V0z" fill="#006923" />
      </g>
    </symbol>
    <symbol id="SO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#56C6F5" />
        <path
          d="M10.112 9.198l-2.353 1.496.79-2.618L6.87 6.365l2.314-.05 1.023-2.585.933 2.619 2.308.04-1.735 1.742.81 2.49-2.411-1.423z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="SR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10h20v5H0v-5zM0 0h20v3.75H0V0z"
          fill="#4E8B1D"
        />
        <path
          d="M0 4.063h-.938v6.875h21.876V4.062H0z"
          fill="#AF0100"
          stroke="#fff"
          stroke-width="1.875"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.002 9.059L8.441 10l.356-1.836L7.5 6.789l1.758-.074L10.002 5l.743 1.715H12.5l-1.295 1.449.39 1.836L10 9.059z"
          fill="#FECA00"
        />
      </g>
    </symbol>
    <symbol id="SS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v5h20V0H0z"
          fill="#272727"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10v5h20v-5H0z"
          fill="#4E8B1D"
        />
        <path
          d="M0 4.375h-.625v6.25h21.25v-6.25H0z"
          fill="#E31D1C"
          stroke="#F7FCFF"
          stroke-width="1.25"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0l12.5 7.5L0 15V0z"
          fill="#3D58DB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.155 9.005l-1.262 1.313-.132-1.866-1.61-.992 1.679-.526.274-1.85L4.267 6.55l1.695-.454-.877 1.734.852 1.673-1.782-.497z"
          fill="#FECA00"
        />
      </g>
    </symbol>
    <symbol id="ST" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0v15h20V0H0z" fill="#FBCD17" />
        <path d="M0 0v5h20V0H0zm0 10v5h20v-5H0z" fill="#73BE4A" />
        <path d="M0 0v15l6.25-7.5L0 0z" fill="#C51918" />
        <path
          d="M10.626 8.67l-1.169.705.267-1.377-.974-1.031 1.318-.056.558-1.286.558 1.286H12.5l-.971 1.087.292 1.377-1.195-.706zm5 0l-1.169.705.267-1.377-.974-1.031 1.318-.056.558-1.286.558 1.286H17.5l-.971 1.087.292 1.377-1.195-.706z"
          fill="#272727"
        />
      </g>
    </symbol>
    <symbol id="SV" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v5h20V0H0zm0 10v5h20v-5H0z"
            fill="#3D58DB"
          />
          <path
            d="M12.14 7.411a2.276 2.276 0 11-4.551 0 2.276 2.276 0 014.552 0z"
            stroke="#E8AA00"
            stroke-width=".625"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.632 6.039s-.596.98-.596 1.652c0 .673.713 1.518 1.834 1.518 1.094 0 1.88-.653 1.904-1.518.023-.864-.589-1.48-.589-1.48s.347 1.245.173 1.75c-.173.504-.733 1.114-1.488 1.037C9.116 8.92 8.4 7.99 8.4 7.69c0-.3.232-1.652.232-1.652z"
            fill="#1E601B"
          />
          <path
            d="M8.85 7.705h2.005"
            stroke="#188396"
            stroke-width=".625"
          />
          <path
            d="M9.037 7.379h1.725m-.106.378H9.121l.774-1.285.761 1.285z"
            stroke="#E8AA00"
            stroke-width=".625"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SX" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 7.5V15h20V7.5H0z"
            fill="#2E42A5"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0-1.25v17.5L12.5 7.5 0-1.25z"
          fill="#F7FCFF"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="0"
          y="-2"
          width="13"
          height="19"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0-1.25v17.5L12.5 7.5 0-1.25z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.079 5.743c.898 0 1.626-.446 1.626-.997 0-.55-.728-.996-1.626-.996-.898 0-1.626.446-1.626.997 0 .55.728.996 1.626.996z"
            fill="#FBCD17"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.22 3.99c-.132 0-.226.086-.226.215v.014a.249.249 0 00-.012.072.23.23 0 00.077.178.147.147 0 01.005.035c-.003-.011-.016-.02-.041-.038-.035-.026-.093-.068-.181-.157-.127-.129-.223-.179-.342-.159a.555.555 0 00-.113.036.419.419 0 01-.245.008c-.319-.06-.668-.001-1.047.174l.131.284c.324-.15.609-.199.858-.151a.725.725 0 00.468-.043c-.004.001-.001.003.015.019l.052.051c.036.037.073.07.111.1-.073.019-.07.032-.056.08.006.02.013.045.017.079.01.074-.006.113.007.131.015.02.064.016.222.01l.166-.013c.13-.013.277-.03.367-.045.088-.015.11-.02.148-.047l.032-.04a14.701 14.701 0 011.027-.115c.006 0 .011-.002.043-.008l.026-.012h.001l.076-.181-.08-.096c-.052-.016-.052-.016-.059-.016l-.015-.001H6.58a.798.798 0 01-.152-.015l-.055-.01c-.244-.045-.47-.045-.949.027l-.027-.02a2.38 2.38 0 01.27-.029c.06-.003.06-.003.094-.003h.015l-.002-.313H5.22zm-.258.906l.03-.007.03-.006a8.363 8.363 0 01-.06.013z"
            fill="#DA610A"
          />
          <path
            d="M4.953 5.363l.05.008.051-.008c.62-.102 1.03-.09 1.266-.01.273.091.575.065.892-.042-.1.449-.152.873-.152 1.271 0 .455.087.822.167 1.144l.007.025c.078.316.142.577.142.877 0 .269-.089.41-.214.499-.144.102-.385.167-.742.167-.504 0-.975.136-1.41.401l-.006-.005-.007.005a2.658 2.658 0 00-1.41-.401c-.357 0-.598-.065-.742-.167-.125-.089-.214-.23-.214-.5 0-.3.065-.56.143-.876l.006-.025c.08-.322.168-.69.168-1.144 0-.398-.052-.822-.152-1.27.317.106.618.132.891.04.237-.079.645-.09 1.266.011z"
            fill="#56C6F5"
            stroke="#E31D1C"
            stroke-width=".625"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.49 6.39l-.482-.428-.482.428h.143v.247l-.75.467v1.143h-.143v.215h2.5v-.215h-.178V7.104l-.786-.49V6.39h.178z"
            fill="#F7FCFF"
          />
          <path
            d="M4.97 10.638c.663 0 1.12-.073 1.355-.196a.316.316 0 01.284-.16c.517.02.917-.198 1.231-.676.34-.517.409-1.251.187-2.215l.562-.129c.254 1.104.171 1.995-.266 2.66-.393.597-.928.916-1.58.937-.334.247-.918.356-1.773.356-.828 0-1.441-.161-1.835-.502-.893-.211-1.461-.568-1.685-1.096-.238-.563-.238-1.345-.016-2.353l.564.125c-.199.9-.199 1.57-.016 2.003.127.302.498.548 1.125.719l.583.124-.028.147c.285.167.72.256 1.308.256z"
            fill="#FBCD17"
          />
          <path
            d="M2.946 5.515l.32.129-.16.332.447-.23-.035.17-.096.47.184-.535v.473l.112-.473.332.1-.332-.206.332-.101"
            stroke="#73BE4A"
            stroke-width=".625"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.556 6.21a.312.312 0 100-.624.312.312 0 000 .625z"
            fill="#FBCD17"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.65 6.17c-.004-.21-.028-.69-.134-.69-.108 0-.124.486-.126.694-.185.06-.324.22-.324.22h.92s-.145-.166-.335-.223z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="SY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#F7FCFF" />
        <path
          d="M5.626 8.67l-1.17.705.268-1.377-.974-1.031 1.318-.056.558-1.286.558 1.286H7.5l-.971 1.087.292 1.377-1.195-.706zm8.75 0l-1.169.705.267-1.377-.974-1.031 1.318-.056.558-1.286.558 1.286h1.316l-.971 1.087.292 1.377-1.195-.706z"
          fill="#409100"
        />
        <path d="M0 0v5h20V0H0z" fill="#E31D1C" />
        <path d="M0 10v5h20v-5H0z" fill="#272727" />
      </g>
    </symbol>
    <symbol id="SZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#3D58DB"
        />
        <path
          d="M0 3.125h-.625v8.75h21.25v-8.75H0z"
          fill="#C51918"
          stroke="#FFD018"
          stroke-width="1.25"
        />
        <path
          d="M4.468 5.832c-.075 0-.135-.17-.135-.379s.06-.378.135-.378H15.35c.075 0 .136.17.136.378 0 .21-.061.379-.136.379H4.468z"
          fill="#FFD018"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.06 5.376l.631-.806 1.118.806-1.118.828-.632-.828z"
          fill="#F7FCFF"
        />
        <path
          d="M4.468 8.332c-.075 0-.135-.17-.135-.379s.06-.378.135-.378H15.35c.075 0 .136.17.136.378 0 .21-.061.379-.136.379H4.468z"
          fill="#FFD018"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.06 7.876l.631-.806 1.118.806-1.118.828-.632-.828z"
          fill="#F7FCFF"
        />
        <path
          d="M2.716 9.889c-.1 0-.182-.193-.182-.43 0-.238.081-.43.182-.43h14.59c.1 0 .182.192.182.43 0 .237-.081.43-.182.43H2.716z"
          fill="#FFD018"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.51 7.533s1.777-3.738 4.317-3.738 4.375 3.738 4.375 3.738-2.241 3.688-4.346 3.688c-2.104 0-4.345-3.688-4.345-3.688z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="5"
          y="3"
          width="10"
          height="9"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.51 7.533s1.777-3.738 4.317-3.738 4.375 3.738 4.375 3.738-2.241 3.688-4.346 3.688c-2.104 0-4.345-3.688-4.345-3.688z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M9.953 3.55s-.58.704-.387 1.375c.193.671.644.6.644 1.192 0 .59-.208 1.194 0 1.194.207 0 .28.407.09.684-.19.277-.359.285-.347.735.01.45.995.892.518.892-.476 0-1.105.463-.905.463.2 0 1.246.36 1.246.833v.851H5.357V3.55h4.596z"
            fill="#272727"
          />
          <path
            d="M7.387 6.202h-.272v1.106h.272V6.202zm.8 0h-.27v1.106h.27V6.202zm-.671 0h.271v1.106h-.271V6.202zm1.072 0h-.271v1.106h.271V6.202zm.13 0h.27v1.106h-.27V6.202zm.671 0h-.271v1.106h.271V6.202zM7.115 7.789h.272v1.105h-.272V7.788zm1.073 0h-.272v1.105h.272V7.788zm-.672 0h.271v1.105h-.271V7.788zm1.072 0h-.271v1.105h.271V7.788zm.13 0h.27v1.105h-.27V7.788zm.671 0h-.271v1.105h.271V7.788z"
            fill="#F7FCFF"
          />
          <path
            d="M10.61 6.202h-.27v1.106h.27V6.202zm.802 0h-.272v1.106h.272V6.202zm-.672 0h.271v1.106h-.271V6.202zm1.072 0h-.271v1.106h.271V6.202zm.13 0h.27v1.106h-.27V6.202zm.671 0h-.271v1.106h.271V6.202zM10.34 7.789h.272v1.105h-.272V7.788zm1.073 0h-.272v1.105h.272V7.788zm-.672 0h.271v1.105h-.271V7.788zm1.072 0h-.271v1.105h.271V7.788zm.13 0h.27v1.105h-.27V7.788zm.671 0h-.271v1.105h.271V7.788z"
            fill="#272727"
          />
          <path
            d="M8.27 4.42c-.38.118-.555 1.115-.512 1.356.042.241.171-.03.171-.03s.264.572.29.726c.028.154.166-.233.166-.233s.457.314.519.665c.061.35.154-.401.154-.401l.104-.018-.066-.371.198.168-.061-.345s.148.194.11-.02l-.058-.332-.052-.292.196-.035s-.779-.956-1.16-.838z"
            fill="#3D58DB"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.305 8.56c-.395.05-.74 1.002-.74 1.247 0 .245.175 0 .175 0s.16.609.16.765c0 .156.203-.2.203-.2s.395.389.395.744c0 .356.222-.368.222-.368h.105v-.376l.165.2v-.35s.113.216.113 0v-.635h.198s-.6-1.077-.996-1.027zM3.496 8.416c.395.05.74 1.002.74 1.247 0 .244-.175 0-.175 0s-.16.608-.16.765c0 .156-.203-.2-.203-.2s-.395.388-.395.744-.222-.368-.222-.368h-.105v-.377l-.165.2v-.35s-.113.217-.113 0v-.634H2.5s.6-1.077.996-1.027z"
          fill="#3D58DB"
        />
      </g>
    </symbol>
    <symbol id="TC" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.154 6.27s.554 7.457 3.051 7.457c2.498 0 3.112-7.457 3.112-7.457h-6.163z"
            fill="#FECA00"
            stroke="#F7FCFF"
            stroke-width=".5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.195 6.639l.091-.104.434.277c.063-.098.174-.143.331-.136l-.158-.24.129-.07.3.362.03.01-.076-.47.15-.018.099.609h.007c.043 0 .09.02.14.053l.107-.662.15.018-.075.47.03-.01.3-.361.129.068-.159.241c.157-.007.269.038.332.136l.433-.277.092.104-.476.303c.007.034.01.072.01.112v.07l.657-.143.048.122-.705.25v.085l.668-.054.02.128-.688.1v.148l.69.114-.028.127-.662-.1v1.437h-.102V7.886L18 7.82c-.05.351-.106.794-.098.954.008.158.125.226.208.273.065.037.108.062.061.108-.106.104-.372.203-.638.203s-.528-.1-.585-.203c-.01-.02-.009-.018 0-.007.042.048.25.286.266-.374a3.622 3.622 0 00-.105-.94l-.346.052v1.452h-.101V7.902L15.998 8l-.028-.127.69-.114v-.148l-.688-.1.02-.128.669.054v-.085l-.706-.25.049-.122.657.144v-.07c0-.041.003-.079.01-.113l-.476-.303zm.869 1.032l.006.02-.308.052v-.116l.302.044zm.006-.475a1.19 1.19 0 00-.014.016l-.294-.065v-.093c0-.018 0-.036.002-.052l.306.194zm.196-.193a2.2 2.2 0 00-.1.093l-.364-.232c.052-.088.152-.12.308-.097l.156.236zm.668.16l.469-.299c-.051-.088-.152-.12-.308-.097l-.218.331c.02.022.04.044.057.065zm.158.061l.35-.222a.592.592 0 01.001.052v.093l-.35.077zm.14.24l.211-.075v.057l-.21.017zm-.161.217l.372-.054v.116l-.372-.062zm-1.309-.292v.057l.21.017-.21-.074z"
            fill="#CF6900"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.549 9.902s-.821 1.375-.821 2.208c0 0 .56.444 1.522.444s1.457-.444 1.457-.444a29.947 29.947 0 00-.732-2.208h-1.426z"
            fill="#00A727"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.589 9.522a.686.686 0 011.371 0v.469h-1.371v-.469z"
            fill="#E31D1C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.45 8.02s1.083.224 1.083.576.437.48.544.384c.107-.095.862-.162.862-.62 0-.46.063-.584-.12-.876-.184-.291-.566-1.276-.654-.881-.088.394-.22.687-.465.451-.245-.235-.56-.733-.67-.451-.11.281.35.564 0 .564s-.103.018-.103.256c0 .239.041.463-.218.463-.26 0-.26.135-.26.135z"
            fill="#FF927F"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TD" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M14 0h6v15h-6V0z" fill="#E11C1B" />
        <path d="M0 0h7v15H0V0z" fill="#2E42A5" />
        <path d="M6 0h8v15H6V0z" fill="#FBCD17" />
      </g>
    </symbol>
    <symbol id="TF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.743 3.875h5.03l-.49.94h-1.526v.505h1.17l-.477.874h-.693v1.75l1.142-1.8 1.478 2.559h-.604l-.21-.28h-1.338l-.941 1.738v.096l-.026-.048-.026.048v-.096l-.94-1.738h-1.338l-.211.28h-.604l1.478-2.56 1.142 1.8V4.815h-1.526l-.49-.94zm4.185 3.318l-.328.505h.622l-.294-.505zm-3.34 0l.328.505h-.621l.293-.505zm-2.392-.56l.52-.383.519.383-.183-.641.504-.405-.633-.014-.208-.633-.207.633-.633.014.504.405-.183.641zm7.589-.383l-.52.383.183-.641-.504-.405.633-.014.208-.633.207.633.633.014-.504.405.183.641-.52-.383zm-2.11 4.877l.519-.383.52.383-.184-.642.504-.405-.632-.013-.208-.634-.208.634-.632.013.504.405-.183.642zm-3.369-.383l-.52.383.184-.642-.504-.405.632-.013.208-.634.208.634.632.013-.504.405.183.642-.519-.383zm1.425 1.881l.519-.383.52.383-.184-.642.504-.405-.632-.013-.208-.634-.208.634-.632.013.504.405-.183.642z"
            fill="#F7FCFF"
          />
          <path
            fill="#2E42A5"
            stroke="#fff"
            stroke-width=".625"
            d="M-.313-.313h8.125v6.875H-.313z"
          />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="10"
            height="8"
          >
            <path
              fill="#fff"
              stroke="#fff"
              stroke-width=".625"
              d="M-.313-.313h8.125v6.875H-.313z"
            />
          </mask>
          <g mask="url(#c)" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M5 0h2.5v6.25H5V0z" fill="#F50100" />
            <path d="M0 0h2.5v6.25H0V0z" fill="#2E42A5" />
            <path d="M2.5 0H5v6.25H2.5V0z" fill="#F7FCFF" />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="TG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M0-.625h-.625v16.25h21.25V-.625H0z"
          fill="#5EAA22"
          stroke="#F7FCFF"
          stroke-width="1.25"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 3.75v2.5h20v-2.5H0zm0 5v2.5h20v-2.5H0z"
          fill="#FECA00"
        />
        <path fill="#F50101" d="M0 0h10v8.75H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.156 6.34L2.832 7.78l.902-2.415-1.859-1.627h2.28l1.001-2.406.764 2.406h2.253L6.59 5.364l.778 2.296-2.213-1.32z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="TH" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10h20v5H0v-5zM0 0h20v3.75H0V0z"
          fill="#F50101"
        />
        <path
          d="M0 4.063h-.938v6.875h21.876V4.062H0z"
          fill="#3D58DB"
          stroke="#fff"
          stroke-width="1.875"
        />
      </g>
    </symbol>
    <symbol id="TJ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M0 0h20v15H0V0z" fill="#F7FCFF" />
        <path d="M0 0v5h20V0H0z" fill="#C51918" />
        <path d="M0 10v5h20v-5H0z" fill="#409100" />
        <path
          d="M10.013 5.394l-.37.26.13-.437-.358-.276.45-.01.148-.431.147.432.45.009-.358.276.13.438-.37-.261zm-1.561.383l-.37.26.13-.437-.358-.276.45-.01.148-.431.148.432.45.009-.359.276.13.438-.37-.261zm-1.583 1.41l.369-.261.37.26-.13-.437.358-.276-.45-.01-.148-.431-.148.432-.45.009.359.276-.13.438zm-.021 1.228l-.37.261.13-.438-.358-.276.45-.009.148-.432.148.432.45.01-.359.275.13.438-.37-.261zm5.917.261l.369-.261.37.261-.13-.438.358-.276-.45-.009-.148-.432-.148.432-.45.01.359.275-.13.438zm-.108-1.75l-.37.26.131-.437-.359-.276.45-.01.148-.431.148.432.45.009-.359.276.13.438-.369-.261zm-1.565-.888l.37-.261.369.26-.13-.437.358-.276-.45-.01-.148-.431-.147.432-.45.009.358.276-.13.438zm-3.175 4.434l-.115-.41c.637-.173 1.37-.259 2.196-.259.826 0 1.558.086 2.196.258l-.116.41c-.597-.161-1.29-.242-2.08-.242s-1.483.08-2.08.243zm.79-.658c-.255.043-.463-.203-.463-.203l.253-.104c-.008-.175.097-.284.097-.284.085.04.202.255.202.255h.229s-.064.293-.318.336zm3.006-.16s-.208.245-.463.202c-.254-.043-.318-.336-.318-.336h.229s.116-.215.202-.254c0 0 .105.108.097.283l.253.105zm-1.747.082c-.258.007-.43-.265-.43-.265l.265-.068a.4.4 0 01.136-.267c.079.05.164.28.164.28l.227.031s-.104.281-.362.289z"
          fill="#FB0"
        />
        <path
          d="M9.974 8.562s-.293.67-.755.722c-.461.052-.696-.381-.696-.381s-.03.45-.578.624c-.549.174-.837-.52-.837-.52s.285.255.728.144c.443-.111.617-.522.617-.522s.328.428.766.214c.439-.214.681-.476.681-.727v-.751s-.113-.195-.31-.195c-.195 0-.25.138-.25.138s-.077-.781.629-.83v-.002l.02.001h.019v.001c.706.049.629.83.629.83s-.055-.138-.25-.138c-.197 0-.31.195-.31.195v.75c0 .252.242.514.68.728.439.214.767-.214.767-.214s.174.41.617.522c.443.111.728-.144.728-.144s-.288.694-.837.52c-.548-.173-.578-.624-.578-.624s-.235.433-.696.381c-.462-.052-.755-.722-.755-.722l-.015-.886-.014.886zm-.006-1.873a.385.385 0 00-.392.275c.287 0 .392.125.392.125s.212-.125.425-.125c0 0-.1-.275-.425-.275z"
          fill="#FB0"
        />
      </g>
    </symbol>
    <symbol id="TK" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M2.059 6.29l-.553.342.214-.575-.47-.435h.57L2.06 5l.182.622h.571l-.411.435.201.575-.543-.342zm2.501-2.5l-.554.342.214-.575-.47-.435h.57l.24-.622.182.622h.572l-.412.435.201.575-.543-.342zm2.5 2.5l-.554.342.214-.575-.47-.435h.57L7.06 5l.182.622h.572l-.412.435.201.575-.543-.342zm-2.5 2.5l-.554.342.214-.575-.47-.435h.57l.24-.622.182.622h.572l-.412.435.201.575-.543-.342z"
            fill="#F7FCFF"
          />
          <path
            d="M15.526 3.414c-2.552 1.261-10.938 6.927-10.938 6.927h13.97c-.14-.031-.27-.057-.393-.082-1.025-.204-1.531-.305-2.639-2.51-1.24-2.47 0-4.335 0-4.335zM4.135 11.228l-.191.475.19.522 14.222.275.394-.725-.394-.522-14.221-.025z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TL" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M0-.625h-.625v16.25h21.25V-.625H0z"
          fill="#E31D1C"
          stroke="#F7FCFF"
          stroke-width="1.25"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0l15 7.5L0 15V0z"
          fill="#FECA00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0l10 7.5L0 15V0z"
          fill="#272727"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.155 9.005l-1.262 1.313-.132-1.866-1.61-.992 1.679-.526.274-1.85L4.267 6.55l1.695-.454-.877 1.734.852 1.673-1.782-.497z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="TM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#29C470"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#C51918" d="M1.25-.202H7.5V16.25H1.25z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="1"
            y="-1"
            width="7"
            height="18"
          >
            <path fill="#fff" d="M1.25-.202H7.5V16.25H1.25z" />
          </mask>
          <g mask="url(#c)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.622.566l-.341.439-.031-.03.331-.426V.463l.001-.008.039-.118-.024-.042-.195.196.376-.587v.2l.073.066.172-.302-.173-.29-.125.096.05.102-.034.024-.282-.472.18.123.031-.046-.172-.176.076-.083-.251-.368.032-.028.274.4-.071.078.168.171-.077.113-.052-.036.098.165.166-.128.211.355-.211.37-.123-.111v-.08l-.124.192.052.092-.044.136v.099zm-.341 3.578l.341-.439v-.098l.044-.137-.052-.091.124-.193v.08l.123.111.211-.37-.21-.354-.167.127-.098-.164.052.035.077-.112-.168-.172.071-.078-.274-.4-.032.029.251.367-.076.084.172.175-.031.046-.18-.123.282.472.035-.024-.05-.102.124-.096.173.29-.172.302-.073-.065v-.2l-.376.586.195-.195.024.041-.039.119v.093l-.332.425.03.03zm.341 2.424l-.341.438-.031-.03.331-.426v-.085l.001-.008.039-.119-.024-.04-.195.194.376-.586v.2l.073.066.172-.302-.173-.29-.125.095.05.102-.034.024-.282-.472.18.123.031-.046-.172-.175.076-.084-.251-.367.032-.028.274.4-.071.078.168.17-.077.113-.052-.035.098.164.166-.127.211.354-.211.37-.123-.11v-.08l-.124.192.052.092-.044.136v.099zm-.341 3.347l.341-.439v-.099l.044-.136-.052-.092.124-.192v.08l.123.111.211-.37-.21-.354-.167.127-.098-.165.052.036.077-.113-.168-.17.071-.08-.274-.399-.032.028.251.368-.076.084.172.175-.031.046-.18-.123.282.472.035-.024-.05-.102.124-.096.173.29-.172.302-.073-.065v-.2l-.376.586.195-.195.024.04-.039.12v.093l-.332.425.03.03zm0 2.585l.341-.439v-.098l.044-.136-.052-.092.124-.193v.08l.123.111.211-.37-.21-.354-.167.127-.098-.164.052.035.077-.112-.168-.171.071-.079-.274-.4-.032.029.251.367-.076.084.172.175-.031.046-.18-.123.282.472.035-.024-.05-.102.124-.096.173.29-.172.302-.073-.065v-.2l-.376.586.195-.195.024.041-.039.119v.093l-.332.426.03.03zm6.188 0l-.341-.439v-.098l-.044-.136.052-.092-.124-.193v.08l-.123.111-.211-.37.21-.354.167.127.098-.164-.052.035-.077-.112.168-.171-.071-.079.274-.4.032.029-.251.367.076.084-.172.175.031.046.18-.123-.282.472-.035-.024.05-.102-.124-.096-.173.29.172.302.073-.065v-.2l.376.586-.195-.195-.024.041.039.119v.093l.332.426-.03.03zm-.341-3.024l.341.439.031-.03-.331-.426v-.086l-.001-.008-.039-.118.024-.041.195.195-.376-.586v.2l-.073.065-.172-.302.173-.29.125.096-.05.102.034.024.282-.472-.18.123-.031-.046.172-.175-.076-.084.251-.368-.032-.028-.274.4.071.078-.168.171.077.113.052-.036-.098.165-.166-.127-.211.354.211.37.123-.111v-.08l.124.192-.052.092.044.136v.1zm.341-2.47l-.341-.438v-.1l-.044-.135.052-.092-.124-.192v.08l-.123.11-.211-.37.21-.354.167.127.098-.164-.052.035-.077-.112.168-.171-.071-.079.274-.4.032.029-.251.367.076.084-.172.175.031.046.18-.123-.282.472-.035-.024.05-.102L6.9 5.58l-.173.29.172.303.073-.066v-.2l.376.586-.195-.195-.024.041.039.119v.093l.332.426-.03.03zm-.341-3.3l.341.438.031-.03-.331-.426v-.085l-.001-.008-.039-.119.024-.041.195.195-.376-.586v.2l-.073.065-.172-.302.173-.29.125.096-.05.102.034.024.282-.472-.18.123-.031-.046.172-.175-.076-.084.251-.367-.032-.029-.274.4.071.078-.168.172.077.112.052-.035-.098.164-.166-.127-.211.354.211.37.123-.11v-.08l.124.192-.052.091.044.137v.098zm.341-2.701L7.128.566V.467L7.084.331 7.136.24 7.012.047v.08L6.89.238l-.211-.37.21-.355.167.128.098-.165-.052.036-.077-.113.168-.17-.071-.08.274-.399.032.028-.251.368.076.083-.172.176.031.046.18-.123L7.01-.2l-.035-.024.05-.102L6.9-.422l-.173.29.172.302.073-.065v-.2l.376.586-.195-.196-.024.042.039.118V.55L7.5.974l-.03.03z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.567 9.103h.97v.228h.222v.182h.265v.592H5.76v.183h-.221v.182h-.945l-.262.232-.263-.232h-.876v-.182h-.22v-.183H2.75v-.592h.221v-.182h.221v-.228h.902l.237-.21.236.21z"
              fill="#389F5D"
            />
            <path
              d="M5.538 9.103h.25v-.25h-.25v.25zm-.971 0L4.4 9.29l.07.063h.096v-.25zm.97.228h-.25v.25h.25v-.25zm.222 0h.25v-.25h-.25v.25zm0 .182h-.25v.25h.25v-.25zm.265 0h.25v-.25h-.25v.25zm0 .592v.25h.25v-.25h-.25zm-.265 0v-.25h-.25v.25h.25zm0 .183v.25h.25v-.25h-.25zm-.221 0v-.25h-.25v.25h.25zm0 .182v.25h.25v-.25h-.25zm-.945 0v-.25h-.095l-.072.063.167.187zm-.262.232l-.166.188.167.146.165-.147-.166-.187zm-.263-.232l.166-.187-.07-.063h-.096v.25zm-.876 0h-.25v.25h.25v-.25zm0-.182h.25v-.25h-.25v.25zm-.22 0h-.25v.25h.25v-.25zm0-.183h.25v-.25h-.25v.25zm-.222 0H2.5v.25h.25v-.25zm0-.592v-.25H2.5v.25h.25zm.221 0v.25h.25v-.25h-.25zm0-.182v-.25h-.25v.25h.25zm.221 0v.25h.25v-.25h-.25zm0-.228v-.25h-.25v.25h.25zm.902 0v.25h.095l.071-.063-.166-.187zm.237-.21l.166-.186-.165-.148-.167.147.166.187zm1.207-.04h-.971v.5h.97v-.5zm.25.478v-.228h-.5v.228h.5zm-.03-.25h-.22v.5h.22v-.5zm.25.432v-.182h-.5v.182h.5zm.016-.25H5.76v.5h.265v-.5zm.25.842v-.592h-.5v.592h.5zm-.515.25h.265v-.5H5.76v.5zm.25-.067v-.183h-.5v.183h.5zm-.471.25h.22v-.5h-.22v.5zm.25-.068v-.182h-.5v.182h.5zm-1.195.25h.945v-.5h-.945v.5zm-.096.17l.262-.233-.333-.374-.261.232.332.374zm-.594-.233l.262.233.332-.375-.263-.232-.331.374zm-.71.063h.875v-.5h-.876v.5zm-.25-.432v.182h.5v-.182h-.5zm.028.25h.221v-.5h-.22v.5zm-.25-.433v.183h.5v-.183h-.5zm.029.25h.221v-.5H2.75v.5zm-.25-.842v.592H3v-.592h-.5zm.471-.25H2.75v.5h.221v-.5zm-.25.068v.182h.5v-.182h-.5zm.471-.25h-.22v.5h.22v-.5zm-.25.022v.228h.5v-.228h-.5zm1.152-.25h-.902v.5h.902v-.5zm.166.437l.237-.21-.332-.374-.236.21.331.374zm-.095-.21l.236.21.332-.374-.236-.21-.332.374z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.322 9.63v-.403h.47l-.47.403zm1.974 0v-.403h-.47l.47.403zm-1.974.729v-.403l.47.403h-.47zm1.974-.403v.403h-.47l.47-.403z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.153 9.262l.162-.212.16.212h-.322zm0 .198l.162.212.16-.212h-.322zm.162.501l-.162.212h.322l-.16-.212zm-.162.41l.162.212.16-.212h-.322z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.157 9.236v.092h-.093v.125h.093v.09h.324v-.09h.093v-.125H4.48v-.092h-.324zm.324 1.003v-.091h-.324v.091h-.093v.125h.093v.091h.324v-.09h.093v-.126H4.48zm-.947-.521l.154-.213.152.213h-.306zm0 .2l.154.212.152-.213h-.306zm1.437-.413l-.154.213h.306l-.152-.213zm-.154.412l.154.213.152-.213h-.306z"
              fill="#AF0100"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.533 9.692v.093h-.089v.128h.089v.093h.308v-.093h.089v-.128h-.09v-.093h-.308zm1.592.093v-.093h-.31v.093h-.088v.128h.089v.093h.309v-.093h.088v-.128h-.088z"
              fill="#E8AA00"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="2"
              y="10"
              width="5"
              height="4"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.886 10.782l-1.108.624v1.035l1.108.65h1.199l1.133-.65v-1.035l-1.133-.624h-1.2z"
                fill="#fff"
              />
            </mask>
            <g mask="url(#d)">
              <path
                d="M2.794 11.935H4.52v1.14H2.794v-1.14z"
                fill="#E8AA00"
              />
              <path
                fill="#F9E8E7"
                d="M2.617 10.796H4.52v1.139H2.617z"
              />
              <path
                d="M3.06 11.46l.573-.345v.345H3.06zm3.363-.664H4.52v1.139h1.903z"
                fill="#E8AA00"
              />
              <path
                d="M5.847 11.46l-.572-.345v.345h.572zm.398 1.614H4.52v-1.139h1.726z"
                fill="#F9E8E7"
              />
              <path
                d="M5.803 12.41l-.573.345v-.345h.573z"
                fill="#E8AA00"
              />
              <path
                d="M3.06 12.338l.573.345v-.345H3.06z"
                fill="#FCFCFC"
              />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.9 11.48h.288l.288-.092.287.091h.288v.866h-.288l-.287.137-.288-.137H3.9v-.866z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.874 10.961h.156v.176h.064v.125H5.03v.068h-.156v-.369zm-1.57.547h-.156v.369h.156v-.068h.065v-.125h-.065v-.176zm.222 0h-.157v.369h.157v-.37zm-.222.456h-.156v.368h.156v-.067h.065v-.125h-.065v-.176zm.065 0h.157v.368h-.157v-.368zm2.213-.456h.156v.176h.064v.125h-.064v.068h-.156v-.37zm.377 0h-.156v.369h.156v-.37zm-.22.456h-.157v.368h.156v-.067h.064v-.125h-.064v-.176zm.064 0h.156v.368h-.156v-.368zm-.552-1.003h-.156v.369h.156v-.369zm-1.283 0h-.156v.369h.156v-.068h.064v-.125h-.064v-.176zm.065 0h.156v.369h-.156v-.369zm.84 1.55h.157v.176h.064v.125H5.03v.067h-.156v-.368zm.378 0h-.156v.368h.156v-.368zm-1.283 0h-.156v.368h.156v-.067h.064v-.125h-.064v-.176zm.065 0h.156v.368h-.156v-.368z"
              fill="#C9343F"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.39 11.666h.045v-.123h-.221v.141h-.182v.203h.17v-.045h-.126v-.112h.15l.226.195-.226.196h-.15v-.112H4.2v-.045h-.17v.203h.183v.141h.22v-.123H4.39v.078h-.133v-.11l.23-.199.23.2v.109h-.132v-.079H4.54v.124h.221v-.141h.183v-.203h-.17v.045H4.9v.112h-.15l-.226-.196.226-.195h.15v.112h-.125v.045h.17v-.203h-.183v-.141h-.22v.123h.044v-.078h.132v.11l-.23.199-.23-.2v-.109h.133v.078z"
              fill="#fff"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.74 3h-.779v2.5h.78V3zm-1.753.529h.487v1.346h-.487V3.529zm2.289 0h.487v1.346h-.487V3.529z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.961 3.192h-.487v1.923h.487V3.192zm-.974.53H2.5v.913h.487V3.72zm2.776 0h.487v.913h-.487V3.72zm-.536-.53H4.74v1.923h.487V3.192z"
              fill="#389F5D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.864 3.433c0 .08-.066.144-.146.144a.145.145 0 01-.147-.144c0-.08.066-.145.147-.145.08 0 .146.065.146.145zm-.974.48c0 .08-.066.145-.147.145a.145.145 0 01-.146-.145c0-.08.066-.144.147-.144.08 0 .146.065.146.144zm0 .53a.146.146 0 01-.147.144.145.145 0 01-.146-.145c0-.08.066-.144.147-.144.08 0 .146.065.146.144zm.828.576c.08 0 .146-.064.146-.144a.145.145 0 00-.146-.144.145.145 0 00-.147.144c0 .08.066.144.147.144zm2.288-.961a.146.146 0 00.147-.145.145.145 0 00-.147-.144.145.145 0 00-.146.144c0 .08.066.145.146.145zm.147.384c0 .08-.066.145-.147.145a.145.145 0 01-.146-.145c0-.08.066-.144.146-.144.081 0 .147.065.147.144zm-1.17.577a.145.145 0 00.147-.144.145.145 0 00-.146-.144.145.145 0 00-.146.144c0 .08.065.144.146.144zm.147-1.586c0 .08-.066.144-.146.144a.145.145 0 01-.146-.144.146.146 0 01.292 0z"
              fill="#E1E5E8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.497 3.24c0 .08-.066.145-.146.145a.145.145 0 01-.146-.145c0-.08.065-.144.146-.144.08 0 .146.065.146.144zm-1.12.53a.145.145 0 01-.146.143.145.145 0 01-.147-.144c0-.08.066-.144.147-.144.08 0 .146.065.146.144zm.974 1.682c.08 0 .146-.065.146-.144a.145.145 0 00-.146-.145.145.145 0 00-.146.145c0 .08.065.144.146.144zm1.315-1.683c0 .08-.066.144-.147.144a.145.145 0 01-.146-.144c0-.08.066-.144.146-.144.081 0 .147.065.147.144zM3.23 4.78c.08 0 .146-.065.146-.144a.145.145 0 00-.146-.145.145.145 0 00-.147.145c0 .08.066.144.147.144zm2.435-.144c0 .08-.066.144-.147.144a.145.145 0 01-.146-.144c0-.08.066-.145.146-.145.081 0 .147.065.147.145z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.504 3.995l.474-.429h.77l.54.492h.718v.192h-.698v.01l-.56.57h-.77l-.474-.514V4.25h-.81v-.192h.81v-.063z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.382 3.923l.23.233-.242.23-.241-.23.23-.233.011-.01.012.01zm.042.563l.027-.025-.028-.026.24-.227.25.253-.112.12h-.067l-.124.077-.186-.172zm-.054.05l-.23.213-.154-.097h-.078l-.181-.192.298-.302-.3-.285.197-.191.071.056.104-.104-.032-.032.053-.05.252.256.253-.256.052.05-.03.032.103.104.071-.056.197.191-.3.285.298.302-.182.192h-.077l-.154.097-.23-.213zm.13-.598l.002-.003-.069-.064-.009-.009.18-.166.138.139.072-.057.097.095-.246.233-.166-.168zm-.155.523l-.214.197-.124-.078H3.94l-.112-.119.25-.253.267.253zm-.516-.588l.247.233.24-.244-.18-.166L4 3.835l-.072-.057-.098.095zM2.78 13.401c-.13-.166-.219-.278-.242-.276-.073.005-.141.777.807 1.365 0 0 .14.078.221 0 .082-.078 0-.193 0-.193-.306-.287-.593-.65-.786-.896zm3.19 0c.13-.166.219-.278.242-.276.073.005.141.777-.807 1.365 0 0-.14.078-.221 0-.082-.078 0-.193 0-.193.306-.287.593-.65.786-.896zM5.9 14.44c-.311.092-.672.111-.81.052a.793.793 0 00-.14-.045 1.258 1.258 0 00-.43-.014l-.058.006h-.004a.416.416 0 01-.025.003c-.01 0-.02.002-.03.004a.137.137 0 00-.031-.004l-.026-.002h-.003l-.06-.007a1.258 1.258 0 00-.429.014.793.793 0 00-.14.045c-.138.06-.498.04-.81-.052 0 0 .567.227.904.127a.586.586 0 01.103-.034.969.969 0 01.312-.012 3.66 3.66 0 01-.175.076v.028c.133-.054.288-.08.354-.087a1.5 1.5 0 01.354.087v-.028a3.664 3.664 0 01-.174-.076.969.969 0 01.312.012c.036.008.07.02.103.034.337.1.903-.127.903-.127z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.602 6.236l-.782.69v.656l.684.688h1.397l.77-.734v-.559l-.77-.741H3.602z"
              fill="#389F5D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.872 6.309h-.177v.137h.177v-.137zm0 1.787h-.177v.137h.177v-.137zm.265 0h.177v.137h-.177v-.137zm.177-1.787h-.177v.137h.177v-.137zm.266 1.787h.177v.137H4.58v-.137zm.177-1.787H4.58v.137h.177v-.137z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.096 6.273h-.18v.137h.18v-.137zm0 1.823h-.18v.137h.18v-.137zm.27-1.823h.18v.137h-.18v-.137zm.18 1.823h-.18v.137h.18v-.137z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.071 6.151h2.363v.365h.338v1.51h-.338v.312H3.07v-.312h-.367v-1.51h.367v-.365zm.133.502h-.368v1.236h.368V8.2H5.3v-.312h.338V6.653H5.3v-.365H3.204v.365z"
              fill="#750100"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.004 6h-.22v.228h.22V6zm.354 0h-.22v.228h.22V6zm.133 0h.221v.228h-.22V6zm-.487 2.279h-.22v.228h.22v-.228zm.133 0h.221v.228h-.22v-.228zm.575 0h-.22v.228h.22v-.228zm-2.215-.505v-.221h.228v.221h-.228zm0-.586v.221h.228v-.22h-.228zm0-.143v-.221h.228v.22h-.228zm3.186.508v.221h.227v-.221h-.227zm0-.144v-.22h.227v.22h-.227zm0-.585v.22h.227v-.22h-.227z"
              fill="#389F5D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.611 6.428l-.381.332v1.074l.317.224h1.372l.317-.224V6.76l-.357-.332H3.61z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.252 6.873l-.46.393h.46v-.393z"
              fill="#E1E5E8"
            />
            <path
              d="M4.252 7.623l-.46-.393h.46v.393z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.212 6.873l.46.393h-.46v-.393z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.232 7.373a.14.14 0 100-.28.14.14 0 000 .28z"
              fill="#29AE66"
            />
            <path
              d="M4.212 7.623l.46-.393h-.46v.393z"
              fill="#E1E5E8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.252 7.094h-.398v.127h.398v-.127zm0 .232h-.398v.128h.398v-.128zm1.991-.232h.399v.127h-.399v-.127zm.399.232h-.399v.128h.399v-.128z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.208 6.957h-.354v.14h.354v-.14zm0 .232h-.354v.14h.354v-.14zm-.354.233h.354v.14h-.354v-.14zm2.743-.465h-.354v.14h.354v-.14zm-.354.232h.354v.14h-.354v-.14zm.354.233h-.354v.14h.354v-.14zM6.24.994v.253H4.39l-.001 1.15h-.58c-.101 0-.379-.194-.379-.194h-.47l-.218-.222v-.223l-.234-.277.002-.254h1.85V.077h.58c.102 0 .38.195.38.195h.47l.217.222v.223l.234.277z"
              fill="#E8AA00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.508.994l.002.253h1.85v1.15h.58c.102 0 .38-.194.38-.194h.47l.217-.222v-.223l.234-.277-.002-.254H4.39V.077h-.58c-.101 0-.379.195-.379.195h-.47l-.218.222v.223l-.234.277z"
              fill="#E1E5E8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.751.428l-.02-.097.399-.092a1.29 1.29 0 00.245-.196l.054.06.01-.01c.114.107.197.173.245.196l.399.092-.02.097L4.84.433l.021.019a.275.275 0 00-.05.04l-.09-.015.008-.032-.023-.004a1.062 1.062 0 00-.058.138L4.554.553 4.59.372 4.38.174l-.149.138a.61.61 0 01.055.058.877.877 0 01-.045.016l-.006.001.024.116-.093.027a1.4 1.4 0 00-.035-.09l-.008.001a.275.275 0 00-.05-.04L4.1.378a.235.235 0 00-.012-.02l-.338.07zm.017.358L3.82.703 3.546.518l.03-.043-.078-.059-.034.047-.11-.073-.053.084.105.07-.021.03.078.06.025-.035.28.187zm-.341.1L3.48.803 3.205.618l.03-.043-.078-.059-.034.047-.11-.073-.053.084.105.07-.021.03.078.06.025-.035.28.187zm-.146.3l.053-.083-.275-.185.03-.043-.078-.059-.034.047-.11-.073-.053.084.105.07-.021.03.078.06.025-.035.28.187zm.004.24l-.053-.083-.28.187-.025-.034-.078.059.021.03-.104.07.053.084.11-.073.033.047.078-.059-.03-.043.275-.185zm.093.217l.053.083-.275.185.03.043-.078.06-.034-.048-.11.073-.052-.083.105-.07-.022-.031.078-.06.025.035.28-.187zm.341.1l.053.083-.275.185.03.043-.078.06-.034-.048-.11.073-.052-.083.104-.07-.021-.031.078-.06.025.035.28-.187zm.52.478a.878.878 0 00-.045-.016L4.175 2.2l.037-.174L4.118 2a.754.754 0 01-.078.172l-.337-.07-.02.098.384.088.055.037.008-.004c.048.034.114.09.197.166l.031-.035.032.035a1.29 1.29 0 01.245-.196l.013-.003a.387.387 0 00.05.037l.056-.037-.005-.019.006-.005.279-.064-.02-.098-.338.07A.753.753 0 014.598 2l-.093.027.038.181-.185.173-.142-.133a.702.702 0 00.023-.026zm1.192-.795l.053-.083.28.187.025-.034.079.059-.022.03.105.07-.053.084-.11-.073-.034.047-.078-.059.03-.043-.275-.185zm-.146.3l.053-.083.28.187.025-.034.079.059-.022.03.105.07-.053.084-.11-.073-.034.047-.078-.059.03-.043-.275-.185zm-.34.1l.052-.083.28.187.025-.034.079.059-.022.03.105.07-.053.084-.11-.073-.034.047-.078-.059.03-.043-.275-.185zm.535-.673l.053.083.28-.187.025.034.078-.059-.021-.03L6 .924 5.946.84l-.109.073-.034-.047-.078.06.03.042-.275.185zm-.146-.3l.053.083.28-.187.025.034.078-.059-.021-.03.104-.07L5.8.54l-.11.073-.033-.047-.078.06.03.042-.275.185zm-.341-.1l.053.083.28-.187.025.034.078-.059-.021-.03.105-.07L5.459.44 5.35.513 5.316.466l-.078.06.03.042-.275.185z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.88.72l.55-.291v.8h1.364l-.325.234v.306h-.514l-.552.293v-.8H3.041l.324-.234V.72h.515z"
              fill="#C51918"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.956.72L4.404.429v.8H3.041l.324.234v.306h.515l.551.293v-.8h1.364l-.325-.234V.72h-.514z"
              fill="#29AE66"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.612.928l.09-.177.229.122.063-.094.16.114-.05.073.679.363.041-.063.16.114-.027.042.073.039-.09.177-.095-.05-.077.114-.16-.114.063-.094-.678-.362-.055.083-.16-.114.041-.062-.207-.111z"
              fill="#29AE66"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.056.88L4.954.707l-.22.139-.07-.09-.151.125.054.07-.65.409-.047-.06-.152.125.03.04-.07.044.103.17.09-.057.085.109.152-.125-.07-.089.652-.409.06.079.153-.125-.046-.059.199-.125z"
              fill="#C51918"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.92 1.25s1.457 3.451.163 4.917C10.79 7.632 7.5 7.35 7.5 7.35s4.223 1.907 6.063-.72c1.84-2.626-1.642-5.38-1.642-5.38z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.278 3.28l-.386.272.136-.455-.374-.287.47-.01.154-.448.154.448.47.01-.375.287.136.455-.385-.272zm.074 1.254l-.385.27.136-.454-.374-.287.47-.01.153-.448.154.449.47.01-.374.286.136.455-.386-.271zm-1.557.368l.386-.272.385.272-.136-.455.374-.287-.47-.01-.153-.448-.154.449-.47.01.374.286-.136.455zm1.557.946l-.385.272.136-.455-.374-.287.47-.01.153-.448.154.448.47.01-.374.287.136.455-.386-.272zm.888-1.426l.386-.271.385.27-.136-.454.374-.287-.47-.01-.153-.448-.154.449-.47.01.374.286-.136.455z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M10 12.5a5 5 0 100-10 5 5 0 000 10z"
            fill="#F7FCFF"
          />
          <path
            d="M10.877 11.032s-2.636-.72-2.636-3.549c0-2.829 2.636-3.61 2.636-3.61-1.09-.421-4.279.226-4.279 3.61 0 3.385 3.278 3.994 4.279 3.549zm-.145-4.164l-1.308.477 1.405.492.048 1.315.855-1.022 1.41.1-1.016-.829.612-1.197-1.195.403-.828-1.035.017 1.296z"
            fill="#E31D1C"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TO" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#F7FCFF" d="M0 0h11.25v10H0z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.5 1.25H5v2.5H2.5v2.5H5v2.5h2.5v-2.5H10v-2.5H7.5v-2.5z"
            fill="#E31D1C"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TR" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.016 10.071c-1.338-.33-2.387-1.45-2.374-3.092.01-1.537.942-2.836 2.413-3.188 1.471-.352 2.766.395 2.766.395-.406-.96-1.819-1.634-2.977-1.633C7.688 2.557 5.39 4.305 5.37 6.98c-.02 2.772 2.461 4.35 4.644 4.347 1.75-.003 2.579-1.2 2.75-1.71 0 0-1.41.785-2.748.455zm3.049-3.617l-1.334.49 1.505.53-.026 1.587.991-1.19 1.638.119-1.298-1.116.852-1.19-1.387.467-.992-1.102.05 1.405z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TT" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M18.468 18.426l-.332.271-.292-.312-18.965-20.25-.335-.357.38-.31L.857-4.113l.332-.27.292.311 18.965 20.25.335.357-.38.31-1.934 1.582z"
            fill="#272727"
            stroke="#F7FCFF"
            stroke-width=".915"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TV" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#00B4FF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="11"
            height="9"
          >
            <path fill="#fff" d="M0 0h11v9H0z" />
          </mask>
          <g mask="url(#c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <mask
              id="d"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="13"
              height="11"
              fill="#000"
            >
              <path fill="#fff" d="M-1-1h13v11H-1z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              />
            </mask>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#d)"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.785 6.678l.38-.703.832-.025-.644-.539.222-.726-.556.334-.702-.426.068.807-.63.378.818.102.212.798zm-2.12.547l-.38.703-.212-.798-.818-.102.63-.378-.068-.807.702.426.556-.334-.222.726.645.539-.833.025zm-1.63 1.953l.38-.703.833-.025-.645-.539.222-.726-.556.334-.702-.426.068.807-.63.378.818.102.212.798zm-2.5 2.5l.38-.703.833-.025-.645-.539.222-.726-.556.334-.702-.426.068.807-.63.378.818.102.212.798zM8.11 13.585l-.688.407.229-.793-.648-.509h.734l.358-.727.382.727h.649l-.565.509.275.793-.726-.407zm2.806-.11l-.38.703-.212-.798-.818-.102.63-.378-.068-.807.702.426.556-.334-.222.726.645.539-.833.025zm2.5-1.25l-.38.703-.212-.798-.818-.102.63-.378-.068-.807.702.426.556-.334-.222.726.645.539-.833.025zm2.5-1.25l-.38.703-.212-.798-.818-.102.63-.378-.068-.807.702.426.556-.334-.222.726.644.539-.832.025zm.87-.547l.38-.703.832-.025-.644-.539.222-.726-.556.334-.702-.426.068.807-.63.378.818.102.212.798z"
            fill="#FFD018"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#EF0000"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v8.75h11.25V0H0z" fill="#2E42A5" />
          <path
            d="M5.456 6.757L4.53 7.912l-.224-1.464-1.38.538.538-1.38L2 5.382l1.155-.926L2 3.53l1.464-.224-.538-1.38 1.38.538L4.53 1l.926 1.155L6.382 1l.224 1.464 1.38-.538-.538 1.38 1.464.224-1.155.926 1.155.926-1.464.224.538 1.38-1.38-.538-.224 1.464-.926-1.155zm0-.512a1.789 1.789 0 100-3.578 1.789 1.789 0 000 3.578zm1.431-1.789a1.431 1.431 0 11-2.862 0 1.431 1.431 0 012.862 0z"
            fill="#FEFFFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="TZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3195F9"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15L20 0H0z"
            fill="#73BE4A"
          />
          <path
            d="M-1.139 15.9l.434.65.65-.434L22.608.988l.65-.433-.434-.65-1.388-2.08-.433-.65-.65.434L-2.31 12.737l-.65.433.434.65 1.387 2.08z"
            fill="#272727"
            stroke="#FFD018"
            stroke-width="1.563"
          />
        </g>
      </g>
    </symbol>
    <symbol id="UA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#3195F9"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 7.5V15h20V7.5H0z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
    <symbol id="UG" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#FECA00"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#272727" d="M0 0h20v2.5H0z" />
          <path fill="#D74800" d="M0 5h20v2.5H0z" />
          <path fill="#272727" d="M0 7.5h20V10H0z" />
          <path fill="#D74800" d="M0 12.5h20V15H0z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 11.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
            fill="#F7FCFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.55 5.205l-.661.217.66.057s.108.261 0 .466a1.046 1.046 0 01-.186.202c-.262.25-.692.657-.692 1.32 0 .887 1.713 1.29 1.713 1.29v.421s.198.124-.936.124c-.983 0-.922.373-.888.577.005.032.01.059.01.08 0 .162.472-.161.694-.482.116-.17.604-.16 1.105-.114.04.003.404.777.087 1.176-.133.168-.593.19-.88.204-.146.007-.248.011-.239.032.007.016.094.011.22.003.157-.009.375-.022.577-.003.03.003-.088.106-.208.21-.123.107-.248.215-.213.217.04.002.27-.126.48-.242.174-.096.333-.185.357-.185.159 0 .302.02.427.037.21.029.37.05.471-.037.032-.026-.149-.07-.333-.114-.19-.045-.383-.091-.352-.122.174-.173.101-.535.044-.82a1.497 1.497 0 01-.044-.314c.015-.26.289-.123.505-.016.094.046.177.088.222.088.408 0-.098-.517-.377-.8a13.806 13.806 0 01-.067-.068c-.141-.147-.042-.127.182-.083.171.034.415.083.68.083.614 0 1.061-.2.906-.739-.103-.356-.664-.477-1.25-.603-.303-.066-.613-.132-.87-.233-.63-.249-.598-.612-.57-.918.005-.06.01-.117.01-.171 0-.333.56-.74.56-.74s-.255-.429-.68-.429c-.425 0-.464.43-.464.43zM9.705 9.11v-.313s.262-.009.354.212c.092.22-.354.101-.354.101z"
            fill="#272727"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.173 4.195l.634.75.328-.076-.158-.759-.804.085z"
            fill="#D74800"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.995 4.013l.041 1.13.541-.134.23-.74-.812-.256z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.486 5.9c.12 0 .216-.095.216-.212a.214.214 0 00-.216-.21.214.214 0 00-.217.21c0 .117.097.211.217.211zM9.86 4.225l-.63.754.133.31.72-.287-.223-.777zm1.464 5.708s1.108-.495 1.108-1.187c0-.692-1.799-1.446-1.799-1.446s-1.058.243-.581.567c.477.324 1.116.448 1.116.88 0 .43.175.841-.18.841s.336.345.336.345z"
            fill="#D74800"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.726 7.174s-.392.069-.373.132c.051.176.587.405.82.564.477.324.93.288 1.266.077.336-.211-1.713-.773-1.713-.773z"
            fill="#FFFDFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="UM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 1.25V2.5h20V1.25H0zm0 2.5V5h20V3.75H0zM0 7.5V6.25h20V7.5H0zm0 1.25V10h20V8.75H0zm0 3.75v-1.25h20v1.25H0zM0 15v-1.25h20V15H0z"
          fill="#F7FCFF"
        />
        <path fill="#2E42A5" d="M0 0h11.25v8.75H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.3 2.717l.662-.461.514.37h-.29l.588.52-.2.73h-.31l-.303-.67-.257.67H.935l.589.52-.224.821.662-.461.514.37h-.29l.588.52-.2.73h-.31l-.303-.67-.257.67H.935l.589.52-.224.821.662-.461.641.461-.199-.82.515-.521H2.68l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521H5.18l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521H7.68l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521h-.655l-.303-.67-.257.67H8.83l-.177-.73.515-.52H8.93l.531-.37.641.461-.199-.82.515-.521h-.655l-.303-.67-.257.67H8.83l-.177-.73.515-.52H8.93l.531-.37.641.461-.199-.82.515-.521h-.655L9.46.706l-.257.67h-.769l.589.52-.2.73h-.31l-.303-.67-.257.67H7.58l-.177-.73.515-.52h-.655L6.96.706l-.257.67h-.769l.589.52-.2.73h-.31l-.303-.67-.257.67H5.08l-.177-.73.515-.52h-.655L4.46.706l-.257.67h-.769l.589.52-.2.73h-.31l-.303-.67-.257.67H2.58l-.177-.73.515-.52h-.655L1.96.706l-.257.67H.935l.589.52-.224.821zm7.525 2.409l.199-.73-.589-.52h.291l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31zm-1.349 0l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31l.2-.73-.589-.52h.291zm-2.202.52l-.2.73h-.31l-.303-.67-.257.67H3.83l-.177-.73.515-.52H3.93l.531-.37.514.37h-.29l.588.52zm.18-.52H5.08l-.177-.73.515-.52H5.18l.531-.37.514.37h-.29l.588.52-.2.73h-.31l-.303-.67-.257.67zm-1.63 0l.2-.73-.589-.52h.291l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31zm3.95-1.98l-.2.73h-.31l-.303-.67-.257.67H6.33l-.177-.73.515-.52H6.43l.531-.37.514.37h-.29l.588.52zm-2.798-.52l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31l.2-.73-.589-.52h.291z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="US" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 1.25V2.5h20V1.25H0zm0 2.5V5h20V3.75H0zM0 7.5V6.25h20V7.5H0zm0 1.25V10h20V8.75H0zm0 3.75v-1.25h20v1.25H0zM0 15v-1.25h20V15H0z"
          fill="#F7FCFF"
        />
        <path fill="#2E42A5" d="M0 0h11.25v8.75H0z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.3 2.717l.662-.461.514.37h-.29l.588.52-.2.73h-.31l-.303-.67-.257.67H.935l.589.52-.224.821.662-.461.514.37h-.29l.588.52-.2.73h-.31l-.303-.67-.257.67H.935l.589.52-.224.821.662-.461.641.461-.199-.82.515-.521H2.68l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521H5.18l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521H7.68l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521h-.655l-.303-.67-.257.67H8.83l-.177-.73.515-.52H8.93l.531-.37.641.461-.199-.82.515-.521h-.655l-.303-.67-.257.67H8.83l-.177-.73.515-.52H8.93l.531-.37.641.461-.199-.82.515-.521h-.655L9.46.706l-.257.67h-.769l.589.52-.2.73h-.31l-.303-.67-.257.67H7.58l-.177-.73.515-.52h-.655L6.96.706l-.257.67h-.769l.589.52-.2.73h-.31l-.303-.67-.257.67H5.08l-.177-.73.515-.52h-.655L4.46.706l-.257.67h-.769l.589.52-.2.73h-.31l-.303-.67-.257.67H2.58l-.177-.73.515-.52h-.655L1.96.706l-.257.67H.935l.589.52-.224.821zm7.525 2.409l.199-.73-.589-.52h.291l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31zm-1.349 0l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31l.2-.73-.589-.52h.291zm-2.202.52l-.2.73h-.31l-.303-.67-.257.67H3.83l-.177-.73.515-.52H3.93l.531-.37.514.37h-.29l.588.52zm.18-.52H5.08l-.177-.73.515-.52H5.18l.531-.37.514.37h-.29l.588.52-.2.73h-.31l-.303-.67-.257.67zm-1.63 0l.2-.73-.589-.52h.291l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31zm3.95-1.98l-.2.73h-.31l-.303-.67-.257.67H6.33l-.177-.73.515-.52H6.43l.531-.37.514.37h-.29l.588.52zm-2.798-.52l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31l.2-.73-.589-.52h.291z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="UY" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill="#2E42A5"
            d="M0 2.5h20v1.25H0zM0 5h20v1.25H0zm0 2.5h20v1.25H0zM0 10h20v1.25H0zm0 2.5h20v1.25H0z"
          />
          <path fill="#F7FCFF" d="M0 0h10v8.75H0z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.767 6.898s-.638 1.324-1.2 1.596c.242-.607.332-1.847.332-1.847s-1.458.578-1.97.473c.616-.43 1.47-1.226 1.47-1.226s-1.887-.617-1.84-.88c.851.153 2.022-.013 2.022-.013s-1.323-1.587-1.19-1.705C3.595 3.492 5.18 4.32 5.18 4.32s.115-1.412.456-1.888c.04.336.52 1.858.52 1.858s.963-.964 1.498-.964c-.235.291-.791 1.57-.791 1.57s1.385-.022 1.912.238c-.638.09-1.756.652-1.756.652S8.475 6.89 8.342 7.12c-.781-.383-1.685-.51-1.685-.51s.25 1.536.048 1.884c-.197-.512-.938-1.596-.938-1.596z"
            fill="#FFD018"
            stroke="#F19900"
            stroke-opacity=".98"
            stroke-width=".5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.683 6.182a.625.625 0 100-1.25.625.625 0 000 1.25z"
            fill="#FFD018"
            stroke="#F19900"
            stroke-opacity=".98"
            stroke-width=".5"
          />
        </g>
      </g>
    </symbol>
    <symbol id="UZ" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10h20v5H0v-5z"
          fill="#14DC5A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v6.25H0V0z"
          fill="#0099B5"
        />
        <path
          d="M-1.25 5.781h-.469v4.689H21.72V5.78H-1.25z"
          fill="#F7FCFF"
          stroke="#C51918"
          stroke-width=".938"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.455 1.5l-.615.349.176-.708-.589-.52h.769l.258-.67.302.67h.655l-.515.52.248.708-.69-.348zM7.306 3.423l.614-.348.69.348-.248-.708.514-.52h-.655l-.302-.67-.258.67h-.768l.588.52-.175.708zM5.61 4.721l-.614.348.176-.708-.589-.52h.769l.257-.67.303.67h.655l-.515.52.247.708-.689-.348zm2.346.002l-.615.349.176-.708-.589-.52h.769l.258-.67.302.67h.655l-.515.52.248.708-.69-.349zm2.5 0l-.615.349.176-.708-.589-.52h.769l.258-.67.302.67h.655l-.515.52.248.708-.69-.349zm-.65-1.3l.614-.35.69.35-.248-.71.514-.52h-.655l-.302-.67-.258.67h-.768l.588.52-.175.71zm2.535 1.649l.615-.349.689.349-.248-.708.515-.52h-.655l-.302-.67-.258.67h-.769l.589.52-.176.708zm.58-1.998l-.615.348.175-.708-.588-.52h.768l.258-.67.302.67h.655l-.514.52.247.708-.689-.348zm-.58-1.225l.614-.348.689.348-.248-.708.515-.52h-.655l-.302-.67-.258.67h-.768l.588.52-.176.708zm3.115 2.874l-.615.349.176-.708-.589-.52h.769l.258-.67.302.67h.655l-.515.52.248.708-.69-.349zm-.65-1.3l.614-.35.69.35-.248-.71.514-.52h-.655l-.302-.67-.258.67h-.768l.588.52-.175.71zm.649-1.922l-.615.348.176-.708-.588-.52h.768l.258-.67.302.67h.655l-.515.52.248.708-.69-.348zM3.678 5.15s-1.51-.41-1.481-1.925C2.225 1.712 3.75 1.318 3.75 1.318c-.623-.236-2.466.08-2.5 1.893-.034 1.812 1.847 2.169 2.428 1.94z"
          fill="#F7FCFF"
        />
      </g>
    </symbol>
    <symbol id="VA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h8.75v15H0V0z"
          fill="#FFDC17"
        />
        <path
          d="M14.239 7.97l-.216.014c.051.74.21 1.313.48 1.717.437.652 1.011 1.155 1.396 1.155.088 0 .108.033.08.113-.042.114-.171.226-.338.269-.277.072-.908.109-1.882.109v.209c.993 0 1.635-.038 1.938-.116.234-.06.42-.221.485-.402.076-.21-.038-.39-.283-.39-.285 0-.816-.465-1.214-1.06-.247-.37-.397-.91-.447-1.619zm-1.022 0l.216.014c-.052.74-.211 1.313-.481 1.717-.436.652-1.011 1.155-1.396 1.155-.087 0-.108.033-.079.113.041.114.17.226.338.269.277.072.908.109 1.881.109v.209c-.993 0-1.635-.038-1.937-.116-.235-.06-.42-.221-.486-.402-.075-.21.038-.39.283-.39.286 0 .816-.465 1.214-1.06.248-.37.398-.91.447-1.619z"
          fill="#AF0100"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.542 4.249l-5.714 4.454a2.062 2.062 0 00-.646-.101c-.927 0-1.702.592-1.702 1.36 0 .769.775 1.36 1.702 1.36.107 0 .211-.007.313-.022a.598.598 0 01-.2-.262c-.041-.117-.024-.226.042-.299a1.56 1.56 0 01-.155.008c-.625 0-1.108-.368-1.108-.785 0-.416.483-.785 1.108-.785.626 0 1.108.369 1.108.785a.61.61 0 01-.125.36l.045-.042c.198-.184-.247.576-.631.576-.088 0-.108.033-.08.113.04.107.155.212.307.26.627-.196 1.08-.68 1.08-1.267 0-.24-.077-.463-.209-.656l3.07-2.606.206.213.148-.134.513.38-.215.165.438.532.883-.68.015-.008-.002-.002.055-.042-.438-.533-.212.164-.573-.397.067-.06-.185-.191.278-.236.147.152.158-.143.497.393-.209.161.438.533.757-.584.086-.047-.012-.01.12-.092-.438-.532-.248.19-.544-.417.074-.067-.127-.13.566-.48-.448-.55z"
          fill="#F4B300"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.804 9.203c.164 0 .297-.105.297-.235s-.133-.235-.297-.235c-.164 0-.297.105-.297.235s.133.235.297.235zm.108 2.146c.164 0 .297-.106.297-.236s-.133-.235-.297-.235c-.164 0-.297.105-.297.235s.133.236.297.236zm2.946-.236c0 .13-.133.236-.297.236-.164 0-.297-.106-.297-.236s.133-.235.297-.235c.164 0 .297.105.297.235zm1.757-1.151c0-.345.157-.655.413-.891l-3.28-2.541-.038.029.096.086-.26.268-.135-.124-.502.387.191.148-.437.532-.874-.673-.024-.015.002-.002-.054-.042.437-.533.212.164.573-.397-.067-.06.248-.257-.289-.224-.199.206-.152-.138-.491.398.197.151-.438.533-.733-.565-.11-.066.012-.01-.12-.092.438-.532.248.19.544-.417-.074-.067.15-.155-.589-.456.372-.449 5.676 4.396c.23-.091.488-.142.76-.142.926 0 1.702.592 1.702 1.36 0 .769-.776 1.36-1.702 1.36-.107 0-.211-.007-.312-.022a.6.6 0 00.198-.262c.043-.117.026-.226-.04-.299.05.005.101.008.154.008.625 0 1.108-.368 1.108-.785 0-.416-.483-.785-1.108-.785-.626 0-1.109.369-1.109.785 0 .128.046.25.126.36a2.827 2.827 0 01-.045-.042c-.198-.184.247.576.631.576.088 0 .108.033.08.113a.478.478 0 01-.307.26c-.627-.196-1.08-.68-1.08-1.267z"
          fill="#BFBFBF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.696 9.203c-.164 0-.297-.105-.297-.235s.133-.235.297-.235c.164 0 .297.105.297.235s-.133.235-.297.235zm-.108 2.146c-.164 0-.297-.106-.297-.236s.133-.235.297-.235c.164 0 .297.105.297.235s-.133.236-.297.236zm-2.946-.236c0 .13.133.236.297.236.164 0 .297-.106.297-.236s-.133-.235-.297-.235c-.164 0-.297.105-.297.235z"
          fill="#F4B300"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.588 7.372a.081.081 0 00-.081.081v.338h-.3a.078.078 0 100 .157h.3v4.47a.08.08 0 00.08.082h.163a.081.081 0 00.081-.081V7.948h.462a.078.078 0 100-.157h-.462v-.338a.081.081 0 00-.081-.08h-.162z"
          fill="#AF0100"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.472 4.746l.132.09c.308-.42.586-.505.868-.284.487.382.53 1.312.008 1.624-.621.372-.936 1.097-.66 1.491.254.364.867.226 1.472-.23.107-.082.21-.169.306-.26l-.128-.098c-.088.082-.18.16-.278.233-.54.408-1.058.525-1.238.267-.215-.307.06-.94.611-1.27.625-.373.577-1.434.009-1.879-.366-.287-.746-.171-1.102.316zm2.38 1.907l.131.092c.23-.31.387-.646.439-.976l-.16-.024c-.048.305-.195.617-.41.908zm4.191-1.907l-.132.09c-.308-.42-.586-.505-.868-.284-.487.382-.53 1.312-.008 1.624.621.372.936 1.097.66 1.491-.254.364-.867.226-1.472-.23a3.642 3.642 0 01-.306-.26l.128-.098c.088.082.18.16.278.233.54.408 1.058.525 1.238.267.215-.307-.06-.94-.611-1.27-.625-.373-.577-1.434-.009-1.879.366-.287.746-.171 1.102.316zm-2.38 1.907l-.132.092c-.229-.31-.386-.646-.438-.976l.16-.024c.048.305.195.617.41.908z"
          fill="#979797"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.669 12.51c.179 0 .324-.072.324-.162 0-.09-.145-.162-.324-.162-.18 0-.324.073-.324.162 0 .09.145.162.324.162zm-.054-6.748c.627 0 1.135-.085 1.135-.19 0-.104-.508-.188-1.135-.188s-1.135.084-1.135.189c0 .104.508.19 1.135.19z"
          fill="#AF0100"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.679 1.274h-.162v.187h-.154v.157h.154v.458h.162v-.458h.187V1.46h-.187v-.187zm-1.22 2.261l-.072-.121c.04-.017.08-.033.121-.048l-.21-.462.148-.064.217.477c.046-.014.093-.026.14-.037a.22.22 0 01-.053-.146c0-.116.085-.21.19-.21.104 0 .188.094.188.21a.228.228 0 01-.018.09 3.91 3.91 0 01.402-.03v-.178h-.203v-.127h.203v-.15h.214v.15h.248v.127h-.248v.176c.16.003.31.014.448.033a.226.226 0 01-.019-.091c0-.116.085-.21.19-.21.104 0 .189.094.189.21a.22.22 0 01-.058.15c.06.016.118.034.174.054l.155-.34.149.063-.154.337.036.018-.082.117-.013-.006-.025.055-.148-.064.024-.053a2.724 2.724 0 00-.866-.137v.056h-.214V3.33a2.946 2.946 0 00-1.053.206zm-.072.14l.038.064-.128.054.211.463c-.04.015-.081.03-.121.047l.072.122a2.945 2.945 0 011.053-.206v.055h.214v-.056c.341.006.63.052.866.137l-.024.053.148.063.025-.054.013.006.082-.118a1.823 1.823 0 00-.036-.017l.154-.338-.149-.063-.155.34a2.106 2.106 0 00-.174-.053.22.22 0 00.058-.15c0-.116-.085-.21-.19-.21-.104 0-.189.094-.189.21 0 .032.007.063.02.09-.14-.019-.29-.03-.449-.033v-.176h.248V3.78h-.248v-.15h-.214v.15h-.203v.126h.203v.178c-.14.004-.274.014-.402.031a.228.228 0 00.018-.09c0-.116-.084-.21-.189-.21-.104 0-.189.094-.189.21 0 .056.02.108.054.146a2.814 2.814 0 00-.141.036l-.19-.415c.328-.134.718-.202 1.173-.202.46 0 .829.07 1.108.206l.082-.118c-.307-.15-.703-.224-1.19-.224-.485 0-.905.074-1.259.222zm0 .89l.038.063-.128.055.211.463c-.04.014-.081.03-.121.047l.072.122a2.946 2.946 0 011.053-.206v.054h.214v-.056c.341.006.63.052.866.137l-.024.053.148.064.025-.055.013.006.082-.117a1.823 1.823 0 00-.036-.017l.154-.338-.149-.064-.155.34a2.11 2.11 0 00-.174-.052.22.22 0 00.058-.151c0-.116-.085-.21-.19-.21-.104 0-.189.094-.189.21a.21.21 0 00.02.091 3.71 3.71 0 00-.449-.033v-.176h.248v-.126h-.248v-.15h-.214v.15h-.203v.126h.203v.177c-.14.004-.274.015-.402.032a.228.228 0 00.018-.091c0-.116-.084-.21-.189-.21-.104 0-.189.094-.189.21 0 .057.02.108.054.146a2.804 2.804 0 00-.141.037l-.19-.415c.328-.135.718-.202 1.173-.202.46 0 .829.069 1.108.205l.082-.117c-.307-.15-.703-.225-1.19-.225-.485 0-.905.074-1.259.223zm0 .89l.072.121c.33-.138.726-.208 1.187-.208.46 0 .829.07 1.108.206l.082-.118c-.307-.15-.703-.224-1.19-.224-.485 0-.905.074-1.259.222z"
          fill="#F4B300"
        />
      </g>
    </symbol>
    <symbol id="VC" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M5 0h10v15H5V0z" fill="#FFDC17" />
        <path d="M15 0h5v15h-5V0z" fill="#5FBF2B" />
        <path d="M0 0h5v15H0V0z" fill="#2E42A5" />
        <path
          d="M12.329 3.125l-1.9 2.79 1.9 2.69 1.9-2.69-1.9-2.79zm-4.656.05l-2.048 2.74 1.9 2.64 1.9-2.64-1.752-2.74zm.354 5.818l2.048-2.74 1.752 2.74-1.752 2.82-2.048-2.82z"
          fill="#5FBF2B"
        />
      </g>
    </symbol>
    <symbol id="VE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <rect width="20" height="15" rx="1.25" fill="#fff" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#FECA00" />
          <path d="M0 10v5h20v-5H0z" fill="#E31D1C" />
          <path
            d="M7.96 7.412l.615-.348.689.348-.248-.708.515-.52h-.655l-.302-.67-.258.67h-.768l.577.51h-.648l-.302-.67-.258.67H6.15l.588.521-.112.454h-.49l-.303-.67-.257.67h-.769l.588.52-.108.44H5.07l-.302-.67-.258.67h-.768l.588.52-.176.708.615-.348.689.348-.248-.708.515-.52h-.033l.14-.08.69.349-.248-.709.295-.298-.008.032.614-.348.69.348-.248-.708.511-.517.007.006-.176.708zm4.054-.027l-.614-.349-.689.349.248-.708-.515-.52h.655l.302-.67.258.67h.768l-.578.51h.652l.302-.67.257.67h.769l-.588.52.112.455h.49l.303-.67.257.67h.769l-.589.52.11.44h.214l.302-.67.258.67h.768l-.588.52.175.708-.614-.349-.689.349.248-.708-.515-.52h.033l-.14-.08-.69.348.248-.708-.295-.298.008.032-.614-.349-.69.349.248-.708-.513-.519-.008.008.175.708z"
            fill="#F7FCFF"
          />
          <path
            d="M9.896 6.584l-.615.349.176-.709-.589-.52h.769l.258-.67.302.67h.655l-.515.52.248.709-.69-.349z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="VG" width="20" height="15" fill="none">
      <g mask="url(#VG_-_Virgin_Islands_(British)__a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#2E42A5"
        />
        <g mask="url(#VG_-_Virgin_Islands_(British)__b)">
          <path fill="#2E42A5" d="M0 0h11v9H0z" />
          <g mask="url(#VG_-_Virgin_Islands_(British)__c)">
            <path
              d="M-1.253 8.125L1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M-.914 8.886l1.261.63L12.143-.583h-1.77L-.915 8.886z"
              fill="#F50100"
            />
            <path
              d="M12.503 8.125L10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z"
              fill="#F7FCFF"
            />
            <path
              d="M12.418 8.67l-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z"
              fill="#F50100"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 0H5v4H0v1h5v4h1V5h5V4H6V0z"
              fill="#F50100"
            />
            <path
              d="M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z"
              fill="#F7FCFF"
              mask="url(#VG_-_Virgin_Islands_(British)__d)"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.654 6.27v4.081s-.06 3.376 3.051 3.376c3.112 0 3.112-3.376 3.112-3.376v-4.08h-6.163z"
            fill="#3B7E05"
            stroke="#F7FCFF"
            stroke-width=".5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.648 12.43l.496-.497c.775.957 1.59 1.422 2.456 1.422.866 0 1.68-.465 2.454-1.422l.282.283.012-.018c.173.146.286.283.341.441a.527.527 0 01-.215.637 1.204 1.204 0 01-.129.073.326.326 0 01-.253.028.363.363 0 01-.233-.217c-.703.622-1.458.938-2.259.938-.794 0-1.543-.31-2.242-.922a.362.362 0 01-.236.21.326.326 0 01-.253-.032 1.214 1.214 0 01-.127-.075.527.527 0 01-.204-.64.66.66 0 01.12-.198.475.475 0 01-.01-.01z"
            fill="#FFD018"
          />
          <path
            d="M13.144 11.933l.194-.158-.175-.216-.196.197.177.177zm-.496.497l-.177-.176-.159.16.142.174.194-.158zm5.406-.497l.177-.177-.196-.197-.175.217.194.157zm.282.283l-.177.176.215.215.17-.251-.208-.14zm.012-.018l.162-.19-.213-.18-.156.23.207.14zm.341.441l.236-.082-.236.082zm-.215.637l.134.211-.134-.211zm-.129.073l-.105-.227.105.227zm-.253.028l.068-.24-.068.24zm-.233-.217l.231-.095-.133-.325-.264.233.166.187zm-4.5.016l.164-.188-.257-.225-.137.313.23.1zm-.237.21l-.064-.241.064.242zm-.253-.032l-.109.225.11-.225zm-.127-.075l-.137.21.136-.21zm-.204-.64l-.235-.086.235.086zm.12-.198l.19.161.133-.158-.13-.16-.194.157zm.309-.685l-.496.498.354.353.496-.498-.354-.353zm2.633 1.35c-.764 0-1.515-.408-2.262-1.33l-.388.314c.802.991 1.682 1.515 2.65 1.515v-.5zm2.26-1.33c-.746.922-1.496 1.33-2.26 1.33v.5c.968 0 1.847-.525 2.649-1.516l-.39-.314zm.653.263l-.282-.283-.354.354.282.282.354-.353zm-.372.02l-.012.017.414.28.012-.018-.414-.28zm.784.498c-.076-.22-.228-.391-.415-.55l-.323.382c.157.134.232.235.266.332l.472-.164zm-.317.93a.777.777 0 00.317-.93l-.472.164c.051.148-.002.274-.112.343l.267.423zm-.157.088c.05-.023.101-.053.157-.088l-.267-.423a.952.952 0 01-.101.058l.21.453zm-.427.042a.564.564 0 00.427-.042l-.211-.453a.193.193 0 01-.05.018c-.002 0-.009.002-.03-.004l-.136.481zm-.396-.362c.07.174.213.31.396.362l.136-.48a.12.12 0 01-.07-.072l-.462.19zM15.6 14.348c.873 0 1.685-.346 2.425-1l-.332-.375c-.666.59-1.364.875-2.093.875v.5zm-2.406-.984c.735.644 1.54.984 2.406.984v-.5c-.723 0-1.415-.28-2.077-.86l-.33.376zm-.008.264a.613.613 0 00.401-.351l-.458-.2c-.019.042-.048.062-.07.068l.127.483zm-.426-.05a.565.565 0 00.426.05l-.128-.483c-.021.005-.028.004-.03.004a.193.193 0 01-.05-.02l-.218.45zm-.155-.09c.054.036.105.067.155.09l.219-.449a.955.955 0 01-.1-.06l-.274.42zm-.302-.935a.777.777 0 00.302.935l.273-.418c-.108-.071-.159-.198-.105-.346l-.47-.171zm.163-.272a.91.91 0 00-.163.272l.47.171a.413.413 0 01.075-.122l-.382-.321zm-.012.307l.01.011.387-.315a.442.442 0 01-.009-.01l-.388.314z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.722 7.163l.07.025c.057-.13.066-.229 0-.292l-.002-.003c-.015-.024-.043-.067.002-.159l-.032-.065c-.065.132-.094.228-.043.292l.002.004.003.002c.03.027.042.1 0 .196zm0 .946l.07.025c.057-.13.066-.229 0-.292l-.002-.003c-.015-.024-.043-.067.002-.159l-.032-.065c-.065.132-.094.228-.043.292l.002.004.003.002c.03.027.042.1 0 .196zm.07.87l-.07-.026c.042-.095.03-.169 0-.195l-.003-.003-.002-.003c-.05-.065-.022-.16.043-.293l.032.066c-.045.091-.017.134-.002.158l.002.003c.066.064.057.163 0 .293zm.416.988l.07.025c.056-.13.066-.229 0-.292l-.003-.003c-.015-.024-.042-.067.002-.159l-.031-.065c-.065.132-.094.228-.044.292l.003.004.003.002c.03.027.041.1 0 .196zm-.507.836l-.07-.026c.042-.095.03-.168 0-.195l-.003-.003-.002-.003c-.05-.064-.022-.16.043-.292l.032.065c-.045.092-.017.134-.002.159l.002.003c.066.063.057.162 0 .292zm-.07.92l.07.026c.057-.13.066-.229 0-.293l-.002-.002c-.015-.025-.043-.067.002-.159l-.032-.065c-.065.132-.094.228-.043.292l.002.003.003.003c.03.027.042.1 0 .195zm3.073.026l-.069-.026c.042-.095.03-.168 0-.195l-.003-.003-.003-.003c-.05-.064-.021-.16.044-.292l.032.065c-.045.092-.018.134-.002.159l.002.002c.066.064.056.163 0 .293zm-.069-.938l.07.026c.056-.13.066-.23 0-.293l-.002-.003c-.016-.024-.043-.067.002-.158l-.032-.065c-.065.132-.094.228-.044.292l.003.003.003.003c.03.026.042.1 0 .195zm.07-.886l-.07-.026c.042-.095.03-.169 0-.195l-.003-.003-.003-.003c-.05-.065-.021-.16.044-.293l.032.066c-.045.091-.018.134-.002.158l.002.003c.066.064.056.163 0 .293zm-.1-.904l.07.025c.056-.13.065-.229 0-.292l-.003-.003c-.015-.024-.043-.067.002-.159l-.032-.065c-.064.132-.094.228-.043.292l.003.004.003.002c.029.027.041.1 0 .196zm.07-.92l-.07-.026c.041-.095.029-.17 0-.195l-.003-.003-.003-.003c-.05-.065-.021-.16.043-.293l.032.065c-.044.092-.017.135-.002.159l.002.003c.066.063.057.162 0 .292zm-.07-.905l.07.026c.056-.13.065-.229 0-.293l-.003-.003c-.015-.024-.043-.066.002-.158l-.032-.065c-.064.132-.094.228-.043.292l.003.003.003.003c.029.027.041.1 0 .195z"
            fill="#F50100"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.225 6.76a.072.072 0 00.008-.034c0-.037-.028-.067-.063-.067-.034 0-.062.03-.062.067 0 .016.005.031.014.043l-.237.366.025.02.236-.366a.058.058 0 00.058-.005l.248.37.025-.02-.252-.375zm-.008.316a.07.07 0 00.016-.046c0-.037-.028-.067-.063-.067-.034 0-.062.03-.062.067 0 .023.01.043.026.055l-.059.072h-.401s.044.1.18.127c.042.04.15.114.15.114l-.062.074h.433v-.074c.106-.001.145-.084.16-.114.005-.012.007-.016.007 0 0 .053.077 0 .077 0s.127-.127.127-.248c0-.122-.267.12-.267.12h-.181l-.081-.08zm-.543 1.027h.401l.06-.072a.07.07 0 01-.027-.055c0-.037.028-.067.063-.067.034 0 .062.03.062.067a.07.07 0 01-.016.046l.08.08h.182s.267-.242.267-.12c0 .12-.127.248-.127.248s-.077.053-.077 0c0-.016-.002-.012-.008 0-.014.03-.053.113-.159.114v.074h-.433l.061-.074s-.107-.074-.149-.114c-.136-.027-.18-.127-.18-.127zm.551-.398a.072.072 0 00.008-.033c0-.037-.028-.067-.063-.067-.034 0-.062.03-.062.067 0 .016.005.031.014.043l-.237.366.025.02.236-.366a.058.058 0 00.058-.005l.248.37.025-.02-.252-.375zm-.551 1.242h.401l.06-.071a.07.07 0 01-.027-.055c0-.037.028-.068.063-.068.034 0 .062.03.062.068a.07.07 0 01-.016.046l.08.08h.182s.267-.242.267-.12c0 .12-.127.248-.127.248s-.077.053-.077 0c0-.016-.002-.013-.008 0-.014.03-.053.112-.159.113v.074h-.433l.061-.074s-.107-.074-.149-.113a.248.248 0 01-.18-.128zm.551-.397a.072.072 0 00.008-.033c0-.037-.028-.068-.063-.068-.034 0-.062.03-.062.068 0 .016.005.03.014.042l-.237.367.025.02.236-.367a.058.058 0 00.058-.005l.248.371.025-.02-.252-.375zm-.066 1.41h.402l.059-.07a.07.07 0 01-.027-.056c0-.037.028-.067.063-.067.034 0 .062.03.062.067a.07.07 0 01-.016.046l.081.08h.182s.267-.242.267-.12c0 .12-.128.248-.128.248s-.077.053-.077 0c0-.015-.001-.012-.007 0-.014.03-.054.113-.16.114v.074h-.432l.06-.074s-.106-.074-.148-.114c-.137-.026-.181-.127-.181-.127zm.552-.397a.072.072 0 00.007-.033c0-.037-.027-.067-.062-.067s-.063.03-.063.067c0 .016.006.031.014.043l-.236.366.024.02.237-.366a.058.058 0 00.057-.005l.249.371.024-.02-.251-.376zm-1.128 1.209h.401l.06-.072a.07.07 0 01-.027-.055c0-.037.028-.067.063-.067.034 0 .062.03.062.067a.07.07 0 01-.016.046l.08.08h.182s.267-.242.267-.12c0 .12-.127.248-.127.248s-.077.053-.077 0c0-.016-.002-.012-.008 0-.014.03-.053.113-.159.114v.074h-.433l.061-.075s-.107-.073-.149-.113a.248.248 0 01-.18-.127zm.551-.398a.072.072 0 00.008-.033c0-.037-.028-.067-.063-.067-.034 0-.062.03-.062.067 0 .016.005.031.014.043l-.237.366.025.02.236-.367a.058.058 0 00.058-.005l.248.372.025-.02-.252-.376zm-.551 1.344h.401l.06-.072a.07.07 0 01-.027-.055c0-.037.028-.067.063-.067.034 0 .062.03.062.067a.07.07 0 01-.016.046l.08.08h.182s.267-.242.267-.12c0 .12-.127.248-.127.248s-.077.053-.077 0c0-.016-.002-.013-.008 0-.014.03-.053.113-.159.114v.074h-.433l.061-.074s-.107-.075-.149-.114c-.136-.027-.18-.127-.18-.127zm.551-.398a.072.072 0 00.008-.033c0-.037-.028-.067-.063-.067-.034 0-.062.03-.062.067 0 .016.005.031.014.043l-.237.366.025.02.236-.366a.06.06 0 00.058-.006l.248.372.025-.02-.252-.376zm2.452.398h.402l.059-.072a.07.07 0 01-.026-.055c0-.037.028-.067.062-.067.035 0 .063.03.063.067a.07.07 0 01-.017.046l.081.08h.182s.267-.242.267-.12c0 .12-.128.248-.128.248s-.077.053-.077 0c0-.016-.001-.013-.007 0-.014.03-.054.113-.16.114v.074h-.432l.06-.074s-.106-.075-.148-.114c-.137-.027-.18-.127-.18-.127zm.552-.398a.07.07 0 00.008-.033c0-.037-.028-.067-.063-.067-.034 0-.062.03-.062.067 0 .016.005.031.014.043l-.237.366.025.02.236-.366a.059.059 0 00.057-.005l.249.37.024-.02-.251-.375zm-.552-.515h.402l.059-.07a.069.069 0 01-.026-.056c0-.037.028-.068.062-.068.035 0 .063.03.063.068a.07.07 0 01-.017.046l.081.08h.182s.267-.242.267-.12c0 .12-.128.248-.128.248s-.077.053-.077 0c0-.016-.001-.013-.007 0-.014.03-.054.113-.16.113v.074h-.432l.06-.074s-.106-.074-.148-.113a.248.248 0 01-.18-.128zm.552-.397a.071.071 0 00.008-.033c0-.037-.028-.068-.063-.068-.034 0-.062.03-.062.068 0 .016.005.03.014.042l-.237.367.025.02.236-.367a.058.058 0 00.057-.005l.249.372.024-.02-.251-.376zm-.552-.515h.402l.059-.071a.07.07 0 01-.026-.055c0-.037.028-.068.062-.068.035 0 .063.03.063.068a.07.07 0 01-.017.045l.081.081h.182s.267-.242.267-.121-.128.248-.128.248-.077.054-.077 0c0-.015-.001-.012-.007 0-.014.03-.054.113-.16.114v.074h-.432l.06-.074s-.106-.074-.148-.114a.243.243 0 01-.18-.127zm.552-.397a.07.07 0 00.008-.033c0-.038-.028-.068-.063-.068-.034 0-.062.03-.062.068 0 .016.005.03.014.042l-.237.366.025.02.236-.366a.059.059 0 00.057-.005l.249.371.024-.02-.251-.375zm-.582-.481h.401l.06-.071a.07.07 0 01-.027-.056c0-.037.028-.067.063-.067.034 0 .062.03.062.067a.07.07 0 01-.016.046l.081.08h.181s.268-.242.268-.12c0 .12-.128.248-.128.248s-.077.053-.077 0c0-.015-.002-.012-.007 0-.015.03-.054.113-.16.114v.074h-.433l.061-.074s-.106-.074-.148-.114a.248.248 0 01-.181-.127zm.551-.398a.072.072 0 00.008-.033c0-.037-.028-.067-.062-.067-.035 0-.063.03-.063.067 0 .017.006.031.014.043l-.236.366.024.02.237-.366a.058.058 0 00.057-.005l.249.371.024-.02-.252-.376zm-.551-.548h.401l.06-.071a.07.07 0 01-.027-.055c0-.038.028-.068.063-.068.034 0 .062.03.062.068a.07.07 0 01-.016.045l.081.08h.181s.268-.242.268-.12c0 .12-.128.248-.128.248s-.077.053-.077 0c0-.015-.002-.012-.007 0-.015.03-.054.113-.16.114v.074h-.433l.061-.074s-.106-.074-.148-.114a.248.248 0 01-.181-.127zm.551-.398a.072.072 0 00.008-.033c0-.037-.028-.067-.062-.067-.035 0-.063.03-.063.067 0 .017.006.031.014.043l-.236.366.024.02.237-.366a.058.058 0 00.057-.005l.249.371.024-.02-.252-.376z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4 7.866l-.21.683s-.352.456-.417.68c-.066.223-.101.371-.083.371a.232.232 0 00.161-.218c0-.154.549-.649.549-.649l.164-.867H15.4z"
            fill="#FFC6B5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.107 6.793a.072.072 0 00.008-.033c0-.037-.028-.067-.062-.067-.035 0-.063.03-.063.067 0 .016.006.031.014.043l-.236.366.024.02.237-.367a.058.058 0 00.057-.005l.249.372.024-.02-.252-.376zm-.008.317a.07.07 0 00.016-.046c0-.037-.028-.067-.062-.067-.035 0-.063.03-.063.067 0 .023.01.043.027.055l-.06.072h-.401s.044.1.18.127c.043.04.15.113.15.113l-.061.075h.432V7.43c.106 0 .145-.084.16-.113.005-.013.007-.016.007 0 0 .053.077 0 .077 0s.128-.127.128-.249c0-.12-.268.122-.268.122h-.18l-.082-.081z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.913 7.592c.005.013.01.022.01.036 0 .039-.167.097-.288.097-.12 0-.073-.097 0-.151.074-.054-.005-.147-.073-.147-.064 0-.064-.09-.063-.163V6.97c0-.114.03-.1.09-.075a.318.318 0 00.131.034c.09 0 .095.02.108.077.009.034.02.08.055.144.057.1.045.124.027.16a.228.228 0 00-.027.117c0 .104.018.14.03.165zm.148.726l.036-.385s-.036-.14.047-.14c.084 0 .212.672.259.942.03.172.003.204-.077.296a1.7 1.7 0 00-.182.25c-.127.21-.118.333-.112.427.004.063.007.112-.031.166-.09.125-.126.007-.162-.109a1.745 1.745 0 00-.008-.025c-.034-.108.122-.435.227-.657l.039-.081c.1-.214.09-.289.047-.379a1.74 1.74 0 01-.083-.305z"
            fill="#FFC6B5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.262 12.106a.172.172 0 01-.167.177c-.092 0-.167-.08-.167-.177 0-.098.075-.177.167-.177.092 0 .167.08.167.177zm-.887.05c-.075.062-.166.076-.204.032-.038-.045-.008-.133.067-.196.075-.062.166-.077.204-.032.038.045.008.132-.067.195z"
            fill="#FFD018"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.594 6.74s-.173.036-.115.123c.058.086-.076.064.115.075.192.011.244.081.218.132-.026.052-.047.18 0 .256.046.077.061.21.144.144.082-.067.24-.159.192-.28-.049-.12.02-.26-.086-.327-.106-.068-.13-.027-.19-.123-.061-.095-.15-.122-.214-.06l-.064.06z"
            fill="#A95601"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.56 7.611s-.349.42-.292.568c.057.148.143.156.1.366-.043.21.026.536-.1.95-.125.413-.208 1.384-.167 1.384.042 0 .099.536.05.777-.05.24-.394.441-.05.441.344 0 .385.048.523 0 .137-.047.333.138.333 0 0-.137.014-.165.12-.165h.192c.093 0 .214.087.214-.118s.023-.646-.096-.988c-.118-.342-.078-.124-.194-.581-.07-.27-.123-.378-.164-.473-.03-.065-.112.05-.131-.053-.007-.034.05-.237.05-.263.004-.163.128-.19.128-.47 0-.324-.077-.68 0-.858.078-.178.269-.071.193-.245-.076-.173-.101-.272-.244-.272h-.465z"
            fill="#F7FCFF"
          />
          <path
            d="M13.117 12.59l.058-.077c.835.778 1.607 1.165 2.316 1.165.709 0 1.572-.41 2.588-1.236l.054.082c-1.03.837-1.91 1.256-2.642 1.256-.733 0-1.524-.397-2.374-1.19z"
            fill="#272727"
          />
        </g>
      </g>
    </symbol>
    <symbol id="VI" width="20" height="15" fill="none">
      <g
        mask="url(#VI_-_Virgin_Islands_(U_S_)__a)"
        fill-rule="evenodd"
        clip-rule="evenodd"
      >
        <path d="M0 0v15h20V0H0z" fill="#F7FCFF" />
        <g mask="url(#VI_-_Virgin_Islands_(U_S_)__b)">
          <path
            d="M11.002 5.134c.15.086.241.307.241.307H8.69l.176-.307s-.176-.08-.088-.08c.089 0 .342-.355.342-.355h-.106s-.054-.088.106-.088.288-.572.288-.572.105-.267-.152-.335c-.257-.067-.566.224-.566.224s.075-.466.176-.567c.047-.046.134-.054.215-.06.092-.009.175-.016.175-.081 0-.123.3-.218.792-.218.492 0 .67.587.67.702 0 .116.168.729.168.729s-.168 0-.168.079.526.42.526.42-.393.116-.241.202zm-9.266-2.09c.196-.085 2.188.509 3.68.954.858.255 1.551.462 1.642.462.25 0 .718.603.483.857-.234.254-.313.402-.156.402.156 0 .947-.205.947-.205V7.87s-.758.18-.947 0c-.092-.087-.232-.092-.352-.097-.128-.004-.234-.008-.234-.11 0-.195-.436-.226-.436-.226s-.404-.134-.404-.259-.265-.48-.265-.48-1.008-.57-1.865-1.197a27.274 27.274 0 00-.508-.36c-.647-.45-1.18-.822-1.276-1.253-.448-.443-.618-.713-.31-.846zM8.027 8.02s-.339.234-.714.86c-.185.308-.2.58-.21.776-.012.202-.019.325-.204.325-.215 0-.372.046-.5.084a.845.845 0 01-.23.049c-.172 0-.5.646-.336.796.164.15.854.388.854 0s.185-.609.522-.609.939-.223.939-.712c0-.49.656-.455.656-.455L8.027 8.02zm6.699-4.022c1.492-.445 3.484-1.039 3.68-.955.309.133.139.403-.309.846-.096.431-.629.803-1.276 1.253-.164.115-.335.234-.508.36-.857.627-1.865 1.197-1.865 1.197s-.265.355-.265.48-.404.259-.404.259-.437.03-.437.227c0 .1-.105.105-.233.11-.12.004-.26.01-.352.096-.19.18-.947 0-.947 0V5.514s.79.205.947.205c.157 0 .078-.148-.156-.402-.235-.254.234-.857.483-.857.09 0 .784-.207 1.642-.462zM12.114 8.02s.34.234.715.86c.185.308.2.58.21.776.012.202.018.325.203.325.216 0 .373.046.5.084a.82.82 0 00.231.049c.171 0 .5.646.336.796-.165.15-.854.388-.854 0s-.185-.609-.522-.609-.939-.223-.939-.712c0-.49-.656-.455-.656-.455l.777-1.114zm-3.65 1.63c0-.215.38-.378.38-.378l1.147-.484.014.291.015-.29 1.147.483s.38.163.38.378c0 .108.163.3.324.49s.322.38.322.486c0 .188-.435.61-.698.866l-.096.094c-.06.06-.125.134-.193.21-.193.22-.407.462-.586.462-.126 0-.228.088-.326.172-.09.077-.176.151-.274.151a.02.02 0 01-.015-.007.02.02 0 01-.014.007c-.098 0-.184-.074-.274-.151-.098-.084-.2-.172-.326-.172-.18 0-.393-.243-.586-.462-.068-.076-.133-.15-.193-.21l-.096-.094c-.263-.255-.698-.678-.698-.866 0-.107.16-.296.321-.486.162-.19.324-.382.324-.49z"
            fill="#E8AA00"
          />
          <path
            d="M4.381 6.67c.025.29.108.46.108.46s.144.228.226.23c.043.105.088.213.138.322.225.6.532 1.389.846 2.107a.504.504 0 00-.09-.05c-.262-.124-.45-.138-.45-.138s-.353.015-.317.115c.036.1.473.317.65.253l.06-.021c.082-.028.157-.054.178-.088l.126.28a1.432 1.432 0 00-.45-.137s-.353.015-.317.115c.037.1.473.317.65.252l.06-.02c.05-.018.096-.034.13-.051.317.675.623 1.214.841 1.35h.44s-.38-.538-.86-1.29c.145-.103.346-.33.346-.472v-.063c.004-.167.006-.308-.176-.126-.206.205-.284.377-.284.377s-.01.03-.02.072a35.34 35.34 0 01-.116-.188c.144-.101.35-.33.35-.474v-.063c.003-.166.005-.308-.178-.126a1.434 1.434 0 00-.283.378s-.01.03-.02.072a30.54 30.54 0 01-.167-.278c.142-.074.4-.344.4-.505V8.9c.004-.166.006-.308-.177-.126a1.434 1.434 0 00-.283.378s-.023.073-.037.152a25.033 25.033 0 01-.217-.379h.007c.106 0 .46-.335.46-.524v-.063c.003-.167.006-.308-.177-.126a1.434 1.434 0 00-.283.378s-.052.165-.047.264a19.183 19.183 0 01-.285-.53h.003c.106 0 .46-.337.46-.526v-.063c.003-.166.005-.308-.177-.125-.206.205-.283.377-.283.377s-.047.149-.048.249a12.783 12.783 0 01-.265-.554 60.68 60.68 0 01-.121-.324.04.04 0 00.014-.011c.069-.082.038-.569-.106-.69a3.747 3.747 0 01-.048-.041c-.126-.11-.233-.202-.21.055zm.49.74s.013-.188.136-.451c.11-.234.156-.1.21.057l.02.06c.065.177-.152.614-.252.65-.1.037-.115-.315-.115-.315zm.492 1.806c-.263-.123-.452-.137-.452-.137s-.352.015-.316.115c.036.1.473.317.65.253l.06-.021c.158-.055.291-.1.058-.21zm-.699-.7s.189.015.452.138c.233.109.1.155-.058.21l-.06.02c-.177.065-.614-.152-.65-.252-.036-.1.316-.115.316-.115zm.246-.424c-.263-.123-.452-.137-.452-.137s-.352.015-.316.115c.036.1.473.317.65.252l.06-.02c.158-.055.291-.101.058-.21zm-.55-.814s.172.078.377.283c.182.183.04.18-.126.178l-.063-.001c-.189 0-.525-.354-.525-.46 0-.106.336 0 .336 0z"
            fill="#46A000"
          />
          <path
            d="M17.932 6.462h-1.335s.283 0 .314.273c0 0 .006 2.309 0 2.49-.007.182-.315.243-.315.243s1.621.005 1.336 0c-.284-.005-.347-.243-.347-.243v-2.49c0-.21.347-.273.347-.273zM2.853 9.283c-.15-.39-1.084-2.78-1.084-2.78h.924c-.16 0-.22.204-.22.204l.647 1.846s.626-1.507.626-1.774c0-.268-.263-.276-.263-.276h1.205l-.291.097s-.964 2.21-.964 2.683c-.046.105.444.175.444.175H2.583l.27-.175zm11.064-.873l.716-1.319.02 1.468-.221-.072-.157.98.791-1.518-.263-.1.98-1.06-.334 1.434-.19-.168-1.123 2.096 1.254-1.436-.242-.121 1.238-.81-.539 1.32-.3-.216-1.272 1.6-.528-.202.528-1.876h-.358zm-.414 2.502h-.396v.302h-.311l-.883 1.024h.487l.17.576.226-.203v.203l.442-.203.423.366.316-1.408-.213-.156.11-.095-.11-.405h-.26z"
            fill="#0093E1"
          />
          <path
            d="M7.715 5.008s.581.402 1.163.402c.582 0 1.163-.402 1.163-.402s.582.402 1.163.402c.582 0 1.164-.402 1.164-.402v1.813c0 1.875-2.327 3.328-2.327 3.328s-2.439-1.334-2.326-3.35v-1.79z"
            fill="#F7FCFF"
          />
          <g mask="url(#VI_-_Virgin_Islands_(U_S_)__c)">
            <path
              d="M7.55 4.888h4.9v1.887h-4.9V4.888z"
              fill="#2E42A5"
            />
            <path
              d="M8.497 6.775h-.412v3.815h.412V6.775zm.7 0h-.412v3.815h.412V6.775zm.288 0h.412v3.815h-.412V6.775zm1.112 0h-.412v3.815h.412V6.775zm.288 0h.412v3.815h-.412V6.775zm1.112 0h-.412v3.815h.412V6.775z"
              fill="#AF0100"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="VN" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#E31D1C"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.039 9.987l-3.22 2.047L7.9 8.451l-2.296-2.34 3.166-.07 1.4-3.537 1.277 3.584 3.158.055-2.373 2.384 1.108 3.409-3.3-1.949z"
            fill="#FFD221"
          />
        </g>
      </g>
    </symbol>
    <symbol id="VU" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v5h20V0H0z"
          fill="#C51918"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10v5h20v-5H0z"
          fill="#5EAA22"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0-1.25L10.418 7.5 0 16.25v-17.5z"
          fill="#272727"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="-2"
          y="-5.097"
          width="24"
          height="25"
          fill="#000"
        >
          <path fill="#fff" d="M-2-5.097h24v25H-2z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0-2.097L10.88 6.25H20v2.5h-9.27L0 16.757v-2.794L8.75 7.5 0 .959v-3.056z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0-2.097L10.88 6.25H20v2.5h-9.27L0 16.757v-2.794L8.75 7.5 0 .959v-3.056z"
          fill="#FFD018"
        />
        <path
          d="M10.88 6.25l-.76.992.336.258h.424V6.25zM0-2.097l.76-.992-2.01-1.542v2.534H0zM20 6.25h1.25V5H20v1.25zm0 2.5V10h1.25V8.75H20zm-9.27 0V7.5h-.414l-.333.248.748 1.002zM0 16.757h-1.25v2.492l1.998-1.49L0 16.757zm0-2.794l-.743-1.006-.507.375v.63H0zM8.75 7.5l.743 1.005 1.353-.999-1.348-1.007L8.75 7.5zM0 .959h-1.25v.626l.502.375.748-1zm11.641 4.3L.761-3.09-.761-1.105l10.88 8.347 1.522-1.984zM20 5h-9.12v2.5H20V5zm1.25 3.75v-2.5h-2.5v2.5h2.5zM10.73 10H20V7.5h-9.27V10zM.749 17.759l10.73-8.007-1.495-2.004-10.73 8.007L.747 17.76zm-1.998-3.796v2.794h2.5v-2.794h-2.5zm9.257-7.468l-8.75 6.462 1.486 2.011 8.75-6.463-1.486-2.01zM-.748 1.96l8.75 6.541L9.498 6.5.748-.042-.748 1.96zm-.502-4.057V.96h2.5v-3.056h-2.5z"
          fill="#272727"
          mask="url(#b)"
        />
        <path
          d="M3.046 10.48l.001-.988c.88-.194 1.464-.446 1.747-.75.7-.862.235-2.88-1.201-2.866-.711 0-1.447.339-1.447 1.136 0 .991.204 1.415.901 1.415.693 0 .948.037 1.404-.585l.496.153c-.49.667-1.15 1.193-1.9 1.193-1.24 0-1.913-.933-1.913-2.013 0-1.334 1.082-2.267 2.387-2.267.974 0 2.514 1.192 2.514 2.267 0 1.074 0 1.567-.845 2.317-.34.303-1.183.842-2.144.988z"
          fill="#FFD018"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.12 6.175a.09.09 0 00-.11.063l-.034.13-.005-.007a.09.09 0 00-.141.11l.061.079-.103.095a.09.09 0 10.121.13L3 6.693c.055.07.107.14.156.205l-.17.092a.09.09 0 10.084.157l.195-.105.133.179-.234.126a.09.09 0 00.084.157l.257-.138c.069.094.129.177.18.25l-.164.088a.09.09 0 10.084.157l.182-.097c.076.112.115.18.115.198a.09.09 0 10.178 0c0-.046-.047-.14-.145-.293a.088.088 0 00.004-.008l.132-.29a.09.09 0 00-.163-.074l-.09.198a13.703 13.703 0 00-.198-.276l.094-.206a.09.09 0 10-.163-.073l-.052.115a32.747 32.747 0 00-.09-.12l.126-.279a.09.09 0 10-.162-.074l-.087.19a57.997 57.997 0 00-.172-.225l.07-.262a.09.09 0 00-.064-.11z"
          fill="#FFD018"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.72 6.175a.09.09 0 01.11.063l.033.13.006-.007a.09.09 0 01.14.11l-.06.079.103.095a.09.09 0 11-.122.13l-.09-.083c-.055.07-.107.14-.157.205l.172.092a.09.09 0 11-.085.157l-.195-.105-.134.179.235.126a.09.09 0 01-.084.157l-.258-.138-.18.25.165.088a.09.09 0 01-.085.157l-.181-.097c-.076.112-.115.18-.115.198a.09.09 0 11-.178 0c0-.046.047-.14.145-.293A.091.091 0 012.9 7.66l-.132-.29a.09.09 0 01.162-.074l.09.198.198-.276-.093-.206a.09.09 0 11.162-.073l.053.115.09-.12-.127-.279a.09.09 0 01.163-.074l.087.19.172-.225-.07-.262a.09.09 0 01.064-.11z"
          fill="#FFD018"
        />
      </g>
    </symbol>
    <symbol id="WF" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)" fill-rule="evenodd" clip-rule="evenodd">
        <path d="M13.75 0H20v15h-6.25V0z" fill="#C51918" />
        <path d="M0 0h7.5v15H0V0z" fill="#2E42A5" />
        <path d="M6.25 0h7.5v15h-7.5V0z" fill="#F7FCFF" />
      </g>
    </symbol>
    <symbol id="WS" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#C51918"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v8.75h10V0H0z" fill="#2E42A5" />
          <path
            d="M2.229 4.857l-.663.4.151-.78-.552-.584.747-.032.317-.729.316.73h.745l-.55.615.166.78-.677-.4zm5 0l-.663.4.151-.78-.552-.584.747-.032.317-.729.316.73h.745l-.55.615.166.78-.677-.4zM4.666 2.586l-.624.377.143-.735-.52-.55.704-.03.297-.685.297.686h.702l-.518.58.156.734-.637-.377zm.675 2.68l-.39.235.09-.46-.325-.343.44-.018.185-.429.186.429h.439l-.324.362.098.459-.399-.235zM4.63 8.018l-.935.564.213-1.102-.778-.824 1.054-.045.446-1.029.447 1.03H6.13l-.778.868.234 1.102-.956-.564z"
            fill="#FEFFFF"
          />
        </g>
      </g>
    </symbol>
    <symbol id="YE" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M0 0v5h20V0H0z" fill="#E31D1C" />
          <path d="M0 10v5h20v-5H0z" fill="#272727" />
        </g>
      </g>
    </symbol>
    <symbol id="YT" width="20" height="15" fill="none">
      <path fill="#fff" d="M0 0h20v15H0z" />
      <path
        d="M6.931 13.268c-.416.126-1.015.384-1.255.528-.078.05-.07.107.05.321.084.138.169.258.183.258.02 0 .254-.094.515-.214.26-.113.594-.262.747-.29.117-.02.225-.039.29-.064.027.058.011.026.06.117.07.13.026.127.147.163.127.037.441-.114.441-.114.367-.114.572-.126 1.89-.126 1.32 0 1.524.012 1.891.132 0 0 .295.09.333.1.038.01.058.02.098.01.036-.007.074-.056.09-.086 0 0 .082-.174.103-.235.07.03.198.07.322.104.148.044.48.176.74.29.261.119.494.213.515.213.014 0 .099-.12.184-.258.169-.296.183-.27-.43-.553-.819-.378-1.637-.547-1.715-.365-.014.034-.026.055-.045.1-.082-.017-.297-.062-.512-.094-.663-.107-2.483-.107-3.146 0-.215.032-.36.084-.482.114-.07-.123-.055-.074-.069-.108-.056-.126-.43-.106-.945.057z"
        fill="#DFDFDF"
      />
      <path
        d="M7.53 5.496c-.013.205.03.35.14.46.05.052.093.114.093.114s-.057.063-.104.11a.547.547 0 00-.157.403c0 .155.045.262.166.402 0 0 .102.052.1.115-.003.064-.11.128-.11.128-.217.255-.21.547.017.79l.098.107h4.46l.109-.122c.21-.238.21-.495.002-.768 0 0-.105-.075-.107-.137-.001-.063.1-.125.1-.125.218-.275.213-.528-.012-.793-.102-.117-.104-.14-.024-.194.13-.093.211-.405.152-.595-.088-.285-.464-.475-.694-.35a1.533 1.533 0 00-.192.137.586.586 0 01-.135.098.636.636 0 01-.126-.1c-.23-.208-.506-.233-.736.002 0 0-.032.126-.08.13-.049.004-.117-.112-.117-.112-.234-.233-.528-.223-.767.022 0 0-.034.103-.088.09-.054-.012-.098-.132-.098-.132-.14-.135-.229-.133-.39-.135-.092-.002-.26.02-.362.097-.101.075-.083.166-.107.16-.058-.015-.123-.11-.123-.11-.227-.205-.41-.24-.63-.117a.499.499 0 00-.277.425z"
        fill="#171796"
      />
      <path
        d="M7.678 9.057s.09.045.088.101c-.003.057-.1.113-.1.113a.932.932 0 00-.133.195.57.57 0 00.13.588c.09.09.093.128.008.236a.972.972 0 00-.1.148.55.55 0 00.481.787.478.478 0 00.382-.17c.085-.093.13-.096.206-.012.111.128.258.207.381.207.145 0 .235-.047.382-.192 0 0 .058-.114.111-.114.053.001.102.116.102.116.22.246.443.253.74.02 0 0 .065-.095.12-.094.056.002.104.099.104.099.13.118.228.164.356.164.128 0 .223-.051.372-.204 0 0 .077-.115.123-.123.046-.007.095.089.095.089.182.17.282.224.415.224.137 0 .234-.047.371-.175.129-.12.197-.26.18-.376a1 1 0 00-.206-.433s-.08-.007-.068-.07c.012-.061.106-.125.106-.125.233-.283.235-.502.005-.782 0 0-.096-.055-.095-.118.002-.063.1-.126.1-.126.223-.273.22-.526-.005-.775l-.12-.13-2.218.002-2.218.003-.1.116c-.232.268-.23.54.005.811z"
        fill="#D42E12"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.138 8.514c.107 0 .197.073.215.17l.004.036v.385l.46-.245a.21.21 0 01.283.085.205.205 0 01-.054.26l-.032.02-.385.204.385.205.032.02c.077.061.102.17.054.26a.21.21 0 01-.284.084l-.46-.244v.428a.213.213 0 01-.218.207.216.216 0 01-.215-.17l-.004-.037v-.376l-.361.192a.21.21 0 01-.284-.084.205.205 0 01.054-.26l.032-.02.385-.205-.385-.204-.032-.02a.205.205 0 01-.054-.26.21.21 0 01.284-.085l.361.192V8.72c0-.114.098-.206.219-.206zm-2.125 0c.108 0 .197.073.216.17l.003.036v.385l.46-.245a.21.21 0 01.283.085.205.205 0 01-.054.26l-.031.02-.386.204.386.205.031.02c.078.061.103.17.054.26a.21.21 0 01-.283.084l-.46-.244v.428a.213.213 0 01-.219.207.216.216 0 01-.215-.17l-.003-.037v-.376l-.362.192a.21.21 0 01-.283-.084.205.205 0 01.054-.26l.031-.02.386-.205-.386-.204-.031-.02a.205.205 0 01-.054-.26.21.21 0 01.283-.085l.362.192V8.72c0-.114.098-.206.218-.206z"
        fill="#E9D315"
      />
      <path
        d="M6.677 4.375v3.66h.2v.09c-.114-.004-.198-.088-.2-.09h0v1.428c.002.758.003 1.614.005 2.006a.353.353 0 00.09.262.57.57 0 00.078.07c.012.009.02.016.03.022l.034.026.124-.156-.124.156c.075.06.19.1.302.128.121.031.272.058.443.079.34.04.77.055 1.228.02a.902.902 0 01.388.08.73.73 0 01.222.17c.032.033.06.068.09.104l.003.004c.027.034.06.073.092.107a.45.45 0 00.33.159c.156 0 .26-.088.328-.161a1.75 1.75 0 00.092-.112h0l.002-.002c.028-.037.054-.07.083-.104a.68.68 0 01.207-.167.82.82 0 01.372-.079 12.1 12.1 0 001.285-.036 3.16 3.16 0 00.425-.063.713.713 0 00.295-.124l.004-.004a.742.742 0 00.068-.063.529.529 0 00.123-.187.57.57 0 00.027-.244V4.175H6.677v.2z"
        stroke="#000"
        stroke-width=".4"
      />
      <path
        d="M9.293 6.166c-.168.312-.175.453-.035.703a.862.862 0 00.41.392c.457.207 1.04.054 1.27-.33.141-.236.125-.63-.031-.803l-.043-.046-.04.136c-.057.194-.113.293-.227.397-.212.194-.505.238-.808.118-.234-.094-.328-.225-.416-.587l-.021-.09-.06.11z"
        fill="#fff"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.13 2c0 .577-.356 1-.857 1-.5 0-.854-.423-.854-1 0-.58.353-1 .854-1s.858.42.858 1zm-6.83.968V1.621l.51 1.347h.223l.499-1.347v1.347h.301V1.032h-.35L4.924 2.52l-.565-1.49H4v1.937h.299zm2.116 0l.19-.536h.71l.19.536h.32l-.713-1.936h-.301l-.713 1.936h.317zm.29-.82h.507l-.254-.716-.253.716zm2.01.82v-.772l.674-1.164h-.332l-.49.867-.492-.867h-.34l.67 1.164v.772h.31zm1.558-.261c-.326 0-.537-.297-.537-.707s.211-.707.537-.707c.326 0 .54.297.54.707s-.214.707-.54.707zm1.878-1.385v1.646h-.314V1.322h-.616v-.29h1.546v.29h-.616zm1.727 1.646V1.322h.616v-.29h-1.546v.29h.616v1.646h.314zM16 2.675v.293h-1.21V1.032H16v.29h-.903v.51h.819v.288h-.819v.555H16z"
        fill="#FF2500"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.11 11.75s-.212-.418.325-.625c.538-.207.8.063 1.037.313.237.25.21 1.005.21 1.005l-.584.936-1.795.371-.715-.371-.838-1.629.063-1.6s.084-.612.084-.738c0-.127.39-1.11.39-1.11l.369-.365 1.043-.555.491-.246.61-.77-.068-.614-.695.885h-.588l-.613.257-.248.233-.301.01-.118-.243.329-.529.497-.5-.229-.423.339-.154-.065-.234.375.234.284-.234.054-.214-.648-.348s.634-.266.932-.238c.299.028.58.38.58.38l.855-.142s-.229.562-.155.562h.538l-.172.698h.662l-.49.537.382.21-.58.395.58.39-.54.356.304.588.48-.291.269.365-.405.9-.662.47-.63.158-.618.16-.245.16-.153-.615-1.042.715-.541 1.121.159 1.019.382.521.704.252.918-.172.48-.585.115-.597s-.278-.404-.48-.37c-.201.033-.622.311-.622.311z"
        fill="#DFDFDF"
        stroke="#000"
        stroke-width=".3"
      />
      <path
        d="M15.054 7.762s1.112.103 1.409-.133m-2.245.854s1.111.104 1.408-.132m-1.596.795s.6.1.66-.108"
        stroke="#000"
        stroke-width=".2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.469 5.938a.156.156 0 110-.313.156.156 0 010 .313z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.89 11.75s.212-.418-.325-.625c-.538-.207-.8.063-1.037.313-.237.25-.21 1.005-.21 1.005l.584.936 1.795.371.715-.371.838-1.629-.063-1.6s-.084-.612-.084-.738c0-.127-.39-1.11-.39-1.11l-.369-.365-1.043-.555-.491-.246-.61-.77.068-.614.695.885h.588l.613.257.248.233.301.01.118-.243-.329-.529-.497-.5.229-.423-.339-.154.065-.234-.375.234-.284-.234-.054-.214.648-.348s-.634-.266-.932-.238c-.299.028-.58.38-.58.38l-.855-.142s.229.562.155.562h-.538l.172.698h-.662l.49.537-.382.21.58.395-.58.39.54.356-.304.588-.48-.291-.269.365.405.9.662.47.63.158.618.16.245.16.153-.615 1.042.715.542 1.121-.16 1.019-.382.521-.704.252-.918-.172-.48-.585-.116-.597s.279-.404.48-.37c.203.033.623.311.623.311z"
        fill="#DFDFDF"
        stroke="#000"
        stroke-width=".3"
      />
      <path
        d="M4.946 7.762s-1.112.103-1.409-.133m2.245.854s-1.111.104-1.408-.132m1.596.795s-.6.1-.66-.108"
        stroke="#000"
        stroke-width=".2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.531 5.938a.156.156 0 100-.313.156.156 0 000 .313z"
        fill="#000"
      />
    </symbol>
    <symbol id="ZA" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v5h20V0H0z"
          fill="#E31D1C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10v5h20v-5H0z"
          fill="#3D58DB"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="-2"
          y="-4.25"
          width="24"
          height="24"
          fill="#000"
        >
          <path fill="#fff" d="M-2-4.25h24v24H-2z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.643 6.25L0-1.25v17.5l9.643-7.5H20v-2.5H9.643z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.643 6.25L0-1.25v17.5l9.643-7.5H20v-2.5H9.643z"
          fill="#5EAA22"
        />
        <path
          d="M0-1.25l.767-.987-2.017-1.569v2.556H0zm9.643 7.5l-.768.987.339.263h.429V6.25zM0 16.25h-1.25v2.556l2.017-1.57L0 16.25zm9.643-7.5V7.5h-.429l-.339.263.768.987zM20 8.75V10h1.25V8.75H20zm0-2.5h1.25V5H20v1.25zM-.767-.263l9.642 7.5 1.535-1.974-9.643-7.5L-.767-.263zM1.25 16.25v-17.5h-2.5v17.5h2.5zm7.625-8.487l-9.642 7.5 1.534 1.974 9.643-7.5-1.535-1.974zM20 7.5H9.643V10H20V7.5zm-1.25-1.25v2.5h2.5v-2.5h-2.5zM9.643 7.5H20V5H9.643v2.5z"
          fill="#F7FCFF"
          mask="url(#b)"
        />
        <path
          d="M.375 3.25l-1-.75v10l1-.75 5-3.75.667-.5-.667-.5-5-3.75z"
          fill="#272727"
          stroke="#FECA00"
          stroke-width="1.25"
        />
      </g>
    </symbol>
    <symbol id="ZM" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0h20v15H0V0z"
          fill="#F7FCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#5EAA22"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#FF8126" d="M16.25 6.25H20V15h-3.75z" />
          <path fill="#272727" d="M12.5 6.25h3.75V15H12.5z" />
          <path fill="#C51918" d="M8.75 6.25h3.75V15H8.75z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.51 1.948c.338.124 0 .315 0 .315s-.067-.078-.067-.143c0-.064-.26 0-.393.236-.127.223.107.222.352.221h.04c.14 0 .356-.013.558-.026.175-.011.34-.022.43-.022.196 0 .289 0 .547-.173.168-.113.723-.252 1.136-.355.223-.055.404-.1.46-.125.164-.073-.162.31-.162.31s1.257-.508 1.51-.681c.155-.107.084-.016-.03.133a3.7 3.7 0 00-.223.31c-.106.176.11.008.351-.178.129-.1.265-.205.361-.265.277-.173-.07.296-.223.443-.153.147.359 0 .536-.147.13-.107.011.081-.09.24-.035.057-.069.11-.087.144l-.003.006c-.069.125-.09.165.073.165.167 0-.429.463-.429.463s.178-.028 0 .28c-.105.182-.614.365-1.028.515-.288.103-.53.19-.555.249-.047.104-.51.224-.727.28-.077.02-.123.033-.107.033.061 0 .163.077.053.077-.11 0-.304.062-.304.062s.102 0 0 .145c-.049.07-.134.059-.194.051-.066-.008-.1-.013-.025.094.068.097.092.132.085.142-.01.012-.06-.009-.139-.009a.642.642 0 01-.224-.061.753.753 0 00-.273-.072c-.173 0 0 .123.11.2l.012.009c.097.069.057.068-.119.068h-.057a.911.911 0 01-.199-.019c-.033-.006-.036-.007-.036.019 0 .024-.082-.01-.18-.051-.103-.043-.223-.093-.288-.093-.129 0 .273.266.273.266s-.21-.068-.323-.122c-.064-.031.018.115.092.247.056.1.107.192.087.192a.333.333 0 01-.09-.036c-.08-.038-.181-.087-.181-.022 0 .096.092.168.205.168.114 0 .132.15.066.15-.024 0-.052-.01-.08-.019-.051-.018-.099-.035-.099.02 0 .034.02.06.044.09.032.042.07.092.07.182 0 .156-.169.178-.114.075.056-.104-.191-.353-.191-.231v.156c0 .11-.022.118-.055.129a.134.134 0 00-.073.05.216.216 0 00-.05.098c-.003.016-.004.02-.034.02-.023 0-.042-.035-.068-.081-.04-.071-.095-.17-.204-.216-.104-.043-.11-.012-.119.042-.007.04-.016.092-.068.136-.079.067-.057.094-.031.127.015.018.03.039.03.069 0 .083-.137-.083-.137-.196 0-.112-.157-.26-.157-.178 0 .083 0 .178-.08.178-.039 0-.04.028-.042.065-.002.04-.005.091-.056.13-.05.04-.049.019-.046-.027.002-.043.006-.11-.033-.168-.049-.073-.008-.185.013-.243.013-.036.018-.05-.013-.018-.078.083-.178.083-.246.083h-.002c-.034 0-.064.043-.085.074-.02.03-.033.049-.033.001 0-.096.1-.347.288-.347.145 0 .218-.06.28-.11a.637.637 0 01.055-.041c.08-.051 0-.119-.08-.168-.037-.022-.024-.095.002-.16.045-.028.078-.064.078-.1 0-.044-.048.023-.078.1a.392.392 0 01-.179.064c-.043 0-.016-.078.018-.175a.892.892 0 00.061-.254c0-.07.012-.133.02-.176.011-.055.016-.079-.02-.05-.043.038-.276-.003-.435-.03-.068-.012-.123-.022-.143-.022-.03 0-.006-.056.018-.111.03-.07.06-.14-.018-.096-.122.067-.369.064-.526.063h-.061c-.092 0-.029-.082.005-.125.019-.025.029-.037-.005-.015a.51.51 0 01-.292.077c-.047 0-.06-.028-.075-.059-.018-.037-.038-.079-.123-.078-.156.001-.19-.001-.276-.069-.045-.035-.02-.056-.006-.067.013-.011.017-.014-.05-.014h-.422c-.21 0 0-.164.076-.164s.164-.147 0-.08c-.104.041-.216.03-.349.016-.074-.008-.155-.017-.244-.017-.25 0-.297-.115-.15-.115s.156-.084-.073-.084c-.144 0-.262-.04-.35-.068a.433.433 0 00-.124-.031c-.08 0-.168-.114 0-.114.169 0 .384-.094.2-.094-.104 0-.277-.056-.428-.104-.116-.037-.219-.07-.266-.07-.037 0 .02-.012.096-.028.152-.033.378-.081.09-.081-.31 0-.633-.252-.856-.425a1.43 1.43 0 00-.215-.151c-.173-.08 0-.236.05-.17.05.064.4.164.248.077a.906.906 0 01-.298-.315c-.05-.08-.011-.135.05-.072.061.063.345.244.345.244s-.152-.172-.272-.442c-.12-.27.12-.204.326 0 .206.204.4.258.497.27.097.012-.097-.147-.284-.27-.187-.123-.144-.563 0-.387.075.091.431.265.78.436.32.157.634.31.716.393.14.143.027-.07-.095-.3l-.075-.142c-.081-.157.246.021.619.224.268.146.56.305.74.36.123.04.27.1.418.162.363.15.726.301.726.106 0-.276.333-.706.69-.852.226-.092.332-.009.466.096.078.06.164.129.287.174zm-.384 3.23c.08 0 .058-.836.058-.836s.238.513.238.735c0 .1-.007.13-.005.16.003.035.019.069.076.22.059.155.02.138-.086.092-.085-.036-.214-.092-.37-.092-.35 0 .008-.279.089-.279z"
            fill="#FF8126"
          />
        </g>
      </g>
    </symbol>
    <symbol id="ZW" width="20" height="15" fill="none">
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
        <path fill="#fff" d="M0 0h20v15H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#F7FCFF"
        />
        <mask
          id="b"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0v15h20V0H0z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 1.25v12.5h20V1.25H0z"
            fill="#FECA00"
          />
          <path
            d="M0 5.156h-1.094v4.688h22.188V5.156H0z"
            fill="#272727"
            stroke="#E31D1C"
            stroke-width="2.188"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 2.5V0h20v2.5H0zM0 15v-2.5h20V15H0z"
            fill="#5EAA22"
          />
        </g>
        <path
          d="M.373-.501l-.998-.743v17.47l.992-.72L10.574 8.1l.689-.5-.683-.507L.373-.501z"
          fill="#F7FCFF"
          stroke="#272727"
          stroke-width="1.25"
        />
        <mask
          id="c"
          maskUnits="userSpaceOnUse"
          x="-2"
          y="-3"
          width="15"
          height="21"
        >
          <path
            d="M.373-.501l-.998-.743v17.47l.992-.72L10.574 8.1l.689-.5-.683-.507L.373-.501z"
            fill="#fff"
            stroke="#fff"
            stroke-width="1.25"
          />
        </mask>
        <g mask="url(#c)" fill-rule="evenodd" clip-rule="evenodd">
          <path
            d="M4.674 8.924L2.312 10.83l1.084-2.547L1.534 6.49h2.197l.902-2.162.958 2.162h2.193l-1.96 1.793.981 2.547-2.131-1.906z"
            fill="#E31D1C"
          />
          <path
            d="M3.136 5.263s-.034-.082.168-.155.264-.228.423-.114c.159.114.258-.115.303.213.046.329.171.847.171.847l2.055 1.544H5.87s-.601.884-.502 1.658c0 0-.415-.063-.977-.063s-.93.135-.93.135l-.325-1.202s.118-.202.168-.365c.05-.163.26-.193.26-.322 0-.13-.207-.238-.103-.574.103-.335.103-1.338.103-1.338s-.326-.143-.26-.143.218-.12.109-.12h-.277z"
            fill="#FECA00"
          />
        </g>
      </g>
    </symbol>
  </svg>
</template>
